export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeOffset: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  Milliseconds: { input: any; output: any; }
  Seconds: { input: any; output: any; }
};

/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). Also implements _BasePage, _FundMetadataPage, Route, _NavigablePage, _MetadataPage. */
export type AbrdnPage = {
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Accordion template (ID: {9406667A-26A9-491B-A21E-C207D73CE1CA}). */
export type Accordion = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Accordion';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** CanOpenMultiple (ID: {595B7102-4533-4D38-8742-AA09037F7CF5}). */
  canOpenMultiple?: Maybe<CheckboxField>;
  /** CanToggle (ID: {6D981F31-E577-41DD-A8AC-C51F56D3AE3B}). */
  canToggle?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** EasingFunction (ID: {68F5CD94-4071-4EF2-B0FA-9802FF36E628}). */
  easingFunction?: Maybe<TextField>;
  /** ExpandOnHover (ID: {6C3B9125-40E3-4F6C-B633-73A02AEF459B}). */
  expandOnHover?: Maybe<CheckboxField>;
  /** ExpandedByDefault (ID: {BB759051-E150-4397-A50D-B2DDE2767CD2}). */
  expandedByDefault?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Speed (ID: {9A178484-D3DD-4644-ABE5-6285ACA68634}). */
  speed?: Maybe<IntegerField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Accordion template (ID: {9406667A-26A9-491B-A21E-C207D73CE1CA}). */
export type AccordionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Accordion template (ID: {9406667A-26A9-491B-A21E-C207D73CE1CA}). */
export type AccordionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Accordion template (ID: {9406667A-26A9-491B-A21E-C207D73CE1CA}). */
export type AccordionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Accordion template (ID: {9406667A-26A9-491B-A21E-C207D73CE1CA}). */
export type AccordionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Accordion template (ID: {9406667A-26A9-491B-A21E-C207D73CE1CA}). */
export type AccordionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Accordion template (ID: {9406667A-26A9-491B-A21E-C207D73CE1CA}). */
export type AccordionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Folder template (ID: {68C00CB0-320B-4324-903A-F6AD56A2A105}). */
export type AccordionFolder = Item & {
  __typename?: 'AccordionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Folder template (ID: {68C00CB0-320B-4324-903A-F6AD56A2A105}). */
export type AccordionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Folder template (ID: {68C00CB0-320B-4324-903A-F6AD56A2A105}). */
export type AccordionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Folder template (ID: {68C00CB0-320B-4324-903A-F6AD56A2A105}). */
export type AccordionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Folder template (ID: {68C00CB0-320B-4324-903A-F6AD56A2A105}). */
export type AccordionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Folder template (ID: {68C00CB0-320B-4324-903A-F6AD56A2A105}). */
export type AccordionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Folder template (ID: {68C00CB0-320B-4324-903A-F6AD56A2A105}). */
export type AccordionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Folder template (ID: {03F88FB4-9788-4025-B46F-2CB249F4FCD6}). */
export type AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = Item & {
  __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Folder template (ID: {03F88FB4-9788-4025-B46F-2CB249F4FCD6}). */
export type AccordionFolder_03f88fb497884025b46f2cb249f4fcd6AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Folder template (ID: {03F88FB4-9788-4025-B46F-2CB249F4FCD6}). */
export type AccordionFolder_03f88fb497884025b46f2cb249f4fcd6ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Folder template (ID: {03F88FB4-9788-4025-B46F-2CB249F4FCD6}). */
export type AccordionFolder_03f88fb497884025b46f2cb249f4fcd6FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Folder template (ID: {03F88FB4-9788-4025-B46F-2CB249F4FCD6}). */
export type AccordionFolder_03f88fb497884025b46f2cb249f4fcd6FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Folder template (ID: {03F88FB4-9788-4025-B46F-2CB249F4FCD6}). */
export type AccordionFolder_03f88fb497884025b46f2cb249f4fcd6HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Folder template (ID: {03F88FB4-9788-4025-B46F-2CB249F4FCD6}). */
export type AccordionFolder_03f88fb497884025b46f2cb249f4fcd6IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Item template (ID: {A6DDAC75-7D24-4BDB-B3F6-5F47FBB21379}). */
export type AccordionItem = Item & {
  __typename?: 'AccordionItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {5A236869-E375-49C0-A92D-0C2F1DB7788F}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Heading (ID: {7240053B-9140-48AC-ACEA-ABFCCD7761A1}). */
  heading?: Maybe<RichTextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Item template (ID: {A6DDAC75-7D24-4BDB-B3F6-5F47FBB21379}). */
export type AccordionItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Item template (ID: {A6DDAC75-7D24-4BDB-B3F6-5F47FBB21379}). */
export type AccordionItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Item template (ID: {A6DDAC75-7D24-4BDB-B3F6-5F47FBB21379}). */
export type AccordionItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Item template (ID: {A6DDAC75-7D24-4BDB-B3F6-5F47FBB21379}). */
export type AccordionItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Item template (ID: {A6DDAC75-7D24-4BDB-B3F6-5F47FBB21379}). */
export type AccordionItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion Item template (ID: {A6DDAC75-7D24-4BDB-B3F6-5F47FBB21379}). */
export type AccordionItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Item template (ID: {8CF67172-1B2D-489E-809F-4C23DB5AB2DA}). */
export type AccordionItem_8cf671721b2d489e809f4c23db5ab2da = Item & {
  __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {2D6EB5F5-9F14-4B2F-A7C8-80636B6B06EB}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {3BBC4705-8189-4582-9AC4-80C42EDF8534}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Item template (ID: {8CF67172-1B2D-489E-809F-4C23DB5AB2DA}). */
export type AccordionItem_8cf671721b2d489e809f4c23db5ab2daAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Item template (ID: {8CF67172-1B2D-489E-809F-4C23DB5AB2DA}). */
export type AccordionItem_8cf671721b2d489e809f4c23db5ab2daChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Item template (ID: {8CF67172-1B2D-489E-809F-4C23DB5AB2DA}). */
export type AccordionItem_8cf671721b2d489e809f4c23db5ab2daFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Item template (ID: {8CF67172-1B2D-489E-809F-4C23DB5AB2DA}). */
export type AccordionItem_8cf671721b2d489e809f4c23db5ab2daFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Item template (ID: {8CF67172-1B2D-489E-809F-4C23DB5AB2DA}). */
export type AccordionItem_8cf671721b2d489e809f4c23db5ab2daHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion Item template (ID: {8CF67172-1B2D-489E-809F-4C23DB5AB2DA}). */
export type AccordionItem_8cf671721b2d489e809f4c23db5ab2daIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Accordion Parameters Template template (ID: {16C1A108-A99E-42E8-B871-4948168423A4}). */
export type AccordionParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'AccordionParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** presentation (ID: {83B7ACC2-3517-46E1-905D-95CCAAA20D57}). */
  presentation?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Accordion Parameters Template template (ID: {16C1A108-A99E-42E8-B871-4948168423A4}). */
export type AccordionParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Accordion Parameters Template template (ID: {16C1A108-A99E-42E8-B871-4948168423A4}). */
export type AccordionParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Accordion Parameters Template template (ID: {16C1A108-A99E-42E8-B871-4948168423A4}). */
export type AccordionParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Accordion Parameters Template template (ID: {16C1A108-A99E-42E8-B871-4948168423A4}). */
export type AccordionParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Accordion Parameters Template template (ID: {16C1A108-A99E-42E8-B871-4948168423A4}). */
export type AccordionParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Accordion Parameters Template template (ID: {16C1A108-A99E-42E8-B871-4948168423A4}). */
export type AccordionParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation template (ID: {CE1B9189-A080-4BE7-B5DE-1E5B81BA347F}). */
export type AccordionPresentation = Item & {
  __typename?: 'AccordionPresentation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation template (ID: {CE1B9189-A080-4BE7-B5DE-1E5B81BA347F}). */
export type AccordionPresentationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation template (ID: {CE1B9189-A080-4BE7-B5DE-1E5B81BA347F}). */
export type AccordionPresentationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation template (ID: {CE1B9189-A080-4BE7-B5DE-1E5B81BA347F}). */
export type AccordionPresentationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation template (ID: {CE1B9189-A080-4BE7-B5DE-1E5B81BA347F}). */
export type AccordionPresentationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation template (ID: {CE1B9189-A080-4BE7-B5DE-1E5B81BA347F}). */
export type AccordionPresentationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation template (ID: {CE1B9189-A080-4BE7-B5DE-1E5B81BA347F}). */
export type AccordionPresentationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation Folder template (ID: {B403B776-A741-4390-B969-9F17D57504F9}). */
export type AccordionPresentationFolder = Item & {
  __typename?: 'AccordionPresentationFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation Folder template (ID: {B403B776-A741-4390-B969-9F17D57504F9}). */
export type AccordionPresentationFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation Folder template (ID: {B403B776-A741-4390-B969-9F17D57504F9}). */
export type AccordionPresentationFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation Folder template (ID: {B403B776-A741-4390-B969-9F17D57504F9}). */
export type AccordionPresentationFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation Folder template (ID: {B403B776-A741-4390-B969-9F17D57504F9}). */
export type AccordionPresentationFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation Folder template (ID: {B403B776-A741-4390-B969-9F17D57504F9}). */
export type AccordionPresentationFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Accordion Settings/Accordion Presentation Folder template (ID: {B403B776-A741-4390-B969-9F17D57504F9}). */
export type AccordionPresentationFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion template (ID: {02D06059-8CC1-4423-A9AC-9FF2365176B7}). */
export type Accordion_02d060598cc14423a9ac9ff2365176b7 = Item & {
  __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion template (ID: {02D06059-8CC1-4423-A9AC-9FF2365176B7}). */
export type Accordion_02d060598cc14423a9ac9ff2365176b7AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion template (ID: {02D06059-8CC1-4423-A9AC-9FF2365176B7}). */
export type Accordion_02d060598cc14423a9ac9ff2365176b7ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion template (ID: {02D06059-8CC1-4423-A9AC-9FF2365176B7}). */
export type Accordion_02d060598cc14423a9ac9ff2365176b7FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion template (ID: {02D06059-8CC1-4423-A9AC-9FF2365176B7}). */
export type Accordion_02d060598cc14423a9ac9ff2365176b7FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion template (ID: {02D06059-8CC1-4423-A9AC-9FF2365176B7}). */
export type Accordion_02d060598cc14423a9ac9ff2365176b7HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Accordion/Accordion template (ID: {02D06059-8CC1-4423-A9AC-9FF2365176B7}). */
export type Accordion_02d060598cc14423a9ac9ff2365176b7IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion template (ID: {705CC8B3-BDE5-4CB3-BF1C-E455A2A36EF1}). */
export type Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = Item & {
  __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion template (ID: {705CC8B3-BDE5-4CB3-BF1C-E455A2A36EF1}). */
export type Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion template (ID: {705CC8B3-BDE5-4CB3-BF1C-E455A2A36EF1}). */
export type Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion template (ID: {705CC8B3-BDE5-4CB3-BF1C-E455A2A36EF1}). */
export type Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion template (ID: {705CC8B3-BDE5-4CB3-BF1C-E455A2A36EF1}). */
export type Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion template (ID: {705CC8B3-BDE5-4CB3-BF1C-E455A2A36EF1}). */
export type Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Accordion/Accordion template (ID: {705CC8B3-BDE5-4CB3-BF1C-E455A2A36EF1}). */
export type Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Workflow/Action template (ID: {66882E97-C8AA-4E37-8901-7A8AA35ED2ED}). */
export type Action = {
  /** Parameters (ID: {1507131D-CEE3-49E9-AF32-DE5403A37B49}). */
  parameters?: Maybe<TextField>;
  /** Type (ID: {A291A22B-99E2-46BB-A27B-8EC744275396}). */
  type?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {634079D3-9906-4003-AE96-AF875BB8DDE5}). */
export type AddItem = Item & _Fields & _Name_299cdb154745448a807868d401248eaa & _Template & {
  __typename?: 'AddItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fields (ID: {AD0E8DE7-F6C1-49FA-B2C4-87E10FBDAA52}). */
  fields_ad0e8de7f6c149fab2c487e10fbdaa52?: Maybe<NameValueListField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Location (ID: {98EE1C8D-E620-42F6-A42A-9E7094135305}). */
  location?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {7868E6BC-525C-4FCE-AB8A-77DA3E09B171}). */
  name_7868e6bc525c4fceab8a77da3e09b171?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {E62C28F0-9D3B-46E2-8BEC-A5E120542499}). */
  template_e62c28f09d3b46e28beca5e120542499?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {634079D3-9906-4003-AE96-AF875BB8DDE5}). */
export type AddItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {634079D3-9906-4003-AE96-AF875BB8DDE5}). */
export type AddItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {634079D3-9906-4003-AE96-AF875BB8DDE5}). */
export type AddItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {634079D3-9906-4003-AE96-AF875BB8DDE5}). */
export type AddItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {634079D3-9906-4003-AE96-AF875BB8DDE5}). */
export type AddItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {634079D3-9906-4003-AE96-AF875BB8DDE5}). */
export type AddItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {1E1B739E-C378-4909-941D-171ACA7362E5}). */
export type AddItem_1e1b739ec3784909941d171aca7362e5 = Item & _Fields & _Name_299cdb154745448a807868d401248eaa & _Template & {
  __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fields (ID: {AD0E8DE7-F6C1-49FA-B2C4-87E10FBDAA52}). */
  fields_ad0e8de7f6c149fab2c487e10fbdaa52?: Maybe<NameValueListField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Location (ID: {49ED6C70-37BD-4A23-AF04-209806605B7F}). */
  location?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {7868E6BC-525C-4FCE-AB8A-77DA3E09B171}). */
  name_7868e6bc525c4fceab8a77da3e09b171?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {E62C28F0-9D3B-46E2-8BEC-A5E120542499}). */
  template_e62c28f09d3b46e28beca5e120542499?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {1E1B739E-C378-4909-941D-171ACA7362E5}). */
export type AddItem_1e1b739ec3784909941d171aca7362e5AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {1E1B739E-C378-4909-941D-171ACA7362E5}). */
export type AddItem_1e1b739ec3784909941d171aca7362e5ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {1E1B739E-C378-4909-941D-171ACA7362E5}). */
export type AddItem_1e1b739ec3784909941d171aca7362e5FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {1E1B739E-C378-4909-941D-171ACA7362E5}). */
export type AddItem_1e1b739ec3784909941d171aca7362e5FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {1E1B739E-C378-4909-941D-171ACA7362E5}). */
export type AddItem_1e1b739ec3784909941d171aca7362e5HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/AddItem template (ID: {1E1B739E-C378-4909-941D-171ACA7362E5}). */
export type AddItem_1e1b739ec3784909941d171aca7362e5IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {3AEA335C-D06D-45B1-841A-CBC8D2D1CE40}). */
export type AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = Item & _Fields & _Name_299cdb154745448a807868d401248eaa & _Template & {
  __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fields (ID: {AD0E8DE7-F6C1-49FA-B2C4-87E10FBDAA52}). */
  fields_ad0e8de7f6c149fab2c487e10fbdaa52?: Maybe<NameValueListField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Location (ID: {52C91C75-6698-4701-A8A2-242ACE59A8D6}). */
  location?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {7868E6BC-525C-4FCE-AB8A-77DA3E09B171}). */
  name_7868e6bc525c4fceab8a77da3e09b171?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {E62C28F0-9D3B-46E2-8BEC-A5E120542499}). */
  template_e62c28f09d3b46e28beca5e120542499?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {3AEA335C-D06D-45B1-841A-CBC8D2D1CE40}). */
export type AddItem_3aea335cd06d45b1841acbc8d2d1ce40AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {3AEA335C-D06D-45B1-841A-CBC8D2D1CE40}). */
export type AddItem_3aea335cd06d45b1841acbc8d2d1ce40ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {3AEA335C-D06D-45B1-841A-CBC8D2D1CE40}). */
export type AddItem_3aea335cd06d45b1841acbc8d2d1ce40FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {3AEA335C-D06D-45B1-841A-CBC8D2D1CE40}). */
export type AddItem_3aea335cd06d45b1841acbc8d2d1ce40FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {3AEA335C-D06D-45B1-841A-CBC8D2D1CE40}). */
export type AddItem_3aea335cd06d45b1841acbc8d2d1ce40HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {3AEA335C-D06D-45B1-841A-CBC8D2D1CE40}). */
export type AddItem_3aea335cd06d45b1841acbc8d2d1ce40IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/AddItem template (ID: {DE8C7522-2F32-4128-8F20-342F479894EB}). */
export type AddItem_De8c75222f3241288f20342f479894eb = Item & {
  __typename?: 'AddItem_de8c75222f3241288f20342f479894eb';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fields (ID: {9149970F-A40F-4212-9BA8-B143FBAAF6D1}). */
  fields_9149970fa40f42129ba8b143fbaaf6d1?: Maybe<NameValueListField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Location (ID: {D1C13E15-5BCA-4C4C-A449-C4B4DBE8E72A}). */
  location?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {999779AA-AA55-493E-A943-1F3793BA34DF}). */
  name_999779aaaa55493ea9431f3793ba34df?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {749DEF76-A3C0-44ED-8AD3-A0961F00E213}). */
  template_749def76a3c044ed8ad3a0961f00e213?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/AddItem template (ID: {DE8C7522-2F32-4128-8F20-342F479894EB}). */
export type AddItem_De8c75222f3241288f20342f479894ebAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/AddItem template (ID: {DE8C7522-2F32-4128-8F20-342F479894EB}). */
export type AddItem_De8c75222f3241288f20342f479894ebChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/AddItem template (ID: {DE8C7522-2F32-4128-8F20-342F479894EB}). */
export type AddItem_De8c75222f3241288f20342f479894ebFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/AddItem template (ID: {DE8C7522-2F32-4128-8F20-342F479894EB}). */
export type AddItem_De8c75222f3241288f20342f479894ebFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/AddItem template (ID: {DE8C7522-2F32-4128-8F20-342F479894EB}). */
export type AddItem_De8c75222f3241288f20342f479894ebHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/AddItem template (ID: {DE8C7522-2F32-4128-8F20-342F479894EB}). */
export type AddItem_De8c75222f3241288f20342f479894ebIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {EA8A3F26-9CCD-443A-95F5-71B868A94BD0}). */
export type AddItem_Ea8a3f269ccd443a95f571b868a94bd0 = Item & _Fields & _Name_299cdb154745448a807868d401248eaa & _Template & {
  __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fields (ID: {AD0E8DE7-F6C1-49FA-B2C4-87E10FBDAA52}). */
  fields_ad0e8de7f6c149fab2c487e10fbdaa52?: Maybe<NameValueListField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Location (ID: {4795A7C6-08A9-4248-86C3-D460062C3A22}). */
  location?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {7868E6BC-525C-4FCE-AB8A-77DA3E09B171}). */
  name_7868e6bc525c4fceab8a77da3e09b171?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {E62C28F0-9D3B-46E2-8BEC-A5E120542499}). */
  template_e62c28f09d3b46e28beca5e120542499?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {EA8A3F26-9CCD-443A-95F5-71B868A94BD0}). */
export type AddItem_Ea8a3f269ccd443a95f571b868a94bd0AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {EA8A3F26-9CCD-443A-95F5-71B868A94BD0}). */
export type AddItem_Ea8a3f269ccd443a95f571b868a94bd0ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {EA8A3F26-9CCD-443A-95F5-71B868A94BD0}). */
export type AddItem_Ea8a3f269ccd443a95f571b868a94bd0FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {EA8A3F26-9CCD-443A-95F5-71B868A94BD0}). */
export type AddItem_Ea8a3f269ccd443a95f571b868a94bd0FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {EA8A3F26-9CCD-443A-95F5-71B868A94BD0}). */
export type AddItem_Ea8a3f269ccd443a95f571b868a94bd0HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/AddItem template (ID: {EA8A3F26-9CCD-443A-95F5-71B868A94BD0}). */
export type AddItem_Ea8a3f269ccd443a95f571b868a94bd0IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/AddThis Parameters template (ID: {88A5FE1F-28FA-4E38-8070-9FCFBD272094}). */
export type AddThisParameters = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'AddThisParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** pubid (ID: {3B67C2CB-B7FB-4C3F-A1CC-14B67B37B689}). */
  pubid?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/AddThis Parameters template (ID: {88A5FE1F-28FA-4E38-8070-9FCFBD272094}). */
export type AddThisParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/AddThis Parameters template (ID: {88A5FE1F-28FA-4E38-8070-9FCFBD272094}). */
export type AddThisParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/AddThis Parameters template (ID: {88A5FE1F-28FA-4E38-8070-9FCFBD272094}). */
export type AddThisParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/AddThis Parameters template (ID: {88A5FE1F-28FA-4E38-8070-9FCFBD272094}). */
export type AddThisParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/AddThis Parameters template (ID: {88A5FE1F-28FA-4E38-8070-9FCFBD272094}). */
export type AddThisParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/AddThis Parameters template (ID: {88A5FE1F-28FA-4E38-8070-9FCFBD272094}). */
export type AddThisParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). */
export type AdvancedParameter = {
  /** Advanced (ID: {07A98F74-131F-4BA1-9C00-88416C2832A4}). */
  advanced?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Aggregated Facet Filter template (ID: {7797FDF7-CA8F-407F-AA78-42AE93AB8D91}). */
export type AggregatedFacetFilter = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'AggregatedFacetFilter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Aggregated Facet Filter template (ID: {7797FDF7-CA8F-407F-AA78-42AE93AB8D91}). */
export type AggregatedFacetFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Aggregated Facet Filter template (ID: {7797FDF7-CA8F-407F-AA78-42AE93AB8D91}). */
export type AggregatedFacetFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Aggregated Facet Filter template (ID: {7797FDF7-CA8F-407F-AA78-42AE93AB8D91}). */
export type AggregatedFacetFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Aggregated Facet Filter template (ID: {7797FDF7-CA8F-407F-AA78-42AE93AB8D91}). */
export type AggregatedFacetFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Aggregated Facet Filter template (ID: {7797FDF7-CA8F-407F-AA78-42AE93AB8D91}). */
export type AggregatedFacetFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Aggregated Facet Filter template (ID: {7797FDF7-CA8F-407F-AA78-42AE93AB8D91}). */
export type AggregatedFacetFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message template (ID: {F2754ED8-7E5B-4074-BD71-529C9560211B}). */
export type AlertMessage = Item & {
  __typename?: 'AlertMessage';
  /** alertExpandableText (ID: {B1E8C384-F3C8-445E-875C-A5F4CE9D312B}). */
  alertExpandableText?: Maybe<RichTextField>;
  /** alertText (ID: {3B8D4AA4-02B6-47E8-8F7C-13B8163C66AE}). */
  alertText?: Maybe<RichTextField>;
  /** alertTitle (ID: {0E92E189-F9CE-4A1B-A6B0-2AA7EB5B3D3E}). */
  alertTitle?: Maybe<TextField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** expandedView (ID: {7466F09A-FEB9-45D5-881A-36B1E077C3B2}). */
  expandedView?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message template (ID: {F2754ED8-7E5B-4074-BD71-529C9560211B}). */
export type AlertMessageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message template (ID: {F2754ED8-7E5B-4074-BD71-529C9560211B}). */
export type AlertMessageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message template (ID: {F2754ED8-7E5B-4074-BD71-529C9560211B}). */
export type AlertMessageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message template (ID: {F2754ED8-7E5B-4074-BD71-529C9560211B}). */
export type AlertMessageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message template (ID: {F2754ED8-7E5B-4074-BD71-529C9560211B}). */
export type AlertMessageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message template (ID: {F2754ED8-7E5B-4074-BD71-529C9560211B}). */
export type AlertMessageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message Folder template (ID: {1F473A75-1392-4B25-9AFA-BE1E2BCB3B70}). */
export type AlertMessageFolder = Item & {
  __typename?: 'AlertMessageFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message Folder template (ID: {1F473A75-1392-4B25-9AFA-BE1E2BCB3B70}). */
export type AlertMessageFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message Folder template (ID: {1F473A75-1392-4B25-9AFA-BE1E2BCB3B70}). */
export type AlertMessageFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message Folder template (ID: {1F473A75-1392-4B25-9AFA-BE1E2BCB3B70}). */
export type AlertMessageFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message Folder template (ID: {1F473A75-1392-4B25-9AFA-BE1E2BCB3B70}). */
export type AlertMessageFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message Folder template (ID: {1F473A75-1392-4B25-9AFA-BE1E2BCB3B70}). */
export type AlertMessageFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Alert Message/Alert Message Folder template (ID: {1F473A75-1392-4B25-9AFA-BE1E2BCB3B70}). */
export type AlertMessageFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Alert Message Parameters Template template (ID: {963480D9-1FC4-44EB-AEB5-524408BBA6F2}). */
export type AlertMessageParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'AlertMessageParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** alertType (ID: {6ECDD089-05AC-4761-86BF-25E67B20E9A6}). */
  alertType?: Maybe<TextField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Alert Message Parameters Template template (ID: {963480D9-1FC4-44EB-AEB5-524408BBA6F2}). */
export type AlertMessageParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Alert Message Parameters Template template (ID: {963480D9-1FC4-44EB-AEB5-524408BBA6F2}). */
export type AlertMessageParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Alert Message Parameters Template template (ID: {963480D9-1FC4-44EB-AEB5-524408BBA6F2}). */
export type AlertMessageParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Alert Message Parameters Template template (ID: {963480D9-1FC4-44EB-AEB5-524408BBA6F2}). */
export type AlertMessageParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Alert Message Parameters Template template (ID: {963480D9-1FC4-44EB-AEB5-524408BBA6F2}). */
export type AlertMessageParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Alert Message Parameters Template template (ID: {963480D9-1FC4-44EB-AEB5-524408BBA6F2}). */
export type AlertMessageParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Alert Message Type template (ID: {3912B98B-2EF6-4058-ABE8-A09F8D3A5B82}). */
export type AlertMessageType = Item & {
  __typename?: 'AlertMessageType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Alert Message Type template (ID: {3912B98B-2EF6-4058-ABE8-A09F8D3A5B82}). */
export type AlertMessageTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Alert Message Type template (ID: {3912B98B-2EF6-4058-ABE8-A09F8D3A5B82}). */
export type AlertMessageTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Alert Message Type template (ID: {3912B98B-2EF6-4058-ABE8-A09F8D3A5B82}). */
export type AlertMessageTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Alert Message Type template (ID: {3912B98B-2EF6-4058-ABE8-A09F8D3A5B82}). */
export type AlertMessageTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Alert Message Type template (ID: {3912B98B-2EF6-4058-ABE8-A09F8D3A5B82}). */
export type AlertMessageTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Alert Message Type template (ID: {3912B98B-2EF6-4058-ABE8-A09F8D3A5B82}). */
export type AlertMessageTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Allert Message Type Folder template (ID: {316212A8-DC4D-4394-BC09-16FFE685F585}). */
export type AllertMessageTypeFolder = Item & {
  __typename?: 'AllertMessageTypeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Allert Message Type Folder template (ID: {316212A8-DC4D-4394-BC09-16FFE685F585}). */
export type AllertMessageTypeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Allert Message Type Folder template (ID: {316212A8-DC4D-4394-BC09-16FFE685F585}). */
export type AllertMessageTypeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Allert Message Type Folder template (ID: {316212A8-DC4D-4394-BC09-16FFE685F585}). */
export type AllertMessageTypeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Allert Message Type Folder template (ID: {316212A8-DC4D-4394-BC09-16FFE685F585}). */
export type AllertMessageTypeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Allert Message Type Folder template (ID: {316212A8-DC4D-4394-BC09-16FFE685F585}). */
export type AllertMessageTypeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Alert Message Settings/Allert Message Type Folder template (ID: {316212A8-DC4D-4394-BC09-16FFE685F585}). */
export type AllertMessageTypeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Archive template (ID: {EFAC8E1B-DE06-41F5-AA98-61F1745128D5}). */
export type Archive = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Archive';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldName (ID: {8A897150-E6C1-498D-8675-D6F5DC1A08F3}). */
  fieldName?: Maybe<TextField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Format (ID: {80532994-D88E-4909-9E21-A6F04766931A}). */
  format?: Maybe<LookupField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SourceType (ID: {0134D7AC-EB5F-4306-B86B-5E61590212DA}). */
  sourceType?: Maybe<LookupField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Archive template (ID: {EFAC8E1B-DE06-41F5-AA98-61F1745128D5}). */
export type ArchiveAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Archive template (ID: {EFAC8E1B-DE06-41F5-AA98-61F1745128D5}). */
export type ArchiveChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Archive template (ID: {EFAC8E1B-DE06-41F5-AA98-61F1745128D5}). */
export type ArchiveFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Archive template (ID: {EFAC8E1B-DE06-41F5-AA98-61F1745128D5}). */
export type ArchiveFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Archive template (ID: {EFAC8E1B-DE06-41F5-AA98-61F1745128D5}). */
export type ArchiveHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Archive template (ID: {EFAC8E1B-DE06-41F5-AA98-61F1745128D5}). */
export type ArchiveIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Author template (ID: {AC1C6208-2C57-4BC1-AFFA-452CD012F90D}). */
export type ArticleAuthor = Item & {
  __typename?: 'ArticleAuthor';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** jobImage (ID: {EC1B5027-653B-4805-B6BE-8067A84DD15A}). */
  jobImage?: Maybe<ImageField>;
  /** jobTitle (ID: {50FDE1A8-FECC-4FFE-9553-2087C34B11A8}). */
  jobTitle?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {6A52AF68-C15F-48A8-B323-1BFAE40157BB}). */
  name_6a52af68c15f48a8b3231bfae40157bb?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Author template (ID: {AC1C6208-2C57-4BC1-AFFA-452CD012F90D}). */
export type ArticleAuthorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Author template (ID: {AC1C6208-2C57-4BC1-AFFA-452CD012F90D}). */
export type ArticleAuthorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Author template (ID: {AC1C6208-2C57-4BC1-AFFA-452CD012F90D}). */
export type ArticleAuthorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Author template (ID: {AC1C6208-2C57-4BC1-AFFA-452CD012F90D}). */
export type ArticleAuthorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Author template (ID: {AC1C6208-2C57-4BC1-AFFA-452CD012F90D}). */
export type ArticleAuthorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Author template (ID: {AC1C6208-2C57-4BC1-AFFA-452CD012F90D}). */
export type ArticleAuthorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Authors Folder template (ID: {15ECE82F-34E9-4502-9DCF-0B0021E147D6}). */
export type ArticleAuthorsFolder = Item & {
  __typename?: 'ArticleAuthorsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Authors Folder template (ID: {15ECE82F-34E9-4502-9DCF-0B0021E147D6}). */
export type ArticleAuthorsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Authors Folder template (ID: {15ECE82F-34E9-4502-9DCF-0B0021E147D6}). */
export type ArticleAuthorsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Authors Folder template (ID: {15ECE82F-34E9-4502-9DCF-0B0021E147D6}). */
export type ArticleAuthorsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Authors Folder template (ID: {15ECE82F-34E9-4502-9DCF-0B0021E147D6}). */
export type ArticleAuthorsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Authors Folder template (ID: {15ECE82F-34E9-4502-9DCF-0B0021E147D6}). */
export type ArticleAuthorsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Authors Folder template (ID: {15ECE82F-34E9-4502-9DCF-0B0021E147D6}). */
export type ArticleAuthorsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Categories Folder template (ID: {548E76F0-24A1-455E-B472-56E8EF143C61}). */
export type ArticleCategoriesFolder = Item & {
  __typename?: 'ArticleCategoriesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Categories Folder template (ID: {548E76F0-24A1-455E-B472-56E8EF143C61}). */
export type ArticleCategoriesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Categories Folder template (ID: {548E76F0-24A1-455E-B472-56E8EF143C61}). */
export type ArticleCategoriesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Categories Folder template (ID: {548E76F0-24A1-455E-B472-56E8EF143C61}). */
export type ArticleCategoriesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Categories Folder template (ID: {548E76F0-24A1-455E-B472-56E8EF143C61}). */
export type ArticleCategoriesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Categories Folder template (ID: {548E76F0-24A1-455E-B472-56E8EF143C61}). */
export type ArticleCategoriesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Categories Folder template (ID: {548E76F0-24A1-455E-B472-56E8EF143C61}). */
export type ArticleCategoriesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Category template (ID: {1984E795-1A24-453F-B14D-A897FE549B22}). */
export type ArticleCategory = Item & {
  __typename?: 'ArticleCategory';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {1E4C2734-DC75-4D52-8AF8-084E6C400E1F}). */
  name_1e4c2734dc754d528af8084e6c400e1f?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Category template (ID: {1984E795-1A24-453F-B14D-A897FE549B22}). */
export type ArticleCategoryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Category template (ID: {1984E795-1A24-453F-B14D-A897FE549B22}). */
export type ArticleCategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Category template (ID: {1984E795-1A24-453F-B14D-A897FE549B22}). */
export type ArticleCategoryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Category template (ID: {1984E795-1A24-453F-B14D-A897FE549B22}). */
export type ArticleCategoryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Category template (ID: {1984E795-1A24-453F-B14D-A897FE549B22}). */
export type ArticleCategoryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Category/Article Category template (ID: {1984E795-1A24-453F-B14D-A897FE549B22}). */
export type ArticleCategoryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapter template (ID: {CAC089A1-2C18-47AE-AA14-EFAFDA05DCB3}). */
export type ArticleChapter = Item & {
  __typename?: 'ArticleChapter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchor (ID: {7261B9B3-5FF1-46A0-A5F7-553B99D7EC4E}). */
  anchor?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {5B3620AD-60D2-4EA3-B4B5-F21F21AAC50B}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapter template (ID: {CAC089A1-2C18-47AE-AA14-EFAFDA05DCB3}). */
export type ArticleChapterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapter template (ID: {CAC089A1-2C18-47AE-AA14-EFAFDA05DCB3}). */
export type ArticleChapterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapter template (ID: {CAC089A1-2C18-47AE-AA14-EFAFDA05DCB3}). */
export type ArticleChapterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapter template (ID: {CAC089A1-2C18-47AE-AA14-EFAFDA05DCB3}). */
export type ArticleChapterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapter template (ID: {CAC089A1-2C18-47AE-AA14-EFAFDA05DCB3}). */
export type ArticleChapterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapter template (ID: {CAC089A1-2C18-47AE-AA14-EFAFDA05DCB3}). */
export type ArticleChapterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapters template (ID: {296E9222-12F6-49DF-9E60-8631FC2EB0D0}). */
export type ArticleChapters = Item & {
  __typename?: 'ArticleChapters';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapters template (ID: {296E9222-12F6-49DF-9E60-8631FC2EB0D0}). */
export type ArticleChaptersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapters template (ID: {296E9222-12F6-49DF-9E60-8631FC2EB0D0}). */
export type ArticleChaptersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapters template (ID: {296E9222-12F6-49DF-9E60-8631FC2EB0D0}). */
export type ArticleChaptersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapters template (ID: {296E9222-12F6-49DF-9E60-8631FC2EB0D0}). */
export type ArticleChaptersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapters template (ID: {296E9222-12F6-49DF-9E60-8631FC2EB0D0}). */
export type ArticleChaptersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Chapters/Article Chapters template (ID: {296E9222-12F6-49DF-9E60-8631FC2EB0D0}). */
export type ArticleChaptersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Type template (ID: {8C9EECDA-7D12-4ECF-A55B-BF13B0AC2D81}). */
export type ArticleContentType = Item & {
  __typename?: 'ArticleContentType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {6B6AC18F-AFE5-424A-A8CB-27C8AEB0185D}). */
  name_6b6ac18fafe5424aa8cb27c8aeb0185d?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Type template (ID: {8C9EECDA-7D12-4ECF-A55B-BF13B0AC2D81}). */
export type ArticleContentTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Type template (ID: {8C9EECDA-7D12-4ECF-A55B-BF13B0AC2D81}). */
export type ArticleContentTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Type template (ID: {8C9EECDA-7D12-4ECF-A55B-BF13B0AC2D81}). */
export type ArticleContentTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Type template (ID: {8C9EECDA-7D12-4ECF-A55B-BF13B0AC2D81}). */
export type ArticleContentTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Type template (ID: {8C9EECDA-7D12-4ECF-A55B-BF13B0AC2D81}). */
export type ArticleContentTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Type template (ID: {8C9EECDA-7D12-4ECF-A55B-BF13B0AC2D81}). */
export type ArticleContentTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Types Folder template (ID: {986E0F5C-5C57-4AC7-910F-ECF0425F723E}). */
export type ArticleContentTypesFolder = Item & {
  __typename?: 'ArticleContentTypesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Types Folder template (ID: {986E0F5C-5C57-4AC7-910F-ECF0425F723E}). */
export type ArticleContentTypesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Types Folder template (ID: {986E0F5C-5C57-4AC7-910F-ECF0425F723E}). */
export type ArticleContentTypesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Types Folder template (ID: {986E0F5C-5C57-4AC7-910F-ECF0425F723E}). */
export type ArticleContentTypesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Types Folder template (ID: {986E0F5C-5C57-4AC7-910F-ECF0425F723E}). */
export type ArticleContentTypesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Types Folder template (ID: {986E0F5C-5C57-4AC7-910F-ECF0425F723E}). */
export type ArticleContentTypesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Content Type/Article Content Types Folder template (ID: {986E0F5C-5C57-4AC7-910F-ECF0425F723E}). */
export type ArticleContentTypesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter template (ID: {3CB3C849-EB49-4C36-B8CB-55DBB7D878E7}). */
export type ArticleFilter = Item & {
  __typename?: 'ArticleFilter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** filterSubHeading (ID: {B1C95C86-000D-4AE9-9018-295119BC2EE3}). */
  filterSubHeading?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter template (ID: {3CB3C849-EB49-4C36-B8CB-55DBB7D878E7}). */
export type ArticleFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter template (ID: {3CB3C849-EB49-4C36-B8CB-55DBB7D878E7}). */
export type ArticleFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter template (ID: {3CB3C849-EB49-4C36-B8CB-55DBB7D878E7}). */
export type ArticleFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter template (ID: {3CB3C849-EB49-4C36-B8CB-55DBB7D878E7}). */
export type ArticleFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter template (ID: {3CB3C849-EB49-4C36-B8CB-55DBB7D878E7}). */
export type ArticleFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter template (ID: {3CB3C849-EB49-4C36-B8CB-55DBB7D878E7}). */
export type ArticleFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter Option template (ID: {C20264A0-4CC2-4295-B860-E76B93A03E2F}). */
export type ArticleFilterOption = Item & {
  __typename?: 'ArticleFilterOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** displayName (ID: {DCA2B94D-B0A2-4C65-AFA3-1E1DB95E6A8A}). */
  displayName_dca2b94db0a24c65afa31e1db95e6a8a?: Maybe<TextField>;
  /** facetName (ID: {35B2C7A0-1FDE-46CB-BE77-DD9522158483}). */
  facetName?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** taxonomy (ID: {4A5982C6-C484-4407-B57B-C25ED7C4C1FA}). */
  taxonomy?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter Option template (ID: {C20264A0-4CC2-4295-B860-E76B93A03E2F}). */
export type ArticleFilterOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter Option template (ID: {C20264A0-4CC2-4295-B860-E76B93A03E2F}). */
export type ArticleFilterOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter Option template (ID: {C20264A0-4CC2-4295-B860-E76B93A03E2F}). */
export type ArticleFilterOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter Option template (ID: {C20264A0-4CC2-4295-B860-E76B93A03E2F}). */
export type ArticleFilterOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter Option template (ID: {C20264A0-4CC2-4295-B860-E76B93A03E2F}). */
export type ArticleFilterOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Filter/Article Filter Option template (ID: {C20264A0-4CC2-4295-B860-E76B93A03E2F}). */
export type ArticleFilterOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote template (ID: {A8B48CED-F277-4F4B-9301-F3A283DEE48D}). */
export type ArticleFootnote = Item & {
  __typename?: 'ArticleFootnote';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote template (ID: {A8B48CED-F277-4F4B-9301-F3A283DEE48D}). */
export type ArticleFootnoteAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote template (ID: {A8B48CED-F277-4F4B-9301-F3A283DEE48D}). */
export type ArticleFootnoteChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote template (ID: {A8B48CED-F277-4F4B-9301-F3A283DEE48D}). */
export type ArticleFootnoteFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote template (ID: {A8B48CED-F277-4F4B-9301-F3A283DEE48D}). */
export type ArticleFootnoteFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote template (ID: {A8B48CED-F277-4F4B-9301-F3A283DEE48D}). */
export type ArticleFootnoteHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote template (ID: {A8B48CED-F277-4F4B-9301-F3A283DEE48D}). */
export type ArticleFootnoteIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Link template (ID: {539A66DC-A880-43D7-901B-FB4A9DF952C9}). */
export type ArticleFootnoteLink = Item & {
  __typename?: 'ArticleFootnoteLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {942E021B-E472-4144-9ACC-6FE55AB36C32}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Link template (ID: {539A66DC-A880-43D7-901B-FB4A9DF952C9}). */
export type ArticleFootnoteLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Link template (ID: {539A66DC-A880-43D7-901B-FB4A9DF952C9}). */
export type ArticleFootnoteLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Link template (ID: {539A66DC-A880-43D7-901B-FB4A9DF952C9}). */
export type ArticleFootnoteLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Link template (ID: {539A66DC-A880-43D7-901B-FB4A9DF952C9}). */
export type ArticleFootnoteLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Link template (ID: {539A66DC-A880-43D7-901B-FB4A9DF952C9}). */
export type ArticleFootnoteLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Link template (ID: {539A66DC-A880-43D7-901B-FB4A9DF952C9}). */
export type ArticleFootnoteLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Text template (ID: {D75E73E2-F8C5-4A9B-A956-06EEAD3092B5}). */
export type ArticleFootnoteText = Item & {
  __typename?: 'ArticleFootnoteText';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** text (ID: {E69AE9E9-0066-4405-A561-2826AE241FCC}). */
  text?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Text template (ID: {D75E73E2-F8C5-4A9B-A956-06EEAD3092B5}). */
export type ArticleFootnoteTextAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Text template (ID: {D75E73E2-F8C5-4A9B-A956-06EEAD3092B5}). */
export type ArticleFootnoteTextChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Text template (ID: {D75E73E2-F8C5-4A9B-A956-06EEAD3092B5}). */
export type ArticleFootnoteTextFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Text template (ID: {D75E73E2-F8C5-4A9B-A956-06EEAD3092B5}). */
export type ArticleFootnoteTextFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Text template (ID: {D75E73E2-F8C5-4A9B-A956-06EEAD3092B5}). */
export type ArticleFootnoteTextHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Footnote/Article Footnote Text template (ID: {D75E73E2-F8C5-4A9B-A956-06EEAD3092B5}). */
export type ArticleFootnoteTextIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Infogram Tile/Article Infogram Tile template (ID: {72F62662-690E-42F3-816A-5EB26BCEBBD2}). */
export type ArticleInfogramTile = Item & {
  __typename?: 'ArticleInfogramTile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {BFB8888E-F9A3-418A-9DD5-5405059C81CE}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {4FA0D875-3165-41A4-B0FB-8C8D8FB9938C}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Infogram Tile/Article Infogram Tile template (ID: {72F62662-690E-42F3-816A-5EB26BCEBBD2}). */
export type ArticleInfogramTileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Infogram Tile/Article Infogram Tile template (ID: {72F62662-690E-42F3-816A-5EB26BCEBBD2}). */
export type ArticleInfogramTileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Infogram Tile/Article Infogram Tile template (ID: {72F62662-690E-42F3-816A-5EB26BCEBBD2}). */
export type ArticleInfogramTileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Infogram Tile/Article Infogram Tile template (ID: {72F62662-690E-42F3-816A-5EB26BCEBBD2}). */
export type ArticleInfogramTileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Infogram Tile/Article Infogram Tile template (ID: {72F62662-690E-42F3-816A-5EB26BCEBBD2}). */
export type ArticleInfogramTileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Infogram Tile/Article Infogram Tile template (ID: {72F62662-690E-42F3-816A-5EB26BCEBBD2}). */
export type ArticleInfogramTileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Infogram Tile Parameters Template template (ID: {5755CA6D-3912-4FEC-B356-BBE46E8291FD}). */
export type ArticleInfogramTileParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'ArticleInfogramTileParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {EC3BAD6F-2B96-4CAA-AEB0-36FD761958B6}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** size (ID: {C12D9DD6-9584-4B2D-B686-DFBF9211EF1A}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Infogram Tile Parameters Template template (ID: {5755CA6D-3912-4FEC-B356-BBE46E8291FD}). */
export type ArticleInfogramTileParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Infogram Tile Parameters Template template (ID: {5755CA6D-3912-4FEC-B356-BBE46E8291FD}). */
export type ArticleInfogramTileParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Infogram Tile Parameters Template template (ID: {5755CA6D-3912-4FEC-B356-BBE46E8291FD}). */
export type ArticleInfogramTileParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Infogram Tile Parameters Template template (ID: {5755CA6D-3912-4FEC-B356-BBE46E8291FD}). */
export type ArticleInfogramTileParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Infogram Tile Parameters Template template (ID: {5755CA6D-3912-4FEC-B356-BBE46E8291FD}). */
export type ArticleInfogramTileParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Infogram Tile Parameters Template template (ID: {5755CA6D-3912-4FEC-B356-BBE46E8291FD}). */
export type ArticleInfogramTileParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Page template (ID: {0F0EA25C-1803-46D9-8D35-ACB160BEAD9E}). */
export type ArticlePage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _Article & _BaseArticle & _BasePage & _ContentType & _Designable & _FundMetadataPage & _InternalArticle & _LimitedDisplay & _MetadataPage & _Navigable & _NavigablePage & _PremiumContentPage & _SharedPage & _Sitemap & _Taggable & {
  __typename?: 'ArticlePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Populated automatically during publish */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Page template (ID: {0F0EA25C-1803-46D9-8D35-ACB160BEAD9E}). */
export type ArticlePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Page template (ID: {0F0EA25C-1803-46D9-8D35-ACB160BEAD9E}). */
export type ArticlePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Page template (ID: {0F0EA25C-1803-46D9-8D35-ACB160BEAD9E}). */
export type ArticlePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Page template (ID: {0F0EA25C-1803-46D9-8D35-ACB160BEAD9E}). */
export type ArticlePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Page template (ID: {0F0EA25C-1803-46D9-8D35-ACB160BEAD9E}). */
export type ArticlePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Page template (ID: {0F0EA25C-1803-46D9-8D35-ACB160BEAD9E}). */
export type ArticlePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Region template (ID: {293A5238-85B9-4228-A5B4-EC455B94AC93}). */
export type ArticleRegion = Item & {
  __typename?: 'ArticleRegion';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {57756394-9878-4DA8-A504-6880ED1F69ED}). */
  name_5775639498784da8a5046880ed1f69ed?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Region template (ID: {293A5238-85B9-4228-A5B4-EC455B94AC93}). */
export type ArticleRegionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Region template (ID: {293A5238-85B9-4228-A5B4-EC455B94AC93}). */
export type ArticleRegionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Region template (ID: {293A5238-85B9-4228-A5B4-EC455B94AC93}). */
export type ArticleRegionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Region template (ID: {293A5238-85B9-4228-A5B4-EC455B94AC93}). */
export type ArticleRegionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Region template (ID: {293A5238-85B9-4228-A5B4-EC455B94AC93}). */
export type ArticleRegionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Region template (ID: {293A5238-85B9-4228-A5B4-EC455B94AC93}). */
export type ArticleRegionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Regions Folder template (ID: {869F5591-8D59-4B06-84B3-E1EFEFE22393}). */
export type ArticleRegionsFolder = Item & {
  __typename?: 'ArticleRegionsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Regions Folder template (ID: {869F5591-8D59-4B06-84B3-E1EFEFE22393}). */
export type ArticleRegionsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Regions Folder template (ID: {869F5591-8D59-4B06-84B3-E1EFEFE22393}). */
export type ArticleRegionsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Regions Folder template (ID: {869F5591-8D59-4B06-84B3-E1EFEFE22393}). */
export type ArticleRegionsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Regions Folder template (ID: {869F5591-8D59-4B06-84B3-E1EFEFE22393}). */
export type ArticleRegionsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Regions Folder template (ID: {869F5591-8D59-4B06-84B3-E1EFEFE22393}). */
export type ArticleRegionsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Region/Article Regions Folder template (ID: {869F5591-8D59-4B06-84B3-E1EFEFE22393}). */
export type ArticleRegionsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Article Search Page template (ID: {086F1099-0252-402C-B5CA-763279F966AA}). */
export type ArticleSearchPage = AbrdnPage & ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _ContentType & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Article Search Page template (ID: {086F1099-0252-402C-B5CA-763279F966AA}). */
export type ArticleSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Search Page template (ID: {086F1099-0252-402C-B5CA-763279F966AA}). */
export type ArticleSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Search Page template (ID: {086F1099-0252-402C-B5CA-763279F966AA}). */
export type ArticleSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Article Search Page template (ID: {086F1099-0252-402C-B5CA-763279F966AA}). */
export type ArticleSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Search Page template (ID: {086F1099-0252-402C-B5CA-763279F966AA}). */
export type ArticleSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Search Page template (ID: {086F1099-0252-402C-B5CA-763279F966AA}). */
export type ArticleSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Article Search Page template (ID: {4D8BD0D1-A078-41DC-9640-5CA1ED71D81C}). */
export type ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = AbrdnPage & ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _ContentType & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Article Search Page template (ID: {4D8BD0D1-A078-41DC-9640-5CA1ED71D81C}). */
export type ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Search Page template (ID: {4D8BD0D1-A078-41DC-9640-5CA1ED71D81C}). */
export type ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Search Page template (ID: {4D8BD0D1-A078-41DC-9640-5CA1ED71D81C}). */
export type ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Article Search Page template (ID: {4D8BD0D1-A078-41DC-9640-5CA1ED71D81C}). */
export type ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Search Page template (ID: {4D8BD0D1-A078-41DC-9640-5CA1ED71D81C}). */
export type ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Search Page template (ID: {4D8BD0D1-A078-41DC-9640-5CA1ED71D81C}). */
export type ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Article Search Page template (ID: {22B7F7C7-C37F-4644-A8EE-D9C32258B4A2}). */
export type ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = AbrdnPage & ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _ContentType & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Article Search Page template (ID: {22B7F7C7-C37F-4644-A8EE-D9C32258B4A2}). */
export type ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Search Page template (ID: {22B7F7C7-C37F-4644-A8EE-D9C32258B4A2}). */
export type ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Search Page template (ID: {22B7F7C7-C37F-4644-A8EE-D9C32258B4A2}). */
export type ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Article Search Page template (ID: {22B7F7C7-C37F-4644-A8EE-D9C32258B4A2}). */
export type ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Search Page template (ID: {22B7F7C7-C37F-4644-A8EE-D9C32258B4A2}). */
export type ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Search Page template (ID: {22B7F7C7-C37F-4644-A8EE-D9C32258B4A2}). */
export type ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). Also implements _ContentType, _ArticleSearchPage. */
export type ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = {
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Search Page template (ID: {BE414FF5-74AC-4203-ABB2-694811443E25}). */
export type ArticleSearchPage_Be414ff574ac4203abb2694811443e25 = AbrdnPage & ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _ContentType & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Search Page template (ID: {BE414FF5-74AC-4203-ABB2-694811443E25}). */
export type ArticleSearchPage_Be414ff574ac4203abb2694811443e25AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Search Page template (ID: {BE414FF5-74AC-4203-ABB2-694811443E25}). */
export type ArticleSearchPage_Be414ff574ac4203abb2694811443e25ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Search Page template (ID: {BE414FF5-74AC-4203-ABB2-694811443E25}). */
export type ArticleSearchPage_Be414ff574ac4203abb2694811443e25FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Search Page template (ID: {BE414FF5-74AC-4203-ABB2-694811443E25}). */
export type ArticleSearchPage_Be414ff574ac4203abb2694811443e25FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Search Page template (ID: {BE414FF5-74AC-4203-ABB2-694811443E25}). */
export type ArticleSearchPage_Be414ff574ac4203abb2694811443e25HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Search Page template (ID: {BE414FF5-74AC-4203-ABB2-694811443E25}). */
export type ArticleSearchPage_Be414ff574ac4203abb2694811443e25IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Article Search Page template (ID: {C7AD44AC-3CAB-4515-8B61-9465A552A82C}). */
export type ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c = AbrdnPage & ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _ContentType & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Search Page template (ID: {C7AD44AC-3CAB-4515-8B61-9465A552A82C}). */
export type ArticleSearchPage_C7ad44ac3cab45158b619465a552a82cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Search Page template (ID: {C7AD44AC-3CAB-4515-8B61-9465A552A82C}). */
export type ArticleSearchPage_C7ad44ac3cab45158b619465a552a82cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Search Page template (ID: {C7AD44AC-3CAB-4515-8B61-9465A552A82C}). */
export type ArticleSearchPage_C7ad44ac3cab45158b619465a552a82cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Search Page template (ID: {C7AD44AC-3CAB-4515-8B61-9465A552A82C}). */
export type ArticleSearchPage_C7ad44ac3cab45158b619465a552a82cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Search Page template (ID: {C7AD44AC-3CAB-4515-8B61-9465A552A82C}). */
export type ArticleSearchPage_C7ad44ac3cab45158b619465a552a82cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Search Page template (ID: {C7AD44AC-3CAB-4515-8B61-9465A552A82C}). */
export type ArticleSearchPage_C7ad44ac3cab45158b619465a552a82cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Article Search Page template (ID: {CF31BD74-0A4B-4363-B03D-1F7A88E39907}). */
export type ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907 = AbrdnPage & ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _ContentType & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Article Search Page template (ID: {CF31BD74-0A4B-4363-B03D-1F7A88E39907}). */
export type ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Search Page template (ID: {CF31BD74-0A4B-4363-B03D-1F7A88E39907}). */
export type ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Search Page template (ID: {CF31BD74-0A4B-4363-B03D-1F7A88E39907}). */
export type ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Article Search Page template (ID: {CF31BD74-0A4B-4363-B03D-1F7A88E39907}). */
export type ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Search Page template (ID: {CF31BD74-0A4B-4363-B03D-1F7A88E39907}). */
export type ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Search Page template (ID: {CF31BD74-0A4B-4363-B03D-1F7A88E39907}). */
export type ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Collection template (ID: {40B9862A-E611-4110-BD48-61DF0264AE31}). */
export type ArticleSeriesCollection = Item & {
  __typename?: 'ArticleSeriesCollection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {EAA5ACE7-A41F-467E-8E5D-4E1AB9C800A6}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** series (ID: {8CB4A08B-BEDD-49F1-8886-A60C1F2C872F}). */
  series?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {7BED7A32-1142-4604-AF42-0F6147031A78}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Collection template (ID: {40B9862A-E611-4110-BD48-61DF0264AE31}). */
export type ArticleSeriesCollectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Collection template (ID: {40B9862A-E611-4110-BD48-61DF0264AE31}). */
export type ArticleSeriesCollectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Collection template (ID: {40B9862A-E611-4110-BD48-61DF0264AE31}). */
export type ArticleSeriesCollectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Collection template (ID: {40B9862A-E611-4110-BD48-61DF0264AE31}). */
export type ArticleSeriesCollectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Collection template (ID: {40B9862A-E611-4110-BD48-61DF0264AE31}). */
export type ArticleSeriesCollectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Collection template (ID: {40B9862A-E611-4110-BD48-61DF0264AE31}). */
export type ArticleSeriesCollectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Folder template (ID: {1FC2A21A-AEF0-4A5A-91CD-51E9FAAD5569}). */
export type ArticleSeriesFolder = Item & {
  __typename?: 'ArticleSeriesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Folder template (ID: {1FC2A21A-AEF0-4A5A-91CD-51E9FAAD5569}). */
export type ArticleSeriesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Folder template (ID: {1FC2A21A-AEF0-4A5A-91CD-51E9FAAD5569}). */
export type ArticleSeriesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Folder template (ID: {1FC2A21A-AEF0-4A5A-91CD-51E9FAAD5569}). */
export type ArticleSeriesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Folder template (ID: {1FC2A21A-AEF0-4A5A-91CD-51E9FAAD5569}). */
export type ArticleSeriesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Folder template (ID: {1FC2A21A-AEF0-4A5A-91CD-51E9FAAD5569}). */
export type ArticleSeriesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Series/Article Series Folder template (ID: {1FC2A21A-AEF0-4A5A-91CD-51E9FAAD5569}). */
export type ArticleSeriesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Settings/Article Settings template (ID: {38F91638-2833-40B7-9017-AF905CE04CE9}). */
export type ArticleSettings = Item & {
  __typename?: 'ArticleSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** bottomContainerFormDatasource (ID: {64933E42-8FBB-48C2-AC56-B0C7557B2997}). */
  bottomContainerFormDatasource?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** helpWildcardPage (ID: {AFF0C38D-9B8D-4A57-A02E-B6F19429423C}). */
  helpWildcardPage?: Maybe<LookupField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumFormDatasource (ID: {212B765A-5A85-4919-8A76-05B39E20ABB8}). */
  premiumFormDatasource?: Maybe<LookupField>;
  /** pressReleaseWildcardPage (ID: {7361B2C2-8F54-4F9F-9D64-3AA84A2B2A81}). */
  pressReleaseWildcardPage?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** seriesWildcardPage (ID: {FB01B4C1-8EEE-417D-A9C0-67D332CBF6F1}). */
  seriesWildcardPage?: Maybe<LookupField>;
  /** showHelpNextSteps (ID: {1B83F3DA-71E1-402A-B1C1-C0AF4CD3DCF7}). */
  showHelpNextSteps?: Maybe<CheckboxField>;
  /** showNextSteps (ID: {A2DB6955-0E57-47CB-86E0-1971CC498F83}). */
  showNextSteps?: Maybe<CheckboxField>;
  /** showRelatedArticles (ID: {F39DD5EC-7567-4075-BC5E-52CC6A567866}). */
  showRelatedArticles?: Maybe<CheckboxField>;
  /** showRelatedCapabilities (ID: {CF1DC6E7-8B3B-4FA9-AE6F-F753C059F6C3}). */
  showRelatedCapabilities?: Maybe<CheckboxField>;
  /** showRelatedHelpPlatform (ID: {BF9A7513-E900-4E4F-B40D-B593C36CBA47}). */
  showRelatedHelpPlatform?: Maybe<CheckboxField>;
  /** showRelatedStories (ID: {613ED760-95CB-4AAC-B54B-27EA1E57801C}). */
  showRelatedStories?: Maybe<CheckboxField>;
  /** showRelatedTaggedHelp (ID: {F32072A3-2DEA-449D-984D-1E7128549041}). */
  showRelatedTaggedHelp?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** themesWildcardPage (ID: {5DDC029E-1B29-43D0-9727-D7C2C1F319E0}). */
  themesWildcardPage?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** wildcardPage (ID: {B471226D-CBDA-4726-B167-53A184FECB2A}). */
  wildcardPage?: Maybe<LookupField>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Settings/Article Settings template (ID: {38F91638-2833-40B7-9017-AF905CE04CE9}). */
export type ArticleSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Settings/Article Settings template (ID: {38F91638-2833-40B7-9017-AF905CE04CE9}). */
export type ArticleSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Settings/Article Settings template (ID: {38F91638-2833-40B7-9017-AF905CE04CE9}). */
export type ArticleSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Settings/Article Settings template (ID: {38F91638-2833-40B7-9017-AF905CE04CE9}). */
export type ArticleSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Settings/Article Settings template (ID: {38F91638-2833-40B7-9017-AF905CE04CE9}). */
export type ArticleSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Settings/Article Settings template (ID: {38F91638-2833-40B7-9017-AF905CE04CE9}). */
export type ArticleSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner template (ID: {E83EE33A-781E-422C-A77C-B00B381464D6}). */
export type ArticleSubscriptionBanner = Item & {
  __typename?: 'ArticleSubscriptionBanner';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {246EF191-44FA-4938-A6E7-193DFFE5EFA6}). */
  cta?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {8FBFAA01-E842-4F17-9982-36DB97314F1F}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner template (ID: {E83EE33A-781E-422C-A77C-B00B381464D6}). */
export type ArticleSubscriptionBannerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner template (ID: {E83EE33A-781E-422C-A77C-B00B381464D6}). */
export type ArticleSubscriptionBannerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner template (ID: {E83EE33A-781E-422C-A77C-B00B381464D6}). */
export type ArticleSubscriptionBannerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner template (ID: {E83EE33A-781E-422C-A77C-B00B381464D6}). */
export type ArticleSubscriptionBannerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner template (ID: {E83EE33A-781E-422C-A77C-B00B381464D6}). */
export type ArticleSubscriptionBannerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner template (ID: {E83EE33A-781E-422C-A77C-B00B381464D6}). */
export type ArticleSubscriptionBannerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner Folder template (ID: {ACCACD63-CE47-426A-B9EA-31069EA8B32B}). */
export type ArticleSubscriptionBannerFolder = Item & {
  __typename?: 'ArticleSubscriptionBannerFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner Folder template (ID: {ACCACD63-CE47-426A-B9EA-31069EA8B32B}). */
export type ArticleSubscriptionBannerFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner Folder template (ID: {ACCACD63-CE47-426A-B9EA-31069EA8B32B}). */
export type ArticleSubscriptionBannerFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner Folder template (ID: {ACCACD63-CE47-426A-B9EA-31069EA8B32B}). */
export type ArticleSubscriptionBannerFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner Folder template (ID: {ACCACD63-CE47-426A-B9EA-31069EA8B32B}). */
export type ArticleSubscriptionBannerFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner Folder template (ID: {ACCACD63-CE47-426A-B9EA-31069EA8B32B}). */
export type ArticleSubscriptionBannerFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Article Subscribtion Banner/Article Subscription Banner Folder template (ID: {ACCACD63-CE47-426A-B9EA-31069EA8B32B}). */
export type ArticleSubscriptionBannerFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tag template (ID: {FE610BA9-0BDA-4C24-B86C-BF441E7E4A14}). */
export type ArticleTag = Item & {
  __typename?: 'ArticleTag';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {7628B9A2-4740-4A51-BB9D-7C828AE944E6}). */
  name_7628b9a247404a51bb9d7c828ae944e6?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tag template (ID: {FE610BA9-0BDA-4C24-B86C-BF441E7E4A14}). */
export type ArticleTagAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tag template (ID: {FE610BA9-0BDA-4C24-B86C-BF441E7E4A14}). */
export type ArticleTagChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tag template (ID: {FE610BA9-0BDA-4C24-B86C-BF441E7E4A14}). */
export type ArticleTagFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tag template (ID: {FE610BA9-0BDA-4C24-B86C-BF441E7E4A14}). */
export type ArticleTagFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tag template (ID: {FE610BA9-0BDA-4C24-B86C-BF441E7E4A14}). */
export type ArticleTagHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tag template (ID: {FE610BA9-0BDA-4C24-B86C-BF441E7E4A14}). */
export type ArticleTagIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tags Folder template (ID: {346C5AF0-2C58-41E2-B1DC-C01148CAA650}). */
export type ArticleTagsFolder = Item & {
  __typename?: 'ArticleTagsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tags Folder template (ID: {346C5AF0-2C58-41E2-B1DC-C01148CAA650}). */
export type ArticleTagsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tags Folder template (ID: {346C5AF0-2C58-41E2-B1DC-C01148CAA650}). */
export type ArticleTagsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tags Folder template (ID: {346C5AF0-2C58-41E2-B1DC-C01148CAA650}). */
export type ArticleTagsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tags Folder template (ID: {346C5AF0-2C58-41E2-B1DC-C01148CAA650}). */
export type ArticleTagsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tags Folder template (ID: {346C5AF0-2C58-41E2-B1DC-C01148CAA650}). */
export type ArticleTagsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Tag/Article Tags Folder template (ID: {346C5AF0-2C58-41E2-B1DC-C01148CAA650}). */
export type ArticleTagsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Team Author template (ID: {A584E3D9-2F92-424D-ABAD-00361D259F13}). */
export type ArticleTeamAuthor = Item & {
  __typename?: 'ArticleTeamAuthor';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** jobImage (ID: {325AD259-B13B-44CC-B022-23C32BD635EF}). */
  jobImage?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {02CEAC31-4BC6-4C3D-8DD7-8B26FD34F2C2}). */
  name_02ceac314bc64c3d8dd78b26fd34f2c2?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Team Author template (ID: {A584E3D9-2F92-424D-ABAD-00361D259F13}). */
export type ArticleTeamAuthorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Team Author template (ID: {A584E3D9-2F92-424D-ABAD-00361D259F13}). */
export type ArticleTeamAuthorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Team Author template (ID: {A584E3D9-2F92-424D-ABAD-00361D259F13}). */
export type ArticleTeamAuthorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Team Author template (ID: {A584E3D9-2F92-424D-ABAD-00361D259F13}). */
export type ArticleTeamAuthorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Team Author template (ID: {A584E3D9-2F92-424D-ABAD-00361D259F13}). */
export type ArticleTeamAuthorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Author/Article Team Author template (ID: {A584E3D9-2F92-424D-ABAD-00361D259F13}). */
export type ArticleTeamAuthorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tile Parameters Template template (ID: {36975491-7236-437C-BA7E-4F9AB50E3E56}). */
export type ArticleTileParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'ArticleTileParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {A7B59AFF-EE67-4190-AA32-3EC53BFAEFA1}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** size (ID: {45451467-01B3-4810-AB01-ECAFDC8D2B4D}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tile Parameters Template template (ID: {36975491-7236-437C-BA7E-4F9AB50E3E56}). */
export type ArticleTileParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tile Parameters Template template (ID: {36975491-7236-437C-BA7E-4F9AB50E3E56}). */
export type ArticleTileParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tile Parameters Template template (ID: {36975491-7236-437C-BA7E-4F9AB50E3E56}). */
export type ArticleTileParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tile Parameters Template template (ID: {36975491-7236-437C-BA7E-4F9AB50E3E56}). */
export type ArticleTileParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tile Parameters Template template (ID: {36975491-7236-437C-BA7E-4F9AB50E3E56}). */
export type ArticleTileParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tile Parameters Template template (ID: {36975491-7236-437C-BA7E-4F9AB50E3E56}). */
export type ArticleTileParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tiles Parameters Template template (ID: {A7222F60-5C86-46FF-9C1D-44738C00F7C3}). */
export type ArticleTilesParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'ArticleTilesParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {B025303E-264C-4986-9B98-1AD5FD26C8AD}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** size (ID: {3AA9A228-7357-44B4-A16E-033EAFCC05C6}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tiles Parameters Template template (ID: {A7222F60-5C86-46FF-9C1D-44738C00F7C3}). */
export type ArticleTilesParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tiles Parameters Template template (ID: {A7222F60-5C86-46FF-9C1D-44738C00F7C3}). */
export type ArticleTilesParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tiles Parameters Template template (ID: {A7222F60-5C86-46FF-9C1D-44738C00F7C3}). */
export type ArticleTilesParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tiles Parameters Template template (ID: {A7222F60-5C86-46FF-9C1D-44738C00F7C3}). */
export type ArticleTilesParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tiles Parameters Template template (ID: {A7222F60-5C86-46FF-9C1D-44738C00F7C3}). */
export type ArticleTilesParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Article Tiles Parameters Template template (ID: {A7222F60-5C86-46FF-9C1D-44738C00F7C3}). */
export type ArticleTilesParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Wildcard Page template (ID: {4BF0BE7A-0C5C-41D5-973B-B82F1EC73F8F}). */
export type ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Wildcard Page template (ID: {4BF0BE7A-0C5C-41D5-973B-B82F1EC73F8F}). */
export type ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Wildcard Page template (ID: {4BF0BE7A-0C5C-41D5-973B-B82F1EC73F8F}). */
export type ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Wildcard Page template (ID: {4BF0BE7A-0C5C-41D5-973B-B82F1EC73F8F}). */
export type ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Wildcard Page template (ID: {4BF0BE7A-0C5C-41D5-973B-B82F1EC73F8F}). */
export type ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Wildcard Page template (ID: {4BF0BE7A-0C5C-41D5-973B-B82F1EC73F8F}). */
export type ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Article Wildcard Page template (ID: {4BF0BE7A-0C5C-41D5-973B-B82F1EC73F8F}). */
export type ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Article Wildcard Page template (ID: {8F17C5D3-EA39-4914-9491-6DBFE2410AD8}). */
export type ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Wildcard Page template (ID: {8F17C5D3-EA39-4914-9491-6DBFE2410AD8}). */
export type ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Wildcard Page template (ID: {8F17C5D3-EA39-4914-9491-6DBFE2410AD8}). */
export type ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Wildcard Page template (ID: {8F17C5D3-EA39-4914-9491-6DBFE2410AD8}). */
export type ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Wildcard Page template (ID: {8F17C5D3-EA39-4914-9491-6DBFE2410AD8}). */
export type ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Wildcard Page template (ID: {8F17C5D3-EA39-4914-9491-6DBFE2410AD8}). */
export type ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Article Wildcard Page template (ID: {8F17C5D3-EA39-4914-9491-6DBFE2410AD8}). */
export type ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Article Wildcard Page template (ID: {84A63B47-89EE-4A3F-8268-4B750A6A23CA}). */
export type ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Article Wildcard Page template (ID: {84A63B47-89EE-4A3F-8268-4B750A6A23CA}). */
export type ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23caAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Wildcard Page template (ID: {84A63B47-89EE-4A3F-8268-4B750A6A23CA}). */
export type ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23caChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Wildcard Page template (ID: {84A63B47-89EE-4A3F-8268-4B750A6A23CA}). */
export type ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23caFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Article Wildcard Page template (ID: {84A63B47-89EE-4A3F-8268-4B750A6A23CA}). */
export type ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23caFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Wildcard Page template (ID: {84A63B47-89EE-4A3F-8268-4B750A6A23CA}). */
export type ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23caHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Article Wildcard Page template (ID: {84A63B47-89EE-4A3F-8268-4B750A6A23CA}). */
export type ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23caIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Article Wildcard Page template (ID: {95E7966E-0DA1-412B-AFBF-0E8A69392C8C}). */
export type ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Article Wildcard Page template (ID: {95E7966E-0DA1-412B-AFBF-0E8A69392C8C}). */
export type ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Wildcard Page template (ID: {95E7966E-0DA1-412B-AFBF-0E8A69392C8C}). */
export type ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Wildcard Page template (ID: {95E7966E-0DA1-412B-AFBF-0E8A69392C8C}). */
export type ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Article Wildcard Page template (ID: {95E7966E-0DA1-412B-AFBF-0E8A69392C8C}). */
export type ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Wildcard Page template (ID: {95E7966E-0DA1-412B-AFBF-0E8A69392C8C}). */
export type ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Article Wildcard Page template (ID: {95E7966E-0DA1-412B-AFBF-0E8A69392C8C}). */
export type ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Article Wildcard Page template (ID: {405B2025-2077-4003-83D3-B47F09F88B47}). */
export type ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Article Wildcard Page template (ID: {405B2025-2077-4003-83D3-B47F09F88B47}). */
export type ArticleWildcardPage_405b20252077400383d3b47f09f88b47AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Wildcard Page template (ID: {405B2025-2077-4003-83D3-B47F09F88B47}). */
export type ArticleWildcardPage_405b20252077400383d3b47f09f88b47ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Wildcard Page template (ID: {405B2025-2077-4003-83D3-B47F09F88B47}). */
export type ArticleWildcardPage_405b20252077400383d3b47f09f88b47FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Article Wildcard Page template (ID: {405B2025-2077-4003-83D3-B47F09F88B47}). */
export type ArticleWildcardPage_405b20252077400383d3b47f09f88b47FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Wildcard Page template (ID: {405B2025-2077-4003-83D3-B47F09F88B47}). */
export type ArticleWildcardPage_405b20252077400383d3b47f09f88b47HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Article Wildcard Page template (ID: {405B2025-2077-4003-83D3-B47F09F88B47}). */
export type ArticleWildcardPage_405b20252077400383d3b47f09f88b47IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Article Wildcard Page template (ID: {B037A577-F5CB-4AD3-B79F-07720A96985B}). */
export type ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Article Wildcard Page template (ID: {B037A577-F5CB-4AD3-B79F-07720A96985B}). */
export type ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Wildcard Page template (ID: {B037A577-F5CB-4AD3-B79F-07720A96985B}). */
export type ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Wildcard Page template (ID: {B037A577-F5CB-4AD3-B79F-07720A96985B}). */
export type ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Article Wildcard Page template (ID: {B037A577-F5CB-4AD3-B79F-07720A96985B}). */
export type ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Wildcard Page template (ID: {B037A577-F5CB-4AD3-B79F-07720A96985B}). */
export type ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Article Wildcard Page template (ID: {B037A577-F5CB-4AD3-B79F-07720A96985B}). */
export type ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Articles Group Folder template (ID: {1823C13F-0DF6-4C3C-9481-B92ED1A4393D}). */
export type ArticlesGroupFolder = Item & _ContentType & _SharedPage & {
  __typename?: 'ArticlesGroupFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Articles Group Folder template (ID: {1823C13F-0DF6-4C3C-9481-B92ED1A4393D}). */
export type ArticlesGroupFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Articles Group Folder template (ID: {1823C13F-0DF6-4C3C-9481-B92ED1A4393D}). */
export type ArticlesGroupFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Articles Group Folder template (ID: {1823C13F-0DF6-4C3C-9481-B92ED1A4393D}). */
export type ArticlesGroupFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Articles Group Folder template (ID: {1823C13F-0DF6-4C3C-9481-B92ED1A4393D}). */
export type ArticlesGroupFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Articles Group Folder template (ID: {1823C13F-0DF6-4C3C-9481-B92ED1A4393D}). */
export type ArticlesGroupFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Articles Group Folder template (ID: {1823C13F-0DF6-4C3C-9481-B92ED1A4393D}). */
export type ArticlesGroupFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/AttachThemeExtension template (ID: {F83E50FA-251D-4051-B61E-6E2E44BFBE4D}). */
export type AttachThemeExtension = Item & {
  __typename?: 'AttachThemeExtension';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension Themes (ID: {9A598CDE-39F9-402F-B018-5B3A511EEBD1}). */
  extensionThemes?: Maybe<MultilistField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Theme (ID: {F87BEE23-E9B4-4BFF-A18C-EAB597836B46}). */
  theme?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/AttachThemeExtension template (ID: {F83E50FA-251D-4051-B61E-6E2E44BFBE4D}). */
export type AttachThemeExtensionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/AttachThemeExtension template (ID: {F83E50FA-251D-4051-B61E-6E2E44BFBE4D}). */
export type AttachThemeExtensionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/AttachThemeExtension template (ID: {F83E50FA-251D-4051-B61E-6E2E44BFBE4D}). */
export type AttachThemeExtensionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/AttachThemeExtension template (ID: {F83E50FA-251D-4051-B61E-6E2E44BFBE4D}). */
export type AttachThemeExtensionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/AttachThemeExtension template (ID: {F83E50FA-251D-4051-B61E-6E2E44BFBE4D}). */
export type AttachThemeExtensionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/AttachThemeExtension template (ID: {F83E50FA-251D-4051-B61E-6E2E44BFBE4D}). */
export type AttachThemeExtensionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings template (ID: {9B6BCC91-4D8F-4740-A2D6-BB6693CE8558}). */
export type AutomaticDocumentListings = Item & {
  __typename?: 'AutomaticDocumentListings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** editionId (ID: {74D73262-013B-4A4B-9163-197AA7AB4D0E}). */
  editionId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {C3C9C30E-D964-4DB4-B8B0-A210CA0D0FA7}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings template (ID: {9B6BCC91-4D8F-4740-A2D6-BB6693CE8558}). */
export type AutomaticDocumentListingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings template (ID: {9B6BCC91-4D8F-4740-A2D6-BB6693CE8558}). */
export type AutomaticDocumentListingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings template (ID: {9B6BCC91-4D8F-4740-A2D6-BB6693CE8558}). */
export type AutomaticDocumentListingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings template (ID: {9B6BCC91-4D8F-4740-A2D6-BB6693CE8558}). */
export type AutomaticDocumentListingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings template (ID: {9B6BCC91-4D8F-4740-A2D6-BB6693CE8558}). */
export type AutomaticDocumentListingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings template (ID: {9B6BCC91-4D8F-4740-A2D6-BB6693CE8558}). */
export type AutomaticDocumentListingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings Folder template (ID: {63215D38-0D17-462B-B7B6-C4AA627E3EC8}). */
export type AutomaticDocumentListingsFolder = Item & {
  __typename?: 'AutomaticDocumentListingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings Folder template (ID: {63215D38-0D17-462B-B7B6-C4AA627E3EC8}). */
export type AutomaticDocumentListingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings Folder template (ID: {63215D38-0D17-462B-B7B6-C4AA627E3EC8}). */
export type AutomaticDocumentListingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings Folder template (ID: {63215D38-0D17-462B-B7B6-C4AA627E3EC8}). */
export type AutomaticDocumentListingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings Folder template (ID: {63215D38-0D17-462B-B7B6-C4AA627E3EC8}). */
export type AutomaticDocumentListingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings Folder template (ID: {63215D38-0D17-462B-B7B6-C4AA627E3EC8}). */
export type AutomaticDocumentListingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Automatic Document Listings/Automatic Document Listings Folder template (ID: {63215D38-0D17-462B-B7B6-C4AA627E3EC8}). */
export type AutomaticDocumentListingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/Available JSON Renderings template (ID: {634465DA-C860-4D80-B469-98DABC3DE6C8}). */
export type AvailableJsonRenderings = Item & _RenderingsList & {
  __typename?: 'AvailableJSONRenderings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Renderings (ID: {715AE6C0-71C8-4744-AB4F-65362D20AD65}). */
  renderings?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Available JSON Renderings template (ID: {634465DA-C860-4D80-B469-98DABC3DE6C8}). */
export type AvailableJsonRenderingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Available JSON Renderings template (ID: {634465DA-C860-4D80-B469-98DABC3DE6C8}). */
export type AvailableJsonRenderingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Available JSON Renderings template (ID: {634465DA-C860-4D80-B469-98DABC3DE6C8}). */
export type AvailableJsonRenderingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Available JSON Renderings template (ID: {634465DA-C860-4D80-B469-98DABC3DE6C8}). */
export type AvailableJsonRenderingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Available JSON Renderings template (ID: {634465DA-C860-4D80-B469-98DABC3DE6C8}). */
export type AvailableJsonRenderingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Available JSON Renderings template (ID: {634465DA-C860-4D80-B469-98DABC3DE6C8}). */
export type AvailableJsonRenderingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Meta Renderings template (ID: {BF70A40B-6D0E-4639-9862-24BB8946094B}). */
export type AvailableMetaRenderings = Item & _RenderingsList & {
  __typename?: 'AvailableMetaRenderings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Renderings (ID: {715AE6C0-71C8-4744-AB4F-65362D20AD65}). */
  renderings?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Meta Renderings template (ID: {BF70A40B-6D0E-4639-9862-24BB8946094B}). */
export type AvailableMetaRenderingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Meta Renderings template (ID: {BF70A40B-6D0E-4639-9862-24BB8946094B}). */
export type AvailableMetaRenderingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Meta Renderings template (ID: {BF70A40B-6D0E-4639-9862-24BB8946094B}). */
export type AvailableMetaRenderingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Meta Renderings template (ID: {BF70A40B-6D0E-4639-9862-24BB8946094B}). */
export type AvailableMetaRenderingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Meta Renderings template (ID: {BF70A40B-6D0E-4639-9862-24BB8946094B}). */
export type AvailableMetaRenderingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Meta Renderings template (ID: {BF70A40B-6D0E-4639-9862-24BB8946094B}). */
export type AvailableMetaRenderingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings template (ID: {76DA0A8D-FC7E-42B2-AF1E-205B49E43F98}). */
export type AvailableRenderings = Item & _RenderingsList & {
  __typename?: 'AvailableRenderings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Renderings (ID: {715AE6C0-71C8-4744-AB4F-65362D20AD65}). */
  renderings?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings template (ID: {76DA0A8D-FC7E-42B2-AF1E-205B49E43F98}). */
export type AvailableRenderingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings template (ID: {76DA0A8D-FC7E-42B2-AF1E-205B49E43F98}). */
export type AvailableRenderingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings template (ID: {76DA0A8D-FC7E-42B2-AF1E-205B49E43F98}). */
export type AvailableRenderingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings template (ID: {76DA0A8D-FC7E-42B2-AF1E-205B49E43F98}). */
export type AvailableRenderingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings template (ID: {76DA0A8D-FC7E-42B2-AF1E-205B49E43F98}). */
export type AvailableRenderingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings template (ID: {76DA0A8D-FC7E-42B2-AF1E-205B49E43F98}). */
export type AvailableRenderingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). Also implements _SharedRoot. */
export type AvailableRenderingsFolder = {
  /** Group renderings in sections (ID: {878C9A33-E760-4CB8-AAD3-B2309383BF10}). */
  groupRenderingsInSections?: Maybe<CheckboxField>;
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {26EC1D18-11B2-4DD9-8326-F6115F4FD7EB}). */
export type AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = AvailableRenderingsFolder & Item & _SharedRoot & {
  __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Group renderings in sections (ID: {878C9A33-E760-4CB8-AAD3-B2309383BF10}). */
  groupRenderingsInSections?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {26EC1D18-11B2-4DD9-8326-F6115F4FD7EB}). */
export type AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7ebAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {26EC1D18-11B2-4DD9-8326-F6115F4FD7EB}). */
export type AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7ebChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {26EC1D18-11B2-4DD9-8326-F6115F4FD7EB}). */
export type AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7ebFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {26EC1D18-11B2-4DD9-8326-F6115F4FD7EB}). */
export type AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7ebFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {26EC1D18-11B2-4DD9-8326-F6115F4FD7EB}). */
export type AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7ebHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {26EC1D18-11B2-4DD9-8326-F6115F4FD7EB}). */
export type AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7ebIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner template (ID: {03768169-8947-447D-BCE2-12B9745944B0}). */
export type AwardsBanner = Item & {
  __typename?: 'AwardsBanner';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ctaLink (ID: {79515745-4C05-4729-8340-698E42726EEC}). */
  ctaLink?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Decimal value, allows to specify stars value with step: 0.1, min value: 1, max value: 5 */
  stars?: Maybe<TextField>;
  /** This field allows to specify {token.stars} keyword that will be dynamically substituted by formatted value from Stars field. For example value "Our clients rate the call {token.stars} stars our of 5" with Stars field been setted as 4.6 will be presented as "Our clients rate the call 4.6 stars our of 5" */
  starsDescription?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {D5F37831-911A-47C5-9071-3F59BE0B66CD}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner template (ID: {03768169-8947-447D-BCE2-12B9745944B0}). */
export type AwardsBannerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner template (ID: {03768169-8947-447D-BCE2-12B9745944B0}). */
export type AwardsBannerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner template (ID: {03768169-8947-447D-BCE2-12B9745944B0}). */
export type AwardsBannerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner template (ID: {03768169-8947-447D-BCE2-12B9745944B0}). */
export type AwardsBannerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner template (ID: {03768169-8947-447D-BCE2-12B9745944B0}). */
export type AwardsBannerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner template (ID: {03768169-8947-447D-BCE2-12B9745944B0}). */
export type AwardsBannerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Folder template (ID: {3976767F-E855-43FE-961C-CF4AE355BE63}). */
export type AwardsBannerFolder = Item & {
  __typename?: 'AwardsBannerFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Folder template (ID: {3976767F-E855-43FE-961C-CF4AE355BE63}). */
export type AwardsBannerFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Folder template (ID: {3976767F-E855-43FE-961C-CF4AE355BE63}). */
export type AwardsBannerFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Folder template (ID: {3976767F-E855-43FE-961C-CF4AE355BE63}). */
export type AwardsBannerFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Folder template (ID: {3976767F-E855-43FE-961C-CF4AE355BE63}). */
export type AwardsBannerFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Folder template (ID: {3976767F-E855-43FE-961C-CF4AE355BE63}). */
export type AwardsBannerFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Folder template (ID: {3976767F-E855-43FE-961C-CF4AE355BE63}). */
export type AwardsBannerFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Image template (ID: {B2BCC359-0260-41EF-AE4A-93B76FB0BFFA}). */
export type AwardsBannerImage = Item & {
  __typename?: 'AwardsBannerImage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {5E7AA128-5850-4DB9-B8C5-E2E4DBF8607B}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Image template (ID: {B2BCC359-0260-41EF-AE4A-93B76FB0BFFA}). */
export type AwardsBannerImageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Image template (ID: {B2BCC359-0260-41EF-AE4A-93B76FB0BFFA}). */
export type AwardsBannerImageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Image template (ID: {B2BCC359-0260-41EF-AE4A-93B76FB0BFFA}). */
export type AwardsBannerImageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Image template (ID: {B2BCC359-0260-41EF-AE4A-93B76FB0BFFA}). */
export type AwardsBannerImageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Image template (ID: {B2BCC359-0260-41EF-AE4A-93B76FB0BFFA}). */
export type AwardsBannerImageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Awards Banner/Awards Banner Image template (ID: {B2BCC359-0260-41EF-AE4A-93B76FB0BFFA}). */
export type AwardsBannerImageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Awards Banner Parameters Template template (ID: {BE28EEE3-4041-48FB-B788-3C776DCD8347}). */
export type AwardsBannerParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'AwardsBannerParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {CE248ACF-C4BC-4CA5-AD96-0EFB6C2B4CC7}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Awards Banner Parameters Template template (ID: {BE28EEE3-4041-48FB-B788-3C776DCD8347}). */
export type AwardsBannerParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Awards Banner Parameters Template template (ID: {BE28EEE3-4041-48FB-B788-3C776DCD8347}). */
export type AwardsBannerParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Awards Banner Parameters Template template (ID: {BE28EEE3-4041-48FB-B788-3C776DCD8347}). */
export type AwardsBannerParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Awards Banner Parameters Template template (ID: {BE28EEE3-4041-48FB-B788-3C776DCD8347}). */
export type AwardsBannerParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Awards Banner Parameters Template template (ID: {BE28EEE3-4041-48FB-B788-3C776DCD8347}). */
export type AwardsBannerParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Awards Banner Parameters Template template (ID: {BE28EEE3-4041-48FB-B788-3C776DCD8347}). */
export type AwardsBannerParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). */
export type ByocRenderingParameters = {
  /** ComponentLabel (ID: {4B1972F7-A473-4F94-8A4B-E084E2E82F47}). */
  componentLabel?: Maybe<TextField>;
  /** ComponentName (ID: {B7BD1752-E8E9-43EC-9397-A3032F0DA173}). */
  componentName?: Maybe<TextField>;
  /** ComponentProps (ID: {6B667D29-31BC-4C67-9AB5-1338795118D5}). */
  componentProps?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/BYOC Wrapper Rendering Parameters template (ID: {4BBFE581-9C3C-436A-9C27-E981C415ED5A}). */
export type ByocWrapperRenderingParameters = ByocRenderingParameters & BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'BYOCWrapperRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ComponentLabel (ID: {4B1972F7-A473-4F94-8A4B-E084E2E82F47}). */
  componentLabel?: Maybe<TextField>;
  /** ComponentName (ID: {B7BD1752-E8E9-43EC-9397-A3032F0DA173}). */
  componentName?: Maybe<TextField>;
  /** ComponentProps (ID: {6B667D29-31BC-4C67-9AB5-1338795118D5}). */
  componentProps?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/BYOC Wrapper Rendering Parameters template (ID: {4BBFE581-9C3C-436A-9C27-E981C415ED5A}). */
export type ByocWrapperRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/BYOC Wrapper Rendering Parameters template (ID: {4BBFE581-9C3C-436A-9C27-E981C415ED5A}). */
export type ByocWrapperRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/BYOC Wrapper Rendering Parameters template (ID: {4BBFE581-9C3C-436A-9C27-E981C415ED5A}). */
export type ByocWrapperRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/BYOC Wrapper Rendering Parameters template (ID: {4BBFE581-9C3C-436A-9C27-E981C415ED5A}). */
export type ByocWrapperRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/BYOC Wrapper Rendering Parameters template (ID: {4BBFE581-9C3C-436A-9C27-E981C415ED5A}). */
export type ByocWrapperRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/BYOC Wrapper Rendering Parameters template (ID: {4BBFE581-9C3C-436A-9C27-E981C415ED5A}). */
export type ByocWrapperRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option template (ID: {C625411D-01CB-485E-9BD1-F6FA9E00A692}). */
export type BackgroundColorOption = Item & _RenderingRelatedParameters & {
  __typename?: 'BackgroundColorOption';
  /** AllowedRenderings (ID: {7DA92DDB-CD84-4284-826E-44A163E9A53F}). */
  allowedRenderings?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option template (ID: {C625411D-01CB-485E-9BD1-F6FA9E00A692}). */
export type BackgroundColorOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option template (ID: {C625411D-01CB-485E-9BD1-F6FA9E00A692}). */
export type BackgroundColorOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option template (ID: {C625411D-01CB-485E-9BD1-F6FA9E00A692}). */
export type BackgroundColorOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option template (ID: {C625411D-01CB-485E-9BD1-F6FA9E00A692}). */
export type BackgroundColorOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option template (ID: {C625411D-01CB-485E-9BD1-F6FA9E00A692}). */
export type BackgroundColorOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option template (ID: {C625411D-01CB-485E-9BD1-F6FA9E00A692}). */
export type BackgroundColorOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option Folder template (ID: {49DE7FDE-79CA-46C9-B689-830E744C2A24}). */
export type BackgroundColorOptionFolder = Item & {
  __typename?: 'BackgroundColorOptionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option Folder template (ID: {49DE7FDE-79CA-46C9-B689-830E744C2A24}). */
export type BackgroundColorOptionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option Folder template (ID: {49DE7FDE-79CA-46C9-B689-830E744C2A24}). */
export type BackgroundColorOptionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option Folder template (ID: {49DE7FDE-79CA-46C9-B689-830E744C2A24}). */
export type BackgroundColorOptionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option Folder template (ID: {49DE7FDE-79CA-46C9-B689-830E744C2A24}). */
export type BackgroundColorOptionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option Folder template (ID: {49DE7FDE-79CA-46C9-B689-830E744C2A24}). */
export type BackgroundColorOptionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Background/Background Color Option Folder template (ID: {49DE7FDE-79CA-46C9-B689-830E744C2A24}). */
export type BackgroundColorOptionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). */
export type BackgroundParametersTemplate = {
  /** background (ID: {785FB6DB-27CB-487A-9FC6-5FD6A1972980}). */
  background?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Banner Folder template (ID: {82359DCD-B9BF-4AEC-89D9-8B1F7940BC7A}). */
export type BannerFolder = Item & {
  __typename?: 'BannerFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Banner Folder template (ID: {82359DCD-B9BF-4AEC-89D9-8B1F7940BC7A}). */
export type BannerFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Banner Folder template (ID: {82359DCD-B9BF-4AEC-89D9-8B1F7940BC7A}). */
export type BannerFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Banner Folder template (ID: {82359DCD-B9BF-4AEC-89D9-8B1F7940BC7A}). */
export type BannerFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Banner Folder template (ID: {82359DCD-B9BF-4AEC-89D9-8B1F7940BC7A}). */
export type BannerFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Banner Folder template (ID: {82359DCD-B9BF-4AEC-89D9-8B1F7940BC7A}). */
export type BannerFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Banner Folder template (ID: {82359DCD-B9BF-4AEC-89D9-8B1F7940BC7A}). */
export type BannerFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type template (ID: {B3A1EF1D-79BC-4D24-A999-A257577EA98A}). */
export type BannerType = Item & {
  __typename?: 'BannerType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type template (ID: {B3A1EF1D-79BC-4D24-A999-A257577EA98A}). */
export type BannerTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type template (ID: {B3A1EF1D-79BC-4D24-A999-A257577EA98A}). */
export type BannerTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type template (ID: {B3A1EF1D-79BC-4D24-A999-A257577EA98A}). */
export type BannerTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type template (ID: {B3A1EF1D-79BC-4D24-A999-A257577EA98A}). */
export type BannerTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type template (ID: {B3A1EF1D-79BC-4D24-A999-A257577EA98A}). */
export type BannerTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type template (ID: {B3A1EF1D-79BC-4D24-A999-A257577EA98A}). */
export type BannerTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type Folder template (ID: {53214797-6713-4631-A248-ABFE3A281E0D}). */
export type BannerTypeFolder = Item & {
  __typename?: 'BannerTypeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type Folder template (ID: {53214797-6713-4631-A248-ABFE3A281E0D}). */
export type BannerTypeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type Folder template (ID: {53214797-6713-4631-A248-ABFE3A281E0D}). */
export type BannerTypeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type Folder template (ID: {53214797-6713-4631-A248-ABFE3A281E0D}). */
export type BannerTypeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type Folder template (ID: {53214797-6713-4631-A248-ABFE3A281E0D}). */
export type BannerTypeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type Folder template (ID: {53214797-6713-4631-A248-ABFE3A281E0D}). */
export type BannerTypeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Banner/Banner Type Folder template (ID: {53214797-6713-4631-A248-ABFE3A281E0D}). */
export type BannerTypeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). Also implements _DatasourceWorkflow, _Statistics. */
export type BaseCta = {
  /** link (ID: {E2812D47-9120-43D2-9BB5-8FD6D57F823A}). */
  link?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading template (ID: {F71EAD4D-CA1E-4716-9937-89456C81C436}). */
export type BaseHeading = Item & {
  __typename?: 'BaseHeading';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {BB94FC7A-C7F7-4405-9953-43B6318FF770}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {7D732C96-4B1F-4471-A055-85B7B3038331}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading template (ID: {F71EAD4D-CA1E-4716-9937-89456C81C436}). */
export type BaseHeadingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading template (ID: {F71EAD4D-CA1E-4716-9937-89456C81C436}). */
export type BaseHeadingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading template (ID: {F71EAD4D-CA1E-4716-9937-89456C81C436}). */
export type BaseHeadingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading template (ID: {F71EAD4D-CA1E-4716-9937-89456C81C436}). */
export type BaseHeadingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading template (ID: {F71EAD4D-CA1E-4716-9937-89456C81C436}). */
export type BaseHeadingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading template (ID: {F71EAD4D-CA1E-4716-9937-89456C81C436}). */
export type BaseHeadingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading Folder template (ID: {2A4B7036-DCF0-421D-B147-E3174C12E43A}). */
export type BaseHeadingFolder = Item & {
  __typename?: 'BaseHeadingFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading Folder template (ID: {2A4B7036-DCF0-421D-B147-E3174C12E43A}). */
export type BaseHeadingFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading Folder template (ID: {2A4B7036-DCF0-421D-B147-E3174C12E43A}). */
export type BaseHeadingFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading Folder template (ID: {2A4B7036-DCF0-421D-B147-E3174C12E43A}). */
export type BaseHeadingFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading Folder template (ID: {2A4B7036-DCF0-421D-B147-E3174C12E43A}). */
export type BaseHeadingFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading Folder template (ID: {2A4B7036-DCF0-421D-B147-E3174C12E43A}). */
export type BaseHeadingFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base Heading/Base Heading Folder template (ID: {2A4B7036-DCF0-421D-B147-E3174C12E43A}). */
export type BaseHeadingFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). Also implements BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, AbrdnPage, _PageWorkflow, BasePage, _Navigable, _Sitemap, _Taggable, _Designable, _BasePage, _FundMetadataPage, _Statistics, Page, Route, _NavigablePage, _MetadataPage. */
export type BasePage_037da552a5524fe4aeee331f57ac1378 = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). Also implements AbrdnPage, _PageWorkflow, BasePage, _Navigable, _Sitemap, _Taggable, _Designable, _BasePage, _FundMetadataPage, _Statistics, Page, Route, _NavigablePage, _MetadataPage. */
export type BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). Also implements BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, AbrdnPage, _PageWorkflow, BasePage, _Navigable, _Sitemap, _Taggable, _Designable, _BasePage, _FundMetadataPage, _Statistics, Page, Route, _NavigablePage, _MetadataPage. */
export type BasePage_315fd21bebf04c9d9f00bae191442f1d = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). Also implements BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, AbrdnPage, _PageWorkflow, BasePage, _Navigable, _Sitemap, _Taggable, _Designable, _BasePage, _FundMetadataPage, _Statistics, Page, Route, _NavigablePage, _MetadataPage. */
export type BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). Also implements BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, AbrdnPage, _PageWorkflow, BasePage, _Navigable, _Sitemap, _Taggable, _Designable, _BasePage, _FundMetadataPage, _Statistics, Page, Route, _NavigablePage, _MetadataPage. */
export type BasePage_728c97b5c56146d9807e21018a972bb5 = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). Also implements BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, AbrdnPage, _PageWorkflow, BasePage, _Navigable, _Sitemap, _Taggable, _Designable, _BasePage, _FundMetadataPage, _Statistics, Page, Route, _NavigablePage, _MetadataPage. */
export type BasePage_6105875085f346729dfc8d133b481f26 = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). Also implements BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, AbrdnPage, _PageWorkflow, BasePage, _Navigable, _Sitemap, _Taggable, _Designable, _BasePage, _FundMetadataPage, _Statistics, Page, Route, _NavigablePage, _MetadataPage. */
export type BasePage_B08130ebd3314a3b9c0f2b5e9b66387b = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). Also implements IStyling, IComponentVariant, GridParameters. */
export type BaseRenderingParameters = {
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). Also implements _ProtectedTheme, _AssetServiceThemeMode. */
export type BaseTheme = {
  /** BaseLayout (ID: {E0367CD6-E333-4625-9993-BAA4F1C0C92B}). */
  baseLayout?: Maybe<MultilistField>;
  /** CompositeLayout (ID: {1123BAC0-6B46-4FAA-B684-8423C13E4004}). */
  compositeLayout?: Maybe<LookupField>;
  /** Mode (ID: {4D0E825C-D503-42FF-A96F-1949F6259FD0}). */
  mode?: Maybe<LookupField>;
  /** Protected Theme (ID: {0B9CCE83-5355-4D1A-BBFE-E9BA3C3FE744}). */
  protectedTheme?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). */
export type BaseVariantField = {
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/BoolFacet template (ID: {1591F119-BDB9-427D-BD5A-9BE08D1D21DC}). */
export type BoolFacet = Facet & Item & {
  __typename?: 'BoolFacet';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Client Side Handle (ID: {7F42ED80-33F0-4C98-A1E7-B15BE7551C36}). */
  clientSideHandle?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayName (ID: {5DE17054-0141-4E58-935B-FEC623A60806}). */
  displayName_5de1705401414e58935bfec623a60806?: Maybe<TextField>;
  /** Enabled (ID: {3D0FE806-D0E3-4254-96BE-A60899C7D2E6}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Global (ID: {182BD0F4-C902-4A19-A1BA-D189CAA18E1B}). */
  global?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Minimum Number of Items (ID: {8A3AC1B8-8CC1-4DD4-8766-9803F1601741}). */
  minimumNumberOfItems?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {31CA077F-EF38-4980-8A24-05408031B2BC}). */
  name_31ca077fef3849808a2405408031b2bc?: Maybe<TextField>;
  /** Parameters (ID: {0E23BB51-C071-41B5-9D83-AC410B89B85A}). */
  parameters?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {FAE92C1E-9E2C-4209-89EB-C256D55E3D7F}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/BoolFacet template (ID: {1591F119-BDB9-427D-BD5A-9BE08D1D21DC}). */
export type BoolFacetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/BoolFacet template (ID: {1591F119-BDB9-427D-BD5A-9BE08D1D21DC}). */
export type BoolFacetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/BoolFacet template (ID: {1591F119-BDB9-427D-BD5A-9BE08D1D21DC}). */
export type BoolFacetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/BoolFacet template (ID: {1591F119-BDB9-427D-BD5A-9BE08D1D21DC}). */
export type BoolFacetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/BoolFacet template (ID: {1591F119-BDB9-427D-BD5A-9BE08D1D21DC}). */
export type BoolFacetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/BoolFacet template (ID: {1591F119-BDB9-427D-BD5A-9BE08D1D21DC}). */
export type BoolFacetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Branches Folder template (ID: {2F5F8343-2A18-46A4-92A1-0F7AB0452741}). */
export type BranchesFolder = Item & {
  __typename?: 'BranchesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Branches Folder template (ID: {2F5F8343-2A18-46A4-92A1-0F7AB0452741}). */
export type BranchesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Branches Folder template (ID: {2F5F8343-2A18-46A4-92A1-0F7AB0452741}). */
export type BranchesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Branches Folder template (ID: {2F5F8343-2A18-46A4-92A1-0F7AB0452741}). */
export type BranchesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Branches Folder template (ID: {2F5F8343-2A18-46A4-92A1-0F7AB0452741}). */
export type BranchesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Branches Folder template (ID: {2F5F8343-2A18-46A4-92A1-0F7AB0452741}). */
export type BranchesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Branches Folder template (ID: {2F5F8343-2A18-46A4-92A1-0F7AB0452741}). */
export type BranchesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Breadcrumb template (ID: {92E4E12A-EFE6-48E8-AC16-86862DAB37D2}). */
export type Breadcrumb = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Breadcrumb';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BreadcrumbRoot (ID: {26669D72-364B-4074-AC3B-334FF3043838}). */
  breadcrumbRoot?: Maybe<LookupField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Filter (ID: {0D87350B-EAD7-43B3-85E7-F272048DAF5D}). */
  filter?: Maybe<LookupField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsNavigation (ID: {A0726FF1-69E9-4FE4-9FF6-7EA5AB814FE9}). */
  isNavigation?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Separator (ID: {7EABBF58-E0E7-48C0-B96F-C286A1197437}). */
  separator?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Breadcrumb template (ID: {92E4E12A-EFE6-48E8-AC16-86862DAB37D2}). */
export type BreadcrumbAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Breadcrumb template (ID: {92E4E12A-EFE6-48E8-AC16-86862DAB37D2}). */
export type BreadcrumbChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Breadcrumb template (ID: {92E4E12A-EFE6-48E8-AC16-86862DAB37D2}). */
export type BreadcrumbFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Breadcrumb template (ID: {92E4E12A-EFE6-48E8-AC16-86862DAB37D2}). */
export type BreadcrumbFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Breadcrumb template (ID: {92E4E12A-EFE6-48E8-AC16-86862DAB37D2}). */
export type BreadcrumbHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Breadcrumb template (ID: {92E4E12A-EFE6-48E8-AC16-86862DAB37D2}). */
export type BreadcrumbIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/Browser Title Definition template (ID: {5A6BF1D1-836B-425A-A6E6-32CEAA8FF3A5}). */
export type BrowserTitleDefinition = IBaseVariantDefinition & ICompatibleRenderings & IVariantDefinition & Item & VariantDefinition & {
  __typename?: 'BrowserTitleDefinition';
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** Specifies class to render into rendering content element.  */
  cssClass?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /**
   * Specifies field name of the rendered item from which the CSS class will be taken and rendered into class attribute.
   * Supported for Navigation rendering only.
   */
  itemCssClassField?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Provide the field name of the target item. This class is added to the list and navigation items markup (li HTML element). This link is used to override all links when the Is link, Is prefix link, or Is suffix link check boxes are selected. */
  linkField?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/Browser Title Definition template (ID: {5A6BF1D1-836B-425A-A6E6-32CEAA8FF3A5}). */
export type BrowserTitleDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/Browser Title Definition template (ID: {5A6BF1D1-836B-425A-A6E6-32CEAA8FF3A5}). */
export type BrowserTitleDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/Browser Title Definition template (ID: {5A6BF1D1-836B-425A-A6E6-32CEAA8FF3A5}). */
export type BrowserTitleDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/Browser Title Definition template (ID: {5A6BF1D1-836B-425A-A6E6-32CEAA8FF3A5}). */
export type BrowserTitleDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/Browser Title Definition template (ID: {5A6BF1D1-836B-425A-A6E6-32CEAA8FF3A5}). */
export type BrowserTitleDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/Browser Title Definition template (ID: {5A6BF1D1-836B-425A-A6E6-32CEAA8FF3A5}). */
export type BrowserTitleDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Entry template (ID: {5203732F-9512-4ADE-8E02-0CB085C10454}). */
export type CorsEntry = Item & _Cors & {
  __typename?: 'CORSEntry';
  /** The Access-Control-Allow-Credentials header indicates whether or not the response to the request can be exposed when the credentials flag is set to true.  When used as part of a response to a preflight request, this indicates whether or not the actual request can be made using credentials. Simple GET requests are not preflighted, and so if a request is made for a resource with credentials, if this header is not returned with the resource, the response is ignored by the browser and not returned to web content. */
  allowCredentials?: Maybe<CheckboxField>;
  /** The Access-Control-Allow-Headers header is used in response to a preflight request to indicate which HTTP headers can be used when making the actual request. */
  allowHeaders?: Maybe<TextField>;
  /** The Access-Control-Allow-Methods header specifies the method or methods allowed when accessing the resource. This is used in response to a preflight request. */
  allowMethods?: Maybe<TextField>;
  /** The origin parameter specifies a URI that may access the resource. The browser must enforce this. For requests without credentials, the server may specify "*" as a wildcard, thereby allowing any origin to access the resource. */
  allowOrigin?: Maybe<TextField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The Access-Control-Expose-Headers header lets a server whitelist headers that browsers are allowed to access. */
  exposeHeaders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The  Access-Control-Max-Age header indicates how long the results of a preflight request can be cached. */
  maxAge?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Entry template (ID: {5203732F-9512-4ADE-8E02-0CB085C10454}). */
export type CorsEntryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Entry template (ID: {5203732F-9512-4ADE-8E02-0CB085C10454}). */
export type CorsEntryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Entry template (ID: {5203732F-9512-4ADE-8E02-0CB085C10454}). */
export type CorsEntryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Entry template (ID: {5203732F-9512-4ADE-8E02-0CB085C10454}). */
export type CorsEntryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Entry template (ID: {5203732F-9512-4ADE-8E02-0CB085C10454}). */
export type CorsEntryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Entry template (ID: {5203732F-9512-4ADE-8E02-0CB085C10454}). */
export type CorsEntryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Grouping template (ID: {3D55C326-3353-48CD-BEDC-E8AE0CB9EF4D}). */
export type CorsGrouping = Item & {
  __typename?: 'CORSGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Grouping template (ID: {3D55C326-3353-48CD-BEDC-E8AE0CB9EF4D}). */
export type CorsGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Grouping template (ID: {3D55C326-3353-48CD-BEDC-E8AE0CB9EF4D}). */
export type CorsGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Grouping template (ID: {3D55C326-3353-48CD-BEDC-E8AE0CB9EF4D}). */
export type CorsGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Grouping template (ID: {3D55C326-3353-48CD-BEDC-E8AE0CB9EF4D}). */
export type CorsGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Grouping template (ID: {3D55C326-3353-48CD-BEDC-E8AE0CB9EF4D}). */
export type CorsGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/CORS Grouping template (ID: {3D55C326-3353-48CD-BEDC-E8AE0CB9EF4D}). */
export type CorsGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type template (ID: {6188C1F3-48BD-4313-80C1-ABB615F2DEA9}). */
export type CtaPresentationType = Item & _RenderingRelatedParameters & {
  __typename?: 'CTAPresentationType';
  /** AllowedRenderings (ID: {7DA92DDB-CD84-4284-826E-44A163E9A53F}). */
  allowedRenderings?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type template (ID: {6188C1F3-48BD-4313-80C1-ABB615F2DEA9}). */
export type CtaPresentationTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type template (ID: {6188C1F3-48BD-4313-80C1-ABB615F2DEA9}). */
export type CtaPresentationTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type template (ID: {6188C1F3-48BD-4313-80C1-ABB615F2DEA9}). */
export type CtaPresentationTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type template (ID: {6188C1F3-48BD-4313-80C1-ABB615F2DEA9}). */
export type CtaPresentationTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type template (ID: {6188C1F3-48BD-4313-80C1-ABB615F2DEA9}). */
export type CtaPresentationTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type template (ID: {6188C1F3-48BD-4313-80C1-ABB615F2DEA9}). */
export type CtaPresentationTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type Folder template (ID: {FE45A697-0E84-4B05-B859-1DCA7720D003}). */
export type CtaPresentationTypeFolder = Item & {
  __typename?: 'CTAPresentationTypeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type Folder template (ID: {FE45A697-0E84-4B05-B859-1DCA7720D003}). */
export type CtaPresentationTypeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type Folder template (ID: {FE45A697-0E84-4B05-B859-1DCA7720D003}). */
export type CtaPresentationTypeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type Folder template (ID: {FE45A697-0E84-4B05-B859-1DCA7720D003}). */
export type CtaPresentationTypeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type Folder template (ID: {FE45A697-0E84-4B05-B859-1DCA7720D003}). */
export type CtaPresentationTypeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type Folder template (ID: {FE45A697-0E84-4B05-B859-1DCA7720D003}). */
export type CtaPresentationTypeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/CTA Presentation/CTA Presentation Type Folder template (ID: {FE45A697-0E84-4B05-B859-1DCA7720D003}). */
export type CtaPresentationTypeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AbrdnPage) for reliable querying. */
export type C__AbrdnPage = AbrdnPage & Item & _BasePage & _FundMetadataPage & _MetadataPage & _NavigablePage & {
  __typename?: 'C__AbrdnPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AbrdnPage) for reliable querying. */
export type C__AbrdnPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AbrdnPage) for reliable querying. */
export type C__AbrdnPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AbrdnPage) for reliable querying. */
export type C__AbrdnPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AbrdnPage) for reliable querying. */
export type C__AbrdnPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AbrdnPage) for reliable querying. */
export type C__AbrdnPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/Abrdn Page template (ID: {76DA3046-1C7A-497C-9D47-EEF525C85007}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AbrdnPage) for reliable querying. */
export type C__AbrdnPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/Action Base template (ID: {080FA6F3-A933-4A9B-849E-62EEC1CE5C23}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ActionBase) for reliable querying. */
export type C__ActionBase = Item & {
  __typename?: 'C__ActionBase';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/Action Base template (ID: {080FA6F3-A933-4A9B-849E-62EEC1CE5C23}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ActionBase) for reliable querying. */
export type C__ActionBaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/Action Base template (ID: {080FA6F3-A933-4A9B-849E-62EEC1CE5C23}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ActionBase) for reliable querying. */
export type C__ActionBaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/Action Base template (ID: {080FA6F3-A933-4A9B-849E-62EEC1CE5C23}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ActionBase) for reliable querying. */
export type C__ActionBaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/Action Base template (ID: {080FA6F3-A933-4A9B-849E-62EEC1CE5C23}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ActionBase) for reliable querying. */
export type C__ActionBaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/Action Base template (ID: {080FA6F3-A933-4A9B-849E-62EEC1CE5C23}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ActionBase) for reliable querying. */
export type C__ActionBaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/Action Base template (ID: {080FA6F3-A933-4A9B-849E-62EEC1CE5C23}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ActionBase) for reliable querying. */
export type C__ActionBaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AdvancedParameter) for reliable querying. */
export type C__AdvancedParameter = AdvancedParameter & Item & {
  __typename?: 'C__AdvancedParameter';
  /** Advanced (ID: {07A98F74-131F-4BA1-9C00-88416C2832A4}). */
  advanced?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AdvancedParameter) for reliable querying. */
export type C__AdvancedParameterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AdvancedParameter) for reliable querying. */
export type C__AdvancedParameterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AdvancedParameter) for reliable querying. */
export type C__AdvancedParameterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AdvancedParameter) for reliable querying. */
export type C__AdvancedParameterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AdvancedParameter) for reliable querying. */
export type C__AdvancedParameterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/AdvancedParameter template (ID: {347FE6B4-F030-4CD7-B93A-DD8CFDA768EB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AdvancedParameter) for reliable querying. */
export type C__AdvancedParameterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/App template (ID: {061CBA15-5474-4B91-8A06-17903B102B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. App) for reliable querying. */
export type C__App = Item & {
  __typename?: 'C__App';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/App template (ID: {061CBA15-5474-4B91-8A06-17903B102B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. App) for reliable querying. */
export type C__AppAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/App template (ID: {061CBA15-5474-4B91-8A06-17903B102B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. App) for reliable querying. */
export type C__AppChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/App template (ID: {061CBA15-5474-4B91-8A06-17903B102B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. App) for reliable querying. */
export type C__AppFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/App template (ID: {061CBA15-5474-4B91-8A06-17903B102B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. App) for reliable querying. */
export type C__AppFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/App template (ID: {061CBA15-5474-4B91-8A06-17903B102B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. App) for reliable querying. */
export type C__AppHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/App template (ID: {061CBA15-5474-4B91-8A06-17903B102B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. App) for reliable querying. */
export type C__AppIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c) for reliable querying. */
export type C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c & Item & _ContentType & {
  __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c) for reliable querying. */
export type C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c) for reliable querying. */
export type C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c) for reliable querying. */
export type C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c) for reliable querying. */
export type C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c) for reliable querying. */
export type C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Search Page template (ID: {47BC2DCB-3D9F-4B5D-8E69-8D599780180C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c) for reliable querying. */
export type C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Wildcard Page template (ID: {15BCFEB5-37BD-4B27-AAE1-00761F0FCD7D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleWildcardPage) for reliable querying. */
export type C__ArticleWildcardPage = Item & {
  __typename?: 'C__ArticleWildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Wildcard Page template (ID: {15BCFEB5-37BD-4B27-AAE1-00761F0FCD7D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleWildcardPage) for reliable querying. */
export type C__ArticleWildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Wildcard Page template (ID: {15BCFEB5-37BD-4B27-AAE1-00761F0FCD7D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleWildcardPage) for reliable querying. */
export type C__ArticleWildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Wildcard Page template (ID: {15BCFEB5-37BD-4B27-AAE1-00761F0FCD7D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleWildcardPage) for reliable querying. */
export type C__ArticleWildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Wildcard Page template (ID: {15BCFEB5-37BD-4B27-AAE1-00761F0FCD7D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleWildcardPage) for reliable querying. */
export type C__ArticleWildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Wildcard Page template (ID: {15BCFEB5-37BD-4B27-AAE1-00761F0FCD7D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleWildcardPage) for reliable querying. */
export type C__ArticleWildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Article Wildcard Page template (ID: {15BCFEB5-37BD-4B27-AAE1-00761F0FCD7D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ArticleWildcardPage) for reliable querying. */
export type C__ArticleWildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AvailableRenderingsFolder) for reliable querying. */
export type C__AvailableRenderingsFolder = AvailableRenderingsFolder & Item & _SharedRoot & {
  __typename?: 'C__AvailableRenderingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Group renderings in sections (ID: {878C9A33-E760-4CB8-AAD3-B2309383BF10}). */
  groupRenderingsInSections?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AvailableRenderingsFolder) for reliable querying. */
export type C__AvailableRenderingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AvailableRenderingsFolder) for reliable querying. */
export type C__AvailableRenderingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AvailableRenderingsFolder) for reliable querying. */
export type C__AvailableRenderingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AvailableRenderingsFolder) for reliable querying. */
export type C__AvailableRenderingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AvailableRenderingsFolder) for reliable querying. */
export type C__AvailableRenderingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/Available Renderings Folder template (ID: {39A9ED72-407D-4440-BA50-30956834794E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. AvailableRenderingsFolder) for reliable querying. */
export type C__AvailableRenderingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BYOCRenderingParameters) for reliable querying. */
export type C__ByocRenderingParameters = ByocRenderingParameters & Item & StandardRenderingParameters & {
  __typename?: 'C__BYOCRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ComponentLabel (ID: {4B1972F7-A473-4F94-8A4B-E084E2E82F47}). */
  componentLabel?: Maybe<TextField>;
  /** ComponentName (ID: {B7BD1752-E8E9-43EC-9397-A3032F0DA173}). */
  componentName?: Maybe<TextField>;
  /** ComponentProps (ID: {6B667D29-31BC-4C67-9AB5-1338795118D5}). */
  componentProps?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BYOCRenderingParameters) for reliable querying. */
export type C__ByocRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BYOCRenderingParameters) for reliable querying. */
export type C__ByocRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BYOCRenderingParameters) for reliable querying. */
export type C__ByocRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BYOCRenderingParameters) for reliable querying. */
export type C__ByocRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BYOCRenderingParameters) for reliable querying. */
export type C__ByocRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/BYOC Rendering Parameters template (ID: {35D2790D-924B-4EC3-A445-7EF24D70D9DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BYOCRenderingParameters) for reliable querying. */
export type C__ByocRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BackgroundParametersTemplate) for reliable querying. */
export type C__BackgroundParametersTemplate = BackgroundParametersTemplate & Item & {
  __typename?: 'C__BackgroundParametersTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** background (ID: {785FB6DB-27CB-487A-9FC6-5FD6A1972980}). */
  background?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BackgroundParametersTemplate) for reliable querying. */
export type C__BackgroundParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BackgroundParametersTemplate) for reliable querying. */
export type C__BackgroundParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BackgroundParametersTemplate) for reliable querying. */
export type C__BackgroundParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BackgroundParametersTemplate) for reliable querying. */
export type C__BackgroundParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BackgroundParametersTemplate) for reliable querying. */
export type C__BackgroundParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Background Parameters Template template (ID: {CAB0CDA5-0B1F-4CDC-97A6-E6101E97CAEF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BackgroundParametersTemplate) for reliable querying. */
export type C__BackgroundParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseCTA) for reliable querying. */
export type C__BaseCta = BaseCta & Item & {
  __typename?: 'C__BaseCTA';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {E2812D47-9120-43D2-9BB5-8FD6D57F823A}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseCTA) for reliable querying. */
export type C__BaseCtaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseCTA) for reliable querying. */
export type C__BaseCtaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseCTA) for reliable querying. */
export type C__BaseCtaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseCTA) for reliable querying. */
export type C__BaseCtaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseCTA) for reliable querying. */
export type C__BaseCtaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Base CTA/Base CTA template (ID: {B8F46F43-DA67-4CFA-B3DA-1D77DF7ADC02}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseCTA) for reliable querying. */
export type C__BaseCtaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base Page template (ID: {47151711-26CA-434E-8132-D3E0B7D26683}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage) for reliable querying. */
export type C__BasePage = Item & {
  __typename?: 'C__BasePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base Page template (ID: {47151711-26CA-434E-8132-D3E0B7D26683}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage) for reliable querying. */
export type C__BasePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base Page template (ID: {47151711-26CA-434E-8132-D3E0B7D26683}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage) for reliable querying. */
export type C__BasePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base Page template (ID: {47151711-26CA-434E-8132-D3E0B7D26683}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage) for reliable querying. */
export type C__BasePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base Page template (ID: {47151711-26CA-434E-8132-D3E0B7D26683}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage) for reliable querying. */
export type C__BasePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base Page template (ID: {47151711-26CA-434E-8132-D3E0B7D26683}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage) for reliable querying. */
export type C__BasePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base Page template (ID: {47151711-26CA-434E-8132-D3E0B7D26683}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage) for reliable querying. */
export type C__BasePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_037da552a5524fe4aeee331f57ac1378) for reliable querying. */
export type C__BasePage_037da552a5524fe4aeee331f57ac1378 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_037da552a5524fe4aeee331f57ac1378) for reliable querying. */
export type C__BasePage_037da552a5524fe4aeee331f57ac1378AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_037da552a5524fe4aeee331f57ac1378) for reliable querying. */
export type C__BasePage_037da552a5524fe4aeee331f57ac1378ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_037da552a5524fe4aeee331f57ac1378) for reliable querying. */
export type C__BasePage_037da552a5524fe4aeee331f57ac1378FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_037da552a5524fe4aeee331f57ac1378) for reliable querying. */
export type C__BasePage_037da552a5524fe4aeee331f57ac1378FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_037da552a5524fe4aeee331f57ac1378) for reliable querying. */
export type C__BasePage_037da552a5524fe4aeee331f57ac1378HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Base Page template (ID: {037DA552-A552-4FE4-AEEE-331F57AC1378}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_037da552a5524fe4aeee331f57ac1378) for reliable querying. */
export type C__BasePage_037da552a5524fe4aeee331f57ac1378IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f) for reliable querying. */
export type C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f) for reliable querying. */
export type C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f) for reliable querying. */
export type C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f) for reliable querying. */
export type C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f) for reliable querying. */
export type C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f) for reliable querying. */
export type C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Base Page template (ID: {40CD6D0C-EF2A-4231-B0B4-A74F30A23F5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f) for reliable querying. */
export type C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_315fd21bebf04c9d9f00bae191442f1d) for reliable querying. */
export type C__BasePage_315fd21bebf04c9d9f00bae191442f1d = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_315fd21bebf04c9d9f00bae191442f1d) for reliable querying. */
export type C__BasePage_315fd21bebf04c9d9f00bae191442f1dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_315fd21bebf04c9d9f00bae191442f1d) for reliable querying. */
export type C__BasePage_315fd21bebf04c9d9f00bae191442f1dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_315fd21bebf04c9d9f00bae191442f1d) for reliable querying. */
export type C__BasePage_315fd21bebf04c9d9f00bae191442f1dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_315fd21bebf04c9d9f00bae191442f1d) for reliable querying. */
export type C__BasePage_315fd21bebf04c9d9f00bae191442f1dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_315fd21bebf04c9d9f00bae191442f1d) for reliable querying. */
export type C__BasePage_315fd21bebf04c9d9f00bae191442f1dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Base Page template (ID: {315FD21B-EBF0-4C9D-9F00-BAE191442F1D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_315fd21bebf04c9d9f00bae191442f1d) for reliable querying. */
export type C__BasePage_315fd21bebf04c9d9f00bae191442f1dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_458c6cc442da4327b4d4d7d4ecd48cbd) for reliable querying. */
export type C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_458c6cc442da4327b4d4d7d4ecd48cbd) for reliable querying. */
export type C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbdAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_458c6cc442da4327b4d4d7d4ecd48cbd) for reliable querying. */
export type C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbdChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_458c6cc442da4327b4d4d7d4ecd48cbd) for reliable querying. */
export type C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbdFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_458c6cc442da4327b4d4d7d4ecd48cbd) for reliable querying. */
export type C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbdFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_458c6cc442da4327b4d4d7d4ecd48cbd) for reliable querying. */
export type C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbdHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Base Page template (ID: {458C6CC4-42DA-4327-B4D4-D7D4ECD48CBD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_458c6cc442da4327b4d4d7d4ecd48cbd) for reliable querying. */
export type C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbdIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_728c97b5c56146d9807e21018a972bb5) for reliable querying. */
export type C__BasePage_728c97b5c56146d9807e21018a972bb5 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_728c97b5c56146d9807e21018a972bb5) for reliable querying. */
export type C__BasePage_728c97b5c56146d9807e21018a972bb5AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_728c97b5c56146d9807e21018a972bb5) for reliable querying. */
export type C__BasePage_728c97b5c56146d9807e21018a972bb5ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_728c97b5c56146d9807e21018a972bb5) for reliable querying. */
export type C__BasePage_728c97b5c56146d9807e21018a972bb5FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_728c97b5c56146d9807e21018a972bb5) for reliable querying. */
export type C__BasePage_728c97b5c56146d9807e21018a972bb5FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_728c97b5c56146d9807e21018a972bb5) for reliable querying. */
export type C__BasePage_728c97b5c56146d9807e21018a972bb5HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Base Page template (ID: {728C97B5-C561-46D9-807E-21018A972BB5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_728c97b5c56146d9807e21018a972bb5) for reliable querying. */
export type C__BasePage_728c97b5c56146d9807e21018a972bb5IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_6105875085f346729dfc8d133b481f26) for reliable querying. */
export type C__BasePage_6105875085f346729dfc8d133b481f26 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_6105875085f346729dfc8d133b481f26) for reliable querying. */
export type C__BasePage_6105875085f346729dfc8d133b481f26AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_6105875085f346729dfc8d133b481f26) for reliable querying. */
export type C__BasePage_6105875085f346729dfc8d133b481f26ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_6105875085f346729dfc8d133b481f26) for reliable querying. */
export type C__BasePage_6105875085f346729dfc8d133b481f26FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_6105875085f346729dfc8d133b481f26) for reliable querying. */
export type C__BasePage_6105875085f346729dfc8d133b481f26FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_6105875085f346729dfc8d133b481f26) for reliable querying. */
export type C__BasePage_6105875085f346729dfc8d133b481f26HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Base Page template (ID: {61058750-85F3-4672-9DFC-8D133B481F26}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_6105875085f346729dfc8d133b481f26) for reliable querying. */
export type C__BasePage_6105875085f346729dfc8d133b481f26IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_b08130ebd3314a3b9c0f2b5e9b66387b) for reliable querying. */
export type C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_b08130ebd3314a3b9c0f2b5e9b66387b) for reliable querying. */
export type C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_b08130ebd3314a3b9c0f2b5e9b66387b) for reliable querying. */
export type C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_b08130ebd3314a3b9c0f2b5e9b66387b) for reliable querying. */
export type C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_b08130ebd3314a3b9c0f2b5e9b66387b) for reliable querying. */
export type C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_b08130ebd3314a3b9c0f2b5e9b66387b) for reliable querying. */
export type C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Base Page template (ID: {B08130EB-D331-4A3B-9C0F-2B5E9B66387B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BasePage_b08130ebd3314a3b9c0f2b5e9b66387b) for reliable querying. */
export type C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseRenderingParameters) for reliable querying. */
export type C__BaseRenderingParameters = BaseRenderingParameters & GridParameters & IComponentVariant & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'C__BaseRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseRenderingParameters) for reliable querying. */
export type C__BaseRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseRenderingParameters) for reliable querying. */
export type C__BaseRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseRenderingParameters) for reliable querying. */
export type C__BaseRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseRenderingParameters) for reliable querying. */
export type C__BaseRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseRenderingParameters) for reliable querying. */
export type C__BaseRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Rendering Parameters/BaseRenderingParameters template (ID: {4247AAD4-EBDE-4994-998F-E067A51B1FE4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseRenderingParameters) for reliable querying. */
export type C__BaseRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseTheme) for reliable querying. */
export type C__BaseTheme = BaseTheme & Item & _AssetServiceThemeMode & _ProtectedTheme & {
  __typename?: 'C__BaseTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BaseLayout (ID: {E0367CD6-E333-4625-9993-BAA4F1C0C92B}). */
  baseLayout?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CompositeLayout (ID: {1123BAC0-6B46-4FAA-B684-8423C13E4004}). */
  compositeLayout?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Mode (ID: {4D0E825C-D503-42FF-A96F-1949F6259FD0}). */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Protected Theme (ID: {0B9CCE83-5355-4D1A-BBFE-E9BA3C3FE744}). */
  protectedTheme?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseTheme) for reliable querying. */
export type C__BaseThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseTheme) for reliable querying. */
export type C__BaseThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseTheme) for reliable querying. */
export type C__BaseThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseTheme) for reliable querying. */
export type C__BaseThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseTheme) for reliable querying. */
export type C__BaseThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Base Theme template (ID: {78086CA4-8985-45EB-8AA7-B2948D2A0E06}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseTheme) for reliable querying. */
export type C__BaseThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseVariantField) for reliable querying. */
export type C__BaseVariantField = BaseVariantField & Item & {
  __typename?: 'C__BaseVariantField';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseVariantField) for reliable querying. */
export type C__BaseVariantFieldAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseVariantField) for reliable querying. */
export type C__BaseVariantFieldChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseVariantField) for reliable querying. */
export type C__BaseVariantFieldFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseVariantField) for reliable querying. */
export type C__BaseVariantFieldFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseVariantField) for reliable querying. */
export type C__BaseVariantFieldHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Base Variant Field template (ID: {6B1A7B9D-2F58-419D-92B7-3401A61E6F9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. BaseVariantField) for reliable querying. */
export type C__BaseVariantFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Class) for reliable querying. */
export type C__Class = Class & GridItemBase & IIcon & Item & {
  __typename?: 'C__Class';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Class (ID: {591C584F-08A7-4DC6-9D58-1DE178C404A2}). */
  class?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Icon (ID: {39816442-74D9-4CE2-BEB3-128B204EFD40}). */
  icon_3981644274d94ce2beb3128b204efd40?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NonNumeric (ID: {55C117EF-46C0-4CDC-A309-82419983FD42}). */
  nonNumeric?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Tooltip (ID: {B55A9065-9589-41D8-997B-9B4592852134}). */
  tooltip?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Class) for reliable querying. */
export type C__ClassAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Class) for reliable querying. */
export type C__ClassChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Class) for reliable querying. */
export type C__ClassFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Class) for reliable querying. */
export type C__ClassFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Class) for reliable querying. */
export type C__ClassHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Class) for reliable querying. */
export type C__ClassIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Group template (ID: {04A95E7C-0D1C-411D-9D94-AD6AEAD0CDAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeGroup) for reliable querying. */
export type C__CompositeGroup = Item & {
  __typename?: 'C__CompositeGroup';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Group template (ID: {04A95E7C-0D1C-411D-9D94-AD6AEAD0CDAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeGroup) for reliable querying. */
export type C__CompositeGroupAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Group template (ID: {04A95E7C-0D1C-411D-9D94-AD6AEAD0CDAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeGroup) for reliable querying. */
export type C__CompositeGroupChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Group template (ID: {04A95E7C-0D1C-411D-9D94-AD6AEAD0CDAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeGroup) for reliable querying. */
export type C__CompositeGroupFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Group template (ID: {04A95E7C-0D1C-411D-9D94-AD6AEAD0CDAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeGroup) for reliable querying. */
export type C__CompositeGroupFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Group template (ID: {04A95E7C-0D1C-411D-9D94-AD6AEAD0CDAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeGroup) for reliable querying. */
export type C__CompositeGroupHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Group template (ID: {04A95E7C-0D1C-411D-9D94-AD6AEAD0CDAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeGroup) for reliable querying. */
export type C__CompositeGroupIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Section template (ID: {47D90B92-9BD8-4903-88C0-8012347592A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeSection) for reliable querying. */
export type C__CompositeSection = Item & {
  __typename?: 'C__CompositeSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Section template (ID: {47D90B92-9BD8-4903-88C0-8012347592A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeSection) for reliable querying. */
export type C__CompositeSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Section template (ID: {47D90B92-9BD8-4903-88C0-8012347592A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeSection) for reliable querying. */
export type C__CompositeSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Section template (ID: {47D90B92-9BD8-4903-88C0-8012347592A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeSection) for reliable querying. */
export type C__CompositeSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Section template (ID: {47D90B92-9BD8-4903-88C0-8012347592A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeSection) for reliable querying. */
export type C__CompositeSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Section template (ID: {47D90B92-9BD8-4903-88C0-8012347592A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeSection) for reliable querying. */
export type C__CompositeSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Composite Section template (ID: {47D90B92-9BD8-4903-88C0-8012347592A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. CompositeSection) for reliable querying. */
export type C__CompositeSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. EloquaForm) for reliable querying. */
export type C__EloquaForm = EloquaForm & Item & {
  __typename?: 'C__EloquaForm';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** companyName (ID: {432AC6F8-2F50-4030-AFE4-4CDBF3CF4BEC}). */
  companyName?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Numerical ID of the form, as seen in Eloqua. */
  formId?: Maybe<IntegerField>;
  /** formJson (ID: {1EB530B8-59A8-48CE-B04B-7395EBBE5718}). */
  formJson?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. EloquaForm) for reliable querying. */
export type C__EloquaFormAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. EloquaForm) for reliable querying. */
export type C__EloquaFormChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. EloquaForm) for reliable querying. */
export type C__EloquaFormFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. EloquaForm) for reliable querying. */
export type C__EloquaFormFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. EloquaForm) for reliable querying. */
export type C__EloquaFormHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. EloquaForm) for reliable querying. */
export type C__EloquaFormIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Error Page template (ID: {D40DD5CA-DBF1-4611-91B8-F9E1071E557D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ErrorPage_d40dd5cadbf1461191b8f9e1071e557d) for reliable querying. */
export type C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d = Item & {
  __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Error Page template (ID: {D40DD5CA-DBF1-4611-91B8-F9E1071E557D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ErrorPage_d40dd5cadbf1461191b8f9e1071e557d) for reliable querying. */
export type C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Error Page template (ID: {D40DD5CA-DBF1-4611-91B8-F9E1071E557D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ErrorPage_d40dd5cadbf1461191b8f9e1071e557d) for reliable querying. */
export type C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Error Page template (ID: {D40DD5CA-DBF1-4611-91B8-F9E1071E557D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ErrorPage_d40dd5cadbf1461191b8f9e1071e557d) for reliable querying. */
export type C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Error Page template (ID: {D40DD5CA-DBF1-4611-91B8-F9E1071E557D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ErrorPage_d40dd5cadbf1461191b8f9e1071e557d) for reliable querying. */
export type C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Error Page template (ID: {D40DD5CA-DBF1-4611-91B8-F9E1071E557D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ErrorPage_d40dd5cadbf1461191b8f9e1071e557d) for reliable querying. */
export type C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Error Page template (ID: {D40DD5CA-DBF1-4611-91B8-F9E1071E557D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ErrorPage_d40dd5cadbf1461191b8f9e1071e557d) for reliable querying. */
export type C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions) for reliable querying. */
export type C__ExtendedOptions = ExtendedOptions & Item & {
  __typename?: 'C__ExtendedOptions';
  /** Additional compatible templates (ID: {F6677A49-0A1D-4BAD-B8BA-4F0F22BDEE64}). */
  additionalCompatibleTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Can select Page as a data source (ID: {A3411FF6-C978-40AA-B059-A49B9CA2209B}). */
  canSelectPageAsADataSource?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingCssClass (ID: {34E81E40-1D4D-45B0-BCF1-A0FFE5521685}). */
  renderingCssClass?: Maybe<TextField>;
  /** RenderingViewPath (ID: {49B9D6C5-9551-4BA4-840E-74D5582256C0}). */
  renderingViewPath?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions) for reliable querying. */
export type C__ExtendedOptionsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions) for reliable querying. */
export type C__ExtendedOptionsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions) for reliable querying. */
export type C__ExtendedOptionsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions) for reliable querying. */
export type C__ExtendedOptionsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions) for reliable querying. */
export type C__ExtendedOptionsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions) for reliable querying. */
export type C__ExtendedOptionsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_2964fb4257a6440fb192218443904c90) for reliable querying. */
export type C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = ExtendedOptions_2964fb4257a6440fb192218443904c90 & Item & {
  __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90';
  /** AllowedOnTemplates (ID: {1B58D065-FE74-43E3-BA20-54C9588B3011}). */
  allowedOnTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_2964fb4257a6440fb192218443904c90) for reliable querying. */
export type C__ExtendedOptions_2964fb4257a6440fb192218443904c90AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_2964fb4257a6440fb192218443904c90) for reliable querying. */
export type C__ExtendedOptions_2964fb4257a6440fb192218443904c90ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_2964fb4257a6440fb192218443904c90) for reliable querying. */
export type C__ExtendedOptions_2964fb4257a6440fb192218443904c90FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_2964fb4257a6440fb192218443904c90) for reliable querying. */
export type C__ExtendedOptions_2964fb4257a6440fb192218443904c90FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_2964fb4257a6440fb192218443904c90) for reliable querying. */
export type C__ExtendedOptions_2964fb4257a6440fb192218443904c90HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_2964fb4257a6440fb192218443904c90) for reliable querying. */
export type C__ExtendedOptions_2964fb4257a6440fb192218443904c90IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_f1850030f97848b4bdb5884b7e863160) for reliable querying. */
export type C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160 = ExtendedOptions_F1850030f97848b4bdb5884b7e863160 & Item & {
  __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OtherProperties (ID: {E829C217-5E94-4306-9C48-2634B094FDC2}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_f1850030f97848b4bdb5884b7e863160) for reliable querying. */
export type C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_f1850030f97848b4bdb5884b7e863160) for reliable querying. */
export type C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_f1850030f97848b4bdb5884b7e863160) for reliable querying. */
export type C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_f1850030f97848b4bdb5884b7e863160) for reliable querying. */
export type C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_f1850030f97848b4bdb5884b7e863160) for reliable querying. */
export type C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ExtendedOptions_f1850030f97848b4bdb5884b7e863160) for reliable querying. */
export type C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FEaaSRenderingParameters) for reliable querying. */
export type C__FEaaSRenderingParameters = FEaaSRenderingParameters & Item & StandardRenderingParameters & {
  __typename?: 'C__FEaaSRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ComponentConfiguration (ID: {EB331824-D4FA-46EC-8F46-0FCB44F2FF04}). */
  componentConfiguration?: Maybe<TextField>;
  /** ComponentDataOverride (ID: {4938816F-2E6A-48E1-9774-2FD27486EEF0}). */
  componentDataOverride?: Maybe<TextField>;
  /** ComponentHTMLOverride (ID: {81AAF152-9A76-4CC4-B536-696F24B6802B}). */
  componentHTMLOverride?: Maybe<TextField>;
  /** ComponentHostName (ID: {83A26F14-29C1-4329-955A-3FD4B24A086C}). */
  componentHostName?: Maybe<TextField>;
  /** ComponentId (ID: {9793E7A7-8235-457D-B0E1-28FD9BE1BC1A}). */
  componentId?: Maybe<TextField>;
  /** ComponentInstanceId (ID: {98DC43EF-C241-4CDA-858B-EB0C268E0E39}). */
  componentInstanceId?: Maybe<TextField>;
  /** ComponentLabel (ID: {C976D578-DCC8-425D-9642-ED09C8912D4F}). */
  componentLabel?: Maybe<TextField>;
  /** ComponentName (ID: {B24A98B6-A7E7-4B94-AFE0-3505C227516E}). */
  componentName?: Maybe<TextField>;
  /** ComponentRevision (ID: {44B4A313-AD98-46FA-864E-F42F4FDE8135}). */
  componentRevision?: Maybe<TextField>;
  /** ComponentVersion (ID: {5ACE96D4-F71D-4C66-8B9F-6FBC96D02674}). */
  componentVersion?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LibraryId (ID: {4F26AC1C-7CA9-40A7-9CCD-F1FE3BFF64AC}). */
  libraryId?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FEaaSRenderingParameters) for reliable querying. */
export type C__FEaaSRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FEaaSRenderingParameters) for reliable querying. */
export type C__FEaaSRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FEaaSRenderingParameters) for reliable querying. */
export type C__FEaaSRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FEaaSRenderingParameters) for reliable querying. */
export type C__FEaaSRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FEaaSRenderingParameters) for reliable querying. */
export type C__FEaaSRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FEaaSRenderingParameters) for reliable querying. */
export type C__FEaaSRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FacetSelectorConfigBase) for reliable querying. */
export type C__FacetSelectorConfigBase = FacetSelectorConfigBase & Item & {
  __typename?: 'C__FacetSelectorConfigBase';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FacetSelectorConfigBase) for reliable querying. */
export type C__FacetSelectorConfigBaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FacetSelectorConfigBase) for reliable querying. */
export type C__FacetSelectorConfigBaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FacetSelectorConfigBase) for reliable querying. */
export type C__FacetSelectorConfigBaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FacetSelectorConfigBase) for reliable querying. */
export type C__FacetSelectorConfigBaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FacetSelectorConfigBase) for reliable querying. */
export type C__FacetSelectorConfigBaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FacetSelectorConfigBase) for reliable querying. */
export type C__FacetSelectorConfigBaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Parent Page template (ID: {8196D9B5-309F-49F8-82F7-918089B77845}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845) for reliable querying. */
export type C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = Item & {
  __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Parent Page template (ID: {8196D9B5-309F-49F8-82F7-918089B77845}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845) for reliable querying. */
export type C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Parent Page template (ID: {8196D9B5-309F-49F8-82F7-918089B77845}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845) for reliable querying. */
export type C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Parent Page template (ID: {8196D9B5-309F-49F8-82F7-918089B77845}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845) for reliable querying. */
export type C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Parent Page template (ID: {8196D9B5-309F-49F8-82F7-918089B77845}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845) for reliable querying. */
export type C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Parent Page template (ID: {8196D9B5-309F-49F8-82F7-918089B77845}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845) for reliable querying. */
export type C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Parent Page template (ID: {8196D9B5-309F-49F8-82F7-918089B77845}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845) for reliable querying. */
export type C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b) for reliable querying. */
export type C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b & Item & _FilteredArticlesWildcard & {
  __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b) for reliable querying. */
export type C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b) for reliable querying. */
export type C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b) for reliable querying. */
export type C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b) for reliable querying. */
export type C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b) for reliable querying. */
export type C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b) for reliable querying. */
export type C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Details Wildcard Page template (ID: {FB127F7A-EEBA-4645-8C5F-BE9F7C589303}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303) for reliable querying. */
export type C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303 = Item & {
  __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Details Wildcard Page template (ID: {FB127F7A-EEBA-4645-8C5F-BE9F7C589303}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303) for reliable querying. */
export type C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Details Wildcard Page template (ID: {FB127F7A-EEBA-4645-8C5F-BE9F7C589303}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303) for reliable querying. */
export type C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Details Wildcard Page template (ID: {FB127F7A-EEBA-4645-8C5F-BE9F7C589303}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303) for reliable querying. */
export type C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Details Wildcard Page template (ID: {FB127F7A-EEBA-4645-8C5F-BE9F7C589303}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303) for reliable querying. */
export type C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Details Wildcard Page template (ID: {FB127F7A-EEBA-4645-8C5F-BE9F7C589303}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303) for reliable querying. */
export type C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Details Wildcard Page template (ID: {FB127F7A-EEBA-4645-8C5F-BE9F7C589303}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303) for reliable querying. */
export type C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Search Page template (ID: {D83DA2A5-CE90-42B6-BD55-7AA8820C62C5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5) for reliable querying. */
export type C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5 = Item & {
  __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Search Page template (ID: {D83DA2A5-CE90-42B6-BD55-7AA8820C62C5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5) for reliable querying. */
export type C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Search Page template (ID: {D83DA2A5-CE90-42B6-BD55-7AA8820C62C5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5) for reliable querying. */
export type C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Search Page template (ID: {D83DA2A5-CE90-42B6-BD55-7AA8820C62C5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5) for reliable querying. */
export type C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Search Page template (ID: {D83DA2A5-CE90-42B6-BD55-7AA8820C62C5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5) for reliable querying. */
export type C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Search Page template (ID: {D83DA2A5-CE90-42B6-BD55-7AA8820C62C5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5) for reliable querying. */
export type C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Search Page template (ID: {D83DA2A5-CE90-42B6-BD55-7AA8820C62C5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5) for reliable querying. */
export type C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Shareclass Details Wildcard Page template (ID: {E3590AD7-64A8-4980-A419-C4F1F926F9FC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc) for reliable querying. */
export type C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc = Item & {
  __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Shareclass Details Wildcard Page template (ID: {E3590AD7-64A8-4980-A419-C4F1F926F9FC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc) for reliable querying. */
export type C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fcAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Shareclass Details Wildcard Page template (ID: {E3590AD7-64A8-4980-A419-C4F1F926F9FC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc) for reliable querying. */
export type C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fcChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Shareclass Details Wildcard Page template (ID: {E3590AD7-64A8-4980-A419-C4F1F926F9FC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc) for reliable querying. */
export type C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fcFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Shareclass Details Wildcard Page template (ID: {E3590AD7-64A8-4980-A419-C4F1F926F9FC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc) for reliable querying. */
export type C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fcFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Shareclass Details Wildcard Page template (ID: {E3590AD7-64A8-4980-A419-C4F1F926F9FC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc) for reliable querying. */
export type C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fcHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Fund Shareclass Details Wildcard Page template (ID: {E3590AD7-64A8-4980-A419-C4F1F926F9FC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc) for reliable querying. */
export type C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fcIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GlobalDatasourceBehavior) for reliable querying. */
export type C__GlobalDatasourceBehavior = GlobalDatasourceBehavior & Item & {
  __typename?: 'C__GlobalDatasourceBehavior';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source Selection Behavior (ID: {C80E6F3C-5BCD-426B-B1EB-6D10672E985D}). */
  dataSourceSelectionBehavior?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GlobalDatasourceBehavior) for reliable querying. */
export type C__GlobalDatasourceBehaviorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GlobalDatasourceBehavior) for reliable querying. */
export type C__GlobalDatasourceBehaviorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GlobalDatasourceBehavior) for reliable querying. */
export type C__GlobalDatasourceBehaviorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GlobalDatasourceBehavior) for reliable querying. */
export type C__GlobalDatasourceBehaviorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GlobalDatasourceBehavior) for reliable querying. */
export type C__GlobalDatasourceBehaviorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GlobalDatasourceBehavior) for reliable querying. */
export type C__GlobalDatasourceBehaviorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridDefinition) for reliable querying. */
export type C__GridDefinition = GridDefinition & Item & PlaceholderWrapper & {
  __typename?: 'C__GridDefinition';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DefaultGridParameters (ID: {CBB899CD-DAD4-4B72-841A-A638E83E5FE5}). */
  defaultGridParameters?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fixed (ID: {549021D8-F27F-4217-805C-20D686E470D9}). */
  fixed?: Maybe<TextField>;
  /** Flex (ID: {91193E28-C9C9-49EB-916D-87E5AF0F1E34}). */
  flex?: Maybe<TextField>;
  /** GridBodyViewPath (ID: {DC986105-2CD6-4A4F-9B2D-57FBB4858E56}). */
  gridBodyViewPath?: Maybe<TextField>;
  /** GridFieldParserType (ID: {0B4D72A7-BE75-4690-805D-DDD564B1DD94}). */
  gridFieldParserType?: Maybe<TextField>;
  /** Grid Theme (ID: {E0B0A836-40BD-4526-998A-649D3AF28AD5}). */
  gridTheme?: Maybe<LookupField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {21624C80-7821-4EED-B788-C716C5C1A088}). */
  name_21624c8078214eedb788c716c5c1a088?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingParametersFieldType (ID: {228606CA-DE6D-4803-AF3C-A420C90F315D}). */
  renderingParametersFieldType?: Maybe<TextField>;
  /** Row Class (ID: {2105078E-C785-4DB4-9BBF-FF78F2179A17}). */
  rowClass?: Maybe<TextField>;
  /** Row Container Class (ID: {BCEE3E9E-E00C-48AE-B723-A0741FED842B}). */
  rowContainerClass?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Wrapping Class (ID: {BC8986B2-5872-466F-AFEB-390C9A3EDAA4}). */
  wrappingClass?: Maybe<TextField>;
  /** Wrapping Tag (ID: {2341030D-19BA-46E1-91FE-9DF617284932}). */
  wrappingTag?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridDefinition) for reliable querying. */
export type C__GridDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridDefinition) for reliable querying. */
export type C__GridDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridDefinition) for reliable querying. */
export type C__GridDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridDefinition) for reliable querying. */
export type C__GridDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridDefinition) for reliable querying. */
export type C__GridDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridDefinition) for reliable querying. */
export type C__GridDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridItemBase) for reliable querying. */
export type C__GridItemBase = GridItemBase & Item & {
  __typename?: 'C__GridItemBase';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Tooltip (ID: {B55A9065-9589-41D8-997B-9B4592852134}). */
  tooltip?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridItemBase) for reliable querying. */
export type C__GridItemBaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridItemBase) for reliable querying. */
export type C__GridItemBaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridItemBase) for reliable querying. */
export type C__GridItemBaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridItemBase) for reliable querying. */
export type C__GridItemBaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridItemBase) for reliable querying. */
export type C__GridItemBaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridItemBase) for reliable querying. */
export type C__GridItemBaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridParameters) for reliable querying. */
export type C__GridParameters = GridParameters & Item & StandardRenderingParameters & {
  __typename?: 'C__GridParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridParameters) for reliable querying. */
export type C__GridParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridParameters) for reliable querying. */
export type C__GridParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridParameters) for reliable querying. */
export type C__GridParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridParameters) for reliable querying. */
export type C__GridParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridParameters) for reliable querying. */
export type C__GridParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. GridParameters) for reliable querying. */
export type C__GridParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessSite) for reliable querying. */
export type C__HeadlessSite = HeadlessSite & Item & _Description & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _SiteMediaLibrary & _SiteTemplate & {
  __typename?: 'C__HeadlessSite';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessSite) for reliable querying. */
export type C__HeadlessSiteAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessSite) for reliable querying. */
export type C__HeadlessSiteChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessSite) for reliable querying. */
export type C__HeadlessSiteFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessSite) for reliable querying. */
export type C__HeadlessSiteFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessSite) for reliable querying. */
export type C__HeadlessSiteHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessSite) for reliable querying. */
export type C__HeadlessSiteIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessTenant) for reliable querying. */
export type C__HeadlessTenant = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & {
  __typename?: 'C__HeadlessTenant';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessTenant) for reliable querying. */
export type C__HeadlessTenantAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessTenant) for reliable querying. */
export type C__HeadlessTenantChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessTenant) for reliable querying. */
export type C__HeadlessTenantFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessTenant) for reliable querying. */
export type C__HeadlessTenantFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessTenant) for reliable querying. */
export type C__HeadlessTenantHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HeadlessTenant) for reliable querying. */
export type C__HeadlessTenantIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Search Page template (ID: {D1C4D913-65C8-4013-89DC-DE7B5FB2F28B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b) for reliable querying. */
export type C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b = Item & {
  __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Search Page template (ID: {D1C4D913-65C8-4013-89DC-DE7B5FB2F28B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b) for reliable querying. */
export type C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Search Page template (ID: {D1C4D913-65C8-4013-89DC-DE7B5FB2F28B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b) for reliable querying. */
export type C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Search Page template (ID: {D1C4D913-65C8-4013-89DC-DE7B5FB2F28B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b) for reliable querying. */
export type C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Search Page template (ID: {D1C4D913-65C8-4013-89DC-DE7B5FB2F28B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b) for reliable querying. */
export type C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Search Page template (ID: {D1C4D913-65C8-4013-89DC-DE7B5FB2F28B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b) for reliable querying. */
export type C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Search Page template (ID: {D1C4D913-65C8-4013-89DC-DE7B5FB2F28B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b) for reliable querying. */
export type C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Wildcard Page template (ID: {C0A93930-5F6E-47A3-8739-F2A8F300E65D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d) for reliable querying. */
export type C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d = Item & {
  __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Wildcard Page template (ID: {C0A93930-5F6E-47A3-8739-F2A8F300E65D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d) for reliable querying. */
export type C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Wildcard Page template (ID: {C0A93930-5F6E-47A3-8739-F2A8F300E65D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d) for reliable querying. */
export type C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Wildcard Page template (ID: {C0A93930-5F6E-47A3-8739-F2A8F300E65D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d) for reliable querying. */
export type C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Wildcard Page template (ID: {C0A93930-5F6E-47A3-8739-F2A8F300E65D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d) for reliable querying. */
export type C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Wildcard Page template (ID: {C0A93930-5F6E-47A3-8739-F2A8F300E65D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d) for reliable querying. */
export type C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Wildcard Page template (ID: {C0A93930-5F6E-47A3-8739-F2A8F300E65D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d) for reliable querying. */
export type C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Home Page template (ID: {2899B95D-A7F3-46B7-A1DA-7EF14D7EF84D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HomePage_2899b95da7f346b7a1da7ef14d7ef84d) for reliable querying. */
export type C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = Item & {
  __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Home Page template (ID: {2899B95D-A7F3-46B7-A1DA-7EF14D7EF84D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HomePage_2899b95da7f346b7a1da7ef14d7ef84d) for reliable querying. */
export type C__HomePage_2899b95da7f346b7a1da7ef14d7ef84dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Home Page template (ID: {2899B95D-A7F3-46B7-A1DA-7EF14D7EF84D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HomePage_2899b95da7f346b7a1da7ef14d7ef84d) for reliable querying. */
export type C__HomePage_2899b95da7f346b7a1da7ef14d7ef84dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Home Page template (ID: {2899B95D-A7F3-46B7-A1DA-7EF14D7EF84D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HomePage_2899b95da7f346b7a1da7ef14d7ef84d) for reliable querying. */
export type C__HomePage_2899b95da7f346b7a1da7ef14d7ef84dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Home Page template (ID: {2899B95D-A7F3-46B7-A1DA-7EF14D7EF84D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HomePage_2899b95da7f346b7a1da7ef14d7ef84d) for reliable querying. */
export type C__HomePage_2899b95da7f346b7a1da7ef14d7ef84dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Home Page template (ID: {2899B95D-A7F3-46B7-A1DA-7EF14D7EF84D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HomePage_2899b95da7f346b7a1da7ef14d7ef84d) for reliable querying. */
export type C__HomePage_2899b95da7f346b7a1da7ef14d7ef84dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Home Page template (ID: {2899B95D-A7F3-46B7-A1DA-7EF14D7EF84D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. HomePage_2899b95da7f346b7a1da7ef14d7ef84d) for reliable querying. */
export type C__HomePage_2899b95da7f346b7a1da7ef14d7ef84dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IAllowEmpty) for reliable querying. */
export type C__IAllowEmpty = IAllowEmpty & Item & {
  __typename?: 'C__IAllowEmpty';
  /** AllowEmpty (ID: {C91E098F-A65C-4625-B166-0ED004ADAA75}). */
  allowEmpty?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IAllowEmpty) for reliable querying. */
export type C__IAllowEmptyAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IAllowEmpty) for reliable querying. */
export type C__IAllowEmptyChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IAllowEmpty) for reliable querying. */
export type C__IAllowEmptyFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IAllowEmpty) for reliable querying. */
export type C__IAllowEmptyFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IAllowEmpty) for reliable querying. */
export type C__IAllowEmptyHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IAllowEmpty) for reliable querying. */
export type C__IAllowEmptyIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBaseVariantDefinition) for reliable querying. */
export type C__IBaseVariantDefinition = IBaseVariantDefinition & Item & {
  __typename?: 'C__IBaseVariantDefinition';
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBaseVariantDefinition) for reliable querying. */
export type C__IBaseVariantDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBaseVariantDefinition) for reliable querying. */
export type C__IBaseVariantDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBaseVariantDefinition) for reliable querying. */
export type C__IBaseVariantDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBaseVariantDefinition) for reliable querying. */
export type C__IBaseVariantDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBaseVariantDefinition) for reliable querying. */
export type C__IBaseVariantDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBaseVariantDefinition) for reliable querying. */
export type C__IBaseVariantDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBoosting) for reliable querying. */
export type C__IBoosting = IBoosting & Item & {
  __typename?: 'C__IBoosting';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rule (ID: {0F628FD3-A28C-4DA7-968B-DCE9F3B71B5A}). */
  rule?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBoosting) for reliable querying. */
export type C__IBoostingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBoosting) for reliable querying. */
export type C__IBoostingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBoosting) for reliable querying. */
export type C__IBoostingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBoosting) for reliable querying. */
export type C__IBoostingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBoosting) for reliable querying. */
export type C__IBoostingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IBoosting) for reliable querying. */
export type C__IBoostingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICacheable) for reliable querying. */
export type C__ICacheable = ICacheable & Item & {
  __typename?: 'C__ICacheable';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICacheable) for reliable querying. */
export type C__ICacheableAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICacheable) for reliable querying. */
export type C__ICacheableChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICacheable) for reliable querying. */
export type C__ICacheableFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICacheable) for reliable querying. */
export type C__ICacheableFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICacheable) for reliable querying. */
export type C__ICacheableHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICacheable) for reliable querying. */
export type C__ICacheableIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICompatibleRenderings) for reliable querying. */
export type C__ICompatibleRenderings = ICompatibleRenderings & Item & {
  __typename?: 'C__ICompatibleRenderings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICompatibleRenderings) for reliable querying. */
export type C__ICompatibleRenderingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICompatibleRenderings) for reliable querying. */
export type C__ICompatibleRenderingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICompatibleRenderings) for reliable querying. */
export type C__ICompatibleRenderingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICompatibleRenderings) for reliable querying. */
export type C__ICompatibleRenderingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICompatibleRenderings) for reliable querying. */
export type C__ICompatibleRenderingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ICompatibleRenderings) for reliable querying. */
export type C__ICompatibleRenderingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IComponentVariant) for reliable querying. */
export type C__IComponentVariant = IComponentVariant & Item & {
  __typename?: 'C__IComponentVariant';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IComponentVariant) for reliable querying. */
export type C__IComponentVariantAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IComponentVariant) for reliable querying. */
export type C__IComponentVariantChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IComponentVariant) for reliable querying. */
export type C__IComponentVariantFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IComponentVariant) for reliable querying. */
export type C__IComponentVariantFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IComponentVariant) for reliable querying. */
export type C__IComponentVariantHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IComponentVariant) for reliable querying. */
export type C__IComponentVariantIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IControlType) for reliable querying. */
export type C__IControlType = IControlType & Item & {
  __typename?: 'C__IControlType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {62CA1C9E-71A4-465F-835E-55BDA7BB270B}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IControlType) for reliable querying. */
export type C__IControlTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IControlType) for reliable querying. */
export type C__IControlTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IControlType) for reliable querying. */
export type C__IControlTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IControlType) for reliable querying. */
export type C__IControlTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IControlType) for reliable querying. */
export type C__IControlTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IControlType) for reliable querying. */
export type C__IControlTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IDynamicPlaceholder) for reliable querying. */
export type C__IDynamicPlaceholder = IDynamicPlaceholder & Item & {
  __typename?: 'C__IDynamicPlaceholder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IDynamicPlaceholder) for reliable querying. */
export type C__IDynamicPlaceholderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IDynamicPlaceholder) for reliable querying. */
export type C__IDynamicPlaceholderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IDynamicPlaceholder) for reliable querying. */
export type C__IDynamicPlaceholderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IDynamicPlaceholder) for reliable querying. */
export type C__IDynamicPlaceholderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IDynamicPlaceholder) for reliable querying. */
export type C__IDynamicPlaceholderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IDynamicPlaceholder) for reliable querying. */
export type C__IDynamicPlaceholderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsDataSourceTemplates) for reliable querying. */
export type C__IfEaaSComponentsDataSourceTemplates = IfEaaSComponentsDataSourceTemplates & Item & {
  __typename?: 'C__IFEaaSComponentsDataSourceTemplates';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsDataSourceTemplates) for reliable querying. */
export type C__IfEaaSComponentsDataSourceTemplatesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsDataSourceTemplates) for reliable querying. */
export type C__IfEaaSComponentsDataSourceTemplatesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsDataSourceTemplates) for reliable querying. */
export type C__IfEaaSComponentsDataSourceTemplatesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsDataSourceTemplates) for reliable querying. */
export type C__IfEaaSComponentsDataSourceTemplatesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsDataSourceTemplates) for reliable querying. */
export type C__IfEaaSComponentsDataSourceTemplatesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsDataSourceTemplates) for reliable querying. */
export type C__IfEaaSComponentsDataSourceTemplatesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsEditorScriptURL) for reliable querying. */
export type C__IfEaaSComponentsEditorScriptUrl = IfEaaSComponentsEditorScriptUrl & Item & {
  __typename?: 'C__IFEaaSComponentsEditorScriptURL';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsEditorScriptURL) for reliable querying. */
export type C__IfEaaSComponentsEditorScriptUrlAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsEditorScriptURL) for reliable querying. */
export type C__IfEaaSComponentsEditorScriptUrlChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsEditorScriptURL) for reliable querying. */
export type C__IfEaaSComponentsEditorScriptUrlFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsEditorScriptURL) for reliable querying. */
export type C__IfEaaSComponentsEditorScriptUrlFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsEditorScriptURL) for reliable querying. */
export type C__IfEaaSComponentsEditorScriptUrlHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IFEaaSComponentsEditorScriptURL) for reliable querying. */
export type C__IfEaaSComponentsEditorScriptUrlIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IIcon) for reliable querying. */
export type C__IIcon = IIcon & Item & {
  __typename?: 'C__IIcon';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Icon (ID: {39816442-74D9-4CE2-BEB3-128B204EFD40}). */
  icon_3981644274d94ce2beb3128b204efd40?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IIcon) for reliable querying. */
export type C__IIconAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IIcon) for reliable querying. */
export type C__IIconChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IIcon) for reliable querying. */
export type C__IIconFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IIcon) for reliable querying. */
export type C__IIconFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IIcon) for reliable querying. */
export type C__IIconHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IIcon) for reliable querying. */
export type C__IIconIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ILocation) for reliable querying. */
export type C__ILocation = ILocation & Item & {
  __typename?: 'C__ILocation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Location (ID: {F4DCDC00-1A6E-4D2C-B586-54EF20326FB6}). */
  location?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ILocation) for reliable querying. */
export type C__ILocationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ILocation) for reliable querying. */
export type C__ILocationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ILocation) for reliable querying. */
export type C__ILocationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ILocation) for reliable querying. */
export type C__ILocationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ILocation) for reliable querying. */
export type C__ILocationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ILocation) for reliable querying. */
export type C__ILocationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPaginable) for reliable querying. */
export type C__IPaginable = IPaginable & Item & {
  __typename?: 'C__IPaginable';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Offset (ID: {778DF306-72BF-4ECA-8DED-0F0A18A5F9B4}). */
  offset?: Maybe<IntegerField>;
  /** PageSize (ID: {C5A5C905-855F-4DA9-941A-2C20845D0473}). */
  pageSize?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPaginable) for reliable querying. */
export type C__IPaginableAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPaginable) for reliable querying. */
export type C__IPaginableChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPaginable) for reliable querying. */
export type C__IPaginableFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPaginable) for reliable querying. */
export type C__IPaginableFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPaginable) for reliable querying. */
export type C__IPaginableHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPaginable) for reliable querying. */
export type C__IPaginableIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPagination) for reliable querying. */
export type C__IPagination = IPagination & Item & {
  __typename?: 'C__IPagination';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** ListSignature (ID: {3E44E786-672E-4DC0-86A0-FFF0D99A3471}). */
  listSignature?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPagination) for reliable querying. */
export type C__IPaginationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPagination) for reliable querying. */
export type C__IPaginationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPagination) for reliable querying. */
export type C__IPaginationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPagination) for reliable querying. */
export type C__IPaginationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPagination) for reliable querying. */
export type C__IPaginationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPagination) for reliable querying. */
export type C__IPaginationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPoi) for reliable querying. */
export type C__IPoi = Coordinate & IPoi & Item & {
  __typename?: 'C__IPoi';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Deprecated-Latitude (ID: {94969C59-C4B8-43ED-9C92-3FBF930C0ACF}). */
  deprecatedLatitude?: Maybe<NumberField>;
  /** Deprecated-Longitude (ID: {8C1AEA63-2E5E-4FEE-B413-D3B1E050DD26}). */
  deprecatedLongitude?: Maybe<NumberField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Latitudes range from -90 to 90. For example 41.25 or -31.96 */
  latitude?: Maybe<NumberField>;
  /** Longitudes range from -180 to 180. For example, -120.9762 and 115.84 */
  longitude?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPoi) for reliable querying. */
export type C__IPoiAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPoi) for reliable querying. */
export type C__IPoiChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPoi) for reliable querying. */
export type C__IPoiFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPoi) for reliable querying. */
export type C__IPoiFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPoi) for reliable querying. */
export type C__IPoiHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IPoi) for reliable querying. */
export type C__IPoiIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IRenderingId) for reliable querying. */
export type C__IRenderingId = IRenderingId & Item & {
  __typename?: 'C__IRenderingId';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IRenderingId) for reliable querying. */
export type C__IRenderingIdAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IRenderingId) for reliable querying. */
export type C__IRenderingIdChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IRenderingId) for reliable querying. */
export type C__IRenderingIdFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IRenderingId) for reliable querying. */
export type C__IRenderingIdFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IRenderingId) for reliable querying. */
export type C__IRenderingIdHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IRenderingId) for reliable querying. */
export type C__IRenderingIdIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ISplitter) for reliable querying. */
export type C__ISplitter = ISplitter & Item & {
  __typename?: 'C__ISplitter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ISplitter) for reliable querying. */
export type C__ISplitterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ISplitter) for reliable querying. */
export type C__ISplitterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ISplitter) for reliable querying. */
export type C__ISplitterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ISplitter) for reliable querying. */
export type C__ISplitterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ISplitter) for reliable querying. */
export type C__ISplitterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ISplitter) for reliable querying. */
export type C__ISplitterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IStyling) for reliable querying. */
export type C__IStyling = IStyling & Item & {
  __typename?: 'C__IStyling';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IStyling) for reliable querying. */
export type C__IStylingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IStyling) for reliable querying. */
export type C__IStylingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IStyling) for reliable querying. */
export type C__IStylingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IStyling) for reliable querying. */
export type C__IStylingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IStyling) for reliable querying. */
export type C__IStylingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IStyling) for reliable querying. */
export type C__IStylingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IVariantDefinition) for reliable querying. */
export type C__IVariantDefinition = IBaseVariantDefinition & ICompatibleRenderings & IVariantDefinition & Item & {
  __typename?: 'C__IVariantDefinition';
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Provide the field name of the target item. This class is added to the list and navigation items markup (li HTML element). This link is used to override all links when the Is link, Is prefix link, or Is suffix link check boxes are selected. */
  linkField?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IVariantDefinition) for reliable querying. */
export type C__IVariantDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IVariantDefinition) for reliable querying. */
export type C__IVariantDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IVariantDefinition) for reliable querying. */
export type C__IVariantDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IVariantDefinition) for reliable querying. */
export type C__IVariantDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IVariantDefinition) for reliable querying. */
export type C__IVariantDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. IVariantDefinition) for reliable querying. */
export type C__IVariantDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. InvestmentTrustPage) for reliable querying. */
export type C__InvestmentTrustPage = InvestmentTrustPage & Item & _BaseInvestmentTrust & {
  __typename?: 'C__InvestmentTrustPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** trustAssetClass (ID: {34893A4D-3273-4069-8012-71D96C4D46A7}). */
  trustAssetClass?: Maybe<LookupField>;
  /** trustDescription (ID: {23A43E10-8A30-4C8A-A3A8-691D2B2D0D03}). */
  trustDescription?: Maybe<TextField>;
  /** trustId (ID: {EDBD21FE-E562-481E-B05D-8A0765158488}). */
  trustId?: Maybe<TextField>;
  /** trustImage (ID: {1D4C60A3-C121-4758-A634-7466B8C4CFFA}). */
  trustImage?: Maybe<ImageField>;
  /** If checked, trust will not appear on Trust Finder page. */
  trustIsHidden?: Maybe<CheckboxField>;
  /** trustLink (ID: {7A8A011D-72D1-4431-83D8-4220FB5B3AC8}). */
  trustLink?: Maybe<LinkField>;
  /** trustName (ID: {FD13EAF9-DC56-412A-9F46-4A223FE05029}). */
  trustName?: Maybe<TextField>;
  /** trustRegion (ID: {A53FE6EB-699C-49B0-8FA8-59172AAC6E1B}). */
  trustRegion?: Maybe<LookupField>;
  /** trustStyle (ID: {B117229B-0780-4447-858D-94B815A50560}). */
  trustStyle?: Maybe<LookupField>;
  /** trustType (ID: {752F80B1-AA76-43CD-B6C3-D57B0AD59093}). */
  trustType?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. InvestmentTrustPage) for reliable querying. */
export type C__InvestmentTrustPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. InvestmentTrustPage) for reliable querying. */
export type C__InvestmentTrustPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. InvestmentTrustPage) for reliable querying. */
export type C__InvestmentTrustPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. InvestmentTrustPage) for reliable querying. */
export type C__InvestmentTrustPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. InvestmentTrustPage) for reliable querying. */
export type C__InvestmentTrustPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. InvestmentTrustPage) for reliable querying. */
export type C__InvestmentTrustPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONField) for reliable querying. */
export type C__JsonField = BaseVariantField & Item & JsonField & {
  __typename?: 'C__JSONField';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_12ffceb03945476bb027464f09ea5e15?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONField) for reliable querying. */
export type C__JsonFieldAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONField) for reliable querying. */
export type C__JsonFieldChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONField) for reliable querying. */
export type C__JsonFieldFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONField) for reliable querying. */
export type C__JsonFieldFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONField) for reliable querying. */
export type C__JsonFieldHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONField) for reliable querying. */
export type C__JsonFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONReference) for reliable querying. */
export type C__JsonReference = Item & JsonReference & {
  __typename?: 'C__JSONReference';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_22697d5448b249b9bfa9d10a34f1b1eb?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** Defines the name of the field that stores the link to a different item. For example, a simple reference, such as a link, or a mult1-reference field, such as a Tree list. */
  passThroughField?: Maybe<TextField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONReference) for reliable querying. */
export type C__JsonReferenceAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONReference) for reliable querying. */
export type C__JsonReferenceChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONReference) for reliable querying. */
export type C__JsonReferenceFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONReference) for reliable querying. */
export type C__JsonReferenceFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONReference) for reliable querying. */
export type C__JsonReferenceHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSONReference) for reliable querying. */
export type C__JsonReferenceIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Data template (ID: {A29D272E-9D48-453C-9E9D-B47585FA7F20}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSData) for reliable querying. */
export type C__JssData = Item & {
  __typename?: 'C__JSSData';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Data template (ID: {A29D272E-9D48-453C-9E9D-B47585FA7F20}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSData) for reliable querying. */
export type C__JssDataAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Data template (ID: {A29D272E-9D48-453C-9E9D-B47585FA7F20}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSData) for reliable querying. */
export type C__JssDataChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Data template (ID: {A29D272E-9D48-453C-9E9D-B47585FA7F20}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSData) for reliable querying. */
export type C__JssDataFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Data template (ID: {A29D272E-9D48-453C-9E9D-B47585FA7F20}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSData) for reliable querying. */
export type C__JssDataFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Data template (ID: {A29D272E-9D48-453C-9E9D-B47585FA7F20}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSData) for reliable querying. */
export type C__JssDataHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Data template (ID: {A29D272E-9D48-453C-9E9D-B47585FA7F20}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSData) for reliable querying. */
export type C__JssDataIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSettings) for reliable querying. */
export type C__JssSettings = Item & ItemBucketsSettings & JssSettings & _BaseSettings & _GridMapping & _LinkSettings & _SupportedLanguages & {
  __typename?: 'C__JSSSettings';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSettings) for reliable querying. */
export type C__JssSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSettings) for reliable querying. */
export type C__JssSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSettings) for reliable querying. */
export type C__JssSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSettings) for reliable querying. */
export type C__JssSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSettings) for reliable querying. */
export type C__JssSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSettings) for reliable querying. */
export type C__JssSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Folder template (ID: {CE91FBD6-4D89-42C9-B5BC-2A670439E1FF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSiteFolder) for reliable querying. */
export type C__JssSiteFolder = Item & {
  __typename?: 'C__JSSSiteFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Folder template (ID: {CE91FBD6-4D89-42C9-B5BC-2A670439E1FF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSiteFolder) for reliable querying. */
export type C__JssSiteFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Folder template (ID: {CE91FBD6-4D89-42C9-B5BC-2A670439E1FF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSiteFolder) for reliable querying. */
export type C__JssSiteFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Folder template (ID: {CE91FBD6-4D89-42C9-B5BC-2A670439E1FF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSiteFolder) for reliable querying. */
export type C__JssSiteFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Folder template (ID: {CE91FBD6-4D89-42C9-B5BC-2A670439E1FF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSiteFolder) for reliable querying. */
export type C__JssSiteFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Folder template (ID: {CE91FBD6-4D89-42C9-B5BC-2A670439E1FF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSiteFolder) for reliable querying. */
export type C__JssSiteFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Folder template (ID: {CE91FBD6-4D89-42C9-B5BC-2A670439E1FF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JSSSiteFolder) for reliable querying. */
export type C__JssSiteFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Jss Root Folder template (ID: {5A88D058-0802-4E64-8C02-D27760897EE8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JssRootFolder) for reliable querying. */
export type C__JssRootFolder = Item & {
  __typename?: 'C__JssRootFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Jss Root Folder template (ID: {5A88D058-0802-4E64-8C02-D27760897EE8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JssRootFolder) for reliable querying. */
export type C__JssRootFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Jss Root Folder template (ID: {5A88D058-0802-4E64-8C02-D27760897EE8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JssRootFolder) for reliable querying. */
export type C__JssRootFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Jss Root Folder template (ID: {5A88D058-0802-4E64-8C02-D27760897EE8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JssRootFolder) for reliable querying. */
export type C__JssRootFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Jss Root Folder template (ID: {5A88D058-0802-4E64-8C02-D27760897EE8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JssRootFolder) for reliable querying. */
export type C__JssRootFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Jss Root Folder template (ID: {5A88D058-0802-4E64-8C02-D27760897EE8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JssRootFolder) for reliable querying. */
export type C__JssRootFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Jss Root Folder template (ID: {5A88D058-0802-4E64-8C02-D27760897EE8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. JssRootFolder) for reliable querying. */
export type C__JssRootFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Literature Hub Search Page template (ID: {5378EF42-E2C4-4884-97AC-7CC017B10086}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086) for reliable querying. */
export type C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = Item & {
  __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Literature Hub Search Page template (ID: {5378EF42-E2C4-4884-97AC-7CC017B10086}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086) for reliable querying. */
export type C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Literature Hub Search Page template (ID: {5378EF42-E2C4-4884-97AC-7CC017B10086}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086) for reliable querying. */
export type C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Literature Hub Search Page template (ID: {5378EF42-E2C4-4884-97AC-7CC017B10086}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086) for reliable querying. */
export type C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Literature Hub Search Page template (ID: {5378EF42-E2C4-4884-97AC-7CC017B10086}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086) for reliable querying. */
export type C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Literature Hub Search Page template (ID: {5378EF42-E2C4-4884-97AC-7CC017B10086}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086) for reliable querying. */
export type C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Literature Hub Search Page template (ID: {5378EF42-E2C4-4884-97AC-7CC017B10086}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086) for reliable querying. */
export type C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Navigation_e6d98f24d01c419e871a4617125a49ed) for reliable querying. */
export type C__Navigation_E6d98f24d01c419e871a4617125a49ed = Item & Navigation_E6d98f24d01c419e871a4617125a49ed & {
  __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed';
  /** AddRoot (ID: {9A0B3039-D8F2-47E5-8D96-9EF38B834682}). */
  addRoot?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Filter (ID: {5509C7BE-2C58-4EA6-A1FB-1F7BDC72845A}). */
  filter?: Maybe<LookupField>;
  /** Flattened (ID: {E55B2D76-4774-4BAA-9E5F-F8108B77D45F}). */
  flattened?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LevelFrom (ID: {B20124B2-820E-4F89-A310-A260656F1A55}). */
  levelFrom?: Maybe<LookupField>;
  /** LevelTo (ID: {D3AE28E6-B489-4AB9-8C28-5B2BD0161228}). */
  levelTo?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationRoot (ID: {A00D72AA-A24B-4E97-8D6D-49CC34849AE5}). */
  navigationRoot?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Navigation_e6d98f24d01c419e871a4617125a49ed) for reliable querying. */
export type C__Navigation_E6d98f24d01c419e871a4617125a49edAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Navigation_e6d98f24d01c419e871a4617125a49ed) for reliable querying. */
export type C__Navigation_E6d98f24d01c419e871a4617125a49edChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Navigation_e6d98f24d01c419e871a4617125a49ed) for reliable querying. */
export type C__Navigation_E6d98f24d01c419e871a4617125a49edFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Navigation_e6d98f24d01c419e871a4617125a49ed) for reliable querying. */
export type C__Navigation_E6d98f24d01c419e871a4617125a49edFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Navigation_e6d98f24d01c419e871a4617125a49ed) for reliable querying. */
export type C__Navigation_E6d98f24d01c419e871a4617125a49edHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Navigation_e6d98f24d01c419e871a4617125a49ed) for reliable querying. */
export type C__Navigation_E6d98f24d01c419e871a4617125a49edIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Page template (ID: {3F8A6A5D-7B1A-4566-8CD4-0A50F3030BD8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Page) for reliable querying. */
export type C__Page = Item & {
  __typename?: 'C__Page';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Page template (ID: {3F8A6A5D-7B1A-4566-8CD4-0A50F3030BD8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Page) for reliable querying. */
export type C__PageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Page template (ID: {3F8A6A5D-7B1A-4566-8CD4-0A50F3030BD8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Page) for reliable querying. */
export type C__PageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Page template (ID: {3F8A6A5D-7B1A-4566-8CD4-0A50F3030BD8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Page) for reliable querying. */
export type C__PageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Page template (ID: {3F8A6A5D-7B1A-4566-8CD4-0A50F3030BD8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Page) for reliable querying. */
export type C__PageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Page template (ID: {3F8A6A5D-7B1A-4566-8CD4-0A50F3030BD8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Page) for reliable querying. */
export type C__PageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Page template (ID: {3F8A6A5D-7B1A-4566-8CD4-0A50F3030BD8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Page) for reliable querying. */
export type C__PageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Page Data template (ID: {1C82E550-EBCD-4E5D-8ABD-D50D0809541E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageData) for reliable querying. */
export type C__PageData = Item & {
  __typename?: 'C__PageData';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Page Data template (ID: {1C82E550-EBCD-4E5D-8ABD-D50D0809541E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageData) for reliable querying. */
export type C__PageDataAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Page Data template (ID: {1C82E550-EBCD-4E5D-8ABD-D50D0809541E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageData) for reliable querying. */
export type C__PageDataChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Page Data template (ID: {1C82E550-EBCD-4E5D-8ABD-D50D0809541E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageData) for reliable querying. */
export type C__PageDataFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Page Data template (ID: {1C82E550-EBCD-4E5D-8ABD-D50D0809541E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageData) for reliable querying. */
export type C__PageDataFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Page Data template (ID: {1C82E550-EBCD-4E5D-8ABD-D50D0809541E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageData) for reliable querying. */
export type C__PageDataHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Page Data template (ID: {1C82E550-EBCD-4E5D-8ABD-D50D0809541E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageData) for reliable querying. */
export type C__PageDataIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {EC7CC4E4-3A6E-4512-808B-691A8B46045E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder) for reliable querying. */
export type C__PageDesignFolder = Item & {
  __typename?: 'C__PageDesignFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {EC7CC4E4-3A6E-4512-808B-691A8B46045E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder) for reliable querying. */
export type C__PageDesignFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {EC7CC4E4-3A6E-4512-808B-691A8B46045E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder) for reliable querying. */
export type C__PageDesignFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {EC7CC4E4-3A6E-4512-808B-691A8B46045E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder) for reliable querying. */
export type C__PageDesignFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {EC7CC4E4-3A6E-4512-808B-691A8B46045E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder) for reliable querying. */
export type C__PageDesignFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {EC7CC4E4-3A6E-4512-808B-691A8B46045E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder) for reliable querying. */
export type C__PageDesignFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {EC7CC4E4-3A6E-4512-808B-691A8B46045E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder) for reliable querying. */
export type C__PageDesignFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {023F5D48-979D-4381-BC5E-149E36ABD3BD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd) for reliable querying. */
export type C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = Item & {
  __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {023F5D48-979D-4381-BC5E-149E36ABD3BD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd) for reliable querying. */
export type C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bdAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {023F5D48-979D-4381-BC5E-149E36ABD3BD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd) for reliable querying. */
export type C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bdChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {023F5D48-979D-4381-BC5E-149E36ABD3BD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd) for reliable querying. */
export type C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bdFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {023F5D48-979D-4381-BC5E-149E36ABD3BD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd) for reliable querying. */
export type C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bdFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {023F5D48-979D-4381-BC5E-149E36ABD3BD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd) for reliable querying. */
export type C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bdHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Page Design Folder template (ID: {023F5D48-979D-4381-BC5E-149E36ABD3BD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd) for reliable querying. */
export type C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bdIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesigns_daaf41fd96db4892be99f62f16d036c4) for reliable querying. */
export type C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesigns_daaf41fd96db4892be99f62f16d036c4) for reliable querying. */
export type C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesigns_daaf41fd96db4892be99f62f16d036c4) for reliable querying. */
export type C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesigns_daaf41fd96db4892be99f62f16d036c4) for reliable querying. */
export type C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesigns_daaf41fd96db4892be99f62f16d036c4) for reliable querying. */
export type C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesigns_daaf41fd96db4892be99f62f16d036c4) for reliable querying. */
export type C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PageDesigns_daaf41fd96db4892be99f62f16d036c4) for reliable querying. */
export type C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesign) for reliable querying. */
export type C__PartialDesign = Item & PartialDesign & _BasePartialDesign & {
  __typename?: 'C__PartialDesign';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Base Partial Design (ID: {76A92454-C8BE-479B-B260-26AEBCED5A1A}). */
  basePartialDesign?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Signature (ID: {55FAAE90-3BBA-4F7F-96FE-13C3F40055FF}). */
  signature?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesign) for reliable querying. */
export type C__PartialDesignAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesign) for reliable querying. */
export type C__PartialDesignChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesign) for reliable querying. */
export type C__PartialDesignFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesign) for reliable querying. */
export type C__PartialDesignFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesign) for reliable querying. */
export type C__PartialDesignHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesign) for reliable querying. */
export type C__PartialDesignIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {6A4620BB-19F5-4995-837A-7BAA61231C52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder) for reliable querying. */
export type C__PartialDesignFolder = Item & {
  __typename?: 'C__PartialDesignFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {6A4620BB-19F5-4995-837A-7BAA61231C52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder) for reliable querying. */
export type C__PartialDesignFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {6A4620BB-19F5-4995-837A-7BAA61231C52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder) for reliable querying. */
export type C__PartialDesignFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {6A4620BB-19F5-4995-837A-7BAA61231C52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder) for reliable querying. */
export type C__PartialDesignFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {6A4620BB-19F5-4995-837A-7BAA61231C52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder) for reliable querying. */
export type C__PartialDesignFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {6A4620BB-19F5-4995-837A-7BAA61231C52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder) for reliable querying. */
export type C__PartialDesignFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {6A4620BB-19F5-4995-837A-7BAA61231C52}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder) for reliable querying. */
export type C__PartialDesignFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {25F01F50-5534-44F9-B1BA-BCBB60B2D13D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d) for reliable querying. */
export type C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = Item & {
  __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {25F01F50-5534-44F9-B1BA-BCBB60B2D13D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d) for reliable querying. */
export type C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {25F01F50-5534-44F9-B1BA-BCBB60B2D13D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d) for reliable querying. */
export type C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {25F01F50-5534-44F9-B1BA-BCBB60B2D13D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d) for reliable querying. */
export type C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {25F01F50-5534-44F9-B1BA-BCBB60B2D13D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d) for reliable querying. */
export type C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {25F01F50-5534-44F9-B1BA-BCBB60B2D13D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d) for reliable querying. */
export type C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Folders/Partial Design Folder template (ID: {25F01F50-5534-44F9-B1BA-BCBB60B2D13D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d) for reliable querying. */
export type C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Designs template (ID: {79C9FA01-5F6A-48B2-B459-05BBAA826A9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d) for reliable querying. */
export type C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = Item & {
  __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Designs template (ID: {79C9FA01-5F6A-48B2-B459-05BBAA826A9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d) for reliable querying. */
export type C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Designs template (ID: {79C9FA01-5F6A-48B2-B459-05BBAA826A9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d) for reliable querying. */
export type C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Designs template (ID: {79C9FA01-5F6A-48B2-B459-05BBAA826A9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d) for reliable querying. */
export type C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Designs template (ID: {79C9FA01-5F6A-48B2-B459-05BBAA826A9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d) for reliable querying. */
export type C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Designs template (ID: {79C9FA01-5F6A-48B2-B459-05BBAA826A9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d) for reliable querying. */
export type C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Designs template (ID: {79C9FA01-5F6A-48B2-B459-05BBAA826A9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d) for reliable querying. */
export type C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PlaceholderWrapper) for reliable querying. */
export type C__PlaceholderWrapper = Item & PlaceholderWrapper & {
  __typename?: 'C__PlaceholderWrapper';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Wrapping Class (ID: {BC8986B2-5872-466F-AFEB-390C9A3EDAA4}). */
  wrappingClass?: Maybe<TextField>;
  /** Wrapping Tag (ID: {2341030D-19BA-46E1-91FE-9DF617284932}). */
  wrappingTag?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PlaceholderWrapper) for reliable querying. */
export type C__PlaceholderWrapperAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PlaceholderWrapper) for reliable querying. */
export type C__PlaceholderWrapperChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PlaceholderWrapper) for reliable querying. */
export type C__PlaceholderWrapperFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PlaceholderWrapper) for reliable querying. */
export type C__PlaceholderWrapperFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PlaceholderWrapper) for reliable querying. */
export type C__PlaceholderWrapperHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PlaceholderWrapper) for reliable querying. */
export type C__PlaceholderWrapperIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Search Page template (ID: {4197F4D9-5D5F-4FB3-BE77-E0BE695DF7AC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac) for reliable querying. */
export type C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = Item & {
  __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Search Page template (ID: {4197F4D9-5D5F-4FB3-BE77-E0BE695DF7AC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac) for reliable querying. */
export type C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7acAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Search Page template (ID: {4197F4D9-5D5F-4FB3-BE77-E0BE695DF7AC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac) for reliable querying. */
export type C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7acChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Search Page template (ID: {4197F4D9-5D5F-4FB3-BE77-E0BE695DF7AC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac) for reliable querying. */
export type C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7acFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Search Page template (ID: {4197F4D9-5D5F-4FB3-BE77-E0BE695DF7AC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac) for reliable querying. */
export type C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7acFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Search Page template (ID: {4197F4D9-5D5F-4FB3-BE77-E0BE695DF7AC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac) for reliable querying. */
export type C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7acHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Search Page template (ID: {4197F4D9-5D5F-4FB3-BE77-E0BE695DF7AC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac) for reliable querying. */
export type C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7acIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Wildcard Page template (ID: {6A8C237F-261D-4A98-91EF-3E27AFEE2B9B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b) for reliable querying. */
export type C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = Item & {
  __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Wildcard Page template (ID: {6A8C237F-261D-4A98-91EF-3E27AFEE2B9B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b) for reliable querying. */
export type C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Wildcard Page template (ID: {6A8C237F-261D-4A98-91EF-3E27AFEE2B9B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b) for reliable querying. */
export type C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Wildcard Page template (ID: {6A8C237F-261D-4A98-91EF-3E27AFEE2B9B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b) for reliable querying. */
export type C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Wildcard Page template (ID: {6A8C237F-261D-4A98-91EF-3E27AFEE2B9B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b) for reliable querying. */
export type C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Wildcard Page template (ID: {6A8C237F-261D-4A98-91EF-3E27AFEE2B9B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b) for reliable querying. */
export type C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Wildcard Page template (ID: {6A8C237F-261D-4A98-91EF-3E27AFEE2B9B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b) for reliable querying. */
export type C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map Grouping template (ID: {E1CF805E-7F49-4EC9-A25A-182DC798CB5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. RedirectMapGrouping) for reliable querying. */
export type C__RedirectMapGrouping = Item & {
  __typename?: 'C__RedirectMapGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map Grouping template (ID: {E1CF805E-7F49-4EC9-A25A-182DC798CB5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. RedirectMapGrouping) for reliable querying. */
export type C__RedirectMapGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map Grouping template (ID: {E1CF805E-7F49-4EC9-A25A-182DC798CB5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. RedirectMapGrouping) for reliable querying. */
export type C__RedirectMapGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map Grouping template (ID: {E1CF805E-7F49-4EC9-A25A-182DC798CB5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. RedirectMapGrouping) for reliable querying. */
export type C__RedirectMapGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map Grouping template (ID: {E1CF805E-7F49-4EC9-A25A-182DC798CB5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. RedirectMapGrouping) for reliable querying. */
export type C__RedirectMapGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map Grouping template (ID: {E1CF805E-7F49-4EC9-A25A-182DC798CB5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. RedirectMapGrouping) for reliable querying. */
export type C__RedirectMapGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map Grouping template (ID: {E1CF805E-7F49-4EC9-A25A-182DC798CB5F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. RedirectMapGrouping) for reliable querying. */
export type C__RedirectMapGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Resizable IFrame Page template (ID: {6FF27D65-56FF-4533-93BB-B3F7F568D973}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973) for reliable querying. */
export type C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = Item & {
  __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Resizable IFrame Page template (ID: {6FF27D65-56FF-4533-93BB-B3F7F568D973}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973) for reliable querying. */
export type C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Resizable IFrame Page template (ID: {6FF27D65-56FF-4533-93BB-B3F7F568D973}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973) for reliable querying. */
export type C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Resizable IFrame Page template (ID: {6FF27D65-56FF-4533-93BB-B3F7F568D973}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973) for reliable querying. */
export type C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Resizable IFrame Page template (ID: {6FF27D65-56FF-4533-93BB-B3F7F568D973}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973) for reliable querying. */
export type C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Resizable IFrame Page template (ID: {6FF27D65-56FF-4533-93BB-B3F7F568D973}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973) for reliable querying. */
export type C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Resizable IFrame Page template (ID: {6FF27D65-56FF-4533-93BB-B3F7F568D973}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973) for reliable querying. */
export type C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/Route template (ID: {B36BA9FD-0DC0-49C8-BEA2-E55D70E6AF28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Route) for reliable querying. */
export type C__Route = Item & {
  __typename?: 'C__Route';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Route template (ID: {B36BA9FD-0DC0-49C8-BEA2-E55D70E6AF28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Route) for reliable querying. */
export type C__RouteAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Route template (ID: {B36BA9FD-0DC0-49C8-BEA2-E55D70E6AF28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Route) for reliable querying. */
export type C__RouteChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Route template (ID: {B36BA9FD-0DC0-49C8-BEA2-E55D70E6AF28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Route) for reliable querying. */
export type C__RouteFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Route template (ID: {B36BA9FD-0DC0-49C8-BEA2-E55D70E6AF28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Route) for reliable querying. */
export type C__RouteFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Route template (ID: {B36BA9FD-0DC0-49C8-BEA2-E55D70E6AF28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Route) for reliable querying. */
export type C__RouteHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Route template (ID: {B36BA9FD-0DC0-49C8-BEA2-E55D70E6AF28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. Route) for reliable querying. */
export type C__RouteIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SimpleVideo) for reliable querying. */
export type C__SimpleVideo = Item & SimpleVideo & {
  __typename?: 'C__SimpleVideo';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MP4Movie (ID: {10DC336D-04A0-4AD7-ACD9-7E820CFCB9CB}). */
  mP4Movie?: Maybe<LinkField>;
  /** MovieCaption (ID: {C4A0614E-5A4A-4ECF-B49B-B0D82E5EEE7E}). */
  movieCaption?: Maybe<TextField>;
  /** MovieDescription (ID: {75562C38-22F6-4B63-AF7A-DAF44F0730F1}). */
  movieDescription?: Maybe<RichTextField>;
  /** MovieThumbnail (ID: {4E3A41DD-AFB7-4763-BA20-FF27E0BEEDDF}). */
  movieThumbnail?: Maybe<ImageField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OggMovie (ID: {BFCADF11-A141-4200-9FC2-8484E446320D}). */
  oggMovie?: Maybe<LinkField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PosterImage (ID: {22379A66-606E-4205-ABEE-F9AC597084DD}). */
  posterImage?: Maybe<ImageField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** WebMMovie (ID: {2295492E-299B-40FD-BE80-ECCB3EEC7790}). */
  webMMovie?: Maybe<LinkField>;
  /** YoutubeMovie (ID: {C7ABDB60-3F28-4D17-B457-2056710E384F}). */
  youtubeMovie?: Maybe<TextField>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SimpleVideo) for reliable querying. */
export type C__SimpleVideoAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SimpleVideo) for reliable querying. */
export type C__SimpleVideoChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SimpleVideo) for reliable querying. */
export type C__SimpleVideoFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SimpleVideo) for reliable querying. */
export type C__SimpleVideoFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SimpleVideo) for reliable querying. */
export type C__SimpleVideoHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SimpleVideo) for reliable querying. */
export type C__SimpleVideoIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Settings Folder template (ID: {5623C85A-C6D8-4812-817F-2E4F19187461}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SiteSettingsFolder) for reliable querying. */
export type C__SiteSettingsFolder = Item & {
  __typename?: 'C__SiteSettingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Settings Folder template (ID: {5623C85A-C6D8-4812-817F-2E4F19187461}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SiteSettingsFolder) for reliable querying. */
export type C__SiteSettingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Settings Folder template (ID: {5623C85A-C6D8-4812-817F-2E4F19187461}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SiteSettingsFolder) for reliable querying. */
export type C__SiteSettingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Settings Folder template (ID: {5623C85A-C6D8-4812-817F-2E4F19187461}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SiteSettingsFolder) for reliable querying. */
export type C__SiteSettingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Settings Folder template (ID: {5623C85A-C6D8-4812-817F-2E4F19187461}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SiteSettingsFolder) for reliable querying. */
export type C__SiteSettingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Settings Folder template (ID: {5623C85A-C6D8-4812-817F-2E4F19187461}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SiteSettingsFolder) for reliable querying. */
export type C__SiteSettingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Settings Folder template (ID: {5623C85A-C6D8-4812-817F-2E4F19187461}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SiteSettingsFolder) for reliable querying. */
export type C__SiteSettingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SitemapSettings) for reliable querying. */
export type C__SitemapSettings = Item & SitemapSettings & {
  __typename?: 'C__SitemapSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Cache Expiration (ID: {139EB09E-73C4-4F96-A06B-A8BC050954E4}). */
  cacheExpiration?: Maybe<NumberField>;
  /** Cache Type (ID: {FCEFA910-FD09-439B-AE81-EF00487090AD}). */
  cacheType?: Maybe<LookupField>;
  /** changefreq (ID: {E35A52F4-12F4-4153-A49E-2B894355A22E}). */
  changefreq?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Crawler (ID: {A4DA1F5E-CBFE-458D-BAC5-7ABFB80B3E84}). */
  crawler?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Generate Alternate Links (ID: {EB78B584-B22E-47CD-88DA-E80D6DBB9238}). */
  generateAlternateLinks?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** HrefLang (ID: {4369DE8A-D99C-441D-8A4D-106B6366A522}). */
  hrefLang?: Maybe<LookupField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Include xdefault (ID: {674A7926-436F-4882-ADD1-0F92EA860C19}). */
  includeXdefault?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** lastmod (ID: {0708C430-1AD8-4B9B-B48D-E3B7D4495088}). */
  lastmod?: Maybe<CheckboxField>;
  /** LinkProvider (ID: {80823FFA-5BCF-4EA8-8CEA-CEF3B024A5F6}). */
  linkProvider?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** priority (ID: {95C52046-38E4-4D96-BB32-B699891BA215}). */
  priority?: Maybe<CheckboxField>;
  /** Refresh Threshold (ID: {E12195E6-3BCD-4C51-9CD4-3AE3C0779B9F}). */
  refreshThreshold?: Maybe<NumberField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Sitemap Index Threshold (ID: {7634339B-C588-4E3C-952F-7E18F0935378}). */
  sitemapIndexThreshold?: Maybe<NumberField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SitemapSettings) for reliable querying. */
export type C__SitemapSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SitemapSettings) for reliable querying. */
export type C__SitemapSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SitemapSettings) for reliable querying. */
export type C__SitemapSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SitemapSettings) for reliable querying. */
export type C__SitemapSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SitemapSettings) for reliable querying. */
export type C__SitemapSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. SitemapSettings) for reliable querying. */
export type C__SitemapSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Templates/Standard template template (ID: {1930BBEB-7805-471A-A3BE-4858AC7CF696}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. StandardTemplate) for reliable querying. */
export type C__StandardTemplate = Item & {
  __typename?: 'C__StandardTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/System/Templates/Standard template template (ID: {1930BBEB-7805-471A-A3BE-4858AC7CF696}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. StandardTemplate) for reliable querying. */
export type C__StandardTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/System/Templates/Standard template template (ID: {1930BBEB-7805-471A-A3BE-4858AC7CF696}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. StandardTemplate) for reliable querying. */
export type C__StandardTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/System/Templates/Standard template template (ID: {1930BBEB-7805-471A-A3BE-4858AC7CF696}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. StandardTemplate) for reliable querying. */
export type C__StandardTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/System/Templates/Standard template template (ID: {1930BBEB-7805-471A-A3BE-4858AC7CF696}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. StandardTemplate) for reliable querying. */
export type C__StandardTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/System/Templates/Standard template template (ID: {1930BBEB-7805-471A-A3BE-4858AC7CF696}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. StandardTemplate) for reliable querying. */
export type C__StandardTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/System/Templates/Standard template template (ID: {1930BBEB-7805-471A-A3BE-4858AC7CF696}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. StandardTemplate) for reliable querying. */
export type C__StandardTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Parent Page template (ID: {11FBD080-AA84-4ABC-A056-F5CAAC316E4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c) for reliable querying. */
export type C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = Item & {
  __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Parent Page template (ID: {11FBD080-AA84-4ABC-A056-F5CAAC316E4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c) for reliable querying. */
export type C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Parent Page template (ID: {11FBD080-AA84-4ABC-A056-F5CAAC316E4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c) for reliable querying. */
export type C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Parent Page template (ID: {11FBD080-AA84-4ABC-A056-F5CAAC316E4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c) for reliable querying. */
export type C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Parent Page template (ID: {11FBD080-AA84-4ABC-A056-F5CAAC316E4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c) for reliable querying. */
export type C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Parent Page template (ID: {11FBD080-AA84-4ABC-A056-F5CAAC316E4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c) for reliable querying. */
export type C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Parent Page template (ID: {11FBD080-AA84-4ABC-A056-F5CAAC316E4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c) for reliable querying. */
export type C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Wildcard Page template (ID: {8B126281-9006-4B29-80F0-A054EAD02A65}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65) for reliable querying. */
export type C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = Item & {
  __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Wildcard Page template (ID: {8B126281-9006-4B29-80F0-A054EAD02A65}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65) for reliable querying. */
export type C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Wildcard Page template (ID: {8B126281-9006-4B29-80F0-A054EAD02A65}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65) for reliable querying. */
export type C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Wildcard Page template (ID: {8B126281-9006-4B29-80F0-A054EAD02A65}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65) for reliable querying. */
export type C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Wildcard Page template (ID: {8B126281-9006-4B29-80F0-A054EAD02A65}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65) for reliable querying. */
export type C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Wildcard Page template (ID: {8B126281-9006-4B29-80F0-A054EAD02A65}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65) for reliable querying. */
export type C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Team Members Wildcard Page template (ID: {8B126281-9006-4B29-80F0-A054EAD02A65}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65) for reliable querying. */
export type C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Folder template (ID: {985D574D-1CB1-497B-8E9B-67258E6FF449}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TrustFolder) for reliable querying. */
export type C__TrustFolder = Item & {
  __typename?: 'C__TrustFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Folder template (ID: {985D574D-1CB1-497B-8E9B-67258E6FF449}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TrustFolder) for reliable querying. */
export type C__TrustFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Folder template (ID: {985D574D-1CB1-497B-8E9B-67258E6FF449}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TrustFolder) for reliable querying. */
export type C__TrustFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Folder template (ID: {985D574D-1CB1-497B-8E9B-67258E6FF449}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TrustFolder) for reliable querying. */
export type C__TrustFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Folder template (ID: {985D574D-1CB1-497B-8E9B-67258E6FF449}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TrustFolder) for reliable querying. */
export type C__TrustFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Folder template (ID: {985D574D-1CB1-497B-8E9B-67258E6FF449}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TrustFolder) for reliable querying. */
export type C__TrustFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Folder template (ID: {985D574D-1CB1-497B-8E9B-67258E6FF449}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. TrustFolder) for reliable querying. */
export type C__TrustFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantDefinition) for reliable querying. */
export type C__VariantDefinition = IBaseVariantDefinition & ICompatibleRenderings & IVariantDefinition & Item & VariantDefinition & {
  __typename?: 'C__VariantDefinition';
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** Specifies class to render into rendering content element.  */
  cssClass?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /**
   * Specifies field name of the rendered item from which the CSS class will be taken and rendered into class attribute.
   * Supported for Navigation rendering only.
   */
  itemCssClassField?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Provide the field name of the target item. This class is added to the list and navigation items markup (li HTML element). This link is used to override all links when the Is link, Is prefix link, or Is suffix link check boxes are selected. */
  linkField?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantDefinition) for reliable querying. */
export type C__VariantDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantDefinition) for reliable querying. */
export type C__VariantDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantDefinition) for reliable querying. */
export type C__VariantDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantDefinition) for reliable querying. */
export type C__VariantDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantDefinition) for reliable querying. */
export type C__VariantDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantDefinition) for reliable querying. */
export type C__VariantDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantField) for reliable querying. */
export type C__VariantField = BaseVariantField & Item & VariantField & _DataAttributes & _LinkAttributes & {
  __typename?: 'C__VariantField';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Select to have a hyperlink with a download attribute. */
  isDownloadLink?: Maybe<CheckboxField>;
  /** Select to have hyperlinks that wrap the field content. */
  isLink?: Maybe<TextField>;
  /** Select to wrap prefix in the same link which you use for the field content. */
  isPrefixLink?: Maybe<TextField>;
  /** Select to wrap the suffix with a hyperlink. */
  isSuffixLink?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Adds string value as a prefix. */
  prefix?: Maybe<TextField>;
  /** Select to render empty element when the field is empty. */
  renderIfEmpty?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Adds string value as a suffix. */
  suffix?: Maybe<TextField>;
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Select to edit rendered field. */
  useFieldRenderer?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantField) for reliable querying. */
export type C__VariantFieldAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantField) for reliable querying. */
export type C__VariantFieldChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantField) for reliable querying. */
export type C__VariantFieldFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantField) for reliable querying. */
export type C__VariantFieldFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantField) for reliable querying. */
export type C__VariantFieldHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantField) for reliable querying. */
export type C__VariantFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Variants Grouping template (ID: {BBB9AE71-C6B4-4201-83E7-AC5B3EF373DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantsGrouping) for reliable querying. */
export type C__VariantsGrouping = Item & {
  __typename?: 'C__VariantsGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Variants Grouping template (ID: {BBB9AE71-C6B4-4201-83E7-AC5B3EF373DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantsGrouping) for reliable querying. */
export type C__VariantsGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Variants Grouping template (ID: {BBB9AE71-C6B4-4201-83E7-AC5B3EF373DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantsGrouping) for reliable querying. */
export type C__VariantsGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Variants Grouping template (ID: {BBB9AE71-C6B4-4201-83E7-AC5B3EF373DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantsGrouping) for reliable querying. */
export type C__VariantsGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Variants Grouping template (ID: {BBB9AE71-C6B4-4201-83E7-AC5B3EF373DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantsGrouping) for reliable querying. */
export type C__VariantsGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Variants Grouping template (ID: {BBB9AE71-C6B4-4201-83E7-AC5B3EF373DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantsGrouping) for reliable querying. */
export type C__VariantsGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Variants Grouping template (ID: {BBB9AE71-C6B4-4201-83E7-AC5B3EF373DC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. VariantsGrouping) for reliable querying. */
export type C__VariantsGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_AdvancedItem template (ID: {423773C2-795C-4E52-B996-9E6A465B7C1F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AdvancedItem) for reliable querying. */
export type C___AdvancedItem = Item & {
  __typename?: 'C___AdvancedItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_AdvancedItem template (ID: {423773C2-795C-4E52-B996-9E6A465B7C1F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AdvancedItem) for reliable querying. */
export type C___AdvancedItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_AdvancedItem template (ID: {423773C2-795C-4E52-B996-9E6A465B7C1F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AdvancedItem) for reliable querying. */
export type C___AdvancedItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_AdvancedItem template (ID: {423773C2-795C-4E52-B996-9E6A465B7C1F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AdvancedItem) for reliable querying. */
export type C___AdvancedItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_AdvancedItem template (ID: {423773C2-795C-4E52-B996-9E6A465B7C1F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AdvancedItem) for reliable querying. */
export type C___AdvancedItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_AdvancedItem template (ID: {423773C2-795C-4E52-B996-9E6A465B7C1F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AdvancedItem) for reliable querying. */
export type C___AdvancedItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_AdvancedItem template (ID: {423773C2-795C-4E52-B996-9E6A465B7C1F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AdvancedItem) for reliable querying. */
export type C___AdvancedItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments) for reliable querying. */
export type C___Arguments = Item & _Arguments & {
  __typename?: 'C___Arguments';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {E830AF53-210B-4981-B6A8-F8939F587EB1}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments) for reliable querying. */
export type C___ArgumentsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments) for reliable querying. */
export type C___ArgumentsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments) for reliable querying. */
export type C___ArgumentsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments) for reliable querying. */
export type C___ArgumentsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments) for reliable querying. */
export type C___ArgumentsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments) for reliable querying. */
export type C___ArgumentsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments_33fab87cd52f44319a1f589ba7c1e287) for reliable querying. */
export type C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = Item & _Arguments_33fab87cd52f44319a1f589ba7c1e287 & {
  __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {58ACA5CA-742A-41BB-866F-CFA3764200C8}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments_33fab87cd52f44319a1f589ba7c1e287) for reliable querying. */
export type C___Arguments_33fab87cd52f44319a1f589ba7c1e287AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments_33fab87cd52f44319a1f589ba7c1e287) for reliable querying. */
export type C___Arguments_33fab87cd52f44319a1f589ba7c1e287ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments_33fab87cd52f44319a1f589ba7c1e287) for reliable querying. */
export type C___Arguments_33fab87cd52f44319a1f589ba7c1e287FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments_33fab87cd52f44319a1f589ba7c1e287) for reliable querying. */
export type C___Arguments_33fab87cd52f44319a1f589ba7c1e287FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments_33fab87cd52f44319a1f589ba7c1e287) for reliable querying. */
export type C___Arguments_33fab87cd52f44319a1f589ba7c1e287HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Arguments_33fab87cd52f44319a1f589ba7c1e287) for reliable querying. */
export type C___Arguments_33fab87cd52f44319a1f589ba7c1e287IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Article) for reliable querying. */
export type C___Article = Item & _Article & _BaseArticle & _ContentType & _InternalArticle & _LimitedDisplay & _PremiumContentPage & _SharedPage & {
  __typename?: 'C___Article';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Populated automatically during publish */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Article) for reliable querying. */
export type C___ArticleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Article) for reliable querying. */
export type C___ArticleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Article) for reliable querying. */
export type C___ArticleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Article) for reliable querying. */
export type C___ArticleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Article) for reliable querying. */
export type C___ArticleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Article) for reliable querying. */
export type C___ArticleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_ArticlePageWorkflow template (ID: {29DB4C47-5F4B-4EB9-87F0-7BC08273C94E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticlePageWorkflow) for reliable querying. */
export type C___ArticlePageWorkflow = Item & {
  __typename?: 'C___ArticlePageWorkflow';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_ArticlePageWorkflow template (ID: {29DB4C47-5F4B-4EB9-87F0-7BC08273C94E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticlePageWorkflow) for reliable querying. */
export type C___ArticlePageWorkflowAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_ArticlePageWorkflow template (ID: {29DB4C47-5F4B-4EB9-87F0-7BC08273C94E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticlePageWorkflow) for reliable querying. */
export type C___ArticlePageWorkflowChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_ArticlePageWorkflow template (ID: {29DB4C47-5F4B-4EB9-87F0-7BC08273C94E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticlePageWorkflow) for reliable querying. */
export type C___ArticlePageWorkflowFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_ArticlePageWorkflow template (ID: {29DB4C47-5F4B-4EB9-87F0-7BC08273C94E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticlePageWorkflow) for reliable querying. */
export type C___ArticlePageWorkflowFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_ArticlePageWorkflow template (ID: {29DB4C47-5F4B-4EB9-87F0-7BC08273C94E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticlePageWorkflow) for reliable querying. */
export type C___ArticlePageWorkflowHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_ArticlePageWorkflow template (ID: {29DB4C47-5F4B-4EB9-87F0-7BC08273C94E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticlePageWorkflow) for reliable querying. */
export type C___ArticlePageWorkflowIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleSearchPage template (ID: {A3F1CEE0-C383-4831-8DB9-4FC219703EFB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleSearchPage) for reliable querying. */
export type C___ArticleSearchPage = Item & {
  __typename?: 'C___ArticleSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleSearchPage template (ID: {A3F1CEE0-C383-4831-8DB9-4FC219703EFB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleSearchPage) for reliable querying. */
export type C___ArticleSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleSearchPage template (ID: {A3F1CEE0-C383-4831-8DB9-4FC219703EFB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleSearchPage) for reliable querying. */
export type C___ArticleSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleSearchPage template (ID: {A3F1CEE0-C383-4831-8DB9-4FC219703EFB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleSearchPage) for reliable querying. */
export type C___ArticleSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleSearchPage template (ID: {A3F1CEE0-C383-4831-8DB9-4FC219703EFB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleSearchPage) for reliable querying. */
export type C___ArticleSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleSearchPage template (ID: {A3F1CEE0-C383-4831-8DB9-4FC219703EFB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleSearchPage) for reliable querying. */
export type C___ArticleSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleSearchPage template (ID: {A3F1CEE0-C383-4831-8DB9-4FC219703EFB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleSearchPage) for reliable querying. */
export type C___ArticleSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleWildcard template (ID: {F185DF1A-4DDE-4EAA-BBDB-5B2B9A703583}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleWildcard) for reliable querying. */
export type C___ArticleWildcard = Item & {
  __typename?: 'C___ArticleWildcard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleWildcard template (ID: {F185DF1A-4DDE-4EAA-BBDB-5B2B9A703583}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleWildcard) for reliable querying. */
export type C___ArticleWildcardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleWildcard template (ID: {F185DF1A-4DDE-4EAA-BBDB-5B2B9A703583}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleWildcard) for reliable querying. */
export type C___ArticleWildcardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleWildcard template (ID: {F185DF1A-4DDE-4EAA-BBDB-5B2B9A703583}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleWildcard) for reliable querying. */
export type C___ArticleWildcardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleWildcard template (ID: {F185DF1A-4DDE-4EAA-BBDB-5B2B9A703583}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleWildcard) for reliable querying. */
export type C___ArticleWildcardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleWildcard template (ID: {F185DF1A-4DDE-4EAA-BBDB-5B2B9A703583}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleWildcard) for reliable querying. */
export type C___ArticleWildcardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ArticleWildcard template (ID: {F185DF1A-4DDE-4EAA-BBDB-5B2B9A703583}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ArticleWildcard) for reliable querying. */
export type C___ArticleWildcardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AssetServiceThemeMode) for reliable querying. */
export type C___AssetServiceThemeMode = Item & _AssetServiceThemeMode & {
  __typename?: 'C___AssetServiceThemeMode';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Mode (ID: {4D0E825C-D503-42FF-A96F-1949F6259FD0}). */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AssetServiceThemeMode) for reliable querying. */
export type C___AssetServiceThemeModeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AssetServiceThemeMode) for reliable querying. */
export type C___AssetServiceThemeModeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AssetServiceThemeMode) for reliable querying. */
export type C___AssetServiceThemeModeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AssetServiceThemeMode) for reliable querying. */
export type C___AssetServiceThemeModeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AssetServiceThemeMode) for reliable querying. */
export type C___AssetServiceThemeModeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _AssetServiceThemeMode) for reliable querying. */
export type C___AssetServiceThemeModeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseArticle) for reliable querying. */
export type C___BaseArticle = Item & _BaseArticle & _ContentType & _LimitedDisplay & _SharedPage & {
  __typename?: 'C___BaseArticle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseArticle) for reliable querying. */
export type C___BaseArticleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseArticle) for reliable querying. */
export type C___BaseArticleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseArticle) for reliable querying. */
export type C___BaseArticleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseArticle) for reliable querying. */
export type C___BaseArticleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseArticle) for reliable querying. */
export type C___BaseArticleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseArticle) for reliable querying. */
export type C___BaseArticleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Data Folder template (ID: {66FB7845-4523-42DB-9B31-B79C64D72534}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseDataFolder) for reliable querying. */
export type C___BaseDataFolder = Item & {
  __typename?: 'C___BaseDataFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Data Folder template (ID: {66FB7845-4523-42DB-9B31-B79C64D72534}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseDataFolder) for reliable querying. */
export type C___BaseDataFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Data Folder template (ID: {66FB7845-4523-42DB-9B31-B79C64D72534}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseDataFolder) for reliable querying. */
export type C___BaseDataFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Data Folder template (ID: {66FB7845-4523-42DB-9B31-B79C64D72534}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseDataFolder) for reliable querying. */
export type C___BaseDataFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Data Folder template (ID: {66FB7845-4523-42DB-9B31-B79C64D72534}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseDataFolder) for reliable querying. */
export type C___BaseDataFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Data Folder template (ID: {66FB7845-4523-42DB-9B31-B79C64D72534}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseDataFolder) for reliable querying. */
export type C___BaseDataFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Data Folder template (ID: {66FB7845-4523-42DB-9B31-B79C64D72534}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseDataFolder) for reliable querying. */
export type C___BaseDataFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseHelpArticle) for reliable querying. */
export type C___BaseHelpArticle = Item & _BaseHelpArticle & _SharedPage & {
  __typename?: 'C___BaseHelpArticle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** helpPlatform (ID: {6D132CC4-961D-4DE6-94F4-C99A8DD8EE64}). */
  helpPlatform?: Maybe<MultilistField>;
  /** helpStrapline (ID: {20C18889-078D-4483-B837-E8CC2CEAD74E}). */
  helpStrapline?: Maybe<TextField>;
  /** helpTag (ID: {212899C9-5810-4BF4-8EEF-D957FBE30EB7}). */
  helpTag?: Maybe<LookupField>;
  /** helpTitle (ID: {8602E54D-E233-4F77-8083-C5023808D8DB}). */
  helpTitle?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseHelpArticle) for reliable querying. */
export type C___BaseHelpArticleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseHelpArticle) for reliable querying. */
export type C___BaseHelpArticleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseHelpArticle) for reliable querying. */
export type C___BaseHelpArticleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseHelpArticle) for reliable querying. */
export type C___BaseHelpArticleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseHelpArticle) for reliable querying. */
export type C___BaseHelpArticleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseHelpArticle) for reliable querying. */
export type C___BaseHelpArticleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseInvestmentTrust) for reliable querying. */
export type C___BaseInvestmentTrust = Item & _BaseInvestmentTrust & {
  __typename?: 'C___BaseInvestmentTrust';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** trustAssetClass (ID: {34893A4D-3273-4069-8012-71D96C4D46A7}). */
  trustAssetClass?: Maybe<LookupField>;
  /** trustDescription (ID: {23A43E10-8A30-4C8A-A3A8-691D2B2D0D03}). */
  trustDescription?: Maybe<TextField>;
  /** trustId (ID: {EDBD21FE-E562-481E-B05D-8A0765158488}). */
  trustId?: Maybe<TextField>;
  /** trustImage (ID: {1D4C60A3-C121-4758-A634-7466B8C4CFFA}). */
  trustImage?: Maybe<ImageField>;
  /** If checked, trust will not appear on Trust Finder page. */
  trustIsHidden?: Maybe<CheckboxField>;
  /** trustLink (ID: {7A8A011D-72D1-4431-83D8-4220FB5B3AC8}). */
  trustLink?: Maybe<LinkField>;
  /** trustName (ID: {FD13EAF9-DC56-412A-9F46-4A223FE05029}). */
  trustName?: Maybe<TextField>;
  /** trustRegion (ID: {A53FE6EB-699C-49B0-8FA8-59172AAC6E1B}). */
  trustRegion?: Maybe<LookupField>;
  /** trustStyle (ID: {B117229B-0780-4447-858D-94B815A50560}). */
  trustStyle?: Maybe<LookupField>;
  /** trustType (ID: {752F80B1-AA76-43CD-B6C3-D57B0AD59093}). */
  trustType?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseInvestmentTrust) for reliable querying. */
export type C___BaseInvestmentTrustAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseInvestmentTrust) for reliable querying. */
export type C___BaseInvestmentTrustChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseInvestmentTrust) for reliable querying. */
export type C___BaseInvestmentTrustFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseInvestmentTrust) for reliable querying. */
export type C___BaseInvestmentTrustFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseInvestmentTrust) for reliable querying. */
export type C___BaseInvestmentTrustHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseInvestmentTrust) for reliable querying. */
export type C___BaseInvestmentTrustIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseJSSTenant) for reliable querying. */
export type C___BaseJssTenant = Item & _BaseJssTenant & {
  __typename?: 'C___BaseJSSTenant';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseJSSTenant) for reliable querying. */
export type C___BaseJssTenantAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseJSSTenant) for reliable querying. */
export type C___BaseJssTenantChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseJSSTenant) for reliable querying. */
export type C___BaseJssTenantFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseJSSTenant) for reliable querying. */
export type C___BaseJssTenantFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseJSSTenant) for reliable querying. */
export type C___BaseJssTenantHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseJSSTenant) for reliable querying. */
export type C___BaseJssTenantIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePage) for reliable querying. */
export type C___BasePage = Item & _BasePage & _MetadataPage & _NavigablePage & {
  __typename?: 'C___BasePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePage) for reliable querying. */
export type C___BasePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePage) for reliable querying. */
export type C___BasePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePage) for reliable querying. */
export type C___BasePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePage) for reliable querying. */
export type C___BasePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePage) for reliable querying. */
export type C___BasePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePage) for reliable querying. */
export type C___BasePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesign) for reliable querying. */
export type C___BasePageDesign = Item & _BasePageDesign & {
  __typename?: 'C___BasePageDesign';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** PartialDesigns (ID: {0966B999-0D0E-4278-ACC9-9DA69D461FE6}). */
  partialDesigns?: Maybe<MultilistField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesign) for reliable querying. */
export type C___BasePageDesignAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesign) for reliable querying. */
export type C___BasePageDesignChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesign) for reliable querying. */
export type C___BasePageDesignFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesign) for reliable querying. */
export type C___BasePageDesignFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesign) for reliable querying. */
export type C___BasePageDesignHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesign) for reliable querying. */
export type C___BasePageDesignIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design Folder template (ID: {A15DECDE-0E49-46E6-9D19-FC41C292A0E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesignFolder) for reliable querying. */
export type C___BasePageDesignFolder = Item & {
  __typename?: 'C___BasePageDesignFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design Folder template (ID: {A15DECDE-0E49-46E6-9D19-FC41C292A0E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesignFolder) for reliable querying. */
export type C___BasePageDesignFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design Folder template (ID: {A15DECDE-0E49-46E6-9D19-FC41C292A0E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesignFolder) for reliable querying. */
export type C___BasePageDesignFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design Folder template (ID: {A15DECDE-0E49-46E6-9D19-FC41C292A0E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesignFolder) for reliable querying. */
export type C___BasePageDesignFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design Folder template (ID: {A15DECDE-0E49-46E6-9D19-FC41C292A0E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesignFolder) for reliable querying. */
export type C___BasePageDesignFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design Folder template (ID: {A15DECDE-0E49-46E6-9D19-FC41C292A0E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesignFolder) for reliable querying. */
export type C___BasePageDesignFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design Folder template (ID: {A15DECDE-0E49-46E6-9D19-FC41C292A0E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePageDesignFolder) for reliable querying. */
export type C___BasePageDesignFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesign) for reliable querying. */
export type C___BasePartialDesign = Item & _BasePartialDesign & {
  __typename?: 'C___BasePartialDesign';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Base Partial Design (ID: {76A92454-C8BE-479B-B260-26AEBCED5A1A}). */
  basePartialDesign?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Signature (ID: {55FAAE90-3BBA-4F7F-96FE-13C3F40055FF}). */
  signature?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesign) for reliable querying. */
export type C___BasePartialDesignAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesign) for reliable querying. */
export type C___BasePartialDesignChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesign) for reliable querying. */
export type C___BasePartialDesignFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesign) for reliable querying. */
export type C___BasePartialDesignFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesign) for reliable querying. */
export type C___BasePartialDesignHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesign) for reliable querying. */
export type C___BasePartialDesignIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design Folder template (ID: {B4544407-E6E1-4050-9983-83D48C2DD8F8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesignFolder) for reliable querying. */
export type C___BasePartialDesignFolder = Item & {
  __typename?: 'C___BasePartialDesignFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design Folder template (ID: {B4544407-E6E1-4050-9983-83D48C2DD8F8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesignFolder) for reliable querying. */
export type C___BasePartialDesignFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design Folder template (ID: {B4544407-E6E1-4050-9983-83D48C2DD8F8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesignFolder) for reliable querying. */
export type C___BasePartialDesignFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design Folder template (ID: {B4544407-E6E1-4050-9983-83D48C2DD8F8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesignFolder) for reliable querying. */
export type C___BasePartialDesignFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design Folder template (ID: {B4544407-E6E1-4050-9983-83D48C2DD8F8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesignFolder) for reliable querying. */
export type C___BasePartialDesignFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design Folder template (ID: {B4544407-E6E1-4050-9983-83D48C2DD8F8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesignFolder) for reliable querying. */
export type C___BasePartialDesignFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design Folder template (ID: {B4544407-E6E1-4050-9983-83D48C2DD8F8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePartialDesignFolder) for reliable querying. */
export type C___BasePartialDesignFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder template (ID: {FF987A76-12D0-4B6B-8137-8F079C83C5B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholder) for reliable querying. */
export type C___BasePlaceholder = Item & Placeholder & {
  __typename?: 'C___BasePlaceholder';
  /** Allowed Controls (ID: {E391B526-D0C5-439D-803E-17512EAE6222}). */
  allowedControls?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {87871FF5-1965-46D6-884F-01D6A0B9C4C1}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Editable (ID: {14D0728A-82F9-4B01-AB16-1FE1577CEDE2}). */
  editable?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** If left empty, the settings should be applied to individual placeholders. */
  placeholderKey?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder template (ID: {FF987A76-12D0-4B6B-8137-8F079C83C5B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholder) for reliable querying. */
export type C___BasePlaceholderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder template (ID: {FF987A76-12D0-4B6B-8137-8F079C83C5B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholder) for reliable querying. */
export type C___BasePlaceholderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder template (ID: {FF987A76-12D0-4B6B-8137-8F079C83C5B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholder) for reliable querying. */
export type C___BasePlaceholderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder template (ID: {FF987A76-12D0-4B6B-8137-8F079C83C5B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholder) for reliable querying. */
export type C___BasePlaceholderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder template (ID: {FF987A76-12D0-4B6B-8137-8F079C83C5B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholder) for reliable querying. */
export type C___BasePlaceholderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder template (ID: {FF987A76-12D0-4B6B-8137-8F079C83C5B8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholder) for reliable querying. */
export type C___BasePlaceholderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholderSettingsFolder) for reliable querying. */
export type C___BasePlaceholderSettingsFolder = Item & _BasePlaceholderSettingsFolder & {
  __typename?: 'C___BasePlaceholderSettingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateForCreation (ID: {30D2A0D2-7A60-4F32-86A9-4AA50BFAB87B}). */
  templateForCreation?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholderSettingsFolder) for reliable querying. */
export type C___BasePlaceholderSettingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholderSettingsFolder) for reliable querying. */
export type C___BasePlaceholderSettingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholderSettingsFolder) for reliable querying. */
export type C___BasePlaceholderSettingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholderSettingsFolder) for reliable querying. */
export type C___BasePlaceholderSettingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholderSettingsFolder) for reliable querying. */
export type C___BasePlaceholderSettingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePlaceholderSettingsFolder) for reliable querying. */
export type C___BasePlaceholderSettingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Presentation template (ID: {5876C1DB-398D-419B-9EFF-4C3A1B67D376}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePresentation) for reliable querying. */
export type C___BasePresentation = Item & {
  __typename?: 'C___BasePresentation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Presentation template (ID: {5876C1DB-398D-419B-9EFF-4C3A1B67D376}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePresentation) for reliable querying. */
export type C___BasePresentationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Presentation template (ID: {5876C1DB-398D-419B-9EFF-4C3A1B67D376}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePresentation) for reliable querying. */
export type C___BasePresentationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Presentation template (ID: {5876C1DB-398D-419B-9EFF-4C3A1B67D376}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePresentation) for reliable querying. */
export type C___BasePresentationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Presentation template (ID: {5876C1DB-398D-419B-9EFF-4C3A1B67D376}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePresentation) for reliable querying. */
export type C___BasePresentationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Presentation template (ID: {5876C1DB-398D-419B-9EFF-4C3A1B67D376}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePresentation) for reliable querying. */
export type C___BasePresentationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Presentation template (ID: {5876C1DB-398D-419B-9EFF-4C3A1B67D376}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePresentation) for reliable querying. */
export type C___BasePresentationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePressRelease) for reliable querying. */
export type C___BasePressRelease = Item & _BasePressRelease & _PressReleaseContentType & _SharedPage & {
  __typename?: 'C___BasePressRelease';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePressRelease) for reliable querying. */
export type C___BasePressReleaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePressRelease) for reliable querying. */
export type C___BasePressReleaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePressRelease) for reliable querying. */
export type C___BasePressReleaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePressRelease) for reliable querying. */
export type C___BasePressReleaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePressRelease) for reliable querying. */
export type C___BasePressReleaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BasePressRelease) for reliable querying. */
export type C___BasePressReleaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseRenderingParameters) for reliable querying. */
export type C___BaseRenderingParameters = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'C___BaseRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseRenderingParameters) for reliable querying. */
export type C___BaseRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseRenderingParameters) for reliable querying. */
export type C___BaseRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseRenderingParameters) for reliable querying. */
export type C___BaseRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseRenderingParameters) for reliable querying. */
export type C___BaseRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseRenderingParameters) for reliable querying. */
export type C___BaseRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseRenderingParameters) for reliable querying. */
export type C___BaseRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/Base/_Base SXA Standard Values Folder template (ID: {F2141646-B989-4F4D-936D-F25ACAA28C8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSXAStandardValuesFolder) for reliable querying. */
export type C___BaseSxaStandardValuesFolder = Item & {
  __typename?: 'C___BaseSXAStandardValuesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/Base/_Base SXA Standard Values Folder template (ID: {F2141646-B989-4F4D-936D-F25ACAA28C8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSXAStandardValuesFolder) for reliable querying. */
export type C___BaseSxaStandardValuesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/Base/_Base SXA Standard Values Folder template (ID: {F2141646-B989-4F4D-936D-F25ACAA28C8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSXAStandardValuesFolder) for reliable querying. */
export type C___BaseSxaStandardValuesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/Base/_Base SXA Standard Values Folder template (ID: {F2141646-B989-4F4D-936D-F25ACAA28C8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSXAStandardValuesFolder) for reliable querying. */
export type C___BaseSxaStandardValuesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/Base/_Base SXA Standard Values Folder template (ID: {F2141646-B989-4F4D-936D-F25ACAA28C8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSXAStandardValuesFolder) for reliable querying. */
export type C___BaseSxaStandardValuesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/Base/_Base SXA Standard Values Folder template (ID: {F2141646-B989-4F4D-936D-F25ACAA28C8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSXAStandardValuesFolder) for reliable querying. */
export type C___BaseSxaStandardValuesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/Base/_Base SXA Standard Values Folder template (ID: {F2141646-B989-4F4D-936D-F25ACAA28C8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSXAStandardValuesFolder) for reliable querying. */
export type C___BaseSxaStandardValuesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSettings) for reliable querying. */
export type C___BaseSettings = Item & _BaseSettings & {
  __typename?: 'C___BaseSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSettings) for reliable querying. */
export type C___BaseSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSettings) for reliable querying. */
export type C___BaseSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSettings) for reliable querying. */
export type C___BaseSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSettings) for reliable querying. */
export type C___BaseSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSettings) for reliable querying. */
export type C___BaseSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSettings) for reliable querying. */
export type C___BaseSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSharedSitesSettings) for reliable querying. */
export type C___BaseSharedSitesSettings = Item & _BaseSharedSitesSettings & {
  __typename?: 'C___BaseSharedSitesSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Delegated Areas (ID: {D5E1CC0E-0D69-4A31-8321-13994D5ACCF6}). */
  delegatedAreas?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSharedSitesSettings) for reliable querying. */
export type C___BaseSharedSitesSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSharedSitesSettings) for reliable querying. */
export type C___BaseSharedSitesSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSharedSitesSettings) for reliable querying. */
export type C___BaseSharedSitesSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSharedSitesSettings) for reliable querying. */
export type C___BaseSharedSitesSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSharedSitesSettings) for reliable querying. */
export type C___BaseSharedSitesSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSharedSitesSettings) for reliable querying. */
export type C___BaseSharedSitesSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteDefinition) for reliable querying. */
export type C___BaseSiteDefinition = Item & _BaseSiteDefinition & {
  __typename?: 'C___BaseSiteDefinition';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Database (ID: {A7803A5D-CD03-4EDA-ABED-1D9AF4BF6660}). */
  database_a7803a5dcd034edaabed1d9af4bf6660?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Environment (ID: {DA06D09E-02B6-464A-80FC-9D8D7FC875E3}). */
  environment?: Maybe<TextField>;
  /** ErrorPageUrl (ID: {76DE376A-A332-46F8-8CAF-A59E557DFEFD}). */
  errorPageUrl?: Maybe<TextField>;
  /** ExternalPort (ID: {FA273891-D5D0-41DF-A713-ADEA620D7732}). */
  externalPort?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldLanguageFallback (ID: {6E6DA5B0-8D01-4514-B7DD-1940AFF3E8CD}). */
  fieldLanguageFallback?: Maybe<CheckboxField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilteredItemsCacheSize (ID: {42DDBE59-96DF-4C83-BB22-0F739A603B3D}). */
  filteredItemsCacheSize?: Maybe<IntegerField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** HostName (ID: {8E0DD914-9AFB-4D45-BF8B-7FF5D6E5337E}). */
  hostName?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ItemLanguageFallback (ID: {8C436235-B85D-4097-89CF-D5A4FA70CC0A}). */
  itemLanguageFallback?: Maybe<CheckboxField>;
  /** ItemNotFoundUrl (ID: {7B32B669-0B70-4FFA-A264-247B97DE8571}). */
  itemNotFoundUrl?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Language Embedding (ID: {4E9E2AE5-36DB-4955-9AF1-5A1934A27C7D}). */
  languageEmbedding?: Maybe<CheckboxField>;
  /** Language (ID: {F19277FE-1B85-4B0A-8C26-5E74D766B3A3}). */
  language_f19277fe1b854b0a8c265e74d766b3a3?: Maybe<TextField>;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LinkProvider (ID: {822CC751-5C96-4A43-B687-FF4786A6EBA2}). */
  linkProvider?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OtherProperties (ID: {301E719A-6F65-4874-B565-A953A7B5AC83}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Port (ID: {1BF930DC-11E1-4103-9001-59562B698C96}). */
  port?: Maybe<IntegerField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Scheme (ID: {B59E43AB-84DA-49F3-87A1-D2FCF648365B}). */
  scheme?: Maybe<TextField>;
  /** SiteName (ID: {CB4E9E2E-2B66-43DC-AD3F-9CAF363D28D3}). */
  siteName?: Maybe<TextField>;
  /** StartItem (ID: {1EE576AF-BA8E-4312-9FBD-2CCF8395BAA1}). */
  startItem?: Maybe<LookupField>;
  /** SxaLinkable (ID: {4EEFF055-EDCD-4387-9E86-C3F40A15DBAC}). */
  sxaLinkable?: Maybe<CheckboxField>;
  /** TargetHostName (ID: {E5B5CCB5-17A1-429D-BD3E-6122B3216E52}). */
  targetHostName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** VirtualFolder (ID: {475031D8-724D-463C-80B2-90839DD1AD98}). */
  virtualFolder?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteDefinition) for reliable querying. */
export type C___BaseSiteDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteDefinition) for reliable querying. */
export type C___BaseSiteDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteDefinition) for reliable querying. */
export type C___BaseSiteDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteDefinition) for reliable querying. */
export type C___BaseSiteDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteDefinition) for reliable querying. */
export type C___BaseSiteDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteDefinition) for reliable querying. */
export type C___BaseSiteDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Folder template (ID: {BF76DCD7-2E6B-4E10-B293-C0C1E010196E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteFolder) for reliable querying. */
export type C___BaseSiteFolder = Item & {
  __typename?: 'C___BaseSiteFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Folder template (ID: {BF76DCD7-2E6B-4E10-B293-C0C1E010196E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteFolder) for reliable querying. */
export type C___BaseSiteFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Folder template (ID: {BF76DCD7-2E6B-4E10-B293-C0C1E010196E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteFolder) for reliable querying. */
export type C___BaseSiteFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Folder template (ID: {BF76DCD7-2E6B-4E10-B293-C0C1E010196E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteFolder) for reliable querying. */
export type C___BaseSiteFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Folder template (ID: {BF76DCD7-2E6B-4E10-B293-C0C1E010196E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteFolder) for reliable querying. */
export type C___BaseSiteFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Folder template (ID: {BF76DCD7-2E6B-4E10-B293-C0C1E010196E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteFolder) for reliable querying. */
export type C___BaseSiteFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Folder template (ID: {BF76DCD7-2E6B-4E10-B293-C0C1E010196E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteFolder) for reliable querying. */
export type C___BaseSiteFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Grouping template (ID: {9534A0CC-1055-4A4B-B624-05F2BE277211}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteGrouping) for reliable querying. */
export type C___BaseSiteGrouping = Item & {
  __typename?: 'C___BaseSiteGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Grouping template (ID: {9534A0CC-1055-4A4B-B624-05F2BE277211}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteGrouping) for reliable querying. */
export type C___BaseSiteGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Grouping template (ID: {9534A0CC-1055-4A4B-B624-05F2BE277211}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteGrouping) for reliable querying. */
export type C___BaseSiteGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Grouping template (ID: {9534A0CC-1055-4A4B-B624-05F2BE277211}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteGrouping) for reliable querying. */
export type C___BaseSiteGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Grouping template (ID: {9534A0CC-1055-4A4B-B624-05F2BE277211}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteGrouping) for reliable querying. */
export type C___BaseSiteGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Grouping template (ID: {9534A0CC-1055-4A4B-B624-05F2BE277211}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteGrouping) for reliable querying. */
export type C___BaseSiteGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Grouping template (ID: {9534A0CC-1055-4A4B-B624-05F2BE277211}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteGrouping) for reliable querying. */
export type C___BaseSiteGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Root template (ID: {A2B9FDC3-F641-4966-94A5-B63944DC39DE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteRoot) for reliable querying. */
export type C___BaseSiteRoot = Item & {
  __typename?: 'C___BaseSiteRoot';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Root template (ID: {A2B9FDC3-F641-4966-94A5-B63944DC39DE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteRoot) for reliable querying. */
export type C___BaseSiteRootAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Root template (ID: {A2B9FDC3-F641-4966-94A5-B63944DC39DE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteRoot) for reliable querying. */
export type C___BaseSiteRootChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Root template (ID: {A2B9FDC3-F641-4966-94A5-B63944DC39DE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteRoot) for reliable querying. */
export type C___BaseSiteRootFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Root template (ID: {A2B9FDC3-F641-4966-94A5-B63944DC39DE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteRoot) for reliable querying. */
export type C___BaseSiteRootFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Root template (ID: {A2B9FDC3-F641-4966-94A5-B63944DC39DE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteRoot) for reliable querying. */
export type C___BaseSiteRootHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Root template (ID: {A2B9FDC3-F641-4966-94A5-B63944DC39DE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseSiteRoot) for reliable querying. */
export type C___BaseSiteRootIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenant) for reliable querying. */
export type C___BaseTenant = Item & _BaseTenant & {
  __typename?: 'C___BaseTenant';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenant) for reliable querying. */
export type C___BaseTenantAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenant) for reliable querying. */
export type C___BaseTenantChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenant) for reliable querying. */
export type C___BaseTenantFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenant) for reliable querying. */
export type C___BaseTenantFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenant) for reliable querying. */
export type C___BaseTenantHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenant) for reliable querying. */
export type C___BaseTenantIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant Folder template (ID: {72F8D6F8-6148-413F-8861-436362393E53}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenantFolder) for reliable querying. */
export type C___BaseTenantFolder = Item & {
  __typename?: 'C___BaseTenantFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant Folder template (ID: {72F8D6F8-6148-413F-8861-436362393E53}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenantFolder) for reliable querying. */
export type C___BaseTenantFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant Folder template (ID: {72F8D6F8-6148-413F-8861-436362393E53}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenantFolder) for reliable querying. */
export type C___BaseTenantFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant Folder template (ID: {72F8D6F8-6148-413F-8861-436362393E53}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenantFolder) for reliable querying. */
export type C___BaseTenantFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant Folder template (ID: {72F8D6F8-6148-413F-8861-436362393E53}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenantFolder) for reliable querying. */
export type C___BaseTenantFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant Folder template (ID: {72F8D6F8-6148-413F-8861-436362393E53}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenantFolder) for reliable querying. */
export type C___BaseTenantFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant Folder template (ID: {72F8D6F8-6148-413F-8861-436362393E53}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BaseTenantFolder) for reliable querying. */
export type C___BaseTenantFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_BucketRules template (ID: {422A8469-5A1B-4ADD-8CCA-F6B79DB6DE6E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BucketRules) for reliable querying. */
export type C___BucketRules = Item & ItemBucketsSettings & {
  __typename?: 'C___BucketRules';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_BucketRules template (ID: {422A8469-5A1B-4ADD-8CCA-F6B79DB6DE6E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BucketRules) for reliable querying. */
export type C___BucketRulesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_BucketRules template (ID: {422A8469-5A1B-4ADD-8CCA-F6B79DB6DE6E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BucketRules) for reliable querying. */
export type C___BucketRulesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_BucketRules template (ID: {422A8469-5A1B-4ADD-8CCA-F6B79DB6DE6E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BucketRules) for reliable querying. */
export type C___BucketRulesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_BucketRules template (ID: {422A8469-5A1B-4ADD-8CCA-F6B79DB6DE6E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BucketRules) for reliable querying. */
export type C___BucketRulesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_BucketRules template (ID: {422A8469-5A1B-4ADD-8CCA-F6B79DB6DE6E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BucketRules) for reliable querying. */
export type C___BucketRulesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_BucketRules template (ID: {422A8469-5A1B-4ADD-8CCA-F6B79DB6DE6E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _BucketRules) for reliable querying. */
export type C___BucketRulesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _CORS) for reliable querying. */
export type C___Cors = Item & _Cors & {
  __typename?: 'C___CORS';
  /** The Access-Control-Allow-Credentials header indicates whether or not the response to the request can be exposed when the credentials flag is set to true.  When used as part of a response to a preflight request, this indicates whether or not the actual request can be made using credentials. Simple GET requests are not preflighted, and so if a request is made for a resource with credentials, if this header is not returned with the resource, the response is ignored by the browser and not returned to web content. */
  allowCredentials?: Maybe<CheckboxField>;
  /** The Access-Control-Allow-Headers header is used in response to a preflight request to indicate which HTTP headers can be used when making the actual request. */
  allowHeaders?: Maybe<TextField>;
  /** The Access-Control-Allow-Methods header specifies the method or methods allowed when accessing the resource. This is used in response to a preflight request. */
  allowMethods?: Maybe<TextField>;
  /** The origin parameter specifies a URI that may access the resource. The browser must enforce this. For requests without credentials, the server may specify "*" as a wildcard, thereby allowing any origin to access the resource. */
  allowOrigin?: Maybe<TextField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The Access-Control-Expose-Headers header lets a server whitelist headers that browsers are allowed to access. */
  exposeHeaders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The  Access-Control-Max-Age header indicates how long the results of a preflight request can be cached. */
  maxAge?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _CORS) for reliable querying. */
export type C___CorsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _CORS) for reliable querying. */
export type C___CorsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _CORS) for reliable querying. */
export type C___CorsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _CORS) for reliable querying. */
export type C___CorsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _CORS) for reliable querying. */
export type C___CorsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _CORS) for reliable querying. */
export type C___CorsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Content) for reliable querying. */
export type C___Content = Item & _Content & {
  __typename?: 'C___Content';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {7152697D-E946-4EC4-AAD5-223FCC204CE7}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Content) for reliable querying. */
export type C___ContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Content) for reliable querying. */
export type C___ContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Content) for reliable querying. */
export type C___ContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Content) for reliable querying. */
export type C___ContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Content) for reliable querying. */
export type C___ContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Content) for reliable querying. */
export type C___ContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ContentType) for reliable querying. */
export type C___ContentType = Item & _ContentType & {
  __typename?: 'C___ContentType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ContentType) for reliable querying. */
export type C___ContentTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ContentType) for reliable querying. */
export type C___ContentTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ContentType) for reliable querying. */
export type C___ContentTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ContentType) for reliable querying. */
export type C___ContentTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ContentType) for reliable querying. */
export type C___ContentTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ContentType) for reliable querying. */
export type C___ContentTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DataAttributes) for reliable querying. */
export type C___DataAttributes = Item & _DataAttributes & {
  __typename?: 'C___DataAttributes';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DataAttributes) for reliable querying. */
export type C___DataAttributesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DataAttributes) for reliable querying. */
export type C___DataAttributesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DataAttributes) for reliable querying. */
export type C___DataAttributesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DataAttributes) for reliable querying. */
export type C___DataAttributesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DataAttributes) for reliable querying. */
export type C___DataAttributesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DataAttributes) for reliable querying. */
export type C___DataAttributesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_DatasourceWorkflow template (ID: {DB7F4CE0-6738-4CAC-B85F-68D6B5BFEF6F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DatasourceWorkflow) for reliable querying. */
export type C___DatasourceWorkflow = Item & {
  __typename?: 'C___DatasourceWorkflow';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_DatasourceWorkflow template (ID: {DB7F4CE0-6738-4CAC-B85F-68D6B5BFEF6F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DatasourceWorkflow) for reliable querying. */
export type C___DatasourceWorkflowAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_DatasourceWorkflow template (ID: {DB7F4CE0-6738-4CAC-B85F-68D6B5BFEF6F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DatasourceWorkflow) for reliable querying. */
export type C___DatasourceWorkflowChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_DatasourceWorkflow template (ID: {DB7F4CE0-6738-4CAC-B85F-68D6B5BFEF6F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DatasourceWorkflow) for reliable querying. */
export type C___DatasourceWorkflowFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_DatasourceWorkflow template (ID: {DB7F4CE0-6738-4CAC-B85F-68D6B5BFEF6F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DatasourceWorkflow) for reliable querying. */
export type C___DatasourceWorkflowFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_DatasourceWorkflow template (ID: {DB7F4CE0-6738-4CAC-B85F-68D6B5BFEF6F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DatasourceWorkflow) for reliable querying. */
export type C___DatasourceWorkflowHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_DatasourceWorkflow template (ID: {DB7F4CE0-6738-4CAC-B85F-68D6B5BFEF6F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DatasourceWorkflow) for reliable querying. */
export type C___DatasourceWorkflowIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Dependencies) for reliable querying. */
export type C___Dependencies = Item & _Dependencies & {
  __typename?: 'C___Dependencies';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Dependencies (ID: {40DEEE2F-7595-40BD-B2C9-51F9E2346100}). */
  dependencies?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Dependencies) for reliable querying. */
export type C___DependenciesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Dependencies) for reliable querying. */
export type C___DependenciesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Dependencies) for reliable querying. */
export type C___DependenciesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Dependencies) for reliable querying. */
export type C___DependenciesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Dependencies) for reliable querying. */
export type C___DependenciesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Dependencies) for reliable querying. */
export type C___DependenciesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Description) for reliable querying. */
export type C___Description = Item & _Description & {
  __typename?: 'C___Description';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Description) for reliable querying. */
export type C___DescriptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Description) for reliable querying. */
export type C___DescriptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Description) for reliable querying. */
export type C___DescriptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Description) for reliable querying. */
export type C___DescriptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Description) for reliable querying. */
export type C___DescriptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Description) for reliable querying. */
export type C___DescriptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DesignTemplateMapping) for reliable querying. */
export type C___DesignTemplateMapping = Item & _DesignTemplateMapping & {
  __typename?: 'C___DesignTemplateMapping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DesignTemplateMapping) for reliable querying. */
export type C___DesignTemplateMappingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DesignTemplateMapping) for reliable querying. */
export type C___DesignTemplateMappingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DesignTemplateMapping) for reliable querying. */
export type C___DesignTemplateMappingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DesignTemplateMapping) for reliable querying. */
export type C___DesignTemplateMappingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DesignTemplateMapping) for reliable querying. */
export type C___DesignTemplateMappingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _DesignTemplateMapping) for reliable querying. */
export type C___DesignTemplateMappingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Designable) for reliable querying. */
export type C___Designable = Item & _Designable & {
  __typename?: 'C___Designable';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Designable) for reliable querying. */
export type C___DesignableAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Designable) for reliable querying. */
export type C___DesignableChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Designable) for reliable querying. */
export type C___DesignableFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Designable) for reliable querying. */
export type C___DesignableFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Designable) for reliable querying. */
export type C___DesignableHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Designable) for reliable querying. */
export type C___DesignableIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType) for reliable querying. */
export type C___EditType = Item & _EditType & {
  __typename?: 'C___EditType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditType (ID: {614F52CF-D54B-47D1-A242-D9A7D42860F4}). */
  editType?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType) for reliable querying. */
export type C___EditTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType) for reliable querying. */
export type C___EditTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType) for reliable querying. */
export type C___EditTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType) for reliable querying. */
export type C___EditTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType) for reliable querying. */
export type C___EditTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType) for reliable querying. */
export type C___EditTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType_8a9f84baaa124c5d9096935714809da4) for reliable querying. */
export type C___EditType_8a9f84baaa124c5d9096935714809da4 = Item & _EditType_8a9f84baaa124c5d9096935714809da4 & {
  __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditType (ID: {76691B61-8692-4D98-A4FF-115BA4208AB6}). */
  editType?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType_8a9f84baaa124c5d9096935714809da4) for reliable querying. */
export type C___EditType_8a9f84baaa124c5d9096935714809da4AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType_8a9f84baaa124c5d9096935714809da4) for reliable querying. */
export type C___EditType_8a9f84baaa124c5d9096935714809da4ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType_8a9f84baaa124c5d9096935714809da4) for reliable querying. */
export type C___EditType_8a9f84baaa124c5d9096935714809da4FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType_8a9f84baaa124c5d9096935714809da4) for reliable querying. */
export type C___EditType_8a9f84baaa124c5d9096935714809da4FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType_8a9f84baaa124c5d9096935714809da4) for reliable querying. */
export type C___EditType_8a9f84baaa124c5d9096935714809da4HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditType_8a9f84baaa124c5d9096935714809da4) for reliable querying. */
export type C___EditType_8a9f84baaa124c5d9096935714809da4IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditingTheme) for reliable querying. */
export type C___EditingTheme = Item & _EditingTheme & {
  __typename?: 'C___EditingTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditingTheme) for reliable querying. */
export type C___EditingThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditingTheme) for reliable querying. */
export type C___EditingThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditingTheme) for reliable querying. */
export type C___EditingThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditingTheme) for reliable querying. */
export type C___EditingThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditingTheme) for reliable querying. */
export type C___EditingThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _EditingTheme) for reliable querying. */
export type C___EditingThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Enabled) for reliable querying. */
export type C___Enabled = Item & _Enabled & {
  __typename?: 'C___Enabled';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled (ID: {4B475746-CF34-4C06-97C8-7A8B0B40064F}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Enabled) for reliable querying. */
export type C___EnabledAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Enabled) for reliable querying. */
export type C___EnabledChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Enabled) for reliable querying. */
export type C___EnabledFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Enabled) for reliable querying. */
export type C___EnabledFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Enabled) for reliable querying. */
export type C___EnabledHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Enabled) for reliable querying. */
export type C___EnabledIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ErrorHandling) for reliable querying. */
export type C___ErrorHandling = Item & _ErrorHandling & {
  __typename?: 'C___ErrorHandling';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ErrorHandling) for reliable querying. */
export type C___ErrorHandlingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ErrorHandling) for reliable querying. */
export type C___ErrorHandlingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ErrorHandling) for reliable querying. */
export type C___ErrorHandlingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ErrorHandling) for reliable querying. */
export type C___ErrorHandlingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ErrorHandling) for reliable querying. */
export type C___ErrorHandlingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ErrorHandling) for reliable querying. */
export type C___ErrorHandlingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ExternalArticle) for reliable querying. */
export type C___ExternalArticle = Item & _BaseArticle & _ContentType & _ExternalArticle & _LimitedDisplay & _SharedPage & {
  __typename?: 'C___ExternalArticle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** articleUrl (ID: {03D20238-CFFC-4238-AB29-21DB4996DABF}). */
  articleUrl?: Maybe<LinkField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ExternalArticle) for reliable querying. */
export type C___ExternalArticleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ExternalArticle) for reliable querying. */
export type C___ExternalArticleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ExternalArticle) for reliable querying. */
export type C___ExternalArticleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ExternalArticle) for reliable querying. */
export type C___ExternalArticleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ExternalArticle) for reliable querying. */
export type C___ExternalArticleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ExternalArticle) for reliable querying. */
export type C___ExternalArticleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Fields) for reliable querying. */
export type C___Fields = Item & _Fields & {
  __typename?: 'C___Fields';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fields (ID: {AD0E8DE7-F6C1-49FA-B2C4-87E10FBDAA52}). */
  fields_ad0e8de7f6c149fab2c487e10fbdaa52?: Maybe<NameValueListField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Fields) for reliable querying. */
export type C___FieldsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Fields) for reliable querying. */
export type C___FieldsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Fields) for reliable querying. */
export type C___FieldsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Fields) for reliable querying. */
export type C___FieldsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Fields) for reliable querying. */
export type C___FieldsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Fields) for reliable querying. */
export type C___FieldsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesParent template (ID: {81C3AD9E-5D1C-4EC0-A9E7-2ECDD4D95819}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesParent) for reliable querying. */
export type C___FilteredArticlesParent = Item & {
  __typename?: 'C___FilteredArticlesParent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesParent template (ID: {81C3AD9E-5D1C-4EC0-A9E7-2ECDD4D95819}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesParent) for reliable querying. */
export type C___FilteredArticlesParentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesParent template (ID: {81C3AD9E-5D1C-4EC0-A9E7-2ECDD4D95819}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesParent) for reliable querying. */
export type C___FilteredArticlesParentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesParent template (ID: {81C3AD9E-5D1C-4EC0-A9E7-2ECDD4D95819}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesParent) for reliable querying. */
export type C___FilteredArticlesParentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesParent template (ID: {81C3AD9E-5D1C-4EC0-A9E7-2ECDD4D95819}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesParent) for reliable querying. */
export type C___FilteredArticlesParentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesParent template (ID: {81C3AD9E-5D1C-4EC0-A9E7-2ECDD4D95819}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesParent) for reliable querying. */
export type C___FilteredArticlesParentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesParent template (ID: {81C3AD9E-5D1C-4EC0-A9E7-2ECDD4D95819}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesParent) for reliable querying. */
export type C___FilteredArticlesParentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesWildcard) for reliable querying. */
export type C___FilteredArticlesWildcard = Item & _FilteredArticlesWildcard & {
  __typename?: 'C___FilteredArticlesWildcard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesWildcard) for reliable querying. */
export type C___FilteredArticlesWildcardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesWildcard) for reliable querying. */
export type C___FilteredArticlesWildcardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesWildcard) for reliable querying. */
export type C___FilteredArticlesWildcardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesWildcard) for reliable querying. */
export type C___FilteredArticlesWildcardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesWildcard) for reliable querying. */
export type C___FilteredArticlesWildcardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FilteredArticlesWildcard) for reliable querying. */
export type C___FilteredArticlesWildcardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Footnotes) for reliable querying. */
export type C___Footnotes = Item & _Footnotes & {
  __typename?: 'C___Footnotes';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** databridgeHoldingsFootnote (ID: {D9BD8C0C-7C9B-4CEF-B6CA-6F9DF0939FC2}). */
  databridgeHoldingsFootnote?: Maybe<RichTextField>;
  /** databridgeKeyInformationFootnote (ID: {8ADED624-9A31-4227-909D-B59EB556FA64}). */
  databridgeKeyInformationFootnote?: Maybe<RichTextField>;
  /** databridgePerformanceFootnote (ID: {1FF1C62A-BBB8-47A1-B29A-71D93EF78E23}). */
  databridgePerformanceFootnote?: Maybe<RichTextField>;
  /** databridgeRiskAnalysisFootnote (ID: {82C18EF2-D617-4B30-8614-9AC2ABEC6789}). */
  databridgeRiskAnalysisFootnote?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Footnotes) for reliable querying. */
export type C___FootnotesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Footnotes) for reliable querying. */
export type C___FootnotesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Footnotes) for reliable querying. */
export type C___FootnotesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Footnotes) for reliable querying. */
export type C___FootnotesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Footnotes) for reliable querying. */
export type C___FootnotesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Footnotes) for reliable querying. */
export type C___FootnotesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundDetailsWildcard template (ID: {6F25CBEA-B6AF-400F-86EB-22F35D82E853}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundDetailsWildcard) for reliable querying. */
export type C___FundDetailsWildcard = Item & {
  __typename?: 'C___FundDetailsWildcard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundDetailsWildcard template (ID: {6F25CBEA-B6AF-400F-86EB-22F35D82E853}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundDetailsWildcard) for reliable querying. */
export type C___FundDetailsWildcardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundDetailsWildcard template (ID: {6F25CBEA-B6AF-400F-86EB-22F35D82E853}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundDetailsWildcard) for reliable querying. */
export type C___FundDetailsWildcardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundDetailsWildcard template (ID: {6F25CBEA-B6AF-400F-86EB-22F35D82E853}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundDetailsWildcard) for reliable querying. */
export type C___FundDetailsWildcardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundDetailsWildcard template (ID: {6F25CBEA-B6AF-400F-86EB-22F35D82E853}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundDetailsWildcard) for reliable querying. */
export type C___FundDetailsWildcardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundDetailsWildcard template (ID: {6F25CBEA-B6AF-400F-86EB-22F35D82E853}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundDetailsWildcard) for reliable querying. */
export type C___FundDetailsWildcardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundDetailsWildcard template (ID: {6F25CBEA-B6AF-400F-86EB-22F35D82E853}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundDetailsWildcard) for reliable querying. */
export type C___FundDetailsWildcardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundFormAvailability) for reliable querying. */
export type C___FundFormAvailability = Item & _FundFormAvailability & {
  __typename?: 'C___FundFormAvailability';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** applicableFunds (ID: {D5891DA4-76A3-4C2A-9B6B-E002FD5BC978}). */
  applicableFunds?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** formAuthorizations (ID: {261F0149-9EA4-4257-B36F-E5D912D66AAD}). */
  formAuthorizations?: Maybe<MultilistField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundFormAvailability) for reliable querying. */
export type C___FundFormAvailabilityAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundFormAvailability) for reliable querying. */
export type C___FundFormAvailabilityChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundFormAvailability) for reliable querying. */
export type C___FundFormAvailabilityFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundFormAvailability) for reliable querying. */
export type C___FundFormAvailabilityFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundFormAvailability) for reliable querying. */
export type C___FundFormAvailabilityHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundFormAvailability) for reliable querying. */
export type C___FundFormAvailabilityIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundMetadataPage) for reliable querying. */
export type C___FundMetadataPage = Item & _FundMetadataPage & {
  __typename?: 'C___FundMetadataPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundMetadataPage) for reliable querying. */
export type C___FundMetadataPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundMetadataPage) for reliable querying. */
export type C___FundMetadataPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundMetadataPage) for reliable querying. */
export type C___FundMetadataPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundMetadataPage) for reliable querying. */
export type C___FundMetadataPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundMetadataPage) for reliable querying. */
export type C___FundMetadataPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundMetadataPage) for reliable querying. */
export type C___FundMetadataPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundSearchPage template (ID: {B67EBD9F-6BA0-4309-9453-EAD6D6482DC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundSearchPage) for reliable querying. */
export type C___FundSearchPage = Item & {
  __typename?: 'C___FundSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundSearchPage template (ID: {B67EBD9F-6BA0-4309-9453-EAD6D6482DC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundSearchPage) for reliable querying. */
export type C___FundSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundSearchPage template (ID: {B67EBD9F-6BA0-4309-9453-EAD6D6482DC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundSearchPage) for reliable querying. */
export type C___FundSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundSearchPage template (ID: {B67EBD9F-6BA0-4309-9453-EAD6D6482DC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundSearchPage) for reliable querying. */
export type C___FundSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundSearchPage template (ID: {B67EBD9F-6BA0-4309-9453-EAD6D6482DC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundSearchPage) for reliable querying. */
export type C___FundSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundSearchPage template (ID: {B67EBD9F-6BA0-4309-9453-EAD6D6482DC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundSearchPage) for reliable querying. */
export type C___FundSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundSearchPage template (ID: {B67EBD9F-6BA0-4309-9453-EAD6D6482DC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundSearchPage) for reliable querying. */
export type C___FundSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFolder template (ID: {55B30B16-2458-409E-A31E-405CED020B9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFolder) for reliable querying. */
export type C___FundsFolder = Item & {
  __typename?: 'C___FundsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFolder template (ID: {55B30B16-2458-409E-A31E-405CED020B9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFolder) for reliable querying. */
export type C___FundsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFolder template (ID: {55B30B16-2458-409E-A31E-405CED020B9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFolder) for reliable querying. */
export type C___FundsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFolder template (ID: {55B30B16-2458-409E-A31E-405CED020B9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFolder) for reliable querying. */
export type C___FundsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFolder template (ID: {55B30B16-2458-409E-A31E-405CED020B9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFolder) for reliable querying. */
export type C___FundsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFolder template (ID: {55B30B16-2458-409E-A31E-405CED020B9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFolder) for reliable querying. */
export type C___FundsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFolder template (ID: {55B30B16-2458-409E-A31E-405CED020B9D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFolder) for reliable querying. */
export type C___FundsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFormsFolder template (ID: {B1A66C27-C766-4C5A-84EF-E9D3ABC6DB85}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFormsFolder) for reliable querying. */
export type C___FundsFormsFolder = Item & {
  __typename?: 'C___FundsFormsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFormsFolder template (ID: {B1A66C27-C766-4C5A-84EF-E9D3ABC6DB85}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFormsFolder) for reliable querying. */
export type C___FundsFormsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFormsFolder template (ID: {B1A66C27-C766-4C5A-84EF-E9D3ABC6DB85}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFormsFolder) for reliable querying. */
export type C___FundsFormsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFormsFolder template (ID: {B1A66C27-C766-4C5A-84EF-E9D3ABC6DB85}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFormsFolder) for reliable querying. */
export type C___FundsFormsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFormsFolder template (ID: {B1A66C27-C766-4C5A-84EF-E9D3ABC6DB85}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFormsFolder) for reliable querying. */
export type C___FundsFormsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFormsFolder template (ID: {B1A66C27-C766-4C5A-84EF-E9D3ABC6DB85}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFormsFolder) for reliable querying. */
export type C___FundsFormsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsFormsFolder template (ID: {B1A66C27-C766-4C5A-84EF-E9D3ABC6DB85}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsFormsFolder) for reliable querying. */
export type C___FundsFormsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsLiteratureFolder template (ID: {8B9E608C-5A4C-4B00-A545-D8DCFE48AA0F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsLiteratureFolder) for reliable querying. */
export type C___FundsLiteratureFolder = Item & {
  __typename?: 'C___FundsLiteratureFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsLiteratureFolder template (ID: {8B9E608C-5A4C-4B00-A545-D8DCFE48AA0F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsLiteratureFolder) for reliable querying. */
export type C___FundsLiteratureFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsLiteratureFolder template (ID: {8B9E608C-5A4C-4B00-A545-D8DCFE48AA0F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsLiteratureFolder) for reliable querying. */
export type C___FundsLiteratureFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsLiteratureFolder template (ID: {8B9E608C-5A4C-4B00-A545-D8DCFE48AA0F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsLiteratureFolder) for reliable querying. */
export type C___FundsLiteratureFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsLiteratureFolder template (ID: {8B9E608C-5A4C-4B00-A545-D8DCFE48AA0F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsLiteratureFolder) for reliable querying. */
export type C___FundsLiteratureFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsLiteratureFolder template (ID: {8B9E608C-5A4C-4B00-A545-D8DCFE48AA0F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsLiteratureFolder) for reliable querying. */
export type C___FundsLiteratureFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundsLiteratureFolder template (ID: {8B9E608C-5A4C-4B00-A545-D8DCFE48AA0F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsLiteratureFolder) for reliable querying. */
export type C___FundsLiteratureFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundsShareclassesDetailsWildcard template (ID: {5061CFF0-9CB7-43A7-BC44-464588BA7EA2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsShareclassesDetailsWildcard) for reliable querying. */
export type C___FundsShareclassesDetailsWildcard = Item & {
  __typename?: 'C___FundsShareclassesDetailsWildcard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundsShareclassesDetailsWildcard template (ID: {5061CFF0-9CB7-43A7-BC44-464588BA7EA2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsShareclassesDetailsWildcard) for reliable querying. */
export type C___FundsShareclassesDetailsWildcardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundsShareclassesDetailsWildcard template (ID: {5061CFF0-9CB7-43A7-BC44-464588BA7EA2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsShareclassesDetailsWildcard) for reliable querying. */
export type C___FundsShareclassesDetailsWildcardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundsShareclassesDetailsWildcard template (ID: {5061CFF0-9CB7-43A7-BC44-464588BA7EA2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsShareclassesDetailsWildcard) for reliable querying. */
export type C___FundsShareclassesDetailsWildcardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundsShareclassesDetailsWildcard template (ID: {5061CFF0-9CB7-43A7-BC44-464588BA7EA2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsShareclassesDetailsWildcard) for reliable querying. */
export type C___FundsShareclassesDetailsWildcardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundsShareclassesDetailsWildcard template (ID: {5061CFF0-9CB7-43A7-BC44-464588BA7EA2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsShareclassesDetailsWildcard) for reliable querying. */
export type C___FundsShareclassesDetailsWildcardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_FundsShareclassesDetailsWildcard template (ID: {5061CFF0-9CB7-43A7-BC44-464588BA7EA2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _FundsShareclassesDetailsWildcard) for reliable querying. */
export type C___FundsShareclassesDetailsWildcardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _GridMapping) for reliable querying. */
export type C___GridMapping = Item & _GridMapping & {
  __typename?: 'C___GridMapping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _GridMapping) for reliable querying. */
export type C___GridMappingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _GridMapping) for reliable querying. */
export type C___GridMappingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _GridMapping) for reliable querying. */
export type C___GridMappingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _GridMapping) for reliable querying. */
export type C___GridMappingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _GridMapping) for reliable querying. */
export type C___GridMappingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _GridMapping) for reliable querying. */
export type C___GridMappingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticle) for reliable querying. */
export type C___HelpArticle = Item & _BaseHelpArticle & _HelpArticle & _SharedPage & {
  __typename?: 'C___HelpArticle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** helpPlatform (ID: {6D132CC4-961D-4DE6-94F4-C99A8DD8EE64}). */
  helpPlatform?: Maybe<MultilistField>;
  /** helpStrapline (ID: {20C18889-078D-4483-B837-E8CC2CEAD74E}). */
  helpStrapline?: Maybe<TextField>;
  /** helpTag (ID: {212899C9-5810-4BF4-8EEF-D957FBE30EB7}). */
  helpTag?: Maybe<LookupField>;
  /** helpTitle (ID: {8602E54D-E233-4F77-8083-C5023808D8DB}). */
  helpTitle?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticle) for reliable querying. */
export type C___HelpArticleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticle) for reliable querying. */
export type C___HelpArticleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticle) for reliable querying. */
export type C___HelpArticleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticle) for reliable querying. */
export type C___HelpArticleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticle) for reliable querying. */
export type C___HelpArticleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticle) for reliable querying. */
export type C___HelpArticleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleSearchPage template (ID: {37EE66FD-38A3-4359-810D-ACFBBF510666}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleSearchPage) for reliable querying. */
export type C___HelpArticleSearchPage = Item & {
  __typename?: 'C___HelpArticleSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleSearchPage template (ID: {37EE66FD-38A3-4359-810D-ACFBBF510666}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleSearchPage) for reliable querying. */
export type C___HelpArticleSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleSearchPage template (ID: {37EE66FD-38A3-4359-810D-ACFBBF510666}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleSearchPage) for reliable querying. */
export type C___HelpArticleSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleSearchPage template (ID: {37EE66FD-38A3-4359-810D-ACFBBF510666}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleSearchPage) for reliable querying. */
export type C___HelpArticleSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleSearchPage template (ID: {37EE66FD-38A3-4359-810D-ACFBBF510666}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleSearchPage) for reliable querying. */
export type C___HelpArticleSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleSearchPage template (ID: {37EE66FD-38A3-4359-810D-ACFBBF510666}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleSearchPage) for reliable querying. */
export type C___HelpArticleSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleSearchPage template (ID: {37EE66FD-38A3-4359-810D-ACFBBF510666}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleSearchPage) for reliable querying. */
export type C___HelpArticleSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleWildcard template (ID: {D774D8BD-0C02-4A7B-A138-5D417F567396}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleWildcard) for reliable querying. */
export type C___HelpArticleWildcard = Item & {
  __typename?: 'C___HelpArticleWildcard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleWildcard template (ID: {D774D8BD-0C02-4A7B-A138-5D417F567396}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleWildcard) for reliable querying. */
export type C___HelpArticleWildcardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleWildcard template (ID: {D774D8BD-0C02-4A7B-A138-5D417F567396}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleWildcard) for reliable querying. */
export type C___HelpArticleWildcardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleWildcard template (ID: {D774D8BD-0C02-4A7B-A138-5D417F567396}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleWildcard) for reliable querying. */
export type C___HelpArticleWildcardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleWildcard template (ID: {D774D8BD-0C02-4A7B-A138-5D417F567396}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleWildcard) for reliable querying. */
export type C___HelpArticleWildcardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleWildcard template (ID: {D774D8BD-0C02-4A7B-A138-5D417F567396}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleWildcard) for reliable querying. */
export type C___HelpArticleWildcardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticleWildcard template (ID: {D774D8BD-0C02-4A7B-A138-5D417F567396}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HelpArticleWildcard) for reliable querying. */
export type C___HelpArticleWildcardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/_HorizonDatasourceGrouping template (ID: {D0F6BE14-2A2D-4C56-ACB5-80CAA573B8E2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HorizonDatasourceGrouping) for reliable querying. */
export type C___HorizonDatasourceGrouping = Item & {
  __typename?: 'C___HorizonDatasourceGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/_HorizonDatasourceGrouping template (ID: {D0F6BE14-2A2D-4C56-ACB5-80CAA573B8E2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HorizonDatasourceGrouping) for reliable querying. */
export type C___HorizonDatasourceGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/_HorizonDatasourceGrouping template (ID: {D0F6BE14-2A2D-4C56-ACB5-80CAA573B8E2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HorizonDatasourceGrouping) for reliable querying. */
export type C___HorizonDatasourceGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/_HorizonDatasourceGrouping template (ID: {D0F6BE14-2A2D-4C56-ACB5-80CAA573B8E2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HorizonDatasourceGrouping) for reliable querying. */
export type C___HorizonDatasourceGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/_HorizonDatasourceGrouping template (ID: {D0F6BE14-2A2D-4C56-ACB5-80CAA573B8E2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HorizonDatasourceGrouping) for reliable querying. */
export type C___HorizonDatasourceGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/_HorizonDatasourceGrouping template (ID: {D0F6BE14-2A2D-4C56-ACB5-80CAA573B8E2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HorizonDatasourceGrouping) for reliable querying. */
export type C___HorizonDatasourceGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/_HorizonDatasourceGrouping template (ID: {D0F6BE14-2A2D-4C56-ACB5-80CAA573B8E2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _HorizonDatasourceGrouping) for reliable querying. */
export type C___HorizonDatasourceGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Icon) for reliable querying. */
export type C___Icon = Item & _Icon & {
  __typename?: 'C___Icon';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Icon (ID: {BF2F5042-9481-488D-A389-1B70A0B78ED8}). */
  icon_bf2f50429481488da3891b70a0b78ed8?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Icon) for reliable querying. */
export type C___IconAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Icon) for reliable querying. */
export type C___IconChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Icon) for reliable querying. */
export type C___IconFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Icon) for reliable querying. */
export type C___IconFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Icon) for reliable querying. */
export type C___IconHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Icon) for reliable querying. */
export type C___IconIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeByDefault) for reliable querying. */
export type C___IncludeByDefault = Item & _IncludeByDefault & {
  __typename?: 'C___IncludeByDefault';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IncludeByDefault (ID: {11488836-D40F-40D4-BEB4-1D31DA7B1470}). */
  includeByDefault?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeByDefault) for reliable querying. */
export type C___IncludeByDefaultAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeByDefault) for reliable querying. */
export type C___IncludeByDefaultChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeByDefault) for reliable querying. */
export type C___IncludeByDefaultFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeByDefault) for reliable querying. */
export type C___IncludeByDefaultFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeByDefault) for reliable querying. */
export type C___IncludeByDefaultHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeByDefault) for reliable querying. */
export type C___IncludeByDefaultIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeIfInstalled) for reliable querying. */
export type C___IncludeIfInstalled = Item & _IncludeIfInstalled & {
  __typename?: 'C___IncludeIfInstalled';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IncludeIfInstalled (ID: {52A4245C-A3D5-4B23-9F3A-5B33C9811906}). */
  includeIfInstalled?: Maybe<MultilistField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeIfInstalled) for reliable querying. */
export type C___IncludeIfInstalledAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeIfInstalled) for reliable querying. */
export type C___IncludeIfInstalledChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeIfInstalled) for reliable querying. */
export type C___IncludeIfInstalledFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeIfInstalled) for reliable querying. */
export type C___IncludeIfInstalledFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeIfInstalled) for reliable querying. */
export type C___IncludeIfInstalledHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IncludeIfInstalled) for reliable querying. */
export type C___IncludeIfInstalledIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternalArticle) for reliable querying. */
export type C___InternalArticle = Item & _BaseArticle & _ContentType & _InternalArticle & _LimitedDisplay & _PremiumContentPage & _SharedPage & {
  __typename?: 'C___InternalArticle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternalArticle) for reliable querying. */
export type C___InternalArticleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternalArticle) for reliable querying. */
export type C___InternalArticleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternalArticle) for reliable querying. */
export type C___InternalArticleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternalArticle) for reliable querying. */
export type C___InternalArticleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternalArticle) for reliable querying. */
export type C___InternalArticleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternalArticle) for reliable querying. */
export type C___InternalArticleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternetExplorerCompatibilityMode) for reliable querying. */
export type C___InternetExplorerCompatibilityMode = Item & _InternetExplorerCompatibilityMode & {
  __typename?: 'C___InternetExplorerCompatibilityMode';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CompatibilityModeEdit (ID: {74F8C14D-559B-40D0-BF52-4C53FA62E7AA}). */
  compatibilityModeEdit?: Maybe<LookupField>;
  /** CompatibilityModePreviewPublic (ID: {A4BAAEBC-8AB7-4038-B6C9-BB7B7D170452}). */
  compatibilityModePreviewPublic?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternetExplorerCompatibilityMode) for reliable querying. */
export type C___InternetExplorerCompatibilityModeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternetExplorerCompatibilityMode) for reliable querying. */
export type C___InternetExplorerCompatibilityModeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternetExplorerCompatibilityMode) for reliable querying. */
export type C___InternetExplorerCompatibilityModeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternetExplorerCompatibilityMode) for reliable querying. */
export type C___InternetExplorerCompatibilityModeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternetExplorerCompatibilityMode) for reliable querying. */
export type C___InternetExplorerCompatibilityModeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _InternetExplorerCompatibilityMode) for reliable querying. */
export type C___InternetExplorerCompatibilityModeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IsSystemModule) for reliable querying. */
export type C___IsSystemModule = Item & _IsSystemModule & {
  __typename?: 'C___IsSystemModule';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsSystemModule (ID: {06D2C562-9229-4779-8807-E2A5FD2990D4}). */
  isSystemModule?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IsSystemModule) for reliable querying. */
export type C___IsSystemModuleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IsSystemModule) for reliable querying. */
export type C___IsSystemModuleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IsSystemModule) for reliable querying. */
export type C___IsSystemModuleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IsSystemModule) for reliable querying. */
export type C___IsSystemModuleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IsSystemModule) for reliable querying. */
export type C___IsSystemModuleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _IsSystemModule) for reliable querying. */
export type C___IsSystemModuleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantPaging) for reliable querying. */
export type C___JsonVariantPaging = Item & _JsonVariantPaging & {
  __typename?: 'C___JSONVariantPaging';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NumberOfResultsToSkip (ID: {79499A55-648D-4B30-A526-13C9F47C3121}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantPaging) for reliable querying. */
export type C___JsonVariantPagingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantPaging) for reliable querying. */
export type C___JsonVariantPagingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantPaging) for reliable querying. */
export type C___JsonVariantPagingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantPaging) for reliable querying. */
export type C___JsonVariantPagingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantPaging) for reliable querying. */
export type C___JsonVariantPagingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantPaging) for reliable querying. */
export type C___JsonVariantPagingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variants Base template (ID: {1E15019A-2934-4F6B-8772-84E8EA77039C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantsBase) for reliable querying. */
export type C___JsonVariantsBase = Item & {
  __typename?: 'C___JSONVariantsBase';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variants Base template (ID: {1E15019A-2934-4F6B-8772-84E8EA77039C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantsBase) for reliable querying. */
export type C___JsonVariantsBaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variants Base template (ID: {1E15019A-2934-4F6B-8772-84E8EA77039C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantsBase) for reliable querying. */
export type C___JsonVariantsBaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variants Base template (ID: {1E15019A-2934-4F6B-8772-84E8EA77039C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantsBase) for reliable querying. */
export type C___JsonVariantsBaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variants Base template (ID: {1E15019A-2934-4F6B-8772-84E8EA77039C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantsBase) for reliable querying. */
export type C___JsonVariantsBaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variants Base template (ID: {1E15019A-2934-4F6B-8772-84E8EA77039C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantsBase) for reliable querying. */
export type C___JsonVariantsBaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variants Base template (ID: {1E15019A-2934-4F6B-8772-84E8EA77039C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _JSONVariantsBase) for reliable querying. */
export type C___JsonVariantsBaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LimitedDisplay) for reliable querying. */
export type C___LimitedDisplay = Item & _LimitedDisplay & {
  __typename?: 'C___LimitedDisplay';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LimitedDisplay) for reliable querying. */
export type C___LimitedDisplayAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LimitedDisplay) for reliable querying. */
export type C___LimitedDisplayChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LimitedDisplay) for reliable querying. */
export type C___LimitedDisplayFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LimitedDisplay) for reliable querying. */
export type C___LimitedDisplayFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LimitedDisplay) for reliable querying. */
export type C___LimitedDisplayHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LimitedDisplay) for reliable querying. */
export type C___LimitedDisplayIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkAttributes) for reliable querying. */
export type C___LinkAttributes = Item & _LinkAttributes & {
  __typename?: 'C___LinkAttributes';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkAttributes) for reliable querying. */
export type C___LinkAttributesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkAttributes) for reliable querying. */
export type C___LinkAttributesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkAttributes) for reliable querying. */
export type C___LinkAttributesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkAttributes) for reliable querying. */
export type C___LinkAttributesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkAttributes) for reliable querying. */
export type C___LinkAttributesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkAttributes) for reliable querying. */
export type C___LinkAttributesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkSettings) for reliable querying. */
export type C___LinkSettings = Item & _LinkSettings & {
  __typename?: 'C___LinkSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkSettings) for reliable querying. */
export type C___LinkSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkSettings) for reliable querying. */
export type C___LinkSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkSettings) for reliable querying. */
export type C___LinkSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkSettings) for reliable querying. */
export type C___LinkSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkSettings) for reliable querying. */
export type C___LinkSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LinkSettings) for reliable querying. */
export type C___LinkSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_LiteratureHubSearchPage template (ID: {9AF596AF-D4F0-4D64-8C3C-8FFE9C1D1B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LiteratureHubSearchPage) for reliable querying. */
export type C___LiteratureHubSearchPage = Item & {
  __typename?: 'C___LiteratureHubSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_LiteratureHubSearchPage template (ID: {9AF596AF-D4F0-4D64-8C3C-8FFE9C1D1B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LiteratureHubSearchPage) for reliable querying. */
export type C___LiteratureHubSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_LiteratureHubSearchPage template (ID: {9AF596AF-D4F0-4D64-8C3C-8FFE9C1D1B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LiteratureHubSearchPage) for reliable querying. */
export type C___LiteratureHubSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_LiteratureHubSearchPage template (ID: {9AF596AF-D4F0-4D64-8C3C-8FFE9C1D1B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LiteratureHubSearchPage) for reliable querying. */
export type C___LiteratureHubSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_LiteratureHubSearchPage template (ID: {9AF596AF-D4F0-4D64-8C3C-8FFE9C1D1B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LiteratureHubSearchPage) for reliable querying. */
export type C___LiteratureHubSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_LiteratureHubSearchPage template (ID: {9AF596AF-D4F0-4D64-8C3C-8FFE9C1D1B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LiteratureHubSearchPage) for reliable querying. */
export type C___LiteratureHubSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_LiteratureHubSearchPage template (ID: {9AF596AF-D4F0-4D64-8C3C-8FFE9C1D1B82}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _LiteratureHubSearchPage) for reliable querying. */
export type C___LiteratureHubSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ManualKeyInformation) for reliable querying. */
export type C___ManualKeyInformation = Item & _ManualKeyInformation & {
  __typename?: 'C___ManualKeyInformation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** cefFiscalYearEnd (ID: {36090CDB-E822-43AA-A941-8DAD83E90944}). */
  cefFiscalYearEnd?: Maybe<TextField>;
  /** cefGrossExpenseRatio (ID: {A82CC7EA-1832-4169-B963-F4B6A99A04C9}). */
  cefGrossExpenseRatio?: Maybe<TextField>;
  /** cefManagedAssets (ID: {46F2EAC2-858F-4F01-AABF-8899EC39C967}). */
  cefManagedAssets?: Maybe<TextField>;
  /** cefMarketDistributionRate (ID: {49217872-A9FB-411B-9D18-E03AD788C21B}). */
  cefMarketDistributionRate?: Maybe<TextField>;
  /** cefNavDistributionRate (ID: {F9ADB002-5758-410F-90A7-6E7002B4F83E}). */
  cefNavDistributionRate?: Maybe<TextField>;
  /** cefNetAssets (ID: {B5DD3507-1038-40A7-9A09-F2F782DA3EBE}). */
  cefNetAssets?: Maybe<TextField>;
  /** cefNetExpenseRatio (ID: {35D637EF-F66B-452E-B95B-207681B9ED6D}). */
  cefNetExpenseRatio?: Maybe<TextField>;
  /** cefSharesOutstanding (ID: {DC32AA50-4061-41D1-B68E-9D1D7058BC6A}). */
  cefSharesOutstanding?: Maybe<TextField>;
  /** cefTickerSymbol (ID: {FA32E335-E08D-4ED2-A5BF-89E25E7D46C6}). */
  cefTickerSymbol?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ManualKeyInformation) for reliable querying. */
export type C___ManualKeyInformationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ManualKeyInformation) for reliable querying. */
export type C___ManualKeyInformationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ManualKeyInformation) for reliable querying. */
export type C___ManualKeyInformationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ManualKeyInformation) for reliable querying. */
export type C___ManualKeyInformationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ManualKeyInformation) for reliable querying. */
export type C___ManualKeyInformationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ManualKeyInformation) for reliable querying. */
export type C___ManualKeyInformationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MemberOf) for reliable querying. */
export type C___MemberOf = Item & _MemberOf & {
  __typename?: 'C___MemberOf';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MemberOf (ID: {359B28A0-9FAC-4F93-B0F6-DB957CBE5CE9}). */
  memberOf?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MemberOf) for reliable querying. */
export type C___MemberOfAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MemberOf) for reliable querying. */
export type C___MemberOfChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MemberOf) for reliable querying. */
export type C___MemberOfFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MemberOf) for reliable querying. */
export type C___MemberOfFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MemberOf) for reliable querying. */
export type C___MemberOfHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MemberOf) for reliable querying. */
export type C___MemberOfIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MetadataPage) for reliable querying. */
export type C___MetadataPage = Item & _MetadataPage & {
  __typename?: 'C___MetadataPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MetadataPage) for reliable querying. */
export type C___MetadataPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MetadataPage) for reliable querying. */
export type C___MetadataPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MetadataPage) for reliable querying. */
export type C___MetadataPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MetadataPage) for reliable querying. */
export type C___MetadataPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MetadataPage) for reliable querying. */
export type C___MetadataPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _MetadataPage) for reliable querying. */
export type C___MetadataPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Modules) for reliable querying. */
export type C___Modules = Item & _Modules & {
  __typename?: 'C___Modules';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Modules) for reliable querying. */
export type C___ModulesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Modules) for reliable querying. */
export type C___ModulesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Modules) for reliable querying. */
export type C___ModulesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Modules) for reliable querying. */
export type C___ModulesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Modules) for reliable querying. */
export type C___ModulesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Modules) for reliable querying. */
export type C___ModulesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name) for reliable querying. */
export type C___Name = Item & _Name & {
  __typename?: 'C___Name';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {4F886DD0-63DC-4A32-8765-E7FE78B9B0D2}). */
  name_4f886dd063dc4a328765e7fe78b9b0d2?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name) for reliable querying. */
export type C___NameAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name) for reliable querying. */
export type C___NameChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name) for reliable querying. */
export type C___NameFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name) for reliable querying. */
export type C___NameFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name) for reliable querying. */
export type C___NameHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name) for reliable querying. */
export type C___NameIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_0345fd2f95094dc7b0f56c73a9b6cd8d) for reliable querying. */
export type C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = Item & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & {
  __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_0345fd2f95094dc7b0f56c73a9b6cd8d) for reliable querying. */
export type C___Name_0345fd2f95094dc7b0f56c73a9b6cd8dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_0345fd2f95094dc7b0f56c73a9b6cd8d) for reliable querying. */
export type C___Name_0345fd2f95094dc7b0f56c73a9b6cd8dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_0345fd2f95094dc7b0f56c73a9b6cd8d) for reliable querying. */
export type C___Name_0345fd2f95094dc7b0f56c73a9b6cd8dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_0345fd2f95094dc7b0f56c73a9b6cd8d) for reliable querying. */
export type C___Name_0345fd2f95094dc7b0f56c73a9b6cd8dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_0345fd2f95094dc7b0f56c73a9b6cd8d) for reliable querying. */
export type C___Name_0345fd2f95094dc7b0f56c73a9b6cd8dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_0345fd2f95094dc7b0f56c73a9b6cd8d) for reliable querying. */
export type C___Name_0345fd2f95094dc7b0f56c73a9b6cd8dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_299cdb154745448a807868d401248eaa) for reliable querying. */
export type C___Name_299cdb154745448a807868d401248eaa = Item & _Name_299cdb154745448a807868d401248eaa & {
  __typename?: 'C___Name_299cdb154745448a807868d401248eaa';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {7868E6BC-525C-4FCE-AB8A-77DA3E09B171}). */
  name_7868e6bc525c4fceab8a77da3e09b171?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_299cdb154745448a807868d401248eaa) for reliable querying. */
export type C___Name_299cdb154745448a807868d401248eaaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_299cdb154745448a807868d401248eaa) for reliable querying. */
export type C___Name_299cdb154745448a807868d401248eaaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_299cdb154745448a807868d401248eaa) for reliable querying. */
export type C___Name_299cdb154745448a807868d401248eaaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_299cdb154745448a807868d401248eaa) for reliable querying. */
export type C___Name_299cdb154745448a807868d401248eaaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_299cdb154745448a807868d401248eaa) for reliable querying. */
export type C___Name_299cdb154745448a807868d401248eaaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_299cdb154745448a807868d401248eaa) for reliable querying. */
export type C___Name_299cdb154745448a807868d401248eaaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_b88cf88159a54a19991e71038751cb60) for reliable querying. */
export type C___Name_B88cf88159a54a19991e71038751cb60 = Item & _Name_B88cf88159a54a19991e71038751cb60 & {
  __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {C202067E-7FAB-4606-AFB4-E76DF2185DDC}). */
  name_c202067e7fab4606afb4e76df2185ddc?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_b88cf88159a54a19991e71038751cb60) for reliable querying. */
export type C___Name_B88cf88159a54a19991e71038751cb60AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_b88cf88159a54a19991e71038751cb60) for reliable querying. */
export type C___Name_B88cf88159a54a19991e71038751cb60ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_b88cf88159a54a19991e71038751cb60) for reliable querying. */
export type C___Name_B88cf88159a54a19991e71038751cb60FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_b88cf88159a54a19991e71038751cb60) for reliable querying. */
export type C___Name_B88cf88159a54a19991e71038751cb60FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_b88cf88159a54a19991e71038751cb60) for reliable querying. */
export type C___Name_B88cf88159a54a19991e71038751cb60HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Name_b88cf88159a54a19991e71038751cb60) for reliable querying. */
export type C___Name_B88cf88159a54a19991e71038751cb60IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Navigable) for reliable querying. */
export type C___Navigable = Item & _Navigable & {
  __typename?: 'C___Navigable';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Navigable) for reliable querying. */
export type C___NavigableAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Navigable) for reliable querying. */
export type C___NavigableChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Navigable) for reliable querying. */
export type C___NavigableFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Navigable) for reliable querying. */
export type C___NavigableFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Navigable) for reliable querying. */
export type C___NavigableHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Navigable) for reliable querying. */
export type C___NavigableIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _NavigablePage) for reliable querying. */
export type C___NavigablePage = Item & _NavigablePage & {
  __typename?: 'C___NavigablePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _NavigablePage) for reliable querying. */
export type C___NavigablePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _NavigablePage) for reliable querying. */
export type C___NavigablePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _NavigablePage) for reliable querying. */
export type C___NavigablePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _NavigablePage) for reliable querying. */
export type C___NavigablePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _NavigablePage) for reliable querying. */
export type C___NavigablePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _NavigablePage) for reliable querying. */
export type C___NavigablePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_PageContent template (ID: {6DA8E051-15E4-443D-BA23-D4B079E65004}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageContent) for reliable querying. */
export type C___PageContent = Item & {
  __typename?: 'C___PageContent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_PageContent template (ID: {6DA8E051-15E4-443D-BA23-D4B079E65004}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageContent) for reliable querying. */
export type C___PageContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_PageContent template (ID: {6DA8E051-15E4-443D-BA23-D4B079E65004}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageContent) for reliable querying. */
export type C___PageContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_PageContent template (ID: {6DA8E051-15E4-443D-BA23-D4B079E65004}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageContent) for reliable querying. */
export type C___PageContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_PageContent template (ID: {6DA8E051-15E4-443D-BA23-D4B079E65004}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageContent) for reliable querying. */
export type C___PageContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_PageContent template (ID: {6DA8E051-15E4-443D-BA23-D4B079E65004}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageContent) for reliable querying. */
export type C___PageContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_PageContent template (ID: {6DA8E051-15E4-443D-BA23-D4B079E65004}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageContent) for reliable querying. */
export type C___PageContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_PageWorkflow template (ID: {07A1CE82-EE5E-4F92-B83C-621E7909893E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageWorkflow) for reliable querying. */
export type C___PageWorkflow = Item & {
  __typename?: 'C___PageWorkflow';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_PageWorkflow template (ID: {07A1CE82-EE5E-4F92-B83C-621E7909893E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageWorkflow) for reliable querying. */
export type C___PageWorkflowAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_PageWorkflow template (ID: {07A1CE82-EE5E-4F92-B83C-621E7909893E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageWorkflow) for reliable querying. */
export type C___PageWorkflowChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_PageWorkflow template (ID: {07A1CE82-EE5E-4F92-B83C-621E7909893E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageWorkflow) for reliable querying. */
export type C___PageWorkflowFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_PageWorkflow template (ID: {07A1CE82-EE5E-4F92-B83C-621E7909893E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageWorkflow) for reliable querying. */
export type C___PageWorkflowFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_PageWorkflow template (ID: {07A1CE82-EE5E-4F92-B83C-621E7909893E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageWorkflow) for reliable querying. */
export type C___PageWorkflowHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Workflows/_PageWorkflow template (ID: {07A1CE82-EE5E-4F92-B83C-621E7909893E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PageWorkflow) for reliable querying. */
export type C___PageWorkflowIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/_PerSiteStandardValues template (ID: {44A022DB-56D3-419A-B43B-E27E4D8E9C41}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PerSiteStandardValues) for reliable querying. */
export type C___PerSiteStandardValues = Item & {
  __typename?: 'C___PerSiteStandardValues';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/_PerSiteStandardValues template (ID: {44A022DB-56D3-419A-B43B-E27E4D8E9C41}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PerSiteStandardValues) for reliable querying. */
export type C___PerSiteStandardValuesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/_PerSiteStandardValues template (ID: {44A022DB-56D3-419A-B43B-E27E4D8E9C41}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PerSiteStandardValues) for reliable querying. */
export type C___PerSiteStandardValuesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/_PerSiteStandardValues template (ID: {44A022DB-56D3-419A-B43B-E27E4D8E9C41}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PerSiteStandardValues) for reliable querying. */
export type C___PerSiteStandardValuesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/_PerSiteStandardValues template (ID: {44A022DB-56D3-419A-B43B-E27E4D8E9C41}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PerSiteStandardValues) for reliable querying. */
export type C___PerSiteStandardValuesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/_PerSiteStandardValues template (ID: {44A022DB-56D3-419A-B43B-E27E4D8E9C41}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PerSiteStandardValues) for reliable querying. */
export type C___PerSiteStandardValuesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/_PerSiteStandardValues template (ID: {44A022DB-56D3-419A-B43B-E27E4D8E9C41}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PerSiteStandardValues) for reliable querying. */
export type C___PerSiteStandardValuesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Podcast) for reliable querying. */
export type C___Podcast = Item & _BaseArticle & _ContentType & _InternalArticle & _LimitedDisplay & _Podcast & _PremiumContentPage & _SharedPage & {
  __typename?: 'C___Podcast';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {EE25CB28-67AA-4564-8B8B-4A8B7076FFF4}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Podcast) for reliable querying. */
export type C___PodcastAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Podcast) for reliable querying. */
export type C___PodcastChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Podcast) for reliable querying. */
export type C___PodcastFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Podcast) for reliable querying. */
export type C___PodcastFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Podcast) for reliable querying. */
export type C___PodcastHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Podcast) for reliable querying. */
export type C___PodcastIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PodcastPressRelease) for reliable querying. */
export type C___PodcastPressRelease = Item & _BasePressRelease & _PodcastPressRelease & _PressReleaseContentType & _SharedPage & {
  __typename?: 'C___PodcastPressRelease';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {123C45F4-DFB2-4D8D-B942-7FBC333B02BD}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PodcastPressRelease) for reliable querying. */
export type C___PodcastPressReleaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PodcastPressRelease) for reliable querying. */
export type C___PodcastPressReleaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PodcastPressRelease) for reliable querying. */
export type C___PodcastPressReleaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PodcastPressRelease) for reliable querying. */
export type C___PodcastPressReleaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PodcastPressRelease) for reliable querying. */
export type C___PodcastPressReleaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PodcastPressRelease) for reliable querying. */
export type C___PodcastPressReleaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PremiumContentPage) for reliable querying. */
export type C___PremiumContentPage = Item & _PremiumContentPage & {
  __typename?: 'C___PremiumContentPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PremiumContentPage) for reliable querying. */
export type C___PremiumContentPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PremiumContentPage) for reliable querying. */
export type C___PremiumContentPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PremiumContentPage) for reliable querying. */
export type C___PremiumContentPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PremiumContentPage) for reliable querying. */
export type C___PremiumContentPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PremiumContentPage) for reliable querying. */
export type C___PremiumContentPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PremiumContentPage) for reliable querying. */
export type C___PremiumContentPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressRelease) for reliable querying. */
export type C___PressRelease = Item & _BasePressRelease & _PressRelease & _PressReleaseContentType & _SharedPage & {
  __typename?: 'C___PressRelease';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Populated automatically during publish */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressRelease) for reliable querying. */
export type C___PressReleaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressRelease) for reliable querying. */
export type C___PressReleaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressRelease) for reliable querying. */
export type C___PressReleaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressRelease) for reliable querying. */
export type C___PressReleaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressRelease) for reliable querying. */
export type C___PressReleaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressRelease) for reliable querying. */
export type C___PressReleaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseContentType) for reliable querying. */
export type C___PressReleaseContentType = Item & _PressReleaseContentType & {
  __typename?: 'C___PressReleaseContentType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseContentType) for reliable querying. */
export type C___PressReleaseContentTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseContentType) for reliable querying. */
export type C___PressReleaseContentTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseContentType) for reliable querying. */
export type C___PressReleaseContentTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseContentType) for reliable querying. */
export type C___PressReleaseContentTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseContentType) for reliable querying. */
export type C___PressReleaseContentTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseContentType) for reliable querying. */
export type C___PressReleaseContentTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseSearchPage template (ID: {9026695F-CF4C-47F9-982C-0E05DC549879}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseSearchPage) for reliable querying. */
export type C___PressReleaseSearchPage = Item & {
  __typename?: 'C___PressReleaseSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseSearchPage template (ID: {9026695F-CF4C-47F9-982C-0E05DC549879}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseSearchPage) for reliable querying. */
export type C___PressReleaseSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseSearchPage template (ID: {9026695F-CF4C-47F9-982C-0E05DC549879}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseSearchPage) for reliable querying. */
export type C___PressReleaseSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseSearchPage template (ID: {9026695F-CF4C-47F9-982C-0E05DC549879}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseSearchPage) for reliable querying. */
export type C___PressReleaseSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseSearchPage template (ID: {9026695F-CF4C-47F9-982C-0E05DC549879}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseSearchPage) for reliable querying. */
export type C___PressReleaseSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseSearchPage template (ID: {9026695F-CF4C-47F9-982C-0E05DC549879}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseSearchPage) for reliable querying. */
export type C___PressReleaseSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseSearchPage template (ID: {9026695F-CF4C-47F9-982C-0E05DC549879}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseSearchPage) for reliable querying. */
export type C___PressReleaseSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseWildcard template (ID: {19EFBB09-1E97-4ECB-B5AD-4EA6880E64E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseWildcard) for reliable querying. */
export type C___PressReleaseWildcard = Item & {
  __typename?: 'C___PressReleaseWildcard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseWildcard template (ID: {19EFBB09-1E97-4ECB-B5AD-4EA6880E64E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseWildcard) for reliable querying. */
export type C___PressReleaseWildcardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseWildcard template (ID: {19EFBB09-1E97-4ECB-B5AD-4EA6880E64E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseWildcard) for reliable querying. */
export type C___PressReleaseWildcardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseWildcard template (ID: {19EFBB09-1E97-4ECB-B5AD-4EA6880E64E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseWildcard) for reliable querying. */
export type C___PressReleaseWildcardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseWildcard template (ID: {19EFBB09-1E97-4ECB-B5AD-4EA6880E64E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseWildcard) for reliable querying. */
export type C___PressReleaseWildcardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseWildcard template (ID: {19EFBB09-1E97-4ECB-B5AD-4EA6880E64E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseWildcard) for reliable querying. */
export type C___PressReleaseWildcardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressReleaseWildcard template (ID: {19EFBB09-1E97-4ECB-B5AD-4EA6880E64E9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PressReleaseWildcard) for reliable querying. */
export type C___PressReleaseWildcardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ProtectedTheme) for reliable querying. */
export type C___ProtectedTheme = Item & _ProtectedTheme & {
  __typename?: 'C___ProtectedTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Protected Theme (ID: {0B9CCE83-5355-4D1A-BBFE-E9BA3C3FE744}). */
  protectedTheme?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ProtectedTheme) for reliable querying. */
export type C___ProtectedThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ProtectedTheme) for reliable querying. */
export type C___ProtectedThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ProtectedTheme) for reliable querying. */
export type C___ProtectedThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ProtectedTheme) for reliable querying. */
export type C___ProtectedThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ProtectedTheme) for reliable querying. */
export type C___ProtectedThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _ProtectedTheme) for reliable querying. */
export type C___ProtectedThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Publishing/_PublishingGroupingTemplate template (ID: {8BA7DAC6-32ED-4378-BD9E-5DA5B0F9848D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PublishingGroupingTemplate) for reliable querying. */
export type C___PublishingGroupingTemplate = Item & {
  __typename?: 'C___PublishingGroupingTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Publishing/_PublishingGroupingTemplate template (ID: {8BA7DAC6-32ED-4378-BD9E-5DA5B0F9848D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PublishingGroupingTemplate) for reliable querying. */
export type C___PublishingGroupingTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Publishing/_PublishingGroupingTemplate template (ID: {8BA7DAC6-32ED-4378-BD9E-5DA5B0F9848D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PublishingGroupingTemplate) for reliable querying. */
export type C___PublishingGroupingTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Publishing/_PublishingGroupingTemplate template (ID: {8BA7DAC6-32ED-4378-BD9E-5DA5B0F9848D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PublishingGroupingTemplate) for reliable querying. */
export type C___PublishingGroupingTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Publishing/_PublishingGroupingTemplate template (ID: {8BA7DAC6-32ED-4378-BD9E-5DA5B0F9848D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PublishingGroupingTemplate) for reliable querying. */
export type C___PublishingGroupingTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Publishing/_PublishingGroupingTemplate template (ID: {8BA7DAC6-32ED-4378-BD9E-5DA5B0F9848D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PublishingGroupingTemplate) for reliable querying. */
export type C___PublishingGroupingTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Publishing/_PublishingGroupingTemplate template (ID: {8BA7DAC6-32ED-4378-BD9E-5DA5B0F9848D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _PublishingGroupingTemplate) for reliable querying. */
export type C___PublishingGroupingTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingRelatedParameters) for reliable querying. */
export type C___RenderingRelatedParameters = Item & _RenderingRelatedParameters & {
  __typename?: 'C___RenderingRelatedParameters';
  /** AllowedRenderings (ID: {7DA92DDB-CD84-4284-826E-44A163E9A53F}). */
  allowedRenderings?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingRelatedParameters) for reliable querying. */
export type C___RenderingRelatedParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingRelatedParameters) for reliable querying. */
export type C___RenderingRelatedParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingRelatedParameters) for reliable querying. */
export type C___RenderingRelatedParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingRelatedParameters) for reliable querying. */
export type C___RenderingRelatedParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingRelatedParameters) for reliable querying. */
export type C___RenderingRelatedParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingRelatedParameters) for reliable querying. */
export type C___RenderingRelatedParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Rendering Variants Base template (ID: {EB94D770-9923-4A66-9C54-420566368FB2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingVariantsBase) for reliable querying. */
export type C___RenderingVariantsBase = Item & {
  __typename?: 'C___RenderingVariantsBase';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Rendering Variants Base template (ID: {EB94D770-9923-4A66-9C54-420566368FB2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingVariantsBase) for reliable querying. */
export type C___RenderingVariantsBaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Rendering Variants Base template (ID: {EB94D770-9923-4A66-9C54-420566368FB2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingVariantsBase) for reliable querying. */
export type C___RenderingVariantsBaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Rendering Variants Base template (ID: {EB94D770-9923-4A66-9C54-420566368FB2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingVariantsBase) for reliable querying. */
export type C___RenderingVariantsBaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Rendering Variants Base template (ID: {EB94D770-9923-4A66-9C54-420566368FB2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingVariantsBase) for reliable querying. */
export type C___RenderingVariantsBaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Rendering Variants Base template (ID: {EB94D770-9923-4A66-9C54-420566368FB2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingVariantsBase) for reliable querying. */
export type C___RenderingVariantsBaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Rendering Variants Base template (ID: {EB94D770-9923-4A66-9C54-420566368FB2}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingVariantsBase) for reliable querying. */
export type C___RenderingVariantsBaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingsList) for reliable querying. */
export type C___RenderingsList = Item & _RenderingsList & {
  __typename?: 'C___RenderingsList';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Renderings (ID: {715AE6C0-71C8-4744-AB4F-65362D20AD65}). */
  renderings?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingsList) for reliable querying. */
export type C___RenderingsListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingsList) for reliable querying. */
export type C___RenderingsListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingsList) for reliable querying. */
export type C___RenderingsListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingsList) for reliable querying. */
export type C___RenderingsListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingsList) for reliable querying. */
export type C___RenderingsListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RenderingsList) for reliable querying. */
export type C___RenderingsListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RobotsContent) for reliable querying. */
export type C___RobotsContent = Item & _RobotsContent & {
  __typename?: 'C___RobotsContent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RobotsContent) for reliable querying. */
export type C___RobotsContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RobotsContent) for reliable querying. */
export type C___RobotsContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RobotsContent) for reliable querying. */
export type C___RobotsContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RobotsContent) for reliable querying. */
export type C___RobotsContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RobotsContent) for reliable querying. */
export type C___RobotsContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RobotsContent) for reliable querying. */
export type C___RobotsContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleDomain) for reliable querying. */
export type C___RoleDomain = Item & _RoleDomain & {
  __typename?: 'C___RoleDomain';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleDomain) for reliable querying. */
export type C___RoleDomainAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleDomain) for reliable querying. */
export type C___RoleDomainChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleDomain) for reliable querying. */
export type C___RoleDomainFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleDomain) for reliable querying. */
export type C___RoleDomainFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleDomain) for reliable querying. */
export type C___RoleDomainHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleDomain) for reliable querying. */
export type C___RoleDomainIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleName) for reliable querying. */
export type C___RoleName = Item & _RoleName & {
  __typename?: 'C___RoleName';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleName (ID: {5382BFDE-8E39-4571-A1C5-EB3C43D5BCE3}). */
  roleName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleName) for reliable querying. */
export type C___RoleNameAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleName) for reliable querying. */
export type C___RoleNameChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleName) for reliable querying. */
export type C___RoleNameFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleName) for reliable querying. */
export type C___RoleNameFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleName) for reliable querying. */
export type C___RoleNameHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleName) for reliable querying. */
export type C___RoleNameIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleType) for reliable querying. */
export type C___RoleType = Item & _RoleType & {
  __typename?: 'C___RoleType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleType (ID: {6471939F-9E50-4512-9EB7-556594C5C728}). */
  roleType?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleType) for reliable querying. */
export type C___RoleTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleType) for reliable querying. */
export type C___RoleTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleType) for reliable querying. */
export type C___RoleTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleType) for reliable querying. */
export type C___RoleTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleType) for reliable querying. */
export type C___RoleTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _RoleType) for reliable querying. */
export type C___RoleTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceCommonValidations) for reliable querying. */
export type C___SalesforceCommonValidations = Item & _SalesforceCommonValidations & {
  __typename?: 'C___SalesforceCommonValidations';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceCommonValidations) for reliable querying. */
export type C___SalesforceCommonValidationsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceCommonValidations) for reliable querying. */
export type C___SalesforceCommonValidationsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceCommonValidations) for reliable querying. */
export type C___SalesforceCommonValidationsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceCommonValidations) for reliable querying. */
export type C___SalesforceCommonValidationsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceCommonValidations) for reliable querying. */
export type C___SalesforceCommonValidationsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceCommonValidations) for reliable querying. */
export type C___SalesforceCommonValidationsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldId) for reliable querying. */
export type C___SalesforceFieldId = Item & _SalesforceFieldId & {
  __typename?: 'C___SalesforceFieldId';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldId) for reliable querying. */
export type C___SalesforceFieldIdAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldId) for reliable querying. */
export type C___SalesforceFieldIdChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldId) for reliable querying. */
export type C___SalesforceFieldIdFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldId) for reliable querying. */
export type C___SalesforceFieldIdFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldId) for reliable querying. */
export type C___SalesforceFieldIdHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldId) for reliable querying. */
export type C___SalesforceFieldIdIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldTitle) for reliable querying. */
export type C___SalesforceFieldTitle = Item & _SalesforceFieldTitle & {
  __typename?: 'C___SalesforceFieldTitle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldTitle) for reliable querying. */
export type C___SalesforceFieldTitleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldTitle) for reliable querying. */
export type C___SalesforceFieldTitleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldTitle) for reliable querying. */
export type C___SalesforceFieldTitleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldTitle) for reliable querying. */
export type C___SalesforceFieldTitleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldTitle) for reliable querying. */
export type C___SalesforceFieldTitleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldTitle) for reliable querying. */
export type C___SalesforceFieldTitleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldValue) for reliable querying. */
export type C___SalesforceFieldValue = Item & _SalesforceFieldValue & {
  __typename?: 'C___SalesforceFieldValue';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceValue (ID: {1627FF3E-97E6-4133-99A3-1E2B62CBAD8A}). */
  salesforceValue?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldValue) for reliable querying. */
export type C___SalesforceFieldValueAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldValue) for reliable querying. */
export type C___SalesforceFieldValueChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldValue) for reliable querying. */
export type C___SalesforceFieldValueFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldValue) for reliable querying. */
export type C___SalesforceFieldValueFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldValue) for reliable querying. */
export type C___SalesforceFieldValueHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SalesforceFieldValue) for reliable querying. */
export type C___SalesforceFieldValueIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Script) for reliable querying. */
export type C___Script = Item & _Script & {
  __typename?: 'C___Script';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Script) for reliable querying. */
export type C___ScriptAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Script) for reliable querying. */
export type C___ScriptChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Script) for reliable querying. */
export type C___ScriptFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Script) for reliable querying. */
export type C___ScriptFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Script) for reliable querying. */
export type C___ScriptHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Script) for reliable querying. */
export type C___ScriptIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SearchSignature) for reliable querying. */
export type C___SearchSignature = Item & _SearchSignature & {
  __typename?: 'C___SearchSignature';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SearchSignature) for reliable querying. */
export type C___SearchSignatureAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SearchSignature) for reliable querying. */
export type C___SearchSignatureChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SearchSignature) for reliable querying. */
export type C___SearchSignatureFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SearchSignature) for reliable querying. */
export type C___SearchSignatureFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SearchSignature) for reliable querying. */
export type C___SearchSignatureHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SearchSignature) for reliable querying. */
export type C___SearchSignatureIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Searchable template (ID: {E94D0466-BC9A-47AA-B0B0-1D626B10BFD6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Searchable) for reliable querying. */
export type C___Searchable = Item & {
  __typename?: 'C___Searchable';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Searchable template (ID: {E94D0466-BC9A-47AA-B0B0-1D626B10BFD6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Searchable) for reliable querying. */
export type C___SearchableAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Searchable template (ID: {E94D0466-BC9A-47AA-B0B0-1D626B10BFD6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Searchable) for reliable querying. */
export type C___SearchableChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Searchable template (ID: {E94D0466-BC9A-47AA-B0B0-1D626B10BFD6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Searchable) for reliable querying. */
export type C___SearchableFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Searchable template (ID: {E94D0466-BC9A-47AA-B0B0-1D626B10BFD6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Searchable) for reliable querying. */
export type C___SearchableFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Searchable template (ID: {E94D0466-BC9A-47AA-B0B0-1D626B10BFD6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Searchable) for reliable querying. */
export type C___SearchableHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Searchable template (ID: {E94D0466-BC9A-47AA-B0B0-1D626B10BFD6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Searchable) for reliable querying. */
export type C___SearchableIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SecurityItemPointer) for reliable querying. */
export type C___SecurityItemPointer = Item & _SecurityItemPointer & {
  __typename?: 'C___SecurityItemPointer';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {BBC2E73A-DE40-493B-9320-86D66D024AAF}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SecurityItemPointer) for reliable querying. */
export type C___SecurityItemPointerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SecurityItemPointer) for reliable querying. */
export type C___SecurityItemPointerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SecurityItemPointer) for reliable querying. */
export type C___SecurityItemPointerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SecurityItemPointer) for reliable querying. */
export type C___SecurityItemPointerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SecurityItemPointer) for reliable querying. */
export type C___SecurityItemPointerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SecurityItemPointer) for reliable querying. */
export type C___SecurityItemPointerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedArticles template (ID: {5C991FB9-31EA-47DA-AE07-B5A36621CD59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedArticles) for reliable querying. */
export type C___SharedArticles = Item & {
  __typename?: 'C___SharedArticles';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedArticles template (ID: {5C991FB9-31EA-47DA-AE07-B5A36621CD59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedArticles) for reliable querying. */
export type C___SharedArticlesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedArticles template (ID: {5C991FB9-31EA-47DA-AE07-B5A36621CD59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedArticles) for reliable querying. */
export type C___SharedArticlesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedArticles template (ID: {5C991FB9-31EA-47DA-AE07-B5A36621CD59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedArticles) for reliable querying. */
export type C___SharedArticlesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedArticles template (ID: {5C991FB9-31EA-47DA-AE07-B5A36621CD59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedArticles) for reliable querying. */
export type C___SharedArticlesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedArticles template (ID: {5C991FB9-31EA-47DA-AE07-B5A36621CD59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedArticles) for reliable querying. */
export type C___SharedArticlesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedArticles template (ID: {5C991FB9-31EA-47DA-AE07-B5A36621CD59}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedArticles) for reliable querying. */
export type C___SharedArticlesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedContent template (ID: {D06DBC6F-0467-4681-B950-24BA11658457}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedContent) for reliable querying. */
export type C___SharedContent = Item & {
  __typename?: 'C___SharedContent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedContent template (ID: {D06DBC6F-0467-4681-B950-24BA11658457}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedContent) for reliable querying. */
export type C___SharedContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedContent template (ID: {D06DBC6F-0467-4681-B950-24BA11658457}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedContent) for reliable querying. */
export type C___SharedContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedContent template (ID: {D06DBC6F-0467-4681-B950-24BA11658457}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedContent) for reliable querying. */
export type C___SharedContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedContent template (ID: {D06DBC6F-0467-4681-B950-24BA11658457}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedContent) for reliable querying. */
export type C___SharedContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedContent template (ID: {D06DBC6F-0467-4681-B950-24BA11658457}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedContent) for reliable querying. */
export type C___SharedContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedContent template (ID: {D06DBC6F-0467-4681-B950-24BA11658457}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedContent) for reliable querying. */
export type C___SharedContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedHelpArticles template (ID: {AC82C6EF-4120-43AF-8B37-D06674C58162}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedHelpArticles) for reliable querying. */
export type C___SharedHelpArticles = Item & {
  __typename?: 'C___SharedHelpArticles';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedHelpArticles template (ID: {AC82C6EF-4120-43AF-8B37-D06674C58162}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedHelpArticles) for reliable querying. */
export type C___SharedHelpArticlesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedHelpArticles template (ID: {AC82C6EF-4120-43AF-8B37-D06674C58162}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedHelpArticles) for reliable querying. */
export type C___SharedHelpArticlesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedHelpArticles template (ID: {AC82C6EF-4120-43AF-8B37-D06674C58162}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedHelpArticles) for reliable querying. */
export type C___SharedHelpArticlesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedHelpArticles template (ID: {AC82C6EF-4120-43AF-8B37-D06674C58162}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedHelpArticles) for reliable querying. */
export type C___SharedHelpArticlesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedHelpArticles template (ID: {AC82C6EF-4120-43AF-8B37-D06674C58162}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedHelpArticles) for reliable querying. */
export type C___SharedHelpArticlesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedHelpArticles template (ID: {AC82C6EF-4120-43AF-8B37-D06674C58162}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedHelpArticles) for reliable querying. */
export type C___SharedHelpArticlesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPage) for reliable querying. */
export type C___SharedPage = Item & _SharedPage & {
  __typename?: 'C___SharedPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPage) for reliable querying. */
export type C___SharedPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPage) for reliable querying. */
export type C___SharedPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPage) for reliable querying. */
export type C___SharedPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPage) for reliable querying. */
export type C___SharedPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPage) for reliable querying. */
export type C___SharedPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPage) for reliable querying. */
export type C___SharedPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedPressReleases template (ID: {1B201301-01EF-4BD4-B03C-35C2E43D4C6C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPressReleases) for reliable querying. */
export type C___SharedPressReleases = Item & {
  __typename?: 'C___SharedPressReleases';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedPressReleases template (ID: {1B201301-01EF-4BD4-B03C-35C2E43D4C6C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPressReleases) for reliable querying. */
export type C___SharedPressReleasesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedPressReleases template (ID: {1B201301-01EF-4BD4-B03C-35C2E43D4C6C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPressReleases) for reliable querying. */
export type C___SharedPressReleasesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedPressReleases template (ID: {1B201301-01EF-4BD4-B03C-35C2E43D4C6C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPressReleases) for reliable querying. */
export type C___SharedPressReleasesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedPressReleases template (ID: {1B201301-01EF-4BD4-B03C-35C2E43D4C6C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPressReleases) for reliable querying. */
export type C___SharedPressReleasesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedPressReleases template (ID: {1B201301-01EF-4BD4-B03C-35C2E43D4C6C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPressReleases) for reliable querying. */
export type C___SharedPressReleasesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedPressReleases template (ID: {1B201301-01EF-4BD4-B03C-35C2E43D4C6C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedPressReleases) for reliable querying. */
export type C___SharedPressReleasesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedRoot) for reliable querying. */
export type C___SharedRoot = Item & _SharedRoot & {
  __typename?: 'C___SharedRoot';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedRoot) for reliable querying. */
export type C___SharedRootAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedRoot) for reliable querying. */
export type C___SharedRootChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedRoot) for reliable querying. */
export type C___SharedRootFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedRoot) for reliable querying. */
export type C___SharedRootFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedRoot) for reliable querying. */
export type C___SharedRootHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedRoot) for reliable querying. */
export type C___SharedRootIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedSettings template (ID: {8DE75545-73B2-4DBC-B5B3-A8B11CD83CE7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedSettings) for reliable querying. */
export type C___SharedSettings = Item & {
  __typename?: 'C___SharedSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedSettings template (ID: {8DE75545-73B2-4DBC-B5B3-A8B11CD83CE7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedSettings) for reliable querying. */
export type C___SharedSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedSettings template (ID: {8DE75545-73B2-4DBC-B5B3-A8B11CD83CE7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedSettings) for reliable querying. */
export type C___SharedSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedSettings template (ID: {8DE75545-73B2-4DBC-B5B3-A8B11CD83CE7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedSettings) for reliable querying. */
export type C___SharedSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedSettings template (ID: {8DE75545-73B2-4DBC-B5B3-A8B11CD83CE7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedSettings) for reliable querying. */
export type C___SharedSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedSettings template (ID: {8DE75545-73B2-4DBC-B5B3-A8B11CD83CE7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedSettings) for reliable querying. */
export type C___SharedSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SharedSettings template (ID: {8DE75545-73B2-4DBC-B5B3-A8B11CD83CE7}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SharedSettings) for reliable querying. */
export type C___SharedSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteContent template (ID: {355AF077-F8AD-4E29-AAE9-6AAA3CE1A342}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteContent) for reliable querying. */
export type C___SiteContent = Item & {
  __typename?: 'C___SiteContent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteContent template (ID: {355AF077-F8AD-4E29-AAE9-6AAA3CE1A342}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteContent) for reliable querying. */
export type C___SiteContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteContent template (ID: {355AF077-F8AD-4E29-AAE9-6AAA3CE1A342}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteContent) for reliable querying. */
export type C___SiteContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteContent template (ID: {355AF077-F8AD-4E29-AAE9-6AAA3CE1A342}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteContent) for reliable querying. */
export type C___SiteContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteContent template (ID: {355AF077-F8AD-4E29-AAE9-6AAA3CE1A342}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteContent) for reliable querying. */
export type C___SiteContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteContent template (ID: {355AF077-F8AD-4E29-AAE9-6AAA3CE1A342}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteContent) for reliable querying. */
export type C___SiteContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteContent template (ID: {355AF077-F8AD-4E29-AAE9-6AAA3CE1A342}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteContent) for reliable querying. */
export type C___SiteContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteFolder template (ID: {692055EB-2EB6-4C5F-AF5A-75C77B620708}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteFolder) for reliable querying. */
export type C___SiteFolder = Item & {
  __typename?: 'C___SiteFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteFolder template (ID: {692055EB-2EB6-4C5F-AF5A-75C77B620708}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteFolder) for reliable querying. */
export type C___SiteFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteFolder template (ID: {692055EB-2EB6-4C5F-AF5A-75C77B620708}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteFolder) for reliable querying. */
export type C___SiteFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteFolder template (ID: {692055EB-2EB6-4C5F-AF5A-75C77B620708}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteFolder) for reliable querying. */
export type C___SiteFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteFolder template (ID: {692055EB-2EB6-4C5F-AF5A-75C77B620708}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteFolder) for reliable querying. */
export type C___SiteFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteFolder template (ID: {692055EB-2EB6-4C5F-AF5A-75C77B620708}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteFolder) for reliable querying. */
export type C___SiteFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteFolder template (ID: {692055EB-2EB6-4C5F-AF5A-75C77B620708}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteFolder) for reliable querying. */
export type C___SiteFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteMediaLibrary) for reliable querying. */
export type C___SiteMediaLibrary = Item & _SiteMediaLibrary & {
  __typename?: 'C___SiteMediaLibrary';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteMediaLibrary) for reliable querying. */
export type C___SiteMediaLibraryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteMediaLibrary) for reliable querying. */
export type C___SiteMediaLibraryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteMediaLibrary) for reliable querying. */
export type C___SiteMediaLibraryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteMediaLibrary) for reliable querying. */
export type C___SiteMediaLibraryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteMediaLibrary) for reliable querying. */
export type C___SiteMediaLibraryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteMediaLibrary) for reliable querying. */
export type C___SiteMediaLibraryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteSettings template (ID: {5DCF5A88-B923-4BEC-83A4-B90F47DBB165}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteSettings) for reliable querying. */
export type C___SiteSettings = Item & {
  __typename?: 'C___SiteSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteSettings template (ID: {5DCF5A88-B923-4BEC-83A4-B90F47DBB165}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteSettings) for reliable querying. */
export type C___SiteSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteSettings template (ID: {5DCF5A88-B923-4BEC-83A4-B90F47DBB165}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteSettings) for reliable querying. */
export type C___SiteSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteSettings template (ID: {5DCF5A88-B923-4BEC-83A4-B90F47DBB165}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteSettings) for reliable querying. */
export type C___SiteSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteSettings template (ID: {5DCF5A88-B923-4BEC-83A4-B90F47DBB165}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteSettings) for reliable querying. */
export type C___SiteSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteSettings template (ID: {5DCF5A88-B923-4BEC-83A4-B90F47DBB165}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteSettings) for reliable querying. */
export type C___SiteSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_SiteSettings template (ID: {5DCF5A88-B923-4BEC-83A4-B90F47DBB165}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteSettings) for reliable querying. */
export type C___SiteSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteTemplate) for reliable querying. */
export type C___SiteTemplate = Item & _SiteTemplate & {
  __typename?: 'C___SiteTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteTemplate) for reliable querying. */
export type C___SiteTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteTemplate) for reliable querying. */
export type C___SiteTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteTemplate) for reliable querying. */
export type C___SiteTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteTemplate) for reliable querying. */
export type C___SiteTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteTemplate) for reliable querying. */
export type C___SiteTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SiteTemplate) for reliable querying. */
export type C___SiteTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Sitecore Client Site Managing template (ID: {0E1B455F-4354-4874-BE54-72F84E55F3A8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitecoreClientSiteManaging) for reliable querying. */
export type C___SitecoreClientSiteManaging = Item & {
  __typename?: 'C___SitecoreClientSiteManaging';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Sitecore Client Site Managing template (ID: {0E1B455F-4354-4874-BE54-72F84E55F3A8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitecoreClientSiteManaging) for reliable querying. */
export type C___SitecoreClientSiteManagingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Sitecore Client Site Managing template (ID: {0E1B455F-4354-4874-BE54-72F84E55F3A8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitecoreClientSiteManaging) for reliable querying. */
export type C___SitecoreClientSiteManagingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Sitecore Client Site Managing template (ID: {0E1B455F-4354-4874-BE54-72F84E55F3A8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitecoreClientSiteManaging) for reliable querying. */
export type C___SitecoreClientSiteManagingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Sitecore Client Site Managing template (ID: {0E1B455F-4354-4874-BE54-72F84E55F3A8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitecoreClientSiteManaging) for reliable querying. */
export type C___SitecoreClientSiteManagingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Sitecore Client Site Managing template (ID: {0E1B455F-4354-4874-BE54-72F84E55F3A8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitecoreClientSiteManaging) for reliable querying. */
export type C___SitecoreClientSiteManagingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Sitecore Client Site Managing template (ID: {0E1B455F-4354-4874-BE54-72F84E55F3A8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitecoreClientSiteManaging) for reliable querying. */
export type C___SitecoreClientSiteManagingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Sitemap) for reliable querying. */
export type C___Sitemap = Item & _Sitemap & {
  __typename?: 'C___Sitemap';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Sitemap) for reliable querying. */
export type C___SitemapAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Sitemap) for reliable querying. */
export type C___SitemapChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Sitemap) for reliable querying. */
export type C___SitemapFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Sitemap) for reliable querying. */
export type C___SitemapFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Sitemap) for reliable querying. */
export type C___SitemapHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Sitemap) for reliable querying. */
export type C___SitemapIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitemapMediaItems) for reliable querying. */
export type C___SitemapMediaItems = Item & _SitemapMediaItems & {
  __typename?: 'C___SitemapMediaItems';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitemapMediaItems) for reliable querying. */
export type C___SitemapMediaItemsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitemapMediaItems) for reliable querying. */
export type C___SitemapMediaItemsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitemapMediaItems) for reliable querying. */
export type C___SitemapMediaItemsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitemapMediaItems) for reliable querying. */
export type C___SitemapMediaItemsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitemapMediaItems) for reliable querying. */
export type C___SitemapMediaItemsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SitemapMediaItems) for reliable querying. */
export type C___SitemapMediaItemsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SlidersRangeSettings) for reliable querying. */
export type C___SlidersRangeSettings = Item & _SlidersRangeSettings & {
  __typename?: 'C___SlidersRangeSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** ShowRangeIndicators (ID: {10D0D449-2D0B-440D-92D8-DD9237C7E36B}). */
  showRangeIndicators?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SlidersRangeSettings) for reliable querying. */
export type C___SlidersRangeSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SlidersRangeSettings) for reliable querying. */
export type C___SlidersRangeSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SlidersRangeSettings) for reliable querying. */
export type C___SlidersRangeSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SlidersRangeSettings) for reliable querying. */
export type C___SlidersRangeSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SlidersRangeSettings) for reliable querying. */
export type C___SlidersRangeSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SlidersRangeSettings) for reliable querying. */
export type C___SlidersRangeSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateContent) for reliable querying. */
export type C___SolutionTemplateContent = Item & _SolutionTemplateContent & {
  __typename?: 'C___SolutionTemplateContent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {DA855368-E5F2-4932-AE55-7F8B08A5A205}). */
  content?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateContent) for reliable querying. */
export type C___SolutionTemplateContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateContent) for reliable querying. */
export type C___SolutionTemplateContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateContent) for reliable querying. */
export type C___SolutionTemplateContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateContent) for reliable querying. */
export type C___SolutionTemplateContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateContent) for reliable querying. */
export type C___SolutionTemplateContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateContent) for reliable querying. */
export type C___SolutionTemplateContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateDescription) for reliable querying. */
export type C___SolutionTemplateDescription = Item & _SolutionTemplateDescription & {
  __typename?: 'C___SolutionTemplateDescription';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {9F437E68-A84D-48AE-8CE1-A3E26C0B5E64}). */
  description_9f437e68a84d48ae8ce1a3e26c0b5e64?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateDescription) for reliable querying. */
export type C___SolutionTemplateDescriptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateDescription) for reliable querying. */
export type C___SolutionTemplateDescriptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateDescription) for reliable querying. */
export type C___SolutionTemplateDescriptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateDescription) for reliable querying. */
export type C___SolutionTemplateDescriptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateDescription) for reliable querying. */
export type C___SolutionTemplateDescriptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateDescription) for reliable querying. */
export type C___SolutionTemplateDescriptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateName) for reliable querying. */
export type C___SolutionTemplateName = Item & _SolutionTemplateName & {
  __typename?: 'C___SolutionTemplateName';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {82E64B52-0B8A-4A38-8C78-530C5493814E}). */
  name_82e64b520b8a4a388c78530c5493814e?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateName) for reliable querying. */
export type C___SolutionTemplateNameAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateName) for reliable querying. */
export type C___SolutionTemplateNameChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateName) for reliable querying. */
export type C___SolutionTemplateNameFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateName) for reliable querying. */
export type C___SolutionTemplateNameFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateName) for reliable querying. */
export type C___SolutionTemplateNameHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SolutionTemplateName) for reliable querying. */
export type C___SolutionTemplateNameIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SortOrder) for reliable querying. */
export type C___SortOrder = Item & _SortOrder & {
  __typename?: 'C___SortOrder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SortOrder (ID: {91ED9872-2007-47E9-BF01-1292C1B261B2}). */
  sortOrder?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SortOrder) for reliable querying. */
export type C___SortOrderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SortOrder) for reliable querying. */
export type C___SortOrderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SortOrder) for reliable querying. */
export type C___SortOrderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SortOrder) for reliable querying. */
export type C___SortOrderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SortOrder) for reliable querying. */
export type C___SortOrderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SortOrder) for reliable querying. */
export type C___SortOrderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _StackBreakpoint) for reliable querying. */
export type C___StackBreakpoint = Item & _StackBreakpoint & {
  __typename?: 'C___StackBreakpoint';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** StackAtBreakpoint (ID: {8CBC1CDD-5F1F-4187-B3B0-D81DB7CA675C}). */
  stackAtBreakpoint?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _StackBreakpoint) for reliable querying. */
export type C___StackBreakpointAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _StackBreakpoint) for reliable querying. */
export type C___StackBreakpointChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _StackBreakpoint) for reliable querying. */
export type C___StackBreakpointFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _StackBreakpoint) for reliable querying. */
export type C___StackBreakpointFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _StackBreakpoint) for reliable querying. */
export type C___StackBreakpointHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _StackBreakpoint) for reliable querying. */
export type C___StackBreakpointIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/_Statistics template (ID: {3F7E3457-F3E7-4E4A-B99C-87D96BCBF01A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Statistics) for reliable querying. */
export type C___Statistics = Item & {
  __typename?: 'C___Statistics';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_Statistics template (ID: {3F7E3457-F3E7-4E4A-B99C-87D96BCBF01A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Statistics) for reliable querying. */
export type C___StatisticsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_Statistics template (ID: {3F7E3457-F3E7-4E4A-B99C-87D96BCBF01A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Statistics) for reliable querying. */
export type C___StatisticsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_Statistics template (ID: {3F7E3457-F3E7-4E4A-B99C-87D96BCBF01A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Statistics) for reliable querying. */
export type C___StatisticsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_Statistics template (ID: {3F7E3457-F3E7-4E4A-B99C-87D96BCBF01A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Statistics) for reliable querying. */
export type C___StatisticsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_Statistics template (ID: {3F7E3457-F3E7-4E4A-B99C-87D96BCBF01A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Statistics) for reliable querying. */
export type C___StatisticsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/JSS/_Statistics template (ID: {3F7E3457-F3E7-4E4A-B99C-87D96BCBF01A}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Statistics) for reliable querying. */
export type C___StatisticsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SupportedLanguages) for reliable querying. */
export type C___SupportedLanguages = Item & _SupportedLanguages & {
  __typename?: 'C___SupportedLanguages';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SupportedLanguages) for reliable querying. */
export type C___SupportedLanguagesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SupportedLanguages) for reliable querying. */
export type C___SupportedLanguagesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SupportedLanguages) for reliable querying. */
export type C___SupportedLanguagesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SupportedLanguages) for reliable querying. */
export type C___SupportedLanguagesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SupportedLanguages) for reliable querying. */
export type C___SupportedLanguagesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _SupportedLanguages) for reliable querying. */
export type C___SupportedLanguagesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Taggable) for reliable querying. */
export type C___Taggable = Item & _Taggable & {
  __typename?: 'C___Taggable';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Taggable) for reliable querying. */
export type C___TaggableAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Taggable) for reliable querying. */
export type C___TaggableChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Taggable) for reliable querying. */
export type C___TaggableFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Taggable) for reliable querying. */
export type C___TaggableFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Taggable) for reliable querying. */
export type C___TaggableHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Taggable) for reliable querying. */
export type C___TaggableIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersParentPage template (ID: {4C8B2453-FA84-494C-B635-FD0A46079A46}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersParentPage) for reliable querying. */
export type C___TeamMembersParentPage = Item & {
  __typename?: 'C___TeamMembersParentPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersParentPage template (ID: {4C8B2453-FA84-494C-B635-FD0A46079A46}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersParentPage) for reliable querying. */
export type C___TeamMembersParentPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersParentPage template (ID: {4C8B2453-FA84-494C-B635-FD0A46079A46}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersParentPage) for reliable querying. */
export type C___TeamMembersParentPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersParentPage template (ID: {4C8B2453-FA84-494C-B635-FD0A46079A46}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersParentPage) for reliable querying. */
export type C___TeamMembersParentPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersParentPage template (ID: {4C8B2453-FA84-494C-B635-FD0A46079A46}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersParentPage) for reliable querying. */
export type C___TeamMembersParentPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersParentPage template (ID: {4C8B2453-FA84-494C-B635-FD0A46079A46}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersParentPage) for reliable querying. */
export type C___TeamMembersParentPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersParentPage template (ID: {4C8B2453-FA84-494C-B635-FD0A46079A46}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersParentPage) for reliable querying. */
export type C___TeamMembersParentPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersWildcard template (ID: {DD049195-E012-434C-9058-390F21F8F944}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersWildcard) for reliable querying. */
export type C___TeamMembersWildcard = Item & {
  __typename?: 'C___TeamMembersWildcard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersWildcard template (ID: {DD049195-E012-434C-9058-390F21F8F944}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersWildcard) for reliable querying. */
export type C___TeamMembersWildcardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersWildcard template (ID: {DD049195-E012-434C-9058-390F21F8F944}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersWildcard) for reliable querying. */
export type C___TeamMembersWildcardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersWildcard template (ID: {DD049195-E012-434C-9058-390F21F8F944}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersWildcard) for reliable querying. */
export type C___TeamMembersWildcardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersWildcard template (ID: {DD049195-E012-434C-9058-390F21F8F944}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersWildcard) for reliable querying. */
export type C___TeamMembersWildcardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersWildcard template (ID: {DD049195-E012-434C-9058-390F21F8F944}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersWildcard) for reliable querying. */
export type C___TeamMembersWildcardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_TeamMembersWildcard template (ID: {DD049195-E012-434C-9058-390F21F8F944}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TeamMembersWildcard) for reliable querying. */
export type C___TeamMembersWildcardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TechzoneArticle) for reliable querying. */
export type C___TechzoneArticle = Item & _BaseArticle & _ContentType & _ExternalArticle & _LimitedDisplay & _SharedPage & _TechzoneArticle & {
  __typename?: 'C___TechzoneArticle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** articleUrl (ID: {03D20238-CFFC-4238-AB29-21DB4996DABF}). */
  articleUrl?: Maybe<LinkField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TechzoneArticle) for reliable querying. */
export type C___TechzoneArticleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TechzoneArticle) for reliable querying. */
export type C___TechzoneArticleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TechzoneArticle) for reliable querying. */
export type C___TechzoneArticleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TechzoneArticle) for reliable querying. */
export type C___TechzoneArticleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TechzoneArticle) for reliable querying. */
export type C___TechzoneArticleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _TechzoneArticle) for reliable querying. */
export type C___TechzoneArticleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Template) for reliable querying. */
export type C___Template = Item & _Template & {
  __typename?: 'C___Template';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {E62C28F0-9D3B-46E2-8BEC-A5E120542499}). */
  template_e62c28f09d3b46e28beca5e120542499?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Template) for reliable querying. */
export type C___TemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Template) for reliable querying. */
export type C___TemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Template) for reliable querying. */
export type C___TemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Template) for reliable querying. */
export type C___TemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Template) for reliable querying. */
export type C___TemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Template) for reliable querying. */
export type C___TemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Title) for reliable querying. */
export type C___Title = Item & _Title & {
  __typename?: 'C___Title';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {1AB993C6-6E09-4367-AAF2-9372B017910B}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Title) for reliable querying. */
export type C___TitleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Title) for reliable querying. */
export type C___TitleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Title) for reliable querying. */
export type C___TitleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Title) for reliable querying. */
export type C___TitleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Title) for reliable querying. */
export type C___TitleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Title) for reliable querying. */
export type C___TitleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Type) for reliable querying. */
export type C___Type = Item & _Type & {
  __typename?: 'C___Type';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {654618D7-A288-44A2-BFA8-A9E1CCB4EFB8}). */
  type?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Type) for reliable querying. */
export type C___TypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Type) for reliable querying. */
export type C___TypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Type) for reliable querying. */
export type C___TypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Type) for reliable querying. */
export type C___TypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Type) for reliable querying. */
export type C___TypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Type) for reliable querying. */
export type C___TypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Validation) for reliable querying. */
export type C___Validation = Item & _Validation & {
  __typename?: 'C___Validation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Validation) for reliable querying. */
export type C___ValidationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Validation) for reliable querying. */
export type C___ValidationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Validation) for reliable querying. */
export type C___ValidationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Validation) for reliable querying. */
export type C___ValidationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Validation) for reliable querying. */
export type C___ValidationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Validation) for reliable querying. */
export type C___ValidationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VariantPaging) for reliable querying. */
export type C___VariantPaging = Item & _VariantPaging & {
  __typename?: 'C___VariantPaging';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NumberOfResultsToSkip (ID: {AE6DB294-8D8B-45BE-919C-1143867BC03D}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VariantPaging) for reliable querying. */
export type C___VariantPagingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VariantPaging) for reliable querying. */
export type C___VariantPagingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VariantPaging) for reliable querying. */
export type C___VariantPagingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VariantPaging) for reliable querying. */
export type C___VariantPagingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VariantPaging) for reliable querying. */
export type C___VariantPagingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VariantPaging) for reliable querying. */
export type C___VariantPagingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTile template (ID: {4EC903EE-9134-4C64-A7F2-3B2C57DA89E8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTile) for reliable querying. */
export type C___VectorTile = Item & {
  __typename?: 'C___VectorTile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTile template (ID: {4EC903EE-9134-4C64-A7F2-3B2C57DA89E8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTile) for reliable querying. */
export type C___VectorTileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTile template (ID: {4EC903EE-9134-4C64-A7F2-3B2C57DA89E8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTile) for reliable querying. */
export type C___VectorTileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTile template (ID: {4EC903EE-9134-4C64-A7F2-3B2C57DA89E8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTile) for reliable querying. */
export type C___VectorTileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTile template (ID: {4EC903EE-9134-4C64-A7F2-3B2C57DA89E8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTile) for reliable querying. */
export type C___VectorTileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTile template (ID: {4EC903EE-9134-4C64-A7F2-3B2C57DA89E8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTile) for reliable querying. */
export type C___VectorTileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTile template (ID: {4EC903EE-9134-4C64-A7F2-3B2C57DA89E8}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTile) for reliable querying. */
export type C___VectorTileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTileLink template (ID: {87F32B74-8E0E-48E3-A302-FB01D85A67D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTileLink) for reliable querying. */
export type C___VectorTileLink = Item & {
  __typename?: 'C___VectorTileLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTileLink template (ID: {87F32B74-8E0E-48E3-A302-FB01D85A67D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTileLink) for reliable querying. */
export type C___VectorTileLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTileLink template (ID: {87F32B74-8E0E-48E3-A302-FB01D85A67D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTileLink) for reliable querying. */
export type C___VectorTileLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTileLink template (ID: {87F32B74-8E0E-48E3-A302-FB01D85A67D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTileLink) for reliable querying. */
export type C___VectorTileLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTileLink template (ID: {87F32B74-8E0E-48E3-A302-FB01D85A67D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTileLink) for reliable querying. */
export type C___VectorTileLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTileLink template (ID: {87F32B74-8E0E-48E3-A302-FB01D85A67D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTileLink) for reliable querying. */
export type C___VectorTileLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/_VectorTileLink template (ID: {87F32B74-8E0E-48E3-A302-FB01D85A67D6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VectorTileLink) for reliable querying. */
export type C___VectorTileLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Video) for reliable querying. */
export type C___Video = Item & _BaseArticle & _ContentType & _InternalArticle & _LimitedDisplay & _PremiumContentPage & _SharedPage & _Video & {
  __typename?: 'C___Video';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {3FA832A3-1006-48DB-85DD-58A9926C49E0}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Video) for reliable querying. */
export type C___VideoAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Video) for reliable querying. */
export type C___VideoChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Video) for reliable querying. */
export type C___VideoFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Video) for reliable querying. */
export type C___VideoFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Video) for reliable querying. */
export type C___VideoHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Video) for reliable querying. */
export type C___VideoIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VideoPressRelease) for reliable querying. */
export type C___VideoPressRelease = Item & _BasePressRelease & _PressReleaseContentType & _SharedPage & _VideoPressRelease & {
  __typename?: 'C___VideoPressRelease';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {809C7EAF-5258-4877-A44C-4FE3A4629C7E}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VideoPressRelease) for reliable querying. */
export type C___VideoPressReleaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VideoPressRelease) for reliable querying. */
export type C___VideoPressReleaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VideoPressRelease) for reliable querying. */
export type C___VideoPressReleaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VideoPressRelease) for reliable querying. */
export type C___VideoPressReleaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VideoPressRelease) for reliable querying. */
export type C___VideoPressReleaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _VideoPressRelease) for reliable querying. */
export type C___VideoPressReleaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Width) for reliable querying. */
export type C___Width = Item & _Width & {
  __typename?: 'C___Width';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Width (ID: {01C5C169-867F-4A45-A8A3-891A3B13B39A}). */
  width?: Maybe<NumberField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Width) for reliable querying. */
export type C___WidthAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Width) for reliable querying. */
export type C___WidthChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Width) for reliable querying. */
export type C___WidthFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Width) for reliable querying. */
export type C___WidthFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Width) for reliable querying. */
export type C___WidthHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _Width) for reliable querying. */
export type C___WidthIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardPage template (ID: {9FF3DEF3-16C8-43D4-BBA1-BBBB97F1AE3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _WildcardPage) for reliable querying. */
export type C___WildcardPage = Item & {
  __typename?: 'C___WildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardPage template (ID: {9FF3DEF3-16C8-43D4-BBA1-BBBB97F1AE3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _WildcardPage) for reliable querying. */
export type C___WildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardPage template (ID: {9FF3DEF3-16C8-43D4-BBA1-BBBB97F1AE3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _WildcardPage) for reliable querying. */
export type C___WildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardPage template (ID: {9FF3DEF3-16C8-43D4-BBA1-BBBB97F1AE3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _WildcardPage) for reliable querying. */
export type C___WildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardPage template (ID: {9FF3DEF3-16C8-43D4-BBA1-BBBB97F1AE3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _WildcardPage) for reliable querying. */
export type C___WildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardPage template (ID: {9FF3DEF3-16C8-43D4-BBA1-BBBB97F1AE3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _WildcardPage) for reliable querying. */
export type C___WildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardPage template (ID: {9FF3DEF3-16C8-43D4-BBA1-BBBB97F1AE3F}). NOTE: This is a concrete type. Favor using interfaces instead of this type (e.g. _WildcardPage) for reliable querying. */
export type C___WildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/CacheSetting template (ID: {E24DE305-C60F-47D1-97C0-DE121D6831D0}). */
export type CacheSetting = Caching & Item & {
  __typename?: 'CacheSetting';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CacheClearingBehavior (ID: {A6D4FC1D-0803-4E0A-9145-B8C6121D6F26}). */
  cacheClearingBehavior?: Maybe<TextField>;
  /** Cacheable (ID: {3D08DB46-2267-41B0-BC52-BE69FD618633}). */
  cacheable?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ClearOnIndexUpdate (ID: {F3E7E552-D7C8-469B-A150-69E4E14AB35C}). */
  clearOnIndexUpdate?: Maybe<CheckboxField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rendering (ID: {E4451EAF-DBFD-4D31-A525-6B42F236289D}). */
  rendering?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** VaryByData (ID: {8B6D532B-6128-4486-A044-CA06D90948BA}). */
  varyByData?: Maybe<CheckboxField>;
  /** VaryByDevice (ID: {C98CF969-BA71-42DA-833D-B3FC1368BA27}). */
  varyByDevice?: Maybe<CheckboxField>;
  /** VaryByLogin (ID: {8D9232B0-613F-440B-A2FA-DCDD80FBD33E}). */
  varyByLogin?: Maybe<CheckboxField>;
  /** VaryByParm (ID: {3AD2506A-DC39-4B1E-959F-9D524ADDBF50}). */
  varyByParm?: Maybe<CheckboxField>;
  /** VaryByQueryString (ID: {1084D3D2-0457-456A-ABBC-EB4CC0966072}). */
  varyByQueryString?: Maybe<CheckboxField>;
  /** VaryByUser (ID: {0E54A8DC-72AD-4372-A7C7-BB4773FAD44D}). */
  varyByUser?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/CacheSetting template (ID: {E24DE305-C60F-47D1-97C0-DE121D6831D0}). */
export type CacheSettingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/CacheSetting template (ID: {E24DE305-C60F-47D1-97C0-DE121D6831D0}). */
export type CacheSettingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/CacheSetting template (ID: {E24DE305-C60F-47D1-97C0-DE121D6831D0}). */
export type CacheSettingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/CacheSetting template (ID: {E24DE305-C60F-47D1-97C0-DE121D6831D0}). */
export type CacheSettingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/CacheSetting template (ID: {E24DE305-C60F-47D1-97C0-DE121D6831D0}). */
export type CacheSettingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/CacheSetting template (ID: {E24DE305-C60F-47D1-97C0-DE121D6831D0}). */
export type CacheSettingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Layout/Sections/Caching template (ID: {E8D2DD19-1347-4562-AE3F-310DC0B21A6C}). */
export type Caching = {
  /** CacheClearingBehavior (ID: {A6D4FC1D-0803-4E0A-9145-B8C6121D6F26}). */
  cacheClearingBehavior?: Maybe<TextField>;
  /** Cacheable (ID: {3D08DB46-2267-41B0-BC52-BE69FD618633}). */
  cacheable?: Maybe<CheckboxField>;
  /** ClearOnIndexUpdate (ID: {F3E7E552-D7C8-469B-A150-69E4E14AB35C}). */
  clearOnIndexUpdate?: Maybe<CheckboxField>;
  /** VaryByData (ID: {8B6D532B-6128-4486-A044-CA06D90948BA}). */
  varyByData?: Maybe<CheckboxField>;
  /** VaryByDevice (ID: {C98CF969-BA71-42DA-833D-B3FC1368BA27}). */
  varyByDevice?: Maybe<CheckboxField>;
  /** VaryByLogin (ID: {8D9232B0-613F-440B-A2FA-DCDD80FBD33E}). */
  varyByLogin?: Maybe<CheckboxField>;
  /** VaryByParm (ID: {3AD2506A-DC39-4B1E-959F-9D524ADDBF50}). */
  varyByParm?: Maybe<CheckboxField>;
  /** VaryByQueryString (ID: {1084D3D2-0457-456A-ABBC-EB4CC0966072}). */
  varyByQueryString?: Maybe<CheckboxField>;
  /** VaryByUser (ID: {0E54A8DC-72AD-4372-A7C7-BB4773FAD44D}). */
  varyByUser?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Caching template (ID: {26FCE9BF-0256-458D-8281-A713A5BF5520}). */
export type Caching_26fce9bf0256458d8281a713a5bf5520 = Item & _SharedRoot & {
  __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Caching template (ID: {26FCE9BF-0256-458D-8281-A713A5BF5520}). */
export type Caching_26fce9bf0256458d8281a713a5bf5520AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Caching template (ID: {26FCE9BF-0256-458D-8281-A713A5BF5520}). */
export type Caching_26fce9bf0256458d8281a713a5bf5520ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Caching template (ID: {26FCE9BF-0256-458D-8281-A713A5BF5520}). */
export type Caching_26fce9bf0256458d8281a713a5bf5520FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Caching template (ID: {26FCE9BF-0256-458D-8281-A713A5BF5520}). */
export type Caching_26fce9bf0256458d8281a713a5bf5520FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Caching template (ID: {26FCE9BF-0256-458D-8281-A713A5BF5520}). */
export type Caching_26fce9bf0256458d8281a713a5bf5520HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Caching template (ID: {26FCE9BF-0256-458D-8281-A713A5BF5520}). */
export type Caching_26fce9bf0256458d8281a713a5bf5520IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Calendar Event template (ID: {62C2B7D0-1C34-4AA6-B3D3-5D612C0891BD}). */
export type CalendarEvent = Item & {
  __typename?: 'CalendarEvent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EndLabel (ID: {A746E8B0-B3A9-4918-A3C6-DB8977DD0DA5}). */
  endLabel?: Maybe<TextField>;
  /** EventDescription (ID: {79825619-C640-4892-98A8-9C4B112673D5}). */
  eventDescription?: Maybe<RichTextField>;
  /** EventEnd (ID: {C9999F64-A453-46A6-AE47-C423599986A7}). */
  eventEnd?: Maybe<DateField>;
  /** EventLink (ID: {84BFA68D-1D6A-4187-86D4-D7EC6294D5F0}). */
  eventLink?: Maybe<LinkField>;
  /** EventName (ID: {1FB9F55D-2C43-49C2-A61D-DF8552C88C20}). */
  eventName?: Maybe<TextField>;
  /** EventPlace (ID: {62BAFE3F-B288-429A-928E-B6A516A198B6}). */
  eventPlace?: Maybe<TextField>;
  /** EventStart (ID: {9E47D308-2E9C-413A-AC93-3C51C52E74D2}). */
  eventStart?: Maybe<DateField>;
  /** EventType (ID: {2C51A553-BB18-4DB2-B887-11AE200F96A9}). */
  eventType?: Maybe<MultilistField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** StartLabel (ID: {B2ACD4DA-A306-460B-81DC-FE40D3461A43}). */
  startLabel?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Calendar Event template (ID: {62C2B7D0-1C34-4AA6-B3D3-5D612C0891BD}). */
export type CalendarEventAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Calendar Event template (ID: {62C2B7D0-1C34-4AA6-B3D3-5D612C0891BD}). */
export type CalendarEventChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Calendar Event template (ID: {62C2B7D0-1C34-4AA6-B3D3-5D612C0891BD}). */
export type CalendarEventFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Calendar Event template (ID: {62C2B7D0-1C34-4AA6-B3D3-5D612C0891BD}). */
export type CalendarEventFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Calendar Event template (ID: {62C2B7D0-1C34-4AA6-B3D3-5D612C0891BD}). */
export type CalendarEventHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Calendar Event template (ID: {62C2B7D0-1C34-4AA6-B3D3-5D612C0891BD}). */
export type CalendarEventIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section template (ID: {82F44EAB-8CBB-4B49-B38A-9E5B15BC36FB}). */
export type CallOutSection = Item & {
  __typename?: 'CallOutSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ctaLabel (ID: {F3DD4166-0520-4153-85DC-D1B488D350EB}). */
  ctaLabel?: Maybe<TextField>;
  /** description (ID: {081E55E8-30AA-4591-89C8-7C25FEAA0F90}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** dropdownPlaceholder (ID: {D343AFCA-D1DD-425E-AEC5-74F204A57CE3}). */
  dropdownPlaceholder?: Maybe<TextField>;
  /** Fill in only if the Icon field is not empty and non-SVG. */
  employeeName?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** An image should be added in square format. */
  icon_33384bc6787d4aa38be2bfde88c6c51a?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Fill in only if the Icon field is not empty and non-SVG. */
  jobTitle?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Decimal value, allows to specify stars value with step: 0.1, min value: 1, max value: 5 */
  stars?: Maybe<TextField>;
  /** This field allows to specify {token.stars} keyword that will be dynamically substituted by formatted value from Stars field.  For example value "Our clients rate the call {token.stars} stars our of 5" with Stars field been setted as 4.6 will be presented as  "Our clients rate the call 4.6 stars our of 5" */
  starsDescription?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {25621211-DC08-4651-9C1F-A10310EEF34F}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section template (ID: {82F44EAB-8CBB-4B49-B38A-9E5B15BC36FB}). */
export type CallOutSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section template (ID: {82F44EAB-8CBB-4B49-B38A-9E5B15BC36FB}). */
export type CallOutSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section template (ID: {82F44EAB-8CBB-4B49-B38A-9E5B15BC36FB}). */
export type CallOutSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section template (ID: {82F44EAB-8CBB-4B49-B38A-9E5B15BC36FB}). */
export type CallOutSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section template (ID: {82F44EAB-8CBB-4B49-B38A-9E5B15BC36FB}). */
export type CallOutSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section template (ID: {82F44EAB-8CBB-4B49-B38A-9E5B15BC36FB}). */
export type CallOutSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Dropdown Option template (ID: {7E842992-04DC-4B85-AFAC-F29CAB999C69}). */
export type CallOutSectionDropdownOption = Item & {
  __typename?: 'CallOutSectionDropdownOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** dropdownOption (ID: {94FAE30D-426D-4634-AAF3-6BD3203447D2}). */
  dropdownOption?: Maybe<LinkField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Dropdown Option template (ID: {7E842992-04DC-4B85-AFAC-F29CAB999C69}). */
export type CallOutSectionDropdownOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Dropdown Option template (ID: {7E842992-04DC-4B85-AFAC-F29CAB999C69}). */
export type CallOutSectionDropdownOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Dropdown Option template (ID: {7E842992-04DC-4B85-AFAC-F29CAB999C69}). */
export type CallOutSectionDropdownOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Dropdown Option template (ID: {7E842992-04DC-4B85-AFAC-F29CAB999C69}). */
export type CallOutSectionDropdownOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Dropdown Option template (ID: {7E842992-04DC-4B85-AFAC-F29CAB999C69}). */
export type CallOutSectionDropdownOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Dropdown Option template (ID: {7E842992-04DC-4B85-AFAC-F29CAB999C69}). */
export type CallOutSectionDropdownOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Folder template (ID: {53224210-863F-483C-89EC-EC7EB89D7105}). */
export type CallOutSectionFolder = Item & {
  __typename?: 'CallOutSectionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Folder template (ID: {53224210-863F-483C-89EC-EC7EB89D7105}). */
export type CallOutSectionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Folder template (ID: {53224210-863F-483C-89EC-EC7EB89D7105}). */
export type CallOutSectionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Folder template (ID: {53224210-863F-483C-89EC-EC7EB89D7105}). */
export type CallOutSectionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Folder template (ID: {53224210-863F-483C-89EC-EC7EB89D7105}). */
export type CallOutSectionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Folder template (ID: {53224210-863F-483C-89EC-EC7EB89D7105}). */
export type CallOutSectionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call Out Section/Call Out Section Folder template (ID: {53224210-863F-483C-89EC-EC7EB89D7105}). */
export type CallOutSectionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Call Out Section Parameters Template template (ID: {FE4431E5-A07D-45F7-97B5-B84FADC7FA3D}). */
export type CallOutSectionParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'CallOutSectionParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {9DB0101D-B11C-471B-9D32-AA43604E8999}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Call Out Section Parameters Template template (ID: {FE4431E5-A07D-45F7-97B5-B84FADC7FA3D}). */
export type CallOutSectionParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Call Out Section Parameters Template template (ID: {FE4431E5-A07D-45F7-97B5-B84FADC7FA3D}). */
export type CallOutSectionParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Call Out Section Parameters Template template (ID: {FE4431E5-A07D-45F7-97B5-B84FADC7FA3D}). */
export type CallOutSectionParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Call Out Section Parameters Template template (ID: {FE4431E5-A07D-45F7-97B5-B84FADC7FA3D}). */
export type CallOutSectionParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Call Out Section Parameters Template template (ID: {FE4431E5-A07D-45F7-97B5-B84FADC7FA3D}). */
export type CallOutSectionParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Call Out Section Parameters Template template (ID: {FE4431E5-A07D-45F7-97B5-B84FADC7FA3D}). */
export type CallOutSectionParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call To Action template (ID: {DF373063-E68C-4052-993B-CD9D242B1F02}). */
export type CallToAction = BaseCta & Item & {
  __typename?: 'CallToAction';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {4FC97E88-C1EC-47F3-AEC9-A51BA2BACCC0}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {E2812D47-9120-43D2-9BB5-8FD6D57F823A}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call To Action template (ID: {DF373063-E68C-4052-993B-CD9D242B1F02}). */
export type CallToActionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call To Action template (ID: {DF373063-E68C-4052-993B-CD9D242B1F02}). */
export type CallToActionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call To Action template (ID: {DF373063-E68C-4052-993B-CD9D242B1F02}). */
export type CallToActionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call To Action template (ID: {DF373063-E68C-4052-993B-CD9D242B1F02}). */
export type CallToActionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call To Action template (ID: {DF373063-E68C-4052-993B-CD9D242B1F02}). */
export type CallToActionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Call To Action template (ID: {DF373063-E68C-4052-993B-CD9D242B1F02}). */
export type CallToActionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Call To Action Folder template (ID: {D3AA90C6-EA73-4926-BAA3-4A3501DB6ECB}). */
export type CallToActionFolder = Item & {
  __typename?: 'CallToActionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Call To Action Folder template (ID: {D3AA90C6-EA73-4926-BAA3-4A3501DB6ECB}). */
export type CallToActionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Call To Action Folder template (ID: {D3AA90C6-EA73-4926-BAA3-4A3501DB6ECB}). */
export type CallToActionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Call To Action Folder template (ID: {D3AA90C6-EA73-4926-BAA3-4A3501DB6ECB}). */
export type CallToActionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Call To Action Folder template (ID: {D3AA90C6-EA73-4926-BAA3-4A3501DB6ECB}). */
export type CallToActionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Call To Action Folder template (ID: {D3AA90C6-EA73-4926-BAA3-4A3501DB6ECB}). */
export type CallToActionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Call To Action Folder template (ID: {D3AA90C6-EA73-4926-BAA3-4A3501DB6ECB}). */
export type CallToActionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capabilities Folder template (ID: {98DFA58D-34EC-41BA-A217-093B0B87C968}). */
export type CapabilitiesFolder = Item & {
  __typename?: 'CapabilitiesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capabilities Folder template (ID: {98DFA58D-34EC-41BA-A217-093B0B87C968}). */
export type CapabilitiesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capabilities Folder template (ID: {98DFA58D-34EC-41BA-A217-093B0B87C968}). */
export type CapabilitiesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capabilities Folder template (ID: {98DFA58D-34EC-41BA-A217-093B0B87C968}). */
export type CapabilitiesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capabilities Folder template (ID: {98DFA58D-34EC-41BA-A217-093B0B87C968}). */
export type CapabilitiesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capabilities Folder template (ID: {98DFA58D-34EC-41BA-A217-093B0B87C968}). */
export type CapabilitiesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capabilities Folder template (ID: {98DFA58D-34EC-41BA-A217-093B0B87C968}). */
export type CapabilitiesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capability template (ID: {80A8D535-34D3-4888-AFF4-72F84C48C400}). */
export type Capability = Item & _LimitedDisplay & {
  __typename?: 'Capability';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** fundAssetClass (ID: {F8B9E7C0-2FD3-44FE-89E7-FC47F2D2598E}). */
  fundAssetClass?: Maybe<MultilistField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {7B40FC7F-6FA7-45A4-9321-56A50F5ECD30}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {36DEF742-6FD9-4A7C-9BB7-8A4206507EBF}). */
  name_36def7426fd94a7c9bb78a4206507ebf?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {E15C901E-1945-4AF1-BDBF-677DFEEC8025}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capability template (ID: {80A8D535-34D3-4888-AFF4-72F84C48C400}). */
export type CapabilityAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capability template (ID: {80A8D535-34D3-4888-AFF4-72F84C48C400}). */
export type CapabilityChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capability template (ID: {80A8D535-34D3-4888-AFF4-72F84C48C400}). */
export type CapabilityFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capability template (ID: {80A8D535-34D3-4888-AFF4-72F84C48C400}). */
export type CapabilityFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capability template (ID: {80A8D535-34D3-4888-AFF4-72F84C48C400}). */
export type CapabilityHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability/Capability template (ID: {80A8D535-34D3-4888-AFF4-72F84C48C400}). */
export type CapabilityIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Map template (ID: {138A6D3E-326C-49D0-8D9B-C275533DEB3B}). */
export type CapabilityMap = Item & {
  __typename?: 'CapabilityMap';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** capability (ID: {C62A415A-9127-4B81-A90F-6591492EC509}). */
  capability?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** page (ID: {FA7D6714-FFAF-4DA9-A216-7F405CCEF8C1}). */
  page?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Map template (ID: {138A6D3E-326C-49D0-8D9B-C275533DEB3B}). */
export type CapabilityMapAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Map template (ID: {138A6D3E-326C-49D0-8D9B-C275533DEB3B}). */
export type CapabilityMapChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Map template (ID: {138A6D3E-326C-49D0-8D9B-C275533DEB3B}). */
export type CapabilityMapFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Map template (ID: {138A6D3E-326C-49D0-8D9B-C275533DEB3B}). */
export type CapabilityMapFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Map template (ID: {138A6D3E-326C-49D0-8D9B-C275533DEB3B}). */
export type CapabilityMapHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Map template (ID: {138A6D3E-326C-49D0-8D9B-C275533DEB3B}). */
export type CapabilityMapIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Mappings template (ID: {376A59C6-55A5-4661-B8AF-73B7E4EE9970}). */
export type CapabilityMappings = Item & {
  __typename?: 'CapabilityMappings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Mappings template (ID: {376A59C6-55A5-4661-B8AF-73B7E4EE9970}). */
export type CapabilityMappingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Mappings template (ID: {376A59C6-55A5-4661-B8AF-73B7E4EE9970}). */
export type CapabilityMappingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Mappings template (ID: {376A59C6-55A5-4661-B8AF-73B7E4EE9970}). */
export type CapabilityMappingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Mappings template (ID: {376A59C6-55A5-4661-B8AF-73B7E4EE9970}). */
export type CapabilityMappingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Mappings template (ID: {376A59C6-55A5-4661-B8AF-73B7E4EE9970}). */
export type CapabilityMappingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Capability Map/Capability Mappings template (ID: {376A59C6-55A5-4661-B8AF-73B7E4EE9970}). */
export type CapabilityMappingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel template (ID: {ADD22F05-6B4C-4344-95AD-9A1A9BA6A216}). */
export type Carousel = Item & {
  __typename?: 'Carousel';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel template (ID: {ADD22F05-6B4C-4344-95AD-9A1A9BA6A216}). */
export type CarouselAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel template (ID: {ADD22F05-6B4C-4344-95AD-9A1A9BA6A216}). */
export type CarouselChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel template (ID: {ADD22F05-6B4C-4344-95AD-9A1A9BA6A216}). */
export type CarouselFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel template (ID: {ADD22F05-6B4C-4344-95AD-9A1A9BA6A216}). */
export type CarouselFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel template (ID: {ADD22F05-6B4C-4344-95AD-9A1A9BA6A216}). */
export type CarouselHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel template (ID: {ADD22F05-6B4C-4344-95AD-9A1A9BA6A216}). */
export type CarouselIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Folder template (ID: {A13A1B91-FD2B-494B-9086-008852175B0A}). */
export type CarouselFolder = Item & {
  __typename?: 'CarouselFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Folder template (ID: {A13A1B91-FD2B-494B-9086-008852175B0A}). */
export type CarouselFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Folder template (ID: {A13A1B91-FD2B-494B-9086-008852175B0A}). */
export type CarouselFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Folder template (ID: {A13A1B91-FD2B-494B-9086-008852175B0A}). */
export type CarouselFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Folder template (ID: {A13A1B91-FD2B-494B-9086-008852175B0A}). */
export type CarouselFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Folder template (ID: {A13A1B91-FD2B-494B-9086-008852175B0A}). */
export type CarouselFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Folder template (ID: {A13A1B91-FD2B-494B-9086-008852175B0A}). */
export type CarouselFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Slide template (ID: {142E5FC1-EC62-4540-BAD9-CD88F337CD2E}). */
export type CarouselSlide = Item & {
  __typename?: 'CarouselSlide';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SlideImage (ID: {427EC0BD-3BF2-45B9-880F-BDB0054E7925}). */
  slideImage?: Maybe<ImageField>;
  /** SlideLink (ID: {B31D5DDD-1EDA-4B22-B97D-FF71FC8E72BC}). */
  slideLink?: Maybe<LinkField>;
  /** SlideText (ID: {7209159D-6B3E-4281-983E-F7F82104FA1B}). */
  slideText?: Maybe<RichTextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Slide template (ID: {142E5FC1-EC62-4540-BAD9-CD88F337CD2E}). */
export type CarouselSlideAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Slide template (ID: {142E5FC1-EC62-4540-BAD9-CD88F337CD2E}). */
export type CarouselSlideChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Slide template (ID: {142E5FC1-EC62-4540-BAD9-CD88F337CD2E}). */
export type CarouselSlideFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Slide template (ID: {142E5FC1-EC62-4540-BAD9-CD88F337CD2E}). */
export type CarouselSlideFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Slide template (ID: {142E5FC1-EC62-4540-BAD9-CD88F337CD2E}). */
export type CarouselSlideHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Carousel/Carousel Slide template (ID: {142E5FC1-EC62-4540-BAD9-CD88F337CD2E}). */
export type CarouselSlideIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Carousel template (ID: {2B65F0D8-7EC5-4834-B4AA-1753C0F7036B}). */
export type Carousel_2b65f0d87ec54834b4aa1753c0f7036b = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Navigation (ID: {029ABE5E-EFC8-4C4D-8105-2CBA77BFF85F}). */
  navigation?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  /** PauseOnHover (ID: {55DBFD60-55AF-41AD-9D9E-2FA65A3FF8EF}). */
  pauseOnHover?: Maybe<CheckboxField>;
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Timeout (ID: {B681A046-4094-45CF-B6FD-89A700142592}). */
  timeout?: Maybe<IntegerField>;
  /** Transition (ID: {3BCE2E36-C396-45E6-80A7-8329B6EA75AC}). */
  transition?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Carousel template (ID: {2B65F0D8-7EC5-4834-B4AA-1753C0F7036B}). */
export type Carousel_2b65f0d87ec54834b4aa1753c0f7036bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Carousel template (ID: {2B65F0D8-7EC5-4834-B4AA-1753C0F7036B}). */
export type Carousel_2b65f0d87ec54834b4aa1753c0f7036bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Carousel template (ID: {2B65F0D8-7EC5-4834-B4AA-1753C0F7036B}). */
export type Carousel_2b65f0d87ec54834b4aa1753c0f7036bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Carousel template (ID: {2B65F0D8-7EC5-4834-B4AA-1753C0F7036B}). */
export type Carousel_2b65f0d87ec54834b4aa1753c0f7036bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Carousel template (ID: {2B65F0D8-7EC5-4834-B4AA-1753C0F7036B}). */
export type Carousel_2b65f0d87ec54834b4aa1753c0f7036bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Carousel template (ID: {2B65F0D8-7EC5-4834-B4AA-1753C0F7036B}). */
export type Carousel_2b65f0d87ec54834b4aa1753c0f7036bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Checkbox template (ID: {A825775A-F3BB-4C91-9341-5A0D1314131D}). */
export type Checkbox = AdvancedParameter & Class & GridItemBase & IIcon & Item & {
  __typename?: 'Checkbox';
  /** Advanced (ID: {07A98F74-131F-4BA1-9C00-88416C2832A4}). */
  advanced?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Class (ID: {591C584F-08A7-4DC6-9D58-1DE178C404A2}). */
  class?: Maybe<TextField>;
  /** Class (ID: {0023EC7C-781A-45B3-A40F-5B7F9C03E082}). */
  class_0023ec7c781a45b3a40f5b7f9c03e082?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Icon (ID: {39816442-74D9-4CE2-BEB3-128B204EFD40}). */
  icon_3981644274d94ce2beb3128b204efd40?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NonNumeric (ID: {55C117EF-46C0-4CDC-A309-82419983FD42}). */
  nonNumeric?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Tooltip (ID: {B55A9065-9589-41D8-997B-9B4592852134}). */
  tooltip?: Maybe<TextField>;
  /** Tooltip (ID: {3F7C057A-70A9-4E83-AB43-7C6D83E550A8}). */
  tooltip_3f7c057a70a94e83ab437c6d83e550a8?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Checkbox template (ID: {A825775A-F3BB-4C91-9341-5A0D1314131D}). */
export type CheckboxAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Checkbox template (ID: {A825775A-F3BB-4C91-9341-5A0D1314131D}). */
export type CheckboxChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Checkbox template (ID: {A825775A-F3BB-4C91-9341-5A0D1314131D}). */
export type CheckboxFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Checkbox template (ID: {A825775A-F3BB-4C91-9341-5A0D1314131D}). */
export type CheckboxFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Checkbox template (ID: {A825775A-F3BB-4C91-9341-5A0D1314131D}). */
export type CheckboxHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Checkbox template (ID: {A825775A-F3BB-4C91-9341-5A0D1314131D}). */
export type CheckboxIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type CheckboxField = ItemField & {
  __typename?: 'CheckboxField';
  /** Indicates whether checkbox is checked. */
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type CheckboxFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Checklist Filter template (ID: {6E188261-E572-4330-B88A-88C68B0926E7}). */
export type ChecklistFilter = FacetSelectorConfigBase & Item & {
  __typename?: 'ChecklistFilter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Empty Value Text (ID: {B912C304-FAB1-4856-BFB4-AAE9B7EE79A1}). */
  emptyValueText?: Maybe<TextField>;
  /** Facet (ID: {0A5DBE83-3914-4630-90EF-D1BBBCDEDE7F}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Go Button Label (ID: {21A0B495-72BD-4BCB-A9EE-ABDEE527E79B}). */
  goButtonLabel?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Show Less Text (ID: {247827A2-A3D1-4713-98A6-395C769A3912}). */
  showLessText?: Maybe<TextField>;
  /** Show More Text (ID: {DF1206A2-4E9C-4642-AD5A-3E301B55568F}). */
  showMoreText?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Threshold Section Separator Text (ID: {CA2837BF-C80A-4BFE-8086-DB1A8D01BC51}). */
  thresholdSectionSeparatorText?: Maybe<TextField>;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Checklist Filter template (ID: {6E188261-E572-4330-B88A-88C68B0926E7}). */
export type ChecklistFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Checklist Filter template (ID: {6E188261-E572-4330-B88A-88C68B0926E7}). */
export type ChecklistFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Checklist Filter template (ID: {6E188261-E572-4330-B88A-88C68B0926E7}). */
export type ChecklistFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Checklist Filter template (ID: {6E188261-E572-4330-B88A-88C68B0926E7}). */
export type ChecklistFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Checklist Filter template (ID: {6E188261-E572-4330-B88A-88C68B0926E7}). */
export type ChecklistFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Checklist Filter template (ID: {6E188261-E572-4330-B88A-88C68B0926E7}). */
export type ChecklistFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Checklist Filter Folder template (ID: {DF757E41-D77E-4125-BAD0-AA2E75EE4085}). */
export type ChecklistFilterFolder = Item & {
  __typename?: 'ChecklistFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Checklist Filter Folder template (ID: {DF757E41-D77E-4125-BAD0-AA2E75EE4085}). */
export type ChecklistFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Checklist Filter Folder template (ID: {DF757E41-D77E-4125-BAD0-AA2E75EE4085}). */
export type ChecklistFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Checklist Filter Folder template (ID: {DF757E41-D77E-4125-BAD0-AA2E75EE4085}). */
export type ChecklistFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Checklist Filter Folder template (ID: {DF757E41-D77E-4125-BAD0-AA2E75EE4085}). */
export type ChecklistFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Checklist Filter Folder template (ID: {DF757E41-D77E-4125-BAD0-AA2E75EE4085}). */
export type ChecklistFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Checklist Filter Folder template (ID: {DF757E41-D77E-4125-BAD0-AA2E75EE4085}). */
export type ChecklistFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Checklist Filter template (ID: {3CB40BD6-69C9-4976-A974-2120A5EBA1EE}). */
export type ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & _SortOrder & {
  __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Collapse On Selection (ID: {324E75B3-78F3-4F55-B19D-D411C9F9413D}). */
  collapseOnSelection?: Maybe<CheckboxField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Highlight Behaviour (ID: {0F86E79B-8502-47CA-BDBF-3383D0D0485A}). */
  highlightBehaviour?: Maybe<IntegerField>;
  /** Highlight Threshold (ID: {63EE66E7-7BD6-4F94-924F-F4382603D54E}). */
  highlightThreshold?: Maybe<IntegerField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Multi Selection (ID: {3AA4BC54-8B86-4369-B6DA-3B7A48DDF870}). */
  multiSelection?: Maybe<CheckboxField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** SortOrder (ID: {91ED9872-2007-47E9-BF01-1292C1B261B2}). */
  sortOrder?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Checklist Filter template (ID: {3CB40BD6-69C9-4976-A974-2120A5EBA1EE}). */
export type ChecklistFilter_3cb40bd669c94976a9742120a5eba1eeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Checklist Filter template (ID: {3CB40BD6-69C9-4976-A974-2120A5EBA1EE}). */
export type ChecklistFilter_3cb40bd669c94976a9742120a5eba1eeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Checklist Filter template (ID: {3CB40BD6-69C9-4976-A974-2120A5EBA1EE}). */
export type ChecklistFilter_3cb40bd669c94976a9742120a5eba1eeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Checklist Filter template (ID: {3CB40BD6-69C9-4976-A974-2120A5EBA1EE}). */
export type ChecklistFilter_3cb40bd669c94976a9742120a5eba1eeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Checklist Filter template (ID: {3CB40BD6-69C9-4976-A974-2120A5EBA1EE}). */
export type ChecklistFilter_3cb40bd669c94976a9742120a5eba1eeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Checklist Filter template (ID: {3CB40BD6-69C9-4976-A974-2120A5EBA1EE}). */
export type ChecklistFilter_3cb40bd669c94976a9742120a5eba1eeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Class template (ID: {CB3B3906-BE80-4D9B-A2A4-038193DA5422}). Also implements IIcon, GridItemBase. */
export type Class = {
  /** Class (ID: {591C584F-08A7-4DC6-9D58-1DE178C404A2}). */
  class?: Maybe<TextField>;
  /** Icon (ID: {39816442-74D9-4CE2-BEB3-128B204EFD40}). */
  icon_3981644274d94ce2beb3128b204efd40?: Maybe<TextField>;
  /** NonNumeric (ID: {55C117EF-46C0-4CDC-A309-82419983FD42}). */
  nonNumeric?: Maybe<CheckboxField>;
  /** Tooltip (ID: {B55A9065-9589-41D8-997B-9B4592852134}). */
  tooltip?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {181740EA-A7AE-4799-A649-A75917570E38}). */
export type ColumnSplitter = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & ISplitter & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'ColumnSplitter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ColumnWidth1 (ID: {292E92D0-5E59-48B4-8271-1EE910CFA0BC}). */
  columnWidth1?: Maybe<TextField>;
  /** ColumnWidth2 (ID: {718CE476-BE2D-4456-8B3D-CF0F2A312CDF}). */
  columnWidth2?: Maybe<TextField>;
  /** ColumnWidth3 (ID: {BBA175B5-49F3-41E7-953D-5615C842530F}). */
  columnWidth3?: Maybe<TextField>;
  /** ColumnWidth4 (ID: {4496CF32-A24C-4210-8EFF-B3FC62C967F1}). */
  columnWidth4?: Maybe<TextField>;
  /** ColumnWidth5 (ID: {7CBF006E-6CFC-4E54-BEEB-BB07542F289F}). */
  columnWidth5?: Maybe<TextField>;
  /** ColumnWidth6 (ID: {33BEAA03-6CBC-497A-A8F9-0979F06ED121}). */
  columnWidth6?: Maybe<TextField>;
  /** ColumnWidth7 (ID: {3E3B0657-1079-4E0B-AE04-BD9E93ECA36B}). */
  columnWidth7?: Maybe<TextField>;
  /** ColumnWidth8 (ID: {BB9FC77C-03C2-4C51-A620-5C65513711F1}). */
  columnWidth8?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Styles1 (ID: {A2C4ABB2-90E9-4866-A428-753BF286C7A5}). */
  styles1?: Maybe<TextField>;
  /** Styles2 (ID: {79777C28-BCD3-4C20-8C2A-ABC99C3A4A6A}). */
  styles2?: Maybe<TextField>;
  /** Styles3 (ID: {591A783F-F3FD-4239-B233-1DAD96D18BE2}). */
  styles3?: Maybe<TextField>;
  /** Styles4 (ID: {FDDA06C2-8D15-46E7-A562-0F8DE50AAEDD}). */
  styles4?: Maybe<TextField>;
  /** Styles5 (ID: {150E00CC-82C8-4CE5-8B46-86A2769D481D}). */
  styles5?: Maybe<TextField>;
  /** Styles6 (ID: {9F5DCCCF-418D-49A2-8DF9-B43F4011B0D1}). */
  styles6?: Maybe<TextField>;
  /** Styles7 (ID: {56EFF754-65C8-4470-992A-1B1ED8A06014}). */
  styles7?: Maybe<TextField>;
  /** Styles8 (ID: {47941461-F5B5-4707-804B-69990971E6A1}). */
  styles8?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {181740EA-A7AE-4799-A649-A75917570E38}). */
export type ColumnSplitterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {181740EA-A7AE-4799-A649-A75917570E38}). */
export type ColumnSplitterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {181740EA-A7AE-4799-A649-A75917570E38}). */
export type ColumnSplitterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {181740EA-A7AE-4799-A649-A75917570E38}). */
export type ColumnSplitterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {181740EA-A7AE-4799-A649-A75917570E38}). */
export type ColumnSplitterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {181740EA-A7AE-4799-A649-A75917570E38}). */
export type ColumnSplitterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {3E1016E5-6ECB-4C19-AA01-17C18B42DEB0}). */
export type ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = ICacheable & IDynamicPlaceholder & ISplitter & Item & StandardRenderingParameters & {
  __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ColumnWidth1 (ID: {C8C9D3B3-962A-45C1-90AE-F36BB0AA54F2}). */
  columnWidth1?: Maybe<TextField>;
  /** ColumnWidth2 (ID: {16667F70-4990-4C66-B6F5-7F83B5E3A7A6}). */
  columnWidth2?: Maybe<TextField>;
  /** ColumnWidth3 (ID: {8DEF98FB-784F-4F2C-BF52-5BB5FF79CD64}). */
  columnWidth3?: Maybe<TextField>;
  /** ColumnWidth4 (ID: {AF01DCB3-53CF-49D8-9530-7F0A76CC63BE}). */
  columnWidth4?: Maybe<TextField>;
  /** ColumnWidth5 (ID: {A0F928B8-7036-4221-A097-C5B1B8372B1C}). */
  columnWidth5?: Maybe<TextField>;
  /** ColumnWidth6 (ID: {295EB8FB-C722-437C-AF4F-3FB482B57561}). */
  columnWidth6?: Maybe<TextField>;
  /** ColumnWidth7 (ID: {AB33A317-F0D3-4312-A5B2-5159AD04B7EC}). */
  columnWidth7?: Maybe<TextField>;
  /** ColumnWidth8 (ID: {AE807864-F2C8-461B-9FC8-0D5BE9861F4E}). */
  columnWidth8?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Styles1 (ID: {E6C7D17A-28FD-4F20-B5D5-0FA71B49F38A}). */
  styles1?: Maybe<TextField>;
  /** Styles2 (ID: {2D4E72B7-FA79-4E5C-9362-0D5232222668}). */
  styles2?: Maybe<TextField>;
  /** Styles3 (ID: {0A33A8F0-DC86-4E07-8562-624002BA5983}). */
  styles3?: Maybe<TextField>;
  /** Styles4 (ID: {D59DE611-1A2D-4B7F-A24F-E88AF212C3C6}). */
  styles4?: Maybe<TextField>;
  /** Styles5 (ID: {FB8855B5-52B7-4DE8-A265-C6ADEE57CB35}). */
  styles5?: Maybe<TextField>;
  /** Styles6 (ID: {BC12416B-FE13-4B48-9D30-60C43BF28B1D}). */
  styles6?: Maybe<TextField>;
  /** Styles7 (ID: {1B799123-CF19-425E-9EFC-53DCAE3C3722}). */
  styles7?: Maybe<TextField>;
  /** Styles8 (ID: {2995883A-CC0C-415E-9551-022CC4215FBA}). */
  styles8?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {3E1016E5-6ECB-4C19-AA01-17C18B42DEB0}). */
export type ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {3E1016E5-6ECB-4C19-AA01-17C18B42DEB0}). */
export type ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {3E1016E5-6ECB-4C19-AA01-17C18B42DEB0}). */
export type ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {3E1016E5-6ECB-4C19-AA01-17C18B42DEB0}). */
export type ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {3E1016E5-6ECB-4C19-AA01-17C18B42DEB0}). */
export type ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/ColumnSplitter template (ID: {3E1016E5-6ECB-4C19-AA01-17C18B42DEB0}). */
export type ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Compatibility Mode template (ID: {F2620263-CD63-4013-9CF9-171FDF2D7ECC}). */
export type CompatibilityMode = Item & {
  __typename?: 'CompatibilityMode';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Value (ID: {3DD612C4-3AA7-48A9-9F46-FD8DE9AE3ACA}). */
  value?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Compatibility Mode template (ID: {F2620263-CD63-4013-9CF9-171FDF2D7ECC}). */
export type CompatibilityModeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Compatibility Mode template (ID: {F2620263-CD63-4013-9CF9-171FDF2D7ECC}). */
export type CompatibilityModeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Compatibility Mode template (ID: {F2620263-CD63-4013-9CF9-171FDF2D7ECC}). */
export type CompatibilityModeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Compatibility Mode template (ID: {F2620263-CD63-4013-9CF9-171FDF2D7ECC}). */
export type CompatibilityModeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Compatibility Mode template (ID: {F2620263-CD63-4013-9CF9-171FDF2D7ECC}). */
export type CompatibilityModeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Compatibility Mode template (ID: {F2620263-CD63-4013-9CF9-171FDF2D7ECC}). */
export type CompatibilityModeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentConfiguration template (ID: {CE488A27-2734-4E5B-AF3A-490E4CFEAB26}). */
export type ComponentConfiguration = ExtendedOptions_2964fb4257a6440fb192218443904c90 & Item & {
  __typename?: 'ComponentConfiguration';
  /** AllowedOnTemplates (ID: {1B58D065-FE74-43E3-BA20-54C9588B3011}). */
  allowedOnTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rendering (ID: {A52A57FA-0AFA-47ED-BB8F-B106135869C5}). */
  rendering?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentConfiguration template (ID: {CE488A27-2734-4E5B-AF3A-490E4CFEAB26}). */
export type ComponentConfigurationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentConfiguration template (ID: {CE488A27-2734-4E5B-AF3A-490E4CFEAB26}). */
export type ComponentConfigurationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentConfiguration template (ID: {CE488A27-2734-4E5B-AF3A-490E4CFEAB26}). */
export type ComponentConfigurationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentConfiguration template (ID: {CE488A27-2734-4E5B-AF3A-490E4CFEAB26}). */
export type ComponentConfigurationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentConfiguration template (ID: {CE488A27-2734-4E5B-AF3A-490E4CFEAB26}). */
export type ComponentConfigurationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentConfiguration template (ID: {CE488A27-2734-4E5B-AF3A-490E4CFEAB26}). */
export type ComponentConfigurationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Theme Configuration template (ID: {343F37DA-5DC4-4EAE-9C2B-EC3FE848CC51}). */
export type ComponentThemeConfiguration = Item & {
  __typename?: 'ComponentThemeConfiguration';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Compatible Renderings (ID: {D6BE6EA6-FD99-4D4A-AE6C-05CADF9688AA}). */
  compatibleRenderings?: Maybe<MultilistField>;
  /** Component Themes (ID: {EFC95483-A5DB-4090-AF60-0435D61E95B2}). */
  componentThemes?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {C868D0A6-6CC9-4B09-BD00-2475190545F3}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Theme Configuration template (ID: {343F37DA-5DC4-4EAE-9C2B-EC3FE848CC51}). */
export type ComponentThemeConfigurationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Theme Configuration template (ID: {343F37DA-5DC4-4EAE-9C2B-EC3FE848CC51}). */
export type ComponentThemeConfigurationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Theme Configuration template (ID: {343F37DA-5DC4-4EAE-9C2B-EC3FE848CC51}). */
export type ComponentThemeConfigurationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Theme Configuration template (ID: {343F37DA-5DC4-4EAE-9C2B-EC3FE848CC51}). */
export type ComponentThemeConfigurationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Theme Configuration template (ID: {343F37DA-5DC4-4EAE-9C2B-EC3FE848CC51}). */
export type ComponentThemeConfigurationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Theme Configuration template (ID: {343F37DA-5DC4-4EAE-9C2B-EC3FE848CC51}). */
export type ComponentThemeConfigurationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Themes Configuration template (ID: {6D39AFEB-15C9-4CDB-BD92-844265F8B77E}). */
export type ComponentThemesConfiguration = Item & {
  __typename?: 'ComponentThemesConfiguration';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Themes Configuration template (ID: {6D39AFEB-15C9-4CDB-BD92-844265F8B77E}). */
export type ComponentThemesConfigurationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Themes Configuration template (ID: {6D39AFEB-15C9-4CDB-BD92-844265F8B77E}). */
export type ComponentThemesConfigurationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Themes Configuration template (ID: {6D39AFEB-15C9-4CDB-BD92-844265F8B77E}). */
export type ComponentThemesConfigurationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Themes Configuration template (ID: {6D39AFEB-15C9-4CDB-BD92-844265F8B77E}). */
export type ComponentThemesConfigurationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Themes Configuration template (ID: {6D39AFEB-15C9-4CDB-BD92-844265F8B77E}). */
export type ComponentThemesConfigurationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Component Themes/Component Themes Configuration template (ID: {6D39AFEB-15C9-4CDB-BD92-844265F8B77E}). */
export type ComponentThemesConfigurationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentsConfigurations template (ID: {E7F93DDC-E6FD-4A17-BF3C-959C82D6FB8D}). */
export type ComponentsConfigurations = Item & {
  __typename?: 'ComponentsConfigurations';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentsConfigurations template (ID: {E7F93DDC-E6FD-4A17-BF3C-959C82D6FB8D}). */
export type ComponentsConfigurationsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentsConfigurations template (ID: {E7F93DDC-E6FD-4A17-BF3C-959C82D6FB8D}). */
export type ComponentsConfigurationsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentsConfigurations template (ID: {E7F93DDC-E6FD-4A17-BF3C-959C82D6FB8D}). */
export type ComponentsConfigurationsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentsConfigurations template (ID: {E7F93DDC-E6FD-4A17-BF3C-959C82D6FB8D}). */
export type ComponentsConfigurationsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentsConfigurations template (ID: {E7F93DDC-E6FD-4A17-BF3C-959C82D6FB8D}). */
export type ComponentsConfigurationsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/ComponentsConfigurations template (ID: {E7F93DDC-E6FD-4A17-BF3C-959C82D6FB8D}). */
export type ComponentsConfigurationsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Configuration Folder template (ID: {A9EA850E-099B-464F-A3C3-020C230DD0EB}). */
export type ConfigurationFolder = Item & {
  __typename?: 'ConfigurationFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Configuration Folder template (ID: {A9EA850E-099B-464F-A3C3-020C230DD0EB}). */
export type ConfigurationFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Configuration Folder template (ID: {A9EA850E-099B-464F-A3C3-020C230DD0EB}). */
export type ConfigurationFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Configuration Folder template (ID: {A9EA850E-099B-464F-A3C3-020C230DD0EB}). */
export type ConfigurationFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Configuration Folder template (ID: {A9EA850E-099B-464F-A3C3-020C230DD0EB}). */
export type ConfigurationFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Configuration Folder template (ID: {A9EA850E-099B-464F-A3C3-020C230DD0EB}). */
export type ConfigurationFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Configuration Folder template (ID: {A9EA850E-099B-464F-A3C3-020C230DD0EB}). */
export type ConfigurationFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {6F9C1FD2-BB0D-4797-B30C-4FA5FA4D5074}). */
export type Container = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Container';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Background Image (ID: {E7AF007D-CEE9-41CF-8A53-5581C62376A3}). */
  backgroundImage?: Maybe<ImageField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {6F9C1FD2-BB0D-4797-B30C-4FA5FA4D5074}). */
export type ContainerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {6F9C1FD2-BB0D-4797-B30C-4FA5FA4D5074}). */
export type ContainerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {6F9C1FD2-BB0D-4797-B30C-4FA5FA4D5074}). */
export type ContainerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {6F9C1FD2-BB0D-4797-B30C-4FA5FA4D5074}). */
export type ContainerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {6F9C1FD2-BB0D-4797-B30C-4FA5FA4D5074}). */
export type ContainerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {6F9C1FD2-BB0D-4797-B30C-4FA5FA4D5074}). */
export type ContainerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Option template (ID: {C508EE68-9F7F-4E5B-BBD5-FAA38FBD98A8}). */
export type ContainerOption = Item & _RenderingRelatedParameters & {
  __typename?: 'ContainerOption';
  /** AllowedRenderings (ID: {7DA92DDB-CD84-4284-826E-44A163E9A53F}). */
  allowedRenderings?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Option template (ID: {C508EE68-9F7F-4E5B-BBD5-FAA38FBD98A8}). */
export type ContainerOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Option template (ID: {C508EE68-9F7F-4E5B-BBD5-FAA38FBD98A8}). */
export type ContainerOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Option template (ID: {C508EE68-9F7F-4E5B-BBD5-FAA38FBD98A8}). */
export type ContainerOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Option template (ID: {C508EE68-9F7F-4E5B-BBD5-FAA38FBD98A8}). */
export type ContainerOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Option template (ID: {C508EE68-9F7F-4E5B-BBD5-FAA38FBD98A8}). */
export type ContainerOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Option template (ID: {C508EE68-9F7F-4E5B-BBD5-FAA38FBD98A8}). */
export type ContainerOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Options Folder template (ID: {2857F02C-50E7-44B7-A662-15477CF3827F}). */
export type ContainerOptionsFolder = Item & {
  __typename?: 'ContainerOptionsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Options Folder template (ID: {2857F02C-50E7-44B7-A662-15477CF3827F}). */
export type ContainerOptionsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Options Folder template (ID: {2857F02C-50E7-44B7-A662-15477CF3827F}). */
export type ContainerOptionsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Options Folder template (ID: {2857F02C-50E7-44B7-A662-15477CF3827F}). */
export type ContainerOptionsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Options Folder template (ID: {2857F02C-50E7-44B7-A662-15477CF3827F}). */
export type ContainerOptionsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Options Folder template (ID: {2857F02C-50E7-44B7-A662-15477CF3827F}). */
export type ContainerOptionsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Container/Container Options Folder template (ID: {2857F02C-50E7-44B7-A662-15477CF3827F}). */
export type ContainerOptionsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Container Parameters Template template (ID: {8BFBE698-9DD4-4477-BD8D-27ABE45CA2F0}). */
export type ContainerParametersTemplate = BackgroundParametersTemplate & Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'ContainerParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {785FB6DB-27CB-487A-9FC6-5FD6A1972980}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** col (ID: {A1BB1F0C-F8B9-4112-B15C-F5793EE2DF6A}). */
  col?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Container Parameters Template template (ID: {8BFBE698-9DD4-4477-BD8D-27ABE45CA2F0}). */
export type ContainerParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Container Parameters Template template (ID: {8BFBE698-9DD4-4477-BD8D-27ABE45CA2F0}). */
export type ContainerParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Container Parameters Template template (ID: {8BFBE698-9DD4-4477-BD8D-27ABE45CA2F0}). */
export type ContainerParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Container Parameters Template template (ID: {8BFBE698-9DD4-4477-BD8D-27ABE45CA2F0}). */
export type ContainerParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Container Parameters Template template (ID: {8BFBE698-9DD4-4477-BD8D-27ABE45CA2F0}). */
export type ContainerParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Container Parameters Template template (ID: {8BFBE698-9DD4-4477-BD8D-27ABE45CA2F0}). */
export type ContainerParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {45130BDB-BAE3-4EDC-AEA8-7B68B9D94C7F}). */
export type Container_45130bdbbae34edcaea87b68b9d94c7f = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Background Image (ID: {6845679D-E298-4E94-96EB-230CB7C3BAAE}). */
  backgroundImage?: Maybe<ImageField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {45130BDB-BAE3-4EDC-AEA8-7B68B9D94C7F}). */
export type Container_45130bdbbae34edcaea87b68b9d94c7fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {45130BDB-BAE3-4EDC-AEA8-7B68B9D94C7F}). */
export type Container_45130bdbbae34edcaea87b68b9d94c7fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {45130BDB-BAE3-4EDC-AEA8-7B68B9D94C7F}). */
export type Container_45130bdbbae34edcaea87b68b9d94c7fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {45130BDB-BAE3-4EDC-AEA8-7B68B9D94C7F}). */
export type Container_45130bdbbae34edcaea87b68b9d94c7fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {45130BDB-BAE3-4EDC-AEA8-7B68B9D94C7F}). */
export type Container_45130bdbbae34edcaea87b68b9d94c7fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/Container template (ID: {45130BDB-BAE3-4EDC-AEA8-7B68B9D94C7F}). */
export type Container_45130bdbbae34edcaea87b68b9d94c7fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/ContentBlock template (ID: {59D885AF-57CE-5C44-80DF-F24C1A55635B}). */
export type ContentBlock = Item & {
  __typename?: 'ContentBlock';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** content (ID: {053827BB-C11D-504E-9920-9DB9A4E7295C}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** heading (ID: {83328412-2279-582A-8A48-24E06F634C9D}). */
  heading?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/ContentBlock template (ID: {59D885AF-57CE-5C44-80DF-F24C1A55635B}). */
export type ContentBlockAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/ContentBlock template (ID: {59D885AF-57CE-5C44-80DF-F24C1A55635B}). */
export type ContentBlockChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/ContentBlock template (ID: {59D885AF-57CE-5C44-80DF-F24C1A55635B}). */
export type ContentBlockFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/ContentBlock template (ID: {59D885AF-57CE-5C44-80DF-F24C1A55635B}). */
export type ContentBlockFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/ContentBlock template (ID: {59D885AF-57CE-5C44-80DF-F24C1A55635B}). */
export type ContentBlockHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/ContentBlock template (ID: {59D885AF-57CE-5C44-80DF-F24C1A55635B}). */
export type ContentBlockIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/Content Block Folder template (ID: {33AD3668-0FD0-4EF2-9BB0-87A014E81961}). */
export type ContentBlockFolder = Item & {
  __typename?: 'ContentBlockFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/Content Block Folder template (ID: {33AD3668-0FD0-4EF2-9BB0-87A014E81961}). */
export type ContentBlockFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/Content Block Folder template (ID: {33AD3668-0FD0-4EF2-9BB0-87A014E81961}). */
export type ContentBlockFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/Content Block Folder template (ID: {33AD3668-0FD0-4EF2-9BB0-87A014E81961}). */
export type ContentBlockFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/Content Block Folder template (ID: {33AD3668-0FD0-4EF2-9BB0-87A014E81961}). */
export type ContentBlockFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/Content Block Folder template (ID: {33AD3668-0FD0-4EF2-9BB0-87A014E81961}). */
export type ContentBlockFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Content Block/Content Block Folder template (ID: {33AD3668-0FD0-4EF2-9BB0-87A014E81961}). */
export type ContentBlockFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Layout/Rendering Dependencies/Content Dependency template (ID: {FC69C08B-44D5-4B94-AF4F-3297B52C5D06}). */
export type ContentDependency = {
  /** Content Dependencies (ID: {B4BBC0BE-7619-4678-B2F7-947D84AA77A9}). */
  contentDependencies?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token template (ID: {7D659EE9-D487-4D40-8A92-10C6D68844C8}). */
export type ContentToken = Item & {
  __typename?: 'ContentToken';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Key (ID: {02F6FB63-FE92-44E8-AFA2-20747C893502}). */
  key?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Value (ID: {1B9D1028-C20C-407B-9DCD-AFFE86A6F793}). */
  value?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token template (ID: {7D659EE9-D487-4D40-8A92-10C6D68844C8}). */
export type ContentTokenAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token template (ID: {7D659EE9-D487-4D40-8A92-10C6D68844C8}). */
export type ContentTokenChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token template (ID: {7D659EE9-D487-4D40-8A92-10C6D68844C8}). */
export type ContentTokenFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token template (ID: {7D659EE9-D487-4D40-8A92-10C6D68844C8}). */
export type ContentTokenFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token template (ID: {7D659EE9-D487-4D40-8A92-10C6D68844C8}). */
export type ContentTokenHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token template (ID: {7D659EE9-D487-4D40-8A92-10C6D68844C8}). */
export type ContentTokenIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token Folder template (ID: {29252703-D448-451C-BF1E-65B16174F4B0}). */
export type ContentTokenFolder = Item & {
  __typename?: 'ContentTokenFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token Folder template (ID: {29252703-D448-451C-BF1E-65B16174F4B0}). */
export type ContentTokenFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token Folder template (ID: {29252703-D448-451C-BF1E-65B16174F4B0}). */
export type ContentTokenFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token Folder template (ID: {29252703-D448-451C-BF1E-65B16174F4B0}). */
export type ContentTokenFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token Folder template (ID: {29252703-D448-451C-BF1E-65B16174F4B0}). */
export type ContentTokenFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token Folder template (ID: {29252703-D448-451C-BF1E-65B16174F4B0}). */
export type ContentTokenFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Content Tokens/Content Token Folder template (ID: {29252703-D448-451C-BF1E-65B16174F4B0}). */
export type ContentTokenFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Content Type template (ID: {75670DA7-4B4F-4DDB-8A6C-F95F2F1F346E}). */
export type ContentType = Item & {
  __typename?: 'ContentType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Content Type template (ID: {75670DA7-4B4F-4DDB-8A6C-F95F2F1F346E}). */
export type ContentTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Content Type template (ID: {75670DA7-4B4F-4DDB-8A6C-F95F2F1F346E}). */
export type ContentTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Content Type template (ID: {75670DA7-4B4F-4DDB-8A6C-F95F2F1F346E}). */
export type ContentTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Content Type template (ID: {75670DA7-4B4F-4DDB-8A6C-F95F2F1F346E}). */
export type ContentTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Content Type template (ID: {75670DA7-4B4F-4DDB-8A6C-F95F2F1F346E}). */
export type ContentTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Content Type template (ID: {75670DA7-4B4F-4DDB-8A6C-F95F2F1F346E}). */
export type ContentTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Geospatial/Coordinate template (ID: {2A637C18-C95A-4A4A-9C69-740CD4C258E7}). */
export type Coordinate = {
  /** Latitudes range from -90 to 90. For example 41.25 or -31.96 */
  latitude?: Maybe<NumberField>;
  /** Longitudes range from -180 to 180. For example, -120.9762 and 115.84 */
  longitude?: Maybe<NumberField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Theme template (ID: {004840B3-205A-4EAF-97F5-31BADE6D91D5}). */
export type CorporateTheme = Item & {
  __typename?: 'CorporateTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {3E8726DA-173F-483C-914D-FEF2C60FBA18}). */
  name_3e8726da173f483c914dfef2c60fba18?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Theme template (ID: {004840B3-205A-4EAF-97F5-31BADE6D91D5}). */
export type CorporateThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Theme template (ID: {004840B3-205A-4EAF-97F5-31BADE6D91D5}). */
export type CorporateThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Theme template (ID: {004840B3-205A-4EAF-97F5-31BADE6D91D5}). */
export type CorporateThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Theme template (ID: {004840B3-205A-4EAF-97F5-31BADE6D91D5}). */
export type CorporateThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Theme template (ID: {004840B3-205A-4EAF-97F5-31BADE6D91D5}). */
export type CorporateThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Theme template (ID: {004840B3-205A-4EAF-97F5-31BADE6D91D5}). */
export type CorporateThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Themes Folder template (ID: {83FFABFD-08A5-47AC-803D-1FF2B41EF0BE}). */
export type CorporateThemesFolder = Item & {
  __typename?: 'CorporateThemesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Themes Folder template (ID: {83FFABFD-08A5-47AC-803D-1FF2B41EF0BE}). */
export type CorporateThemesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Themes Folder template (ID: {83FFABFD-08A5-47AC-803D-1FF2B41EF0BE}). */
export type CorporateThemesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Themes Folder template (ID: {83FFABFD-08A5-47AC-803D-1FF2B41EF0BE}). */
export type CorporateThemesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Themes Folder template (ID: {83FFABFD-08A5-47AC-803D-1FF2B41EF0BE}). */
export type CorporateThemesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Themes Folder template (ID: {83FFABFD-08A5-47AC-803D-1FF2B41EF0BE}). */
export type CorporateThemesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Article Corporate Theme/Corporate Themes Folder template (ID: {83FFABFD-08A5-47AC-803D-1FF2B41EF0BE}). */
export type CorporateThemesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Country template (ID: {51A43ECF-9453-4514-9312-B7FF4D87AC8F}). */
export type Country = Item & {
  __typename?: 'Country';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** availableLanguages (ID: {41D0E3EA-BD5D-46BB-8D63-31413E573B28}). */
  availableLanguages?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** code (ID: {104244CE-985C-4E0C-BEF4-E9E491355AD6}). */
  code?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** flag (ID: {6150930A-AD50-4A85-8DBF-1A26000BDCCA}). */
  flag?: Maybe<ImageField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {6B0BA483-47E7-46A6-B3E9-0A790D7FC3C3}). */
  name_6b0ba48347e746a6b3e90a790d7fc3c3?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Country template (ID: {51A43ECF-9453-4514-9312-B7FF4D87AC8F}). */
export type CountryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Country template (ID: {51A43ECF-9453-4514-9312-B7FF4D87AC8F}). */
export type CountryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Country template (ID: {51A43ECF-9453-4514-9312-B7FF4D87AC8F}). */
export type CountryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Country template (ID: {51A43ECF-9453-4514-9312-B7FF4D87AC8F}). */
export type CountryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Country template (ID: {51A43ECF-9453-4514-9312-B7FF4D87AC8F}). */
export type CountryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Country template (ID: {51A43ECF-9453-4514-9312-B7FF4D87AC8F}). */
export type CountryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Code template (ID: {4547CCEC-B6E8-48DE-8F27-D5B262508A58}). */
export type CountryIsoCode = Item & {
  __typename?: 'CountryISOCode';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** countryCode (ID: {F29D4F13-09C2-404F-8C70-B6054E4DAD02}). */
  countryCode?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Code template (ID: {4547CCEC-B6E8-48DE-8F27-D5B262508A58}). */
export type CountryIsoCodeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Code template (ID: {4547CCEC-B6E8-48DE-8F27-D5B262508A58}). */
export type CountryIsoCodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Code template (ID: {4547CCEC-B6E8-48DE-8F27-D5B262508A58}). */
export type CountryIsoCodeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Code template (ID: {4547CCEC-B6E8-48DE-8F27-D5B262508A58}). */
export type CountryIsoCodeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Code template (ID: {4547CCEC-B6E8-48DE-8F27-D5B262508A58}). */
export type CountryIsoCodeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Code template (ID: {4547CCEC-B6E8-48DE-8F27-D5B262508A58}). */
export type CountryIsoCodeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Codes Folder template (ID: {C1D98DFD-869E-4474-9711-E2BC41CD9FDC}). */
export type CountryIsoCodesFolder = Item & {
  __typename?: 'CountryISOCodesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Codes Folder template (ID: {C1D98DFD-869E-4474-9711-E2BC41CD9FDC}). */
export type CountryIsoCodesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Codes Folder template (ID: {C1D98DFD-869E-4474-9711-E2BC41CD9FDC}). */
export type CountryIsoCodesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Codes Folder template (ID: {C1D98DFD-869E-4474-9711-E2BC41CD9FDC}). */
export type CountryIsoCodesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Codes Folder template (ID: {C1D98DFD-869E-4474-9711-E2BC41CD9FDC}). */
export type CountryIsoCodesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Codes Folder template (ID: {C1D98DFD-869E-4474-9711-E2BC41CD9FDC}). */
export type CountryIsoCodesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Country ISO Codes Folder template (ID: {C1D98DFD-869E-4474-9711-E2BC41CD9FDC}). */
export type CountryIsoCodesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Folder template (ID: {E50B5523-86C2-4A4E-8952-56DBDEF5D2A6}). */
export type CustomerReviewFolder = Item & {
  __typename?: 'CustomerReviewFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Folder template (ID: {E50B5523-86C2-4A4E-8952-56DBDEF5D2A6}). */
export type CustomerReviewFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Folder template (ID: {E50B5523-86C2-4A4E-8952-56DBDEF5D2A6}). */
export type CustomerReviewFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Folder template (ID: {E50B5523-86C2-4A4E-8952-56DBDEF5D2A6}). */
export type CustomerReviewFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Folder template (ID: {E50B5523-86C2-4A4E-8952-56DBDEF5D2A6}). */
export type CustomerReviewFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Folder template (ID: {E50B5523-86C2-4A4E-8952-56DBDEF5D2A6}). */
export type CustomerReviewFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Folder template (ID: {E50B5523-86C2-4A4E-8952-56DBDEF5D2A6}). */
export type CustomerReviewFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Tile template (ID: {56BA433C-F860-4DBA-9404-989C820C1C2C}). */
export type CustomerReviewTile = Item & {
  __typename?: 'CustomerReviewTile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** authorName (ID: {7C14BDB9-1440-4A70-9CD2-F8D4BD7190E7}). */
  authorName?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {50EA04AB-41B4-44FC-9737-6925EE2A35D4}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Decimal value, allows to specify stars value with step: 0.1, min value: 1, max value: 5 */
  stars?: Maybe<TextField>;
  /** This field allows to specify {token.stars} keyword that will be dynamically substituted by formatted value from Stars field.  For example value "Our clients rate the call {token.stars} stars our of 5" with Stars field been setted as 4.6 will be presented as  "Our clients rate the call 4.6 stars our of 5" */
  starsDescription?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {339DAF6A-09AA-4C10-9893-63B03A1F2A9F}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Tile template (ID: {56BA433C-F860-4DBA-9404-989C820C1C2C}). */
export type CustomerReviewTileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Tile template (ID: {56BA433C-F860-4DBA-9404-989C820C1C2C}). */
export type CustomerReviewTileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Tile template (ID: {56BA433C-F860-4DBA-9404-989C820C1C2C}). */
export type CustomerReviewTileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Tile template (ID: {56BA433C-F860-4DBA-9404-989C820C1C2C}). */
export type CustomerReviewTileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Tile template (ID: {56BA433C-F860-4DBA-9404-989C820C1C2C}). */
export type CustomerReviewTileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Customer Review/Customer Review Tile template (ID: {56BA433C-F860-4DBA-9404-989C820C1C2C}). */
export type CustomerReviewTileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Customer Review Tile Parameters Template template (ID: {B34C29E1-3D4A-49B6-B5F0-70C5FC3AD411}). */
export type CustomerReviewTileParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'CustomerReviewTileParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {CAC6A977-797B-4C65-9DB8-F94F22DCA60B}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** size (ID: {46254E39-94E5-4C68-BDF1-5FABDF0A9AC9}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Customer Review Tile Parameters Template template (ID: {B34C29E1-3D4A-49B6-B5F0-70C5FC3AD411}). */
export type CustomerReviewTileParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Customer Review Tile Parameters Template template (ID: {B34C29E1-3D4A-49B6-B5F0-70C5FC3AD411}). */
export type CustomerReviewTileParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Customer Review Tile Parameters Template template (ID: {B34C29E1-3D4A-49B6-B5F0-70C5FC3AD411}). */
export type CustomerReviewTileParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Customer Review Tile Parameters Template template (ID: {B34C29E1-3D4A-49B6-B5F0-70C5FC3AD411}). */
export type CustomerReviewTileParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Customer Review Tile Parameters Template template (ID: {B34C29E1-3D4A-49B6-B5F0-70C5FC3AD411}). */
export type CustomerReviewTileParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Customer Review Tile Parameters Template template (ID: {B34C29E1-3D4A-49B6-B5F0-70C5FC3AD411}). */
export type CustomerReviewTileParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Document Category Map template (ID: {B875A34D-457E-4478-B565-4170B7D398C3}). */
export type DataBridgeDocumentCategoryMap = Item & {
  __typename?: 'DataBridgeDocumentCategoryMap';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** databridgeDocumentCategory (ID: {941CB9E0-9C13-4815-AFD5-D69135CE4795}). */
  databridgeDocumentCategory?: Maybe<TextField>;
  /** displayDocumentCategory (ID: {133C159C-23D3-4742-8ABE-3A71C9960CD4}). */
  displayDocumentCategory?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Document Category Map template (ID: {B875A34D-457E-4478-B565-4170B7D398C3}). */
export type DataBridgeDocumentCategoryMapAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Document Category Map template (ID: {B875A34D-457E-4478-B565-4170B7D398C3}). */
export type DataBridgeDocumentCategoryMapChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Document Category Map template (ID: {B875A34D-457E-4478-B565-4170B7D398C3}). */
export type DataBridgeDocumentCategoryMapFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Document Category Map template (ID: {B875A34D-457E-4478-B565-4170B7D398C3}). */
export type DataBridgeDocumentCategoryMapFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Document Category Map template (ID: {B875A34D-457E-4478-B565-4170B7D398C3}). */
export type DataBridgeDocumentCategoryMapHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Document Category Map template (ID: {B875A34D-457E-4478-B565-4170B7D398C3}). */
export type DataBridgeDocumentCategoryMapIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund template (ID: {20954D8C-B17F-4FD2-9B5D-BDFBC5CBF9C4}). */
export type DataBridgeFund = Item & _Footnotes & _ManualKeyInformation & {
  __typename?: 'DataBridgeFund';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** cefFiscalYearEnd (ID: {36090CDB-E822-43AA-A941-8DAD83E90944}). */
  cefFiscalYearEnd?: Maybe<TextField>;
  /** cefGrossExpenseRatio (ID: {A82CC7EA-1832-4169-B963-F4B6A99A04C9}). */
  cefGrossExpenseRatio?: Maybe<TextField>;
  /** cefManagedAssets (ID: {46F2EAC2-858F-4F01-AABF-8899EC39C967}). */
  cefManagedAssets?: Maybe<TextField>;
  /** cefMarketDistributionRate (ID: {49217872-A9FB-411B-9D18-E03AD788C21B}). */
  cefMarketDistributionRate?: Maybe<TextField>;
  /** cefNavDistributionRate (ID: {F9ADB002-5758-410F-90A7-6E7002B4F83E}). */
  cefNavDistributionRate?: Maybe<TextField>;
  /** cefNetAssets (ID: {B5DD3507-1038-40A7-9A09-F2F782DA3EBE}). */
  cefNetAssets?: Maybe<TextField>;
  /** cefNetExpenseRatio (ID: {35D637EF-F66B-452E-B95B-207681B9ED6D}). */
  cefNetExpenseRatio?: Maybe<TextField>;
  /** cefSharesOutstanding (ID: {DC32AA50-4061-41D1-B68E-9D1D7058BC6A}). */
  cefSharesOutstanding?: Maybe<TextField>;
  /** cefTickerSymbol (ID: {FA32E335-E08D-4ED2-A5BF-89E25E7D46C6}). */
  cefTickerSymbol?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** countryInvestors (ID: {988650DA-FEF7-4BF9-AF66-A2B3F3F6E2D1}). */
  countryInvestors?: Maybe<TextField>;
  /** databridgeFundAssetClass (ID: {0CE23BFF-8AD0-4381-A038-F587774DDE29}). */
  databridgeFundAssetClass?: Maybe<TextField>;
  /** databridgeFundId (ID: {86C95EC0-E4FF-432C-A4B9-C5443E343729}). */
  databridgeFundId?: Maybe<TextField>;
  /** databridgeFundName (ID: {F3CC739C-1058-4626-9579-4E06E70E11D0}). */
  databridgeFundName?: Maybe<TextField>;
  /** databridgeFundProductType (ID: {938D855C-1E32-4C94-933C-D2D25EB3F07D}). */
  databridgeFundProductType?: Maybe<TextField>;
  /** databridgeFundSfdrClassification (ID: {439FACA2-22AB-4A5A-8075-2617B2BF3DC0}). */
  databridgeFundSfdrClassification?: Maybe<TextField>;
  /** databridgeFundType (ID: {0D5F7316-EA27-41C5-8BEF-19D386D764D8}). */
  databridgeFundType?: Maybe<TextField>;
  /** databridgeHoldingsFootnote (ID: {D9BD8C0C-7C9B-4CEF-B6CA-6F9DF0939FC2}). */
  databridgeHoldingsFootnote?: Maybe<RichTextField>;
  /** databridgeKeyInformationFootnote (ID: {8ADED624-9A31-4227-909D-B59EB556FA64}). */
  databridgeKeyInformationFootnote?: Maybe<RichTextField>;
  /** databridgePerformanceFootnote (ID: {1FF1C62A-BBB8-47A1-B29A-71D93EF78E23}). */
  databridgePerformanceFootnote?: Maybe<RichTextField>;
  /** databridgeRiskAnalysisFootnote (ID: {82C18EF2-D617-4B30-8614-9AC2ABEC6789}). */
  databridgeRiskAnalysisFootnote?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Only applicable for fund ranges: UK Investment Trusts, UK Investment Trust (SLI), US Investment Trusts. */
  investmentTrustLink?: Maybe<LinkField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** lastUpdate (ID: {28AF405B-85FC-430C-8297-7F3F3A06B8CA}). */
  lastUpdate?: Maybe<DateField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** podcastDescription (ID: {700B2F9F-0426-49A4-8261-359B6DA2654D}). */
  podcastDescription?: Maybe<RichTextField>;
  /** podcastTitle (ID: {5FF5238B-1503-4207-A930-2EC33707B122}). */
  podcastTitle?: Maybe<TextField>;
  /** podcastTranscript (ID: {5BEB4C07-E19D-4239-A114-81CB38709BE8}). */
  podcastTranscript?: Maybe<RichTextField>;
  /** podcastUrl (ID: {C559E14E-A44B-4A71-A654-84E9A9CB0641}). */
  podcastUrl?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund template (ID: {20954D8C-B17F-4FD2-9B5D-BDFBC5CBF9C4}). */
export type DataBridgeFundAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund template (ID: {20954D8C-B17F-4FD2-9B5D-BDFBC5CBF9C4}). */
export type DataBridgeFundChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund template (ID: {20954D8C-B17F-4FD2-9B5D-BDFBC5CBF9C4}). */
export type DataBridgeFundFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund template (ID: {20954D8C-B17F-4FD2-9B5D-BDFBC5CBF9C4}). */
export type DataBridgeFundFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund template (ID: {20954D8C-B17F-4FD2-9B5D-BDFBC5CBF9C4}). */
export type DataBridgeFundHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund template (ID: {20954D8C-B17F-4FD2-9B5D-BDFBC5CBF9C4}). */
export type DataBridgeFundIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund Range Name template (ID: {3D5FA6FB-9977-49A1-95E0-4EB2FB41E373}). */
export type DataBridgeFundRangeName = Item & _Footnotes & {
  __typename?: 'DataBridgeFundRangeName';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** databridgeFundRangeCorrelationId (ID: {17E1173C-3170-46B6-A547-1640F7804246}). */
  databridgeFundRangeCorrelationId?: Maybe<TextField>;
  /** databridgeFundRangeName (ID: {38A1A024-0D1E-4841-94B3-F7ECE98BD4F2}). */
  databridgeFundRangeName?: Maybe<TextField>;
  /** databridgeHoldingsFootnote (ID: {D9BD8C0C-7C9B-4CEF-B6CA-6F9DF0939FC2}). */
  databridgeHoldingsFootnote?: Maybe<RichTextField>;
  /** databridgeKeyInformationFootnote (ID: {8ADED624-9A31-4227-909D-B59EB556FA64}). */
  databridgeKeyInformationFootnote?: Maybe<RichTextField>;
  /** databridgePerformanceFootnote (ID: {1FF1C62A-BBB8-47A1-B29A-71D93EF78E23}). */
  databridgePerformanceFootnote?: Maybe<RichTextField>;
  /** databridgeRiskAnalysisFootnote (ID: {82C18EF2-D617-4B30-8614-9AC2ABEC6789}). */
  databridgeRiskAnalysisFootnote?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** lastUpdate (ID: {FF4530F8-BEF9-4CAD-A07F-58276AD91B8A}). */
  lastUpdate?: Maybe<DateField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund Range Name template (ID: {3D5FA6FB-9977-49A1-95E0-4EB2FB41E373}). */
export type DataBridgeFundRangeNameAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund Range Name template (ID: {3D5FA6FB-9977-49A1-95E0-4EB2FB41E373}). */
export type DataBridgeFundRangeNameChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund Range Name template (ID: {3D5FA6FB-9977-49A1-95E0-4EB2FB41E373}). */
export type DataBridgeFundRangeNameFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund Range Name template (ID: {3D5FA6FB-9977-49A1-95E0-4EB2FB41E373}). */
export type DataBridgeFundRangeNameFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund Range Name template (ID: {3D5FA6FB-9977-49A1-95E0-4EB2FB41E373}). */
export type DataBridgeFundRangeNameHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Fund Range Name template (ID: {3D5FA6FB-9977-49A1-95E0-4EB2FB41E373}). */
export type DataBridgeFundRangeNameIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Settings Folder template (ID: {E085942F-4F63-45B9-A861-B082E7E44E9B}). */
export type DataBridgeSettingsFolder = Item & {
  __typename?: 'DataBridgeSettingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Settings Folder template (ID: {E085942F-4F63-45B9-A861-B082E7E44E9B}). */
export type DataBridgeSettingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Settings Folder template (ID: {E085942F-4F63-45B9-A861-B082E7E44E9B}). */
export type DataBridgeSettingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Settings Folder template (ID: {E085942F-4F63-45B9-A861-B082E7E44E9B}). */
export type DataBridgeSettingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Settings Folder template (ID: {E085942F-4F63-45B9-A861-B082E7E44E9B}). */
export type DataBridgeSettingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Settings Folder template (ID: {E085942F-4F63-45B9-A861-B082E7E44E9B}). */
export type DataBridgeSettingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge Settings Folder template (ID: {E085942F-4F63-45B9-A861-B082E7E44E9B}). */
export type DataBridgeSettingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge ShareClass template (ID: {0FAFE8DC-500E-4D49-B2C7-16EA7B593B01}). */
export type DataBridgeShareClass = Item & _Footnotes & {
  __typename?: 'DataBridgeShareClass';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** countryInvestors (ID: {9DA09807-D0B0-433B-8767-802B0526866A}). */
  countryInvestors?: Maybe<TextField>;
  /** databridgeHoldingsFootnote (ID: {D9BD8C0C-7C9B-4CEF-B6CA-6F9DF0939FC2}). */
  databridgeHoldingsFootnote?: Maybe<RichTextField>;
  /** databridgeKeyInformationFootnote (ID: {8ADED624-9A31-4227-909D-B59EB556FA64}). */
  databridgeKeyInformationFootnote?: Maybe<RichTextField>;
  /** databridgePerformanceFootnote (ID: {1FF1C62A-BBB8-47A1-B29A-71D93EF78E23}). */
  databridgePerformanceFootnote?: Maybe<RichTextField>;
  /** databridgeRiskAnalysisFootnote (ID: {82C18EF2-D617-4B30-8614-9AC2ABEC6789}). */
  databridgeRiskAnalysisFootnote?: Maybe<RichTextField>;
  /** databridgeShareClassId (ID: {AE1024D9-92D6-4860-A3EA-DA89668FC0CC}). */
  databridgeShareClassId?: Maybe<TextField>;
  /** databridgeShareClassIsin (ID: {2A00438D-7FBD-472D-8278-A58BE9CA75E5}). */
  databridgeShareClassIsin?: Maybe<TextField>;
  /** databridgeShareClassName (ID: {AA33C12A-F974-4FD4-95F3-FE74DE7C5699}). */
  databridgeShareClassName?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** lastUpdate (ID: {4AD834EF-8F79-4EB3-A431-0A49FF4F3F83}). */
  lastUpdate?: Maybe<DateField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge ShareClass template (ID: {0FAFE8DC-500E-4D49-B2C7-16EA7B593B01}). */
export type DataBridgeShareClassAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge ShareClass template (ID: {0FAFE8DC-500E-4D49-B2C7-16EA7B593B01}). */
export type DataBridgeShareClassChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge ShareClass template (ID: {0FAFE8DC-500E-4D49-B2C7-16EA7B593B01}). */
export type DataBridgeShareClassFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge ShareClass template (ID: {0FAFE8DC-500E-4D49-B2C7-16EA7B593B01}). */
export type DataBridgeShareClassFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge ShareClass template (ID: {0FAFE8DC-500E-4D49-B2C7-16EA7B593B01}). */
export type DataBridgeShareClassHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Data Bridge ShareClass template (ID: {0FAFE8DC-500E-4D49-B2C7-16EA7B593B01}). */
export type DataBridgeShareClassIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/DataFolder template (ID: {5ECD34F4-B36F-4533-9643-DF41CD8B5036}). */
export type DataFolder = Item & {
  __typename?: 'DataFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/DataFolder template (ID: {5ECD34F4-B36F-4533-9643-DF41CD8B5036}). */
export type DataFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/DataFolder template (ID: {5ECD34F4-B36F-4533-9643-DF41CD8B5036}). */
export type DataFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/DataFolder template (ID: {5ECD34F4-B36F-4533-9643-DF41CD8B5036}). */
export type DataFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/DataFolder template (ID: {5ECD34F4-B36F-4533-9643-DF41CD8B5036}). */
export type DataFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/DataFolder template (ID: {5ECD34F4-B36F-4533-9643-DF41CD8B5036}). */
export type DataFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/DataFolder template (ID: {5ECD34F4-B36F-4533-9643-DF41CD8B5036}). */
export type DataFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configuration template (ID: {62AA32C6-5C12-4D5D-899D-19375D69BB41}). */
export type DatasourceConfiguration = ExtendedOptions & Item & {
  __typename?: 'DatasourceConfiguration';
  /** Additional compatible templates (ID: {F6677A49-0A1D-4BAD-B8BA-4F0F22BDEE64}). */
  additionalCompatibleTemplates?: Maybe<MultilistField>;
  /** AllowPageRelativeLocation (ID: {05A0F1AE-4FD0-44FD-B702-70DBD2D6EFB4}). */
  allowPageRelativeLocation?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Can select Page as a data source (ID: {A3411FF6-C978-40AA-B059-A49B9CA2209B}). */
  canSelectPageAsADataSource?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CompatibleRenderings (ID: {68BFA8E2-0F2E-4AFA-B95B-A44B6B75FFCB}). */
  compatibleRenderings?: Maybe<MultilistField>;
  /** DatasourceLocation (ID: {A69FEF91-CD50-4B8C-917A-3B5435029570}). */
  datasourceLocation?: Maybe<MultilistField>;
  /** DatasourceTemplate (ID: {DFFBDFAD-2FAE-47C2-8058-1293968F91EA}). */
  datasourceTemplate?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingCssClass (ID: {34E81E40-1D4D-45B0-BCF1-A0FFE5521685}). */
  renderingCssClass?: Maybe<TextField>;
  /** RenderingViewPath (ID: {49B9D6C5-9551-4BA4-840E-74D5582256C0}). */
  renderingViewPath?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configuration template (ID: {62AA32C6-5C12-4D5D-899D-19375D69BB41}). */
export type DatasourceConfigurationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configuration template (ID: {62AA32C6-5C12-4D5D-899D-19375D69BB41}). */
export type DatasourceConfigurationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configuration template (ID: {62AA32C6-5C12-4D5D-899D-19375D69BB41}). */
export type DatasourceConfigurationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configuration template (ID: {62AA32C6-5C12-4D5D-899D-19375D69BB41}). */
export type DatasourceConfigurationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configuration template (ID: {62AA32C6-5C12-4D5D-899D-19375D69BB41}). */
export type DatasourceConfigurationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configuration template (ID: {62AA32C6-5C12-4D5D-899D-19375D69BB41}). */
export type DatasourceConfigurationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configurations template (ID: {F86FE270-00A4-492F-BFAF-5BF27E40CE13}). */
export type DatasourceConfigurations = Item & _SharedRoot & {
  __typename?: 'DatasourceConfigurations';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configurations template (ID: {F86FE270-00A4-492F-BFAF-5BF27E40CE13}). */
export type DatasourceConfigurationsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configurations template (ID: {F86FE270-00A4-492F-BFAF-5BF27E40CE13}). */
export type DatasourceConfigurationsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configurations template (ID: {F86FE270-00A4-492F-BFAF-5BF27E40CE13}). */
export type DatasourceConfigurationsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configurations template (ID: {F86FE270-00A4-492F-BFAF-5BF27E40CE13}). */
export type DatasourceConfigurationsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configurations template (ID: {F86FE270-00A4-492F-BFAF-5BF27E40CE13}). */
export type DatasourceConfigurationsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Datasource Configurations template (ID: {F86FE270-00A4-492F-BFAF-5BF27E40CE13}). */
export type DatasourceConfigurationsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Workflows/Datasource Workflow Action template (ID: {DEF0AA0D-3446-41AE-B307-EC7BA429CE50}). */
export type DatasourceWorkflowAction = Action & Item & {
  __typename?: 'DatasourceWorkflowAction';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Command Item (ID: {8273A3DB-FAC0-44D6-AED0-29E2E039E8F9}). */
  commandItem?: Maybe<LookupField>;
  /** Datasource Validation (ID: {4AE36874-58D6-44C4-96F7-23287A22848D}). */
  datasourceValidation?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Item Validation (ID: {73C28AB2-3072-4BB8-B85C-181A128650D6}). */
  itemValidation?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parameters (ID: {1507131D-CEE3-49E9-AF32-DE5403A37B49}). */
  parameters?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Scope (ID: {B5757325-3263-4DAF-B6CD-811629CF4794}). */
  scope?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {A291A22B-99E2-46BB-A27B-8EC744275396}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Workflows/Datasource Workflow Action template (ID: {DEF0AA0D-3446-41AE-B307-EC7BA429CE50}). */
export type DatasourceWorkflowActionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Workflows/Datasource Workflow Action template (ID: {DEF0AA0D-3446-41AE-B307-EC7BA429CE50}). */
export type DatasourceWorkflowActionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Workflows/Datasource Workflow Action template (ID: {DEF0AA0D-3446-41AE-B307-EC7BA429CE50}). */
export type DatasourceWorkflowActionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Workflows/Datasource Workflow Action template (ID: {DEF0AA0D-3446-41AE-B307-EC7BA429CE50}). */
export type DatasourceWorkflowActionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Workflows/Datasource Workflow Action template (ID: {DEF0AA0D-3446-41AE-B307-EC7BA429CE50}). */
export type DatasourceWorkflowActionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Workflows/Datasource Workflow Action template (ID: {DEF0AA0D-3446-41AE-B307-EC7BA429CE50}). */
export type DatasourceWorkflowActionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DateFacet template (ID: {43A7D301-17C0-44FF-BF47-E0C4CF6C891E}). */
export type DateFacet = Facet & Item & {
  __typename?: 'DateFacet';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Client Side Handle (ID: {7F42ED80-33F0-4C98-A1E7-B15BE7551C36}). */
  clientSideHandle?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayName (ID: {5DE17054-0141-4E58-935B-FEC623A60806}). */
  displayName_5de1705401414e58935bfec623a60806?: Maybe<TextField>;
  /** Enabled (ID: {3D0FE806-D0E3-4254-96BE-A60899C7D2E6}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Global (ID: {182BD0F4-C902-4A19-A1BA-D189CAA18E1B}). */
  global?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Minimum Number of Items (ID: {8A3AC1B8-8CC1-4DD4-8766-9803F1601741}). */
  minimumNumberOfItems?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {31CA077F-EF38-4980-8A24-05408031B2BC}). */
  name_31ca077fef3849808a2405408031b2bc?: Maybe<TextField>;
  /** Parameters (ID: {0E23BB51-C071-41B5-9D83-AC410B89B85A}). */
  parameters?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {FAE92C1E-9E2C-4209-89EB-C256D55E3D7F}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DateFacet template (ID: {43A7D301-17C0-44FF-BF47-E0C4CF6C891E}). */
export type DateFacetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DateFacet template (ID: {43A7D301-17C0-44FF-BF47-E0C4CF6C891E}). */
export type DateFacetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DateFacet template (ID: {43A7D301-17C0-44FF-BF47-E0C4CF6C891E}). */
export type DateFacetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DateFacet template (ID: {43A7D301-17C0-44FF-BF47-E0C4CF6C891E}). */
export type DateFacetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DateFacet template (ID: {43A7D301-17C0-44FF-BF47-E0C4CF6C891E}). */
export type DateFacetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DateFacet template (ID: {43A7D301-17C0-44FF-BF47-E0C4CF6C891E}). */
export type DateFacetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type DateField = ItemField & {
  __typename?: 'DateField';
  /** The field's value as a UTC epoch date suitable for constructing a Javascript Date. */
  dateValue?: Maybe<Scalars['Long']['output']>;
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The field's value as a preformatted date. */
  formattedDateValue?: Maybe<Scalars['String']['output']>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type DateFieldFormattedDateValueArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DateFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Date Filter template (ID: {F84E329F-1CBA-4A4E-8910-C7876E9CC29D}). */
export type DateFilter = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'DateFilter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** From Date Default Offset (ID: {0D75F77D-164B-462D-9ECE-9FBCE0BAEB82}). */
  fromDateDefaultOffset?: Maybe<TextField>;
  /** From Date Display Format (ID: {FC744825-117E-4CF7-B89E-D6E19B2D3D29}). */
  fromDateDisplayFormat?: Maybe<LookupField>;
  /** From Date Months Shown (ID: {DBA33AFF-9EF2-46F4-8272-0B528EB2838A}). */
  fromDateMonthsShown?: Maybe<CheckboxField>;
  /** From Date Past Days (ID: {8C97BF88-A812-49F8-85CF-FA2B5731E3A9}). */
  fromDatePastDays?: Maybe<CheckboxField>;
  /** From Date Visible (ID: {C3D8C991-9017-49E8-A27A-0ACF31E0B625}). */
  fromDateVisible?: Maybe<CheckboxField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** To Date Default Offset (ID: {1E9B8C42-F855-4F16-B4AA-F74B65844D89}). */
  toDateDefaultOffset?: Maybe<TextField>;
  /** To Date Display Format (ID: {89EA903E-DFC7-4A1F-B43D-C25A0020AF91}). */
  toDateDisplayFormat?: Maybe<LookupField>;
  /** To Date Future Days (ID: {AA8505BF-733A-4F8C-95DA-AAB57249B736}). */
  toDateFutureDays?: Maybe<CheckboxField>;
  /** To Date Months Shown (ID: {E18DE156-CE22-44BA-9D6C-A9F7E922AF0E}). */
  toDateMonthsShown?: Maybe<CheckboxField>;
  /** To Date Visible (ID: {467E2993-A903-47C4-8E17-D80E3388DE03}). */
  toDateVisible?: Maybe<CheckboxField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Date Filter template (ID: {F84E329F-1CBA-4A4E-8910-C7876E9CC29D}). */
export type DateFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Date Filter template (ID: {F84E329F-1CBA-4A4E-8910-C7876E9CC29D}). */
export type DateFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Date Filter template (ID: {F84E329F-1CBA-4A4E-8910-C7876E9CC29D}). */
export type DateFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Date Filter template (ID: {F84E329F-1CBA-4A4E-8910-C7876E9CC29D}). */
export type DateFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Date Filter template (ID: {F84E329F-1CBA-4A4E-8910-C7876E9CC29D}). */
export type DateFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Date Filter template (ID: {F84E329F-1CBA-4A4E-8910-C7876E9CC29D}). */
export type DateFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Date Filter Folder template (ID: {8D85D00E-ECDE-4B9A-A53C-0C01D60274E4}). */
export type DateFilterFolder = Item & {
  __typename?: 'DateFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Date Filter Folder template (ID: {8D85D00E-ECDE-4B9A-A53C-0C01D60274E4}). */
export type DateFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Date Filter Folder template (ID: {8D85D00E-ECDE-4B9A-A53C-0C01D60274E4}). */
export type DateFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Date Filter Folder template (ID: {8D85D00E-ECDE-4B9A-A53C-0C01D60274E4}). */
export type DateFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Date Filter Folder template (ID: {8D85D00E-ECDE-4B9A-A53C-0C01D60274E4}). */
export type DateFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Date Filter Folder template (ID: {8D85D00E-ECDE-4B9A-A53C-0C01D60274E4}). */
export type DateFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Date Filter Folder template (ID: {8D85D00E-ECDE-4B9A-A53C-0C01D60274E4}). */
export type DateFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Date Filter template (ID: {AD89C1F1-E991-48EF-8659-38AB13AA28F1}). */
export type DateFilter_Ad89c1f1e99148ef865938ab13aa28f1 = FacetSelectorConfigBase & Item & {
  __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Facet (ID: {734F9A5A-C02A-4D34-87E8-29C732D8EB67}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** From Date Text (ID: {3DC2D905-C97A-4C68-A24F-67A8181441F3}). */
  fromDateText?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** To Date Text (ID: {7B6F8374-8FAA-4CC0-BEFE-B6DE5D864FC1}). */
  toDateText?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Date Filter template (ID: {AD89C1F1-E991-48EF-8659-38AB13AA28F1}). */
export type DateFilter_Ad89c1f1e99148ef865938ab13aa28f1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Date Filter template (ID: {AD89C1F1-E991-48EF-8659-38AB13AA28F1}). */
export type DateFilter_Ad89c1f1e99148ef865938ab13aa28f1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Date Filter template (ID: {AD89C1F1-E991-48EF-8659-38AB13AA28F1}). */
export type DateFilter_Ad89c1f1e99148ef865938ab13aa28f1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Date Filter template (ID: {AD89C1F1-E991-48EF-8659-38AB13AA28F1}). */
export type DateFilter_Ad89c1f1e99148ef865938ab13aa28f1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Date Filter template (ID: {AD89C1F1-E991-48EF-8659-38AB13AA28F1}). */
export type DateFilter_Ad89c1f1e99148ef865938ab13aa28f1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Date Filter template (ID: {AD89C1F1-E991-48EF-8659-38AB13AA28F1}). */
export type DateFilter_Ad89c1f1e99148ef865938ab13aa28f1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Default Column Layout template (ID: {5AA37700-C308-408D-B2ED-EA773CC94E25}). */
export type DefaultColumnLayout = GridDefinition & Item & PlaceholderWrapper & {
  __typename?: 'DefaultColumnLayout';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DefaultGridParameters (ID: {CBB899CD-DAD4-4B72-841A-A638E83E5FE5}). */
  defaultGridParameters?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Fixed (ID: {549021D8-F27F-4217-805C-20D686E470D9}). */
  fixed?: Maybe<TextField>;
  /** Flex (ID: {91193E28-C9C9-49EB-916D-87E5AF0F1E34}). */
  flex?: Maybe<TextField>;
  /** GridBodyViewPath (ID: {DC986105-2CD6-4A4F-9B2D-57FBB4858E56}). */
  gridBodyViewPath?: Maybe<TextField>;
  /** Grid Definition (ID: {96B0D7F6-FE54-44EA-A6A6-4AE308411488}). */
  gridDefinition?: Maybe<LookupField>;
  /** GridFieldParserType (ID: {0B4D72A7-BE75-4690-805D-DDD564B1DD94}). */
  gridFieldParserType?: Maybe<TextField>;
  /** Grid Theme (ID: {E0B0A836-40BD-4526-998A-649D3AF28AD5}). */
  gridTheme?: Maybe<LookupField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {21624C80-7821-4EED-B788-C716C5C1A088}). */
  name_21624c8078214eedb788c716c5c1a088?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingParametersFieldType (ID: {228606CA-DE6D-4803-AF3C-A420C90F315D}). */
  renderingParametersFieldType?: Maybe<TextField>;
  /** Row Class (ID: {2105078E-C785-4DB4-9BBF-FF78F2179A17}). */
  rowClass?: Maybe<TextField>;
  /** Row Container Class (ID: {BCEE3E9E-E00C-48AE-B723-A0741FED842B}). */
  rowContainerClass?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Wrapping Class (ID: {BC8986B2-5872-466F-AFEB-390C9A3EDAA4}). */
  wrappingClass?: Maybe<TextField>;
  /** Wrapping Tag (ID: {2341030D-19BA-46E1-91FE-9DF617284932}). */
  wrappingTag?: Maybe<TextField>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Default Column Layout template (ID: {5AA37700-C308-408D-B2ED-EA773CC94E25}). */
export type DefaultColumnLayoutAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Default Column Layout template (ID: {5AA37700-C308-408D-B2ED-EA773CC94E25}). */
export type DefaultColumnLayoutChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Default Column Layout template (ID: {5AA37700-C308-408D-B2ED-EA773CC94E25}). */
export type DefaultColumnLayoutFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Default Column Layout template (ID: {5AA37700-C308-408D-B2ED-EA773CC94E25}). */
export type DefaultColumnLayoutFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Default Column Layout template (ID: {5AA37700-C308-408D-B2ED-EA773CC94E25}). */
export type DefaultColumnLayoutHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Default Column Layout template (ID: {5AA37700-C308-408D-B2ED-EA773CC94E25}). */
export type DefaultColumnLayoutIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mapping template (ID: {67294E0B-CB8D-4881-BBB0-906DA593D979}). */
export type DefaultShareclassMapping = Item & {
  __typename?: 'DefaultShareclassMapping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** fundRange (ID: {F51DC4BD-EB88-48AC-9618-7F2B150D2580}). */
  fundRange?: Maybe<LookupField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Share class which name begins with the specified string will be selected by default. */
  shareclassName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mapping template (ID: {67294E0B-CB8D-4881-BBB0-906DA593D979}). */
export type DefaultShareclassMappingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mapping template (ID: {67294E0B-CB8D-4881-BBB0-906DA593D979}). */
export type DefaultShareclassMappingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mapping template (ID: {67294E0B-CB8D-4881-BBB0-906DA593D979}). */
export type DefaultShareclassMappingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mapping template (ID: {67294E0B-CB8D-4881-BBB0-906DA593D979}). */
export type DefaultShareclassMappingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mapping template (ID: {67294E0B-CB8D-4881-BBB0-906DA593D979}). */
export type DefaultShareclassMappingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mapping template (ID: {67294E0B-CB8D-4881-BBB0-906DA593D979}). */
export type DefaultShareclassMappingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mappings template (ID: {BEAE1976-3B9A-4A87-9786-0152901D6BC9}). */
export type DefaultShareclassMappings = Item & {
  __typename?: 'DefaultShareclassMappings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mappings template (ID: {BEAE1976-3B9A-4A87-9786-0152901D6BC9}). */
export type DefaultShareclassMappingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mappings template (ID: {BEAE1976-3B9A-4A87-9786-0152901D6BC9}). */
export type DefaultShareclassMappingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mappings template (ID: {BEAE1976-3B9A-4A87-9786-0152901D6BC9}). */
export type DefaultShareclassMappingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mappings template (ID: {BEAE1976-3B9A-4A87-9786-0152901D6BC9}). */
export type DefaultShareclassMappingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mappings template (ID: {BEAE1976-3B9A-4A87-9786-0152901D6BC9}). */
export type DefaultShareclassMappingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Default Shareclass Mapping/Default Shareclass Mappings template (ID: {BEAE1976-3B9A-4A87-9786-0152901D6BC9}). */
export type DefaultShareclassMappingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight template (ID: {73CBEBF6-8827-423D-A722-7667CDAF7015}). */
export type DescriptiveHighlight = Item & {
  __typename?: 'DescriptiveHighlight';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight template (ID: {73CBEBF6-8827-423D-A722-7667CDAF7015}). */
export type DescriptiveHighlightAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight template (ID: {73CBEBF6-8827-423D-A722-7667CDAF7015}). */
export type DescriptiveHighlightChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight template (ID: {73CBEBF6-8827-423D-A722-7667CDAF7015}). */
export type DescriptiveHighlightFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight template (ID: {73CBEBF6-8827-423D-A722-7667CDAF7015}). */
export type DescriptiveHighlightFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight template (ID: {73CBEBF6-8827-423D-A722-7667CDAF7015}). */
export type DescriptiveHighlightHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight template (ID: {73CBEBF6-8827-423D-A722-7667CDAF7015}). */
export type DescriptiveHighlightIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Folder template (ID: {AEF47B95-1814-48D6-9785-8D25C250231E}). */
export type DescriptiveHighlightFolder = Item & {
  __typename?: 'DescriptiveHighlightFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Folder template (ID: {AEF47B95-1814-48D6-9785-8D25C250231E}). */
export type DescriptiveHighlightFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Folder template (ID: {AEF47B95-1814-48D6-9785-8D25C250231E}). */
export type DescriptiveHighlightFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Folder template (ID: {AEF47B95-1814-48D6-9785-8D25C250231E}). */
export type DescriptiveHighlightFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Folder template (ID: {AEF47B95-1814-48D6-9785-8D25C250231E}). */
export type DescriptiveHighlightFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Folder template (ID: {AEF47B95-1814-48D6-9785-8D25C250231E}). */
export type DescriptiveHighlightFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Folder template (ID: {AEF47B95-1814-48D6-9785-8D25C250231E}). */
export type DescriptiveHighlightFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Item template (ID: {54039F27-4FCB-43D8-A89F-446B6939AA73}). */
export type DescriptiveHighlightItem = Item & {
  __typename?: 'DescriptiveHighlightItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {BD3767AA-18F3-405D-B47C-0778B3366C80}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** icon (ID: {39359BDC-3175-4F2C-8DB0-7A639BBA2A8D}). */
  icon_39359bdc31754f2c8db07a639bba2a8d?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {EA13DD52-901C-48A3-8026-0DBBA572E643}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Item template (ID: {54039F27-4FCB-43D8-A89F-446B6939AA73}). */
export type DescriptiveHighlightItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Item template (ID: {54039F27-4FCB-43D8-A89F-446B6939AA73}). */
export type DescriptiveHighlightItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Item template (ID: {54039F27-4FCB-43D8-A89F-446B6939AA73}). */
export type DescriptiveHighlightItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Item template (ID: {54039F27-4FCB-43D8-A89F-446B6939AA73}). */
export type DescriptiveHighlightItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Item template (ID: {54039F27-4FCB-43D8-A89F-446B6939AA73}). */
export type DescriptiveHighlightItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Descriptive Highlight/Descriptive Highlight Item template (ID: {54039F27-4FCB-43D8-A89F-446B6939AA73}). */
export type DescriptiveHighlightItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Descriptive Highlight Parameters Template template (ID: {ED178FB3-0B38-4197-A08A-08233D65AF57}). */
export type DescriptiveHighlightParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'DescriptiveHighlightParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {57585F38-B758-4575-B2A7-9CAA12E38512}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Descriptive Highlight Parameters Template template (ID: {ED178FB3-0B38-4197-A08A-08233D65AF57}). */
export type DescriptiveHighlightParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Descriptive Highlight Parameters Template template (ID: {ED178FB3-0B38-4197-A08A-08233D65AF57}). */
export type DescriptiveHighlightParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Descriptive Highlight Parameters Template template (ID: {ED178FB3-0B38-4197-A08A-08233D65AF57}). */
export type DescriptiveHighlightParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Descriptive Highlight Parameters Template template (ID: {ED178FB3-0B38-4197-A08A-08233D65AF57}). */
export type DescriptiveHighlightParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Descriptive Highlight Parameters Template template (ID: {ED178FB3-0B38-4197-A08A-08233D65AF57}). */
export type DescriptiveHighlightParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Descriptive Highlight Parameters Template template (ID: {ED178FB3-0B38-4197-A08A-08233D65AF57}). */
export type DescriptiveHighlightParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device template (ID: {BCA0E629-150F-41DD-893B-F4B65338C0B7}). */
export type Device = GridItemBase & Item & {
  __typename?: 'Device';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BreakpointMax (ID: {39D6D2C4-F31E-4310-AB2D-F6D5C9CB89FD}). */
  breakpointMax?: Maybe<TextField>;
  /** BreakpointMin (ID: {3B2C405A-5A69-4CE9-A28A-0E72715F159A}). */
  breakpointMin?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Tooltip (ID: {B55A9065-9589-41D8-997B-9B4592852134}). */
  tooltip?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device template (ID: {BCA0E629-150F-41DD-893B-F4B65338C0B7}). */
export type DeviceAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device template (ID: {BCA0E629-150F-41DD-893B-F4B65338C0B7}). */
export type DeviceChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device template (ID: {BCA0E629-150F-41DD-893B-F4B65338C0B7}). */
export type DeviceFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device template (ID: {BCA0E629-150F-41DD-893B-F4B65338C0B7}). */
export type DeviceFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device template (ID: {BCA0E629-150F-41DD-893B-F4B65338C0B7}). */
export type DeviceHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device template (ID: {BCA0E629-150F-41DD-893B-F4B65338C0B7}). */
export type DeviceIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Device template (ID: {7C27EC70-F42E-4042-8A0F-ABAA2F8EDA18}). */
export type Device_7c27ec70f42e40428a0fabaa2f8eda18 = Item & _Icon & _Name & _StackBreakpoint & _Type & _Width & {
  __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Icon (ID: {BF2F5042-9481-488D-A389-1B70A0B78ED8}). */
  icon_bf2f50429481488da3891b70a0b78ed8?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {4F886DD0-63DC-4A32-8765-E7FE78B9B0D2}). */
  name_4f886dd063dc4a328765e7fe78b9b0d2?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** StackAtBreakpoint (ID: {8CBC1CDD-5F1F-4187-B3B0-D81DB7CA675C}). */
  stackAtBreakpoint?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {654618D7-A288-44A2-BFA8-A9E1CCB4EFB8}). */
  type?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Width (ID: {01C5C169-867F-4A45-A8A3-891A3B13B39A}). */
  width?: Maybe<NumberField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Device template (ID: {7C27EC70-F42E-4042-8A0F-ABAA2F8EDA18}). */
export type Device_7c27ec70f42e40428a0fabaa2f8eda18AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Device template (ID: {7C27EC70-F42E-4042-8A0F-ABAA2F8EDA18}). */
export type Device_7c27ec70f42e40428a0fabaa2f8eda18ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Device template (ID: {7C27EC70-F42E-4042-8A0F-ABAA2F8EDA18}). */
export type Device_7c27ec70f42e40428a0fabaa2f8eda18FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Device template (ID: {7C27EC70-F42E-4042-8A0F-ABAA2F8EDA18}). */
export type Device_7c27ec70f42e40428a0fabaa2f8eda18FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Device template (ID: {7C27EC70-F42E-4042-8A0F-ABAA2F8EDA18}). */
export type Device_7c27ec70f42e40428a0fabaa2f8eda18HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Device template (ID: {7C27EC70-F42E-4042-8A0F-ABAA2F8EDA18}). */
export type Device_7c27ec70f42e40428a0fabaa2f8eda18IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Devices template (ID: {2604AC58-99CA-4973-9432-1A958CB8B446}). */
export type Devices = Item & {
  __typename?: 'Devices';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Default (ID: {DC554656-A2F9-4771-9CE9-4B3C28770F20}). */
  default?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Devices template (ID: {2604AC58-99CA-4973-9432-1A958CB8B446}). */
export type DevicesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Devices template (ID: {2604AC58-99CA-4973-9432-1A958CB8B446}). */
export type DevicesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Devices template (ID: {2604AC58-99CA-4973-9432-1A958CB8B446}). */
export type DevicesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Devices template (ID: {2604AC58-99CA-4973-9432-1A958CB8B446}). */
export type DevicesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Devices template (ID: {2604AC58-99CA-4973-9432-1A958CB8B446}). */
export type DevicesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Devices template (ID: {2604AC58-99CA-4973-9432-1A958CB8B446}). */
export type DevicesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Dictionary/Dictionary Domain template (ID: {0A2847E6-9885-450B-B61E-F9E6528480EF}). */
export type DictionaryDomain = {
  /** Fallback Domain (ID: {CD72E892-D8BB-487C-9EB1-6A57C48C72CC}). */
  fallbackDomain?: Maybe<LookupField>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Dictionary Folder template (ID: {518D7272-DC04-4DFB-BBF2-AE6EDB0DAA4B}). */
export type DictionaryFolder = DictionaryDomain & Item & {
  __typename?: 'DictionaryFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Fallback Domain (ID: {CD72E892-D8BB-487C-9EB1-6A57C48C72CC}). */
  fallbackDomain?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Dictionary Folder template (ID: {518D7272-DC04-4DFB-BBF2-AE6EDB0DAA4B}). */
export type DictionaryFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Dictionary Folder template (ID: {518D7272-DC04-4DFB-BBF2-AE6EDB0DAA4B}). */
export type DictionaryFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Dictionary Folder template (ID: {518D7272-DC04-4DFB-BBF2-AE6EDB0DAA4B}). */
export type DictionaryFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Dictionary Folder template (ID: {518D7272-DC04-4DFB-BBF2-AE6EDB0DAA4B}). */
export type DictionaryFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Dictionary Folder template (ID: {518D7272-DC04-4DFB-BBF2-AE6EDB0DAA4B}). */
export type DictionaryFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Dictionary Folder template (ID: {518D7272-DC04-4DFB-BBF2-AE6EDB0DAA4B}). */
export type DictionaryFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryResult = {
  __typename?: 'DictionaryResult';
  /** Pagination info. */
  pageInfo: PageInfo;
  /** All dictionary entries for a specific language. */
  results: Array<Maybe<KeyValuePair>>;
  /** Total number of dictionary entries for the site in a specific language. */
  total: Scalars['Int']['output'];
};

/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/Disqus Parameters template (ID: {E059E196-A180-4685-8F53-1EB3D362A70C}). */
export type DisqusParameters = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'DisqusParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** disqus_category_id (ID: {056A3031-B6BA-4B51-89B0-BA466D5D955E}). */
  disqus_category_id?: Maybe<TextField>;
  /** disqus_identifier (ID: {0746D4F1-5729-4F53-9DB8-6E719E612DFD}). */
  disqus_identifier?: Maybe<TextField>;
  /** disqus_shortname (ID: {B2206189-9784-4D4D-A7F2-1DD31AEAC7FE}). */
  disqus_shortname?: Maybe<TextField>;
  /** disqus_title (ID: {B06B0315-9579-4128-99E5-C66921926335}). */
  disqus_title?: Maybe<TextField>;
  /** disqus_url (ID: {B43C7492-53AF-4764-AA1C-BE8D106D97A2}). */
  disqus_url?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/Disqus Parameters template (ID: {E059E196-A180-4685-8F53-1EB3D362A70C}). */
export type DisqusParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/Disqus Parameters template (ID: {E059E196-A180-4685-8F53-1EB3D362A70C}). */
export type DisqusParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/Disqus Parameters template (ID: {E059E196-A180-4685-8F53-1EB3D362A70C}). */
export type DisqusParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/Disqus Parameters template (ID: {E059E196-A180-4685-8F53-1EB3D362A70C}). */
export type DisqusParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/Disqus Parameters template (ID: {E059E196-A180-4685-8F53-1EB3D362A70C}). */
export type DisqusParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/Disqus Parameters template (ID: {E059E196-A180-4685-8F53-1EB3D362A70C}). */
export type DisqusParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DistanceFacet template (ID: {BB3E6DC9-97AA-47FA-A5EA-7D833A9C4CFC}). */
export type DistanceFacet = Facet & Item & {
  __typename?: 'DistanceFacet';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Client Side Handle (ID: {7F42ED80-33F0-4C98-A1E7-B15BE7551C36}). */
  clientSideHandle?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayName (ID: {5DE17054-0141-4E58-935B-FEC623A60806}). */
  displayName_5de1705401414e58935bfec623a60806?: Maybe<TextField>;
  /** Enabled (ID: {3D0FE806-D0E3-4254-96BE-A60899C7D2E6}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Global (ID: {182BD0F4-C902-4A19-A1BA-D189CAA18E1B}). */
  global?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Minimum Number of Items (ID: {8A3AC1B8-8CC1-4DD4-8766-9803F1601741}). */
  minimumNumberOfItems?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {31CA077F-EF38-4980-8A24-05408031B2BC}). */
  name_31ca077fef3849808a2405408031b2bc?: Maybe<TextField>;
  /** Parameters (ID: {0E23BB51-C071-41B5-9D83-AC410B89B85A}). */
  parameters?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {FAE92C1E-9E2C-4209-89EB-C256D55E3D7F}). */
  type?: Maybe<TextField>;
  /** Unit (ID: {2C054663-0478-41FF-8F50-5D5D69CBA936}). */
  unit?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DistanceFacet template (ID: {BB3E6DC9-97AA-47FA-A5EA-7D833A9C4CFC}). */
export type DistanceFacetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DistanceFacet template (ID: {BB3E6DC9-97AA-47FA-A5EA-7D833A9C4CFC}). */
export type DistanceFacetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DistanceFacet template (ID: {BB3E6DC9-97AA-47FA-A5EA-7D833A9C4CFC}). */
export type DistanceFacetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DistanceFacet template (ID: {BB3E6DC9-97AA-47FA-A5EA-7D833A9C4CFC}). */
export type DistanceFacetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DistanceFacet template (ID: {BB3E6DC9-97AA-47FA-A5EA-7D833A9C4CFC}). */
export type DistanceFacetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/DistanceFacet template (ID: {BB3E6DC9-97AA-47FA-A5EA-7D833A9C4CFC}). */
export type DistanceFacetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Divider template (ID: {9A75501C-B1C6-46C5-9FE9-97D1936124FA}). */
export type Divider = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Divider';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Divider template (ID: {9A75501C-B1C6-46C5-9FE9-97D1936124FA}). */
export type DividerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Divider template (ID: {9A75501C-B1C6-46C5-9FE9-97D1936124FA}). */
export type DividerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Divider template (ID: {9A75501C-B1C6-46C5-9FE9-97D1936124FA}). */
export type DividerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Divider template (ID: {9A75501C-B1C6-46C5-9FE9-97D1936124FA}). */
export type DividerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Divider template (ID: {9A75501C-B1C6-46C5-9FE9-97D1936124FA}). */
export type DividerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Divider template (ID: {9A75501C-B1C6-46C5-9FE9-97D1936124FA}). */
export type DividerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Item template (ID: {DDDDC624-8D8A-4EA7-9E39-68AFDDE5F03A}). */
export type DocumentItem = Item & {
  __typename?: 'DocumentItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {950101DC-995E-40F1-8B3A-740B9B22A8EF}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {39AC65DB-CA7F-479A-98E9-CA78AD18FC1C}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Item template (ID: {DDDDC624-8D8A-4EA7-9E39-68AFDDE5F03A}). */
export type DocumentItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Item template (ID: {DDDDC624-8D8A-4EA7-9E39-68AFDDE5F03A}). */
export type DocumentItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Item template (ID: {DDDDC624-8D8A-4EA7-9E39-68AFDDE5F03A}). */
export type DocumentItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Item template (ID: {DDDDC624-8D8A-4EA7-9E39-68AFDDE5F03A}). */
export type DocumentItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Item template (ID: {DDDDC624-8D8A-4EA7-9E39-68AFDDE5F03A}). */
export type DocumentItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Item template (ID: {DDDDC624-8D8A-4EA7-9E39-68AFDDE5F03A}). */
export type DocumentItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings template (ID: {E43E4B5E-D588-42C6-A26A-3D6CB6D945E6}). */
export type DocumentListings = Item & {
  __typename?: 'DocumentListings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {53254C82-F392-4FF8-B34E-49821EDF41C0}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {0CCCE7DB-9A4E-4FAF-AB0F-0C7CF8F114AB}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings template (ID: {E43E4B5E-D588-42C6-A26A-3D6CB6D945E6}). */
export type DocumentListingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings template (ID: {E43E4B5E-D588-42C6-A26A-3D6CB6D945E6}). */
export type DocumentListingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings template (ID: {E43E4B5E-D588-42C6-A26A-3D6CB6D945E6}). */
export type DocumentListingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings template (ID: {E43E4B5E-D588-42C6-A26A-3D6CB6D945E6}). */
export type DocumentListingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings template (ID: {E43E4B5E-D588-42C6-A26A-3D6CB6D945E6}). */
export type DocumentListingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings template (ID: {E43E4B5E-D588-42C6-A26A-3D6CB6D945E6}). */
export type DocumentListingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings Folder template (ID: {15D6138A-FF8D-4FA7-BE6C-55B6E0D10235}). */
export type DocumentListingsFolder = Item & {
  __typename?: 'DocumentListingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings Folder template (ID: {15D6138A-FF8D-4FA7-BE6C-55B6E0D10235}). */
export type DocumentListingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings Folder template (ID: {15D6138A-FF8D-4FA7-BE6C-55B6E0D10235}). */
export type DocumentListingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings Folder template (ID: {15D6138A-FF8D-4FA7-BE6C-55B6E0D10235}). */
export type DocumentListingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings Folder template (ID: {15D6138A-FF8D-4FA7-BE6C-55B6E0D10235}). */
export type DocumentListingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings Folder template (ID: {15D6138A-FF8D-4FA7-BE6C-55B6E0D10235}). */
export type DocumentListingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Document Listings/Document Listings Folder template (ID: {15D6138A-FF8D-4FA7-BE6C-55B6E0D10235}). */
export type DocumentListingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Document Type Folder template (ID: {BBBF2701-07D7-4B7B-BB33-A486C6EB4FBA}). */
export type DocumentTypeFolder = Item & {
  __typename?: 'DocumentTypeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Document Type Folder template (ID: {BBBF2701-07D7-4B7B-BB33-A486C6EB4FBA}). */
export type DocumentTypeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Document Type Folder template (ID: {BBBF2701-07D7-4B7B-BB33-A486C6EB4FBA}). */
export type DocumentTypeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Document Type Folder template (ID: {BBBF2701-07D7-4B7B-BB33-A486C6EB4FBA}). */
export type DocumentTypeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Document Type Folder template (ID: {BBBF2701-07D7-4B7B-BB33-A486C6EB4FBA}). */
export type DocumentTypeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Document Type Folder template (ID: {BBBF2701-07D7-4B7B-BB33-A486C6EB4FBA}). */
export type DocumentTypeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Document Type/Document Type Folder template (ID: {BBBF2701-07D7-4B7B-BB33-A486C6EB4FBA}). */
export type DocumentTypeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Dominant Language Mapping/Dominant Language Mapping template (ID: {7D787653-BB13-49F3-8893-EFB4F238648E}). */
export type DominantLanguageMapping = Item & {
  __typename?: 'DominantLanguageMapping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Language Map (ID: {8CF2C674-AF6A-4A56-A110-2B3290C551A7}). */
  languageMap?: Maybe<NameValueListField>;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Dominant Language Mapping/Dominant Language Mapping template (ID: {7D787653-BB13-49F3-8893-EFB4F238648E}). */
export type DominantLanguageMappingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Dominant Language Mapping/Dominant Language Mapping template (ID: {7D787653-BB13-49F3-8893-EFB4F238648E}). */
export type DominantLanguageMappingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Dominant Language Mapping/Dominant Language Mapping template (ID: {7D787653-BB13-49F3-8893-EFB4F238648E}). */
export type DominantLanguageMappingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Dominant Language Mapping/Dominant Language Mapping template (ID: {7D787653-BB13-49F3-8893-EFB4F238648E}). */
export type DominantLanguageMappingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Dominant Language Mapping/Dominant Language Mapping template (ID: {7D787653-BB13-49F3-8893-EFB4F238648E}). */
export type DominantLanguageMappingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Dominant Language Mapping/Dominant Language Mapping template (ID: {7D787653-BB13-49F3-8893-EFB4F238648E}). */
export type DominantLanguageMappingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Dropdown template (ID: {5E32E75F-446A-412C-8ED8-922320AE9031}). */
export type Dropdown = AdvancedParameter & IControlType & Item & {
  __typename?: 'Dropdown';
  /** Advanced (ID: {07A98F74-131F-4BA1-9C00-88416C2832A4}). */
  advanced?: Maybe<CheckboxField>;
  /** Allow Empty Value (ID: {7BB96072-0860-41DC-A908-3CCFDF46D30F}). */
  allowEmptyValue?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Tooltip (ID: {9C7CF235-A456-4320-A156-03F1E0CCA6C6}). */
  tooltip?: Maybe<TextField>;
  /** Type (ID: {62CA1C9E-71A4-465F-835E-55BDA7BB270B}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Dropdown template (ID: {5E32E75F-446A-412C-8ED8-922320AE9031}). */
export type DropdownAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Dropdown template (ID: {5E32E75F-446A-412C-8ED8-922320AE9031}). */
export type DropdownChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Dropdown template (ID: {5E32E75F-446A-412C-8ED8-922320AE9031}). */
export type DropdownFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Dropdown template (ID: {5E32E75F-446A-412C-8ED8-922320AE9031}). */
export type DropdownFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Dropdown template (ID: {5E32E75F-446A-412C-8ED8-922320AE9031}). */
export type DropdownHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Device children/Dropdown template (ID: {5E32E75F-446A-412C-8ED8-922320AE9031}). */
export type DropdownIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Dropdown Filter template (ID: {C5EA4FED-F0FA-4E0F-A3EF-793577B375DA}). */
export type DropdownFilter = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & _SortOrder & {
  __typename?: 'DropdownFilter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** SortOrder (ID: {91ED9872-2007-47E9-BF01-1292C1B261B2}). */
  sortOrder?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Dropdown Filter template (ID: {C5EA4FED-F0FA-4E0F-A3EF-793577B375DA}). */
export type DropdownFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Dropdown Filter template (ID: {C5EA4FED-F0FA-4E0F-A3EF-793577B375DA}). */
export type DropdownFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Dropdown Filter template (ID: {C5EA4FED-F0FA-4E0F-A3EF-793577B375DA}). */
export type DropdownFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Dropdown Filter template (ID: {C5EA4FED-F0FA-4E0F-A3EF-793577B375DA}). */
export type DropdownFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Dropdown Filter template (ID: {C5EA4FED-F0FA-4E0F-A3EF-793577B375DA}). */
export type DropdownFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Dropdown Filter template (ID: {C5EA4FED-F0FA-4E0F-A3EF-793577B375DA}). */
export type DropdownFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Dropdown Filter Folder template (ID: {9D46C5C3-AAEE-46AA-B406-A1806302116E}). */
export type DropdownFilterFolder = Item & {
  __typename?: 'DropdownFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Dropdown Filter Folder template (ID: {9D46C5C3-AAEE-46AA-B406-A1806302116E}). */
export type DropdownFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Dropdown Filter Folder template (ID: {9D46C5C3-AAEE-46AA-B406-A1806302116E}). */
export type DropdownFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Dropdown Filter Folder template (ID: {9D46C5C3-AAEE-46AA-B406-A1806302116E}). */
export type DropdownFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Dropdown Filter Folder template (ID: {9D46C5C3-AAEE-46AA-B406-A1806302116E}). */
export type DropdownFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Dropdown Filter Folder template (ID: {9D46C5C3-AAEE-46AA-B406-A1806302116E}). */
export type DropdownFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Dropdown Filter Folder template (ID: {9D46C5C3-AAEE-46AA-B406-A1806302116E}). */
export type DropdownFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Dropdown Filter template (ID: {790C0F2C-1621-4604-A6C6-72B9F8AE830D}). */
export type DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = FacetSelectorConfigBase & Item & {
  __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Empty Value Text (ID: {F043691D-4D65-4228-9F18-9559C503221C}). */
  emptyValueText?: Maybe<TextField>;
  /** Facet (ID: {38D3DE1F-F23C-4587-AE30-06EC5ED73E82}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** Unselected Text (ID: {938C972B-02AC-4CC1-A79E-D262BA7F2344}). */
  unselectedText?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Dropdown Filter template (ID: {790C0F2C-1621-4604-A6C6-72B9F8AE830D}). */
export type DropdownFilter_790c0f2c16214604a6c672b9f8ae830dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Dropdown Filter template (ID: {790C0F2C-1621-4604-A6C6-72B9F8AE830D}). */
export type DropdownFilter_790c0f2c16214604a6c672b9f8ae830dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Dropdown Filter template (ID: {790C0F2C-1621-4604-A6C6-72B9F8AE830D}). */
export type DropdownFilter_790c0f2c16214604a6c672b9f8ae830dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Dropdown Filter template (ID: {790C0F2C-1621-4604-A6C6-72B9F8AE830D}). */
export type DropdownFilter_790c0f2c16214604a6c672b9f8ae830dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Dropdown Filter template (ID: {790C0F2C-1621-4604-A6C6-72B9F8AE830D}). */
export type DropdownFilter_790c0f2c16214604a6c672b9f8ae830dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Dropdown Filter template (ID: {790C0F2C-1621-4604-A6C6-72B9F8AE830D}). */
export type DropdownFilter_790c0f2c16214604a6c672b9f8ae830dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditEditingTheme template (ID: {37397CC6-D9E3-4F3E-B320-1EF5CC76CC2E}). */
export type EditEditingTheme = Item & {
  __typename?: 'EditEditingTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {37A6A70B-D1AB-45F4-9306-047A853866BA}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditEditingTheme template (ID: {37397CC6-D9E3-4F3E-B320-1EF5CC76CC2E}). */
export type EditEditingThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditEditingTheme template (ID: {37397CC6-D9E3-4F3E-B320-1EF5CC76CC2E}). */
export type EditEditingThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditEditingTheme template (ID: {37397CC6-D9E3-4F3E-B320-1EF5CC76CC2E}). */
export type EditEditingThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditEditingTheme template (ID: {37397CC6-D9E3-4F3E-B320-1EF5CC76CC2E}). */
export type EditEditingThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditEditingTheme template (ID: {37397CC6-D9E3-4F3E-B320-1EF5CC76CC2E}). */
export type EditEditingThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditEditingTheme template (ID: {37397CC6-D9E3-4F3E-B320-1EF5CC76CC2E}). */
export type EditEditingThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Edit Frame template (ID: {98E1C490-65E2-4F23-A4FD-D2D496CB387B}). */
export type EditFrame = BaseVariantField & Item & {
  __typename?: 'EditFrame';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Edits frame buttons */
  buttons?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Edit Frame template (ID: {98E1C490-65E2-4F23-A4FD-D2D496CB387B}). */
export type EditFrameAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Edit Frame template (ID: {98E1C490-65E2-4F23-A4FD-D2D496CB387B}). */
export type EditFrameChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Edit Frame template (ID: {98E1C490-65E2-4F23-A4FD-D2D496CB387B}). */
export type EditFrameFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Edit Frame template (ID: {98E1C490-65E2-4F23-A4FD-D2D496CB387B}). */
export type EditFrameFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Edit Frame template (ID: {98E1C490-65E2-4F23-A4FD-D2D496CB387B}). */
export type EditFrameHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Edit Frame template (ID: {98E1C490-65E2-4F23-A4FD-D2D496CB387B}). */
export type EditFrameIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Edit Mode Panel template (ID: {254A8DCA-4C55-47D8-912D-0609A8009BB3}). */
export type EditModePanel = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & ISplitter & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'EditModePanel';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Edit Mode Panel template (ID: {254A8DCA-4C55-47D8-912D-0609A8009BB3}). */
export type EditModePanelAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Edit Mode Panel template (ID: {254A8DCA-4C55-47D8-912D-0609A8009BB3}). */
export type EditModePanelChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Edit Mode Panel template (ID: {254A8DCA-4C55-47D8-912D-0609A8009BB3}). */
export type EditModePanelFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Edit Mode Panel template (ID: {254A8DCA-4C55-47D8-912D-0609A8009BB3}). */
export type EditModePanelFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Edit Mode Panel template (ID: {254A8DCA-4C55-47D8-912D-0609A8009BB3}). */
export type EditModePanelHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Edit Mode Panel template (ID: {254A8DCA-4C55-47D8-912D-0609A8009BB3}). */
export type EditModePanelIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {1773ECCE-3F78-4201-8095-CAE3574E8EDE}). */
export type EditSiteItem = Item & _Arguments_33fab87cd52f44319a1f589ba7c1e287 & _EditType_8a9f84baaa124c5d9096935714809da4 & {
  __typename?: 'EditSiteItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {58ACA5CA-742A-41BB-866F-CFA3764200C8}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditType (ID: {76691B61-8692-4D98-A4FF-115BA4208AB6}). */
  editType?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {E308B8AE-E98E-42B2-80E2-12E902E5E50E}). */
  template_e308b8aee98e42b280e212e902e5e50e?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {1773ECCE-3F78-4201-8095-CAE3574E8EDE}). */
export type EditSiteItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {1773ECCE-3F78-4201-8095-CAE3574E8EDE}). */
export type EditSiteItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {1773ECCE-3F78-4201-8095-CAE3574E8EDE}). */
export type EditSiteItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {1773ECCE-3F78-4201-8095-CAE3574E8EDE}). */
export type EditSiteItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {1773ECCE-3F78-4201-8095-CAE3574E8EDE}). */
export type EditSiteItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {1773ECCE-3F78-4201-8095-CAE3574E8EDE}). */
export type EditSiteItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {F040DB03-87FE-4E10-AE40-53C63175E31B}). */
export type EditSiteItem_F040db0387fe4e10ae4053c63175e31b = Item & _Arguments_33fab87cd52f44319a1f589ba7c1e287 & _EditType_8a9f84baaa124c5d9096935714809da4 & {
  __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {58ACA5CA-742A-41BB-866F-CFA3764200C8}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditType (ID: {76691B61-8692-4D98-A4FF-115BA4208AB6}). */
  editType?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {0916832D-459E-463C-852B-C538476A422D}). */
  template_0916832d459e463c852bc538476a422d?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {F040DB03-87FE-4E10-AE40-53C63175E31B}). */
export type EditSiteItem_F040db0387fe4e10ae4053c63175e31bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {F040DB03-87FE-4E10-AE40-53C63175E31B}). */
export type EditSiteItem_F040db0387fe4e10ae4053c63175e31bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {F040DB03-87FE-4E10-AE40-53C63175E31B}). */
export type EditSiteItem_F040db0387fe4e10ae4053c63175e31bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {F040DB03-87FE-4E10-AE40-53C63175E31B}). */
export type EditSiteItem_F040db0387fe4e10ae4053c63175e31bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {F040DB03-87FE-4E10-AE40-53C63175E31B}). */
export type EditSiteItem_F040db0387fe4e10ae4053c63175e31bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/EditSiteItem template (ID: {F040DB03-87FE-4E10-AE40-53C63175E31B}). */
export type EditSiteItem_F040db0387fe4e10ae4053c63175e31bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditSiteTheme template (ID: {5AE7EE87-FBEB-4648-818F-9B17E13B4C89}). */
export type EditSiteTheme = Item & {
  __typename?: 'EditSiteTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {4D4C227E-A1B5-46AC-82F9-D6F25DFED8AA}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditSiteTheme template (ID: {5AE7EE87-FBEB-4648-818F-9B17E13B4C89}). */
export type EditSiteThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditSiteTheme template (ID: {5AE7EE87-FBEB-4648-818F-9B17E13B4C89}). */
export type EditSiteThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditSiteTheme template (ID: {5AE7EE87-FBEB-4648-818F-9B17E13B4C89}). */
export type EditSiteThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditSiteTheme template (ID: {5AE7EE87-FBEB-4648-818F-9B17E13B4C89}). */
export type EditSiteThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditSiteTheme template (ID: {5AE7EE87-FBEB-4648-818F-9B17E13B4C89}). */
export type EditSiteThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/EditSiteTheme template (ID: {5AE7EE87-FBEB-4648-818F-9B17E13B4C89}). */
export type EditSiteThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {88752F77-9109-424C-B1D8-AF91E6369A2E}). */
export type EditTenantTemplate = Item & _Arguments & _EditType & {
  __typename?: 'EditTenantTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {E830AF53-210B-4981-B6A8-F8939F587EB1}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditType (ID: {614F52CF-D54B-47D1-A242-D9A7D42860F4}). */
  editType?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {67B6641E-309D-4C1E-8E97-63965C7E2C5F}). */
  template_67b6641e309d4c1e8e9763965c7e2c5f?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {88752F77-9109-424C-B1D8-AF91E6369A2E}). */
export type EditTenantTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {88752F77-9109-424C-B1D8-AF91E6369A2E}). */
export type EditTenantTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {88752F77-9109-424C-B1D8-AF91E6369A2E}). */
export type EditTenantTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {88752F77-9109-424C-B1D8-AF91E6369A2E}). */
export type EditTenantTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {88752F77-9109-424C-B1D8-AF91E6369A2E}). */
export type EditTenantTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {88752F77-9109-424C-B1D8-AF91E6369A2E}). */
export type EditTenantTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {A7D9FCBC-C894-4274-935F-9B9659C000D3}). */
export type EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3 = Item & _Arguments & _EditType & {
  __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {E830AF53-210B-4981-B6A8-F8939F587EB1}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditType (ID: {614F52CF-D54B-47D1-A242-D9A7D42860F4}). */
  editType?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {5A6EBF0F-5975-486C-807F-ADFF943BBA13}). */
  template_5a6ebf0f5975486c807fadff943bba13?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {A7D9FCBC-C894-4274-935F-9B9659C000D3}). */
export type EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {A7D9FCBC-C894-4274-935F-9B9659C000D3}). */
export type EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {A7D9FCBC-C894-4274-935F-9B9659C000D3}). */
export type EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {A7D9FCBC-C894-4274-935F-9B9659C000D3}). */
export type EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {A7D9FCBC-C894-4274-935F-9B9659C000D3}). */
export type EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/EditTenantTemplate template (ID: {A7D9FCBC-C894-4274-935F-9B9659C000D3}). */
export type EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/EditType template (ID: {2D2ADCD4-6367-4245-8707-FAA5EA08DFB5}). */
export type EditType = Item & {
  __typename?: 'EditType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/EditType template (ID: {2D2ADCD4-6367-4245-8707-FAA5EA08DFB5}). */
export type EditTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/EditType template (ID: {2D2ADCD4-6367-4245-8707-FAA5EA08DFB5}). */
export type EditTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/EditType template (ID: {2D2ADCD4-6367-4245-8707-FAA5EA08DFB5}). */
export type EditTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/EditType template (ID: {2D2ADCD4-6367-4245-8707-FAA5EA08DFB5}). */
export type EditTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/EditType template (ID: {2D2ADCD4-6367-4245-8707-FAA5EA08DFB5}). */
export type EditTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/EditType template (ID: {2D2ADCD4-6367-4245-8707-FAA5EA08DFB5}). */
export type EditTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form template (ID: {7F0C4367-C6A7-4FBD-8452-A292BBB614A5}). Also implements _DatasourceWorkflow, _Statistics. */
export type EloquaForm = {
  /** companyName (ID: {432AC6F8-2F50-4030-AFE4-4CDBF3CF4BEC}). */
  companyName?: Maybe<TextField>;
  /** Numerical ID of the form, as seen in Eloqua. */
  formId?: Maybe<IntegerField>;
  /** formJson (ID: {1EB530B8-59A8-48CE-B04B-7395EBBE5718}). */
  formJson?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form Folder template (ID: {A1731BFD-B68C-439E-B086-FD617EF619CA}). */
export type EloquaFormFolder = Item & {
  __typename?: 'EloquaFormFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form Folder template (ID: {A1731BFD-B68C-439E-B086-FD617EF619CA}). */
export type EloquaFormFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form Folder template (ID: {A1731BFD-B68C-439E-B086-FD617EF619CA}). */
export type EloquaFormFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form Folder template (ID: {A1731BFD-B68C-439E-B086-FD617EF619CA}). */
export type EloquaFormFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form Folder template (ID: {A1731BFD-B68C-439E-B086-FD617EF619CA}). */
export type EloquaFormFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form Folder template (ID: {A1731BFD-B68C-439E-B086-FD617EF619CA}). */
export type EloquaFormFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Form Folder template (ID: {A1731BFD-B68C-439E-B086-FD617EF619CA}). */
export type EloquaFormFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Fund Form template (ID: {EDA6F3E0-C2FA-414E-A04F-4D10B1F1F834}). */
export type EloquaFundForm = EloquaForm & Item & _FundFormAvailability & {
  __typename?: 'EloquaFundForm';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** applicableFunds (ID: {D5891DA4-76A3-4C2A-9B6B-E002FD5BC978}). */
  applicableFunds?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** companyName (ID: {432AC6F8-2F50-4030-AFE4-4CDBF3CF4BEC}). */
  companyName?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** formAuthorizations (ID: {261F0149-9EA4-4257-B36F-E5D912D66AAD}). */
  formAuthorizations?: Maybe<MultilistField>;
  /** Numerical ID of the form, as seen in Eloqua. */
  formId?: Maybe<IntegerField>;
  /** formJson (ID: {1EB530B8-59A8-48CE-B04B-7395EBBE5718}). */
  formJson?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Fund Form template (ID: {EDA6F3E0-C2FA-414E-A04F-4D10B1F1F834}). */
export type EloquaFundFormAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Fund Form template (ID: {EDA6F3E0-C2FA-414E-A04F-4D10B1F1F834}). */
export type EloquaFundFormChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Fund Form template (ID: {EDA6F3E0-C2FA-414E-A04F-4D10B1F1F834}). */
export type EloquaFundFormFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Fund Form template (ID: {EDA6F3E0-C2FA-414E-A04F-4D10B1F1F834}). */
export type EloquaFundFormFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Fund Form template (ID: {EDA6F3E0-C2FA-414E-A04F-4D10B1F1F834}). */
export type EloquaFundFormHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Eloqua Form/Eloqua Fund Form template (ID: {EDA6F3E0-C2FA-414E-A04F-4D10B1F1F834}). */
export type EloquaFundFormIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enum template (ID: {D2923FEE-DA4E-49BE-830C-E27764DFA269}). */
export type Enum = Item & {
  __typename?: 'Enum';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Value (ID: {F917C951-1F75-4D62-B14A-BC6888D7EECA}). */
  value?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enum template (ID: {D2923FEE-DA4E-49BE-830C-E27764DFA269}). */
export type EnumAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enum template (ID: {D2923FEE-DA4E-49BE-830C-E27764DFA269}). */
export type EnumChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enum template (ID: {D2923FEE-DA4E-49BE-830C-E27764DFA269}). */
export type EnumFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enum template (ID: {D2923FEE-DA4E-49BE-830C-E27764DFA269}). */
export type EnumFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enum template (ID: {D2923FEE-DA4E-49BE-830C-E27764DFA269}). */
export type EnumHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enum template (ID: {D2923FEE-DA4E-49BE-830C-E27764DFA269}). */
export type EnumIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enums template (ID: {0A92FEEE-0E15-4E81-B044-2AD901B88DDD}). */
export type Enums = Item & {
  __typename?: 'Enums';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enums template (ID: {0A92FEEE-0E15-4E81-B044-2AD901B88DDD}). */
export type EnumsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enums template (ID: {0A92FEEE-0E15-4E81-B044-2AD901B88DDD}). */
export type EnumsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enums template (ID: {0A92FEEE-0E15-4E81-B044-2AD901B88DDD}). */
export type EnumsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enums template (ID: {0A92FEEE-0E15-4E81-B044-2AD901B88DDD}). */
export type EnumsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enums template (ID: {0A92FEEE-0E15-4E81-B044-2AD901B88DDD}). */
export type EnumsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Common/Enums template (ID: {0A92FEEE-0E15-4E81-B044-2AD901B88DDD}). */
export type EnumsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ErrorHandlingInfo = {
  __typename?: 'ErrorHandlingInfo';
  /** Item representing the notFound page path. */
  notFoundPage?: Maybe<Item>;
  /** The path to redirect to, if a page is not found. */
  notFoundPagePath?: Maybe<Scalars['String']['output']>;
  /** Item representing the serverError page path. */
  serverErrorPage?: Maybe<Item>;
  /** The path to redirect to, if a generic error occurs. */
  serverErrorPagePath?: Maybe<Scalars['String']['output']>;
};

/** /sitecore/templates/Project/Personal/Pages/Error Page template (ID: {03542735-765E-45F0-8862-E4A9DD47EBCC}). */
export type ErrorPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ErrorPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Error Page template (ID: {03542735-765E-45F0-8862-E4A9DD47EBCC}). */
export type ErrorPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Error Page template (ID: {03542735-765E-45F0-8862-E4A9DD47EBCC}). */
export type ErrorPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Error Page template (ID: {03542735-765E-45F0-8862-E4A9DD47EBCC}). */
export type ErrorPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Error Page template (ID: {03542735-765E-45F0-8862-E4A9DD47EBCC}). */
export type ErrorPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Error Page template (ID: {03542735-765E-45F0-8862-E4A9DD47EBCC}). */
export type ErrorPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Error Page template (ID: {03542735-765E-45F0-8862-E4A9DD47EBCC}). */
export type ErrorPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Error Page template (ID: {4B405EC4-EF9F-4C91-A3FF-B98C1AC81171}). */
export type ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Error Page template (ID: {4B405EC4-EF9F-4C91-A3FF-B98C1AC81171}). */
export type ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Error Page template (ID: {4B405EC4-EF9F-4C91-A3FF-B98C1AC81171}). */
export type ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Error Page template (ID: {4B405EC4-EF9F-4C91-A3FF-B98C1AC81171}). */
export type ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Error Page template (ID: {4B405EC4-EF9F-4C91-A3FF-B98C1AC81171}). */
export type ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Error Page template (ID: {4B405EC4-EF9F-4C91-A3FF-B98C1AC81171}). */
export type ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Error Page template (ID: {4B405EC4-EF9F-4C91-A3FF-B98C1AC81171}). */
export type ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Error Page template (ID: {4DBCCCE4-16D1-491F-9419-8496E3F77C6D}). */
export type ErrorPage_4dbccce416d1491f94198496e3f77c6d = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Error Page template (ID: {4DBCCCE4-16D1-491F-9419-8496E3F77C6D}). */
export type ErrorPage_4dbccce416d1491f94198496e3f77c6dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Error Page template (ID: {4DBCCCE4-16D1-491F-9419-8496E3F77C6D}). */
export type ErrorPage_4dbccce416d1491f94198496e3f77c6dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Error Page template (ID: {4DBCCCE4-16D1-491F-9419-8496E3F77C6D}). */
export type ErrorPage_4dbccce416d1491f94198496e3f77c6dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Error Page template (ID: {4DBCCCE4-16D1-491F-9419-8496E3F77C6D}). */
export type ErrorPage_4dbccce416d1491f94198496e3f77c6dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Error Page template (ID: {4DBCCCE4-16D1-491F-9419-8496E3F77C6D}). */
export type ErrorPage_4dbccce416d1491f94198496e3f77c6dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Error Page template (ID: {4DBCCCE4-16D1-491F-9419-8496E3F77C6D}). */
export type ErrorPage_4dbccce416d1491f94198496e3f77c6dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Error Page template (ID: {45D797CC-0487-40FF-B693-214883FF35C2}). */
export type ErrorPage_45d797cc048740ffb693214883ff35c2 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Error Page template (ID: {45D797CC-0487-40FF-B693-214883FF35C2}). */
export type ErrorPage_45d797cc048740ffb693214883ff35c2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Error Page template (ID: {45D797CC-0487-40FF-B693-214883FF35C2}). */
export type ErrorPage_45d797cc048740ffb693214883ff35c2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Error Page template (ID: {45D797CC-0487-40FF-B693-214883FF35C2}). */
export type ErrorPage_45d797cc048740ffb693214883ff35c2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Error Page template (ID: {45D797CC-0487-40FF-B693-214883FF35C2}). */
export type ErrorPage_45d797cc048740ffb693214883ff35c2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Error Page template (ID: {45D797CC-0487-40FF-B693-214883FF35C2}). */
export type ErrorPage_45d797cc048740ffb693214883ff35c2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Error Page template (ID: {45D797CC-0487-40FF-B693-214883FF35C2}). */
export type ErrorPage_45d797cc048740ffb693214883ff35c2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Error Page template (ID: {76EB47B3-F3A2-48BD-BBDB-B5BF7D8F9BF9}). */
export type ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Error Page template (ID: {76EB47B3-F3A2-48BD-BBDB-B5BF7D8F9BF9}). */
export type ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Error Page template (ID: {76EB47B3-F3A2-48BD-BBDB-B5BF7D8F9BF9}). */
export type ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Error Page template (ID: {76EB47B3-F3A2-48BD-BBDB-B5BF7D8F9BF9}). */
export type ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Error Page template (ID: {76EB47B3-F3A2-48BD-BBDB-B5BF7D8F9BF9}). */
export type ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Error Page template (ID: {76EB47B3-F3A2-48BD-BBDB-B5BF7D8F9BF9}). */
export type ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Error Page template (ID: {76EB47B3-F3A2-48BD-BBDB-B5BF7D8F9BF9}). */
export type ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Error Page template (ID: {A7DFA497-6122-4679-BF99-49FFFACD5FA1}). */
export type ErrorPage_A7dfa49761224679bf9949fffacd5fa1 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Error Page template (ID: {A7DFA497-6122-4679-BF99-49FFFACD5FA1}). */
export type ErrorPage_A7dfa49761224679bf9949fffacd5fa1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Error Page template (ID: {A7DFA497-6122-4679-BF99-49FFFACD5FA1}). */
export type ErrorPage_A7dfa49761224679bf9949fffacd5fa1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Error Page template (ID: {A7DFA497-6122-4679-BF99-49FFFACD5FA1}). */
export type ErrorPage_A7dfa49761224679bf9949fffacd5fa1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Error Page template (ID: {A7DFA497-6122-4679-BF99-49FFFACD5FA1}). */
export type ErrorPage_A7dfa49761224679bf9949fffacd5fa1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Error Page template (ID: {A7DFA497-6122-4679-BF99-49FFFACD5FA1}). */
export type ErrorPage_A7dfa49761224679bf9949fffacd5fa1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Error Page template (ID: {A7DFA497-6122-4679-BF99-49FFFACD5FA1}). */
export type ErrorPage_A7dfa49761224679bf9949fffacd5fa1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event Calendar Parameters template (ID: {43E4F676-DA99-4859-9F7F-FA82F9D52277}). */
export type EventCalendarParameters = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'EventCalendarParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** CalendarType (ID: {606078CC-C134-486D-84E7-1E5266973B5F}). */
  calendarType?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CompactView (ID: {F7265871-664D-4F5B-91D4-C07427782ABE}). */
  compactView?: Maybe<CheckboxField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** ShowMonthCaptions (ID: {849E1A6B-E39E-43F6-8019-B810487C8C25}). */
  showMonthCaptions?: Maybe<CheckboxField>;
  /** ShowPreviousNext (ID: {5758F3A6-31F5-441D-93ED-37BC9700D21F}). */
  showPreviousNext?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TitleHeadingLevel (ID: {44C2597F-790B-460E-AD68-89ADEB11AA7D}). */
  titleHeadingLevel?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event Calendar Parameters template (ID: {43E4F676-DA99-4859-9F7F-FA82F9D52277}). */
export type EventCalendarParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event Calendar Parameters template (ID: {43E4F676-DA99-4859-9F7F-FA82F9D52277}). */
export type EventCalendarParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event Calendar Parameters template (ID: {43E4F676-DA99-4859-9F7F-FA82F9D52277}). */
export type EventCalendarParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event Calendar Parameters template (ID: {43E4F676-DA99-4859-9F7F-FA82F9D52277}). */
export type EventCalendarParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event Calendar Parameters template (ID: {43E4F676-DA99-4859-9F7F-FA82F9D52277}). */
export type EventCalendarParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event Calendar Parameters template (ID: {43E4F676-DA99-4859-9F7F-FA82F9D52277}). */
export type EventCalendarParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Event List template (ID: {311E5F53-CF27-4A85-B887-B84BEE5D3BA3}). */
export type EventList = Item & {
  __typename?: 'EventList';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EventTypes (ID: {19DE610D-9714-4B5D-A17E-A2ACEA64769C}). */
  eventTypes?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GoogleCalendarAPIKey (ID: {7CFFA839-9AB6-4242-9B50-65B6B1E42691}). */
  googleCalendarAPIKey?: Maybe<TextField>;
  /** GoogleCalendarID (ID: {7B27442B-03C0-47DE-8C93-4C93B8493604}). */
  googleCalendarID?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {C08B42E9-C147-47D1-B50C-6274EB3A8BAA}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Event List template (ID: {311E5F53-CF27-4A85-B887-B84BEE5D3BA3}). */
export type EventListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Event List template (ID: {311E5F53-CF27-4A85-B887-B84BEE5D3BA3}). */
export type EventListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Event List template (ID: {311E5F53-CF27-4A85-B887-B84BEE5D3BA3}). */
export type EventListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Event List template (ID: {311E5F53-CF27-4A85-B887-B84BEE5D3BA3}). */
export type EventListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Event List template (ID: {311E5F53-CF27-4A85-B887-B84BEE5D3BA3}). */
export type EventListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Event List template (ID: {311E5F53-CF27-4A85-B887-B84BEE5D3BA3}). */
export type EventListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event List Parameters template (ID: {CA514E36-37FB-4F43-B024-F7F365B91B9E}). */
export type EventListParameters = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IPaginable & IPagination & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'EventListParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** ListSignature (ID: {3E44E786-672E-4DC0-86A0-FFF0D99A3471}). */
  listSignature?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Offset (ID: {778DF306-72BF-4ECA-8DED-0F0A18A5F9B4}). */
  offset?: Maybe<IntegerField>;
  /** PageSize (ID: {C5A5C905-855F-4DA9-941A-2C20845D0473}). */
  pageSize?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TitleHeadingLevel (ID: {31EA642D-5757-4CF3-863B-DCFBD73B277A}). */
  titleHeadingLevel?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event List Parameters template (ID: {CA514E36-37FB-4F43-B024-F7F365B91B9E}). */
export type EventListParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event List Parameters template (ID: {CA514E36-37FB-4F43-B024-F7F365B91B9E}). */
export type EventListParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event List Parameters template (ID: {CA514E36-37FB-4F43-B024-F7F365B91B9E}). */
export type EventListParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event List Parameters template (ID: {CA514E36-37FB-4F43-B024-F7F365B91B9E}). */
export type EventListParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event List Parameters template (ID: {CA514E36-37FB-4F43-B024-F7F365B91B9E}). */
export type EventListParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Rendering Parameters/Event List Parameters template (ID: {CA514E36-37FB-4F43-B024-F7F365B91B9E}). */
export type EventListParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Events/Event Types template (ID: {FD612519-1C44-48B7-A44A-D582E22C38DD}). */
export type EventTypes = Item & {
  __typename?: 'EventTypes';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Event Types template (ID: {FD612519-1C44-48B7-A44A-D582E22C38DD}). */
export type EventTypesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Event Types template (ID: {FD612519-1C44-48B7-A44A-D582E22C38DD}). */
export type EventTypesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Event Types template (ID: {FD612519-1C44-48B7-A44A-D582E22C38DD}). */
export type EventTypesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Event Types template (ID: {FD612519-1C44-48B7-A44A-D582E22C38DD}). */
export type EventTypesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Event Types template (ID: {FD612519-1C44-48B7-A44A-D582E22C38DD}). */
export type EventTypesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Event Types template (ID: {FD612519-1C44-48B7-A44A-D582E22C38DD}). */
export type EventTypesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Events Folder template (ID: {AF1CC1AF-99CC-4E3C-9A26-3EAD62890FCE}). */
export type EventsFolder = Item & {
  __typename?: 'EventsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Events Folder template (ID: {AF1CC1AF-99CC-4E3C-9A26-3EAD62890FCE}). */
export type EventsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Events Folder template (ID: {AF1CC1AF-99CC-4E3C-9A26-3EAD62890FCE}). */
export type EventsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Events Folder template (ID: {AF1CC1AF-99CC-4E3C-9A26-3EAD62890FCE}). */
export type EventsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Events Folder template (ID: {AF1CC1AF-99CC-4E3C-9A26-3EAD62890FCE}). */
export type EventsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Events Folder template (ID: {AF1CC1AF-99CC-4E3C-9A26-3EAD62890FCE}). */
export type EventsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Events/Datasource/Events Folder template (ID: {AF1CC1AF-99CC-4E3C-9A26-3EAD62890FCE}). */
export type EventsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {3A385B25-DF9B-47AC-9F6B-39C8534E81F1}). */
export type ExecuteScript = Item & _Script & _Validation & {
  __typename?: 'ExecuteScript';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {3A385B25-DF9B-47AC-9F6B-39C8534E81F1}). */
export type ExecuteScriptAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {3A385B25-DF9B-47AC-9F6B-39C8534E81F1}). */
export type ExecuteScriptChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {3A385B25-DF9B-47AC-9F6B-39C8534E81F1}). */
export type ExecuteScriptFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {3A385B25-DF9B-47AC-9F6B-39C8534E81F1}). */
export type ExecuteScriptFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {3A385B25-DF9B-47AC-9F6B-39C8534E81F1}). */
export type ExecuteScriptHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {3A385B25-DF9B-47AC-9F6B-39C8534E81F1}). */
export type ExecuteScriptIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/ExecuteScript template (ID: {3D4E4577-AB33-4CA6-AE43-B98D1EC6472F}). */
export type ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = Item & _Validation & {
  __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {CEDA3E7F-7406-40D0-A154-7CF7E3E7E85B}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/ExecuteScript template (ID: {3D4E4577-AB33-4CA6-AE43-B98D1EC6472F}). */
export type ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/ExecuteScript template (ID: {3D4E4577-AB33-4CA6-AE43-B98D1EC6472F}). */
export type ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/ExecuteScript template (ID: {3D4E4577-AB33-4CA6-AE43-B98D1EC6472F}). */
export type ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/ExecuteScript template (ID: {3D4E4577-AB33-4CA6-AE43-B98D1EC6472F}). */
export type ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/ExecuteScript template (ID: {3D4E4577-AB33-4CA6-AE43-B98D1EC6472F}). */
export type ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/OBSOLETE/ExecuteScript template (ID: {3D4E4577-AB33-4CA6-AE43-B98D1EC6472F}). */
export type ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {6545C81F-C30F-4B58-97D9-EF85B890F70A}). */
export type ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = Item & _Script & _Validation & {
  __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {6545C81F-C30F-4B58-97D9-EF85B890F70A}). */
export type ExecuteScript_6545c81fc30f4b5897d9ef85b890f70aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {6545C81F-C30F-4B58-97D9-EF85B890F70A}). */
export type ExecuteScript_6545c81fc30f4b5897d9ef85b890f70aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {6545C81F-C30F-4B58-97D9-EF85B890F70A}). */
export type ExecuteScript_6545c81fc30f4b5897d9ef85b890f70aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {6545C81F-C30F-4B58-97D9-EF85B890F70A}). */
export type ExecuteScript_6545c81fc30f4b5897d9ef85b890f70aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {6545C81F-C30F-4B58-97D9-EF85B890F70A}). */
export type ExecuteScript_6545c81fc30f4b5897d9ef85b890f70aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {6545C81F-C30F-4B58-97D9-EF85B890F70A}). */
export type ExecuteScript_6545c81fc30f4b5897d9ef85b890f70aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/OBSOLETE/ExecuteScript template (ID: {B06460C2-8B7B-47A5-9E2C-F966F689B6CA}). */
export type ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca = Item & _Validation & {
  __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {FF1383BB-F095-4958-9B6D-E555DB653C44}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/OBSOLETE/ExecuteScript template (ID: {B06460C2-8B7B-47A5-9E2C-F966F689B6CA}). */
export type ExecuteScript_B06460c28b7b47a59e2cf966f689b6caAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/OBSOLETE/ExecuteScript template (ID: {B06460C2-8B7B-47A5-9E2C-F966F689B6CA}). */
export type ExecuteScript_B06460c28b7b47a59e2cf966f689b6caChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/OBSOLETE/ExecuteScript template (ID: {B06460C2-8B7B-47A5-9E2C-F966F689B6CA}). */
export type ExecuteScript_B06460c28b7b47a59e2cf966f689b6caFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/OBSOLETE/ExecuteScript template (ID: {B06460C2-8B7B-47A5-9E2C-F966F689B6CA}). */
export type ExecuteScript_B06460c28b7b47a59e2cf966f689b6caFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/OBSOLETE/ExecuteScript template (ID: {B06460C2-8B7B-47A5-9E2C-F966F689B6CA}). */
export type ExecuteScript_B06460c28b7b47a59e2cf966f689b6caHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/OBSOLETE/ExecuteScript template (ID: {B06460C2-8B7B-47A5-9E2C-F966F689B6CA}). */
export type ExecuteScript_B06460c28b7b47a59e2cf966f689b6caIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {BC9BB684-36DF-4285-888B-D8B4D87B10DE}). */
export type ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de = Item & _Script & _Validation & {
  __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {BC9BB684-36DF-4285-888B-D8B4D87B10DE}). */
export type ExecuteScript_Bc9bb68436df4285888bd8b4d87b10deAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {BC9BB684-36DF-4285-888B-D8B4D87B10DE}). */
export type ExecuteScript_Bc9bb68436df4285888bd8b4d87b10deChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {BC9BB684-36DF-4285-888B-D8B4D87B10DE}). */
export type ExecuteScript_Bc9bb68436df4285888bd8b4d87b10deFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {BC9BB684-36DF-4285-888B-D8B4D87B10DE}). */
export type ExecuteScript_Bc9bb68436df4285888bd8b4d87b10deFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {BC9BB684-36DF-4285-888B-D8B4D87B10DE}). */
export type ExecuteScript_Bc9bb68436df4285888bd8b4d87b10deHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/ExecuteScript template (ID: {BC9BB684-36DF-4285-888B-D8B4D87B10DE}). */
export type ExecuteScript_Bc9bb68436df4285888bd8b4d87b10deIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {E14C0872-1A97-459E-AFEF-0ACAAAF1FFBB}). */
export type ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb = Item & _Script & _Validation & {
  __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {E14C0872-1A97-459E-AFEF-0ACAAAF1FFBB}). */
export type ExecuteScript_E14c08721a97459eafef0acaaaf1ffbbAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {E14C0872-1A97-459E-AFEF-0ACAAAF1FFBB}). */
export type ExecuteScript_E14c08721a97459eafef0acaaaf1ffbbChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {E14C0872-1A97-459E-AFEF-0ACAAAF1FFBB}). */
export type ExecuteScript_E14c08721a97459eafef0acaaaf1ffbbFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {E14C0872-1A97-459E-AFEF-0ACAAAF1FFBB}). */
export type ExecuteScript_E14c08721a97459eafef0acaaaf1ffbbFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {E14C0872-1A97-459E-AFEF-0ACAAAF1FFBB}). */
export type ExecuteScript_E14c08721a97459eafef0acaaaf1ffbbHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/ExecuteScript template (ID: {E14C0872-1A97-459E-AFEF-0ACAAAF1FFBB}). */
export type ExecuteScript_E14c08721a97459eafef0acaaaf1ffbbIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/ExtendSiteTheme template (ID: {621318AC-63E9-48B1-B5A9-5BCF31D0E41A}). */
export type ExtendSiteTheme = Item & {
  __typename?: 'ExtendSiteTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Arguments (ID: {6CDDC859-D797-4C2F-A95A-BB168B4AD966}). */
  arguments?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/ExtendSiteTheme template (ID: {621318AC-63E9-48B1-B5A9-5BCF31D0E41A}). */
export type ExtendSiteThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/ExtendSiteTheme template (ID: {621318AC-63E9-48B1-B5A9-5BCF31D0E41A}). */
export type ExtendSiteThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/ExtendSiteTheme template (ID: {621318AC-63E9-48B1-B5A9-5BCF31D0E41A}). */
export type ExtendSiteThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/ExtendSiteTheme template (ID: {621318AC-63E9-48B1-B5A9-5BCF31D0E41A}). */
export type ExtendSiteThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/ExtendSiteTheme template (ID: {621318AC-63E9-48B1-B5A9-5BCF31D0E41A}). */
export type ExtendSiteThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Shared/ExtendSiteTheme template (ID: {621318AC-63E9-48B1-B5A9-5BCF31D0E41A}). */
export type ExtendSiteThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Extended Options template (ID: {478A5C00-6B7A-4344-8F98-4886B984F3EE}). */
export type ExtendedOptions = {
  /** Additional compatible templates (ID: {F6677A49-0A1D-4BAD-B8BA-4F0F22BDEE64}). */
  additionalCompatibleTemplates?: Maybe<MultilistField>;
  /** Can select Page as a data source (ID: {A3411FF6-C978-40AA-B059-A49B9CA2209B}). */
  canSelectPageAsADataSource?: Maybe<CheckboxField>;
  /** RenderingCssClass (ID: {34E81E40-1D4D-45B0-BCF1-A0FFE5521685}). */
  renderingCssClass?: Maybe<TextField>;
  /** RenderingViewPath (ID: {49B9D6C5-9551-4BA4-840E-74D5582256C0}). */
  renderingViewPath?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/Extended Options template (ID: {2964FB42-57A6-440F-B192-218443904C90}). */
export type ExtendedOptions_2964fb4257a6440fb192218443904c90 = {
  /** AllowedOnTemplates (ID: {1B58D065-FE74-43E3-BA20-54C9588B3011}). */
  allowedOnTemplates?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Sitecore Extensions/Extended Options template (ID: {F1850030-F978-48B4-BDB5-884B7E863160}). */
export type ExtendedOptions_F1850030f97848b4bdb5884b7e863160 = {
  /** OtherProperties (ID: {E829C217-5E94-4306-9C48-2634B094FDC2}). */
  otherProperties?: Maybe<NameValueListField>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/External Literature/External Literature template (ID: {326B6B30-56ED-4F06-9367-25F3E16B2FFD}). */
export type ExternalLiterature = Item & {
  __typename?: 'ExternalLiterature';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** applicableFunds (ID: {8FEE09BD-1F81-4DBB-8812-E173CA4775BE}). */
  applicableFunds?: Maybe<MultilistField>;
  /** applicableShareClass (ID: {26579599-B94F-4736-84D9-970AC1298ADF}). */
  applicableShareClass?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** documentCategory (ID: {32C8FD59-E6CB-4522-AE62-A24D31D2906C}). */
  documentCategory?: Maybe<LookupField>;
  /** documentType (ID: {5F79C63F-57A6-433D-839E-0E6FCA2F03BA}). */
  documentType?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** literatureAuthorizations (ID: {943E71CF-4409-41FD-B832-18E1EEE571EF}). */
  literatureAuthorizations?: Maybe<MultilistField>;
  /** literatureUrl (ID: {BDC54F42-606B-4517-A0D0-EBA1499483D9}). */
  literatureUrl?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/External Literature/External Literature template (ID: {326B6B30-56ED-4F06-9367-25F3E16B2FFD}). */
export type ExternalLiteratureAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/External Literature/External Literature template (ID: {326B6B30-56ED-4F06-9367-25F3E16B2FFD}). */
export type ExternalLiteratureChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/External Literature/External Literature template (ID: {326B6B30-56ED-4F06-9367-25F3E16B2FFD}). */
export type ExternalLiteratureFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/External Literature/External Literature template (ID: {326B6B30-56ED-4F06-9367-25F3E16B2FFD}). */
export type ExternalLiteratureFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/External Literature/External Literature template (ID: {326B6B30-56ED-4F06-9367-25F3E16B2FFD}). */
export type ExternalLiteratureHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/External Literature/External Literature template (ID: {326B6B30-56ED-4F06-9367-25F3E16B2FFD}). */
export type ExternalLiteratureIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/Rendering parameters/FEaaS Rendering Parameters template (ID: {CEAAFBDC-6F45-4DC9-90F5-9A9DE074D30C}). */
export type FEaaSRenderingParameters = {
  /** ComponentConfiguration (ID: {EB331824-D4FA-46EC-8F46-0FCB44F2FF04}). */
  componentConfiguration?: Maybe<TextField>;
  /** ComponentDataOverride (ID: {4938816F-2E6A-48E1-9774-2FD27486EEF0}). */
  componentDataOverride?: Maybe<TextField>;
  /** ComponentHTMLOverride (ID: {81AAF152-9A76-4CC4-B536-696F24B6802B}). */
  componentHTMLOverride?: Maybe<TextField>;
  /** ComponentHostName (ID: {83A26F14-29C1-4329-955A-3FD4B24A086C}). */
  componentHostName?: Maybe<TextField>;
  /** ComponentId (ID: {9793E7A7-8235-457D-B0E1-28FD9BE1BC1A}). */
  componentId?: Maybe<TextField>;
  /** ComponentInstanceId (ID: {98DC43EF-C241-4CDA-858B-EB0C268E0E39}). */
  componentInstanceId?: Maybe<TextField>;
  /** ComponentLabel (ID: {C976D578-DCC8-425D-9642-ED09C8912D4F}). */
  componentLabel?: Maybe<TextField>;
  /** ComponentName (ID: {B24A98B6-A7E7-4B94-AFE0-3505C227516E}). */
  componentName?: Maybe<TextField>;
  /** ComponentRevision (ID: {44B4A313-AD98-46FA-864E-F42F4FDE8135}). */
  componentRevision?: Maybe<TextField>;
  /** ComponentVersion (ID: {5ACE96D4-F71D-4C66-8B9F-6FBC96D02674}). */
  componentVersion?: Maybe<TextField>;
  /** LibraryId (ID: {4F26AC1C-7CA9-40A7-9CCD-F1FE3BFF64AC}). */
  libraryId?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/FEaaS Wrapper Rendering Parameters template (ID: {1BC5FA34-38E3-4E74-8FA8-F181B297E3B7}). */
export type FEaaSWrapperRenderingParameters = BaseRenderingParameters & FEaaSRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'FEaaSWrapperRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ComponentConfiguration (ID: {EB331824-D4FA-46EC-8F46-0FCB44F2FF04}). */
  componentConfiguration?: Maybe<TextField>;
  /** ComponentDataOverride (ID: {4938816F-2E6A-48E1-9774-2FD27486EEF0}). */
  componentDataOverride?: Maybe<TextField>;
  /** ComponentHTMLOverride (ID: {81AAF152-9A76-4CC4-B536-696F24B6802B}). */
  componentHTMLOverride?: Maybe<TextField>;
  /** ComponentHostName (ID: {83A26F14-29C1-4329-955A-3FD4B24A086C}). */
  componentHostName?: Maybe<TextField>;
  /** ComponentId (ID: {9793E7A7-8235-457D-B0E1-28FD9BE1BC1A}). */
  componentId?: Maybe<TextField>;
  /** ComponentInstanceId (ID: {98DC43EF-C241-4CDA-858B-EB0C268E0E39}). */
  componentInstanceId?: Maybe<TextField>;
  /** ComponentLabel (ID: {C976D578-DCC8-425D-9642-ED09C8912D4F}). */
  componentLabel?: Maybe<TextField>;
  /** ComponentName (ID: {B24A98B6-A7E7-4B94-AFE0-3505C227516E}). */
  componentName?: Maybe<TextField>;
  /** ComponentRevision (ID: {44B4A313-AD98-46FA-864E-F42F4FDE8135}). */
  componentRevision?: Maybe<TextField>;
  /** ComponentVersion (ID: {5ACE96D4-F71D-4C66-8B9F-6FBC96D02674}). */
  componentVersion?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LibraryId (ID: {4F26AC1C-7CA9-40A7-9CCD-F1FE3BFF64AC}). */
  libraryId?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/FEaaS Wrapper Rendering Parameters template (ID: {1BC5FA34-38E3-4E74-8FA8-F181B297E3B7}). */
export type FEaaSWrapperRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/FEaaS Wrapper Rendering Parameters template (ID: {1BC5FA34-38E3-4E74-8FA8-F181B297E3B7}). */
export type FEaaSWrapperRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/FEaaS Wrapper Rendering Parameters template (ID: {1BC5FA34-38E3-4E74-8FA8-F181B297E3B7}). */
export type FEaaSWrapperRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/FEaaS Wrapper Rendering Parameters template (ID: {1BC5FA34-38E3-4E74-8FA8-F181B297E3B7}). */
export type FEaaSWrapperRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/FEaaS Wrapper Rendering Parameters template (ID: {1BC5FA34-38E3-4E74-8FA8-F181B297E3B7}). */
export type FEaaSWrapperRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/Rendering Parameters/FEaaS Wrapper Rendering Parameters template (ID: {1BC5FA34-38E3-4E74-8FA8-F181B297E3B7}). */
export type FEaaSWrapperRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/FacebookCommentsParametersTemplate template (ID: {F74CAD62-5EB2-45EE-93C1-691F264453AB}). */
export type FacebookCommentsParametersTemplate = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'FacebookCommentsParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Color Scheme (ID: {399DF37D-AA47-4E46-9621-723928D1DDFA}). */
  colorScheme?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Number of Posts (ID: {AFB8261F-0119-4EEF-8573-2394937A6A04}). */
  numberOfPosts?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/FacebookCommentsParametersTemplate template (ID: {F74CAD62-5EB2-45EE-93C1-691F264453AB}). */
export type FacebookCommentsParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/FacebookCommentsParametersTemplate template (ID: {F74CAD62-5EB2-45EE-93C1-691F264453AB}). */
export type FacebookCommentsParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/FacebookCommentsParametersTemplate template (ID: {F74CAD62-5EB2-45EE-93C1-691F264453AB}). */
export type FacebookCommentsParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/FacebookCommentsParametersTemplate template (ID: {F74CAD62-5EB2-45EE-93C1-691F264453AB}). */
export type FacebookCommentsParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/FacebookCommentsParametersTemplate template (ID: {F74CAD62-5EB2-45EE-93C1-691F264453AB}). */
export type FacebookCommentsParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Engagement/Rendering Parameters/FacebookCommentsParametersTemplate template (ID: {F74CAD62-5EB2-45EE-93C1-691F264453AB}). */
export type FacebookCommentsParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Item Buckets/Facet template (ID: {5C125B6D-C481-4C24-B5B9-9A23FE396BF0}). */
export type Facet = {
  /** Client Side Handle (ID: {7F42ED80-33F0-4C98-A1E7-B15BE7551C36}). */
  clientSideHandle?: Maybe<TextField>;
  /** DisplayName (ID: {5DE17054-0141-4E58-935B-FEC623A60806}). */
  displayName_5de1705401414e58935bfec623a60806?: Maybe<TextField>;
  /** Enabled (ID: {3D0FE806-D0E3-4254-96BE-A60899C7D2E6}). */
  enabled?: Maybe<CheckboxField>;
  /** Global (ID: {182BD0F4-C902-4A19-A1BA-D189CAA18E1B}). */
  global?: Maybe<CheckboxField>;
  /** Minimum Number of Items (ID: {8A3AC1B8-8CC1-4DD4-8766-9803F1601741}). */
  minimumNumberOfItems?: Maybe<NumberField>;
  /** Name (ID: {31CA077F-EF38-4980-8A24-05408031B2BC}). */
  name_31ca077fef3849808a2405408031b2bc?: Maybe<TextField>;
  /** Parameters (ID: {0E23BB51-C071-41B5-9D83-AC410B89B85A}). */
  parameters?: Maybe<TextField>;
  /** Type (ID: {FAE92C1E-9E2C-4209-89EB-C256D55E3D7F}). */
  type?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/FacetSelectorConfigBase template (ID: {67E85B88-929D-4F5B-BC21-B56D5358B931}). */
export type FacetSelectorConfigBase = {
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Slider template (ID: {1E36E4F6-B5E5-4EED-AFA9-A5AEC50F78A9}). */
export type FacetSlider = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & _SlidersRangeSettings & {
  __typename?: 'FacetSlider';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Relation (ID: {D7A9368B-BE90-41E0-B15D-FF1A253EB95D}). */
  relation?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** ShowRangeIndicators (ID: {10D0D449-2D0B-440D-92D8-DD9237C7E36B}). */
  showRangeIndicators?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Slider template (ID: {1E36E4F6-B5E5-4EED-AFA9-A5AEC50F78A9}). */
export type FacetSliderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Slider template (ID: {1E36E4F6-B5E5-4EED-AFA9-A5AEC50F78A9}). */
export type FacetSliderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Slider template (ID: {1E36E4F6-B5E5-4EED-AFA9-A5AEC50F78A9}). */
export type FacetSliderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Slider template (ID: {1E36E4F6-B5E5-4EED-AFA9-A5AEC50F78A9}). */
export type FacetSliderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Slider template (ID: {1E36E4F6-B5E5-4EED-AFA9-A5AEC50F78A9}). */
export type FacetSliderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Slider template (ID: {1E36E4F6-B5E5-4EED-AFA9-A5AEC50F78A9}). */
export type FacetSliderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Slider Folder template (ID: {EBB0B13D-CCF4-4BDF-8D3C-E2FDB4BB0240}). */
export type FacetSliderFolder = Item & {
  __typename?: 'FacetSliderFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Slider Folder template (ID: {EBB0B13D-CCF4-4BDF-8D3C-E2FDB4BB0240}). */
export type FacetSliderFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Slider Folder template (ID: {EBB0B13D-CCF4-4BDF-8D3C-E2FDB4BB0240}). */
export type FacetSliderFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Slider Folder template (ID: {EBB0B13D-CCF4-4BDF-8D3C-E2FDB4BB0240}). */
export type FacetSliderFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Slider Folder template (ID: {EBB0B13D-CCF4-4BDF-8D3C-E2FDB4BB0240}). */
export type FacetSliderFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Slider Folder template (ID: {EBB0B13D-CCF4-4BDF-8D3C-E2FDB4BB0240}). */
export type FacetSliderFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Slider Folder template (ID: {EBB0B13D-CCF4-4BDF-8D3C-E2FDB4BB0240}). */
export type FacetSliderFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Slider template (ID: {995CE2C7-319F-478B-84FE-22053AC85BB7}). */
export type FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = FacetSelectorConfigBase & Item & {
  __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** ChangeStep (ID: {0B1358CB-0123-494C-A786-F160F7FAA337}). */
  changeStep?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Facet (ID: {94DB1E7D-B26A-400E-95D6-9186E9AC7394}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Format String (ID: {2952C881-DD21-432D-9E4E-6A2EFC87BEE2}). */
  formatString?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MaxValue (ID: {9EECBCE9-8E42-4DF4-8FDE-50BB4E2F2BD2}). */
  maxValue?: Maybe<TextField>;
  /** MinValue (ID: {5FD6392A-5778-4203-8C08-70115F38B4F3}). */
  minValue?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SelectedValue (ID: {D388278B-FB70-4132-94B4-5A7B0158C934}). */
  selectedValue?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Slider template (ID: {995CE2C7-319F-478B-84FE-22053AC85BB7}). */
export type FacetSlider_995ce2c7319f478b84fe22053ac85bb7AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Slider template (ID: {995CE2C7-319F-478B-84FE-22053AC85BB7}). */
export type FacetSlider_995ce2c7319f478b84fe22053ac85bb7ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Slider template (ID: {995CE2C7-319F-478B-84FE-22053AC85BB7}). */
export type FacetSlider_995ce2c7319f478b84fe22053ac85bb7FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Slider template (ID: {995CE2C7-319F-478B-84FE-22053AC85BB7}). */
export type FacetSlider_995ce2c7319f478b84fe22053ac85bb7FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Slider template (ID: {995CE2C7-319F-478B-84FE-22053AC85BB7}). */
export type FacetSlider_995ce2c7319f478b84fe22053ac85bb7HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Slider template (ID: {995CE2C7-319F-478B-84FE-22053AC85BB7}). */
export type FacetSlider_995ce2c7319f478b84fe22053ac85bb7IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Summary template (ID: {D829066A-F9D9-4507-A922-A3F6058DBB73}). */
export type FacetSummary = FacetSelectorConfigBase & Item & {
  __typename?: 'FacetSummary';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Summary template (ID: {D829066A-F9D9-4507-A922-A3F6058DBB73}). */
export type FacetSummaryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Summary template (ID: {D829066A-F9D9-4507-A922-A3F6058DBB73}). */
export type FacetSummaryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Summary template (ID: {D829066A-F9D9-4507-A922-A3F6058DBB73}). */
export type FacetSummaryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Summary template (ID: {D829066A-F9D9-4507-A922-A3F6058DBB73}). */
export type FacetSummaryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Summary template (ID: {D829066A-F9D9-4507-A922-A3F6058DBB73}). */
export type FacetSummaryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Facet Summary template (ID: {D829066A-F9D9-4507-A922-A3F6058DBB73}). */
export type FacetSummaryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Summary Folder template (ID: {3DB5C823-61CB-449A-B4AB-E461626DC119}). */
export type FacetSummaryFolder = Item & {
  __typename?: 'FacetSummaryFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Summary Folder template (ID: {3DB5C823-61CB-449A-B4AB-E461626DC119}). */
export type FacetSummaryFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Summary Folder template (ID: {3DB5C823-61CB-449A-B4AB-E461626DC119}). */
export type FacetSummaryFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Summary Folder template (ID: {3DB5C823-61CB-449A-B4AB-E461626DC119}). */
export type FacetSummaryFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Summary Folder template (ID: {3DB5C823-61CB-449A-B4AB-E461626DC119}). */
export type FacetSummaryFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Summary Folder template (ID: {3DB5C823-61CB-449A-B4AB-E461626DC119}). */
export type FacetSummaryFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Facet Summary Folder template (ID: {3DB5C823-61CB-449A-B4AB-E461626DC119}). */
export type FacetSummaryFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Summary template (ID: {CD5C935C-1F60-4D89-9A6B-88CE28305CF2}). */
export type FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2 = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Summary template (ID: {CD5C935C-1F60-4D89-9A6B-88CE28305CF2}). */
export type FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Summary template (ID: {CD5C935C-1F60-4D89-9A6B-88CE28305CF2}). */
export type FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Summary template (ID: {CD5C935C-1F60-4D89-9A6B-88CE28305CF2}). */
export type FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Summary template (ID: {CD5C935C-1F60-4D89-9A6B-88CE28305CF2}). */
export type FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Summary template (ID: {CD5C935C-1F60-4D89-9A6B-88CE28305CF2}). */
export type FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Facet Summary template (ID: {CD5C935C-1F60-4D89-9A6B-88CE28305CF2}). */
export type FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets Grouping template (ID: {20EF5E69-B366-4E9E-960B-E451B24DBD46}). */
export type FacetsGrouping = Item & {
  __typename?: 'FacetsGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets Grouping template (ID: {20EF5E69-B366-4E9E-960B-E451B24DBD46}). */
export type FacetsGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets Grouping template (ID: {20EF5E69-B366-4E9E-960B-E451B24DBD46}). */
export type FacetsGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets Grouping template (ID: {20EF5E69-B366-4E9E-960B-E451B24DBD46}). */
export type FacetsGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets Grouping template (ID: {20EF5E69-B366-4E9E-960B-E451B24DBD46}). */
export type FacetsGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets Grouping template (ID: {20EF5E69-B366-4E9E-960B-E451B24DBD46}). */
export type FacetsGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets Grouping template (ID: {20EF5E69-B366-4E9E-960B-E451B24DBD46}). */
export type FacetsGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Fake/Fake Navigation Item template (ID: {C7DDD6B8-90FD-4097-82D5-792AFD6777E6}). */
export type FakeNavigationItem = Item & _Content & _Navigable & _Title & {
  __typename?: 'FakeNavigationItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {7152697D-E946-4EC4-AAD5-223FCC204CE7}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {1AB993C6-6E09-4367-AAF2-9372B017910B}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Fake/Fake Navigation Item template (ID: {C7DDD6B8-90FD-4097-82D5-792AFD6777E6}). */
export type FakeNavigationItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Fake/Fake Navigation Item template (ID: {C7DDD6B8-90FD-4097-82D5-792AFD6777E6}). */
export type FakeNavigationItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Fake/Fake Navigation Item template (ID: {C7DDD6B8-90FD-4097-82D5-792AFD6777E6}). */
export type FakeNavigationItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Fake/Fake Navigation Item template (ID: {C7DDD6B8-90FD-4097-82D5-792AFD6777E6}). */
export type FakeNavigationItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Fake/Fake Navigation Item template (ID: {C7DDD6B8-90FD-4097-82D5-792AFD6777E6}). */
export type FakeNavigationItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Fake/Fake Navigation Item template (ID: {C7DDD6B8-90FD-4097-82D5-792AFD6777E6}). */
export type FakeNavigationItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Feature Banner template (ID: {B6914840-F489-4FC6-B33E-C374F94F1781}). */
export type FeatureBanner = Item & {
  __typename?: 'FeatureBanner';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {0B4FE217-D28C-4963-AD07-D4307E69D9D8}). */
  cta?: Maybe<TextField>;
  /** description (ID: {87DA23BA-C52B-4C36-930A-3E4B66E44871}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {AE3A7803-10C9-4270-94FA-B9048D50B6DC}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** subtitle (ID: {297F503F-9A10-40E0-9F2F-2543E9362D8D}). */
  subtitle?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {735A9A08-D05F-4166-BC24-6CECADAA99BA}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Feature Banner template (ID: {B6914840-F489-4FC6-B33E-C374F94F1781}). */
export type FeatureBannerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Feature Banner template (ID: {B6914840-F489-4FC6-B33E-C374F94F1781}). */
export type FeatureBannerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Feature Banner template (ID: {B6914840-F489-4FC6-B33E-C374F94F1781}). */
export type FeatureBannerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Feature Banner template (ID: {B6914840-F489-4FC6-B33E-C374F94F1781}). */
export type FeatureBannerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Feature Banner template (ID: {B6914840-F489-4FC6-B33E-C374F94F1781}). */
export type FeatureBannerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Feature Banner template (ID: {B6914840-F489-4FC6-B33E-C374F94F1781}). */
export type FeatureBannerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Feature Banner Parameters Template template (ID: {5ADD43D4-83A7-4D65-A0A9-7F954DD5E898}). */
export type FeatureBannerParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'FeatureBannerParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {BEB81D40-639F-43D5-A412-260656F71FE2}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** imagePosition (ID: {512373C0-C807-4E83-B35C-CA1E8EC163E7}). */
  imagePosition?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Feature Banner Parameters Template template (ID: {5ADD43D4-83A7-4D65-A0A9-7F954DD5E898}). */
export type FeatureBannerParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Feature Banner Parameters Template template (ID: {5ADD43D4-83A7-4D65-A0A9-7F954DD5E898}). */
export type FeatureBannerParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Feature Banner Parameters Template template (ID: {5ADD43D4-83A7-4D65-A0A9-7F954DD5E898}). */
export type FeatureBannerParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Feature Banner Parameters Template template (ID: {5ADD43D4-83A7-4D65-A0A9-7F954DD5E898}). */
export type FeatureBannerParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Feature Banner Parameters Template template (ID: {5ADD43D4-83A7-4D65-A0A9-7F954DD5E898}). */
export type FeatureBannerParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Feature Banner Parameters Template template (ID: {5ADD43D4-83A7-4D65-A0A9-7F954DD5E898}). */
export type FeatureBannerParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles template (ID: {8E1FE264-7619-4B71-BA66-C21A5819A595}). */
export type FeaturedArticles = Item & {
  __typename?: 'FeaturedArticles';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articles (ID: {D5B70CCF-415C-4B3E-8572-26AD0D9E3571}). */
  articles?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles template (ID: {8E1FE264-7619-4B71-BA66-C21A5819A595}). */
export type FeaturedArticlesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles template (ID: {8E1FE264-7619-4B71-BA66-C21A5819A595}). */
export type FeaturedArticlesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles template (ID: {8E1FE264-7619-4B71-BA66-C21A5819A595}). */
export type FeaturedArticlesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles template (ID: {8E1FE264-7619-4B71-BA66-C21A5819A595}). */
export type FeaturedArticlesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles template (ID: {8E1FE264-7619-4B71-BA66-C21A5819A595}). */
export type FeaturedArticlesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles template (ID: {8E1FE264-7619-4B71-BA66-C21A5819A595}). */
export type FeaturedArticlesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles Folder template (ID: {7CCDF3F1-499A-4441-B527-2812D0EA4832}). */
export type FeaturedArticlesFolder = Item & {
  __typename?: 'FeaturedArticlesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles Folder template (ID: {7CCDF3F1-499A-4441-B527-2812D0EA4832}). */
export type FeaturedArticlesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles Folder template (ID: {7CCDF3F1-499A-4441-B527-2812D0EA4832}). */
export type FeaturedArticlesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles Folder template (ID: {7CCDF3F1-499A-4441-B527-2812D0EA4832}). */
export type FeaturedArticlesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles Folder template (ID: {7CCDF3F1-499A-4441-B527-2812D0EA4832}). */
export type FeaturedArticlesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles Folder template (ID: {7CCDF3F1-499A-4441-B527-2812D0EA4832}). */
export type FeaturedArticlesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Articles/Featured Articles Folder template (ID: {7CCDF3F1-499A-4441-B527-2812D0EA4832}). */
export type FeaturedArticlesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Theme template (ID: {3B76CCDF-A50F-4F8A-AAF0-407A19926A49}). */
export type FeaturedTheme = Item & {
  __typename?: 'FeaturedTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** theme (ID: {5285E5E8-066D-403E-ABD4-153ECBE02DE3}). */
  theme?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Theme template (ID: {3B76CCDF-A50F-4F8A-AAF0-407A19926A49}). */
export type FeaturedThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Theme template (ID: {3B76CCDF-A50F-4F8A-AAF0-407A19926A49}). */
export type FeaturedThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Theme template (ID: {3B76CCDF-A50F-4F8A-AAF0-407A19926A49}). */
export type FeaturedThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Theme template (ID: {3B76CCDF-A50F-4F8A-AAF0-407A19926A49}). */
export type FeaturedThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Theme template (ID: {3B76CCDF-A50F-4F8A-AAF0-407A19926A49}). */
export type FeaturedThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Theme template (ID: {3B76CCDF-A50F-4F8A-AAF0-407A19926A49}). */
export type FeaturedThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Themes Folder template (ID: {E24313A7-5B2C-4468-89F2-11D9AD8E9FC8}). */
export type FeaturedThemesFolder = Item & {
  __typename?: 'FeaturedThemesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Themes Folder template (ID: {E24313A7-5B2C-4468-89F2-11D9AD8E9FC8}). */
export type FeaturedThemesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Themes Folder template (ID: {E24313A7-5B2C-4468-89F2-11D9AD8E9FC8}). */
export type FeaturedThemesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Themes Folder template (ID: {E24313A7-5B2C-4468-89F2-11D9AD8E9FC8}). */
export type FeaturedThemesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Themes Folder template (ID: {E24313A7-5B2C-4468-89F2-11D9AD8E9FC8}). */
export type FeaturedThemesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Themes Folder template (ID: {E24313A7-5B2C-4468-89F2-11D9AD8E9FC8}). */
export type FeaturedThemesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Featured Theme/Featured Themes Folder template (ID: {E24313A7-5B2C-4468-89F2-11D9AD8E9FC8}). */
export type FeaturedThemesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed template (ID: {B7F764A3-AD45-4666-A169-0C5A836D8AE2}). */
export type Feed = Item & {
  __typename?: 'Feed';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CacheInterval (ID: {ED0ADCCF-7ED0-407E-B42A-F3F8766AE53F}). */
  cacheInterval?: Maybe<IntegerField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** FeedUrl (ID: {2D52A3F9-29C6-4AC1-A0A4-5693ACB3DB48}). */
  feedUrl?: Maybe<LinkField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ItemsNumber (ID: {CE0FAE5A-7E2C-48BE-AA15-12F0D55C582F}). */
  itemsNumber?: Maybe<IntegerField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** ReadMoreLink (ID: {383E3E76-5688-4138-942B-4F9F6749056C}). */
  readMoreLink?: Maybe<LinkField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {FEFB37DF-0883-4714-B7FC-607B5ADA8908}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed template (ID: {B7F764A3-AD45-4666-A169-0C5A836D8AE2}). */
export type FeedAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed template (ID: {B7F764A3-AD45-4666-A169-0C5A836D8AE2}). */
export type FeedChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed template (ID: {B7F764A3-AD45-4666-A169-0C5A836D8AE2}). */
export type FeedFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed template (ID: {B7F764A3-AD45-4666-A169-0C5A836D8AE2}). */
export type FeedFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed template (ID: {B7F764A3-AD45-4666-A169-0C5A836D8AE2}). */
export type FeedHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed template (ID: {B7F764A3-AD45-4666-A169-0C5A836D8AE2}). */
export type FeedIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed Folder template (ID: {4EB7DDBF-D224-4FF1-B9D5-425712210972}). */
export type FeedFolder = Item & {
  __typename?: 'FeedFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed Folder template (ID: {4EB7DDBF-D224-4FF1-B9D5-425712210972}). */
export type FeedFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed Folder template (ID: {4EB7DDBF-D224-4FF1-B9D5-425712210972}). */
export type FeedFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed Folder template (ID: {4EB7DDBF-D224-4FF1-B9D5-425712210972}). */
export type FeedFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed Folder template (ID: {4EB7DDBF-D224-4FF1-B9D5-425712210972}). */
export type FeedFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed Folder template (ID: {4EB7DDBF-D224-4FF1-B9D5-425712210972}). */
export type FeedFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Feed Folder template (ID: {4EB7DDBF-D224-4FF1-B9D5-425712210972}). */
export type FeedFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Feed Parameters template (ID: {69FBC1EF-6BDE-494F-B576-1D35C2616975}). */
export type FeedParameters = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'FeedParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TitleHeadingLevel (ID: {8E0DEBBE-2E8A-46BD-B594-8B0FABC44D40}). */
  titleHeadingLevel?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Feed Parameters template (ID: {69FBC1EF-6BDE-494F-B576-1D35C2616975}). */
export type FeedParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Feed Parameters template (ID: {69FBC1EF-6BDE-494F-B576-1D35C2616975}). */
export type FeedParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Feed Parameters template (ID: {69FBC1EF-6BDE-494F-B576-1D35C2616975}). */
export type FeedParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Feed Parameters template (ID: {69FBC1EF-6BDE-494F-B576-1D35C2616975}). */
export type FeedParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Feed Parameters template (ID: {69FBC1EF-6BDE-494F-B576-1D35C2616975}). */
export type FeedParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Feed Parameters template (ID: {69FBC1EF-6BDE-494F-B576-1D35C2616975}). */
export type FeedParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Field Editor template (ID: {22CB1238-575A-45B5-8420-6EA53DA62E5F}). */
export type FieldEditor = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'FieldEditor';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Field Editor template (ID: {22CB1238-575A-45B5-8420-6EA53DA62E5F}). */
export type FieldEditorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Field Editor template (ID: {22CB1238-575A-45B5-8420-6EA53DA62E5F}). */
export type FieldEditorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Field Editor template (ID: {22CB1238-575A-45B5-8420-6EA53DA62E5F}). */
export type FieldEditorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Field Editor template (ID: {22CB1238-575A-45B5-8420-6EA53DA62E5F}). */
export type FieldEditorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Field Editor template (ID: {22CB1238-575A-45B5-8420-6EA53DA62E5F}). */
export type FieldEditorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Field Editor template (ID: {22CB1238-575A-45B5-8420-6EA53DA62E5F}). */
export type FieldEditorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/MVC/Rendering Parameters/Field Renderer template (ID: {FD22A454-F1A8-4D1B-A46B-EBA0C7F7F6C9}). */
export type FieldRenderer = Item & StandardRenderingParameters & {
  __typename?: 'FieldRenderer';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldName (ID: {AAB65432-C1FF-4FF2-9FBD-F3D2A0F35D20}). */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/Rendering Parameters/Field Renderer template (ID: {FD22A454-F1A8-4D1B-A46B-EBA0C7F7F6C9}). */
export type FieldRendererAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/Rendering Parameters/Field Renderer template (ID: {FD22A454-F1A8-4D1B-A46B-EBA0C7F7F6C9}). */
export type FieldRendererChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/Rendering Parameters/Field Renderer template (ID: {FD22A454-F1A8-4D1B-A46B-EBA0C7F7F6C9}). */
export type FieldRendererFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/Rendering Parameters/Field Renderer template (ID: {FD22A454-F1A8-4D1B-A46B-EBA0C7F7F6C9}). */
export type FieldRendererFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/Rendering Parameters/Field Renderer template (ID: {FD22A454-F1A8-4D1B-A46B-EBA0C7F7F6C9}). */
export type FieldRendererHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/Rendering Parameters/Field Renderer template (ID: {FD22A454-F1A8-4D1B-A46B-EBA0C7F7F6C9}). */
export type FieldRendererIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Media/Unversioned/File template (ID: {962B53C4-F93B-4DF9-9821-415C867B8903}). */
export type File = {
  /** Blob (ID: {40E50ED9-BA07-4702-992E-A912738D32DC}). */
  blob?: Maybe<TextField>;
  /** CountryCode (ID: {FF01BC1A-EF22-407C-9115-7DBEE11451A5}). */
  countryCode?: Maybe<TextField>;
  /** Description (ID: {BA8341A1-FF30-47B8-AE6A-F4947E4113F0}). */
  description?: Maybe<TextField>;
  /** Extension (ID: {C06867FE-9A43-4C7D-B739-48780492D06F}). */
  extension?: Maybe<TextField>;
  /** File Path (ID: {2134867A-AC67-4DAC-836C-A9264FD9D6D6}). */
  filePath?: Maybe<TextField>;
  /** Format (ID: {FBD90442-DB0C-48F1-A0F4-0427CD9AFCCE}). */
  format?: Maybe<TextField>;
  /** Keywords (ID: {2FAFE7CB-2691-4800-8848-255EFA1D31AA}). */
  keywords?: Maybe<TextField>;
  /** Latitude (ID: {5D589EC4-4842-4630-A860-540357A196F3}). */
  latitude?: Maybe<NumberField>;
  /** LocationDescription (ID: {E8FA62D2-13FC-4C5C-91E5-71D615591420}). */
  locationDescription?: Maybe<TextField>;
  /** Longitude (ID: {11CB6358-8F71-4F80-AB30-04D745D99D56}). */
  longitude?: Maybe<NumberField>;
  /** Mime Type (ID: {6F47A0A5-9C94-4B48-ABEB-42D38DEF6054}). */
  mimeType?: Maybe<TextField>;
  /** Size (ID: {6954B7C7-2487-423F-8600-436CB3B6DC0E}). */
  size?: Maybe<TextField>;
  /** Title (ID: {3F4B20E9-36E6-4D45-A423-C86567373F82}). */
  title?: Maybe<TextField>;
  /** ZipCode (ID: {FB540BF1-B2EB-47C9-A55F-F01B2FCA5851}). */
  zipCode?: Maybe<TextField>;
};

export type FileField = ItemField & {
  __typename?: 'FileField';
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The description of the media item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The extension of the media item (for example, 'jpg', 'gif'). */
  extension?: Maybe<Scalars['String']['output']>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The keywords of the media item. */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the media item (for example, 'image/jpeg'). */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** The size, in bytes, of the media item. */
  size?: Maybe<Scalars['Int']['output']>;
  /** The title of the media item. */
  title?: Maybe<Scalars['String']['output']>;
  /** The URL to the media item. */
  url?: Maybe<Scalars['String']['output']>;
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type FileFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List template (ID: {97E0240B-B5FC-422B-8A72-44D2B00FACD6}). */
export type FileList = Item & {
  __typename?: 'FileList';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {31EB03B0-13E7-4C65-9BC0-0E7887A51B05}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List template (ID: {97E0240B-B5FC-422B-8A72-44D2B00FACD6}). */
export type FileListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List template (ID: {97E0240B-B5FC-422B-8A72-44D2B00FACD6}). */
export type FileListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List template (ID: {97E0240B-B5FC-422B-8A72-44D2B00FACD6}). */
export type FileListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List template (ID: {97E0240B-B5FC-422B-8A72-44D2B00FACD6}). */
export type FileListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List template (ID: {97E0240B-B5FC-422B-8A72-44D2B00FACD6}). */
export type FileListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List template (ID: {97E0240B-B5FC-422B-8A72-44D2B00FACD6}). */
export type FileListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List Folder template (ID: {C959E8EF-CD42-4967-83F6-BEE092C0BEAE}). */
export type FileListFolder = Item & {
  __typename?: 'FileListFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List Folder template (ID: {C959E8EF-CD42-4967-83F6-BEE092C0BEAE}). */
export type FileListFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List Folder template (ID: {C959E8EF-CD42-4967-83F6-BEE092C0BEAE}). */
export type FileListFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List Folder template (ID: {C959E8EF-CD42-4967-83F6-BEE092C0BEAE}). */
export type FileListFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List Folder template (ID: {C959E8EF-CD42-4967-83F6-BEE092C0BEAE}). */
export type FileListFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List Folder template (ID: {C959E8EF-CD42-4967-83F6-BEE092C0BEAE}). */
export type FileListFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File List Folder template (ID: {C959E8EF-CD42-4967-83F6-BEE092C0BEAE}). */
export type FileListFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/FileListParametersTemplate template (ID: {863B6357-09FB-462F-A819-D8F41CD39BDE}). */
export type FileListParametersTemplate = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IPaginable & IPagination & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'FileListParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** ListSignature (ID: {3E44E786-672E-4DC0-86A0-FFF0D99A3471}). */
  listSignature?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Offset (ID: {778DF306-72BF-4ECA-8DED-0F0A18A5F9B4}). */
  offset?: Maybe<IntegerField>;
  /** PageSize (ID: {C5A5C905-855F-4DA9-941A-2C20845D0473}). */
  pageSize?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TitleHeadingLevel (ID: {90C4649D-5917-4946-965C-D0EB1ECC4BA8}). */
  titleHeadingLevel?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/FileListParametersTemplate template (ID: {863B6357-09FB-462F-A819-D8F41CD39BDE}). */
export type FileListParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/FileListParametersTemplate template (ID: {863B6357-09FB-462F-A819-D8F41CD39BDE}). */
export type FileListParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/FileListParametersTemplate template (ID: {863B6357-09FB-462F-A819-D8F41CD39BDE}). */
export type FileListParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/FileListParametersTemplate template (ID: {863B6357-09FB-462F-A819-D8F41CD39BDE}). */
export type FileListParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/FileListParametersTemplate template (ID: {863B6357-09FB-462F-A819-D8F41CD39BDE}). */
export type FileListParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/FileListParametersTemplate template (ID: {863B6357-09FB-462F-A819-D8F41CD39BDE}). */
export type FileListParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File template (ID: {04129321-7708-49C1-801B-AEE196E1C0A8}). */
export type File_04129321770849c1801baee196e1c0a8 = Item & {
  __typename?: 'File_04129321770849c1801baee196e1c0a8';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CustomImage (ID: {413F42D9-9868-418A-9A0E-770202B9CCC4}). */
  customImage?: Maybe<ImageField>;
  /** Description (ID: {75797CEC-589F-47E2-B416-45CFF546EEE1}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** File (ID: {74A012F7-D87B-456E-A447-6F392C69C48F}). */
  file?: Maybe<FileField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LinkText (ID: {58DEEF8C-1A88-449E-B165-BFE3BE9B53B7}). */
  linkText?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File template (ID: {04129321-7708-49C1-801B-AEE196E1C0A8}). */
export type File_04129321770849c1801baee196e1c0a8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File template (ID: {04129321-7708-49C1-801B-AEE196E1C0A8}). */
export type File_04129321770849c1801baee196e1c0a8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File template (ID: {04129321-7708-49C1-801B-AEE196E1C0A8}). */
export type File_04129321770849c1801baee196e1c0a8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File template (ID: {04129321-7708-49C1-801B-AEE196E1C0A8}). */
export type File_04129321770849c1801baee196e1c0a8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File template (ID: {04129321-7708-49C1-801B-AEE196E1C0A8}). */
export type File_04129321770849c1801baee196e1c0a8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/File template (ID: {04129321-7708-49C1-801B-AEE196E1C0A8}). */
export type File_04129321770849c1801baee196e1c0a8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria template (ID: {85089D7D-40C1-49F8-9EC7-CC5388E0843C}). */
export type FilterCriteria = Item & {
  __typename?: 'FilterCriteria';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteriaTemplate (ID: {C3862B81-CAD2-4994-BBEA-E98E4C0732A2}). */
  criteriaTemplate?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** indexFieldName (ID: {608D75CB-C114-4077-A40A-B2F14C0A3851}). */
  indexFieldName?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria template (ID: {85089D7D-40C1-49F8-9EC7-CC5388E0843C}). */
export type FilterCriteriaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria template (ID: {85089D7D-40C1-49F8-9EC7-CC5388E0843C}). */
export type FilterCriteriaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria template (ID: {85089D7D-40C1-49F8-9EC7-CC5388E0843C}). */
export type FilterCriteriaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria template (ID: {85089D7D-40C1-49F8-9EC7-CC5388E0843C}). */
export type FilterCriteriaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria template (ID: {85089D7D-40C1-49F8-9EC7-CC5388E0843C}). */
export type FilterCriteriaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria template (ID: {85089D7D-40C1-49F8-9EC7-CC5388E0843C}). */
export type FilterCriteriaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria Folder template (ID: {B15BB657-8A3E-4708-A1ED-57A3B97D632E}). */
export type FilterCriteriaFolder = Item & {
  __typename?: 'FilterCriteriaFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria Folder template (ID: {B15BB657-8A3E-4708-A1ED-57A3B97D632E}). */
export type FilterCriteriaFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria Folder template (ID: {B15BB657-8A3E-4708-A1ED-57A3B97D632E}). */
export type FilterCriteriaFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria Folder template (ID: {B15BB657-8A3E-4708-A1ED-57A3B97D632E}). */
export type FilterCriteriaFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria Folder template (ID: {B15BB657-8A3E-4708-A1ED-57A3B97D632E}). */
export type FilterCriteriaFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria Folder template (ID: {B15BB657-8A3E-4708-A1ED-57A3B97D632E}). */
export type FilterCriteriaFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Criteria/Filter Criteria Folder template (ID: {B15BB657-8A3E-4708-A1ED-57A3B97D632E}). */
export type FilterCriteriaFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Option template (ID: {182FC379-9DB1-47C4-8978-DACD5EE6F410}). */
export type FilterTaxonomyOption = Item & {
  __typename?: 'FilterTaxonomyOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Option template (ID: {182FC379-9DB1-47C4-8978-DACD5EE6F410}). */
export type FilterTaxonomyOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Option template (ID: {182FC379-9DB1-47C4-8978-DACD5EE6F410}). */
export type FilterTaxonomyOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Option template (ID: {182FC379-9DB1-47C4-8978-DACD5EE6F410}). */
export type FilterTaxonomyOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Option template (ID: {182FC379-9DB1-47C4-8978-DACD5EE6F410}). */
export type FilterTaxonomyOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Option template (ID: {182FC379-9DB1-47C4-8978-DACD5EE6F410}). */
export type FilterTaxonomyOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Option template (ID: {182FC379-9DB1-47C4-8978-DACD5EE6F410}). */
export type FilterTaxonomyOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Options template (ID: {16EFD4C4-F376-4976-AD9F-45965F37BB38}). */
export type FilterTaxonomyOptions = Item & {
  __typename?: 'FilterTaxonomyOptions';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Options template (ID: {16EFD4C4-F376-4976-AD9F-45965F37BB38}). */
export type FilterTaxonomyOptionsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Options template (ID: {16EFD4C4-F376-4976-AD9F-45965F37BB38}). */
export type FilterTaxonomyOptionsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Options template (ID: {16EFD4C4-F376-4976-AD9F-45965F37BB38}). */
export type FilterTaxonomyOptionsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Options template (ID: {16EFD4C4-F376-4976-AD9F-45965F37BB38}). */
export type FilterTaxonomyOptionsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Options template (ID: {16EFD4C4-F376-4976-AD9F-45965F37BB38}). */
export type FilterTaxonomyOptionsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Filter Taxonomy/Filter Taxonomy Options template (ID: {16EFD4C4-F376-4976-AD9F-45965F37BB38}). */
export type FilterTaxonomyOptionsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Parent Page template (ID: {2EA9D8A5-30BB-4B06-B6CB-E8D19B962F5D}). */
export type FilteredArticlesParentPage = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesParentPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Parent Page template (ID: {2EA9D8A5-30BB-4B06-B6CB-E8D19B962F5D}). */
export type FilteredArticlesParentPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Parent Page template (ID: {2EA9D8A5-30BB-4B06-B6CB-E8D19B962F5D}). */
export type FilteredArticlesParentPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Parent Page template (ID: {2EA9D8A5-30BB-4B06-B6CB-E8D19B962F5D}). */
export type FilteredArticlesParentPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Parent Page template (ID: {2EA9D8A5-30BB-4B06-B6CB-E8D19B962F5D}). */
export type FilteredArticlesParentPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Parent Page template (ID: {2EA9D8A5-30BB-4B06-B6CB-E8D19B962F5D}). */
export type FilteredArticlesParentPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Parent Page template (ID: {2EA9D8A5-30BB-4B06-B6CB-E8D19B962F5D}). */
export type FilteredArticlesParentPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Parent Page template (ID: {6ADC5BE1-46AB-4C7D-97F6-4E5C3512177D}). */
export type FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Parent Page template (ID: {6ADC5BE1-46AB-4C7D-97F6-4E5C3512177D}). */
export type FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Parent Page template (ID: {6ADC5BE1-46AB-4C7D-97F6-4E5C3512177D}). */
export type FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Parent Page template (ID: {6ADC5BE1-46AB-4C7D-97F6-4E5C3512177D}). */
export type FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Parent Page template (ID: {6ADC5BE1-46AB-4C7D-97F6-4E5C3512177D}). */
export type FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Parent Page template (ID: {6ADC5BE1-46AB-4C7D-97F6-4E5C3512177D}). */
export type FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Parent Page template (ID: {6ADC5BE1-46AB-4C7D-97F6-4E5C3512177D}). */
export type FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Parent Page template (ID: {7F5D3442-47EB-446A-8F14-7890B998E941}). */
export type FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Parent Page template (ID: {7F5D3442-47EB-446A-8F14-7890B998E941}). */
export type FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Parent Page template (ID: {7F5D3442-47EB-446A-8F14-7890B998E941}). */
export type FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Parent Page template (ID: {7F5D3442-47EB-446A-8F14-7890B998E941}). */
export type FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Parent Page template (ID: {7F5D3442-47EB-446A-8F14-7890B998E941}). */
export type FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Parent Page template (ID: {7F5D3442-47EB-446A-8F14-7890B998E941}). */
export type FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Parent Page template (ID: {7F5D3442-47EB-446A-8F14-7890B998E941}). */
export type FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Parent Page template (ID: {A3484503-9CF1-441F-8C96-7A5BBBDD7616}). */
export type FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Parent Page template (ID: {A3484503-9CF1-441F-8C96-7A5BBBDD7616}). */
export type FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Parent Page template (ID: {A3484503-9CF1-441F-8C96-7A5BBBDD7616}). */
export type FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Parent Page template (ID: {A3484503-9CF1-441F-8C96-7A5BBBDD7616}). */
export type FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Parent Page template (ID: {A3484503-9CF1-441F-8C96-7A5BBBDD7616}). */
export type FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Parent Page template (ID: {A3484503-9CF1-441F-8C96-7A5BBBDD7616}). */
export type FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Parent Page template (ID: {A3484503-9CF1-441F-8C96-7A5BBBDD7616}). */
export type FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Parent Page template (ID: {E4F65F07-4322-4857-8746-0A4058D378F9}). */
export type FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Parent Page template (ID: {E4F65F07-4322-4857-8746-0A4058D378F9}). */
export type FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Parent Page template (ID: {E4F65F07-4322-4857-8746-0A4058D378F9}). */
export type FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Parent Page template (ID: {E4F65F07-4322-4857-8746-0A4058D378F9}). */
export type FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Parent Page template (ID: {E4F65F07-4322-4857-8746-0A4058D378F9}). */
export type FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Parent Page template (ID: {E4F65F07-4322-4857-8746-0A4058D378F9}). */
export type FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Parent Page template (ID: {E4F65F07-4322-4857-8746-0A4058D378F9}). */
export type FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Parent Page template (ID: {F099104E-8720-4D52-A6AB-75AA44D159CE}). */
export type FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Parent Page template (ID: {F099104E-8720-4D52-A6AB-75AA44D159CE}). */
export type FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ceAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Parent Page template (ID: {F099104E-8720-4D52-A6AB-75AA44D159CE}). */
export type FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ceChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Parent Page template (ID: {F099104E-8720-4D52-A6AB-75AA44D159CE}). */
export type FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ceFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Parent Page template (ID: {F099104E-8720-4D52-A6AB-75AA44D159CE}). */
export type FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ceFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Parent Page template (ID: {F099104E-8720-4D52-A6AB-75AA44D159CE}). */
export type FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ceHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Parent Page template (ID: {F099104E-8720-4D52-A6AB-75AA44D159CE}). */
export type FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ceIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Wildcard Page template (ID: {262140F5-5FFD-474B-A3AA-8C3EFFE8F27B}). */
export type FilteredArticlesWildcardPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b & Item & _BasePage & _Designable & _FilteredArticlesWildcard & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesWildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Wildcard Page template (ID: {262140F5-5FFD-474B-A3AA-8C3EFFE8F27B}). */
export type FilteredArticlesWildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Wildcard Page template (ID: {262140F5-5FFD-474B-A3AA-8C3EFFE8F27B}). */
export type FilteredArticlesWildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Wildcard Page template (ID: {262140F5-5FFD-474B-A3AA-8C3EFFE8F27B}). */
export type FilteredArticlesWildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Wildcard Page template (ID: {262140F5-5FFD-474B-A3AA-8C3EFFE8F27B}). */
export type FilteredArticlesWildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Wildcard Page template (ID: {262140F5-5FFD-474B-A3AA-8C3EFFE8F27B}). */
export type FilteredArticlesWildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Filtered Articles Wildcard Page template (ID: {262140F5-5FFD-474B-A3AA-8C3EFFE8F27B}). */
export type FilteredArticlesWildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Wildcard Page template (ID: {5D527E40-33C0-48C6-A474-AF1068DB082E}). */
export type FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b & Item & _BasePage & _Designable & _FilteredArticlesWildcard & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Wildcard Page template (ID: {5D527E40-33C0-48C6-A474-AF1068DB082E}). */
export type FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Wildcard Page template (ID: {5D527E40-33C0-48C6-A474-AF1068DB082E}). */
export type FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Wildcard Page template (ID: {5D527E40-33C0-48C6-A474-AF1068DB082E}). */
export type FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Wildcard Page template (ID: {5D527E40-33C0-48C6-A474-AF1068DB082E}). */
export type FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Wildcard Page template (ID: {5D527E40-33C0-48C6-A474-AF1068DB082E}). */
export type FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Filtered Articles Wildcard Page template (ID: {5D527E40-33C0-48C6-A474-AF1068DB082E}). */
export type FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Filtered Articles Wildcard Page template (ID: {9F8FEF04-516E-43B4-BEE7-1D5D39757A2B}). Also implements _FilteredArticlesWildcard, _WildcardPage, _PageWorkflow, _Statistics. */
export type FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = {
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
};

/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Wildcard Page template (ID: {98C82B05-8684-44DF-9FE8-06B5FB955835}). */
export type FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b & Item & _BasePage & _Designable & _FilteredArticlesWildcard & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Wildcard Page template (ID: {98C82B05-8684-44DF-9FE8-06B5FB955835}). */
export type FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Wildcard Page template (ID: {98C82B05-8684-44DF-9FE8-06B5FB955835}). */
export type FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Wildcard Page template (ID: {98C82B05-8684-44DF-9FE8-06B5FB955835}). */
export type FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Wildcard Page template (ID: {98C82B05-8684-44DF-9FE8-06B5FB955835}). */
export type FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Wildcard Page template (ID: {98C82B05-8684-44DF-9FE8-06B5FB955835}). */
export type FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Filtered Articles Wildcard Page template (ID: {98C82B05-8684-44DF-9FE8-06B5FB955835}). */
export type FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Wildcard Page template (ID: {705B3BB7-CECC-447F-910F-A76BDC57ADA2}). */
export type FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b & Item & _BasePage & _Designable & _FilteredArticlesWildcard & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Wildcard Page template (ID: {705B3BB7-CECC-447F-910F-A76BDC57ADA2}). */
export type FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Wildcard Page template (ID: {705B3BB7-CECC-447F-910F-A76BDC57ADA2}). */
export type FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Wildcard Page template (ID: {705B3BB7-CECC-447F-910F-A76BDC57ADA2}). */
export type FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Wildcard Page template (ID: {705B3BB7-CECC-447F-910F-A76BDC57ADA2}). */
export type FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Wildcard Page template (ID: {705B3BB7-CECC-447F-910F-A76BDC57ADA2}). */
export type FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Filtered Articles Wildcard Page template (ID: {705B3BB7-CECC-447F-910F-A76BDC57ADA2}). */
export type FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Wildcard Page template (ID: {CEAC9AA7-2D34-4797-ADF0-0F73F9A55F96}). */
export type FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b & Item & _BasePage & _Designable & _FilteredArticlesWildcard & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Wildcard Page template (ID: {CEAC9AA7-2D34-4797-ADF0-0F73F9A55F96}). */
export type FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Wildcard Page template (ID: {CEAC9AA7-2D34-4797-ADF0-0F73F9A55F96}). */
export type FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Wildcard Page template (ID: {CEAC9AA7-2D34-4797-ADF0-0F73F9A55F96}). */
export type FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Wildcard Page template (ID: {CEAC9AA7-2D34-4797-ADF0-0F73F9A55F96}). */
export type FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Wildcard Page template (ID: {CEAC9AA7-2D34-4797-ADF0-0F73F9A55F96}). */
export type FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Filtered Articles Wildcard Page template (ID: {CEAC9AA7-2D34-4797-ADF0-0F73F9A55F96}). */
export type FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Wildcard Page template (ID: {DA761C9A-4E8F-4A91-B990-40D8F5BAA260}). */
export type FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b & Item & _BasePage & _Designable & _FilteredArticlesWildcard & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Wildcard Page template (ID: {DA761C9A-4E8F-4A91-B990-40D8F5BAA260}). */
export type FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Wildcard Page template (ID: {DA761C9A-4E8F-4A91-B990-40D8F5BAA260}). */
export type FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Wildcard Page template (ID: {DA761C9A-4E8F-4A91-B990-40D8F5BAA260}). */
export type FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Wildcard Page template (ID: {DA761C9A-4E8F-4A91-B990-40D8F5BAA260}). */
export type FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Wildcard Page template (ID: {DA761C9A-4E8F-4A91-B990-40D8F5BAA260}). */
export type FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Filtered Articles Wildcard Page template (ID: {DA761C9A-4E8F-4A91-B990-40D8F5BAA260}). */
export type FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Flip template (ID: {92FCEA7B-E501-4907-8DB0-1E9F0EF72DD1}). */
export type Flip = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Flip';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Flip template (ID: {92FCEA7B-E501-4907-8DB0-1E9F0EF72DD1}). */
export type FlipAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Flip template (ID: {92FCEA7B-E501-4907-8DB0-1E9F0EF72DD1}). */
export type FlipChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Flip template (ID: {92FCEA7B-E501-4907-8DB0-1E9F0EF72DD1}). */
export type FlipFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Flip template (ID: {92FCEA7B-E501-4907-8DB0-1E9F0EF72DD1}). */
export type FlipFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Flip template (ID: {92FCEA7B-E501-4907-8DB0-1E9F0EF72DD1}). */
export type FlipHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Flip template (ID: {92FCEA7B-E501-4907-8DB0-1E9F0EF72DD1}). */
export type FlipIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip Folder template (ID: {8D84F263-A22A-4967-9CCE-CC12407E05FC}). */
export type FlipFolder = Item & {
  __typename?: 'FlipFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip Folder template (ID: {8D84F263-A22A-4967-9CCE-CC12407E05FC}). */
export type FlipFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip Folder template (ID: {8D84F263-A22A-4967-9CCE-CC12407E05FC}). */
export type FlipFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip Folder template (ID: {8D84F263-A22A-4967-9CCE-CC12407E05FC}). */
export type FlipFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip Folder template (ID: {8D84F263-A22A-4967-9CCE-CC12407E05FC}). */
export type FlipFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip Folder template (ID: {8D84F263-A22A-4967-9CCE-CC12407E05FC}). */
export type FlipFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip Folder template (ID: {8D84F263-A22A-4967-9CCE-CC12407E05FC}). */
export type FlipFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip template (ID: {5EF07850-4C04-4B83-9DAF-EFD752CFABA8}). */
export type Flip_5ef078504c044b839dafefd752cfaba8 = Item & {
  __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip template (ID: {5EF07850-4C04-4B83-9DAF-EFD752CFABA8}). */
export type Flip_5ef078504c044b839dafefd752cfaba8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip template (ID: {5EF07850-4C04-4B83-9DAF-EFD752CFABA8}). */
export type Flip_5ef078504c044b839dafefd752cfaba8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip template (ID: {5EF07850-4C04-4B83-9DAF-EFD752CFABA8}). */
export type Flip_5ef078504c044b839dafefd752cfaba8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip template (ID: {5EF07850-4C04-4B83-9DAF-EFD752CFABA8}). */
export type Flip_5ef078504c044b839dafefd752cfaba8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip template (ID: {5EF07850-4C04-4B83-9DAF-EFD752CFABA8}). */
export type Flip_5ef078504c044b839dafefd752cfaba8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flip template (ID: {5EF07850-4C04-4B83-9DAF-EFD752CFABA8}). */
export type Flip_5ef078504c044b839dafefd752cfaba8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flipside template (ID: {36F45117-539A-4A13-ABF8-F1F74CB4B249}). */
export type Flipside = Item & {
  __typename?: 'Flipside';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {B64A5F49-1B79-4F86-AECD-C5A2C0DEFEED}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Heading (ID: {FD8FDB4A-8022-453C-AFF5-8E68D3D3EB5F}). */
  heading?: Maybe<RichTextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flipside template (ID: {36F45117-539A-4A13-ABF8-F1F74CB4B249}). */
export type FlipsideAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flipside template (ID: {36F45117-539A-4A13-ABF8-F1F74CB4B249}). */
export type FlipsideChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flipside template (ID: {36F45117-539A-4A13-ABF8-F1F74CB4B249}). */
export type FlipsideFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flipside template (ID: {36F45117-539A-4A13-ABF8-F1F74CB4B249}). */
export type FlipsideFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flipside template (ID: {36F45117-539A-4A13-ABF8-F1F74CB4B249}). */
export type FlipsideHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Flip/Flipside template (ID: {36F45117-539A-4A13-ABF8-F1F74CB4B249}). */
export type FlipsideIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/FloatFacet template (ID: {09084D21-F597-4C59-A61D-58FC001943C2}). */
export type FloatFacet = Facet & Item & {
  __typename?: 'FloatFacet';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Client Side Handle (ID: {7F42ED80-33F0-4C98-A1E7-B15BE7551C36}). */
  clientSideHandle?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayName (ID: {5DE17054-0141-4E58-935B-FEC623A60806}). */
  displayName_5de1705401414e58935bfec623a60806?: Maybe<TextField>;
  /** Enabled (ID: {3D0FE806-D0E3-4254-96BE-A60899C7D2E6}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Global (ID: {182BD0F4-C902-4A19-A1BA-D189CAA18E1B}). */
  global?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Minimum Number of Items (ID: {8A3AC1B8-8CC1-4DD4-8766-9803F1601741}). */
  minimumNumberOfItems?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {31CA077F-EF38-4980-8A24-05408031B2BC}). */
  name_31ca077fef3849808a2405408031b2bc?: Maybe<TextField>;
  /** Parameters (ID: {0E23BB51-C071-41B5-9D83-AC410B89B85A}). */
  parameters?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {FAE92C1E-9E2C-4209-89EB-C256D55E3D7F}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/FloatFacet template (ID: {09084D21-F597-4C59-A61D-58FC001943C2}). */
export type FloatFacetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/FloatFacet template (ID: {09084D21-F597-4C59-A61D-58FC001943C2}). */
export type FloatFacetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/FloatFacet template (ID: {09084D21-F597-4C59-A61D-58FC001943C2}). */
export type FloatFacetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/FloatFacet template (ID: {09084D21-F597-4C59-A61D-58FC001943C2}). */
export type FloatFacetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/FloatFacet template (ID: {09084D21-F597-4C59-A61D-58FC001943C2}). */
export type FloatFacetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/FloatFacet template (ID: {09084D21-F597-4C59-A61D-58FC001943C2}). */
export type FloatFacetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer template (ID: {6CEDC6BC-01F0-44F3-A33D-67DE2F3B7B09}). */
export type Footer = Item & {
  __typename?: 'Footer';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** badge (ID: {51628F2B-EB4A-49F9-B0E3-F85CB6587B4B}). */
  badge?: Maybe<ImageField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** This field allows to specify {token.currentYear} keyword that will be dynamically substituted with current year. For example value "copyright 2021- {token.currentYear}. All Rights Reserved." in the year 2022 will be presented as "copyright 2021- 22. All Rights Reserved." */
  copyrightText?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** expandableBlockText (ID: {9182D9EB-DE5E-4DC1-BA1C-745E906EE1EA}). */
  expandableBlockText?: Maybe<RichTextField>;
  /** expandableBlockTitle (ID: {BF6C5AA4-1047-4DC8-BB5B-F06530B544BE}). */
  expandableBlockTitle?: Maybe<TextField>;
  /** expandedView (ID: {23299826-0BC1-44C6-B0DB-8F19126CDD81}). */
  expandedView?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** logo (ID: {57ABA8B2-CF53-4D9F-B089-EF4B9A5DFD4B}). */
  logo?: Maybe<ImageField>;
  /** logoLink (ID: {53A90ACD-5FFC-4248-92C6-DCA67E4BA44F}). */
  logoLink?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** registeredText (ID: {CD3434BA-450F-46EB-9562-D7A2377E843A}). */
  registeredText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** riskWarning (ID: {711C3000-508E-425C-930A-7A3FCE55F344}). */
  riskWarning?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer template (ID: {6CEDC6BC-01F0-44F3-A33D-67DE2F3B7B09}). */
export type FooterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer template (ID: {6CEDC6BC-01F0-44F3-A33D-67DE2F3B7B09}). */
export type FooterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer template (ID: {6CEDC6BC-01F0-44F3-A33D-67DE2F3B7B09}). */
export type FooterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer template (ID: {6CEDC6BC-01F0-44F3-A33D-67DE2F3B7B09}). */
export type FooterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer template (ID: {6CEDC6BC-01F0-44F3-A33D-67DE2F3B7B09}). */
export type FooterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer template (ID: {6CEDC6BC-01F0-44F3-A33D-67DE2F3B7B09}). */
export type FooterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Folder template (ID: {714C92AB-988E-49BB-B6C5-2DD36EEA3411}). */
export type FooterFolder = Item & {
  __typename?: 'FooterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Folder template (ID: {714C92AB-988E-49BB-B6C5-2DD36EEA3411}). */
export type FooterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Folder template (ID: {714C92AB-988E-49BB-B6C5-2DD36EEA3411}). */
export type FooterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Folder template (ID: {714C92AB-988E-49BB-B6C5-2DD36EEA3411}). */
export type FooterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Folder template (ID: {714C92AB-988E-49BB-B6C5-2DD36EEA3411}). */
export type FooterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Folder template (ID: {714C92AB-988E-49BB-B6C5-2DD36EEA3411}). */
export type FooterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Folder template (ID: {714C92AB-988E-49BB-B6C5-2DD36EEA3411}). */
export type FooterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Link template (ID: {FCB80E30-407D-4C16-AB2A-341DE1F0C449}). */
export type FooterLink = Item & {
  __typename?: 'FooterLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {BBD96E61-FE08-4568-ACC4-2683EE0B9A55}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Link template (ID: {FCB80E30-407D-4C16-AB2A-341DE1F0C449}). */
export type FooterLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Link template (ID: {FCB80E30-407D-4C16-AB2A-341DE1F0C449}). */
export type FooterLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Link template (ID: {FCB80E30-407D-4C16-AB2A-341DE1F0C449}). */
export type FooterLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Link template (ID: {FCB80E30-407D-4C16-AB2A-341DE1F0C449}). */
export type FooterLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Link template (ID: {FCB80E30-407D-4C16-AB2A-341DE1F0C449}). */
export type FooterLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Footer/Footer Link template (ID: {FCB80E30-407D-4C16-AB2A-341DE1F0C449}). */
export type FooterLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Forms/Rendering Parameters/Form Rendering Parameters template (ID: {0A188F5D-4B5D-48AB-83E1-949A3C745477}). */
export type FormRenderingParameters = BaseRenderingParameters & GridParameters & IComponentVariant & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'FormRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FormId (ID: {B3CA00AD-012C-4080-B615-DD3C42A1A072}). */
  formId?: Maybe<TextField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Forms/Rendering Parameters/Form Rendering Parameters template (ID: {0A188F5D-4B5D-48AB-83E1-949A3C745477}). */
export type FormRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Forms/Rendering Parameters/Form Rendering Parameters template (ID: {0A188F5D-4B5D-48AB-83E1-949A3C745477}). */
export type FormRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Forms/Rendering Parameters/Form Rendering Parameters template (ID: {0A188F5D-4B5D-48AB-83E1-949A3C745477}). */
export type FormRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Forms/Rendering Parameters/Form Rendering Parameters template (ID: {0A188F5D-4B5D-48AB-83E1-949A3C745477}). */
export type FormRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Forms/Rendering Parameters/Form Rendering Parameters template (ID: {0A188F5D-4B5D-48AB-83E1-949A3C745477}). */
export type FormRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Forms/Rendering Parameters/Form Rendering Parameters template (ID: {0A188F5D-4B5D-48AB-83E1-949A3C745477}). */
export type FormRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Class template (ID: {728FE5CB-F09E-46BB-9C5D-7CE97F5C6464}). */
export type FundAssetClass = Item & {
  __typename?: 'FundAssetClass';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** classId (ID: {962C59B7-0C43-46DD-A6A5-451FA98DA490}). */
  classId?: Maybe<TextField>;
  /** className (ID: {54DCB440-5509-455A-BC3B-2274C3A2E808}). */
  className?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Class template (ID: {728FE5CB-F09E-46BB-9C5D-7CE97F5C6464}). */
export type FundAssetClassAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Class template (ID: {728FE5CB-F09E-46BB-9C5D-7CE97F5C6464}). */
export type FundAssetClassChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Class template (ID: {728FE5CB-F09E-46BB-9C5D-7CE97F5C6464}). */
export type FundAssetClassFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Class template (ID: {728FE5CB-F09E-46BB-9C5D-7CE97F5C6464}). */
export type FundAssetClassFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Class template (ID: {728FE5CB-F09E-46BB-9C5D-7CE97F5C6464}). */
export type FundAssetClassHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Class template (ID: {728FE5CB-F09E-46BB-9C5D-7CE97F5C6464}). */
export type FundAssetClassIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Classes Folder template (ID: {FFC53486-5D67-4939-849F-CE3503D53614}). */
export type FundAssetClassesFolder = Item & {
  __typename?: 'FundAssetClassesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Classes Folder template (ID: {FFC53486-5D67-4939-849F-CE3503D53614}). */
export type FundAssetClassesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Classes Folder template (ID: {FFC53486-5D67-4939-849F-CE3503D53614}). */
export type FundAssetClassesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Classes Folder template (ID: {FFC53486-5D67-4939-849F-CE3503D53614}). */
export type FundAssetClassesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Classes Folder template (ID: {FFC53486-5D67-4939-849F-CE3503D53614}). */
export type FundAssetClassesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Classes Folder template (ID: {FFC53486-5D67-4939-849F-CE3503D53614}). */
export type FundAssetClassesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Asset Classes Folder template (ID: {FFC53486-5D67-4939-849F-CE3503D53614}). */
export type FundAssetClassesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Fund Details Wildcard Page template (ID: {207E1EAD-2E0C-4223-A250-3EC053F4AA21}). */
export type FundDetailsWildcardPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundDetailsWildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Fund Details Wildcard Page template (ID: {207E1EAD-2E0C-4223-A250-3EC053F4AA21}). */
export type FundDetailsWildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Details Wildcard Page template (ID: {207E1EAD-2E0C-4223-A250-3EC053F4AA21}). */
export type FundDetailsWildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Details Wildcard Page template (ID: {207E1EAD-2E0C-4223-A250-3EC053F4AA21}). */
export type FundDetailsWildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Fund Details Wildcard Page template (ID: {207E1EAD-2E0C-4223-A250-3EC053F4AA21}). */
export type FundDetailsWildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Details Wildcard Page template (ID: {207E1EAD-2E0C-4223-A250-3EC053F4AA21}). */
export type FundDetailsWildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Details Wildcard Page template (ID: {207E1EAD-2E0C-4223-A250-3EC053F4AA21}). */
export type FundDetailsWildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Fund Details Wildcard Page template (ID: {97DF45D1-E529-4F6D-BC22-79895EE83734}). */
export type FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Details Wildcard Page template (ID: {97DF45D1-E529-4F6D-BC22-79895EE83734}). */
export type FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Details Wildcard Page template (ID: {97DF45D1-E529-4F6D-BC22-79895EE83734}). */
export type FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Details Wildcard Page template (ID: {97DF45D1-E529-4F6D-BC22-79895EE83734}). */
export type FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Details Wildcard Page template (ID: {97DF45D1-E529-4F6D-BC22-79895EE83734}). */
export type FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Details Wildcard Page template (ID: {97DF45D1-E529-4F6D-BC22-79895EE83734}). */
export type FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Details Wildcard Page template (ID: {97DF45D1-E529-4F6D-BC22-79895EE83734}). */
export type FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Fund Details Wildcard Page template (ID: {590B1242-6AB6-4F49-990B-2DD2C5FFFD0F}). */
export type FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Fund Details Wildcard Page template (ID: {590B1242-6AB6-4F49-990B-2DD2C5FFFD0F}). */
export type FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Details Wildcard Page template (ID: {590B1242-6AB6-4F49-990B-2DD2C5FFFD0F}). */
export type FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Details Wildcard Page template (ID: {590B1242-6AB6-4F49-990B-2DD2C5FFFD0F}). */
export type FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Fund Details Wildcard Page template (ID: {590B1242-6AB6-4F49-990B-2DD2C5FFFD0F}). */
export type FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Details Wildcard Page template (ID: {590B1242-6AB6-4F49-990B-2DD2C5FFFD0F}). */
export type FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Details Wildcard Page template (ID: {590B1242-6AB6-4F49-990B-2DD2C5FFFD0F}). */
export type FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Details Wildcard Page template (ID: {60069DBB-81DC-496B-888F-E2E38073A74B}). */
export type FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Details Wildcard Page template (ID: {60069DBB-81DC-496B-888F-E2E38073A74B}). */
export type FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Details Wildcard Page template (ID: {60069DBB-81DC-496B-888F-E2E38073A74B}). */
export type FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Details Wildcard Page template (ID: {60069DBB-81DC-496B-888F-E2E38073A74B}). */
export type FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Details Wildcard Page template (ID: {60069DBB-81DC-496B-888F-E2E38073A74B}). */
export type FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Details Wildcard Page template (ID: {60069DBB-81DC-496B-888F-E2E38073A74B}). */
export type FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Details Wildcard Page template (ID: {60069DBB-81DC-496B-888F-E2E38073A74B}). */
export type FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Fund Forms Folder template (ID: {8CDD0CF6-9B17-4B6D-8B94-81013EDDCCAF}). */
export type FundFormsFolder = Item & {
  __typename?: 'FundFormsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Fund Forms Folder template (ID: {8CDD0CF6-9B17-4B6D-8B94-81013EDDCCAF}). */
export type FundFormsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Fund Forms Folder template (ID: {8CDD0CF6-9B17-4B6D-8B94-81013EDDCCAF}). */
export type FundFormsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Fund Forms Folder template (ID: {8CDD0CF6-9B17-4B6D-8B94-81013EDDCCAF}). */
export type FundFormsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Fund Forms Folder template (ID: {8CDD0CF6-9B17-4B6D-8B94-81013EDDCCAF}). */
export type FundFormsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Fund Forms Folder template (ID: {8CDD0CF6-9B17-4B6D-8B94-81013EDDCCAF}). */
export type FundFormsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Fund Forms Folder template (ID: {8CDD0CF6-9B17-4B6D-8B94-81013EDDCCAF}). */
export type FundFormsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus template (ID: {B39C1DF1-0D97-4E85-BA26-0271853266CB}). */
export type FundInFocus = Item & {
  __typename?: 'FundInFocus';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** fund (ID: {3945422C-AD51-4973-AC03-69BEB06AB515}). */
  fund?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus template (ID: {B39C1DF1-0D97-4E85-BA26-0271853266CB}). */
export type FundInFocusAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus template (ID: {B39C1DF1-0D97-4E85-BA26-0271853266CB}). */
export type FundInFocusChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus template (ID: {B39C1DF1-0D97-4E85-BA26-0271853266CB}). */
export type FundInFocusFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus template (ID: {B39C1DF1-0D97-4E85-BA26-0271853266CB}). */
export type FundInFocusFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus template (ID: {B39C1DF1-0D97-4E85-BA26-0271853266CB}). */
export type FundInFocusHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus template (ID: {B39C1DF1-0D97-4E85-BA26-0271853266CB}). */
export type FundInFocusIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus Share Class template (ID: {CDE6D5B9-1082-4C11-B31E-10DE5640954A}). */
export type FundInFocusShareClass = Item & {
  __typename?: 'FundInFocusShareClass';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareClass (ID: {D77DA159-DB90-4C88-B8E6-833DC83786EA}). */
  shareClass?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus Share Class template (ID: {CDE6D5B9-1082-4C11-B31E-10DE5640954A}). */
export type FundInFocusShareClassAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus Share Class template (ID: {CDE6D5B9-1082-4C11-B31E-10DE5640954A}). */
export type FundInFocusShareClassChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus Share Class template (ID: {CDE6D5B9-1082-4C11-B31E-10DE5640954A}). */
export type FundInFocusShareClassFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus Share Class template (ID: {CDE6D5B9-1082-4C11-B31E-10DE5640954A}). */
export type FundInFocusShareClassFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus Share Class template (ID: {CDE6D5B9-1082-4C11-B31E-10DE5640954A}). */
export type FundInFocusShareClassHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Fund In Focus Share Class template (ID: {CDE6D5B9-1082-4C11-B31E-10DE5640954A}). */
export type FundInFocusShareClassIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Search Page template (ID: {2C3BA4FB-C33D-4A52-8AE1-2BFE7209F95A}). */
export type FundSearchPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Search Page template (ID: {2C3BA4FB-C33D-4A52-8AE1-2BFE7209F95A}). */
export type FundSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Search Page template (ID: {2C3BA4FB-C33D-4A52-8AE1-2BFE7209F95A}). */
export type FundSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Search Page template (ID: {2C3BA4FB-C33D-4A52-8AE1-2BFE7209F95A}). */
export type FundSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Search Page template (ID: {2C3BA4FB-C33D-4A52-8AE1-2BFE7209F95A}). */
export type FundSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Search Page template (ID: {2C3BA4FB-C33D-4A52-8AE1-2BFE7209F95A}). */
export type FundSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Search Page template (ID: {2C3BA4FB-C33D-4A52-8AE1-2BFE7209F95A}). */
export type FundSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Fund Search Page template (ID: {5505B84D-BA1F-47C7-B805-4749D802D926}). */
export type FundSearchPage_5505b84dba1f47c7b8054749d802d926 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Fund Search Page template (ID: {5505B84D-BA1F-47C7-B805-4749D802D926}). */
export type FundSearchPage_5505b84dba1f47c7b8054749d802d926AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Search Page template (ID: {5505B84D-BA1F-47C7-B805-4749D802D926}). */
export type FundSearchPage_5505b84dba1f47c7b8054749d802d926ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Search Page template (ID: {5505B84D-BA1F-47C7-B805-4749D802D926}). */
export type FundSearchPage_5505b84dba1f47c7b8054749d802d926FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Fund Search Page template (ID: {5505B84D-BA1F-47C7-B805-4749D802D926}). */
export type FundSearchPage_5505b84dba1f47c7b8054749d802d926FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Search Page template (ID: {5505B84D-BA1F-47C7-B805-4749D802D926}). */
export type FundSearchPage_5505b84dba1f47c7b8054749d802d926HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Search Page template (ID: {5505B84D-BA1F-47C7-B805-4749D802D926}). */
export type FundSearchPage_5505b84dba1f47c7b8054749d802d926IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Fund Search Page template (ID: {5806F83C-03BC-4433-8067-8FF955F4310F}). */
export type FundSearchPage_5806f83c03bc443380678ff955f4310f = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Search Page template (ID: {5806F83C-03BC-4433-8067-8FF955F4310F}). */
export type FundSearchPage_5806f83c03bc443380678ff955f4310fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Search Page template (ID: {5806F83C-03BC-4433-8067-8FF955F4310F}). */
export type FundSearchPage_5806f83c03bc443380678ff955f4310fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Search Page template (ID: {5806F83C-03BC-4433-8067-8FF955F4310F}). */
export type FundSearchPage_5806f83c03bc443380678ff955f4310fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Search Page template (ID: {5806F83C-03BC-4433-8067-8FF955F4310F}). */
export type FundSearchPage_5806f83c03bc443380678ff955f4310fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Search Page template (ID: {5806F83C-03BC-4433-8067-8FF955F4310F}). */
export type FundSearchPage_5806f83c03bc443380678ff955f4310fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Search Page template (ID: {5806F83C-03BC-4433-8067-8FF955F4310F}). */
export type FundSearchPage_5806f83c03bc443380678ff955f4310fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Fund Search Page template (ID: {7432205C-0421-4A41-9CA0-64C4CB37501C}). */
export type FundSearchPage_7432205c04214a419ca064c4cb37501c = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Fund Search Page template (ID: {7432205C-0421-4A41-9CA0-64C4CB37501C}). */
export type FundSearchPage_7432205c04214a419ca064c4cb37501cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Search Page template (ID: {7432205C-0421-4A41-9CA0-64C4CB37501C}). */
export type FundSearchPage_7432205c04214a419ca064c4cb37501cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Search Page template (ID: {7432205C-0421-4A41-9CA0-64C4CB37501C}). */
export type FundSearchPage_7432205c04214a419ca064c4cb37501cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Fund Search Page template (ID: {7432205C-0421-4A41-9CA0-64C4CB37501C}). */
export type FundSearchPage_7432205c04214a419ca064c4cb37501cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Search Page template (ID: {7432205C-0421-4A41-9CA0-64C4CB37501C}). */
export type FundSearchPage_7432205c04214a419ca064c4cb37501cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Search Page template (ID: {7432205C-0421-4A41-9CA0-64C4CB37501C}). */
export type FundSearchPage_7432205c04214a419ca064c4cb37501cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Search Page template (ID: {EDC9DF02-132E-4C0A-8435-DD60057CBB0A}). */
export type FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Search Page template (ID: {EDC9DF02-132E-4C0A-8435-DD60057CBB0A}). */
export type FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Search Page template (ID: {EDC9DF02-132E-4C0A-8435-DD60057CBB0A}). */
export type FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Search Page template (ID: {EDC9DF02-132E-4C0A-8435-DD60057CBB0A}). */
export type FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Search Page template (ID: {EDC9DF02-132E-4C0A-8435-DD60057CBB0A}). */
export type FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Search Page template (ID: {EDC9DF02-132E-4C0A-8435-DD60057CBB0A}). */
export type FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Search Page template (ID: {EDC9DF02-132E-4C0A-8435-DD60057CBB0A}). */
export type FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Fund Settings/Fund Settings template (ID: {0586AE70-5785-4D20-B717-2716018AFF09}). */
export type FundSettings = Item & {
  __typename?: 'FundSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** countries (ID: {B5358A5D-A6CD-4B8A-B21C-BC9216C26239}). */
  countries?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** fundWithShareclassesDetailsWildcard (ID: {BC1EEDC7-9FCF-4FAB-97EA-D5A0A9F49F29}). */
  fundWithShareclassesDetailsWildcard?: Maybe<LookupField>;
  /** fundsLandingPage (ID: {05C9CB1F-6CC3-46EF-8464-5D097DCEED10}). */
  fundsLandingPage?: Maybe<LookupField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** investorTypes (ID: {ABE27259-DF3D-4483-B7EE-C3E8552E2F9C}). */
  investorTypes?: Maybe<MultilistField>;
  /** jurisdictions (ID: {804CDF2F-9EAF-4563-B5BC-77735B6ADAF4}). */
  jurisdictions?: Maybe<LookupField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** literatureAuthorizations (ID: {C9602077-088C-4E9E-94C5-219A4AC343BE}). */
  literatureAuthorizations?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** showFundsInFocusTab (ID: {A94C8D50-7CAB-48C6-A49B-214B25A99921}). */
  showFundsInFocusTab?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** wildcardPage (ID: {323B0AA5-9650-4D80-807B-4D4CFC1D7693}). */
  wildcardPage?: Maybe<LookupField>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Fund Settings/Fund Settings template (ID: {0586AE70-5785-4D20-B717-2716018AFF09}). */
export type FundSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Fund Settings/Fund Settings template (ID: {0586AE70-5785-4D20-B717-2716018AFF09}). */
export type FundSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Fund Settings/Fund Settings template (ID: {0586AE70-5785-4D20-B717-2716018AFF09}). */
export type FundSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Fund Settings/Fund Settings template (ID: {0586AE70-5785-4D20-B717-2716018AFF09}). */
export type FundSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Fund Settings/Fund Settings template (ID: {0586AE70-5785-4D20-B717-2716018AFF09}). */
export type FundSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Fund Settings/Fund Settings template (ID: {0586AE70-5785-4D20-B717-2716018AFF09}). */
export type FundSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Fund Shareclass Details Wildcard Page template (ID: {023EE573-91D8-46DC-A139-7A3EB4157AAA}). */
export type FundShareclassDetailsWildcardPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundShareclassDetailsWildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Shareclass Details Wildcard Page template (ID: {023EE573-91D8-46DC-A139-7A3EB4157AAA}). */
export type FundShareclassDetailsWildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Shareclass Details Wildcard Page template (ID: {023EE573-91D8-46DC-A139-7A3EB4157AAA}). */
export type FundShareclassDetailsWildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Shareclass Details Wildcard Page template (ID: {023EE573-91D8-46DC-A139-7A3EB4157AAA}). */
export type FundShareclassDetailsWildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Shareclass Details Wildcard Page template (ID: {023EE573-91D8-46DC-A139-7A3EB4157AAA}). */
export type FundShareclassDetailsWildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Shareclass Details Wildcard Page template (ID: {023EE573-91D8-46DC-A139-7A3EB4157AAA}). */
export type FundShareclassDetailsWildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Fund Shareclass Details Wildcard Page template (ID: {023EE573-91D8-46DC-A139-7A3EB4157AAA}). */
export type FundShareclassDetailsWildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Fund Shareclass Details Wildcard Page template (ID: {543D5F77-8AD4-4326-9E23-84804031CB3C}). */
export type FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Fund Shareclass Details Wildcard Page template (ID: {543D5F77-8AD4-4326-9E23-84804031CB3C}). */
export type FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Shareclass Details Wildcard Page template (ID: {543D5F77-8AD4-4326-9E23-84804031CB3C}). */
export type FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Shareclass Details Wildcard Page template (ID: {543D5F77-8AD4-4326-9E23-84804031CB3C}). */
export type FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Fund Shareclass Details Wildcard Page template (ID: {543D5F77-8AD4-4326-9E23-84804031CB3C}). */
export type FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Shareclass Details Wildcard Page template (ID: {543D5F77-8AD4-4326-9E23-84804031CB3C}). */
export type FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Fund Shareclass Details Wildcard Page template (ID: {543D5F77-8AD4-4326-9E23-84804031CB3C}). */
export type FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Shareclass Details Wildcard Page template (ID: {5827425C-1B42-46D1-9F13-11387A5BD4B3}). */
export type FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Shareclass Details Wildcard Page template (ID: {5827425C-1B42-46D1-9F13-11387A5BD4B3}). */
export type FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Shareclass Details Wildcard Page template (ID: {5827425C-1B42-46D1-9F13-11387A5BD4B3}). */
export type FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Shareclass Details Wildcard Page template (ID: {5827425C-1B42-46D1-9F13-11387A5BD4B3}). */
export type FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Shareclass Details Wildcard Page template (ID: {5827425C-1B42-46D1-9F13-11387A5BD4B3}). */
export type FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Shareclass Details Wildcard Page template (ID: {5827425C-1B42-46D1-9F13-11387A5BD4B3}). */
export type FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Fund Shareclass Details Wildcard Page template (ID: {5827425C-1B42-46D1-9F13-11387A5BD4B3}). */
export type FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Fund Shareclass Details Wildcard Page template (ID: {CF3F2635-270B-4977-9BB3-822AB90F1DCC}). */
export type FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Fund Shareclass Details Wildcard Page template (ID: {CF3F2635-270B-4977-9BB3-822AB90F1DCC}). */
export type FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dccAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Shareclass Details Wildcard Page template (ID: {CF3F2635-270B-4977-9BB3-822AB90F1DCC}). */
export type FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dccChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Shareclass Details Wildcard Page template (ID: {CF3F2635-270B-4977-9BB3-822AB90F1DCC}). */
export type FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dccFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Fund Shareclass Details Wildcard Page template (ID: {CF3F2635-270B-4977-9BB3-822AB90F1DCC}). */
export type FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dccFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Shareclass Details Wildcard Page template (ID: {CF3F2635-270B-4977-9BB3-822AB90F1DCC}). */
export type FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dccHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Fund Shareclass Details Wildcard Page template (ID: {CF3F2635-270B-4977-9BB3-822AB90F1DCC}). */
export type FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dccIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Shareclass Details Wildcard Page template (ID: {D7E686D9-C3BC-4EF9-974E-201972B59EEE}). */
export type FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Shareclass Details Wildcard Page template (ID: {D7E686D9-C3BC-4EF9-974E-201972B59EEE}). */
export type FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eeeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Shareclass Details Wildcard Page template (ID: {D7E686D9-C3BC-4EF9-974E-201972B59EEE}). */
export type FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eeeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Shareclass Details Wildcard Page template (ID: {D7E686D9-C3BC-4EF9-974E-201972B59EEE}). */
export type FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eeeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Shareclass Details Wildcard Page template (ID: {D7E686D9-C3BC-4EF9-974E-201972B59EEE}). */
export type FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eeeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Shareclass Details Wildcard Page template (ID: {D7E686D9-C3BC-4EF9-974E-201972B59EEE}). */
export type FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eeeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Fund Shareclass Details Wildcard Page template (ID: {D7E686D9-C3BC-4EF9-974E-201972B59EEE}). */
export type FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eeeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Class template (ID: {79AEFE0A-3D7E-439E-8A84-4BFDC0EAB7CA}). */
export type FundSubAssetClass = Item & {
  __typename?: 'FundSubAssetClass';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** baseAssetClass (ID: {FCE67D66-82B9-4F0C-841E-DF281046D389}). */
  baseAssetClass?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {5E2527F0-03B5-4DA1-A3E7-15040D2D678F}). */
  name_5e2527f003b54da1a3e715040d2d678f?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Class template (ID: {79AEFE0A-3D7E-439E-8A84-4BFDC0EAB7CA}). */
export type FundSubAssetClassAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Class template (ID: {79AEFE0A-3D7E-439E-8A84-4BFDC0EAB7CA}). */
export type FundSubAssetClassChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Class template (ID: {79AEFE0A-3D7E-439E-8A84-4BFDC0EAB7CA}). */
export type FundSubAssetClassFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Class template (ID: {79AEFE0A-3D7E-439E-8A84-4BFDC0EAB7CA}). */
export type FundSubAssetClassFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Class template (ID: {79AEFE0A-3D7E-439E-8A84-4BFDC0EAB7CA}). */
export type FundSubAssetClassHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Class template (ID: {79AEFE0A-3D7E-439E-8A84-4BFDC0EAB7CA}). */
export type FundSubAssetClassIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Classes Folder template (ID: {FC24AB03-4667-4CE3-A3D7-53DBF9844F81}). */
export type FundSubAssetClassesFolder = Item & {
  __typename?: 'FundSubAssetClassesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Classes Folder template (ID: {FC24AB03-4667-4CE3-A3D7-53DBF9844F81}). */
export type FundSubAssetClassesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Classes Folder template (ID: {FC24AB03-4667-4CE3-A3D7-53DBF9844F81}). */
export type FundSubAssetClassesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Classes Folder template (ID: {FC24AB03-4667-4CE3-A3D7-53DBF9844F81}). */
export type FundSubAssetClassesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Classes Folder template (ID: {FC24AB03-4667-4CE3-A3D7-53DBF9844F81}). */
export type FundSubAssetClassesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Classes Folder template (ID: {FC24AB03-4667-4CE3-A3D7-53DBF9844F81}). */
export type FundSubAssetClassesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Fund Sub Asset Classes Folder template (ID: {FC24AB03-4667-4CE3-A3D7-53DBF9844F81}). */
export type FundSubAssetClassesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds External Literature Folder template (ID: {9237199C-A028-41A0-90EF-2D35AD3894B7}). */
export type FundsExternalLiteratureFolder = Item & {
  __typename?: 'FundsExternalLiteratureFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds External Literature Folder template (ID: {9237199C-A028-41A0-90EF-2D35AD3894B7}). */
export type FundsExternalLiteratureFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds External Literature Folder template (ID: {9237199C-A028-41A0-90EF-2D35AD3894B7}). */
export type FundsExternalLiteratureFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds External Literature Folder template (ID: {9237199C-A028-41A0-90EF-2D35AD3894B7}). */
export type FundsExternalLiteratureFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds External Literature Folder template (ID: {9237199C-A028-41A0-90EF-2D35AD3894B7}). */
export type FundsExternalLiteratureFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds External Literature Folder template (ID: {9237199C-A028-41A0-90EF-2D35AD3894B7}). */
export type FundsExternalLiteratureFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds External Literature Folder template (ID: {9237199C-A028-41A0-90EF-2D35AD3894B7}). */
export type FundsExternalLiteratureFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Folder template (ID: {DEB0F4B5-E839-47D0-B46F-AC84DD8B2E07}). */
export type FundsFolder = Item & {
  __typename?: 'FundsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Folder template (ID: {DEB0F4B5-E839-47D0-B46F-AC84DD8B2E07}). */
export type FundsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Folder template (ID: {DEB0F4B5-E839-47D0-B46F-AC84DD8B2E07}). */
export type FundsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Folder template (ID: {DEB0F4B5-E839-47D0-B46F-AC84DD8B2E07}). */
export type FundsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Folder template (ID: {DEB0F4B5-E839-47D0-B46F-AC84DD8B2E07}). */
export type FundsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Folder template (ID: {DEB0F4B5-E839-47D0-B46F-AC84DD8B2E07}). */
export type FundsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Folder template (ID: {DEB0F4B5-E839-47D0-B46F-AC84DD8B2E07}). */
export type FundsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Funds In Focus Folder template (ID: {D749CEA3-AE10-41D0-A326-75362A89AEB7}). */
export type FundsInFocusFolder = Item & {
  __typename?: 'FundsInFocusFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Funds In Focus Folder template (ID: {D749CEA3-AE10-41D0-A326-75362A89AEB7}). */
export type FundsInFocusFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Funds In Focus Folder template (ID: {D749CEA3-AE10-41D0-A326-75362A89AEB7}). */
export type FundsInFocusFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Funds In Focus Folder template (ID: {D749CEA3-AE10-41D0-A326-75362A89AEB7}). */
export type FundsInFocusFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Funds In Focus Folder template (ID: {D749CEA3-AE10-41D0-A326-75362A89AEB7}). */
export type FundsInFocusFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Funds In Focus Folder template (ID: {D749CEA3-AE10-41D0-A326-75362A89AEB7}). */
export type FundsInFocusFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Funds In Focus/Funds In Focus Folder template (ID: {D749CEA3-AE10-41D0-A326-75362A89AEB7}). */
export type FundsInFocusFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Rendering Parameters/Funds In Focus Parameters Template template (ID: {5880234F-65F5-4A6F-88BA-1DE7B1816FB6}). */
export type FundsInFocusParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'FundsInFocusParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {4B85DF79-AD63-47F1-AE8A-12C95021A5DE}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Rendering Parameters/Funds In Focus Parameters Template template (ID: {5880234F-65F5-4A6F-88BA-1DE7B1816FB6}). */
export type FundsInFocusParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Rendering Parameters/Funds In Focus Parameters Template template (ID: {5880234F-65F5-4A6F-88BA-1DE7B1816FB6}). */
export type FundsInFocusParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Rendering Parameters/Funds In Focus Parameters Template template (ID: {5880234F-65F5-4A6F-88BA-1DE7B1816FB6}). */
export type FundsInFocusParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Rendering Parameters/Funds In Focus Parameters Template template (ID: {5880234F-65F5-4A6F-88BA-1DE7B1816FB6}). */
export type FundsInFocusParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Rendering Parameters/Funds In Focus Parameters Template template (ID: {5880234F-65F5-4A6F-88BA-1DE7B1816FB6}). */
export type FundsInFocusParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Rendering Parameters/Funds In Focus Parameters Template template (ID: {5880234F-65F5-4A6F-88BA-1DE7B1816FB6}). */
export type FundsInFocusParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Folder template (ID: {86A18052-0AD0-4D1C-870E-BDEFAE3639A3}). */
export type FundsLiteratureFolder = Item & {
  __typename?: 'FundsLiteratureFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Folder template (ID: {86A18052-0AD0-4D1C-870E-BDEFAE3639A3}). */
export type FundsLiteratureFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Folder template (ID: {86A18052-0AD0-4D1C-870E-BDEFAE3639A3}). */
export type FundsLiteratureFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Folder template (ID: {86A18052-0AD0-4D1C-870E-BDEFAE3639A3}). */
export type FundsLiteratureFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Folder template (ID: {86A18052-0AD0-4D1C-870E-BDEFAE3639A3}). */
export type FundsLiteratureFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Folder template (ID: {86A18052-0AD0-4D1C-870E-BDEFAE3639A3}). */
export type FundsLiteratureFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Folder template (ID: {86A18052-0AD0-4D1C-870E-BDEFAE3639A3}). */
export type FundsLiteratureFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Mappings Folder template (ID: {1C249D96-63D8-47C0-A048-C77BA9EEE30D}). */
export type FundsLiteratureMappingsFolder = Item & {
  __typename?: 'FundsLiteratureMappingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Mappings Folder template (ID: {1C249D96-63D8-47C0-A048-C77BA9EEE30D}). */
export type FundsLiteratureMappingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Mappings Folder template (ID: {1C249D96-63D8-47C0-A048-C77BA9EEE30D}). */
export type FundsLiteratureMappingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Mappings Folder template (ID: {1C249D96-63D8-47C0-A048-C77BA9EEE30D}). */
export type FundsLiteratureMappingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Mappings Folder template (ID: {1C249D96-63D8-47C0-A048-C77BA9EEE30D}). */
export type FundsLiteratureMappingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Mappings Folder template (ID: {1C249D96-63D8-47C0-A048-C77BA9EEE30D}). */
export type FundsLiteratureMappingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Funds Literature Mappings Folder template (ID: {1C249D96-63D8-47C0-A048-C77BA9EEE30D}). */
export type FundsLiteratureMappingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery template (ID: {57BCF1CE-35CB-4752-B23B-2D4522AF6292}). */
export type Gallery = Item & {
  __typename?: 'Gallery';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GalleriaTheme (ID: {DD79FC89-7939-4865-9DC6-800743F02078}). */
  galleriaTheme?: Maybe<LinkField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery template (ID: {57BCF1CE-35CB-4752-B23B-2D4522AF6292}). */
export type GalleryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery template (ID: {57BCF1CE-35CB-4752-B23B-2D4522AF6292}). */
export type GalleryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery template (ID: {57BCF1CE-35CB-4752-B23B-2D4522AF6292}). */
export type GalleryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery template (ID: {57BCF1CE-35CB-4752-B23B-2D4522AF6292}). */
export type GalleryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery template (ID: {57BCF1CE-35CB-4752-B23B-2D4522AF6292}). */
export type GalleryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery template (ID: {57BCF1CE-35CB-4752-B23B-2D4522AF6292}). */
export type GalleryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Folder template (ID: {83DB28A0-F7F6-42FC-AD48-D0A2D4B644D6}). */
export type GalleryFolder = Item & {
  __typename?: 'GalleryFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Folder template (ID: {83DB28A0-F7F6-42FC-AD48-D0A2D4B644D6}). */
export type GalleryFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Folder template (ID: {83DB28A0-F7F6-42FC-AD48-D0A2D4B644D6}). */
export type GalleryFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Folder template (ID: {83DB28A0-F7F6-42FC-AD48-D0A2D4B644D6}). */
export type GalleryFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Folder template (ID: {83DB28A0-F7F6-42FC-AD48-D0A2D4B644D6}). */
export type GalleryFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Folder template (ID: {83DB28A0-F7F6-42FC-AD48-D0A2D4B644D6}). */
export type GalleryFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Folder template (ID: {83DB28A0-F7F6-42FC-AD48-D0A2D4B644D6}). */
export type GalleryFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Image template (ID: {9D77C212-A828-4792-8E72-749F19C0154D}). */
export type GalleryImage = Item & {
  __typename?: 'GalleryImage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Image (ID: {CBDAAB5F-3F7A-4072-8B7F-6A325A4A2205}). */
  image?: Maybe<ImageField>;
  /** ImageDescription (ID: {D8F2EB04-E684-46C0-8D03-BECCF007CA72}). */
  imageDescription?: Maybe<TextField>;
  /** ImageTitle (ID: {1194ED4A-378B-4D43-ADBA-A46E6082E004}). */
  imageTitle?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Image template (ID: {9D77C212-A828-4792-8E72-749F19C0154D}). */
export type GalleryImageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Image template (ID: {9D77C212-A828-4792-8E72-749F19C0154D}). */
export type GalleryImageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Image template (ID: {9D77C212-A828-4792-8E72-749F19C0154D}). */
export type GalleryImageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Image template (ID: {9D77C212-A828-4792-8E72-749F19C0154D}). */
export type GalleryImageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Image template (ID: {9D77C212-A828-4792-8E72-749F19C0154D}). */
export type GalleryImageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Image template (ID: {9D77C212-A828-4792-8E72-749F19C0154D}). */
export type GalleryImageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/GalleryParametersTemplate template (ID: {B0F1729A-7279-4920-A8DB-37A5EAFEEB08}). */
export type GalleryParametersTemplate = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'GalleryParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GalleryHeight (ID: {862A053A-16AC-4CAC-859C-00E95A6506C6}). */
  galleryHeight?: Maybe<IntegerField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/GalleryParametersTemplate template (ID: {B0F1729A-7279-4920-A8DB-37A5EAFEEB08}). */
export type GalleryParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/GalleryParametersTemplate template (ID: {B0F1729A-7279-4920-A8DB-37A5EAFEEB08}). */
export type GalleryParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/GalleryParametersTemplate template (ID: {B0F1729A-7279-4920-A8DB-37A5EAFEEB08}). */
export type GalleryParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/GalleryParametersTemplate template (ID: {B0F1729A-7279-4920-A8DB-37A5EAFEEB08}). */
export type GalleryParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/GalleryParametersTemplate template (ID: {B0F1729A-7279-4920-A8DB-37A5EAFEEB08}). */
export type GalleryParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/GalleryParametersTemplate template (ID: {B0F1729A-7279-4920-A8DB-37A5EAFEEB08}). */
export type GalleryParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Video template (ID: {4AF51F4D-8AC4-4394-B6A5-11B52CFAF613}). */
export type GalleryVideo = Item & {
  __typename?: 'GalleryVideo';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** VideoDescription (ID: {FE45EDF9-DCD1-48B9-A314-F3BE93E66513}). */
  videoDescription?: Maybe<TextField>;
  /** VideoID (ID: {6C0C3C28-8D0B-4540-B090-207D0505A61A}). */
  videoID?: Maybe<TextField>;
  /** VideoProvider (ID: {5A592C96-87E5-486F-A699-555DDCA06CEB}). */
  videoProvider?: Maybe<LookupField>;
  /** VideoThumbnail (ID: {C576F702-2FC3-43E5-8020-B82A1493B993}). */
  videoThumbnail?: Maybe<LinkField>;
  /** VideoTitle (ID: {94D9B3D7-307B-4261-8BDD-F91987811C7A}). */
  videoTitle?: Maybe<TextField>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Video template (ID: {4AF51F4D-8AC4-4394-B6A5-11B52CFAF613}). */
export type GalleryVideoAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Video template (ID: {4AF51F4D-8AC4-4394-B6A5-11B52CFAF613}). */
export type GalleryVideoChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Video template (ID: {4AF51F4D-8AC4-4394-B6A5-11B52CFAF613}). */
export type GalleryVideoFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Video template (ID: {4AF51F4D-8AC4-4394-B6A5-11B52CFAF613}). */
export type GalleryVideoFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Video template (ID: {4AF51F4D-8AC4-4394-B6A5-11B52CFAF613}). */
export type GalleryVideoHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Gallery Video template (ID: {4AF51F4D-8AC4-4394-B6A5-11B52CFAF613}). */
export type GalleryVideoIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Gated Accordion Container/Gated Accordion Container template (ID: {B074350A-F45A-4FF8-A037-A1412D8EDD24}). */
export type GatedAccordionContainer = Item & {
  __typename?: 'GatedAccordionContainer';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** checkboxHint (ID: {9816F163-0C2F-4488-A49D-7714110A65FE}). */
  checkboxHint?: Maybe<TextField>;
  /** checkboxText (ID: {34E40966-B462-4F72-B66C-779BDEBE3D67}). */
  checkboxText?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** notificationText (ID: {4B69EF70-B6A3-428F-A64D-FB7FB9266B99}). */
  notificationText?: Maybe<RichTextField>;
  /** notificationTitle (ID: {DD581097-9290-4D9C-9242-3E0BE8BCB326}). */
  notificationTitle?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Gated Accordion Container/Gated Accordion Container template (ID: {B074350A-F45A-4FF8-A037-A1412D8EDD24}). */
export type GatedAccordionContainerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Gated Accordion Container/Gated Accordion Container template (ID: {B074350A-F45A-4FF8-A037-A1412D8EDD24}). */
export type GatedAccordionContainerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Gated Accordion Container/Gated Accordion Container template (ID: {B074350A-F45A-4FF8-A037-A1412D8EDD24}). */
export type GatedAccordionContainerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Gated Accordion Container/Gated Accordion Container template (ID: {B074350A-F45A-4FF8-A037-A1412D8EDD24}). */
export type GatedAccordionContainerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Gated Accordion Container/Gated Accordion Container template (ID: {B074350A-F45A-4FF8-A037-A1412D8EDD24}). */
export type GatedAccordionContainerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Gated Accordion Container/Gated Accordion Container template (ID: {B074350A-F45A-4FF8-A037-A1412D8EDD24}). */
export type GatedAccordionContainerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Global Datasource Behavior template (ID: {A7837DE9-3266-46CB-A945-62C55DA45E9E}). */
export type GlobalDatasourceBehavior = {
  /** Data Source Selection Behavior (ID: {C80E6F3C-5BCD-426B-B1EB-6D10672E985D}). */
  dataSourceSelectionBehavior?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Global Language Selector template (ID: {F1196FA7-CD5C-45E6-9EA3-3083E277CD13}). */
export type GlobalLanguageSelector = Item & {
  __typename?: 'GlobalLanguageSelector';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {72E964DD-C43A-46A7-93D5-3C6FE7C73B71}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {9DFA8BDE-4348-40E1-A326-A0D0876A5560}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Global Language Selector template (ID: {F1196FA7-CD5C-45E6-9EA3-3083E277CD13}). */
export type GlobalLanguageSelectorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Global Language Selector template (ID: {F1196FA7-CD5C-45E6-9EA3-3083E277CD13}). */
export type GlobalLanguageSelectorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Global Language Selector template (ID: {F1196FA7-CD5C-45E6-9EA3-3083E277CD13}). */
export type GlobalLanguageSelectorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Global Language Selector template (ID: {F1196FA7-CD5C-45E6-9EA3-3083E277CD13}). */
export type GlobalLanguageSelectorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Global Language Selector template (ID: {F1196FA7-CD5C-45E6-9EA3-3083E277CD13}). */
export type GlobalLanguageSelectorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Global Language Selector template (ID: {F1196FA7-CD5C-45E6-9EA3-3083E277CD13}). */
export type GlobalLanguageSelectorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Global Navigation Bar template (ID: {8874B345-C0F4-4B03-86FC-C92DEAB7E4A9}). */
export type GlobalNavigationBar = Item & {
  __typename?: 'GlobalNavigationBar';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {B9FE066F-9554-4C46-868A-F5B1EF7E305B}). */
  cta?: Maybe<TextField>;
  /** ctaSecondary (ID: {B1237931-4BD6-4018-AE22-29AF33AD3574}). */
  ctaSecondary?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** iconSecondary (ID: {046695B1-08B5-4308-95E2-B7036A3E3015}). */
  iconSecondary?: Maybe<TextField>;
  /** icon (ID: {9A680B31-115F-4F15-89DB-C97FDAE31613}). */
  icon_9a680b31115f4f1589dbc97fdae31613?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Global Navigation Bar template (ID: {8874B345-C0F4-4B03-86FC-C92DEAB7E4A9}). */
export type GlobalNavigationBarAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Global Navigation Bar template (ID: {8874B345-C0F4-4B03-86FC-C92DEAB7E4A9}). */
export type GlobalNavigationBarChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Global Navigation Bar template (ID: {8874B345-C0F4-4B03-86FC-C92DEAB7E4A9}). */
export type GlobalNavigationBarFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Global Navigation Bar template (ID: {8874B345-C0F4-4B03-86FC-C92DEAB7E4A9}). */
export type GlobalNavigationBarFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Global Navigation Bar template (ID: {8874B345-C0F4-4B03-86FC-C92DEAB7E4A9}). */
export type GlobalNavigationBarHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Global Navigation Bar template (ID: {8874B345-C0F4-4B03-86FC-C92DEAB7E4A9}). */
export type GlobalNavigationBarIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Analytics/Rendering Parameters/Google Analytics template (ID: {09F7560E-16F8-4F94-B782-5CD1FDB44515}). */
export type GoogleAnalytics = ICacheable & Item & StandardRenderingParameters & {
  __typename?: 'GoogleAnalytics';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Key (ID: {E824F48B-CD60-4773-A82E-4D28B6DBF339}). */
  key?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Analytics/Rendering Parameters/Google Analytics template (ID: {09F7560E-16F8-4F94-B782-5CD1FDB44515}). */
export type GoogleAnalyticsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Analytics/Rendering Parameters/Google Analytics template (ID: {09F7560E-16F8-4F94-B782-5CD1FDB44515}). */
export type GoogleAnalyticsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Analytics/Rendering Parameters/Google Analytics template (ID: {09F7560E-16F8-4F94-B782-5CD1FDB44515}). */
export type GoogleAnalyticsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Analytics/Rendering Parameters/Google Analytics template (ID: {09F7560E-16F8-4F94-B782-5CD1FDB44515}). */
export type GoogleAnalyticsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Analytics/Rendering Parameters/Google Analytics template (ID: {09F7560E-16F8-4F94-B782-5CD1FDB44515}). */
export type GoogleAnalyticsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Analytics/Rendering Parameters/Google Analytics template (ID: {09F7560E-16F8-4F94-B782-5CD1FDB44515}). */
export type GoogleAnalyticsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager template (ID: {BE463031-435D-4FC5-B526-8BB705CE83AA}). */
export type GoogleTagManager = Item & {
  __typename?: 'GoogleTagManager';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** gtmId (ID: {D9F6A07A-043A-4513-B9EE-F0705F41C3DB}). */
  gtmId?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager template (ID: {BE463031-435D-4FC5-B526-8BB705CE83AA}). */
export type GoogleTagManagerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager template (ID: {BE463031-435D-4FC5-B526-8BB705CE83AA}). */
export type GoogleTagManagerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager template (ID: {BE463031-435D-4FC5-B526-8BB705CE83AA}). */
export type GoogleTagManagerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager template (ID: {BE463031-435D-4FC5-B526-8BB705CE83AA}). */
export type GoogleTagManagerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager template (ID: {BE463031-435D-4FC5-B526-8BB705CE83AA}). */
export type GoogleTagManagerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager template (ID: {BE463031-435D-4FC5-B526-8BB705CE83AA}). */
export type GoogleTagManagerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager Folder template (ID: {9D4C7BC3-4F0E-45C7-A69D-645BF25C38AA}). */
export type GoogleTagManagerFolder = Item & {
  __typename?: 'GoogleTagManagerFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager Folder template (ID: {9D4C7BC3-4F0E-45C7-A69D-645BF25C38AA}). */
export type GoogleTagManagerFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager Folder template (ID: {9D4C7BC3-4F0E-45C7-A69D-645BF25C38AA}). */
export type GoogleTagManagerFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager Folder template (ID: {9D4C7BC3-4F0E-45C7-A69D-645BF25C38AA}). */
export type GoogleTagManagerFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager Folder template (ID: {9D4C7BC3-4F0E-45C7-A69D-645BF25C38AA}). */
export type GoogleTagManagerFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager Folder template (ID: {9D4C7BC3-4F0E-45C7-A69D-645BF25C38AA}). */
export type GoogleTagManagerFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Google Tag Manager/Google Tag Manager Folder template (ID: {9D4C7BC3-4F0E-45C7-A69D-645BF25C38AA}). */
export type GoogleTagManagerFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition template (ID: {A12EF6DE-1E2A-4D9B-82B4-DFFB70189E52}). Also implements PlaceholderWrapper. */
export type GridDefinition = {
  /** DefaultGridParameters (ID: {CBB899CD-DAD4-4B72-841A-A638E83E5FE5}). */
  defaultGridParameters?: Maybe<TextField>;
  /** Fixed (ID: {549021D8-F27F-4217-805C-20D686E470D9}). */
  fixed?: Maybe<TextField>;
  /** Flex (ID: {91193E28-C9C9-49EB-916D-87E5AF0F1E34}). */
  flex?: Maybe<TextField>;
  /** GridBodyViewPath (ID: {DC986105-2CD6-4A4F-9B2D-57FBB4858E56}). */
  gridBodyViewPath?: Maybe<TextField>;
  /** GridFieldParserType (ID: {0B4D72A7-BE75-4690-805D-DDD564B1DD94}). */
  gridFieldParserType?: Maybe<TextField>;
  /** Grid Theme (ID: {E0B0A836-40BD-4526-998A-649D3AF28AD5}). */
  gridTheme?: Maybe<LookupField>;
  /** Name (ID: {21624C80-7821-4EED-B788-C716C5C1A088}). */
  name_21624c8078214eedb788c716c5c1a088?: Maybe<TextField>;
  /** RenderingParametersFieldType (ID: {228606CA-DE6D-4803-AF3C-A420C90F315D}). */
  renderingParametersFieldType?: Maybe<TextField>;
  /** Row Class (ID: {2105078E-C785-4DB4-9BBF-FF78F2179A17}). */
  rowClass?: Maybe<TextField>;
  /** Row Container Class (ID: {BCEE3E9E-E00C-48AE-B723-A0741FED842B}). */
  rowContainerClass?: Maybe<TextField>;
  /** Wrapping Class (ID: {BC8986B2-5872-466F-AFEB-390C9A3EDAA4}). */
  wrappingClass?: Maybe<TextField>;
  /** Wrapping Tag (ID: {2341030D-19BA-46E1-91FE-9DF617284932}). */
  wrappingTag?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Definition Items/Base/GridItemBase template (ID: {12940789-6D90-458D-9D53-0ADD6EEA6268}). */
export type GridItemBase = {
  /** Tooltip (ID: {B55A9065-9589-41D8-997B-9B4592852134}). */
  tooltip?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Rendering Parameters/Grid Parameters template (ID: {FF75632A-03ED-4D31-B42A-1EEE45E5147F}). */
export type GridParameters = {
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/Grid Setup template (ID: {DBDF5DFD-F79B-4766-99B9-E29775D97328}). */
export type GridSetup = Item & _Dependencies & _Name_B88cf88159a54a19991e71038751cb60 & {
  __typename?: 'GridSetup';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Dependencies (ID: {40DEEE2F-7595-40BD-B2C9-51F9E2346100}). */
  dependencies?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Grid Definition (ID: {C1489CFF-FC13-4CF7-9457-4E5870D647E2}). */
  gridDefinition?: Maybe<LookupField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {C202067E-7FAB-4606-AFB4-E76DF2185DDC}). */
  name_c202067e7fab4606afb4e76df2185ddc?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/Grid Setup template (ID: {DBDF5DFD-F79B-4766-99B9-E29775D97328}). */
export type GridSetupAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/Grid Setup template (ID: {DBDF5DFD-F79B-4766-99B9-E29775D97328}). */
export type GridSetupChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/Grid Setup template (ID: {DBDF5DFD-F79B-4766-99B9-E29775D97328}). */
export type GridSetupFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/Grid Setup template (ID: {DBDF5DFD-F79B-4766-99B9-E29775D97328}). */
export type GridSetupFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/Grid Setup template (ID: {DBDF5DFD-F79B-4766-99B9-E29775D97328}). */
export type GridSetupHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/Grid Setup template (ID: {DBDF5DFD-F79B-4766-99B9-E29775D97328}). */
export type GridSetupIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Theme template (ID: {B746D24C-8767-47E6-A092-AEBEA4EF647F}). */
export type GridTheme = BaseTheme & Item & _AssetServiceThemeMode & _ProtectedTheme & {
  __typename?: 'GridTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BaseLayout (ID: {E0367CD6-E333-4625-9993-BAA4F1C0C92B}). */
  baseLayout?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CompositeLayout (ID: {1123BAC0-6B46-4FAA-B684-8423C13E4004}). */
  compositeLayout?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Mode (ID: {4D0E825C-D503-42FF-A96F-1949F6259FD0}). */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Protected Theme (ID: {0B9CCE83-5355-4D1A-BBFE-E9BA3C3FE744}). */
  protectedTheme?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Theme template (ID: {B746D24C-8767-47E6-A092-AEBEA4EF647F}). */
export type GridThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Theme template (ID: {B746D24C-8767-47E6-A092-AEBEA4EF647F}). */
export type GridThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Theme template (ID: {B746D24C-8767-47E6-A092-AEBEA4EF647F}). */
export type GridThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Theme template (ID: {B746D24C-8767-47E6-A092-AEBEA4EF647F}). */
export type GridThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Theme template (ID: {B746D24C-8767-47E6-A092-AEBEA4EF647F}). */
export type GridThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Grid/Grid Theme template (ID: {B746D24C-8767-47E6-A092-AEBEA4EF647F}). */
export type GridThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code template (ID: {2AD23D55-AECD-43DD-AE0D-72D2EBCBA60F}). */
export type HtmlCode = Item & {
  __typename?: 'HTMLCode';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** HtmlCode (ID: {24CCE27C-05DB-4473-A1ED-E69B1725FF1C}). */
  htmlCode?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code template (ID: {2AD23D55-AECD-43DD-AE0D-72D2EBCBA60F}). */
export type HtmlCodeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code template (ID: {2AD23D55-AECD-43DD-AE0D-72D2EBCBA60F}). */
export type HtmlCodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code template (ID: {2AD23D55-AECD-43DD-AE0D-72D2EBCBA60F}). */
export type HtmlCodeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code template (ID: {2AD23D55-AECD-43DD-AE0D-72D2EBCBA60F}). */
export type HtmlCodeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code template (ID: {2AD23D55-AECD-43DD-AE0D-72D2EBCBA60F}). */
export type HtmlCodeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code template (ID: {2AD23D55-AECD-43DD-AE0D-72D2EBCBA60F}). */
export type HtmlCodeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code Folder template (ID: {5AB4AE85-0E97-4AFB-8498-B93C657A0DF0}). */
export type HtmlCodeFolder = Item & {
  __typename?: 'HTMLCodeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code Folder template (ID: {5AB4AE85-0E97-4AFB-8498-B93C657A0DF0}). */
export type HtmlCodeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code Folder template (ID: {5AB4AE85-0E97-4AFB-8498-B93C657A0DF0}). */
export type HtmlCodeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code Folder template (ID: {5AB4AE85-0E97-4AFB-8498-B93C657A0DF0}). */
export type HtmlCodeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code Folder template (ID: {5AB4AE85-0E97-4AFB-8498-B93C657A0DF0}). */
export type HtmlCodeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code Folder template (ID: {5AB4AE85-0E97-4AFB-8498-B93C657A0DF0}). */
export type HtmlCodeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/HTML Code Folder template (ID: {5AB4AE85-0E97-4AFB-8498-B93C657A0DF0}). */
export type HtmlCodeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Include template (ID: {A99D8A56-1BAF-4E52-BF69-4701821443BE}). */
export type HtmlInclude = ILocation & Item & {
  __typename?: 'HTMLInclude';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** HTML (ID: {97320AAC-8B2A-4F74-A219-6C422DC9DC41}). */
  hTML?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Location (ID: {F4DCDC00-1A6E-4D2C-B586-54EF20326FB6}). */
  location?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Include template (ID: {A99D8A56-1BAF-4E52-BF69-4701821443BE}). */
export type HtmlIncludeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Include template (ID: {A99D8A56-1BAF-4E52-BF69-4701821443BE}). */
export type HtmlIncludeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Include template (ID: {A99D8A56-1BAF-4E52-BF69-4701821443BE}). */
export type HtmlIncludeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Include template (ID: {A99D8A56-1BAF-4E52-BF69-4701821443BE}). */
export type HtmlIncludeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Include template (ID: {A99D8A56-1BAF-4E52-BF69-4701821443BE}). */
export type HtmlIncludeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Include template (ID: {A99D8A56-1BAF-4E52-BF69-4701821443BE}). */
export type HtmlIncludeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Includes Folder template (ID: {DCE12AF7-5462-45A9-9F70-6D3E2B1A5440}). */
export type HtmlIncludesFolder = Item & {
  __typename?: 'HTMLIncludesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Includes Folder template (ID: {DCE12AF7-5462-45A9-9F70-6D3E2B1A5440}). */
export type HtmlIncludesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Includes Folder template (ID: {DCE12AF7-5462-45A9-9F70-6D3E2B1A5440}). */
export type HtmlIncludesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Includes Folder template (ID: {DCE12AF7-5462-45A9-9F70-6D3E2B1A5440}). */
export type HtmlIncludesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Includes Folder template (ID: {DCE12AF7-5462-45A9-9F70-6D3E2B1A5440}). */
export type HtmlIncludesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Includes Folder template (ID: {DCE12AF7-5462-45A9-9F70-6D3E2B1A5440}). */
export type HtmlIncludesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/HTML Includes Folder template (ID: {DCE12AF7-5462-45A9-9F70-6D3E2B1A5440}). */
export type HtmlIncludesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet template (ID: {25F18683-2F03-4776-ADA3-6D2A76DBDF2D}). */
export type HtmlSnippet = Item & {
  __typename?: 'HTMLSnippet';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Html (ID: {EC4A491F-CC4B-4175-858A-3E6E859540BB}). */
  html?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet template (ID: {25F18683-2F03-4776-ADA3-6D2A76DBDF2D}). */
export type HtmlSnippetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet template (ID: {25F18683-2F03-4776-ADA3-6D2A76DBDF2D}). */
export type HtmlSnippetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet template (ID: {25F18683-2F03-4776-ADA3-6D2A76DBDF2D}). */
export type HtmlSnippetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet template (ID: {25F18683-2F03-4776-ADA3-6D2A76DBDF2D}). */
export type HtmlSnippetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet template (ID: {25F18683-2F03-4776-ADA3-6D2A76DBDF2D}). */
export type HtmlSnippetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet template (ID: {25F18683-2F03-4776-ADA3-6D2A76DBDF2D}). */
export type HtmlSnippetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet Folder template (ID: {35ABCB7F-DD86-483D-ABE1-41C93C3AA7D9}). */
export type HtmlSnippetFolder = Item & {
  __typename?: 'HTMLSnippetFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet Folder template (ID: {35ABCB7F-DD86-483D-ABE1-41C93C3AA7D9}). */
export type HtmlSnippetFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet Folder template (ID: {35ABCB7F-DD86-483D-ABE1-41C93C3AA7D9}). */
export type HtmlSnippetFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet Folder template (ID: {35ABCB7F-DD86-483D-ABE1-41C93C3AA7D9}). */
export type HtmlSnippetFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet Folder template (ID: {35ABCB7F-DD86-483D-ABE1-41C93C3AA7D9}). */
export type HtmlSnippetFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet Folder template (ID: {35ABCB7F-DD86-483D-ABE1-41C93C3AA7D9}). */
export type HtmlSnippetFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Generic Meta Rendering/HTML Snippet Folder template (ID: {35ABCB7F-DD86-483D-ABE1-41C93C3AA7D9}). */
export type HtmlSnippetFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/HTML Tag template (ID: {73A99860-05A0-4DC1-82F1-10D31267E43F}). */
export type HtmlTag = BaseVariantField & Item & _DataAttributes & _LinkAttributes & {
  __typename?: 'HTMLTag';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Select to have hyperlinks that wrap the field content. */
  isLink?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/HTML Tag template (ID: {73A99860-05A0-4DC1-82F1-10D31267E43F}). */
export type HtmlTagAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/HTML Tag template (ID: {73A99860-05A0-4DC1-82F1-10D31267E43F}). */
export type HtmlTagChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/HTML Tag template (ID: {73A99860-05A0-4DC1-82F1-10D31267E43F}). */
export type HtmlTagFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/HTML Tag template (ID: {73A99860-05A0-4DC1-82F1-10D31267E43F}). */
export type HtmlTagFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/HTML Tag template (ID: {73A99860-05A0-4DC1-82F1-10D31267E43F}). */
export type HtmlTagHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/HTML Tag template (ID: {73A99860-05A0-4DC1-82F1-10D31267E43F}). */
export type HtmlTagIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header template (ID: {F353A85A-27B2-4907-9560-5BC671B7F4F2}). */
export type Header = Item & {
  __typename?: 'Header';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** logo (ID: {554B6573-B696-41F8-A405-70F154589DF5}). */
  logo?: Maybe<ImageField>;
  /** logoLink (ID: {7AB155D9-0892-4906-9825-C4BDCEF356EC}). */
  logoLink?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header template (ID: {F353A85A-27B2-4907-9560-5BC671B7F4F2}). */
export type HeaderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header template (ID: {F353A85A-27B2-4907-9560-5BC671B7F4F2}). */
export type HeaderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header template (ID: {F353A85A-27B2-4907-9560-5BC671B7F4F2}). */
export type HeaderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header template (ID: {F353A85A-27B2-4907-9560-5BC671B7F4F2}). */
export type HeaderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header template (ID: {F353A85A-27B2-4907-9560-5BC671B7F4F2}). */
export type HeaderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header template (ID: {F353A85A-27B2-4907-9560-5BC671B7F4F2}). */
export type HeaderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header Folder template (ID: {AC125022-66FD-48F5-9181-889CCE0D5EBE}). */
export type HeaderFolder = Item & {
  __typename?: 'HeaderFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header Folder template (ID: {AC125022-66FD-48F5-9181-889CCE0D5EBE}). */
export type HeaderFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header Folder template (ID: {AC125022-66FD-48F5-9181-889CCE0D5EBE}). */
export type HeaderFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header Folder template (ID: {AC125022-66FD-48F5-9181-889CCE0D5EBE}). */
export type HeaderFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header Folder template (ID: {AC125022-66FD-48F5-9181-889CCE0D5EBE}). */
export type HeaderFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header Folder template (ID: {AC125022-66FD-48F5-9181-889CCE0D5EBE}). */
export type HeaderFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Header/Header Folder template (ID: {AC125022-66FD-48F5-9181-889CCE0D5EBE}). */
export type HeaderFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Heading template (ID: {C6C33CD3-7E47-49A6-A210-6D1BF173C317}). */
export type Heading = Item & {
  __typename?: 'Heading';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** header (ID: {37F61609-125A-45A1-8EB1-20107BED0001}). */
  header?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Heading template (ID: {C6C33CD3-7E47-49A6-A210-6D1BF173C317}). */
export type HeadingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Heading template (ID: {C6C33CD3-7E47-49A6-A210-6D1BF173C317}). */
export type HeadingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Heading template (ID: {C6C33CD3-7E47-49A6-A210-6D1BF173C317}). */
export type HeadingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Heading template (ID: {C6C33CD3-7E47-49A6-A210-6D1BF173C317}). */
export type HeadingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Heading template (ID: {C6C33CD3-7E47-49A6-A210-6D1BF173C317}). */
export type HeadingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Heading template (ID: {C6C33CD3-7E47-49A6-A210-6D1BF173C317}). */
export type HeadingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Site template (ID: {9ED66404-64C9-4122-90E1-869CB3CEA566}). Also implements _BaseSiteRoot, _SiteMediaLibrary, App, _Name_0345fd2f95094dc7b0f56c73a9b6cd8d, _Description, _SiteTemplate. */
export type HeadlessSite = {
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessSiteSetupRoot template (ID: {BED31D6F-D968-45A9-B54E-12D7F977D861}). */
export type HeadlessSiteSetupRoot = Item & _Dependencies & _Enabled & _IncludeByDefault & _IncludeIfInstalled & _IsSystemModule & _Name_B88cf88159a54a19991e71038751cb60 & {
  __typename?: 'HeadlessSiteSetupRoot';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Dependencies (ID: {40DEEE2F-7595-40BD-B2C9-51F9E2346100}). */
  dependencies?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled (ID: {4B475746-CF34-4C06-97C8-7A8B0B40064F}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IncludeByDefault (ID: {11488836-D40F-40D4-BEB4-1D31DA7B1470}). */
  includeByDefault?: Maybe<CheckboxField>;
  /** IncludeIfInstalled (ID: {52A4245C-A3D5-4B23-9F3A-5B33C9811906}). */
  includeIfInstalled?: Maybe<MultilistField>;
  /** IsSystemModule (ID: {06D2C562-9229-4779-8807-E2A5FD2990D4}). */
  isSystemModule?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {C202067E-7FAB-4606-AFB4-E76DF2185DDC}). */
  name_c202067e7fab4606afb4e76df2185ddc?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessSiteSetupRoot template (ID: {BED31D6F-D968-45A9-B54E-12D7F977D861}). */
export type HeadlessSiteSetupRootAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessSiteSetupRoot template (ID: {BED31D6F-D968-45A9-B54E-12D7F977D861}). */
export type HeadlessSiteSetupRootChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessSiteSetupRoot template (ID: {BED31D6F-D968-45A9-B54E-12D7F977D861}). */
export type HeadlessSiteSetupRootFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessSiteSetupRoot template (ID: {BED31D6F-D968-45A9-B54E-12D7F977D861}). */
export type HeadlessSiteSetupRootFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessSiteSetupRoot template (ID: {BED31D6F-D968-45A9-B54E-12D7F977D861}). */
export type HeadlessSiteSetupRootHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessSiteSetupRoot template (ID: {BED31D6F-D968-45A9-B54E-12D7F977D861}). */
export type HeadlessSiteSetupRootIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/Headless Site template (ID: {00D05098-8BAD-49E5-B65D-B1E08B03CA1B}). */
export type HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/Headless Site template (ID: {00D05098-8BAD-49E5-B65D-B1E08B03CA1B}). */
export type HeadlessSite_00d050988bad49e5b65db1e08b03ca1bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Headless Site template (ID: {00D05098-8BAD-49E5-B65D-B1E08B03CA1B}). */
export type HeadlessSite_00d050988bad49e5b65db1e08b03ca1bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Headless Site template (ID: {00D05098-8BAD-49E5-B65D-B1E08B03CA1B}). */
export type HeadlessSite_00d050988bad49e5b65db1e08b03ca1bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/Headless Site template (ID: {00D05098-8BAD-49E5-B65D-B1E08B03CA1B}). */
export type HeadlessSite_00d050988bad49e5b65db1e08b03ca1bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/Headless Site template (ID: {00D05098-8BAD-49E5-B65D-B1E08B03CA1B}). */
export type HeadlessSite_00d050988bad49e5b65db1e08b03ca1bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Headless Site template (ID: {00D05098-8BAD-49E5-B65D-B1E08B03CA1B}). */
export type HeadlessSite_00d050988bad49e5b65db1e08b03ca1bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Invest Trusts/Headless Site template (ID: {0BB67DAE-D5D0-4933-A5CE-1C0BAA6C4DF1}). */
export type HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/Headless Site template (ID: {0BB67DAE-D5D0-4933-A5CE-1C0BAA6C4DF1}). */
export type HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Site template (ID: {0BB67DAE-D5D0-4933-A5CE-1C0BAA6C4DF1}). */
export type HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Site template (ID: {0BB67DAE-D5D0-4933-A5CE-1C0BAA6C4DF1}). */
export type HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/Headless Site template (ID: {0BB67DAE-D5D0-4933-A5CE-1C0BAA6C4DF1}). */
export type HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Site template (ID: {0BB67DAE-D5D0-4933-A5CE-1C0BAA6C4DF1}). */
export type HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Site template (ID: {0BB67DAE-D5D0-4933-A5CE-1C0BAA6C4DF1}). */
export type HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Headless Site template (ID: {8CA00145-3C4B-4715-959D-8A05292ECBC5}). */
export type HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Headless Site template (ID: {8CA00145-3C4B-4715-959D-8A05292ECBC5}). */
export type HeadlessSite_8ca001453c4b4715959d8a05292ecbc5AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Headless Site template (ID: {8CA00145-3C4B-4715-959D-8A05292ECBC5}). */
export type HeadlessSite_8ca001453c4b4715959d8a05292ecbc5ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Headless Site template (ID: {8CA00145-3C4B-4715-959D-8A05292ECBC5}). */
export type HeadlessSite_8ca001453c4b4715959d8a05292ecbc5FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Headless Site template (ID: {8CA00145-3C4B-4715-959D-8A05292ECBC5}). */
export type HeadlessSite_8ca001453c4b4715959d8a05292ecbc5FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Headless Site template (ID: {8CA00145-3C4B-4715-959D-8A05292ECBC5}). */
export type HeadlessSite_8ca001453c4b4715959d8a05292ecbc5HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Headless Site template (ID: {8CA00145-3C4B-4715-959D-8A05292ECBC5}). */
export type HeadlessSite_8ca001453c4b4715959d8a05292ecbc5IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Headless Site template (ID: {68FFA40C-5AAB-4554-8F77-4742B163F318}). */
export type HeadlessSite_68ffa40c5aab45548f774742b163f318 = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Headless Site template (ID: {68FFA40C-5AAB-4554-8F77-4742B163F318}). */
export type HeadlessSite_68ffa40c5aab45548f774742b163f318AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Site template (ID: {68FFA40C-5AAB-4554-8F77-4742B163F318}). */
export type HeadlessSite_68ffa40c5aab45548f774742b163f318ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Site template (ID: {68FFA40C-5AAB-4554-8F77-4742B163F318}). */
export type HeadlessSite_68ffa40c5aab45548f774742b163f318FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Headless Site template (ID: {68FFA40C-5AAB-4554-8F77-4742B163F318}). */
export type HeadlessSite_68ffa40c5aab45548f774742b163f318FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Headless Site template (ID: {68FFA40C-5AAB-4554-8F77-4742B163F318}). */
export type HeadlessSite_68ffa40c5aab45548f774742b163f318HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Site template (ID: {68FFA40C-5AAB-4554-8F77-4742B163F318}). */
export type HeadlessSite_68ffa40c5aab45548f774742b163f318IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Headless Site template (ID: {89D464C8-C03E-4B02-87E9-A878D95D7149}). */
export type HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Site template (ID: {89D464C8-C03E-4B02-87E9-A878D95D7149}). */
export type HeadlessSite_89d464c8c03e4b0287e9a878d95d7149AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Site template (ID: {89D464C8-C03E-4B02-87E9-A878D95D7149}). */
export type HeadlessSite_89d464c8c03e4b0287e9a878d95d7149ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Site template (ID: {89D464C8-C03E-4B02-87E9-A878D95D7149}). */
export type HeadlessSite_89d464c8c03e4b0287e9a878d95d7149FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Site template (ID: {89D464C8-C03E-4B02-87E9-A878D95D7149}). */
export type HeadlessSite_89d464c8c03e4b0287e9a878d95d7149FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Site template (ID: {89D464C8-C03E-4B02-87E9-A878D95D7149}). */
export type HeadlessSite_89d464c8c03e4b0287e9a878d95d7149HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Site template (ID: {89D464C8-C03E-4B02-87E9-A878D95D7149}). */
export type HeadlessSite_89d464c8c03e4b0287e9a878d95d7149IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Headless Site template (ID: {22948489-3CA1-4495-8B99-37167DFB5064}). */
export type HeadlessSite_229484893ca144958b9937167dfb5064 = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Headless Site template (ID: {22948489-3CA1-4495-8B99-37167DFB5064}). */
export type HeadlessSite_229484893ca144958b9937167dfb5064AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Headless Site template (ID: {22948489-3CA1-4495-8B99-37167DFB5064}). */
export type HeadlessSite_229484893ca144958b9937167dfb5064ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Headless Site template (ID: {22948489-3CA1-4495-8B99-37167DFB5064}). */
export type HeadlessSite_229484893ca144958b9937167dfb5064FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Headless Site template (ID: {22948489-3CA1-4495-8B99-37167DFB5064}). */
export type HeadlessSite_229484893ca144958b9937167dfb5064FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Headless Site template (ID: {22948489-3CA1-4495-8B99-37167DFB5064}). */
export type HeadlessSite_229484893ca144958b9937167dfb5064HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Headless Site template (ID: {22948489-3CA1-4495-8B99-37167DFB5064}). */
export type HeadlessSite_229484893ca144958b9937167dfb5064IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Site template (ID: {B2805562-6ACC-45A2-913A-9617398C9730}). */
export type HeadlessSite_B28055626acc45a2913a9617398c9730 = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Site template (ID: {B2805562-6ACC-45A2-913A-9617398C9730}). */
export type HeadlessSite_B28055626acc45a2913a9617398c9730AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Site template (ID: {B2805562-6ACC-45A2-913A-9617398C9730}). */
export type HeadlessSite_B28055626acc45a2913a9617398c9730ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Site template (ID: {B2805562-6ACC-45A2-913A-9617398C9730}). */
export type HeadlessSite_B28055626acc45a2913a9617398c9730FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Site template (ID: {B2805562-6ACC-45A2-913A-9617398C9730}). */
export type HeadlessSite_B28055626acc45a2913a9617398c9730FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Site template (ID: {B2805562-6ACC-45A2-913A-9617398C9730}). */
export type HeadlessSite_B28055626acc45a2913a9617398c9730HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Site template (ID: {B2805562-6ACC-45A2-913A-9617398C9730}). */
export type HeadlessSite_B28055626acc45a2913a9617398c9730IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Headless Site template (ID: {F1CAB166-1ABB-450D-84D5-5D938E7699CB}). */
export type HeadlessSite_F1cab1661abb450d84d55d938e7699cb = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Headless Site template (ID: {F1CAB166-1ABB-450D-84D5-5D938E7699CB}). */
export type HeadlessSite_F1cab1661abb450d84d55d938e7699cbAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Headless Site template (ID: {F1CAB166-1ABB-450D-84D5-5D938E7699CB}). */
export type HeadlessSite_F1cab1661abb450d84d55d938e7699cbChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Headless Site template (ID: {F1CAB166-1ABB-450D-84D5-5D938E7699CB}). */
export type HeadlessSite_F1cab1661abb450d84d55d938e7699cbFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Headless Site template (ID: {F1CAB166-1ABB-450D-84D5-5D938E7699CB}). */
export type HeadlessSite_F1cab1661abb450d84d55d938e7699cbFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Headless Site template (ID: {F1CAB166-1ABB-450D-84D5-5D938E7699CB}). */
export type HeadlessSite_F1cab1661abb450d84d55d938e7699cbHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Headless Site template (ID: {F1CAB166-1ABB-450D-84D5-5D938E7699CB}). */
export type HeadlessSite_F1cab1661abb450d84d55d938e7699cbIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Headless Site template (ID: {F3884BAA-0E15-48F5-9A6D-7154A4559604}). */
export type HeadlessSite_F3884baa0e1548f59a6d7154a4559604 = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Headless Site template (ID: {F3884BAA-0E15-48F5-9A6D-7154A4559604}). */
export type HeadlessSite_F3884baa0e1548f59a6d7154a4559604AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Site template (ID: {F3884BAA-0E15-48F5-9A6D-7154A4559604}). */
export type HeadlessSite_F3884baa0e1548f59a6d7154a4559604ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Site template (ID: {F3884BAA-0E15-48F5-9A6D-7154A4559604}). */
export type HeadlessSite_F3884baa0e1548f59a6d7154a4559604FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Headless Site template (ID: {F3884BAA-0E15-48F5-9A6D-7154A4559604}). */
export type HeadlessSite_F3884baa0e1548f59a6d7154a4559604FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Site template (ID: {F3884BAA-0E15-48F5-9A6D-7154A4559604}). */
export type HeadlessSite_F3884baa0e1548f59a6d7154a4559604HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Site template (ID: {F3884BAA-0E15-48F5-9A6D-7154A4559604}). */
export type HeadlessSite_F3884baa0e1548f59a6d7154a4559604IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Solution Template Folder template (ID: {A5705AF7-25DF-4B3A-B220-2EC026AB2099}). */
export type HeadlessSolutionTemplateFolder = Item & {
  __typename?: 'HeadlessSolutionTemplateFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Solution Template Folder template (ID: {A5705AF7-25DF-4B3A-B220-2EC026AB2099}). */
export type HeadlessSolutionTemplateFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Solution Template Folder template (ID: {A5705AF7-25DF-4B3A-B220-2EC026AB2099}). */
export type HeadlessSolutionTemplateFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Solution Template Folder template (ID: {A5705AF7-25DF-4B3A-B220-2EC026AB2099}). */
export type HeadlessSolutionTemplateFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Solution Template Folder template (ID: {A5705AF7-25DF-4B3A-B220-2EC026AB2099}). */
export type HeadlessSolutionTemplateFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Solution Template Folder template (ID: {A5705AF7-25DF-4B3A-B220-2EC026AB2099}). */
export type HeadlessSolutionTemplateFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Solution Template Folder template (ID: {A5705AF7-25DF-4B3A-B220-2EC026AB2099}). */
export type HeadlessSolutionTemplateFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Headless Tenant template (ID: {B91811F1-FA8B-47F8-B131-BD2C6D5EC805}). Also implements _BaseTenant, _BaseJSSTenant, _Name_0345fd2f95094dc7b0f56c73a9b6cd8d, _Description, _SitecoreClientSiteManaging. */
export type HeadlessTenant = {
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessTenantSetupRoot template (ID: {F036B5E0-37FB-4537-9D36-EF84E5BD41B7}). */
export type HeadlessTenantSetupRoot = Item & _Enabled & _IncludeByDefault & _IsSystemModule & _Name_B88cf88159a54a19991e71038751cb60 & {
  __typename?: 'HeadlessTenantSetupRoot';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled (ID: {4B475746-CF34-4C06-97C8-7A8B0B40064F}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IncludeByDefault (ID: {11488836-D40F-40D4-BEB4-1D31DA7B1470}). */
  includeByDefault?: Maybe<CheckboxField>;
  /** IsSystemModule (ID: {06D2C562-9229-4779-8807-E2A5FD2990D4}). */
  isSystemModule?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {C202067E-7FAB-4606-AFB4-E76DF2185DDC}). */
  name_c202067e7fab4606afb4e76df2185ddc?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessTenantSetupRoot template (ID: {F036B5E0-37FB-4537-9D36-EF84E5BD41B7}). */
export type HeadlessTenantSetupRootAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessTenantSetupRoot template (ID: {F036B5E0-37FB-4537-9D36-EF84E5BD41B7}). */
export type HeadlessTenantSetupRootChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessTenantSetupRoot template (ID: {F036B5E0-37FB-4537-9D36-EF84E5BD41B7}). */
export type HeadlessTenantSetupRootFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessTenantSetupRoot template (ID: {F036B5E0-37FB-4537-9D36-EF84E5BD41B7}). */
export type HeadlessTenantSetupRootFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessTenantSetupRoot template (ID: {F036B5E0-37FB-4537-9D36-EF84E5BD41B7}). */
export type HeadlessTenantSetupRootHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Roots/HeadlessTenantSetupRoot template (ID: {F036B5E0-37FB-4537-9D36-EF84E5BD41B7}). */
export type HeadlessTenantSetupRootIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Tenant template (ID: {07248C47-00AF-499E-B2A9-CB7789F72372}). */
export type HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Tenant template (ID: {07248C47-00AF-499E-B2A9-CB7789F72372}). */
export type HeadlessTenant_07248c4700af499eb2a9cb7789f72372AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Tenant template (ID: {07248C47-00AF-499E-B2A9-CB7789F72372}). */
export type HeadlessTenant_07248c4700af499eb2a9cb7789f72372ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Tenant template (ID: {07248C47-00AF-499E-B2A9-CB7789F72372}). */
export type HeadlessTenant_07248c4700af499eb2a9cb7789f72372FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Tenant template (ID: {07248C47-00AF-499E-B2A9-CB7789F72372}). */
export type HeadlessTenant_07248c4700af499eb2a9cb7789f72372FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Tenant template (ID: {07248C47-00AF-499E-B2A9-CB7789F72372}). */
export type HeadlessTenant_07248c4700af499eb2a9cb7789f72372HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Headless Tenant template (ID: {07248C47-00AF-499E-B2A9-CB7789F72372}). */
export type HeadlessTenant_07248c4700af499eb2a9cb7789f72372IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Headless Tenant template (ID: {5B3D7AC5-4193-43C6-97C7-22309A2AD4C8}). */
export type HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Tenant template (ID: {5B3D7AC5-4193-43C6-97C7-22309A2AD4C8}). */
export type HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Tenant template (ID: {5B3D7AC5-4193-43C6-97C7-22309A2AD4C8}). */
export type HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Tenant template (ID: {5B3D7AC5-4193-43C6-97C7-22309A2AD4C8}). */
export type HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Tenant template (ID: {5B3D7AC5-4193-43C6-97C7-22309A2AD4C8}). */
export type HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Tenant template (ID: {5B3D7AC5-4193-43C6-97C7-22309A2AD4C8}). */
export type HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Headless Tenant template (ID: {5B3D7AC5-4193-43C6-97C7-22309A2AD4C8}). */
export type HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Headless Tenant template (ID: {5D72DF60-49C7-4324-9692-05B55767AD7B}). */
export type HeadlessTenant_5d72df6049c74324969205b55767ad7b = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Headless Tenant template (ID: {5D72DF60-49C7-4324-9692-05B55767AD7B}). */
export type HeadlessTenant_5d72df6049c74324969205b55767ad7bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Tenant template (ID: {5D72DF60-49C7-4324-9692-05B55767AD7B}). */
export type HeadlessTenant_5d72df6049c74324969205b55767ad7bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Tenant template (ID: {5D72DF60-49C7-4324-9692-05B55767AD7B}). */
export type HeadlessTenant_5d72df6049c74324969205b55767ad7bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Headless Tenant template (ID: {5D72DF60-49C7-4324-9692-05B55767AD7B}). */
export type HeadlessTenant_5d72df6049c74324969205b55767ad7bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Headless Tenant template (ID: {5D72DF60-49C7-4324-9692-05B55767AD7B}). */
export type HeadlessTenant_5d72df6049c74324969205b55767ad7bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Tenant template (ID: {5D72DF60-49C7-4324-9692-05B55767AD7B}). */
export type HeadlessTenant_5d72df6049c74324969205b55767ad7bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/Headless Tenant template (ID: {6ABD3BF1-6BCB-4F25-AC5B-2399FF7A92E3}). */
export type HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/Headless Tenant template (ID: {6ABD3BF1-6BCB-4F25-AC5B-2399FF7A92E3}). */
export type HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Headless Tenant template (ID: {6ABD3BF1-6BCB-4F25-AC5B-2399FF7A92E3}). */
export type HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Headless Tenant template (ID: {6ABD3BF1-6BCB-4F25-AC5B-2399FF7A92E3}). */
export type HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/Headless Tenant template (ID: {6ABD3BF1-6BCB-4F25-AC5B-2399FF7A92E3}). */
export type HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/Headless Tenant template (ID: {6ABD3BF1-6BCB-4F25-AC5B-2399FF7A92E3}). */
export type HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Headless Tenant template (ID: {6ABD3BF1-6BCB-4F25-AC5B-2399FF7A92E3}). */
export type HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Invest Trusts/Headless Tenant template (ID: {77A403A2-094E-48AF-AFA6-0943D349D23D}). */
export type HeadlessTenant_77a403a2094e48afafa60943d349d23d = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/Headless Tenant template (ID: {77A403A2-094E-48AF-AFA6-0943D349D23D}). */
export type HeadlessTenant_77a403a2094e48afafa60943d349d23dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Tenant template (ID: {77A403A2-094E-48AF-AFA6-0943D349D23D}). */
export type HeadlessTenant_77a403a2094e48afafa60943d349d23dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Tenant template (ID: {77A403A2-094E-48AF-AFA6-0943D349D23D}). */
export type HeadlessTenant_77a403a2094e48afafa60943d349d23dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/Headless Tenant template (ID: {77A403A2-094E-48AF-AFA6-0943D349D23D}). */
export type HeadlessTenant_77a403a2094e48afafa60943d349d23dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Tenant template (ID: {77A403A2-094E-48AF-AFA6-0943D349D23D}). */
export type HeadlessTenant_77a403a2094e48afafa60943d349d23dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Headless Tenant template (ID: {77A403A2-094E-48AF-AFA6-0943D349D23D}). */
export type HeadlessTenant_77a403a2094e48afafa60943d349d23dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Headless Tenant template (ID: {115C4202-9C0D-4FBC-B542-A4A539C33EE2}). */
export type HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Headless Tenant template (ID: {115C4202-9C0D-4FBC-B542-A4A539C33EE2}). */
export type HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Headless Tenant template (ID: {115C4202-9C0D-4FBC-B542-A4A539C33EE2}). */
export type HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Headless Tenant template (ID: {115C4202-9C0D-4FBC-B542-A4A539C33EE2}). */
export type HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Headless Tenant template (ID: {115C4202-9C0D-4FBC-B542-A4A539C33EE2}). */
export type HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Headless Tenant template (ID: {115C4202-9C0D-4FBC-B542-A4A539C33EE2}). */
export type HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Headless Tenant template (ID: {115C4202-9C0D-4FBC-B542-A4A539C33EE2}). */
export type HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Headless Tenant template (ID: {94824AC3-90D7-4849-9E5A-F0275D10811F}). */
export type HeadlessTenant_94824ac390d748499e5af0275d10811f = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Headless Tenant template (ID: {94824AC3-90D7-4849-9E5A-F0275D10811F}). */
export type HeadlessTenant_94824ac390d748499e5af0275d10811fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Headless Tenant template (ID: {94824AC3-90D7-4849-9E5A-F0275D10811F}). */
export type HeadlessTenant_94824ac390d748499e5af0275d10811fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Headless Tenant template (ID: {94824AC3-90D7-4849-9E5A-F0275D10811F}). */
export type HeadlessTenant_94824ac390d748499e5af0275d10811fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Headless Tenant template (ID: {94824AC3-90D7-4849-9E5A-F0275D10811F}). */
export type HeadlessTenant_94824ac390d748499e5af0275d10811fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Headless Tenant template (ID: {94824AC3-90D7-4849-9E5A-F0275D10811F}). */
export type HeadlessTenant_94824ac390d748499e5af0275d10811fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Headless Tenant template (ID: {94824AC3-90D7-4849-9E5A-F0275D10811F}). */
export type HeadlessTenant_94824ac390d748499e5af0275d10811fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Headless Tenant template (ID: {47975718-64FD-4092-9CF2-412C39757EC3}). */
export type HeadlessTenant_4797571864fd40929cf2412c39757ec3 = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Headless Tenant template (ID: {47975718-64FD-4092-9CF2-412C39757EC3}). */
export type HeadlessTenant_4797571864fd40929cf2412c39757ec3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Headless Tenant template (ID: {47975718-64FD-4092-9CF2-412C39757EC3}). */
export type HeadlessTenant_4797571864fd40929cf2412c39757ec3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Headless Tenant template (ID: {47975718-64FD-4092-9CF2-412C39757EC3}). */
export type HeadlessTenant_4797571864fd40929cf2412c39757ec3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Headless Tenant template (ID: {47975718-64FD-4092-9CF2-412C39757EC3}). */
export type HeadlessTenant_4797571864fd40929cf2412c39757ec3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Headless Tenant template (ID: {47975718-64FD-4092-9CF2-412C39757EC3}). */
export type HeadlessTenant_4797571864fd40929cf2412c39757ec3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Headless Tenant template (ID: {47975718-64FD-4092-9CF2-412C39757EC3}). */
export type HeadlessTenant_4797571864fd40929cf2412c39757ec3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Headless Tenant template (ID: {C102FB48-F40F-49FB-9C21-F8E3E1B0C107}). */
export type HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107 = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & {
  __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Headless Tenant template (ID: {C102FB48-F40F-49FB-9C21-F8E3E1B0C107}). */
export type HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Tenant template (ID: {C102FB48-F40F-49FB-9C21-F8E3E1B0C107}). */
export type HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Tenant template (ID: {C102FB48-F40F-49FB-9C21-F8E3E1B0C107}). */
export type HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Headless Tenant template (ID: {C102FB48-F40F-49FB-9C21-F8E3E1B0C107}). */
export type HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Tenant template (ID: {C102FB48-F40F-49FB-9C21-F8E3E1B0C107}). */
export type HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Headless Tenant template (ID: {C102FB48-F40F-49FB-9C21-F8E3E1B0C107}). */
export type HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Headless Trust Site template (ID: {A3B383CA-84A4-4738-8190-44974A4F6A51}). */
export type HeadlessTrustSite = HeadlessSite & Item & _Description & _Modules & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _RoleDomain & _SiteMediaLibrary & _SiteTemplate & _SitemapMediaItems & {
  __typename?: 'HeadlessTrustSite';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Headless Trust Site template (ID: {A3B383CA-84A4-4738-8190-44974A4F6A51}). */
export type HeadlessTrustSiteAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Trust Site template (ID: {A3B383CA-84A4-4738-8190-44974A4F6A51}). */
export type HeadlessTrustSiteChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Trust Site template (ID: {A3B383CA-84A4-4738-8190-44974A4F6A51}). */
export type HeadlessTrustSiteFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Headless Trust Site template (ID: {A3B383CA-84A4-4738-8190-44974A4F6A51}). */
export type HeadlessTrustSiteFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Headless Trust Site template (ID: {A3B383CA-84A4-4738-8190-44974A4F6A51}). */
export type HeadlessTrustSiteHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Headless Trust Site template (ID: {A3B383CA-84A4-4738-8190-44974A4F6A51}). */
export type HeadlessTrustSiteIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariants template (ID: {49C111D0-6867-4798-A724-1F103166E6E9}). */
export type HeadlessVariants = ICompatibleRenderings & Item & {
  __typename?: 'HeadlessVariants';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariants template (ID: {49C111D0-6867-4798-A724-1F103166E6E9}). */
export type HeadlessVariantsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariants template (ID: {49C111D0-6867-4798-A724-1F103166E6E9}). */
export type HeadlessVariantsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariants template (ID: {49C111D0-6867-4798-A724-1F103166E6E9}). */
export type HeadlessVariantsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariants template (ID: {49C111D0-6867-4798-A724-1F103166E6E9}). */
export type HeadlessVariantsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariants template (ID: {49C111D0-6867-4798-A724-1F103166E6E9}). */
export type HeadlessVariantsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariants template (ID: {49C111D0-6867-4798-A724-1F103166E6E9}). */
export type HeadlessVariantsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariantsGrouping template (ID: {DA26C636-96E1-45E4-88D6-3FCEC70D5699}). */
export type HeadlessVariantsGrouping = Item & {
  __typename?: 'HeadlessVariantsGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariantsGrouping template (ID: {DA26C636-96E1-45E4-88D6-3FCEC70D5699}). */
export type HeadlessVariantsGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariantsGrouping template (ID: {DA26C636-96E1-45E4-88D6-3FCEC70D5699}). */
export type HeadlessVariantsGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariantsGrouping template (ID: {DA26C636-96E1-45E4-88D6-3FCEC70D5699}). */
export type HeadlessVariantsGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariantsGrouping template (ID: {DA26C636-96E1-45E4-88D6-3FCEC70D5699}). */
export type HeadlessVariantsGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariantsGrouping template (ID: {DA26C636-96E1-45E4-88D6-3FCEC70D5699}). */
export type HeadlessVariantsGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/HeadlessVariantsGrouping template (ID: {DA26C636-96E1-45E4-88D6-3FCEC70D5699}). */
export type HeadlessVariantsGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Page template (ID: {53D5DDB8-A81E-4343-B691-5A45CA7AD1B0}). */
export type HelpArticlePage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BaseHelpArticle & _BasePage & _Designable & _FundMetadataPage & _HelpArticle & _MetadataPage & _Navigable & _NavigablePage & _SharedPage & _Sitemap & _Taggable & {
  __typename?: 'HelpArticlePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** helpPlatform (ID: {6D132CC4-961D-4DE6-94F4-C99A8DD8EE64}). */
  helpPlatform?: Maybe<MultilistField>;
  /** helpStrapline (ID: {20C18889-078D-4483-B837-E8CC2CEAD74E}). */
  helpStrapline?: Maybe<TextField>;
  /** helpTag (ID: {212899C9-5810-4BF4-8EEF-D957FBE30EB7}). */
  helpTag?: Maybe<LookupField>;
  /** helpTitle (ID: {8602E54D-E233-4F77-8083-C5023808D8DB}). */
  helpTitle?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Page template (ID: {53D5DDB8-A81E-4343-B691-5A45CA7AD1B0}). */
export type HelpArticlePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Page template (ID: {53D5DDB8-A81E-4343-B691-5A45CA7AD1B0}). */
export type HelpArticlePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Page template (ID: {53D5DDB8-A81E-4343-B691-5A45CA7AD1B0}). */
export type HelpArticlePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Page template (ID: {53D5DDB8-A81E-4343-B691-5A45CA7AD1B0}). */
export type HelpArticlePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Page template (ID: {53D5DDB8-A81E-4343-B691-5A45CA7AD1B0}). */
export type HelpArticlePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Help Article Page template (ID: {53D5DDB8-A81E-4343-B691-5A45CA7AD1B0}). */
export type HelpArticlePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platform template (ID: {231D443A-24A4-4F55-9390-F911249C5197}). */
export type HelpArticlePlatform = Item & {
  __typename?: 'HelpArticlePlatform';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {DD8B57F1-980A-466B-B55F-884CD5B035CB}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {8ADB7C9B-D7EE-4EE0-9446-0204D5CBD44A}). */
  name_8adb7c9bd7ee4ee094460204d5cbd44a?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {C695B185-BAFF-4816-96E8-714D4DA097E5}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platform template (ID: {231D443A-24A4-4F55-9390-F911249C5197}). */
export type HelpArticlePlatformAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platform template (ID: {231D443A-24A4-4F55-9390-F911249C5197}). */
export type HelpArticlePlatformChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platform template (ID: {231D443A-24A4-4F55-9390-F911249C5197}). */
export type HelpArticlePlatformFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platform template (ID: {231D443A-24A4-4F55-9390-F911249C5197}). */
export type HelpArticlePlatformFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platform template (ID: {231D443A-24A4-4F55-9390-F911249C5197}). */
export type HelpArticlePlatformHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platform template (ID: {231D443A-24A4-4F55-9390-F911249C5197}). */
export type HelpArticlePlatformIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Map template (ID: {5EDF28EB-F488-429B-B889-7FC497876C2F}). */
export type HelpArticlePlatformMap = Item & {
  __typename?: 'HelpArticlePlatformMap';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** page (ID: {6A221D59-FCE2-49E2-B499-5AA7FDB518D6}). */
  page?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** platform (ID: {AD9B5D75-BD40-4DAE-A88B-69540DF43D5A}). */
  platform?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Map template (ID: {5EDF28EB-F488-429B-B889-7FC497876C2F}). */
export type HelpArticlePlatformMapAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Map template (ID: {5EDF28EB-F488-429B-B889-7FC497876C2F}). */
export type HelpArticlePlatformMapChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Map template (ID: {5EDF28EB-F488-429B-B889-7FC497876C2F}). */
export type HelpArticlePlatformMapFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Map template (ID: {5EDF28EB-F488-429B-B889-7FC497876C2F}). */
export type HelpArticlePlatformMapFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Map template (ID: {5EDF28EB-F488-429B-B889-7FC497876C2F}). */
export type HelpArticlePlatformMapHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Map template (ID: {5EDF28EB-F488-429B-B889-7FC497876C2F}). */
export type HelpArticlePlatformMapIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Mappings template (ID: {DBB161AF-A561-4A87-B911-9B1BDE2B1FAC}). */
export type HelpArticlePlatformMappings = Item & {
  __typename?: 'HelpArticlePlatformMappings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Mappings template (ID: {DBB161AF-A561-4A87-B911-9B1BDE2B1FAC}). */
export type HelpArticlePlatformMappingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Mappings template (ID: {DBB161AF-A561-4A87-B911-9B1BDE2B1FAC}). */
export type HelpArticlePlatformMappingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Mappings template (ID: {DBB161AF-A561-4A87-B911-9B1BDE2B1FAC}). */
export type HelpArticlePlatformMappingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Mappings template (ID: {DBB161AF-A561-4A87-B911-9B1BDE2B1FAC}). */
export type HelpArticlePlatformMappingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Mappings template (ID: {DBB161AF-A561-4A87-B911-9B1BDE2B1FAC}). */
export type HelpArticlePlatformMappingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform Map/Help Article Platform Mappings template (ID: {DBB161AF-A561-4A87-B911-9B1BDE2B1FAC}). */
export type HelpArticlePlatformMappingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platforms Folder template (ID: {D09EA9BC-221B-400C-81BE-444A0267C619}). */
export type HelpArticlePlatformsFolder = Item & {
  __typename?: 'HelpArticlePlatformsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platforms Folder template (ID: {D09EA9BC-221B-400C-81BE-444A0267C619}). */
export type HelpArticlePlatformsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platforms Folder template (ID: {D09EA9BC-221B-400C-81BE-444A0267C619}). */
export type HelpArticlePlatformsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platforms Folder template (ID: {D09EA9BC-221B-400C-81BE-444A0267C619}). */
export type HelpArticlePlatformsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platforms Folder template (ID: {D09EA9BC-221B-400C-81BE-444A0267C619}). */
export type HelpArticlePlatformsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platforms Folder template (ID: {D09EA9BC-221B-400C-81BE-444A0267C619}). */
export type HelpArticlePlatformsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Platform/Help Article Platforms Folder template (ID: {D09EA9BC-221B-400C-81BE-444A0267C619}). */
export type HelpArticlePlatformsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Search Page template (ID: {421198C1-43FD-436D-8BD3-BADFF70AFCCD}). */
export type HelpArticleSearchPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HelpArticleSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Search Page template (ID: {421198C1-43FD-436D-8BD3-BADFF70AFCCD}). */
export type HelpArticleSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Search Page template (ID: {421198C1-43FD-436D-8BD3-BADFF70AFCCD}). */
export type HelpArticleSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Search Page template (ID: {421198C1-43FD-436D-8BD3-BADFF70AFCCD}). */
export type HelpArticleSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Search Page template (ID: {421198C1-43FD-436D-8BD3-BADFF70AFCCD}). */
export type HelpArticleSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Search Page template (ID: {421198C1-43FD-436D-8BD3-BADFF70AFCCD}). */
export type HelpArticleSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Search Page template (ID: {421198C1-43FD-436D-8BD3-BADFF70AFCCD}). */
export type HelpArticleSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Help Article Search Page template (ID: {486D4C74-32C6-4F9A-929B-595943C6FE77}). */
export type HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Search Page template (ID: {486D4C74-32C6-4F9A-929B-595943C6FE77}). */
export type HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Search Page template (ID: {486D4C74-32C6-4F9A-929B-595943C6FE77}). */
export type HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Search Page template (ID: {486D4C74-32C6-4F9A-929B-595943C6FE77}). */
export type HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Search Page template (ID: {486D4C74-32C6-4F9A-929B-595943C6FE77}). */
export type HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Search Page template (ID: {486D4C74-32C6-4F9A-929B-595943C6FE77}). */
export type HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Search Page template (ID: {486D4C74-32C6-4F9A-929B-595943C6FE77}). */
export type HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tag template (ID: {BE289332-E2FC-4885-AC8A-85F018913569}). */
export type HelpArticleTag = Item & {
  __typename?: 'HelpArticleTag';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {7D46279A-1FF5-49B8-B6F2-EA663EDB696F}). */
  name_7d46279a1ff549b8b6f2ea663edb696f?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tag template (ID: {BE289332-E2FC-4885-AC8A-85F018913569}). */
export type HelpArticleTagAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tag template (ID: {BE289332-E2FC-4885-AC8A-85F018913569}). */
export type HelpArticleTagChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tag template (ID: {BE289332-E2FC-4885-AC8A-85F018913569}). */
export type HelpArticleTagFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tag template (ID: {BE289332-E2FC-4885-AC8A-85F018913569}). */
export type HelpArticleTagFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tag template (ID: {BE289332-E2FC-4885-AC8A-85F018913569}). */
export type HelpArticleTagHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tag template (ID: {BE289332-E2FC-4885-AC8A-85F018913569}). */
export type HelpArticleTagIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tags Folder template (ID: {94AA0B48-FA5A-47EE-8AC5-B6DC8027C389}). */
export type HelpArticleTagsFolder = Item & {
  __typename?: 'HelpArticleTagsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tags Folder template (ID: {94AA0B48-FA5A-47EE-8AC5-B6DC8027C389}). */
export type HelpArticleTagsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tags Folder template (ID: {94AA0B48-FA5A-47EE-8AC5-B6DC8027C389}). */
export type HelpArticleTagsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tags Folder template (ID: {94AA0B48-FA5A-47EE-8AC5-B6DC8027C389}). */
export type HelpArticleTagsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tags Folder template (ID: {94AA0B48-FA5A-47EE-8AC5-B6DC8027C389}). */
export type HelpArticleTagsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tags Folder template (ID: {94AA0B48-FA5A-47EE-8AC5-B6DC8027C389}). */
export type HelpArticleTagsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Article Tag/Help Article Tags Folder template (ID: {94AA0B48-FA5A-47EE-8AC5-B6DC8027C389}). */
export type HelpArticleTagsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Wildcard Page template (ID: {558F80C8-E40C-4227-A8F2-C4EFF4336BD1}). */
export type HelpArticleWildcardPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HelpArticleWildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Wildcard Page template (ID: {558F80C8-E40C-4227-A8F2-C4EFF4336BD1}). */
export type HelpArticleWildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Wildcard Page template (ID: {558F80C8-E40C-4227-A8F2-C4EFF4336BD1}). */
export type HelpArticleWildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Wildcard Page template (ID: {558F80C8-E40C-4227-A8F2-C4EFF4336BD1}). */
export type HelpArticleWildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Wildcard Page template (ID: {558F80C8-E40C-4227-A8F2-C4EFF4336BD1}). */
export type HelpArticleWildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Wildcard Page template (ID: {558F80C8-E40C-4227-A8F2-C4EFF4336BD1}). */
export type HelpArticleWildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Help Article Wildcard Page template (ID: {558F80C8-E40C-4227-A8F2-C4EFF4336BD1}). */
export type HelpArticleWildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Help Article Wildcard Page template (ID: {E4E2D58C-8533-41DE-AA6B-2A2A136421C4}). */
export type HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Wildcard Page template (ID: {E4E2D58C-8533-41DE-AA6B-2A2A136421C4}). */
export type HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Wildcard Page template (ID: {E4E2D58C-8533-41DE-AA6B-2A2A136421C4}). */
export type HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Wildcard Page template (ID: {E4E2D58C-8533-41DE-AA6B-2A2A136421C4}). */
export type HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Wildcard Page template (ID: {E4E2D58C-8533-41DE-AA6B-2A2A136421C4}). */
export type HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Wildcard Page template (ID: {E4E2D58C-8533-41DE-AA6B-2A2A136421C4}). */
export type HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Help Article Wildcard Page template (ID: {E4E2D58C-8533-41DE-AA6B-2A2A136421C4}). */
export type HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Help Articles Group Folder template (ID: {138DA230-8D86-45FF-9CC0-D47AE7F5DC00}). */
export type HelpArticlesGroupFolder = Item & _SharedPage & {
  __typename?: 'HelpArticlesGroupFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Help Articles Group Folder template (ID: {138DA230-8D86-45FF-9CC0-D47AE7F5DC00}). */
export type HelpArticlesGroupFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Help Articles Group Folder template (ID: {138DA230-8D86-45FF-9CC0-D47AE7F5DC00}). */
export type HelpArticlesGroupFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Help Articles Group Folder template (ID: {138DA230-8D86-45FF-9CC0-D47AE7F5DC00}). */
export type HelpArticlesGroupFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Help Articles Group Folder template (ID: {138DA230-8D86-45FF-9CC0-D47AE7F5DC00}). */
export type HelpArticlesGroupFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Help Articles Group Folder template (ID: {138DA230-8D86-45FF-9CC0-D47AE7F5DC00}). */
export type HelpArticlesGroupFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Help Articles Group Folder template (ID: {138DA230-8D86-45FF-9CC0-D47AE7F5DC00}). */
export type HelpArticlesGroupFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Map template (ID: {600851A8-B909-45BF-9A7C-CB9F936F38FF}). */
export type HelpTagMap = Item & {
  __typename?: 'HelpTagMap';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** helpTag (ID: {039BE011-6E13-4778-9C78-2D70989249FF}). */
  helpTag?: Maybe<LookupField>;
  /** helpTagArticles (ID: {B9A40B93-618E-437B-88A2-A2D8D3D9A0EF}). */
  helpTagArticles?: Maybe<MultilistField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Map template (ID: {600851A8-B909-45BF-9A7C-CB9F936F38FF}). */
export type HelpTagMapAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Map template (ID: {600851A8-B909-45BF-9A7C-CB9F936F38FF}). */
export type HelpTagMapChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Map template (ID: {600851A8-B909-45BF-9A7C-CB9F936F38FF}). */
export type HelpTagMapFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Map template (ID: {600851A8-B909-45BF-9A7C-CB9F936F38FF}). */
export type HelpTagMapFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Map template (ID: {600851A8-B909-45BF-9A7C-CB9F936F38FF}). */
export type HelpTagMapHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Map template (ID: {600851A8-B909-45BF-9A7C-CB9F936F38FF}). */
export type HelpTagMapIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Mappings template (ID: {C86A0167-47EF-4569-8C7C-BEF6CFC87A74}). */
export type HelpTagMappings = Item & {
  __typename?: 'HelpTagMappings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Mappings template (ID: {C86A0167-47EF-4569-8C7C-BEF6CFC87A74}). */
export type HelpTagMappingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Mappings template (ID: {C86A0167-47EF-4569-8C7C-BEF6CFC87A74}). */
export type HelpTagMappingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Mappings template (ID: {C86A0167-47EF-4569-8C7C-BEF6CFC87A74}). */
export type HelpTagMappingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Mappings template (ID: {C86A0167-47EF-4569-8C7C-BEF6CFC87A74}). */
export type HelpTagMappingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Mappings template (ID: {C86A0167-47EF-4569-8C7C-BEF6CFC87A74}). */
export type HelpTagMappingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Help Tag Map/Help Tag Mappings template (ID: {C86A0167-47EF-4569-8C7C-BEF6CFC87A74}). */
export type HelpTagMappingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Hero Banner template (ID: {94091DF0-72CE-45C5-B0DC-063F46E7BCA6}). */
export type HeroBanner = Item & {
  __typename?: 'HeroBanner';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** JSON animation. */
  backgroundAnimation?: Maybe<TextField>;
  /** backgroundImage (ID: {DDC7EF3A-14EE-401D-BCC3-2FBB7FEE5277}). */
  backgroundImage?: Maybe<ImageField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** primaryCtaLink (ID: {BB90EF84-EFD6-446F-90B7-89834473B476}). */
  primaryCtaLink?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** secondaryCtaLink (ID: {ED6AF8DA-B9DC-40B2-A34D-C62D2806DF06}). */
  secondaryCtaLink?: Maybe<TextField>;
  /** subtitle (ID: {5C9CC03A-F44F-4BF1-9A21-0C4426B19D40}). */
  subtitle?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {C15856D7-49F2-4C15-98AF-7C75A0964351}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Hero Banner template (ID: {94091DF0-72CE-45C5-B0DC-063F46E7BCA6}). */
export type HeroBannerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Hero Banner template (ID: {94091DF0-72CE-45C5-B0DC-063F46E7BCA6}). */
export type HeroBannerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Hero Banner template (ID: {94091DF0-72CE-45C5-B0DC-063F46E7BCA6}). */
export type HeroBannerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Hero Banner template (ID: {94091DF0-72CE-45C5-B0DC-063F46E7BCA6}). */
export type HeroBannerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Hero Banner template (ID: {94091DF0-72CE-45C5-B0DC-063F46E7BCA6}). */
export type HeroBannerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Hero Banner template (ID: {94091DF0-72CE-45C5-B0DC-063F46E7BCA6}). */
export type HeroBannerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight template (ID: {58942B4E-7016-41EA-9EB2-C93F027154B3}). */
export type Highlight = Item & {
  __typename?: 'Highlight';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight template (ID: {58942B4E-7016-41EA-9EB2-C93F027154B3}). */
export type HighlightAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight template (ID: {58942B4E-7016-41EA-9EB2-C93F027154B3}). */
export type HighlightChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight template (ID: {58942B4E-7016-41EA-9EB2-C93F027154B3}). */
export type HighlightFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight template (ID: {58942B4E-7016-41EA-9EB2-C93F027154B3}). */
export type HighlightFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight template (ID: {58942B4E-7016-41EA-9EB2-C93F027154B3}). */
export type HighlightHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight template (ID: {58942B4E-7016-41EA-9EB2-C93F027154B3}). */
export type HighlightIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block template (ID: {D0BBC6C3-951B-4CDC-939F-CF9D6102EF5A}). */
export type HighlightBlock = Item & {
  __typename?: 'HighlightBlock';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {18867AA6-6483-439C-B1BC-1B03071C83E1}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** heading (ID: {BFE18270-9018-4A19-885C-2386DF7A8C36}). */
  heading?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block template (ID: {D0BBC6C3-951B-4CDC-939F-CF9D6102EF5A}). */
export type HighlightBlockAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block template (ID: {D0BBC6C3-951B-4CDC-939F-CF9D6102EF5A}). */
export type HighlightBlockChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block template (ID: {D0BBC6C3-951B-4CDC-939F-CF9D6102EF5A}). */
export type HighlightBlockFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block template (ID: {D0BBC6C3-951B-4CDC-939F-CF9D6102EF5A}). */
export type HighlightBlockFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block template (ID: {D0BBC6C3-951B-4CDC-939F-CF9D6102EF5A}). */
export type HighlightBlockHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block template (ID: {D0BBC6C3-951B-4CDC-939F-CF9D6102EF5A}). */
export type HighlightBlockIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block Folder template (ID: {3369D693-DB9D-4101-A073-D72821CFD054}). */
export type HighlightBlockFolder = Item & {
  __typename?: 'HighlightBlockFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block Folder template (ID: {3369D693-DB9D-4101-A073-D72821CFD054}). */
export type HighlightBlockFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block Folder template (ID: {3369D693-DB9D-4101-A073-D72821CFD054}). */
export type HighlightBlockFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block Folder template (ID: {3369D693-DB9D-4101-A073-D72821CFD054}). */
export type HighlightBlockFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block Folder template (ID: {3369D693-DB9D-4101-A073-D72821CFD054}). */
export type HighlightBlockFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block Folder template (ID: {3369D693-DB9D-4101-A073-D72821CFD054}). */
export type HighlightBlockFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight Block/Highlight Block Folder template (ID: {3369D693-DB9D-4101-A073-D72821CFD054}). */
export type HighlightBlockFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Block Parameters Template template (ID: {491FB70D-F1BC-4CF4-A1A3-1C0FCFAF3CE5}). */
export type HighlightBlockParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'HighlightBlockParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {C903F62A-482D-4D23-9F5A-18180196A3F6}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Block Parameters Template template (ID: {491FB70D-F1BC-4CF4-A1A3-1C0FCFAF3CE5}). */
export type HighlightBlockParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Block Parameters Template template (ID: {491FB70D-F1BC-4CF4-A1A3-1C0FCFAF3CE5}). */
export type HighlightBlockParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Block Parameters Template template (ID: {491FB70D-F1BC-4CF4-A1A3-1C0FCFAF3CE5}). */
export type HighlightBlockParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Block Parameters Template template (ID: {491FB70D-F1BC-4CF4-A1A3-1C0FCFAF3CE5}). */
export type HighlightBlockParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Block Parameters Template template (ID: {491FB70D-F1BC-4CF4-A1A3-1C0FCFAF3CE5}). */
export type HighlightBlockParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Block Parameters Template template (ID: {491FB70D-F1BC-4CF4-A1A3-1C0FCFAF3CE5}). */
export type HighlightBlockParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Folder template (ID: {DD2F5E33-4AF8-4BEF-B412-D87FDB1FD362}). */
export type HighlightFolder = Item & {
  __typename?: 'HighlightFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Folder template (ID: {DD2F5E33-4AF8-4BEF-B412-D87FDB1FD362}). */
export type HighlightFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Folder template (ID: {DD2F5E33-4AF8-4BEF-B412-D87FDB1FD362}). */
export type HighlightFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Folder template (ID: {DD2F5E33-4AF8-4BEF-B412-D87FDB1FD362}). */
export type HighlightFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Folder template (ID: {DD2F5E33-4AF8-4BEF-B412-D87FDB1FD362}). */
export type HighlightFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Folder template (ID: {DD2F5E33-4AF8-4BEF-B412-D87FDB1FD362}). */
export type HighlightFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Folder template (ID: {DD2F5E33-4AF8-4BEF-B412-D87FDB1FD362}). */
export type HighlightFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Item template (ID: {7C75DB6C-F043-4193-A8DF-1309053B94D1}). */
export type HighlightItem = Item & {
  __typename?: 'HighlightItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {D8B2F696-1BE2-46A8-96B7-0B27E07A8793}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** icon (ID: {AEFDB2F3-6249-4316-8C05-D4C236204DF7}). */
  icon_aefdb2f3624943168c05d4c236204df7?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {DE54D3A1-D1EB-4239-8E9D-6CEB728B282B}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Item template (ID: {7C75DB6C-F043-4193-A8DF-1309053B94D1}). */
export type HighlightItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Item template (ID: {7C75DB6C-F043-4193-A8DF-1309053B94D1}). */
export type HighlightItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Item template (ID: {7C75DB6C-F043-4193-A8DF-1309053B94D1}). */
export type HighlightItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Item template (ID: {7C75DB6C-F043-4193-A8DF-1309053B94D1}). */
export type HighlightItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Item template (ID: {7C75DB6C-F043-4193-A8DF-1309053B94D1}). */
export type HighlightItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Highlight/Highlight Item template (ID: {7C75DB6C-F043-4193-A8DF-1309053B94D1}). */
export type HighlightItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Parameters Template template (ID: {95F66967-1263-47B8-8F8B-D98B0F2790F4}). */
export type HighlightParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'HighlightParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {CEB3DC0C-B2E0-4D9D-8468-2E269CE0878A}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Parameters Template template (ID: {95F66967-1263-47B8-8F8B-D98B0F2790F4}). */
export type HighlightParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Parameters Template template (ID: {95F66967-1263-47B8-8F8B-D98B0F2790F4}). */
export type HighlightParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Parameters Template template (ID: {95F66967-1263-47B8-8F8B-D98B0F2790F4}). */
export type HighlightParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Parameters Template template (ID: {95F66967-1263-47B8-8F8B-D98B0F2790F4}). */
export type HighlightParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Parameters Template template (ID: {95F66967-1263-47B8-8F8B-D98B0F2790F4}). */
export type HighlightParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Highlight Parameters Template template (ID: {95F66967-1263-47B8-8F8B-D98B0F2790F4}). */
export type HighlightParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Home template (ID: {E9272B0E-3BBA-445F-8634-224D68966BB9}). */
export type Home = Item & {
  __typename?: 'Home';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Home template (ID: {E9272B0E-3BBA-445F-8634-224D68966BB9}). */
export type HomeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Home template (ID: {E9272B0E-3BBA-445F-8634-224D68966BB9}). */
export type HomeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Home template (ID: {E9272B0E-3BBA-445F-8634-224D68966BB9}). */
export type HomeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Home template (ID: {E9272B0E-3BBA-445F-8634-224D68966BB9}). */
export type HomeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Home template (ID: {E9272B0E-3BBA-445F-8634-224D68966BB9}). */
export type HomeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/Home template (ID: {E9272B0E-3BBA-445F-8634-224D68966BB9}). */
export type HomeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Home Page template (ID: {08080891-843F-41FD-8C98-C99391273514}). */
export type HomePage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HomePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Home Page template (ID: {08080891-843F-41FD-8C98-C99391273514}). */
export type HomePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Home Page template (ID: {08080891-843F-41FD-8C98-C99391273514}). */
export type HomePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Home Page template (ID: {08080891-843F-41FD-8C98-C99391273514}). */
export type HomePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Home Page template (ID: {08080891-843F-41FD-8C98-C99391273514}). */
export type HomePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Home Page template (ID: {08080891-843F-41FD-8C98-C99391273514}). */
export type HomePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Home Page template (ID: {08080891-843F-41FD-8C98-C99391273514}). */
export type HomePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Home Page template (ID: {0D3963A8-171D-4080-B5F8-08618578B631}). */
export type HomePage_0d3963a8171d4080b5f808618578b631 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Home Page template (ID: {0D3963A8-171D-4080-B5F8-08618578B631}). */
export type HomePage_0d3963a8171d4080b5f808618578b631AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Home Page template (ID: {0D3963A8-171D-4080-B5F8-08618578B631}). */
export type HomePage_0d3963a8171d4080b5f808618578b631ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Home Page template (ID: {0D3963A8-171D-4080-B5F8-08618578B631}). */
export type HomePage_0d3963a8171d4080b5f808618578b631FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Home Page template (ID: {0D3963A8-171D-4080-B5F8-08618578B631}). */
export type HomePage_0d3963a8171d4080b5f808618578b631FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Home Page template (ID: {0D3963A8-171D-4080-B5F8-08618578B631}). */
export type HomePage_0d3963a8171d4080b5f808618578b631HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Home Page template (ID: {0D3963A8-171D-4080-B5F8-08618578B631}). */
export type HomePage_0d3963a8171d4080b5f808618578b631IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Home Page template (ID: {6D95C7D9-46C7-4A70-BE07-304CC73A2010}). */
export type HomePage_6d95c7d946c74a70be07304cc73a2010 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Home Page template (ID: {6D95C7D9-46C7-4A70-BE07-304CC73A2010}). */
export type HomePage_6d95c7d946c74a70be07304cc73a2010AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Home Page template (ID: {6D95C7D9-46C7-4A70-BE07-304CC73A2010}). */
export type HomePage_6d95c7d946c74a70be07304cc73a2010ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Home Page template (ID: {6D95C7D9-46C7-4A70-BE07-304CC73A2010}). */
export type HomePage_6d95c7d946c74a70be07304cc73a2010FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Home Page template (ID: {6D95C7D9-46C7-4A70-BE07-304CC73A2010}). */
export type HomePage_6d95c7d946c74a70be07304cc73a2010FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Home Page template (ID: {6D95C7D9-46C7-4A70-BE07-304CC73A2010}). */
export type HomePage_6d95c7d946c74a70be07304cc73a2010HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Home Page template (ID: {6D95C7D9-46C7-4A70-BE07-304CC73A2010}). */
export type HomePage_6d95c7d946c74a70be07304cc73a2010IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Home Page template (ID: {B407F259-B4E3-4C7D-B9A0-6E8907A56B17}). */
export type HomePage_B407f259b4e34c7db9a06e8907a56b17 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Home Page template (ID: {B407F259-B4E3-4C7D-B9A0-6E8907A56B17}). */
export type HomePage_B407f259b4e34c7db9a06e8907a56b17AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Home Page template (ID: {B407F259-B4E3-4C7D-B9A0-6E8907A56B17}). */
export type HomePage_B407f259b4e34c7db9a06e8907a56b17ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Home Page template (ID: {B407F259-B4E3-4C7D-B9A0-6E8907A56B17}). */
export type HomePage_B407f259b4e34c7db9a06e8907a56b17FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Home Page template (ID: {B407F259-B4E3-4C7D-B9A0-6E8907A56B17}). */
export type HomePage_B407f259b4e34c7db9a06e8907a56b17FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Home Page template (ID: {B407F259-B4E3-4C7D-B9A0-6E8907A56B17}). */
export type HomePage_B407f259b4e34c7db9a06e8907a56b17HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Home Page template (ID: {B407F259-B4E3-4C7D-B9A0-6E8907A56B17}). */
export type HomePage_B407f259b4e34c7db9a06e8907a56b17IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Home Page template (ID: {CDE13C51-062D-426B-9556-9E8202EDC963}). */
export type HomePage_Cde13c51062d426b95569e8202edc963 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HomePage_cde13c51062d426b95569e8202edc963';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Home Page template (ID: {CDE13C51-062D-426B-9556-9E8202EDC963}). */
export type HomePage_Cde13c51062d426b95569e8202edc963AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Home Page template (ID: {CDE13C51-062D-426B-9556-9E8202EDC963}). */
export type HomePage_Cde13c51062d426b95569e8202edc963ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Home Page template (ID: {CDE13C51-062D-426B-9556-9E8202EDC963}). */
export type HomePage_Cde13c51062d426b95569e8202edc963FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Home Page template (ID: {CDE13C51-062D-426B-9556-9E8202EDC963}). */
export type HomePage_Cde13c51062d426b95569e8202edc963FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Home Page template (ID: {CDE13C51-062D-426B-9556-9E8202EDC963}). */
export type HomePage_Cde13c51062d426b95569e8202edc963HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Home Page template (ID: {CDE13C51-062D-426B-9556-9E8202EDC963}). */
export type HomePage_Cde13c51062d426b95569e8202edc963IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Home Page template (ID: {DE935328-3A3E-41C4-95BA-386AED0540C6}). */
export type HomePage_De9353283a3e41c495ba386aed0540c6 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Home Page template (ID: {DE935328-3A3E-41C4-95BA-386AED0540C6}). */
export type HomePage_De9353283a3e41c495ba386aed0540c6AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Home Page template (ID: {DE935328-3A3E-41C4-95BA-386AED0540C6}). */
export type HomePage_De9353283a3e41c495ba386aed0540c6ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Home Page template (ID: {DE935328-3A3E-41C4-95BA-386AED0540C6}). */
export type HomePage_De9353283a3e41c495ba386aed0540c6FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Home Page template (ID: {DE935328-3A3E-41C4-95BA-386AED0540C6}). */
export type HomePage_De9353283a3e41c495ba386aed0540c6FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Home Page template (ID: {DE935328-3A3E-41C4-95BA-386AED0540C6}). */
export type HomePage_De9353283a3e41c495ba386aed0540c6HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Home Page template (ID: {DE935328-3A3E-41C4-95BA-386AED0540C6}). */
export type HomePage_De9353283a3e41c495ba386aed0540c6IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IAllowEmpty template (ID: {7522F99E-0FFF-4427-92F2-1B6142334358}). */
export type IAllowEmpty = {
  /** AllowEmpty (ID: {C91E098F-A65C-4625-B166-0ED004ADAA75}). */
  allowEmpty?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IBaseVariantDefinition template (ID: {C2EB6329-D47F-46B6-9206-2EE96487EB93}). */
export type IBaseVariantDefinition = {
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Search/IBoosting template (ID: {0F5E11DB-BFAF-400F-BFFE-0FDA575DC3E7}). */
export type IBoosting = {
  /** Rule (ID: {0F628FD3-A28C-4DA7-968B-DCE9F3B71B5A}). */
  rule?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/ICacheable template (ID: {6DA8A00F-473E-487D-BEFE-6834350D5B67}). */
export type ICacheable = {
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/ICompatibleRenderings template (ID: {05D3365F-0159-470D-8706-3CE3465DABAD}). */
export type ICompatibleRenderings = {
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/Rendering Parameters/IComponentVariant template (ID: {A9F8A74E-5F7D-4506-8661-B08E7B9A7B91}). */
export type IComponentVariant = {
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IControlType template (ID: {EEEBE923-8528-4D0D-B70A-F2132A5A7A4D}). */
export type IControlType = {
  /** Type (ID: {62CA1C9E-71A4-465F-835E-55BDA7BB270B}). */
  type?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Dynamic Placeholders/Rendering Parameters/IDynamicPlaceholder template (ID: {5C74E985-E055-43FF-B28C-DB6C6A6450A2}). */
export type IDynamicPlaceholder = {
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents data source templates template (ID: {30869218-C3AD-40F9-BCFF-6837127ECD8F}). */
export type IfEaaSComponentsDataSourceTemplates = {
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/FEaaS/IFEaaSComponents editor script URL template (ID: {2AF2DC09-057F-48C2-A9F4-9779ADF83659}). */
export type IfEaaSComponentsEditorScriptUrl = {
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/IFrame template (ID: {8E1F74DB-15C0-43F3-85F0-86E4651DF912}). */
export type IFrame = Item & {
  __typename?: 'IFrame';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Link (ID: {4B737984-1EAC-4E50-8DD1-883566FA7BDE}). */
  link?: Maybe<LinkField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/IFrame template (ID: {8E1F74DB-15C0-43F3-85F0-86E4651DF912}). */
export type IFrameAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/IFrame template (ID: {8E1F74DB-15C0-43F3-85F0-86E4651DF912}). */
export type IFrameChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/IFrame template (ID: {8E1F74DB-15C0-43F3-85F0-86E4651DF912}). */
export type IFrameFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/IFrame template (ID: {8E1F74DB-15C0-43F3-85F0-86E4651DF912}). */
export type IFrameFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/IFrame template (ID: {8E1F74DB-15C0-43F3-85F0-86E4651DF912}). */
export type IFrameHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/IFrame template (ID: {8E1F74DB-15C0-43F3-85F0-86E4651DF912}). */
export type IFrameIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/IFrame Folder template (ID: {ED1B1BA7-4267-466F-A57A-8D96D2CB979D}). */
export type IFrameFolder = Item & {
  __typename?: 'IFrameFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/IFrame Folder template (ID: {ED1B1BA7-4267-466F-A57A-8D96D2CB979D}). */
export type IFrameFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/IFrame Folder template (ID: {ED1B1BA7-4267-466F-A57A-8D96D2CB979D}). */
export type IFrameFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/IFrame Folder template (ID: {ED1B1BA7-4267-466F-A57A-8D96D2CB979D}). */
export type IFrameFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/IFrame Folder template (ID: {ED1B1BA7-4267-466F-A57A-8D96D2CB979D}). */
export type IFrameFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/IFrame Folder template (ID: {ED1B1BA7-4267-466F-A57A-8D96D2CB979D}). */
export type IFrameFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/IFrame Folder template (ID: {ED1B1BA7-4267-466F-A57A-8D96D2CB979D}). */
export type IFrameFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/IFrame Folder template (ID: {21366EBF-5FDA-4FF4-A4DA-C7B1F4D7ADA2}). */
export type IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = Item & {
  __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/IFrame Folder template (ID: {21366EBF-5FDA-4FF4-A4DA-C7B1F4D7ADA2}). */
export type IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/IFrame Folder template (ID: {21366EBF-5FDA-4FF4-A4DA-C7B1F4D7ADA2}). */
export type IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/IFrame Folder template (ID: {21366EBF-5FDA-4FF4-A4DA-C7B1F4D7ADA2}). */
export type IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/IFrame Folder template (ID: {21366EBF-5FDA-4FF4-A4DA-C7B1F4D7ADA2}). */
export type IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/IFrame Folder template (ID: {21366EBF-5FDA-4FF4-A4DA-C7B1F4D7ADA2}). */
export type IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/IFrame Folder template (ID: {21366EBF-5FDA-4FF4-A4DA-C7B1F4D7ADA2}). */
export type IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/IFrame Parameters Template template (ID: {C0933A5E-F22D-4F2C-8234-23C93FA7CE6D}). */
export type IFrameParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'IFrameParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** If checked, URL parameters of page will be passed into IFrame. */
  passUrlParameters?: Maybe<CheckboxField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/IFrame Parameters Template template (ID: {C0933A5E-F22D-4F2C-8234-23C93FA7CE6D}). */
export type IFrameParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/IFrame Parameters Template template (ID: {C0933A5E-F22D-4F2C-8234-23C93FA7CE6D}). */
export type IFrameParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/IFrame Parameters Template template (ID: {C0933A5E-F22D-4F2C-8234-23C93FA7CE6D}). */
export type IFrameParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/IFrame Parameters Template template (ID: {C0933A5E-F22D-4F2C-8234-23C93FA7CE6D}). */
export type IFrameParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/IFrame Parameters Template template (ID: {C0933A5E-F22D-4F2C-8234-23C93FA7CE6D}). */
export type IFrameParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/IFrame Parameters Template template (ID: {C0933A5E-F22D-4F2C-8234-23C93FA7CE6D}). */
export type IFrameParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/IFrame template (ID: {0DA12D47-6DE2-4DFE-B4D0-F513489BFEA1}). */
export type IFrame_0da12d476de24dfeb4d0f513489bfea1 = GridParameters & ICacheable & IRenderingId & ISplitter & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/IFrame template (ID: {0DA12D47-6DE2-4DFE-B4D0-F513489BFEA1}). */
export type IFrame_0da12d476de24dfeb4d0f513489bfea1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/IFrame template (ID: {0DA12D47-6DE2-4DFE-B4D0-F513489BFEA1}). */
export type IFrame_0da12d476de24dfeb4d0f513489bfea1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/IFrame template (ID: {0DA12D47-6DE2-4DFE-B4D0-F513489BFEA1}). */
export type IFrame_0da12d476de24dfeb4d0f513489bfea1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/IFrame template (ID: {0DA12D47-6DE2-4DFE-B4D0-F513489BFEA1}). */
export type IFrame_0da12d476de24dfeb4d0f513489bfea1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/IFrame template (ID: {0DA12D47-6DE2-4DFE-B4D0-F513489BFEA1}). */
export type IFrame_0da12d476de24dfeb4d0f513489bfea1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/IFrame template (ID: {0DA12D47-6DE2-4DFE-B4D0-F513489BFEA1}). */
export type IFrame_0da12d476de24dfeb4d0f513489bfea1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/IFrame/IFrame template (ID: {88A6F65F-2B78-491B-B377-0B06E48883E1}). */
export type IFrame_88a6f65f2b78491bb3770b06e48883e1 = Item & {
  __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** source (ID: {DCE4F935-9356-4348-8639-C3ED45896090}). */
  source?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {0340C506-E5A2-474C-8450-FDD33A151240}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/IFrame/IFrame template (ID: {88A6F65F-2B78-491B-B377-0B06E48883E1}). */
export type IFrame_88a6f65f2b78491bb3770b06e48883e1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/IFrame/IFrame template (ID: {88A6F65F-2B78-491B-B377-0B06E48883E1}). */
export type IFrame_88a6f65f2b78491bb3770b06e48883e1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/IFrame/IFrame template (ID: {88A6F65F-2B78-491B-B377-0B06E48883E1}). */
export type IFrame_88a6f65f2b78491bb3770b06e48883e1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/IFrame/IFrame template (ID: {88A6F65F-2B78-491B-B377-0B06E48883E1}). */
export type IFrame_88a6f65f2b78491bb3770b06e48883e1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/IFrame/IFrame template (ID: {88A6F65F-2B78-491B-B377-0B06E48883E1}). */
export type IFrame_88a6f65f2b78491bb3770b06e48883e1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/IFrame/IFrame template (ID: {88A6F65F-2B78-491B-B377-0B06E48883E1}). */
export type IFrame_88a6f65f2b78491bb3770b06e48883e1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/IIcon template (ID: {7E97E7AC-0C9F-4EBF-B106-CCBFE44985A4}). */
export type IIcon = {
  /** Icon (ID: {39816442-74D9-4CE2-BEB3-128B204EFD40}). */
  icon_3981644274d94ce2beb3128b204efd40?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/HTML Includes/ILocation template (ID: {85E83B3A-3474-4AED-A6DE-A219BD9E39B8}). */
export type ILocation = {
  /** Location (ID: {F4DCDC00-1A6E-4D2C-B586-54EF20326FB6}). */
  location?: Maybe<LookupField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPaginable template (ID: {5BDF5EFE-B334-407B-BD42-ABFF8595B691}). */
export type IPaginable = {
  /** Offset (ID: {778DF306-72BF-4ECA-8DED-0F0A18A5F9B4}). */
  offset?: Maybe<IntegerField>;
  /** PageSize (ID: {C5A5C905-855F-4DA9-941A-2C20845D0473}). */
  pageSize?: Maybe<IntegerField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/IPagination template (ID: {5E680478-0705-4452-A14B-42B945EB1AB6}). */
export type IPagination = {
  /** ListSignature (ID: {3E44E786-672E-4DC0-86A0-FFF0D99A3471}). */
  listSignature?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/IPoi template (ID: {7F018744-BC34-4A42-A380-C7259E744843}). Also implements _Searchable. */
export type IPoi = {
  /** Deprecated-Latitude (ID: {94969C59-C4B8-43ED-9C92-3FBF930C0ACF}). */
  deprecatedLatitude?: Maybe<NumberField>;
  /** Deprecated-Longitude (ID: {8C1AEA63-2E5E-4FEE-B413-D3B1E050DD26}). */
  deprecatedLongitude?: Maybe<NumberField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Markup Decorator/Rendering Parameters/IRenderingId template (ID: {3DB3EB10-F8D0-4CC9-BE26-18CE7B139EC8}). */
export type IRenderingId = {
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/ISplitter template (ID: {82D2FED1-E9C5-489B-A3AB-0FD1B32490F1}). */
export type ISplitter = {
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Rendering Parameters/IStyling template (ID: {D959F476-2A2C-40C6-81F5-FB75342BBFB9}). */
export type IStyling = {
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Variants/IVariantDefinition template (ID: {CC9C2B37-A5FD-4F6E-B6E0-63BDECE3FF45}). Also implements IBaseVariantDefinition, ICompatibleRenderings. */
export type IVariantDefinition = {
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** Provide the field name of the target item. This class is added to the list and navigation items markup (li HTML element). This link is used to override all links when the Is link, Is prefix link, or Is suffix link check boxes are selected. */
  linkField?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon template (ID: {8417D24A-A3E9-4D67-A804-904D2E3480DF}). */
export type Icon = Item & {
  __typename?: 'Icon';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon template (ID: {8417D24A-A3E9-4D67-A804-904D2E3480DF}). */
export type IconAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon template (ID: {8417D24A-A3E9-4D67-A804-904D2E3480DF}). */
export type IconChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon template (ID: {8417D24A-A3E9-4D67-A804-904D2E3480DF}). */
export type IconFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon template (ID: {8417D24A-A3E9-4D67-A804-904D2E3480DF}). */
export type IconFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon template (ID: {8417D24A-A3E9-4D67-A804-904D2E3480DF}). */
export type IconHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon template (ID: {8417D24A-A3E9-4D67-A804-904D2E3480DF}). */
export type IconIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon Folder template (ID: {44D3A1E5-8535-4F81-B666-33858CF8769C}). */
export type IconFolder = Item & {
  __typename?: 'IconFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon Folder template (ID: {44D3A1E5-8535-4F81-B666-33858CF8769C}). */
export type IconFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon Folder template (ID: {44D3A1E5-8535-4F81-B666-33858CF8769C}). */
export type IconFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon Folder template (ID: {44D3A1E5-8535-4F81-B666-33858CF8769C}). */
export type IconFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon Folder template (ID: {44D3A1E5-8535-4F81-B666-33858CF8769C}). */
export type IconFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon Folder template (ID: {44D3A1E5-8535-4F81-B666-33858CF8769C}). */
export type IconFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Icons/Icon Folder template (ID: {44D3A1E5-8535-4F81-B666-33858CF8769C}). */
export type IconFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image template (ID: {BB8A85AB-1F6D-4518-8772-1C9F4F8DAC18}). */
export type Image = Item & {
  __typename?: 'Image';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Image (ID: {EBE4FDEF-16D5-4D19-833C-24A241628A3A}). */
  image?: Maybe<ImageField>;
  /** ImageCaption (ID: {4F52B258-7B05-4D6C-8C96-2E2EAC46DC1B}). */
  imageCaption?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** TargetUrl (ID: {54CAB1BA-53D3-4CE4-AB7E-F8C17596AA47}). */
  targetUrl?: Maybe<LinkField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image template (ID: {BB8A85AB-1F6D-4518-8772-1C9F4F8DAC18}). */
export type ImageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image template (ID: {BB8A85AB-1F6D-4518-8772-1C9F4F8DAC18}). */
export type ImageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image template (ID: {BB8A85AB-1F6D-4518-8772-1C9F4F8DAC18}). */
export type ImageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image template (ID: {BB8A85AB-1F6D-4518-8772-1C9F4F8DAC18}). */
export type ImageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image template (ID: {BB8A85AB-1F6D-4518-8772-1C9F4F8DAC18}). */
export type ImageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image template (ID: {BB8A85AB-1F6D-4518-8772-1C9F4F8DAC18}). */
export type ImageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ImageField = ItemField & {
  __typename?: 'ImageField';
  /** The alternate text for the image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The description of the media item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The extension of the media item (for example, 'jpg', 'gif'). */
  extension?: Maybe<Scalars['String']['output']>;
  /** Height of the image at full size. */
  height?: Maybe<Scalars['String']['output']>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The keywords of the media item. */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the media item (for example, 'image/jpeg'). */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** The size, in bytes, of the media item. */
  size?: Maybe<Scalars['Int']['output']>;
  /** The URL to the media item. */
  src?: Maybe<Scalars['String']['output']>;
  /** The title of the media item. */
  title?: Maybe<Scalars['String']['output']>;
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
  /** Width of the image at full size. */
  width?: Maybe<Scalars['String']['output']>;
};


export type ImageFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ImageFieldSrcArgs = {
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image Folder template (ID: {861D0715-E397-4114-870A-7FBB1FE8C9D6}). */
export type ImageFolder = Item & {
  __typename?: 'ImageFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image Folder template (ID: {861D0715-E397-4114-870A-7FBB1FE8C9D6}). */
export type ImageFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image Folder template (ID: {861D0715-E397-4114-870A-7FBB1FE8C9D6}). */
export type ImageFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image Folder template (ID: {861D0715-E397-4114-870A-7FBB1FE8C9D6}). */
export type ImageFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image Folder template (ID: {861D0715-E397-4114-870A-7FBB1FE8C9D6}). */
export type ImageFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image Folder template (ID: {861D0715-E397-4114-870A-7FBB1FE8C9D6}). */
export type ImageFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Image Folder template (ID: {861D0715-E397-4114-870A-7FBB1FE8C9D6}). */
export type ImageFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image Folder template (ID: {EDC00E86-CEF2-4D0C-BFA2-64460BECC323}). */
export type ImageFolder_Edc00e86cef24d0cbfa264460becc323 = Item & {
  __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image Folder template (ID: {EDC00E86-CEF2-4D0C-BFA2-64460BECC323}). */
export type ImageFolder_Edc00e86cef24d0cbfa264460becc323AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image Folder template (ID: {EDC00E86-CEF2-4D0C-BFA2-64460BECC323}). */
export type ImageFolder_Edc00e86cef24d0cbfa264460becc323ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image Folder template (ID: {EDC00E86-CEF2-4D0C-BFA2-64460BECC323}). */
export type ImageFolder_Edc00e86cef24d0cbfa264460becc323FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image Folder template (ID: {EDC00E86-CEF2-4D0C-BFA2-64460BECC323}). */
export type ImageFolder_Edc00e86cef24d0cbfa264460becc323FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image Folder template (ID: {EDC00E86-CEF2-4D0C-BFA2-64460BECC323}). */
export type ImageFolder_Edc00e86cef24d0cbfa264460becc323HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image Folder template (ID: {EDC00E86-CEF2-4D0C-BFA2-64460BECC323}). */
export type ImageFolder_Edc00e86cef24d0cbfa264460becc323IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image Folder template (ID: {F7A45276-87F1-4EA5-BF25-E3C7CB7AA993}). */
export type ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993 = Item & {
  __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image Folder template (ID: {F7A45276-87F1-4EA5-BF25-E3C7CB7AA993}). */
export type ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image Folder template (ID: {F7A45276-87F1-4EA5-BF25-E3C7CB7AA993}). */
export type ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image Folder template (ID: {F7A45276-87F1-4EA5-BF25-E3C7CB7AA993}). */
export type ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image Folder template (ID: {F7A45276-87F1-4EA5-BF25-E3C7CB7AA993}). */
export type ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image Folder template (ID: {F7A45276-87F1-4EA5-BF25-E3C7CB7AA993}). */
export type ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image Folder template (ID: {F7A45276-87F1-4EA5-BF25-E3C7CB7AA993}). */
export type ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/ImageParametersTemplate template (ID: {CF309BD7-EE93-47B6-A5BA-78D2DEC8F548}). */
export type ImageParametersTemplate = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'ImageParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/ImageParametersTemplate template (ID: {CF309BD7-EE93-47B6-A5BA-78D2DEC8F548}). */
export type ImageParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/ImageParametersTemplate template (ID: {CF309BD7-EE93-47B6-A5BA-78D2DEC8F548}). */
export type ImageParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/ImageParametersTemplate template (ID: {CF309BD7-EE93-47B6-A5BA-78D2DEC8F548}). */
export type ImageParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/ImageParametersTemplate template (ID: {CF309BD7-EE93-47B6-A5BA-78D2DEC8F548}). */
export type ImageParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/ImageParametersTemplate template (ID: {CF309BD7-EE93-47B6-A5BA-78D2DEC8F548}). */
export type ImageParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/ImageParametersTemplate template (ID: {CF309BD7-EE93-47B6-A5BA-78D2DEC8F548}). */
export type ImageParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image template (ID: {83BC563C-6320-4900-92F8-204BFF81586A}). */
export type Image_83bc563c6320490092f8204bff81586a = Item & {
  __typename?: 'Image_83bc563c6320490092f8204bff81586a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {976EE8C2-4048-48E2-925C-6B807EB52087}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image template (ID: {83BC563C-6320-4900-92F8-204BFF81586A}). */
export type Image_83bc563c6320490092f8204bff81586aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image template (ID: {83BC563C-6320-4900-92F8-204BFF81586A}). */
export type Image_83bc563c6320490092f8204bff81586aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image template (ID: {83BC563C-6320-4900-92F8-204BFF81586A}). */
export type Image_83bc563c6320490092f8204bff81586aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image template (ID: {83BC563C-6320-4900-92F8-204BFF81586A}). */
export type Image_83bc563c6320490092f8204bff81586aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image template (ID: {83BC563C-6320-4900-92F8-204BFF81586A}). */
export type Image_83bc563c6320490092f8204bff81586aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Image/Image template (ID: {83BC563C-6320-4900-92F8-204BFF81586A}). */
export type Image_83bc563c6320490092f8204bff81586aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Rendering Parameters/Image template (ID: {15185B0E-6418-4449-9F93-4FF03B7EE032}). */
export type Image_15185b0e641844499f934ff03b7ee032 = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Image_15185b0e641844499f934ff03b7ee032';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Rendering Parameters/Image template (ID: {15185B0E-6418-4449-9F93-4FF03B7EE032}). */
export type Image_15185b0e641844499f934ff03b7ee032AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Rendering Parameters/Image template (ID: {15185B0E-6418-4449-9F93-4FF03B7EE032}). */
export type Image_15185b0e641844499f934ff03b7ee032ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Rendering Parameters/Image template (ID: {15185B0E-6418-4449-9F93-4FF03B7EE032}). */
export type Image_15185b0e641844499f934ff03b7ee032FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Rendering Parameters/Image template (ID: {15185B0E-6418-4449-9F93-4FF03B7EE032}). */
export type Image_15185b0e641844499f934ff03b7ee032FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Rendering Parameters/Image template (ID: {15185B0E-6418-4449-9F93-4FF03B7EE032}). */
export type Image_15185b0e641844499f934ff03b7ee032HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Rendering Parameters/Image template (ID: {15185B0E-6418-4449-9F93-4FF03B7EE032}). */
export type Image_15185b0e641844499f934ff03b7ee032IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image template (ID: {D885DF8C-B2D6-4007-B34B-2BBAFB527304}). */
export type Image_D885df8cb2d64007b34b2bbafb527304 = Item & {
  __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Image (ID: {57CAF172-CE57-4E48-B3A1-46F8AEA71C08}). */
  image?: Maybe<ImageField>;
  /** ImageCaption (ID: {4D7B05D0-0300-486F-8F87-57DE34A9B793}). */
  imageCaption?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** TargetUrl (ID: {75FBF1B1-E7C5-494B-9633-693909F79425}). */
  targetUrl?: Maybe<LinkField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image template (ID: {D885DF8C-B2D6-4007-B34B-2BBAFB527304}). */
export type Image_D885df8cb2d64007b34b2bbafb527304AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image template (ID: {D885DF8C-B2D6-4007-B34B-2BBAFB527304}). */
export type Image_D885df8cb2d64007b34b2bbafb527304ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image template (ID: {D885DF8C-B2D6-4007-B34B-2BBAFB527304}). */
export type Image_D885df8cb2d64007b34b2bbafb527304FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image template (ID: {D885DF8C-B2D6-4007-B34B-2BBAFB527304}). */
export type Image_D885df8cb2d64007b34b2bbafb527304FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image template (ID: {D885DF8C-B2D6-4007-B34B-2BBAFB527304}). */
export type Image_D885df8cb2d64007b34b2bbafb527304HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Media/Image template (ID: {D885DF8C-B2D6-4007-B34B-2BBAFB527304}). */
export type Image_D885df8cb2d64007b34b2bbafb527304IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics template (ID: {10EE1026-19A8-4439-A850-E6BD4099ADD2}). */
export type Infographics = Item & {
  __typename?: 'Infographics';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** id (ID: {127003A3-A30B-4C88-8123-4CDA8F5A8C2E}). */
  id_127003a3a30b4c8881234cda8f5a8c2e?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** source (ID: {EECDCE5C-09E3-4050-A204-767D4A0865F8}). */
  source?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {3C83A4F9-77CF-43FB-9688-161F52C8F3C1}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics template (ID: {10EE1026-19A8-4439-A850-E6BD4099ADD2}). */
export type InfographicsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics template (ID: {10EE1026-19A8-4439-A850-E6BD4099ADD2}). */
export type InfographicsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics template (ID: {10EE1026-19A8-4439-A850-E6BD4099ADD2}). */
export type InfographicsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics template (ID: {10EE1026-19A8-4439-A850-E6BD4099ADD2}). */
export type InfographicsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics template (ID: {10EE1026-19A8-4439-A850-E6BD4099ADD2}). */
export type InfographicsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics template (ID: {10EE1026-19A8-4439-A850-E6BD4099ADD2}). */
export type InfographicsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics Folder template (ID: {83715138-FB69-466B-8C43-5BEDEF992920}). */
export type InfographicsFolder = Item & {
  __typename?: 'InfographicsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics Folder template (ID: {83715138-FB69-466B-8C43-5BEDEF992920}). */
export type InfographicsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics Folder template (ID: {83715138-FB69-466B-8C43-5BEDEF992920}). */
export type InfographicsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics Folder template (ID: {83715138-FB69-466B-8C43-5BEDEF992920}). */
export type InfographicsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics Folder template (ID: {83715138-FB69-466B-8C43-5BEDEF992920}). */
export type InfographicsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics Folder template (ID: {83715138-FB69-466B-8C43-5BEDEF992920}). */
export type InfographicsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Infographics/Infographics Folder template (ID: {83715138-FB69-466B-8C43-5BEDEF992920}). */
export type InfographicsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {64BD7181-187A-41EB-9BC3-FACE91FCA288}). */
export type InputValidationStep = Item & _Validation & {
  __typename?: 'InputValidationStep';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {64BD7181-187A-41EB-9BC3-FACE91FCA288}). */
export type InputValidationStepAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {64BD7181-187A-41EB-9BC3-FACE91FCA288}). */
export type InputValidationStepChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {64BD7181-187A-41EB-9BC3-FACE91FCA288}). */
export type InputValidationStepFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {64BD7181-187A-41EB-9BC3-FACE91FCA288}). */
export type InputValidationStepFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {64BD7181-187A-41EB-9BC3-FACE91FCA288}). */
export type InputValidationStepHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {64BD7181-187A-41EB-9BC3-FACE91FCA288}). */
export type InputValidationStepIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {088928CF-558E-40EC-87F3-342AA9E66757}). */
export type InputValidationStep_088928cf558e40ec87f3342aa9e66757 = Item & _Validation & {
  __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {088928CF-558E-40EC-87F3-342AA9E66757}). */
export type InputValidationStep_088928cf558e40ec87f3342aa9e66757AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {088928CF-558E-40EC-87F3-342AA9E66757}). */
export type InputValidationStep_088928cf558e40ec87f3342aa9e66757ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {088928CF-558E-40EC-87F3-342AA9E66757}). */
export type InputValidationStep_088928cf558e40ec87f3342aa9e66757FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {088928CF-558E-40EC-87F3-342AA9E66757}). */
export type InputValidationStep_088928cf558e40ec87f3342aa9e66757FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {088928CF-558E-40EC-87F3-342AA9E66757}). */
export type InputValidationStep_088928cf558e40ec87f3342aa9e66757HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {088928CF-558E-40EC-87F3-342AA9E66757}). */
export type InputValidationStep_088928cf558e40ec87f3342aa9e66757IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {9EDED2F7-F847-4893-8A0B-F69E7FCF3593}). */
export type InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = Item & _Validation & {
  __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {9EDED2F7-F847-4893-8A0B-F69E7FCF3593}). */
export type InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {9EDED2F7-F847-4893-8A0B-F69E7FCF3593}). */
export type InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {9EDED2F7-F847-4893-8A0B-F69E7FCF3593}). */
export type InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {9EDED2F7-F847-4893-8A0B-F69E7FCF3593}). */
export type InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {9EDED2F7-F847-4893-8A0B-F69E7FCF3593}). */
export type InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/InputValidationStep template (ID: {9EDED2F7-F847-4893-8A0B-F69E7FCF3593}). */
export type InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {D028FEF2-BABF-4AD1-BBE7-4D62A977992F}). */
export type InputValidationStep_D028fef2babf4ad1bbe74d62a977992f = Item & _Validation & {
  __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {D028FEF2-BABF-4AD1-BBE7-4D62A977992F}). */
export type InputValidationStep_D028fef2babf4ad1bbe74d62a977992fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {D028FEF2-BABF-4AD1-BBE7-4D62A977992F}). */
export type InputValidationStep_D028fef2babf4ad1bbe74d62a977992fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {D028FEF2-BABF-4AD1-BBE7-4D62A977992F}). */
export type InputValidationStep_D028fef2babf4ad1bbe74d62a977992fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {D028FEF2-BABF-4AD1-BBE7-4D62A977992F}). */
export type InputValidationStep_D028fef2babf4ad1bbe74d62a977992fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {D028FEF2-BABF-4AD1-BBE7-4D62A977992F}). */
export type InputValidationStep_D028fef2babf4ad1bbe74d62a977992fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/InputValidationStep template (ID: {D028FEF2-BABF-4AD1-BBE7-4D62A977992F}). */
export type InputValidationStep_D028fef2babf4ad1bbe74d62a977992fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/IntegerFacet template (ID: {CD7A8A06-AA77-45E9-A585-DA9C4686B129}). */
export type IntegerFacet = Facet & Item & {
  __typename?: 'IntegerFacet';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Client Side Handle (ID: {7F42ED80-33F0-4C98-A1E7-B15BE7551C36}). */
  clientSideHandle?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayName (ID: {5DE17054-0141-4E58-935B-FEC623A60806}). */
  displayName_5de1705401414e58935bfec623a60806?: Maybe<TextField>;
  /** Enabled (ID: {3D0FE806-D0E3-4254-96BE-A60899C7D2E6}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Global (ID: {182BD0F4-C902-4A19-A1BA-D189CAA18E1B}). */
  global?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Minimum Number of Items (ID: {8A3AC1B8-8CC1-4DD4-8766-9803F1601741}). */
  minimumNumberOfItems?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {31CA077F-EF38-4980-8A24-05408031B2BC}). */
  name_31ca077fef3849808a2405408031b2bc?: Maybe<TextField>;
  /** Parameters (ID: {0E23BB51-C071-41B5-9D83-AC410B89B85A}). */
  parameters?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {FAE92C1E-9E2C-4209-89EB-C256D55E3D7F}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/IntegerFacet template (ID: {CD7A8A06-AA77-45E9-A585-DA9C4686B129}). */
export type IntegerFacetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/IntegerFacet template (ID: {CD7A8A06-AA77-45E9-A585-DA9C4686B129}). */
export type IntegerFacetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/IntegerFacet template (ID: {CD7A8A06-AA77-45E9-A585-DA9C4686B129}). */
export type IntegerFacetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/IntegerFacet template (ID: {CD7A8A06-AA77-45E9-A585-DA9C4686B129}). */
export type IntegerFacetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/IntegerFacet template (ID: {CD7A8A06-AA77-45E9-A585-DA9C4686B129}). */
export type IntegerFacetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/IntegerFacet template (ID: {CD7A8A06-AA77-45E9-A585-DA9C4686B129}). */
export type IntegerFacetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type IntegerField = ItemField & {
  __typename?: 'IntegerField';
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** The field's value as an integer. */
  intValue?: Maybe<Scalars['Int']['output']>;
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type IntegerFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy template (ID: {9713DB87-4C3C-445B-A224-C353ADDFF086}). */
export type IntroCopy = Item & {
  __typename?: 'IntroCopy';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {00DAAD92-84C6-43AA-B837-2733C659D912}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy template (ID: {9713DB87-4C3C-445B-A224-C353ADDFF086}). */
export type IntroCopyAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy template (ID: {9713DB87-4C3C-445B-A224-C353ADDFF086}). */
export type IntroCopyChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy template (ID: {9713DB87-4C3C-445B-A224-C353ADDFF086}). */
export type IntroCopyFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy template (ID: {9713DB87-4C3C-445B-A224-C353ADDFF086}). */
export type IntroCopyFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy template (ID: {9713DB87-4C3C-445B-A224-C353ADDFF086}). */
export type IntroCopyHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy template (ID: {9713DB87-4C3C-445B-A224-C353ADDFF086}). */
export type IntroCopyIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy Folder template (ID: {0175F9BE-C77F-49D7-A986-F97822E884DF}). */
export type IntroCopyFolder = Item & {
  __typename?: 'IntroCopyFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy Folder template (ID: {0175F9BE-C77F-49D7-A986-F97822E884DF}). */
export type IntroCopyFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy Folder template (ID: {0175F9BE-C77F-49D7-A986-F97822E884DF}). */
export type IntroCopyFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy Folder template (ID: {0175F9BE-C77F-49D7-A986-F97822E884DF}). */
export type IntroCopyFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy Folder template (ID: {0175F9BE-C77F-49D7-A986-F97822E884DF}). */
export type IntroCopyFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy Folder template (ID: {0175F9BE-C77F-49D7-A986-F97822E884DF}). */
export type IntroCopyFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Intro Copy/Intro Copy Folder template (ID: {0175F9BE-C77F-49D7-A986-F97822E884DF}). */
export type IntroCopyFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class template (ID: {81A922BE-30C4-47AC-8703-D364C7325868}). */
export type InvestmentTrustAssetClass = Item & {
  __typename?: 'InvestmentTrustAssetClass';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {F028947C-2B30-411C-9BFC-7E3D076D4AE5}). */
  name_f028947c2b30411c9bfc7e3d076d4ae5?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class template (ID: {81A922BE-30C4-47AC-8703-D364C7325868}). */
export type InvestmentTrustAssetClassAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class template (ID: {81A922BE-30C4-47AC-8703-D364C7325868}). */
export type InvestmentTrustAssetClassChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class template (ID: {81A922BE-30C4-47AC-8703-D364C7325868}). */
export type InvestmentTrustAssetClassFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class template (ID: {81A922BE-30C4-47AC-8703-D364C7325868}). */
export type InvestmentTrustAssetClassFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class template (ID: {81A922BE-30C4-47AC-8703-D364C7325868}). */
export type InvestmentTrustAssetClassHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class template (ID: {81A922BE-30C4-47AC-8703-D364C7325868}). */
export type InvestmentTrustAssetClassIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class Folder template (ID: {40FB1411-0DEB-4200-8EB5-3DAAB40D3CE5}). */
export type InvestmentTrustAssetClassFolder = Item & {
  __typename?: 'InvestmentTrustAssetClassFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class Folder template (ID: {40FB1411-0DEB-4200-8EB5-3DAAB40D3CE5}). */
export type InvestmentTrustAssetClassFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class Folder template (ID: {40FB1411-0DEB-4200-8EB5-3DAAB40D3CE5}). */
export type InvestmentTrustAssetClassFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class Folder template (ID: {40FB1411-0DEB-4200-8EB5-3DAAB40D3CE5}). */
export type InvestmentTrustAssetClassFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class Folder template (ID: {40FB1411-0DEB-4200-8EB5-3DAAB40D3CE5}). */
export type InvestmentTrustAssetClassFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class Folder template (ID: {40FB1411-0DEB-4200-8EB5-3DAAB40D3CE5}). */
export type InvestmentTrustAssetClassFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Asset Class/Investment Trust Asset Class Folder template (ID: {40FB1411-0DEB-4200-8EB5-3DAAB40D3CE5}). */
export type InvestmentTrustAssetClassFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Investment Trust Page template (ID: {0FC5818F-DBE6-4749-B5BD-874BA368C65E}). Also implements _BaseInvestmentTrust. */
export type InvestmentTrustPage = {
  /** trustAssetClass (ID: {34893A4D-3273-4069-8012-71D96C4D46A7}). */
  trustAssetClass?: Maybe<LookupField>;
  /** trustDescription (ID: {23A43E10-8A30-4C8A-A3A8-691D2B2D0D03}). */
  trustDescription?: Maybe<TextField>;
  /** trustId (ID: {EDBD21FE-E562-481E-B05D-8A0765158488}). */
  trustId?: Maybe<TextField>;
  /** trustImage (ID: {1D4C60A3-C121-4758-A634-7466B8C4CFFA}). */
  trustImage?: Maybe<ImageField>;
  /** If checked, trust will not appear on Trust Finder page. */
  trustIsHidden?: Maybe<CheckboxField>;
  /** trustLink (ID: {7A8A011D-72D1-4431-83D8-4220FB5B3AC8}). */
  trustLink?: Maybe<LinkField>;
  /** trustName (ID: {FD13EAF9-DC56-412A-9F46-4A223FE05029}). */
  trustName?: Maybe<TextField>;
  /** trustRegion (ID: {A53FE6EB-699C-49B0-8FA8-59172AAC6E1B}). */
  trustRegion?: Maybe<LookupField>;
  /** trustStyle (ID: {B117229B-0780-4447-858D-94B815A50560}). */
  trustStyle?: Maybe<LookupField>;
  /** trustType (ID: {752F80B1-AA76-43CD-B6C3-D57B0AD59093}). */
  trustType?: Maybe<TextField>;
};

/** /sitecore/templates/Project/Investments/Pages/Investment Trust Page template (ID: {8F108193-367D-41DC-B4DC-3A71722C2B73}). */
export type InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & InvestmentTrustPage & Item & _BaseInvestmentTrust & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** trustAssetClass (ID: {34893A4D-3273-4069-8012-71D96C4D46A7}). */
  trustAssetClass?: Maybe<LookupField>;
  /** trustDescription (ID: {23A43E10-8A30-4C8A-A3A8-691D2B2D0D03}). */
  trustDescription?: Maybe<TextField>;
  /** trustId (ID: {EDBD21FE-E562-481E-B05D-8A0765158488}). */
  trustId?: Maybe<TextField>;
  /** trustImage (ID: {1D4C60A3-C121-4758-A634-7466B8C4CFFA}). */
  trustImage?: Maybe<ImageField>;
  /** If checked, trust will not appear on Trust Finder page. */
  trustIsHidden?: Maybe<CheckboxField>;
  /** trustLink (ID: {7A8A011D-72D1-4431-83D8-4220FB5B3AC8}). */
  trustLink?: Maybe<LinkField>;
  /** trustName (ID: {FD13EAF9-DC56-412A-9F46-4A223FE05029}). */
  trustName?: Maybe<TextField>;
  /** trustRegion (ID: {A53FE6EB-699C-49B0-8FA8-59172AAC6E1B}). */
  trustRegion?: Maybe<LookupField>;
  /** trustStyle (ID: {B117229B-0780-4447-858D-94B815A50560}). */
  trustStyle?: Maybe<LookupField>;
  /** trustType (ID: {752F80B1-AA76-43CD-B6C3-D57B0AD59093}). */
  trustType?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Investment Trust Page template (ID: {8F108193-367D-41DC-B4DC-3A71722C2B73}). */
export type InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Investment Trust Page template (ID: {8F108193-367D-41DC-B4DC-3A71722C2B73}). */
export type InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Investment Trust Page template (ID: {8F108193-367D-41DC-B4DC-3A71722C2B73}). */
export type InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Investment Trust Page template (ID: {8F108193-367D-41DC-B4DC-3A71722C2B73}). */
export type InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Investment Trust Page template (ID: {8F108193-367D-41DC-B4DC-3A71722C2B73}). */
export type InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Investment Trust Page template (ID: {8F108193-367D-41DC-B4DC-3A71722C2B73}). */
export type InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Investment Trust Page template (ID: {79A99EC2-8FE8-41F0-A929-356FE3A6AAEB}). */
export type InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & InvestmentTrustPage & Item & _BaseInvestmentTrust & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** trustAssetClass (ID: {34893A4D-3273-4069-8012-71D96C4D46A7}). */
  trustAssetClass?: Maybe<LookupField>;
  /** trustDescription (ID: {23A43E10-8A30-4C8A-A3A8-691D2B2D0D03}). */
  trustDescription?: Maybe<TextField>;
  /** trustId (ID: {EDBD21FE-E562-481E-B05D-8A0765158488}). */
  trustId?: Maybe<TextField>;
  /** trustImage (ID: {1D4C60A3-C121-4758-A634-7466B8C4CFFA}). */
  trustImage?: Maybe<ImageField>;
  /** If checked, trust will not appear on Trust Finder page. */
  trustIsHidden?: Maybe<CheckboxField>;
  /** trustLink (ID: {7A8A011D-72D1-4431-83D8-4220FB5B3AC8}). */
  trustLink?: Maybe<LinkField>;
  /** trustName (ID: {FD13EAF9-DC56-412A-9F46-4A223FE05029}). */
  trustName?: Maybe<TextField>;
  /** trustRegion (ID: {A53FE6EB-699C-49B0-8FA8-59172AAC6E1B}). */
  trustRegion?: Maybe<LookupField>;
  /** trustStyle (ID: {B117229B-0780-4447-858D-94B815A50560}). */
  trustStyle?: Maybe<LookupField>;
  /** trustType (ID: {752F80B1-AA76-43CD-B6C3-D57B0AD59093}). */
  trustType?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Investment Trust Page template (ID: {79A99EC2-8FE8-41F0-A929-356FE3A6AAEB}). */
export type InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaebAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Investment Trust Page template (ID: {79A99EC2-8FE8-41F0-A929-356FE3A6AAEB}). */
export type InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaebChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Investment Trust Page template (ID: {79A99EC2-8FE8-41F0-A929-356FE3A6AAEB}). */
export type InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaebFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Investment Trust Page template (ID: {79A99EC2-8FE8-41F0-A929-356FE3A6AAEB}). */
export type InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaebFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Investment Trust Page template (ID: {79A99EC2-8FE8-41F0-A929-356FE3A6AAEB}). */
export type InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaebHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Investment Trust Page template (ID: {79A99EC2-8FE8-41F0-A929-356FE3A6AAEB}). */
export type InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaebIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region template (ID: {6D8F077D-6076-4056-B308-78129372991A}). */
export type InvestmentTrustRegion = Item & {
  __typename?: 'InvestmentTrustRegion';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {0861E759-815B-4DFD-A19B-A400B1113815}). */
  name_0861e759815b4dfda19ba400b1113815?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region template (ID: {6D8F077D-6076-4056-B308-78129372991A}). */
export type InvestmentTrustRegionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region template (ID: {6D8F077D-6076-4056-B308-78129372991A}). */
export type InvestmentTrustRegionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region template (ID: {6D8F077D-6076-4056-B308-78129372991A}). */
export type InvestmentTrustRegionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region template (ID: {6D8F077D-6076-4056-B308-78129372991A}). */
export type InvestmentTrustRegionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region template (ID: {6D8F077D-6076-4056-B308-78129372991A}). */
export type InvestmentTrustRegionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region template (ID: {6D8F077D-6076-4056-B308-78129372991A}). */
export type InvestmentTrustRegionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region Folder template (ID: {64D9C9CD-D1E7-42DC-BD80-5EAAFA41B707}). */
export type InvestmentTrustRegionFolder = Item & {
  __typename?: 'InvestmentTrustRegionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region Folder template (ID: {64D9C9CD-D1E7-42DC-BD80-5EAAFA41B707}). */
export type InvestmentTrustRegionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region Folder template (ID: {64D9C9CD-D1E7-42DC-BD80-5EAAFA41B707}). */
export type InvestmentTrustRegionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region Folder template (ID: {64D9C9CD-D1E7-42DC-BD80-5EAAFA41B707}). */
export type InvestmentTrustRegionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region Folder template (ID: {64D9C9CD-D1E7-42DC-BD80-5EAAFA41B707}). */
export type InvestmentTrustRegionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region Folder template (ID: {64D9C9CD-D1E7-42DC-BD80-5EAAFA41B707}). */
export type InvestmentTrustRegionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Region/Investment Trust Region Folder template (ID: {64D9C9CD-D1E7-42DC-BD80-5EAAFA41B707}). */
export type InvestmentTrustRegionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style template (ID: {5FAB8253-7EB5-4F71-8FFE-CA7A0A061796}). */
export type InvestmentTrustStyle = Item & {
  __typename?: 'InvestmentTrustStyle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {6F68560E-BDF9-4E3F-B3A8-2E182E35ED40}). */
  name_6f68560ebdf94e3fb3a82e182e35ed40?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style template (ID: {5FAB8253-7EB5-4F71-8FFE-CA7A0A061796}). */
export type InvestmentTrustStyleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style template (ID: {5FAB8253-7EB5-4F71-8FFE-CA7A0A061796}). */
export type InvestmentTrustStyleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style template (ID: {5FAB8253-7EB5-4F71-8FFE-CA7A0A061796}). */
export type InvestmentTrustStyleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style template (ID: {5FAB8253-7EB5-4F71-8FFE-CA7A0A061796}). */
export type InvestmentTrustStyleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style template (ID: {5FAB8253-7EB5-4F71-8FFE-CA7A0A061796}). */
export type InvestmentTrustStyleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style template (ID: {5FAB8253-7EB5-4F71-8FFE-CA7A0A061796}). */
export type InvestmentTrustStyleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style Folder template (ID: {35E1440C-5241-4086-A3F6-82D86AEE95E7}). */
export type InvestmentTrustStyleFolder = Item & {
  __typename?: 'InvestmentTrustStyleFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style Folder template (ID: {35E1440C-5241-4086-A3F6-82D86AEE95E7}). */
export type InvestmentTrustStyleFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style Folder template (ID: {35E1440C-5241-4086-A3F6-82D86AEE95E7}). */
export type InvestmentTrustStyleFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style Folder template (ID: {35E1440C-5241-4086-A3F6-82D86AEE95E7}). */
export type InvestmentTrustStyleFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style Folder template (ID: {35E1440C-5241-4086-A3F6-82D86AEE95E7}). */
export type InvestmentTrustStyleFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style Folder template (ID: {35E1440C-5241-4086-A3F6-82D86AEE95E7}). */
export type InvestmentTrustStyleFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Investment Trust Style/Investment Trust Style Folder template (ID: {35E1440C-5241-4086-A3F6-82D86AEE95E7}). */
export type InvestmentTrustStyleFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Type template (ID: {02D92E14-FA94-42E1-B0F2-4173E6C9B57B}). */
export type InvestorType = Item & {
  __typename?: 'InvestorType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** id (ID: {BCCE36BE-0D4D-4D5F-8D44-3707B03AE293}). */
  id_bcce36be0d4d4d5f8d443707b03ae293?: Maybe<IntegerField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** type (ID: {3587B748-80A7-466D-8ACC-84F9FAFA6C3B}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Type template (ID: {02D92E14-FA94-42E1-B0F2-4173E6C9B57B}). */
export type InvestorTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Type template (ID: {02D92E14-FA94-42E1-B0F2-4173E6C9B57B}). */
export type InvestorTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Type template (ID: {02D92E14-FA94-42E1-B0F2-4173E6C9B57B}). */
export type InvestorTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Type template (ID: {02D92E14-FA94-42E1-B0F2-4173E6C9B57B}). */
export type InvestorTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Type template (ID: {02D92E14-FA94-42E1-B0F2-4173E6C9B57B}). */
export type InvestorTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Type template (ID: {02D92E14-FA94-42E1-B0F2-4173E6C9B57B}). */
export type InvestorTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Types Folder template (ID: {88A78491-64E0-4485-AEB3-A8FD46BF647B}). */
export type InvestorTypesFolder = Item & {
  __typename?: 'InvestorTypesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Types Folder template (ID: {88A78491-64E0-4485-AEB3-A8FD46BF647B}). */
export type InvestorTypesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Types Folder template (ID: {88A78491-64E0-4485-AEB3-A8FD46BF647B}). */
export type InvestorTypesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Types Folder template (ID: {88A78491-64E0-4485-AEB3-A8FD46BF647B}). */
export type InvestorTypesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Types Folder template (ID: {88A78491-64E0-4485-AEB3-A8FD46BF647B}). */
export type InvestorTypesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Types Folder template (ID: {88A78491-64E0-4485-AEB3-A8FD46BF647B}). */
export type InvestorTypesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Investor Types Folder template (ID: {88A78491-64E0-4485-AEB3-A8FD46BF647B}). */
export type InvestorTypesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Item = {
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  /** personalization info */
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


export type ItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ItemFieldArgs = {
  name: Scalars['String']['input'];
};


export type ItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Item Buckets/Item Buckets Settings template (ID: {9F6E14E6-C593-410B-A57E-21F6B5A413AD}). */
export type ItemBucketsSettings = {
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
};

export type ItemField = {
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type ItemFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ItemLanguage = {
  __typename?: 'ItemLanguage';
  /** A mapping of the englishName to the nativeName. For example, 'Spanish (Argentina) : español (Argentina)'. */
  displayName: Scalars['String']['output'];
  /** The name of the language in English. */
  englishName: Scalars['String']['output'];
  /** The language and locale. For example, 'es-AR'. */
  name: Scalars['String']['output'];
  /** The native name of the language. */
  nativeName: Scalars['String']['output'];
};

export type ItemPersonalization = {
  __typename?: 'ItemPersonalization';
  variantIds: Array<Maybe<Scalars['String']['output']>>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Search/Item Queries Folder template (ID: {5C76AD53-96CD-4B96-9690-DD9AF2650171}). */
export type ItemQueriesFolder = Item & {
  __typename?: 'ItemQueriesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Item Queries Folder template (ID: {5C76AD53-96CD-4B96-9690-DD9AF2650171}). */
export type ItemQueriesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Item Queries Folder template (ID: {5C76AD53-96CD-4B96-9690-DD9AF2650171}). */
export type ItemQueriesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Item Queries Folder template (ID: {5C76AD53-96CD-4B96-9690-DD9AF2650171}). */
export type ItemQueriesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Item Queries Folder template (ID: {5C76AD53-96CD-4B96-9690-DD9AF2650171}). */
export type ItemQueriesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Item Queries Folder template (ID: {5C76AD53-96CD-4B96-9690-DD9AF2650171}). */
export type ItemQueriesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Item Queries Folder template (ID: {5C76AD53-96CD-4B96-9690-DD9AF2650171}). */
export type ItemQueriesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/ItemRights template (ID: {47946F47-73FF-4531-8E8E-66AE7C0147E3}). */
export type ItemRights = Item & {
  __typename?: 'ItemRights';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Item (ID: {2181A054-5BCA-46DA-87C7-D74FB1DF2B26}). */
  item?: Maybe<LookupField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Security (ID: {AB0C8B8A-122A-45D9-AB77-F3CC23A02500}). */
  security?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/ItemRights template (ID: {47946F47-73FF-4531-8E8E-66AE7C0147E3}). */
export type ItemRightsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/ItemRights template (ID: {47946F47-73FF-4531-8E8E-66AE7C0147E3}). */
export type ItemRightsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/ItemRights template (ID: {47946F47-73FF-4531-8E8E-66AE7C0147E3}). */
export type ItemRightsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/ItemRights template (ID: {47946F47-73FF-4531-8E8E-66AE7C0147E3}). */
export type ItemRightsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/ItemRights template (ID: {47946F47-73FF-4531-8E8E-66AE7C0147E3}). */
export type ItemRightsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/ItemRights template (ID: {47946F47-73FF-4531-8E8E-66AE7C0147E3}). */
export type ItemRightsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum ItemSearchOperator {
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE',
  Ncontains = 'NCONTAINS',
  Neq = 'NEQ'
}

export type ItemSearchOrderByInput = {
  /** Sorting rule direction (ASC or DESC). */
  direction?: InputMaybe<OrderByDirection>;
  /** The name of the field to use for sorting. */
  name: Scalars['String']['input'];
};

export type ItemSearchPredicateInput = {
  /** AND logical operator. */
  AND?: InputMaybe<Array<InputMaybe<ItemSearchPredicateInput>>>;
  /** OR logical operator. */
  OR?: InputMaybe<Array<InputMaybe<ItemSearchPredicateInput>>>;
  /** The name of the field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A predicate (for example, EQ, CONTAINS, NCONTAINS or NEQ). */
  operator?: InputMaybe<ItemSearchOperator>;
  /** The value of the field. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ItemSearchResults = {
  __typename?: 'ItemSearchResults';
  /** Pagination info. */
  pageInfo: PageInfo;
  /** Found items. */
  results: Array<Maybe<Item>>;
  /** Total number of items. */
  total: Scalars['Int']['output'];
};

export type ItemTemplate = {
  __typename?: 'ItemTemplate';
  /** List of inherited templates. */
  baseTemplates?: Maybe<Array<Maybe<ItemTemplate>>>;
  /** The list of the template fields, including inherited fields. */
  fields?: Maybe<Array<Maybe<ItemTemplateField>>>;
  /** The ID of the template. */
  id: Scalars['ID']['output'];
  /** The name of the template. */
  name: Scalars['String']['output'];
  /** The list of template fields defined for this template (not inherited). */
  ownFields?: Maybe<Array<Maybe<ItemTemplateField>>>;
};


export type ItemTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ItemTemplateField = {
  __typename?: 'ItemTemplateField';
  /** The ID of the field. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Name of the field's section. */
  section: Scalars['String']['output'];
  /** The sorting order defined for the section. */
  sectionSortOrder: Scalars['Int']['output'];
  /** Boolean value indicating whether the field is shared among all languages and all numbered versions. */
  shared: Scalars['Boolean']['output'];
  /** The sorting order defined for the field. */
  sortOrder: Scalars['Int']['output'];
  /** The full path to the source of the field. */
  source: Scalars['String']['output'];
  /** The title of the field. */
  title: Scalars['String']['output'];
  /** The type of the field. */
  type: Scalars['String']['output'];
  /** A boolean value indicating whether the field is unversioned. */
  unversioned: Scalars['Boolean']['output'];
};


export type ItemTemplateFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ItemUrl = {
  __typename?: 'ItemUrl';
  /** The host name of the item’s site, as resolved during export. */
  hostName: Scalars['String']['output'];
  /** The URL path of the item (without scheme and domain name). */
  path: Scalars['String']['output'];
  /** The scheme (http or https) of the item’s site, as resolved during export. */
  scheme: Scalars['String']['output'];
  /** The name of the resolved site of the item. */
  siteName: Scalars['String']['output'];
  /** The full URL of the item, as resolved during export. */
  url: Scalars['String']['output'];
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/JS Beacon Settings/JS Beacon Settings template (ID: {834CD1F9-7FD0-4AC1-A1F6-62A387A54E2D}). */
export type JsBeaconSettings = Item & {
  __typename?: 'JSBeaconSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** beaconSrc (ID: {02FB95F8-49AC-47F4-BE9D-5920797616FD}). */
  beaconSrc?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/JS Beacon Settings/JS Beacon Settings template (ID: {834CD1F9-7FD0-4AC1-A1F6-62A387A54E2D}). */
export type JsBeaconSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/JS Beacon Settings/JS Beacon Settings template (ID: {834CD1F9-7FD0-4AC1-A1F6-62A387A54E2D}). */
export type JsBeaconSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/JS Beacon Settings/JS Beacon Settings template (ID: {834CD1F9-7FD0-4AC1-A1F6-62A387A54E2D}). */
export type JsBeaconSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/JS Beacon Settings/JS Beacon Settings template (ID: {834CD1F9-7FD0-4AC1-A1F6-62A387A54E2D}). */
export type JsBeaconSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/JS Beacon Settings/JS Beacon Settings template (ID: {834CD1F9-7FD0-4AC1-A1F6-62A387A54E2D}). */
export type JsBeaconSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/JS Beacon Settings/JS Beacon Settings template (ID: {834CD1F9-7FD0-4AC1-A1F6-62A387A54E2D}). */
export type JsBeaconSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Checkbox template (ID: {FCECE97C-5693-4B7C-BE42-B198E45AE316}). */
export type JsonCheckbox = BaseVariantField & Item & JsonField & {
  __typename?: 'JSONCheckbox';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /**
   * Depending on the rendering variant child item, the mode field can be set to different views:
   * 
   * Raw – renders a raw Sitecore value, unformatted data.
   * Text – renders text.
   * Rendered – renders the value using the field renderer.
   * Plain – renders the item as plain text.
   * Path – renders the path of the item.
   * Guid – renders the globally unique identifiers of the item in Sitecore.
   */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_12ffceb03945476bb027464f09ea5e15?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Determines the value that is rendered for false. */
  valueForFalse?: Maybe<TextField>;
  /** Determines the value that is rendered for true. */
  valueForTrue?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Checkbox template (ID: {FCECE97C-5693-4B7C-BE42-B198E45AE316}). */
export type JsonCheckboxAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Checkbox template (ID: {FCECE97C-5693-4B7C-BE42-B198E45AE316}). */
export type JsonCheckboxChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Checkbox template (ID: {FCECE97C-5693-4B7C-BE42-B198E45AE316}). */
export type JsonCheckboxFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Checkbox template (ID: {FCECE97C-5693-4B7C-BE42-B198E45AE316}). */
export type JsonCheckboxFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Checkbox template (ID: {FCECE97C-5693-4B7C-BE42-B198E45AE316}). */
export type JsonCheckboxHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Checkbox template (ID: {FCECE97C-5693-4B7C-BE42-B198E45AE316}). */
export type JsonCheckboxIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONContent template (ID: {AC584354-4AB4-4C31-AFA0-BBE83EC65FAA}). */
export type JsonContent = ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & Item & StandardRenderingParameters & {
  __typename?: 'JSONContent';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONContent template (ID: {AC584354-4AB4-4C31-AFA0-BBE83EC65FAA}). */
export type JsonContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONContent template (ID: {AC584354-4AB4-4C31-AFA0-BBE83EC65FAA}). */
export type JsonContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONContent template (ID: {AC584354-4AB4-4C31-AFA0-BBE83EC65FAA}). */
export type JsonContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONContent template (ID: {AC584354-4AB4-4C31-AFA0-BBE83EC65FAA}). */
export type JsonContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONContent template (ID: {AC584354-4AB4-4C31-AFA0-BBE83EC65FAA}). */
export type JsonContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONContent template (ID: {AC584354-4AB4-4C31-AFA0-BBE83EC65FAA}). */
export type JsonContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Date template (ID: {3ECEDC1B-9F37-41F6-9F98-BA3C0BBA347A}). */
export type JsonDate = BaseVariantField & Item & JsonField & {
  __typename?: 'JSONDate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Determines the date format. */
  dateFormat?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_12ffceb03945476bb027464f09ea5e15?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Date template (ID: {3ECEDC1B-9F37-41F6-9F98-BA3C0BBA347A}). */
export type JsonDateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Date template (ID: {3ECEDC1B-9F37-41F6-9F98-BA3C0BBA347A}). */
export type JsonDateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Date template (ID: {3ECEDC1B-9F37-41F6-9F98-BA3C0BBA347A}). */
export type JsonDateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Date template (ID: {3ECEDC1B-9F37-41F6-9F98-BA3C0BBA347A}). */
export type JsonDateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Date template (ID: {3ECEDC1B-9F37-41F6-9F98-BA3C0BBA347A}). */
export type JsonDateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Date template (ID: {3ECEDC1B-9F37-41F6-9F98-BA3C0BBA347A}). */
export type JsonDateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Field template (ID: {F69D787D-0ECF-43D3-B9CB-35B303D5233A}). Also implements BaseVariantField, _JSONVariantsBase. */
export type JsonField = {
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_12ffceb03945476bb027464f09ea5e15?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON File template (ID: {430E92E0-6A2C-42F7-A5F4-51547D31934D}). */
export type JsonFile = BaseVariantField & Item & JsonField & {
  __typename?: 'JSONFile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /**
   * Depending on the rendering variant child item, the mode field can be set to different views:
   * 
   * Raw – renders a raw Sitecore value, unformatted data.
   * Text – renders text.
   * Rendered – renders the value using the field renderer.
   * Plain – renders the item as plain text.
   * Path – renders the path of the item.
   * Guid – renders the globally unique identifiers of the item in Sitecore.
   */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_12ffceb03945476bb027464f09ea5e15?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON File template (ID: {430E92E0-6A2C-42F7-A5F4-51547D31934D}). */
export type JsonFileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON File template (ID: {430E92E0-6A2C-42F7-A5F4-51547D31934D}). */
export type JsonFileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON File template (ID: {430E92E0-6A2C-42F7-A5F4-51547D31934D}). */
export type JsonFileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON File template (ID: {430E92E0-6A2C-42F7-A5F4-51547D31934D}). */
export type JsonFileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON File template (ID: {430E92E0-6A2C-42F7-A5F4-51547D31934D}). */
export type JsonFileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON File template (ID: {430E92E0-6A2C-42F7-A5F4-51547D31934D}). */
export type JsonFileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Image template (ID: {590D6149-951B-436B-A767-53F7210E4925}). */
export type JsonImage = BaseVariantField & Item & JsonField & {
  __typename?: 'JSONImage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /**
   * Depending on the rendering variant child item, the mode field can be set to different views:
   * 
   * Raw – renders a raw Sitecore value, unformatted data.
   * Text – renders text.
   * Rendered – renders the value using the field renderer.
   * Plain – renders the item as plain text.
   * Path – renders the path of the item.
   * Guid – renders the globally unique identifiers of the item in Sitecore.
   */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_12ffceb03945476bb027464f09ea5e15?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Image template (ID: {590D6149-951B-436B-A767-53F7210E4925}). */
export type JsonImageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Image template (ID: {590D6149-951B-436B-A767-53F7210E4925}). */
export type JsonImageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Image template (ID: {590D6149-951B-436B-A767-53F7210E4925}). */
export type JsonImageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Image template (ID: {590D6149-951B-436B-A767-53F7210E4925}). */
export type JsonImageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Image template (ID: {590D6149-951B-436B-A767-53F7210E4925}). */
export type JsonImageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Image template (ID: {590D6149-951B-436B-A767-53F7210E4925}). */
export type JsonImageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/JSON Layout template (ID: {D4A92895-5104-4BFC-9D9F-16B5F59F0DB0}). */
export type JsonLayout = Item & Layout & {
  __typename?: 'JSONLayout';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Area (ID: {70DC08D9-CDA2-4F04-AA35-C11FD7138066}). */
  area?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Model (ID: {E9CC5A73-3C8A-4D7D-92AC-3B88C18A996A}). */
  model?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  /** Path (ID: {A036B2BC-BA04-44F6-A75F-BAE6CD242ABF}). */
  path_a036b2bcba0444f6a75fbae6cd242abf?: Maybe<TextField>;
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholders (ID: {80334869-86DC-4472-AA89-44CF1B2F6C9B}). */
  placeholders?: Maybe<MultilistField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/JSON Layout template (ID: {D4A92895-5104-4BFC-9D9F-16B5F59F0DB0}). */
export type JsonLayoutAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/JSON Layout template (ID: {D4A92895-5104-4BFC-9D9F-16B5F59F0DB0}). */
export type JsonLayoutChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/JSON Layout template (ID: {D4A92895-5104-4BFC-9D9F-16B5F59F0DB0}). */
export type JsonLayoutFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/JSON Layout template (ID: {D4A92895-5104-4BFC-9D9F-16B5F59F0DB0}). */
export type JsonLayoutFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/JSON Layout template (ID: {D4A92895-5104-4BFC-9D9F-16B5F59F0DB0}). */
export type JsonLayoutHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/JSON Layout template (ID: {D4A92895-5104-4BFC-9D9F-16B5F59F0DB0}). */
export type JsonLayoutIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSON List template (ID: {36EE6E93-3344-4C03-92DD-B9CAE293EBBA}). */
export type JsonList = ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & Item & StandardRenderingParameters & {
  __typename?: 'JSONList';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Property Name (ID: {451AC4C9-92DB-442D-A2BD-8402375A3DAE}). */
  propertyName?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SourceType (ID: {5B716A15-2C6F-41C0-8422-8E503DF896D1}). */
  sourceType?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSON List template (ID: {36EE6E93-3344-4C03-92DD-B9CAE293EBBA}). */
export type JsonListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSON List template (ID: {36EE6E93-3344-4C03-92DD-B9CAE293EBBA}). */
export type JsonListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSON List template (ID: {36EE6E93-3344-4C03-92DD-B9CAE293EBBA}). */
export type JsonListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSON List template (ID: {36EE6E93-3344-4C03-92DD-B9CAE293EBBA}). */
export type JsonListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSON List template (ID: {36EE6E93-3344-4C03-92DD-B9CAE293EBBA}). */
export type JsonListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSON List template (ID: {36EE6E93-3344-4C03-92DD-B9CAE293EBBA}). */
export type JsonListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Multilist Reference template (ID: {61B57D28-B376-4584-AF5F-F55279BCE6DD}). */
export type JsonMultilistReference = Item & JsonReference & _JsonVariantPaging & {
  __typename?: 'JSONMultilistReference';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_22697d5448b249b9bfa9d10a34f1b1eb?: Maybe<TextField>;
  /** NumberOfResultsToSkip (ID: {79499A55-648D-4B30-A526-13C9F47C3121}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** Defines the name of the field that stores the link to a different item. For example, a simple reference, such as a link, or a mult1-reference field, such as a Tree list. */
  passThroughField?: Maybe<TextField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Multilist Reference template (ID: {61B57D28-B376-4584-AF5F-F55279BCE6DD}). */
export type JsonMultilistReferenceAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Multilist Reference template (ID: {61B57D28-B376-4584-AF5F-F55279BCE6DD}). */
export type JsonMultilistReferenceChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Multilist Reference template (ID: {61B57D28-B376-4584-AF5F-F55279BCE6DD}). */
export type JsonMultilistReferenceFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Multilist Reference template (ID: {61B57D28-B376-4584-AF5F-F55279BCE6DD}). */
export type JsonMultilistReferenceFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Multilist Reference template (ID: {61B57D28-B376-4584-AF5F-F55279BCE6DD}). */
export type JsonMultilistReferenceHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Multilist Reference template (ID: {61B57D28-B376-4584-AF5F-F55279BCE6DD}). */
export type JsonMultilistReferenceIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Placeholder template (ID: {F9A7C944-AD85-4D0A-86E8-1D1B3AF814B8}). */
export type JsonPlaceholder = BaseVariantField & Item & {
  __typename?: 'JSONPlaceholder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_318cdb5d243549618ef7b18a38023237?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Switch component context to currently rendered item */
  switchContext?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Placeholder template (ID: {F9A7C944-AD85-4D0A-86E8-1D1B3AF814B8}). */
export type JsonPlaceholderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Placeholder template (ID: {F9A7C944-AD85-4D0A-86E8-1D1B3AF814B8}). */
export type JsonPlaceholderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Placeholder template (ID: {F9A7C944-AD85-4D0A-86E8-1D1B3AF814B8}). */
export type JsonPlaceholderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Placeholder template (ID: {F9A7C944-AD85-4D0A-86E8-1D1B3AF814B8}). */
export type JsonPlaceholderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Placeholder template (ID: {F9A7C944-AD85-4D0A-86E8-1D1B3AF814B8}). */
export type JsonPlaceholderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Placeholder template (ID: {F9A7C944-AD85-4D0A-86E8-1D1B3AF814B8}). */
export type JsonPlaceholderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Query template (ID: {97A895E7-DD2B-42BC-B366-DEC64EA7F2CC}). */
export type JsonQuery = Item & _JsonVariantPaging & {
  __typename?: 'JSONQuery';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_45084238befd42d7a6e169185e66b682?: Maybe<TextField>;
  /** NumberOfResultsToSkip (ID: {79499A55-648D-4B30-A526-13C9F47C3121}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /**
   * Determines the query that will be run on the current context item. For example:
   * To get all child items:
   * query:./* 
   * To get all items of Page template from under the current item:
   * query:..//*[@@templatename='Page'] 
   * To get all items of Page template from under Home item of the current site:
   * query:/*[@@name='Home']//*[@@templatename='Page']
   */
  query?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Query template (ID: {97A895E7-DD2B-42BC-B366-DEC64EA7F2CC}). */
export type JsonQueryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Query template (ID: {97A895E7-DD2B-42BC-B366-DEC64EA7F2CC}). */
export type JsonQueryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Query template (ID: {97A895E7-DD2B-42BC-B366-DEC64EA7F2CC}). */
export type JsonQueryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Query template (ID: {97A895E7-DD2B-42BC-B366-DEC64EA7F2CC}). */
export type JsonQueryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Query template (ID: {97A895E7-DD2B-42BC-B366-DEC64EA7F2CC}). */
export type JsonQueryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Query template (ID: {97A895E7-DD2B-42BC-B366-DEC64EA7F2CC}). */
export type JsonQueryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Reference template (ID: {C4D4361B-87CE-4640-A2C4-554838E0E417}). Also implements _JSONVariantsBase. */
export type JsonReference = {
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_22697d5448b249b9bfa9d10a34f1b1eb?: Maybe<TextField>;
  /** Defines the name of the field that stores the link to a different item. For example, a simple reference, such as a link, or a mult1-reference field, such as a Tree list. */
  passThroughField?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONResults template (ID: {48FB6B99-2593-46EF-9C46-86E51E434DA2}). */
export type JsonResults = ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & Item & StandardRenderingParameters & {
  __typename?: 'JSONResults';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** Default Language Filter (ID: {B1F4E59B-90D3-4327-AE85-A1C247DAAD41}). */
  defaultLanguageFilter?: Maybe<LookupField>;
  /** Default Sort Order (ID: {98020F8F-B2FC-40DD-BE4F-8C59C1AFD367}). */
  defaultSortOrder?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Page Size (ID: {D629F480-1D96-4AD2-824E-04ABD30EB88C}). */
  pageSize?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Property Name (ID: {1B315061-0CB5-4EAB-BCA9-C7F0F480E228}). */
  propertyName?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Scope (ID: {0942C1CE-31E8-41ED-8F09-4707D956EAC9}). */
  scope?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONResults template (ID: {48FB6B99-2593-46EF-9C46-86E51E434DA2}). */
export type JsonResultsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONResults template (ID: {48FB6B99-2593-46EF-9C46-86E51E434DA2}). */
export type JsonResultsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONResults template (ID: {48FB6B99-2593-46EF-9C46-86E51E434DA2}). */
export type JsonResultsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONResults template (ID: {48FB6B99-2593-46EF-9C46-86E51E434DA2}). */
export type JsonResultsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONResults template (ID: {48FB6B99-2593-46EF-9C46-86E51E434DA2}). */
export type JsonResultsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/JSON/Rendering Parameters/JSONResults template (ID: {48FB6B99-2593-46EF-9C46-86E51E434DA2}). */
export type JsonResultsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Rich Text template (ID: {2D7EB1AC-9DC7-417F-A61D-43BA1871DD85}). */
export type JsonRichText = BaseVariantField & Item & JsonField & {
  __typename?: 'JSONRichText';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /**
   * Depending on the rendering variant child item, the mode field can be set to different views:
   * 
   * Raw – renders a raw Sitecore value, unformatted data.
   * Text – renders text.
   * Rendered – renders the value using the field renderer.
   * Plain – renders the item as plain text.
   * Path – renders the path of the item.
   * Guid – renders the globally unique identifiers of the item in Sitecore.
   */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_12ffceb03945476bb027464f09ea5e15?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Rich Text template (ID: {2D7EB1AC-9DC7-417F-A61D-43BA1871DD85}). */
export type JsonRichTextAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Rich Text template (ID: {2D7EB1AC-9DC7-417F-A61D-43BA1871DD85}). */
export type JsonRichTextChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Rich Text template (ID: {2D7EB1AC-9DC7-417F-A61D-43BA1871DD85}). */
export type JsonRichTextFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Rich Text template (ID: {2D7EB1AC-9DC7-417F-A61D-43BA1871DD85}). */
export type JsonRichTextFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Rich Text template (ID: {2D7EB1AC-9DC7-417F-A61D-43BA1871DD85}). */
export type JsonRichTextHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Rich Text template (ID: {2D7EB1AC-9DC7-417F-A61D-43BA1871DD85}). */
export type JsonRichTextIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Scriban template (ID: {7B22166B-6A23-4E31-8C9E-7AEC2CB29225}). */
export type JsonScriban = BaseVariantField & Item & {
  __typename?: 'JSONScriban';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Scriban field, you can create an additional object. */
  name_5abb8d233c904c56a201f83a3753d17e?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {106FB8A5-3997-41B8-BDEB-065DC3AA5710}). */
  template_106fb8a5399741b8bdeb065dc3aa5710?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Scriban template (ID: {7B22166B-6A23-4E31-8C9E-7AEC2CB29225}). */
export type JsonScribanAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Scriban template (ID: {7B22166B-6A23-4E31-8C9E-7AEC2CB29225}). */
export type JsonScribanChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Scriban template (ID: {7B22166B-6A23-4E31-8C9E-7AEC2CB29225}). */
export type JsonScribanFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Scriban template (ID: {7B22166B-6A23-4E31-8C9E-7AEC2CB29225}). */
export type JsonScribanFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Scriban template (ID: {7B22166B-6A23-4E31-8C9E-7AEC2CB29225}). */
export type JsonScribanHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Scriban template (ID: {7B22166B-6A23-4E31-8C9E-7AEC2CB29225}). */
export type JsonScribanIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Section template (ID: {63906414-EB97-461E-A571-F9C4DCE5340C}). */
export type JsonSection = BaseVariantField & Item & {
  __typename?: 'JSONSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_7e0dd42cf87c4e1ea225e17e0ba15811?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Section template (ID: {63906414-EB97-461E-A571-F9C4DCE5340C}). */
export type JsonSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Section template (ID: {63906414-EB97-461E-A571-F9C4DCE5340C}). */
export type JsonSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Section template (ID: {63906414-EB97-461E-A571-F9C4DCE5340C}). */
export type JsonSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Section template (ID: {63906414-EB97-461E-A571-F9C4DCE5340C}). */
export type JsonSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Section template (ID: {63906414-EB97-461E-A571-F9C4DCE5340C}). */
export type JsonSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Section template (ID: {63906414-EB97-461E-A571-F9C4DCE5340C}). */
export type JsonSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Template template (ID: {103D1799-F98A-41CB-B060-6B03A277419B}). */
export type JsonTemplate = Item & {
  __typename?: 'JSONTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_ee0e0915a83d417a8c19aa82b9bf577f?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /**
   * Define the NVelocity template that renders part of the component variant HTML
   *  – access to the current item (the .Name object displays the current item name).
   * .Format(date, format) – formats date and time values.
   * .Format(number, format) – formats numbers.
   * .Distance – displays distance to points of interest in geospatial searches.
   */
  template_f5c88509732a41e2b9ae26af1b89fdc7?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Template template (ID: {103D1799-F98A-41CB-B060-6B03A277419B}). */
export type JsonTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Template template (ID: {103D1799-F98A-41CB-B060-6B03A277419B}). */
export type JsonTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Template template (ID: {103D1799-F98A-41CB-B060-6B03A277419B}). */
export type JsonTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Template template (ID: {103D1799-F98A-41CB-B060-6B03A277419B}). */
export type JsonTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Template template (ID: {103D1799-F98A-41CB-B060-6B03A277419B}). */
export type JsonTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Template template (ID: {103D1799-F98A-41CB-B060-6B03A277419B}). */
export type JsonTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Text template (ID: {79E93F13-26A4-419B-AB9D-75D96329F81B}). */
export type JsonText = BaseVariantField & Item & {
  __typename?: 'JSONText';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_1f3ae4d82c4145d3b023a19dbdb01214?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Displays text and is used to render a custom string, of for example, a description. You can use the following fields: Name (define property name for the text), Text (containing the text to be rendered). */
  text?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Text template (ID: {79E93F13-26A4-419B-AB9D-75D96329F81B}). */
export type JsonTextAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Text template (ID: {79E93F13-26A4-419B-AB9D-75D96329F81B}). */
export type JsonTextChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Text template (ID: {79E93F13-26A4-419B-AB9D-75D96329F81B}). */
export type JsonTextFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Text template (ID: {79E93F13-26A4-419B-AB9D-75D96329F81B}). */
export type JsonTextFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Text template (ID: {79E93F13-26A4-419B-AB9D-75D96329F81B}). */
export type JsonTextHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Text template (ID: {79E93F13-26A4-419B-AB9D-75D96329F81B}). */
export type JsonTextIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Token template (ID: {86DE4395-C8EA-48E7-91A6-65F23204D0CC}). */
export type JsonToken = BaseVariantField & Item & {
  __typename?: 'JSONToken';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Overrides the JSON property name. By adding a name for the JSON Reference field, you can create an additional object. */
  name_1de574d0412945669952b3fe30c8ac49?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /**
   * Use special tokens to format certain field values. Supported tokens are:
   * 	· $Size: displays size of a file depending on size unit.
   * 	· $FileTypeIcon: displays icon depending on file extension.
   * 	· $id: displays id of an item
   * 	· $name: displays name of an item
   */
  token?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Token template (ID: {86DE4395-C8EA-48E7-91A6-65F23204D0CC}). */
export type JsonTokenAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Token template (ID: {86DE4395-C8EA-48E7-91A6-65F23204D0CC}). */
export type JsonTokenChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Token template (ID: {86DE4395-C8EA-48E7-91A6-65F23204D0CC}). */
export type JsonTokenFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Token template (ID: {86DE4395-C8EA-48E7-91A6-65F23204D0CC}). */
export type JsonTokenFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Token template (ID: {86DE4395-C8EA-48E7-91A6-65F23204D0CC}). */
export type JsonTokenHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Token template (ID: {86DE4395-C8EA-48E7-91A6-65F23204D0CC}). */
export type JsonTokenIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variant Definition template (ID: {2E1D7985-0BF1-469B-A00B-4F2AC443940C}). */
export type JsonVariantDefinition = IBaseVariantDefinition & ICompatibleRenderings & IVariantDefinition & Item & {
  __typename?: 'JSONVariantDefinition';
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Provide the field name of the target item. This class is added to the list and navigation items markup (li HTML element). This link is used to override all links when the Is link, Is prefix link, or Is suffix link check boxes are selected. */
  linkField?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variant Definition template (ID: {2E1D7985-0BF1-469B-A00B-4F2AC443940C}). */
export type JsonVariantDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variant Definition template (ID: {2E1D7985-0BF1-469B-A00B-4F2AC443940C}). */
export type JsonVariantDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variant Definition template (ID: {2E1D7985-0BF1-469B-A00B-4F2AC443940C}). */
export type JsonVariantDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variant Definition template (ID: {2E1D7985-0BF1-469B-A00B-4F2AC443940C}). */
export type JsonVariantDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variant Definition template (ID: {2E1D7985-0BF1-469B-A00B-4F2AC443940C}). */
export type JsonVariantDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variant Definition template (ID: {2E1D7985-0BF1-469B-A00B-4F2AC443940C}). */
export type JsonVariantDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variants template (ID: {4C1DC3CF-36D2-4484-BA4E-40AF34D01E95}). */
export type JsonVariants = ICompatibleRenderings & Item & {
  __typename?: 'JSONVariants';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variants template (ID: {4C1DC3CF-36D2-4484-BA4E-40AF34D01E95}). */
export type JsonVariantsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variants template (ID: {4C1DC3CF-36D2-4484-BA4E-40AF34D01E95}). */
export type JsonVariantsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variants template (ID: {4C1DC3CF-36D2-4484-BA4E-40AF34D01E95}). */
export type JsonVariantsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variants template (ID: {4C1DC3CF-36D2-4484-BA4E-40AF34D01E95}). */
export type JsonVariantsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variants template (ID: {4C1DC3CF-36D2-4484-BA4E-40AF34D01E95}). */
export type JsonVariantsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/JSON Variants template (ID: {4C1DC3CF-36D2-4484-BA4E-40AF34D01E95}). */
export type JsonVariantsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/JSS Layout template (ID: {35C61E90-47DD-43DD-83A8-D1C4D5119720}). */
export type JssLayout = Item & Layout & {
  __typename?: 'JSSLayout';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Area (ID: {70DC08D9-CDA2-4F04-AA35-C11FD7138066}). */
  area?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Model (ID: {E9CC5A73-3C8A-4D7D-92AC-3B88C18A996A}). */
  model?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  /** Path (ID: {A036B2BC-BA04-44F6-A75F-BAE6CD242ABF}). */
  path_a036b2bcba0444f6a75fbae6cd242abf?: Maybe<TextField>;
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholders (ID: {80334869-86DC-4472-AA89-44CF1B2F6C9B}). */
  placeholders?: Maybe<MultilistField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/JSS Layout template (ID: {35C61E90-47DD-43DD-83A8-D1C4D5119720}). */
export type JssLayoutAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JSS Layout template (ID: {35C61E90-47DD-43DD-83A8-D1C4D5119720}). */
export type JssLayoutChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JSS Layout template (ID: {35C61E90-47DD-43DD-83A8-D1C4D5119720}). */
export type JssLayoutFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/JSS Layout template (ID: {35C61E90-47DD-43DD-83A8-D1C4D5119720}). */
export type JssLayoutFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JSS Layout template (ID: {35C61E90-47DD-43DD-83A8-D1C4D5119720}). */
export type JssLayoutHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JSS Layout template (ID: {35C61E90-47DD-43DD-83A8-D1C4D5119720}). */
export type JssLayoutIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Settings template (ID: {EC848505-D30C-4BDC-A0AA-7CC9D320085E}). Also implements _BaseSettings, _BucketRules, _LinkSettings, _GridMapping, _AdvancedItem, _SupportedLanguages. */
export type JssSettings = {
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Project/Invest Trusts/JSS Settings template (ID: {1A6FB678-ECA2-42C0-9AE7-7A9E7F72A6D0}). */
export type JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/JSS Settings template (ID: {1A6FB678-ECA2-42C0-9AE7-7A9E7F72A6D0}). */
export type JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/JSS Settings template (ID: {1A6FB678-ECA2-42C0-9AE7-7A9E7F72A6D0}). */
export type JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/JSS Settings template (ID: {1A6FB678-ECA2-42C0-9AE7-7A9E7F72A6D0}). */
export type JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/JSS Settings template (ID: {1A6FB678-ECA2-42C0-9AE7-7A9E7F72A6D0}). */
export type JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/JSS Settings template (ID: {1A6FB678-ECA2-42C0-9AE7-7A9E7F72A6D0}). */
export type JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/JSS Settings template (ID: {1A6FB678-ECA2-42C0-9AE7-7A9E7F72A6D0}). */
export type JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/JSS Settings template (ID: {6B328292-F831-4AB7-9885-D89A054CA10A}). */
export type JssSettings_6b328292f8314ab79885d89a054ca10a = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/JSS Settings template (ID: {6B328292-F831-4AB7-9885-D89A054CA10A}). */
export type JssSettings_6b328292f8314ab79885d89a054ca10aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/JSS Settings template (ID: {6B328292-F831-4AB7-9885-D89A054CA10A}). */
export type JssSettings_6b328292f8314ab79885d89a054ca10aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/JSS Settings template (ID: {6B328292-F831-4AB7-9885-D89A054CA10A}). */
export type JssSettings_6b328292f8314ab79885d89a054ca10aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/JSS Settings template (ID: {6B328292-F831-4AB7-9885-D89A054CA10A}). */
export type JssSettings_6b328292f8314ab79885d89a054ca10aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/JSS Settings template (ID: {6B328292-F831-4AB7-9885-D89A054CA10A}). */
export type JssSettings_6b328292f8314ab79885d89a054ca10aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/JSS Settings template (ID: {6B328292-F831-4AB7-9885-D89A054CA10A}). */
export type JssSettings_6b328292f8314ab79885d89a054ca10aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/JSS Settings template (ID: {457C9D0B-61B8-4ADF-AF7F-82561ED275FF}). */
export type JssSettings_457c9d0b61b84adfaf7f82561ed275ff = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/JSS Settings template (ID: {457C9D0B-61B8-4ADF-AF7F-82561ED275FF}). */
export type JssSettings_457c9d0b61b84adfaf7f82561ed275ffAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/JSS Settings template (ID: {457C9D0B-61B8-4ADF-AF7F-82561ED275FF}). */
export type JssSettings_457c9d0b61b84adfaf7f82561ed275ffChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/JSS Settings template (ID: {457C9D0B-61B8-4ADF-AF7F-82561ED275FF}). */
export type JssSettings_457c9d0b61b84adfaf7f82561ed275ffFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/JSS Settings template (ID: {457C9D0B-61B8-4ADF-AF7F-82561ED275FF}). */
export type JssSettings_457c9d0b61b84adfaf7f82561ed275ffFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/JSS Settings template (ID: {457C9D0B-61B8-4ADF-AF7F-82561ED275FF}). */
export type JssSettings_457c9d0b61b84adfaf7f82561ed275ffHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/JSS Settings template (ID: {457C9D0B-61B8-4ADF-AF7F-82561ED275FF}). */
export type JssSettings_457c9d0b61b84adfaf7f82561ed275ffIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/JSS Settings template (ID: {5045BF85-D2EA-430B-9F41-C2E348436E5D}). */
export type JssSettings_5045bf85d2ea430b9f41c2e348436e5d = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/JSS Settings template (ID: {5045BF85-D2EA-430B-9F41-C2E348436E5D}). */
export type JssSettings_5045bf85d2ea430b9f41c2e348436e5dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/JSS Settings template (ID: {5045BF85-D2EA-430B-9F41-C2E348436E5D}). */
export type JssSettings_5045bf85d2ea430b9f41c2e348436e5dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/JSS Settings template (ID: {5045BF85-D2EA-430B-9F41-C2E348436E5D}). */
export type JssSettings_5045bf85d2ea430b9f41c2e348436e5dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/JSS Settings template (ID: {5045BF85-D2EA-430B-9F41-C2E348436E5D}). */
export type JssSettings_5045bf85d2ea430b9f41c2e348436e5dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/JSS Settings template (ID: {5045BF85-D2EA-430B-9F41-C2E348436E5D}). */
export type JssSettings_5045bf85d2ea430b9f41c2e348436e5dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/JSS Settings template (ID: {5045BF85-D2EA-430B-9F41-C2E348436E5D}). */
export type JssSettings_5045bf85d2ea430b9f41c2e348436e5dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/JSS Settings template (ID: {A767F80D-5AD4-4BFB-B8B7-50A8DA144CB5}). */
export type JssSettings_A767f80d5ad44bfbb8b750a8da144cb5 = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/JSS Settings template (ID: {A767F80D-5AD4-4BFB-B8B7-50A8DA144CB5}). */
export type JssSettings_A767f80d5ad44bfbb8b750a8da144cb5AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/JSS Settings template (ID: {A767F80D-5AD4-4BFB-B8B7-50A8DA144CB5}). */
export type JssSettings_A767f80d5ad44bfbb8b750a8da144cb5ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/JSS Settings template (ID: {A767F80D-5AD4-4BFB-B8B7-50A8DA144CB5}). */
export type JssSettings_A767f80d5ad44bfbb8b750a8da144cb5FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/JSS Settings template (ID: {A767F80D-5AD4-4BFB-B8B7-50A8DA144CB5}). */
export type JssSettings_A767f80d5ad44bfbb8b750a8da144cb5FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/JSS Settings template (ID: {A767F80D-5AD4-4BFB-B8B7-50A8DA144CB5}). */
export type JssSettings_A767f80d5ad44bfbb8b750a8da144cb5HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/JSS Settings template (ID: {A767F80D-5AD4-4BFB-B8B7-50A8DA144CB5}). */
export type JssSettings_A767f80d5ad44bfbb8b750a8da144cb5IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/JSS Settings template (ID: {B001FD72-5BB1-4764-9682-5A8CB9E995CD}). */
export type JssSettings_B001fd725bb1476496825a8cb9e995cd = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/JSS Settings template (ID: {B001FD72-5BB1-4764-9682-5A8CB9E995CD}). */
export type JssSettings_B001fd725bb1476496825a8cb9e995cdAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/JSS Settings template (ID: {B001FD72-5BB1-4764-9682-5A8CB9E995CD}). */
export type JssSettings_B001fd725bb1476496825a8cb9e995cdChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/JSS Settings template (ID: {B001FD72-5BB1-4764-9682-5A8CB9E995CD}). */
export type JssSettings_B001fd725bb1476496825a8cb9e995cdFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/JSS Settings template (ID: {B001FD72-5BB1-4764-9682-5A8CB9E995CD}). */
export type JssSettings_B001fd725bb1476496825a8cb9e995cdFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/JSS Settings template (ID: {B001FD72-5BB1-4764-9682-5A8CB9E995CD}). */
export type JssSettings_B001fd725bb1476496825a8cb9e995cdHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/JSS Settings template (ID: {B001FD72-5BB1-4764-9682-5A8CB9E995CD}). */
export type JssSettings_B001fd725bb1476496825a8cb9e995cdIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/JSS Settings template (ID: {C643BC86-30D1-4D61-A173-C7870F5DBBAD}). */
export type JssSettings_C643bc8630d14d61a173c7870f5dbbad = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/JSS Settings template (ID: {C643BC86-30D1-4D61-A173-C7870F5DBBAD}). */
export type JssSettings_C643bc8630d14d61a173c7870f5dbbadAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/JSS Settings template (ID: {C643BC86-30D1-4D61-A173-C7870F5DBBAD}). */
export type JssSettings_C643bc8630d14d61a173c7870f5dbbadChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/JSS Settings template (ID: {C643BC86-30D1-4D61-A173-C7870F5DBBAD}). */
export type JssSettings_C643bc8630d14d61a173c7870f5dbbadFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/JSS Settings template (ID: {C643BC86-30D1-4D61-A173-C7870F5DBBAD}). */
export type JssSettings_C643bc8630d14d61a173c7870f5dbbadFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/JSS Settings template (ID: {C643BC86-30D1-4D61-A173-C7870F5DBBAD}). */
export type JssSettings_C643bc8630d14d61a173c7870f5dbbadHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/JSS Settings template (ID: {C643BC86-30D1-4D61-A173-C7870F5DBBAD}). */
export type JssSettings_C643bc8630d14d61a173c7870f5dbbadIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/JSS Settings template (ID: {CE3DFD34-0DF3-4B2D-8715-E54F85DFCCE2}). */
export type JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2 = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/JSS Settings template (ID: {CE3DFD34-0DF3-4B2D-8715-E54F85DFCCE2}). */
export type JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/JSS Settings template (ID: {CE3DFD34-0DF3-4B2D-8715-E54F85DFCCE2}). */
export type JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/JSS Settings template (ID: {CE3DFD34-0DF3-4B2D-8715-E54F85DFCCE2}). */
export type JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/JSS Settings template (ID: {CE3DFD34-0DF3-4B2D-8715-E54F85DFCCE2}). */
export type JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/JSS Settings template (ID: {CE3DFD34-0DF3-4B2D-8715-E54F85DFCCE2}). */
export type JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/JSS Settings template (ID: {CE3DFD34-0DF3-4B2D-8715-E54F85DFCCE2}). */
export type JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/JSS Settings template (ID: {EF855D0B-A8B0-4A8E-8785-1D1298266D90}). */
export type JssSettings_Ef855d0ba8b04a8e87851d1298266d90 = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/JSS Settings template (ID: {EF855D0B-A8B0-4A8E-8785-1D1298266D90}). */
export type JssSettings_Ef855d0ba8b04a8e87851d1298266d90AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/JSS Settings template (ID: {EF855D0B-A8B0-4A8E-8785-1D1298266D90}). */
export type JssSettings_Ef855d0ba8b04a8e87851d1298266d90ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/JSS Settings template (ID: {EF855D0B-A8B0-4A8E-8785-1D1298266D90}). */
export type JssSettings_Ef855d0ba8b04a8e87851d1298266d90FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/JSS Settings template (ID: {EF855D0B-A8B0-4A8E-8785-1D1298266D90}). */
export type JssSettings_Ef855d0ba8b04a8e87851d1298266d90FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/JSS Settings template (ID: {EF855D0B-A8B0-4A8E-8785-1D1298266D90}). */
export type JssSettings_Ef855d0ba8b04a8e87851d1298266d90HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/JSS Settings template (ID: {EF855D0B-A8B0-4A8E-8785-1D1298266D90}). */
export type JssSettings_Ef855d0ba8b04a8e87851d1298266d90IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Grouping template (ID: {8357F958-9AAA-46DB-8898-36448A96356F}). */
export type JssSiteGrouping = Item & {
  __typename?: 'JSSSiteGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Grouping template (ID: {8357F958-9AAA-46DB-8898-36448A96356F}). */
export type JssSiteGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Grouping template (ID: {8357F958-9AAA-46DB-8898-36448A96356F}). */
export type JssSiteGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Grouping template (ID: {8357F958-9AAA-46DB-8898-36448A96356F}). */
export type JssSiteGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Grouping template (ID: {8357F958-9AAA-46DB-8898-36448A96356F}). */
export type JssSiteGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Grouping template (ID: {8357F958-9AAA-46DB-8898-36448A96356F}). */
export type JssSiteGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Site Grouping template (ID: {8357F958-9AAA-46DB-8898-36448A96356F}). */
export type JssSiteGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Tenant Folder template (ID: {CA170F6F-5EC2-4E0C-B4BB-C77B7931B168}). */
export type JssTenantFolder = Item & {
  __typename?: 'JSSTenantFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Tenant Folder template (ID: {CA170F6F-5EC2-4E0C-B4BB-C77B7931B168}). */
export type JssTenantFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Tenant Folder template (ID: {CA170F6F-5EC2-4E0C-B4BB-C77B7931B168}). */
export type JssTenantFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Tenant Folder template (ID: {CA170F6F-5EC2-4E0C-B4BB-C77B7931B168}). */
export type JssTenantFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Tenant Folder template (ID: {CA170F6F-5EC2-4E0C-B4BB-C77B7931B168}). */
export type JssTenantFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Tenant Folder template (ID: {CA170F6F-5EC2-4E0C-B4BB-C77B7931B168}). */
export type JssTenantFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/JSS Tenant Folder template (ID: {CA170F6F-5EC2-4E0C-B4BB-C77B7931B168}). */
export type JssTenantFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/JavaScript Rendering template (ID: {B1C80C94-792D-44DA-861E-557C6E1915F2}). */
export type JavaScriptRendering = Caching & ContentDependency & ExtendedOptions & ExtendedOptions_2964fb4257a6440fb192218443904c90 & ExtendedOptions_F1850030f97848b4bdb5884b7e863160 & Item & RenderingOptions & {
  __typename?: 'JavaScriptRendering';
  /** AddFieldEditorButton (ID: {19D095B4-7621-4222-A89B-505289650792}). */
  addFieldEditorButton?: Maybe<CheckboxField>;
  /** Additional compatible templates (ID: {F6677A49-0A1D-4BAD-B8BA-4F0F22BDEE64}). */
  additionalCompatibleTemplates?: Maybe<MultilistField>;
  /** AllowedOnTemplates (ID: {1B58D065-FE74-43E3-BA20-54C9588B3011}). */
  allowedOnTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CacheClearingBehavior (ID: {A6D4FC1D-0803-4E0A-9145-B8C6121D6F26}). */
  cacheClearingBehavior?: Maybe<TextField>;
  /** Cacheable (ID: {3D08DB46-2267-41B0-BC52-BE69FD618633}). */
  cacheable?: Maybe<CheckboxField>;
  /** Can select Page as a data source (ID: {A3411FF6-C978-40AA-B059-A49B9CA2209B}). */
  canSelectPageAsADataSource?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ClearOnIndexUpdate (ID: {F3E7E552-D7C8-469B-A150-69E4E14AB35C}). */
  clearOnIndexUpdate?: Maybe<CheckboxField>;
  /** Client Script Path (ID: {125BB7B7-5D7D-42F3-A314-480799A9643E}). */
  clientScriptPath?: Maybe<TextField>;
  /** Compatible Renderings (ID: {E441ABE7-2CA3-4640-AE26-3789967925D7}). */
  compatibleRenderings?: Maybe<MultilistField>;
  /** Component Name (ID: {E6779F24-A474-4F29-A60F-83182CD1993A}). */
  componentName?: Maybe<TextField>;
  /** ComponentQuery (ID: {4528B82B-E79E-4BD9-820D-1BAD26260342}). */
  componentQuery?: Maybe<TextField>;
  /** Content Dependencies (ID: {B4BBC0BE-7619-4678-B2F7-947D84AA77A9}). */
  contentDependencies?: Maybe<MultilistField>;
  /** Customize Page (ID: {DAF096B4-BBE3-4FB1-9B2E-774A37FCCEC6}). */
  customizePage?: Maybe<TextField>;
  /** Data source (ID: {35F7859C-1E7F-4E86-87BD-65BFCF8679D8}). */
  dataSource?: Maybe<TextField>;
  /** Datasource Location (ID: {B5B27AF1-25EF-405C-87CE-369B3A004016}). */
  datasourceLocation?: Maybe<TextField>;
  /** Datasource Template (ID: {1A7C85E5-DC0B-490D-9187-BB1DBCB4C72F}). */
  datasourceTemplate?: Maybe<TextField>;
  /** Description (ID: {1127DFEE-0183-4A10-964A-00CCEA2121AC}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Editable (ID: {308E88F5-CD6E-4F8F-BAFE-95A47DEDEFDC}). */
  editable?: Maybe<CheckboxField>;
  /** Enable Datasource Query (ID: {F172B787-7B88-4BD5-AE4D-6308E102EF11}). */
  enableDatasourceQuery?: Maybe<CheckboxField>;
  /** Exported Function Name (ID: {E61F6FEA-BA01-44CF-A50B-369D7B18ADDA}). */
  exportedFunctionName?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldEditorFields (ID: {9F069AF7-A5A1-4143-A641-14735D50B1E8}). */
  fieldEditorFields?: Maybe<MultilistField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Open Properties after Add (ID: {C60E2D02-5F62-4DCF-A281-29005272C101}). */
  openPropertiesAfterAdd?: Maybe<TextField>;
  /** OtherProperties (ID: {E829C217-5E94-4306-9C48-2634B094FDC2}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Page Editor Buttons (ID: {A2F5D9DF-8CBA-4A1D-99EB-51ACB94CB057}). */
  pageEditorButtons?: Maybe<MultilistField>;
  /** Parameters (ID: {BEE1D4B3-CDFC-4A2D-AA19-6775C59CAE7B}). */
  parameters?: Maybe<TextField>;
  /** Parameters Template (ID: {5391FAAC-6C16-42B3-A411-49109A8502A3}). */
  parametersTemplate?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {DA298A61-8CEB-4FA5-9A56-90F531B1C105}). */
  placeholder?: Maybe<TextField>;
  /** Placeholders (ID: {069A8361-B1CD-437C-8C32-A3BE78941446}). */
  placeholders?: Maybe<MultilistField>;
  /** Render as HTML (ID: {BBB8A1E0-F966-4710-B4F4-42F267598127}). */
  renderAsHTML?: Maybe<CheckboxField>;
  /** Render Engine Instance Configuration Id (ID: {1E0EBAA2-DEC4-4756-A510-2A20A4951E2D}). */
  renderEngineInstanceConfigurationId?: Maybe<TextField>;
  /** Render Engine Type (ID: {135C8B8A-9F55-4B2D-9EA1-333320BADE0C}). */
  renderEngineType?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rendering Contents Resolver (ID: {B0B15510-B138-470E-8F33-8DA2E228AAFE}). */
  renderingContentsResolver?: Maybe<LookupField>;
  /** RenderingCssClass (ID: {34E81E40-1D4D-45B0-BCF1-A0FFE5521685}). */
  renderingCssClass?: Maybe<TextField>;
  /** RenderingViewPath (ID: {49B9D6C5-9551-4BA4-840E-74D5582256C0}). */
  renderingViewPath?: Maybe<TextField>;
  /** Server Script Path (ID: {7EDACBF4-CD65-44D6-B524-3A5ED411AE05}). */
  serverScriptPath?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** VaryByData (ID: {8B6D532B-6128-4486-A044-CA06D90948BA}). */
  varyByData?: Maybe<CheckboxField>;
  /** VaryByDevice (ID: {C98CF969-BA71-42DA-833D-B3FC1368BA27}). */
  varyByDevice?: Maybe<CheckboxField>;
  /** VaryByLogin (ID: {8D9232B0-613F-440B-A2FA-DCDD80FBD33E}). */
  varyByLogin?: Maybe<CheckboxField>;
  /** VaryByParm (ID: {3AD2506A-DC39-4B1E-959F-9D524ADDBF50}). */
  varyByParm?: Maybe<CheckboxField>;
  /** VaryByQueryString (ID: {1084D3D2-0457-456A-ABBC-EB4CC0966072}). */
  varyByQueryString?: Maybe<CheckboxField>;
  /** VaryByUser (ID: {0E54A8DC-72AD-4372-A7C7-BB4773FAD44D}). */
  varyByUser?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/JavaScript Rendering template (ID: {B1C80C94-792D-44DA-861E-557C6E1915F2}). */
export type JavaScriptRenderingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JavaScript Rendering template (ID: {B1C80C94-792D-44DA-861E-557C6E1915F2}). */
export type JavaScriptRenderingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JavaScript Rendering template (ID: {B1C80C94-792D-44DA-861E-557C6E1915F2}). */
export type JavaScriptRenderingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/JavaScript Rendering template (ID: {B1C80C94-792D-44DA-861E-557C6E1915F2}). */
export type JavaScriptRenderingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JavaScript Rendering template (ID: {B1C80C94-792D-44DA-861E-557C6E1915F2}). */
export type JavaScriptRenderingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/JavaScript Rendering template (ID: {B1C80C94-792D-44DA-861E-557C6E1915F2}). */
export type JavaScriptRenderingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/Json Rendering template (ID: {04646A89-996F-4EE7-878A-FFDBF1F0EF0D}). */
export type JsonRendering = Caching & ContentDependency & ExtendedOptions & ExtendedOptions_2964fb4257a6440fb192218443904c90 & ExtendedOptions_F1850030f97848b4bdb5884b7e863160 & Item & RenderingOptions & {
  __typename?: 'JsonRendering';
  /** AddFieldEditorButton (ID: {C39A90CE-0035-41BB-90F6-3C8A6EA87797}). */
  addFieldEditorButton?: Maybe<CheckboxField>;
  /** Additional compatible templates (ID: {F6677A49-0A1D-4BAD-B8BA-4F0F22BDEE64}). */
  additionalCompatibleTemplates?: Maybe<MultilistField>;
  /** AllowedOnTemplates (ID: {1B58D065-FE74-43E3-BA20-54C9588B3011}). */
  allowedOnTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CacheClearingBehavior (ID: {A6D4FC1D-0803-4E0A-9145-B8C6121D6F26}). */
  cacheClearingBehavior?: Maybe<TextField>;
  /** Cacheable (ID: {3D08DB46-2267-41B0-BC52-BE69FD618633}). */
  cacheable?: Maybe<CheckboxField>;
  /** Can select Page as a data source (ID: {A3411FF6-C978-40AA-B059-A49B9CA2209B}). */
  canSelectPageAsADataSource?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ClearOnIndexUpdate (ID: {F3E7E552-D7C8-469B-A150-69E4E14AB35C}). */
  clearOnIndexUpdate?: Maybe<CheckboxField>;
  /** Compatible Renderings (ID: {E441ABE7-2CA3-4640-AE26-3789967925D7}). */
  compatibleRenderings?: Maybe<MultilistField>;
  /** componentName (ID: {037FE404-DD19-4BF7-8E30-4DADF68B27B0}). */
  componentName?: Maybe<TextField>;
  /** ComponentQuery (ID: {17BB046A-A32A-41B3-8315-81217947611B}). */
  componentQuery?: Maybe<TextField>;
  /** Content Dependencies (ID: {B4BBC0BE-7619-4678-B2F7-947D84AA77A9}). */
  contentDependencies?: Maybe<MultilistField>;
  /** Customize Page (ID: {705A4365-065A-4104-B755-7363F455EBC6}). */
  customizePage?: Maybe<TextField>;
  /** Data source (ID: {003A72CD-4CD6-4392-9862-41D4159929CD}). */
  dataSource?: Maybe<TextField>;
  /** Datasource Location (ID: {B5B27AF1-25EF-405C-87CE-369B3A004016}). */
  datasourceLocation?: Maybe<TextField>;
  /** Datasource Template (ID: {1A7C85E5-DC0B-490D-9187-BB1DBCB4C72F}). */
  datasourceTemplate?: Maybe<TextField>;
  /** Description (ID: {56E4618A-F3F2-4CB5-B69A-8A45DE578902}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Editable (ID: {308E88F5-CD6E-4F8F-BAFE-95A47DEDEFDC}). */
  editable?: Maybe<CheckboxField>;
  /** Enable Datasource Query (ID: {F172B787-7B88-4BD5-AE4D-6308E102EF11}). */
  enableDatasourceQuery?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldEditorFields (ID: {C7B72114-3F04-45A0-BA43-3856A9C9FEB3}). */
  fieldEditorFields?: Maybe<MultilistField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Open Properties after Add (ID: {7D8AE35F-9ED1-43B5-96A2-0A5F040D4E4E}). */
  openPropertiesAfterAdd?: Maybe<TextField>;
  /** OtherProperties (ID: {E829C217-5E94-4306-9C48-2634B094FDC2}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Page Editor Buttons (ID: {A2F5D9DF-8CBA-4A1D-99EB-51ACB94CB057}). */
  pageEditorButtons?: Maybe<MultilistField>;
  /** Parameters (ID: {D01DF626-2284-4BC6-A6CA-C0A3E6D2E844}). */
  parameters?: Maybe<TextField>;
  /** Parameters Template (ID: {A77E8568-1AB3-44F1-A664-B7C37EC7810D}). */
  parametersTemplate?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {592A1CE7-ABE0-4986-9783-0A34F3961DC0}). */
  placeholder?: Maybe<TextField>;
  /** Placeholders (ID: {069A8361-B1CD-437C-8C32-A3BE78941446}). */
  placeholders?: Maybe<MultilistField>;
  /** Render as HTML (ID: {BBB8A1E0-F966-4710-B4F4-42F267598127}). */
  renderAsHTML?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rendering Contents Resolver (ID: {B0B15510-B138-470E-8F33-8DA2E228AAFE}). */
  renderingContentsResolver?: Maybe<LookupField>;
  /** RenderingCssClass (ID: {34E81E40-1D4D-45B0-BCF1-A0FFE5521685}). */
  renderingCssClass?: Maybe<TextField>;
  /** RenderingViewPath (ID: {49B9D6C5-9551-4BA4-840E-74D5582256C0}). */
  renderingViewPath?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** VaryByData (ID: {8B6D532B-6128-4486-A044-CA06D90948BA}). */
  varyByData?: Maybe<CheckboxField>;
  /** VaryByDevice (ID: {C98CF969-BA71-42DA-833D-B3FC1368BA27}). */
  varyByDevice?: Maybe<CheckboxField>;
  /** VaryByLogin (ID: {8D9232B0-613F-440B-A2FA-DCDD80FBD33E}). */
  varyByLogin?: Maybe<CheckboxField>;
  /** VaryByParm (ID: {3AD2506A-DC39-4B1E-959F-9D524ADDBF50}). */
  varyByParm?: Maybe<CheckboxField>;
  /** VaryByQueryString (ID: {1084D3D2-0457-456A-ABBC-EB4CC0966072}). */
  varyByQueryString?: Maybe<CheckboxField>;
  /** VaryByUser (ID: {0E54A8DC-72AD-4372-A7C7-BB4773FAD44D}). */
  varyByUser?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Json Rendering template (ID: {04646A89-996F-4EE7-878A-FFDBF1F0EF0D}). */
export type JsonRenderingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Json Rendering template (ID: {04646A89-996F-4EE7-878A-FFDBF1F0EF0D}). */
export type JsonRenderingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Json Rendering template (ID: {04646A89-996F-4EE7-878A-FFDBF1F0EF0D}). */
export type JsonRenderingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Json Rendering template (ID: {04646A89-996F-4EE7-878A-FFDBF1F0EF0D}). */
export type JsonRenderingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Json Rendering template (ID: {04646A89-996F-4EE7-878A-FFDBF1F0EF0D}). */
export type JsonRenderingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Json Rendering template (ID: {04646A89-996F-4EE7-878A-FFDBF1F0EF0D}). */
export type JsonRenderingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdiction Status template (ID: {187AC2ED-77E1-4A59-BAB5-104689AF0E4B}). */
export type JurisdictionStatus = Item & {
  __typename?: 'JurisdictionStatus';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** status (ID: {B908576E-7419-4F53-AB57-485836CA780D}). */
  status?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdiction Status template (ID: {187AC2ED-77E1-4A59-BAB5-104689AF0E4B}). */
export type JurisdictionStatusAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdiction Status template (ID: {187AC2ED-77E1-4A59-BAB5-104689AF0E4B}). */
export type JurisdictionStatusChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdiction Status template (ID: {187AC2ED-77E1-4A59-BAB5-104689AF0E4B}). */
export type JurisdictionStatusFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdiction Status template (ID: {187AC2ED-77E1-4A59-BAB5-104689AF0E4B}). */
export type JurisdictionStatusFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdiction Status template (ID: {187AC2ED-77E1-4A59-BAB5-104689AF0E4B}). */
export type JurisdictionStatusHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdiction Status template (ID: {187AC2ED-77E1-4A59-BAB5-104689AF0E4B}). */
export type JurisdictionStatusIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdictions Folder template (ID: {98ABB409-0E80-4657-B9F8-86EFBEF23C65}). */
export type JurisdictionsFolder = Item & {
  __typename?: 'JurisdictionsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdictions Folder template (ID: {98ABB409-0E80-4657-B9F8-86EFBEF23C65}). */
export type JurisdictionsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdictions Folder template (ID: {98ABB409-0E80-4657-B9F8-86EFBEF23C65}). */
export type JurisdictionsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdictions Folder template (ID: {98ABB409-0E80-4657-B9F8-86EFBEF23C65}). */
export type JurisdictionsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdictions Folder template (ID: {98ABB409-0E80-4657-B9F8-86EFBEF23C65}). */
export type JurisdictionsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdictions Folder template (ID: {98ABB409-0E80-4657-B9F8-86EFBEF23C65}). */
export type JurisdictionsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Jurisdictions Folder template (ID: {98ABB409-0E80-4657-B9F8-86EFBEF23C65}). */
export type JurisdictionsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlight Item template (ID: {F8A845C4-E7BE-4C43-BC3C-3AFF9A1EEA12}). */
export type KeyHighlightItem = Item & {
  __typename?: 'KeyHighlightItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {18A2D7F4-848B-4A25-92BF-5CE1E4DB8EF6}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {062B9CC1-36A6-4CE5-A2EF-6F607BC8DFF8}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlight Item template (ID: {F8A845C4-E7BE-4C43-BC3C-3AFF9A1EEA12}). */
export type KeyHighlightItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlight Item template (ID: {F8A845C4-E7BE-4C43-BC3C-3AFF9A1EEA12}). */
export type KeyHighlightItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlight Item template (ID: {F8A845C4-E7BE-4C43-BC3C-3AFF9A1EEA12}). */
export type KeyHighlightItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlight Item template (ID: {F8A845C4-E7BE-4C43-BC3C-3AFF9A1EEA12}). */
export type KeyHighlightItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlight Item template (ID: {F8A845C4-E7BE-4C43-BC3C-3AFF9A1EEA12}). */
export type KeyHighlightItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlight Item template (ID: {F8A845C4-E7BE-4C43-BC3C-3AFF9A1EEA12}). */
export type KeyHighlightItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights template (ID: {0D5B2CD8-F764-4859-82C7-8FBC6F79A9E9}). */
export type KeyHighlights = Item & {
  __typename?: 'KeyHighlights';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {B4D148C1-D761-4F32-9E1A-E0BFD35F36A9}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights template (ID: {0D5B2CD8-F764-4859-82C7-8FBC6F79A9E9}). */
export type KeyHighlightsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights template (ID: {0D5B2CD8-F764-4859-82C7-8FBC6F79A9E9}). */
export type KeyHighlightsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights template (ID: {0D5B2CD8-F764-4859-82C7-8FBC6F79A9E9}). */
export type KeyHighlightsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights template (ID: {0D5B2CD8-F764-4859-82C7-8FBC6F79A9E9}). */
export type KeyHighlightsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights template (ID: {0D5B2CD8-F764-4859-82C7-8FBC6F79A9E9}). */
export type KeyHighlightsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights template (ID: {0D5B2CD8-F764-4859-82C7-8FBC6F79A9E9}). */
export type KeyHighlightsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights Folder template (ID: {138B0AD5-242F-43BE-AA8F-5F2502C98B6C}). */
export type KeyHighlightsFolder = Item & {
  __typename?: 'KeyHighlightsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights Folder template (ID: {138B0AD5-242F-43BE-AA8F-5F2502C98B6C}). */
export type KeyHighlightsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights Folder template (ID: {138B0AD5-242F-43BE-AA8F-5F2502C98B6C}). */
export type KeyHighlightsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights Folder template (ID: {138B0AD5-242F-43BE-AA8F-5F2502C98B6C}). */
export type KeyHighlightsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights Folder template (ID: {138B0AD5-242F-43BE-AA8F-5F2502C98B6C}). */
export type KeyHighlightsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights Folder template (ID: {138B0AD5-242F-43BE-AA8F-5F2502C98B6C}). */
export type KeyHighlightsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Key Highlights/Key Highlights Folder template (ID: {138B0AD5-242F-43BE-AA8F-5F2502C98B6C}). */
export type KeyHighlightsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Key Highlights Parameters Template template (ID: {20315F7C-61CF-4645-BF1C-C920AC60CEAA}). */
export type KeyHighlightsParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'KeyHighlightsParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {4A187771-9D37-4F52-A4A1-D72AB6551040}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Key Highlights Parameters Template template (ID: {20315F7C-61CF-4645-BF1C-C920AC60CEAA}). */
export type KeyHighlightsParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Key Highlights Parameters Template template (ID: {20315F7C-61CF-4645-BF1C-C920AC60CEAA}). */
export type KeyHighlightsParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Key Highlights Parameters Template template (ID: {20315F7C-61CF-4645-BF1C-C920AC60CEAA}). */
export type KeyHighlightsParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Key Highlights Parameters Template template (ID: {20315F7C-61CF-4645-BF1C-C920AC60CEAA}). */
export type KeyHighlightsParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Key Highlights Parameters Template template (ID: {20315F7C-61CF-4645-BF1C-C920AC60CEAA}). */
export type KeyHighlightsParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Key Highlights Parameters Template template (ID: {20315F7C-61CF-4645-BF1C-C920AC60CEAA}). */
export type KeyHighlightsParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValuePair = {
  __typename?: 'KeyValuePair';
  /** The key of the key-value pair. */
  key: Scalars['String']['output'];
  /** The value of the key-value pair. */
  value: Scalars['String']['output'];
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Language template (ID: {471B8418-4DC6-4E1F-8041-C6330FC575F2}). */
export type Language = Item & {
  __typename?: 'Language';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** code (ID: {8BD53E60-AF88-4D66-8F44-A6EC3B7DC952}). */
  code?: Maybe<LookupField>;
  /** countryName (ID: {3F2E8CC7-1460-4DA2-B1E5-75CE2773F7C1}). */
  countryName?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {C66EBAE8-769B-4D0D-B96A-284DAEA65D73}). */
  name_c66ebae8769b4d0db96a284daea65d73?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Language template (ID: {471B8418-4DC6-4E1F-8041-C6330FC575F2}). */
export type LanguageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Language template (ID: {471B8418-4DC6-4E1F-8041-C6330FC575F2}). */
export type LanguageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Language template (ID: {471B8418-4DC6-4E1F-8041-C6330FC575F2}). */
export type LanguageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Language template (ID: {471B8418-4DC6-4E1F-8041-C6330FC575F2}). */
export type LanguageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Language template (ID: {471B8418-4DC6-4E1F-8041-C6330FC575F2}). */
export type LanguageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Language template (ID: {471B8418-4DC6-4E1F-8041-C6330FC575F2}). */
export type LanguageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Language Selector template (ID: {7F24DE7A-205C-489B-B451-1CF506FA926A}). */
export type LanguageSelector = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'LanguageSelector';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Language Selector template (ID: {7F24DE7A-205C-489B-B451-1CF506FA926A}). */
export type LanguageSelectorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Language Selector template (ID: {7F24DE7A-205C-489B-B451-1CF506FA926A}). */
export type LanguageSelectorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Language Selector template (ID: {7F24DE7A-205C-489B-B451-1CF506FA926A}). */
export type LanguageSelectorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Language Selector template (ID: {7F24DE7A-205C-489B-B451-1CF506FA926A}). */
export type LanguageSelectorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Language Selector template (ID: {7F24DE7A-205C-489B-B451-1CF506FA926A}). */
export type LanguageSelectorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Language Selector template (ID: {7F24DE7A-205C-489B-B451-1CF506FA926A}). */
export type LanguageSelectorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Languages Folder template (ID: {ADCFAEEE-F30E-4394-8FCC-92E49FEA0B72}). */
export type LanguagesFolder = Item & {
  __typename?: 'LanguagesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Languages Folder template (ID: {ADCFAEEE-F30E-4394-8FCC-92E49FEA0B72}). */
export type LanguagesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Languages Folder template (ID: {ADCFAEEE-F30E-4394-8FCC-92E49FEA0B72}). */
export type LanguagesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Languages Folder template (ID: {ADCFAEEE-F30E-4394-8FCC-92E49FEA0B72}). */
export type LanguagesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Languages Folder template (ID: {ADCFAEEE-F30E-4394-8FCC-92E49FEA0B72}). */
export type LanguagesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Languages Folder template (ID: {ADCFAEEE-F30E-4394-8FCC-92E49FEA0B72}). */
export type LanguagesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Language/Languages Folder template (ID: {ADCFAEEE-F30E-4394-8FCC-92E49FEA0B72}). */
export type LanguagesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Latest Press Releases Parameters Template template (ID: {20412A16-8015-4F25-9B47-25766344DED6}). */
export type LatestPressReleasesParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'LatestPressReleasesParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {1E5650E6-FE2D-46CC-AB85-4A5E23676C36}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Latest Press Releases Parameters Template template (ID: {20412A16-8015-4F25-9B47-25766344DED6}). */
export type LatestPressReleasesParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Latest Press Releases Parameters Template template (ID: {20412A16-8015-4F25-9B47-25766344DED6}). */
export type LatestPressReleasesParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Latest Press Releases Parameters Template template (ID: {20412A16-8015-4F25-9B47-25766344DED6}). */
export type LatestPressReleasesParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Latest Press Releases Parameters Template template (ID: {20412A16-8015-4F25-9B47-25766344DED6}). */
export type LatestPressReleasesParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Latest Press Releases Parameters Template template (ID: {20412A16-8015-4F25-9B47-25766344DED6}). */
export type LatestPressReleasesParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Latest Press Releases Parameters Template template (ID: {20412A16-8015-4F25-9B47-25766344DED6}). */
export type LatestPressReleasesParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Layout/Layout template (ID: {3A45A723-64EE-4919-9D41-02FD40FD1466}). */
export type Layout = {
  /** Area (ID: {70DC08D9-CDA2-4F04-AA35-C11FD7138066}). */
  area?: Maybe<TextField>;
  /** Model (ID: {E9CC5A73-3C8A-4D7D-92AC-3B88C18A996A}). */
  model?: Maybe<TextField>;
  /** Path (ID: {A036B2BC-BA04-44F6-A75F-BAE6CD242ABF}). */
  path_a036b2bcba0444f6a75fbae6cd242abf?: Maybe<TextField>;
  /** Placeholders (ID: {80334869-86DC-4472-AA89-44CF1B2F6C9B}). */
  placeholders?: Maybe<MultilistField>;
};

export type LayoutData = {
  __typename?: 'LayoutData';
  /** Item for getting presentation details/layout data. */
  item?: Maybe<Item>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Layout Service/Layout Service Variants template (ID: {FA0B4154-BB8A-4670-B378-E27EBC41445B}). */
export type LayoutServiceVariants = Item & _SharedRoot & {
  __typename?: 'LayoutServiceVariants';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingToVariantMapping (ID: {E62DD2D8-A4D3-4647-9868-63E2381FE551}). */
  renderingToVariantMapping?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Layout Service/Layout Service Variants template (ID: {FA0B4154-BB8A-4670-B378-E27EBC41445B}). */
export type LayoutServiceVariantsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Layout Service/Layout Service Variants template (ID: {FA0B4154-BB8A-4670-B378-E27EBC41445B}). */
export type LayoutServiceVariantsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Layout Service/Layout Service Variants template (ID: {FA0B4154-BB8A-4670-B378-E27EBC41445B}). */
export type LayoutServiceVariantsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Layout Service/Layout Service Variants template (ID: {FA0B4154-BB8A-4670-B378-E27EBC41445B}). */
export type LayoutServiceVariantsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Layout Service/Layout Service Variants template (ID: {FA0B4154-BB8A-4670-B378-E27EBC41445B}). */
export type LayoutServiceVariantsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Layout Service/Layout Service Variants template (ID: {FA0B4154-BB8A-4670-B378-E27EBC41445B}). */
export type LayoutServiceVariantsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Folder template (ID: {6D72697D-0E9A-4265-BC83-122F792731F9}). */
export type LimitedDisplayFolder = Item & {
  __typename?: 'LimitedDisplayFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Folder template (ID: {6D72697D-0E9A-4265-BC83-122F792731F9}). */
export type LimitedDisplayFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Folder template (ID: {6D72697D-0E9A-4265-BC83-122F792731F9}). */
export type LimitedDisplayFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Folder template (ID: {6D72697D-0E9A-4265-BC83-122F792731F9}). */
export type LimitedDisplayFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Folder template (ID: {6D72697D-0E9A-4265-BC83-122F792731F9}). */
export type LimitedDisplayFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Folder template (ID: {6D72697D-0E9A-4265-BC83-122F792731F9}). */
export type LimitedDisplayFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Folder template (ID: {6D72697D-0E9A-4265-BC83-122F792731F9}). */
export type LimitedDisplayFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Option template (ID: {AE43DF5D-04B5-41A0-B397-64350F23033E}). */
export type LimitedDisplayOption = Item & {
  __typename?: 'LimitedDisplayOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Option template (ID: {AE43DF5D-04B5-41A0-B397-64350F23033E}). */
export type LimitedDisplayOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Option template (ID: {AE43DF5D-04B5-41A0-B397-64350F23033E}). */
export type LimitedDisplayOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Option template (ID: {AE43DF5D-04B5-41A0-B397-64350F23033E}). */
export type LimitedDisplayOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Option template (ID: {AE43DF5D-04B5-41A0-B397-64350F23033E}). */
export type LimitedDisplayOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Option template (ID: {AE43DF5D-04B5-41A0-B397-64350F23033E}). */
export type LimitedDisplayOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/Limited Display Option template (ID: {AE43DF5D-04B5-41A0-B397-64350F23033E}). */
export type LimitedDisplayOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link template (ID: {6F108E3C-5D57-42F8-A910-C22920269B0A}). */
export type Link = Item & {
  __typename?: 'Link';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Link (ID: {68C2A603-F98E-42A3-BE2D-DD70598C2A63}). */
  link?: Maybe<LinkField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link template (ID: {6F108E3C-5D57-42F8-A910-C22920269B0A}). */
export type LinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link template (ID: {6F108E3C-5D57-42F8-A910-C22920269B0A}). */
export type LinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link template (ID: {6F108E3C-5D57-42F8-A910-C22920269B0A}). */
export type LinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link template (ID: {6F108E3C-5D57-42F8-A910-C22920269B0A}). */
export type LinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link template (ID: {6F108E3C-5D57-42F8-A910-C22920269B0A}). */
export type LinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link template (ID: {6F108E3C-5D57-42F8-A910-C22920269B0A}). */
export type LinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type LinkField = ItemField & {
  __typename?: 'LinkField';
  /** The anchor name this link points to (for example, #foo). */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The CSS class on this link. */
  className?: Maybe<Scalars['String']['output']>;
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The type of link this is (for example, 'external'). */
  linkType?: Maybe<Scalars['String']['output']>;
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** The query string on this link. */
  queryString?: Maybe<Scalars['String']['output']>;
  /** The HTML target attribute of the link (for example, __blank). */
  target?: Maybe<Scalars['String']['output']>;
  /** The internal item that this link targets (null for external or other link types). */
  targetItem?: Maybe<Item>;
  /** The body text of the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The URL/href of this link. */
  url?: Maybe<Scalars['String']['output']>;
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type LinkFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List template (ID: {60C9AC62-4227-443E-8980-92C97E483832}). */
export type LinkList = Item & {
  __typename?: 'LinkList';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {DC9AAEE9-FC44-458D-A9FB-BAC61D8B0234}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List template (ID: {60C9AC62-4227-443E-8980-92C97E483832}). */
export type LinkListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List template (ID: {60C9AC62-4227-443E-8980-92C97E483832}). */
export type LinkListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List template (ID: {60C9AC62-4227-443E-8980-92C97E483832}). */
export type LinkListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List template (ID: {60C9AC62-4227-443E-8980-92C97E483832}). */
export type LinkListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List template (ID: {60C9AC62-4227-443E-8980-92C97E483832}). */
export type LinkListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List template (ID: {60C9AC62-4227-443E-8980-92C97E483832}). */
export type LinkListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {2FB317E5-509A-4BE9-B348-BF79168665C9}). */
export type LinkListFolder = Item & {
  __typename?: 'LinkListFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {2FB317E5-509A-4BE9-B348-BF79168665C9}). */
export type LinkListFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {2FB317E5-509A-4BE9-B348-BF79168665C9}). */
export type LinkListFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {2FB317E5-509A-4BE9-B348-BF79168665C9}). */
export type LinkListFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {2FB317E5-509A-4BE9-B348-BF79168665C9}). */
export type LinkListFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {2FB317E5-509A-4BE9-B348-BF79168665C9}). */
export type LinkListFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {2FB317E5-509A-4BE9-B348-BF79168665C9}). */
export type LinkListFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {C237D144-647A-4AFE-AA7B-1570F3E3F139}). */
export type LinkListFolder_C237d144647a4afeaa7b1570f3e3f139 = Item & {
  __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {C237D144-647A-4AFE-AA7B-1570F3E3F139}). */
export type LinkListFolder_C237d144647a4afeaa7b1570f3e3f139AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {C237D144-647A-4AFE-AA7B-1570F3E3F139}). */
export type LinkListFolder_C237d144647a4afeaa7b1570f3e3f139ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {C237D144-647A-4AFE-AA7B-1570F3E3F139}). */
export type LinkListFolder_C237d144647a4afeaa7b1570f3e3f139FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {C237D144-647A-4AFE-AA7B-1570F3E3F139}). */
export type LinkListFolder_C237d144647a4afeaa7b1570f3e3f139FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {C237D144-647A-4AFE-AA7B-1570F3E3F139}). */
export type LinkListFolder_C237d144647a4afeaa7b1570f3e3f139HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Datasource/Link List Folder template (ID: {C237D144-647A-4AFE-AA7B-1570F3E3F139}). */
export type LinkListFolder_C237d144647a4afeaa7b1570f3e3f139IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {33C9207E-3B04-4606-8EF5-4CA99A97C776}). */
export type LinkList_33c9207e3b0446068ef54ca99a97c776 = BaseRenderingParameters & GridParameters & IComponentVariant & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {33C9207E-3B04-4606-8EF5-4CA99A97C776}). */
export type LinkList_33c9207e3b0446068ef54ca99a97c776AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {33C9207E-3B04-4606-8EF5-4CA99A97C776}). */
export type LinkList_33c9207e3b0446068ef54ca99a97c776ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {33C9207E-3B04-4606-8EF5-4CA99A97C776}). */
export type LinkList_33c9207e3b0446068ef54ca99a97c776FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {33C9207E-3B04-4606-8EF5-4CA99A97C776}). */
export type LinkList_33c9207e3b0446068ef54ca99a97c776FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {33C9207E-3B04-4606-8EF5-4CA99A97C776}). */
export type LinkList_33c9207e3b0446068ef54ca99a97c776HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {33C9207E-3B04-4606-8EF5-4CA99A97C776}). */
export type LinkList_33c9207e3b0446068ef54ca99a97c776IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {97A593AD-2731-41DC-80BF-CEB5EF6A33B7}). */
export type LinkList_97a593ad273141dc80bfceb5ef6a33b7 = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TitleHeadingLevel (ID: {6CAC7197-F819-4D30-A1EB-852016299D08}). */
  titleHeadingLevel?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {97A593AD-2731-41DC-80BF-CEB5EF6A33B7}). */
export type LinkList_97a593ad273141dc80bfceb5ef6a33b7AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {97A593AD-2731-41DC-80BF-CEB5EF6A33B7}). */
export type LinkList_97a593ad273141dc80bfceb5ef6a33b7ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {97A593AD-2731-41DC-80BF-CEB5EF6A33B7}). */
export type LinkList_97a593ad273141dc80bfceb5ef6a33b7FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {97A593AD-2731-41DC-80BF-CEB5EF6A33B7}). */
export type LinkList_97a593ad273141dc80bfceb5ef6a33b7FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {97A593AD-2731-41DC-80BF-CEB5EF6A33B7}). */
export type LinkList_97a593ad273141dc80bfceb5ef6a33b7HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/LinkList template (ID: {97A593AD-2731-41DC-80BF-CEB5EF6A33B7}). */
export type LinkList_97a593ad273141dc80bfceb5ef6a33b7IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List template (ID: {F7561FFC-C0D8-477F-B53D-2703A4060BE1}). */
export type LinkList_F7561ffcc0d8477fb53d2703a4060be1 = Item & {
  __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AA9C8D1C-B210-4EFA-86DB-83E8FA32C672}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List template (ID: {F7561FFC-C0D8-477F-B53D-2703A4060BE1}). */
export type LinkList_F7561ffcc0d8477fb53d2703a4060be1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List template (ID: {F7561FFC-C0D8-477F-B53D-2703A4060BE1}). */
export type LinkList_F7561ffcc0d8477fb53d2703a4060be1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List template (ID: {F7561FFC-C0D8-477F-B53D-2703A4060BE1}). */
export type LinkList_F7561ffcc0d8477fb53d2703a4060be1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List template (ID: {F7561FFC-C0D8-477F-B53D-2703A4060BE1}). */
export type LinkList_F7561ffcc0d8477fb53d2703a4060be1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List template (ID: {F7561FFC-C0D8-477F-B53D-2703A4060BE1}). */
export type LinkList_F7561ffcc0d8477fb53d2703a4060be1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link List template (ID: {F7561FFC-C0D8-477F-B53D-2703A4060BE1}). */
export type LinkList_F7561ffcc0d8477fb53d2703a4060be1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Link template (ID: {68BD1CB5-A762-4A96-9AC6-CB16AB5882A3}). */
export type Link_68bd1cb5a7624a969ac6cb16ab5882a3 = Item & {
  __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {DD7B59AB-F6DE-4778-AFFB-4BB2096F6787}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Link template (ID: {68BD1CB5-A762-4A96-9AC6-CB16AB5882A3}). */
export type Link_68bd1cb5a7624a969ac6cb16ab5882a3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Link template (ID: {68BD1CB5-A762-4A96-9AC6-CB16AB5882A3}). */
export type Link_68bd1cb5a7624a969ac6cb16ab5882a3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Link template (ID: {68BD1CB5-A762-4A96-9AC6-CB16AB5882A3}). */
export type Link_68bd1cb5a7624a969ac6cb16ab5882a3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Link template (ID: {68BD1CB5-A762-4A96-9AC6-CB16AB5882A3}). */
export type Link_68bd1cb5a7624a969ac6cb16ab5882a3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Link template (ID: {68BD1CB5-A762-4A96-9AC6-CB16AB5882A3}). */
export type Link_68bd1cb5a7624a969ac6cb16ab5882a3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Link template (ID: {68BD1CB5-A762-4A96-9AC6-CB16AB5882A3}). */
export type Link_68bd1cb5a7624a969ac6cb16ab5882a3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Link template (ID: {930F134D-5678-4B35-BFD1-B77F9D0115F1}). */
export type Link_930f134d56784b35bfd1b77f9d0115f1 = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Link template (ID: {930F134D-5678-4B35-BFD1-B77F9D0115F1}). */
export type Link_930f134d56784b35bfd1b77f9d0115f1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Link template (ID: {930F134D-5678-4B35-BFD1-B77F9D0115F1}). */
export type Link_930f134d56784b35bfd1b77f9d0115f1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Link template (ID: {930F134D-5678-4B35-BFD1-B77F9D0115F1}). */
export type Link_930f134d56784b35bfd1b77f9d0115f1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Link template (ID: {930F134D-5678-4B35-BFD1-B77F9D0115F1}). */
export type Link_930f134d56784b35bfd1b77f9d0115f1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Link template (ID: {930F134D-5678-4B35-BFD1-B77F9D0115F1}). */
export type Link_930f134d56784b35bfd1b77f9d0115f1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Link template (ID: {930F134D-5678-4B35-BFD1-B77F9D0115F1}). */
export type Link_930f134d56784b35bfd1b77f9d0115f1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link template (ID: {E24E0789-A058-48BF-ABB6-C69C0E60B6B7}). */
export type Link_E24e0789a05848bfabb6c69c0e60b6b7 = Item & {
  __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Link (ID: {DD05144A-BD66-4EA3-956A-4B7104DAABA3}). */
  link?: Maybe<LinkField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link template (ID: {E24E0789-A058-48BF-ABB6-C69C0E60B6B7}). */
export type Link_E24e0789a05848bfabb6c69c0e60b6b7AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link template (ID: {E24E0789-A058-48BF-ABB6-C69C0E60B6B7}). */
export type Link_E24e0789a05848bfabb6c69c0e60b6b7ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link template (ID: {E24E0789-A058-48BF-ABB6-C69C0E60B6B7}). */
export type Link_E24e0789a05848bfabb6c69c0e60b6b7FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link template (ID: {E24E0789-A058-48BF-ABB6-C69C0E60B6B7}). */
export type Link_E24e0789a05848bfabb6c69c0e60b6b7FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link template (ID: {E24E0789-A058-48BF-ABB6-C69C0E60B6B7}). */
export type Link_E24e0789a05848bfabb6c69c0e60b6b7HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Link template (ID: {E24E0789-A058-48BF-ABB6-C69C0E60B6B7}). */
export type Link_E24e0789a05848bfabb6c69c0e60b6b7IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Links Folder template (ID: {AD8537DF-06BB-4DD3-B044-0CD5C181A219}). */
export type LinksFolder = Item & {
  __typename?: 'LinksFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Links Folder template (ID: {AD8537DF-06BB-4DD3-B044-0CD5C181A219}). */
export type LinksFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Links Folder template (ID: {AD8537DF-06BB-4DD3-B044-0CD5C181A219}). */
export type LinksFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Links Folder template (ID: {AD8537DF-06BB-4DD3-B044-0CD5C181A219}). */
export type LinksFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Links Folder template (ID: {AD8537DF-06BB-4DD3-B044-0CD5C181A219}). */
export type LinksFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Links Folder template (ID: {AD8537DF-06BB-4DD3-B044-0CD5C181A219}). */
export type LinksFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Datasource/Links Folder template (ID: {AD8537DF-06BB-4DD3-B044-0CD5C181A219}). */
export type LinksFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List template (ID: {414E5163-B964-4766-9992-9D8DE9A9023D}). */
export type List = Item & {
  __typename?: 'List';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** icon (ID: {BB3E0C80-68DE-49C0-914E-8A6509D7CDA4}). */
  icon_bb3e0c8068de49c0914e8a6509d7cda4?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {1E4783D0-92AA-491F-918D-938529204461}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List template (ID: {414E5163-B964-4766-9992-9D8DE9A9023D}). */
export type ListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List template (ID: {414E5163-B964-4766-9992-9D8DE9A9023D}). */
export type ListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List template (ID: {414E5163-B964-4766-9992-9D8DE9A9023D}). */
export type ListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List template (ID: {414E5163-B964-4766-9992-9D8DE9A9023D}). */
export type ListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List template (ID: {414E5163-B964-4766-9992-9D8DE9A9023D}). */
export type ListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List template (ID: {414E5163-B964-4766-9992-9D8DE9A9023D}). */
export type ListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/ListFacet template (ID: {6042E216-F650-447C-86D1-00FEA97454E7}). */
export type ListFacet = Facet & Item & {
  __typename?: 'ListFacet';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Client Side Handle (ID: {7F42ED80-33F0-4C98-A1E7-B15BE7551C36}). */
  clientSideHandle?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayName (ID: {5DE17054-0141-4E58-935B-FEC623A60806}). */
  displayName_5de1705401414e58935bfec623a60806?: Maybe<TextField>;
  /** Enabled (ID: {3D0FE806-D0E3-4254-96BE-A60899C7D2E6}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Global (ID: {182BD0F4-C902-4A19-A1BA-D189CAA18E1B}). */
  global?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Minimum Number of Items (ID: {8A3AC1B8-8CC1-4DD4-8766-9803F1601741}). */
  minimumNumberOfItems?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {31CA077F-EF38-4980-8A24-05408031B2BC}). */
  name_31ca077fef3849808a2405408031b2bc?: Maybe<TextField>;
  /** Parameters (ID: {0E23BB51-C071-41B5-9D83-AC410B89B85A}). */
  parameters?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {FAE92C1E-9E2C-4209-89EB-C256D55E3D7F}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/ListFacet template (ID: {6042E216-F650-447C-86D1-00FEA97454E7}). */
export type ListFacetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/ListFacet template (ID: {6042E216-F650-447C-86D1-00FEA97454E7}). */
export type ListFacetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/ListFacet template (ID: {6042E216-F650-447C-86D1-00FEA97454E7}). */
export type ListFacetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/ListFacet template (ID: {6042E216-F650-447C-86D1-00FEA97454E7}). */
export type ListFacetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/ListFacet template (ID: {6042E216-F650-447C-86D1-00FEA97454E7}). */
export type ListFacetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Facets/ListFacet template (ID: {6042E216-F650-447C-86D1-00FEA97454E7}). */
export type ListFacetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Folder template (ID: {3C248B8D-C49D-4150-9091-58EFC72F6546}). */
export type ListFolder = Item & {
  __typename?: 'ListFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Folder template (ID: {3C248B8D-C49D-4150-9091-58EFC72F6546}). */
export type ListFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Folder template (ID: {3C248B8D-C49D-4150-9091-58EFC72F6546}). */
export type ListFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Folder template (ID: {3C248B8D-C49D-4150-9091-58EFC72F6546}). */
export type ListFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Folder template (ID: {3C248B8D-C49D-4150-9091-58EFC72F6546}). */
export type ListFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Folder template (ID: {3C248B8D-C49D-4150-9091-58EFC72F6546}). */
export type ListFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Folder template (ID: {3C248B8D-C49D-4150-9091-58EFC72F6546}). */
export type ListFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Item template (ID: {7A7B682D-4C62-4B21-B5BB-5487EA16A03A}). */
export type ListItem = Item & {
  __typename?: 'ListItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {49F9D250-D8FA-4B50-9168-24F7E6E2B2E9}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {7554E311-8DFD-4015-BD00-739D478042C9}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {578C884C-87D1-4798-B31F-B1AA38ED0861}). */
  title?: Maybe<RichTextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Item template (ID: {7A7B682D-4C62-4B21-B5BB-5487EA16A03A}). */
export type ListItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Item template (ID: {7A7B682D-4C62-4B21-B5BB-5487EA16A03A}). */
export type ListItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Item template (ID: {7A7B682D-4C62-4B21-B5BB-5487EA16A03A}). */
export type ListItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Item template (ID: {7A7B682D-4C62-4B21-B5BB-5487EA16A03A}). */
export type ListItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Item template (ID: {7A7B682D-4C62-4B21-B5BB-5487EA16A03A}). */
export type ListItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/List/List Item template (ID: {7A7B682D-4C62-4B21-B5BB-5487EA16A03A}). */
export type ListItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/List Parameters Template template (ID: {E03F6DDA-7098-4C32-8B51-C761B98AF336}). */
export type ListParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'ListParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** style (ID: {2A5BECA2-D0A6-42C0-92F7-93DE2056FC2B}). */
  style?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/List Parameters Template template (ID: {E03F6DDA-7098-4C32-8B51-C761B98AF336}). */
export type ListParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/List Parameters Template template (ID: {E03F6DDA-7098-4C32-8B51-C761B98AF336}). */
export type ListParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/List Parameters Template template (ID: {E03F6DDA-7098-4C32-8B51-C761B98AF336}). */
export type ListParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/List Parameters Template template (ID: {E03F6DDA-7098-4C32-8B51-C761B98AF336}). */
export type ListParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/List Parameters Template template (ID: {E03F6DDA-7098-4C32-8B51-C761B98AF336}). */
export type ListParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/List Parameters Template template (ID: {E03F6DDA-7098-4C32-8B51-C761B98AF336}). */
export type ListParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style template (ID: {3EEBC330-6B31-4485-BAFB-D8D7E4788718}). */
export type ListStyle = Item & {
  __typename?: 'ListStyle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style template (ID: {3EEBC330-6B31-4485-BAFB-D8D7E4788718}). */
export type ListStyleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style template (ID: {3EEBC330-6B31-4485-BAFB-D8D7E4788718}). */
export type ListStyleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style template (ID: {3EEBC330-6B31-4485-BAFB-D8D7E4788718}). */
export type ListStyleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style template (ID: {3EEBC330-6B31-4485-BAFB-D8D7E4788718}). */
export type ListStyleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style template (ID: {3EEBC330-6B31-4485-BAFB-D8D7E4788718}). */
export type ListStyleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style template (ID: {3EEBC330-6B31-4485-BAFB-D8D7E4788718}). */
export type ListStyleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style Item template (ID: {94DA0EB0-EE3C-4AC9-9276-DA02FE9F8E32}). */
export type ListStyleItem = Item & {
  __typename?: 'ListStyleItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style Item template (ID: {94DA0EB0-EE3C-4AC9-9276-DA02FE9F8E32}). */
export type ListStyleItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style Item template (ID: {94DA0EB0-EE3C-4AC9-9276-DA02FE9F8E32}). */
export type ListStyleItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style Item template (ID: {94DA0EB0-EE3C-4AC9-9276-DA02FE9F8E32}). */
export type ListStyleItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style Item template (ID: {94DA0EB0-EE3C-4AC9-9276-DA02FE9F8E32}). */
export type ListStyleItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style Item template (ID: {94DA0EB0-EE3C-4AC9-9276-DA02FE9F8E32}). */
export type ListStyleItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/List/List Style Item template (ID: {94DA0EB0-EE3C-4AC9-9276-DA02FE9F8E32}). */
export type ListStyleItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Listing Hero Banner template (ID: {22F166E3-BACB-4D3E-9E8D-BAF807D049AD}). */
export type ListingHeroBanner = Item & {
  __typename?: 'ListingHeroBanner';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {779A4992-8A74-4C4D-BC20-37D60342110A}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {64FBC798-27F6-4EA7-A2DC-BFA30C3D54AF}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Listing Hero Banner template (ID: {22F166E3-BACB-4D3E-9E8D-BAF807D049AD}). */
export type ListingHeroBannerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Listing Hero Banner template (ID: {22F166E3-BACB-4D3E-9E8D-BAF807D049AD}). */
export type ListingHeroBannerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Listing Hero Banner template (ID: {22F166E3-BACB-4D3E-9E8D-BAF807D049AD}). */
export type ListingHeroBannerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Listing Hero Banner template (ID: {22F166E3-BACB-4D3E-9E8D-BAF807D049AD}). */
export type ListingHeroBannerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Listing Hero Banner template (ID: {22F166E3-BACB-4D3E-9E8D-BAF807D049AD}). */
export type ListingHeroBannerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Listing Hero Banner template (ID: {22F166E3-BACB-4D3E-9E8D-BAF807D049AD}). */
export type ListingHeroBannerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Listing Hero Parameters Template template (ID: {34247118-BCB2-456B-B3C0-B4B26D25C87F}). */
export type ListingHeroParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'ListingHeroParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {2A787877-D096-4D57-B0CE-BDB4255C937C}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Listing Hero Parameters Template template (ID: {34247118-BCB2-456B-B3C0-B4B26D25C87F}). */
export type ListingHeroParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Listing Hero Parameters Template template (ID: {34247118-BCB2-456B-B3C0-B4B26D25C87F}). */
export type ListingHeroParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Listing Hero Parameters Template template (ID: {34247118-BCB2-456B-B3C0-B4B26D25C87F}). */
export type ListingHeroParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Listing Hero Parameters Template template (ID: {34247118-BCB2-456B-B3C0-B4B26D25C87F}). */
export type ListingHeroParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Listing Hero Parameters Template template (ID: {34247118-BCB2-456B-B3C0-B4B26D25C87F}). */
export type ListingHeroParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Listing Hero Parameters Template template (ID: {34247118-BCB2-456B-B3C0-B4B26D25C87F}). */
export type ListingHeroParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorization template (ID: {AE6D7915-AB79-4DC3-A903-EDD91B49DAC8}). */
export type LiteratureAuthorization = Item & {
  __typename?: 'LiteratureAuthorization';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** id (ID: {A0580CB7-6698-436C-9ED9-F832F8B24324}). */
  id_a0580cb76698436c9ed9f832f8b24324?: Maybe<NumberField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorization template (ID: {AE6D7915-AB79-4DC3-A903-EDD91B49DAC8}). */
export type LiteratureAuthorizationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorization template (ID: {AE6D7915-AB79-4DC3-A903-EDD91B49DAC8}). */
export type LiteratureAuthorizationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorization template (ID: {AE6D7915-AB79-4DC3-A903-EDD91B49DAC8}). */
export type LiteratureAuthorizationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorization template (ID: {AE6D7915-AB79-4DC3-A903-EDD91B49DAC8}). */
export type LiteratureAuthorizationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorization template (ID: {AE6D7915-AB79-4DC3-A903-EDD91B49DAC8}). */
export type LiteratureAuthorizationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorization template (ID: {AE6D7915-AB79-4DC3-A903-EDD91B49DAC8}). */
export type LiteratureAuthorizationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorizations Folder template (ID: {71A491F7-D814-455C-ABF8-229E761745CE}). */
export type LiteratureAuthorizationsFolder = Item & {
  __typename?: 'LiteratureAuthorizationsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorizations Folder template (ID: {71A491F7-D814-455C-ABF8-229E761745CE}). */
export type LiteratureAuthorizationsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorizations Folder template (ID: {71A491F7-D814-455C-ABF8-229E761745CE}). */
export type LiteratureAuthorizationsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorizations Folder template (ID: {71A491F7-D814-455C-ABF8-229E761745CE}). */
export type LiteratureAuthorizationsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorizations Folder template (ID: {71A491F7-D814-455C-ABF8-229E761745CE}). */
export type LiteratureAuthorizationsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorizations Folder template (ID: {71A491F7-D814-455C-ABF8-229E761745CE}). */
export type LiteratureAuthorizationsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/Literature Authorizations Folder template (ID: {71A491F7-D814-455C-ABF8-229E761745CE}). */
export type LiteratureAuthorizationsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Literature Hub Search Page template (ID: {11A58142-9715-4735-A69A-034D3A75C9D0}). */
export type LiteratureHubSearchPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'LiteratureHubSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Literature Hub Search Page template (ID: {11A58142-9715-4735-A69A-034D3A75C9D0}). */
export type LiteratureHubSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Literature Hub Search Page template (ID: {11A58142-9715-4735-A69A-034D3A75C9D0}). */
export type LiteratureHubSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Literature Hub Search Page template (ID: {11A58142-9715-4735-A69A-034D3A75C9D0}). */
export type LiteratureHubSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Literature Hub Search Page template (ID: {11A58142-9715-4735-A69A-034D3A75C9D0}). */
export type LiteratureHubSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Literature Hub Search Page template (ID: {11A58142-9715-4735-A69A-034D3A75C9D0}). */
export type LiteratureHubSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Literature Hub Search Page template (ID: {11A58142-9715-4735-A69A-034D3A75C9D0}). */
export type LiteratureHubSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Literature Hub Search Page template (ID: {62F4748B-81DB-49EE-9BE8-B674A7F42D9D}). */
export type LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Literature Hub Search Page template (ID: {62F4748B-81DB-49EE-9BE8-B674A7F42D9D}). */
export type LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Literature Hub Search Page template (ID: {62F4748B-81DB-49EE-9BE8-B674A7F42D9D}). */
export type LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Literature Hub Search Page template (ID: {62F4748B-81DB-49EE-9BE8-B674A7F42D9D}). */
export type LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Literature Hub Search Page template (ID: {62F4748B-81DB-49EE-9BE8-B674A7F42D9D}). */
export type LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Literature Hub Search Page template (ID: {62F4748B-81DB-49EE-9BE8-B674A7F42D9D}). */
export type LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Literature Hub Search Page template (ID: {62F4748B-81DB-49EE-9BE8-B674A7F42D9D}). */
export type LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Literature Hub Search Page template (ID: {94278FE5-377A-4665-BCCB-D1D4CEF5E30E}). */
export type LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Literature Hub Search Page template (ID: {94278FE5-377A-4665-BCCB-D1D4CEF5E30E}). */
export type LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Literature Hub Search Page template (ID: {94278FE5-377A-4665-BCCB-D1D4CEF5E30E}). */
export type LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Literature Hub Search Page template (ID: {94278FE5-377A-4665-BCCB-D1D4CEF5E30E}). */
export type LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Literature Hub Search Page template (ID: {94278FE5-377A-4665-BCCB-D1D4CEF5E30E}). */
export type LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Literature Hub Search Page template (ID: {94278FE5-377A-4665-BCCB-D1D4CEF5E30E}). */
export type LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Literature Hub Search Page template (ID: {94278FE5-377A-4665-BCCB-D1D4CEF5E30E}). */
export type LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Literature Hub Search Page template (ID: {D2B29582-6356-4BA8-BBA5-922ADD46A0EA}). */
export type LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Literature Hub Search Page template (ID: {D2B29582-6356-4BA8-BBA5-922ADD46A0EA}). */
export type LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0eaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Literature Hub Search Page template (ID: {D2B29582-6356-4BA8-BBA5-922ADD46A0EA}). */
export type LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0eaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Literature Hub Search Page template (ID: {D2B29582-6356-4BA8-BBA5-922ADD46A0EA}). */
export type LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0eaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Literature Hub Search Page template (ID: {D2B29582-6356-4BA8-BBA5-922ADD46A0EA}). */
export type LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0eaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Literature Hub Search Page template (ID: {D2B29582-6356-4BA8-BBA5-922ADD46A0EA}). */
export type LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0eaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Literature Hub Search Page template (ID: {D2B29582-6356-4BA8-BBA5-922ADD46A0EA}). */
export type LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0eaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Load More template (ID: {6AE084B6-4EFE-43F0-84A3-3A9772D3D70F}). */
export type LoadMore = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'LoadMore';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Load More template (ID: {6AE084B6-4EFE-43F0-84A3-3A9772D3D70F}). */
export type LoadMoreAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Load More template (ID: {6AE084B6-4EFE-43F0-84A3-3A9772D3D70F}). */
export type LoadMoreChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Load More template (ID: {6AE084B6-4EFE-43F0-84A3-3A9772D3D70F}). */
export type LoadMoreFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Load More template (ID: {6AE084B6-4EFE-43F0-84A3-3A9772D3D70F}). */
export type LoadMoreFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Load More template (ID: {6AE084B6-4EFE-43F0-84A3-3A9772D3D70F}). */
export type LoadMoreHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Load More template (ID: {6AE084B6-4EFE-43F0-84A3-3A9772D3D70F}). */
export type LoadMoreIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Load More Folder template (ID: {59AA313D-90C3-4813-976D-CE440E1C9B10}). */
export type LoadMoreFolder = Item & {
  __typename?: 'LoadMoreFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Load More Folder template (ID: {59AA313D-90C3-4813-976D-CE440E1C9B10}). */
export type LoadMoreFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Load More Folder template (ID: {59AA313D-90C3-4813-976D-CE440E1C9B10}). */
export type LoadMoreFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Load More Folder template (ID: {59AA313D-90C3-4813-976D-CE440E1C9B10}). */
export type LoadMoreFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Load More Folder template (ID: {59AA313D-90C3-4813-976D-CE440E1C9B10}). */
export type LoadMoreFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Load More Folder template (ID: {59AA313D-90C3-4813-976D-CE440E1C9B10}). */
export type LoadMoreFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Load More Folder template (ID: {59AA313D-90C3-4813-976D-CE440E1C9B10}). */
export type LoadMoreFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Load More template (ID: {7A3A53E0-6A01-44FF-8BA5-2BE46E201FE6}). */
export type LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = Item & {
  __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Load More Label (ID: {DE3D2735-E01C-4F2C-B9DF-BA67E1BD0065}). */
  loadMoreLabel?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Load More template (ID: {7A3A53E0-6A01-44FF-8BA5-2BE46E201FE6}). */
export type LoadMore_7a3a53e06a0144ff8ba52be46e201fe6AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Load More template (ID: {7A3A53E0-6A01-44FF-8BA5-2BE46E201FE6}). */
export type LoadMore_7a3a53e06a0144ff8ba52be46e201fe6ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Load More template (ID: {7A3A53E0-6A01-44FF-8BA5-2BE46E201FE6}). */
export type LoadMore_7a3a53e06a0144ff8ba52be46e201fe6FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Load More template (ID: {7A3A53E0-6A01-44FF-8BA5-2BE46E201FE6}). */
export type LoadMore_7a3a53e06a0144ff8ba52be46e201fe6FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Load More template (ID: {7A3A53E0-6A01-44FF-8BA5-2BE46E201FE6}). */
export type LoadMore_7a3a53e06a0144ff8ba52be46e201fe6HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Load More template (ID: {7A3A53E0-6A01-44FF-8BA5-2BE46E201FE6}). */
export type LoadMore_7a3a53e06a0144ff8ba52be46e201fe6IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Location Filter template (ID: {95BAF527-4502-4CDB-B331-BAAB664417AE}). */
export type LocationFilter = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'LocationFilter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MaxPredictiveResultsCount (ID: {84CFB8D3-8F74-4DF1-BEC7-F649697A8D30}). */
  maxPredictiveResultsCount?: Maybe<IntegerField>;
  /** Mode (ID: {DAA889FE-51EF-44CF-A68B-148CB0FE534B}). */
  mode?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Location Filter template (ID: {95BAF527-4502-4CDB-B331-BAAB664417AE}). */
export type LocationFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Location Filter template (ID: {95BAF527-4502-4CDB-B331-BAAB664417AE}). */
export type LocationFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Location Filter template (ID: {95BAF527-4502-4CDB-B331-BAAB664417AE}). */
export type LocationFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Location Filter template (ID: {95BAF527-4502-4CDB-B331-BAAB664417AE}). */
export type LocationFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Location Filter template (ID: {95BAF527-4502-4CDB-B331-BAAB664417AE}). */
export type LocationFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Location Filter template (ID: {95BAF527-4502-4CDB-B331-BAAB664417AE}). */
export type LocationFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Location Filter Folder template (ID: {C8E2A53C-6EAC-49E2-BBC6-3EA8D0861834}). */
export type LocationFilterFolder = Item & {
  __typename?: 'LocationFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Location Filter Folder template (ID: {C8E2A53C-6EAC-49E2-BBC6-3EA8D0861834}). */
export type LocationFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Location Filter Folder template (ID: {C8E2A53C-6EAC-49E2-BBC6-3EA8D0861834}). */
export type LocationFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Location Filter Folder template (ID: {C8E2A53C-6EAC-49E2-BBC6-3EA8D0861834}). */
export type LocationFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Location Filter Folder template (ID: {C8E2A53C-6EAC-49E2-BBC6-3EA8D0861834}). */
export type LocationFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Location Filter Folder template (ID: {C8E2A53C-6EAC-49E2-BBC6-3EA8D0861834}). */
export type LocationFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Location Filter Folder template (ID: {C8E2A53C-6EAC-49E2-BBC6-3EA8D0861834}). */
export type LocationFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Location Filter template (ID: {AAAD4AAD-2907-44DC-90B6-9E4E83A661EC}). */
export type LocationFilter_Aaad4aad290744dc90b69e4e83a661ec = Item & {
  __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Facet (ID: {8A67FCA9-7E15-4B7C-B6B8-86F37CAFE720}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** My Location Text (ID: {2D51C8E8-AF57-4B64-80FA-C989667E3B67}). */
  myLocationText?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Search Button Text (ID: {250020AD-40D0-4D04-A79C-3AAC82FE9AEB}). */
  searchButtonText?: Maybe<TextField>;
  /** SearchTextBoxLabel (ID: {E4F59DD9-04C3-4B60-921D-2F62926856E8}). */
  searchTextBoxLabel?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TextBoxText (ID: {E2A1B879-FC25-4F04-8466-85AA7F235C47}). */
  textBoxText?: Maybe<TextField>;
  /** Title (ID: {4F3BB1A9-E899-4933-A06F-B139CF5DE927}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Location Filter template (ID: {AAAD4AAD-2907-44DC-90B6-9E4E83A661EC}). */
export type LocationFilter_Aaad4aad290744dc90b69e4e83a661ecAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Location Filter template (ID: {AAAD4AAD-2907-44DC-90B6-9E4E83A661EC}). */
export type LocationFilter_Aaad4aad290744dc90b69e4e83a661ecChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Location Filter template (ID: {AAAD4AAD-2907-44DC-90B6-9E4E83A661EC}). */
export type LocationFilter_Aaad4aad290744dc90b69e4e83a661ecFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Location Filter template (ID: {AAAD4AAD-2907-44DC-90B6-9E4E83A661EC}). */
export type LocationFilter_Aaad4aad290744dc90b69e4e83a661ecFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Location Filter template (ID: {AAAD4AAD-2907-44DC-90B6-9E4E83A661EC}). */
export type LocationFilter_Aaad4aad290744dc90b69e4e83a661ecHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Location Filter template (ID: {AAAD4AAD-2907-44DC-90B6-9E4E83A661EC}). */
export type LocationFilter_Aaad4aad290744dc90b69e4e83a661ecIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Log template (ID: {0DF19F56-1F6D-4B60-9640-C2A9E5858365}). */
export type Log = Item & {
  __typename?: 'Log';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** UpdateLog (ID: {6FEBC49A-1285-43E7-99DC-9F2C8E703557}). */
  updateLog?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Log template (ID: {0DF19F56-1F6D-4B60-9640-C2A9E5858365}). */
export type LogAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Log template (ID: {0DF19F56-1F6D-4B60-9640-C2A9E5858365}). */
export type LogChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Log template (ID: {0DF19F56-1F6D-4B60-9640-C2A9E5858365}). */
export type LogFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Log template (ID: {0DF19F56-1F6D-4B60-9640-C2A9E5858365}). */
export type LogFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Log template (ID: {0DF19F56-1F6D-4B60-9640-C2A9E5858365}). */
export type LogHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Log template (ID: {0DF19F56-1F6D-4B60-9640-C2A9E5858365}). */
export type LogIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Login template (ID: {8807C9D3-406D-419A-9262-D8F3EAE6832C}). */
export type Login = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Login';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Login template (ID: {8807C9D3-406D-419A-9262-D8F3EAE6832C}). */
export type LoginAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Login template (ID: {8807C9D3-406D-419A-9262-D8F3EAE6832C}). */
export type LoginChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Login template (ID: {8807C9D3-406D-419A-9262-D8F3EAE6832C}). */
export type LoginFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Login template (ID: {8807C9D3-406D-419A-9262-D8F3EAE6832C}). */
export type LoginFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Login template (ID: {8807C9D3-406D-419A-9262-D8F3EAE6832C}). */
export type LoginHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Login template (ID: {8807C9D3-406D-419A-9262-D8F3EAE6832C}). */
export type LoginIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Login template (ID: {ABED54DC-4F78-40DD-AC56-2289C9C849D8}). */
export type Login_Abed54dc4f7840ddac562289c9c849d8 = Item & {
  __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DestinationUrl (ID: {D7BE3834-097A-4151-827D-D852B54FF530}). */
  destinationUrl?: Maybe<LinkField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayRememberMe (ID: {82D265E1-99D0-4A5F-964F-775A14DACE71}). */
  displayRememberMe?: Maybe<CheckboxField>;
  /** FailureText (ID: {BC5CD635-130E-4A03-A5D0-E1AFB9AE6055}). */
  failureText?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Introduction (ID: {6E6C0B3C-7041-4FFA-B0FC-849D1975D368}). */
  introduction?: Maybe<RichTextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LoginButtonCaption (ID: {99C9FDD7-4503-489B-8A21-115B963AA341}). */
  loginButtonCaption?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** PasswordLabel (ID: {B80F0331-68E7-4515-8485-903B5C8B2390}). */
  passwordLabel?: Maybe<TextField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** RememberMeLabel (ID: {129B54AB-7D51-4C6B-899C-642BB3EE4B85}). */
  rememberMeLabel?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UsernameLabel (ID: {53E213E6-E020-4C32-A559-EC90B5B67179}). */
  usernameLabel?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Login template (ID: {ABED54DC-4F78-40DD-AC56-2289C9C849D8}). */
export type Login_Abed54dc4f7840ddac562289c9c849d8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Login template (ID: {ABED54DC-4F78-40DD-AC56-2289C9C849D8}). */
export type Login_Abed54dc4f7840ddac562289c9c849d8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Login template (ID: {ABED54DC-4F78-40DD-AC56-2289C9C849D8}). */
export type Login_Abed54dc4f7840ddac562289c9c849d8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Login template (ID: {ABED54DC-4F78-40DD-AC56-2289C9C849D8}). */
export type Login_Abed54dc4f7840ddac562289c9c849d8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Login template (ID: {ABED54DC-4F78-40DD-AC56-2289C9C849D8}). */
export type Login_Abed54dc4f7840ddac562289c9c849d8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Login template (ID: {ABED54DC-4F78-40DD-AC56-2289C9C849D8}). */
export type Login_Abed54dc4f7840ddac562289c9c849d8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Block Item template (ID: {7F5209A2-CE3A-449A-8FA7-ED3B4133FC90}). */
export type LogoTextBlockItem = Item & {
  __typename?: 'LogoTextBlockItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {C4633AC9-F800-4B9A-9D37-04815B3EC623}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {E665E73D-B01C-4E45-8E7E-991BEE47F6C1}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {4E0EBC5B-CD21-43AC-8D87-27B35727E842}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Block Item template (ID: {7F5209A2-CE3A-449A-8FA7-ED3B4133FC90}). */
export type LogoTextBlockItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Block Item template (ID: {7F5209A2-CE3A-449A-8FA7-ED3B4133FC90}). */
export type LogoTextBlockItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Block Item template (ID: {7F5209A2-CE3A-449A-8FA7-ED3B4133FC90}). */
export type LogoTextBlockItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Block Item template (ID: {7F5209A2-CE3A-449A-8FA7-ED3B4133FC90}). */
export type LogoTextBlockItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Block Item template (ID: {7F5209A2-CE3A-449A-8FA7-ED3B4133FC90}). */
export type LogoTextBlockItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Block Item template (ID: {7F5209A2-CE3A-449A-8FA7-ED3B4133FC90}). */
export type LogoTextBlockItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks template (ID: {345006BB-A6BC-4160-82F7-637FB8C9F14F}). */
export type LogoTextBlocks = Item & {
  __typename?: 'LogoTextBlocks';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {64F2B981-0FDA-4DCC-B76B-C385AB69A567}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {14C7A65B-C529-4FF5-8511-7134790B591F}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks template (ID: {345006BB-A6BC-4160-82F7-637FB8C9F14F}). */
export type LogoTextBlocksAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks template (ID: {345006BB-A6BC-4160-82F7-637FB8C9F14F}). */
export type LogoTextBlocksChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks template (ID: {345006BB-A6BC-4160-82F7-637FB8C9F14F}). */
export type LogoTextBlocksFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks template (ID: {345006BB-A6BC-4160-82F7-637FB8C9F14F}). */
export type LogoTextBlocksFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks template (ID: {345006BB-A6BC-4160-82F7-637FB8C9F14F}). */
export type LogoTextBlocksHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks template (ID: {345006BB-A6BC-4160-82F7-637FB8C9F14F}). */
export type LogoTextBlocksIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks Folder template (ID: {7526A4CC-8994-4251-BA82-5AC8F1574DA6}). */
export type LogoTextBlocksFolder = Item & {
  __typename?: 'LogoTextBlocksFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks Folder template (ID: {7526A4CC-8994-4251-BA82-5AC8F1574DA6}). */
export type LogoTextBlocksFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks Folder template (ID: {7526A4CC-8994-4251-BA82-5AC8F1574DA6}). */
export type LogoTextBlocksFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks Folder template (ID: {7526A4CC-8994-4251-BA82-5AC8F1574DA6}). */
export type LogoTextBlocksFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks Folder template (ID: {7526A4CC-8994-4251-BA82-5AC8F1574DA6}). */
export type LogoTextBlocksFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks Folder template (ID: {7526A4CC-8994-4251-BA82-5AC8F1574DA6}). */
export type LogoTextBlocksFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Logo Text Blocks/Logo Text Blocks Folder template (ID: {7526A4CC-8994-4251-BA82-5AC8F1574DA6}). */
export type LogoTextBlocksFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Logout template (ID: {8DCA82CE-40C6-46B2-B602-665946965384}). */
export type Logout = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Logout';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Logout template (ID: {8DCA82CE-40C6-46B2-B602-665946965384}). */
export type LogoutAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Logout template (ID: {8DCA82CE-40C6-46B2-B602-665946965384}). */
export type LogoutChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Logout template (ID: {8DCA82CE-40C6-46B2-B602-665946965384}). */
export type LogoutFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Logout template (ID: {8DCA82CE-40C6-46B2-B602-665946965384}). */
export type LogoutFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Logout template (ID: {8DCA82CE-40C6-46B2-B602-665946965384}). */
export type LogoutHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Logout template (ID: {8DCA82CE-40C6-46B2-B602-665946965384}). */
export type LogoutIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Logout template (ID: {C2294D82-35A6-452A-94B1-5EB5E543B602}). */
export type Logout_C2294d8235a6452a94b15eb5e543b602 = Item & {
  __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DestinationUrl (ID: {13B96AFD-2685-4C98-B2AC-D44D49893807}). */
  destinationUrl?: Maybe<LinkField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DisplayUsername (ID: {8A12EFAE-3CB2-49DA-817F-9C8B159BA45A}). */
  displayUsername?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Introduction (ID: {C28B5524-3740-4DC2-B5BF-9CF7B6434A19}). */
  introduction?: Maybe<RichTextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LogoutLinkCaption (ID: {8A83D191-8F06-4AB2-9600-1968BEBF0805}). */
  logoutLinkCaption?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Logout template (ID: {C2294D82-35A6-452A-94B1-5EB5E543B602}). */
export type Logout_C2294d8235a6452a94b15eb5e543b602AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Logout template (ID: {C2294D82-35A6-452A-94B1-5EB5E543B602}). */
export type Logout_C2294d8235a6452a94b15eb5e543b602ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Logout template (ID: {C2294D82-35A6-452A-94B1-5EB5E543B602}). */
export type Logout_C2294d8235a6452a94b15eb5e543b602FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Logout template (ID: {C2294D82-35A6-452A-94B1-5EB5E543B602}). */
export type Logout_C2294d8235a6452a94b15eb5e543b602FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Logout template (ID: {C2294D82-35A6-452A-94B1-5EB5E543B602}). */
export type Logout_C2294d8235a6452a94b15eb5e543b602HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Logout template (ID: {C2294D82-35A6-452A-94B1-5EB5E543B602}). */
export type Logout_C2294d8235a6452a94b15eb5e543b602IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type LookupField = ItemField & {
  __typename?: 'LookupField';
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** The item ID that this field references. */
  targetId?: Maybe<Scalars['ID']['output']>;
  /** The item that this field references. */
  targetItem?: Maybe<Item>;
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type LookupFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type LookupFieldTargetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/Managed Range Filter template (ID: {B3C7D7EF-474B-4447-A138-7894632CE199}). */
export type ManagedRangeFilter = FacetSelectorConfigBase & Item & {
  __typename?: 'ManagedRangeFilter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Facet (ID: {42C9489B-01B9-4533-9CAC-1A84A4B4AB65}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** From Label (ID: {8C61C2D2-3B16-4E39-831D-9E45ABB9454C}). */
  fromLabel?: Maybe<TextField>;
  /** Go Button Label (ID: {0D2AD3B3-AFF3-4EB3-B186-EFE2EE02DE2E}). */
  goButtonLabel?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** To Label (ID: {3020EF4A-7B7F-4ED3-A220-2D78CF210974}). */
  toLabel?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/Managed Range Filter template (ID: {B3C7D7EF-474B-4447-A138-7894632CE199}). */
export type ManagedRangeFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/Managed Range Filter template (ID: {B3C7D7EF-474B-4447-A138-7894632CE199}). */
export type ManagedRangeFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/Managed Range Filter template (ID: {B3C7D7EF-474B-4447-A138-7894632CE199}). */
export type ManagedRangeFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/Managed Range Filter template (ID: {B3C7D7EF-474B-4447-A138-7894632CE199}). */
export type ManagedRangeFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/Managed Range Filter template (ID: {B3C7D7EF-474B-4447-A138-7894632CE199}). */
export type ManagedRangeFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/Managed Range Filter template (ID: {B3C7D7EF-474B-4447-A138-7894632CE199}). */
export type ManagedRangeFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Managed Range Filter Folder template (ID: {670A7E82-78A6-4B25-A710-1E2E8F72515A}). */
export type ManagedRangeFilterFolder = Item & {
  __typename?: 'ManagedRangeFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Managed Range Filter Folder template (ID: {670A7E82-78A6-4B25-A710-1E2E8F72515A}). */
export type ManagedRangeFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Managed Range Filter Folder template (ID: {670A7E82-78A6-4B25-A710-1E2E8F72515A}). */
export type ManagedRangeFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Managed Range Filter Folder template (ID: {670A7E82-78A6-4B25-A710-1E2E8F72515A}). */
export type ManagedRangeFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Managed Range Filter Folder template (ID: {670A7E82-78A6-4B25-A710-1E2E8F72515A}). */
export type ManagedRangeFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Managed Range Filter Folder template (ID: {670A7E82-78A6-4B25-A710-1E2E8F72515A}). */
export type ManagedRangeFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Managed Range Filter Folder template (ID: {670A7E82-78A6-4B25-A710-1E2E8F72515A}). */
export type ManagedRangeFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Managed Range Filter template (ID: {14C6033E-186B-4908-8BB9-25ABA0DA4D91}). */
export type ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Managed Range Mode (ID: {307E3251-4140-456B-BCCC-497F2AE83D4C}). */
  managedRangeMode?: Maybe<CheckboxField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Ranges (ID: {121FE88D-14A6-4A42-AA1D-5D3D0DF2B282}). */
  ranges?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Selected Max Value (ID: {F87DEB6D-C671-4E65-BA4F-401E596A8B8B}). */
  selectedMaxValue?: Maybe<TextField>;
  /** Selected Min Value (ID: {E15BE5DF-00E1-4B9A-B6C7-4639775768B7}). */
  selectedMinValue?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Managed Range Filter template (ID: {14C6033E-186B-4908-8BB9-25ABA0DA4D91}). */
export type ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Managed Range Filter template (ID: {14C6033E-186B-4908-8BB9-25ABA0DA4D91}). */
export type ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Managed Range Filter template (ID: {14C6033E-186B-4908-8BB9-25ABA0DA4D91}). */
export type ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Managed Range Filter template (ID: {14C6033E-186B-4908-8BB9-25ABA0DA4D91}). */
export type ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Managed Range Filter template (ID: {14C6033E-186B-4908-8BB9-25ABA0DA4D91}). */
export type ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Managed Range Filter template (ID: {14C6033E-186B-4908-8BB9-25ABA0DA4D91}). */
export type ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/ManagedRangeItem template (ID: {958FFBDC-F1E1-4486-8667-C2DD451F5E31}). */
export type ManagedRangeItem = Item & {
  __typename?: 'ManagedRangeItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Max Value (ID: {55215831-D3C0-450A-AE0E-6F10E74B56BE}). */
  maxValue?: Maybe<TextField>;
  /** Min Value (ID: {BD38A8A0-C8BB-42CA-9783-C80296FE8BAC}). */
  minValue?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {77F05FD0-6463-4A57-A37E-C2232293C891}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/ManagedRangeItem template (ID: {958FFBDC-F1E1-4486-8667-C2DD451F5E31}). */
export type ManagedRangeItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/ManagedRangeItem template (ID: {958FFBDC-F1E1-4486-8667-C2DD451F5E31}). */
export type ManagedRangeItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/ManagedRangeItem template (ID: {958FFBDC-F1E1-4486-8667-C2DD451F5E31}). */
export type ManagedRangeItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/ManagedRangeItem template (ID: {958FFBDC-F1E1-4486-8667-C2DD451F5E31}). */
export type ManagedRangeItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/ManagedRangeItem template (ID: {958FFBDC-F1E1-4486-8667-C2DD451F5E31}). */
export type ManagedRangeItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Managed Range Filter Items/ManagedRangeItem template (ID: {958FFBDC-F1E1-4486-8667-C2DD451F5E31}). */
export type ManagedRangeItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Maps/Map template (ID: {0AACD498-CEA9-4E37-8CA0-61D1F024FB34}). */
export type Map = Item & {
  __typename?: 'Map';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Central Point Latitude (ID: {FCC4F148-2F8A-4310-A898-C38FEE380E9E}). */
  centralPointLatidiute?: Maybe<TextField>;
  /** Central Point Longitude (ID: {37B1DD2C-AC94-4281-B9B5-C6437028072A}). */
  centralPointLongitude?: Maybe<TextField>;
  /** Central Point Mode (ID: {D9DD5DE6-AF41-4D3B-9F73-4FF9BD05898B}). */
  centralPointMode?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Height (ID: {AD71F7F9-2690-4B61-936B-DADF18455792}). */
  height?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Mode (ID: {A07C174F-60F9-467F-8A05-6F272F22F4EA}). */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** POI (ID: {DF9686EE-85F7-4AD3-BDD2-8A28D31740DF}). */
  pOI?: Maybe<MultilistField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type To Variant Mapping (ID: {BD834612-4BFA-45FF-B1CE-05A87B9755AD}). */
  typeToVariantMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Width (ID: {61BBF86D-0746-47DB-92BD-3183D997CBE5}). */
  width?: Maybe<TextField>;
  /** Zoom (ID: {54ADDAE0-9C54-42A0-9220-5AAAC5312E1A}). */
  zoom?: Maybe<LookupField>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Map template (ID: {0AACD498-CEA9-4E37-8CA0-61D1F024FB34}). */
export type MapAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Map template (ID: {0AACD498-CEA9-4E37-8CA0-61D1F024FB34}). */
export type MapChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Map template (ID: {0AACD498-CEA9-4E37-8CA0-61D1F024FB34}). */
export type MapFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Map template (ID: {0AACD498-CEA9-4E37-8CA0-61D1F024FB34}). */
export type MapFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Map template (ID: {0AACD498-CEA9-4E37-8CA0-61D1F024FB34}). */
export type MapHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Map template (ID: {0AACD498-CEA9-4E37-8CA0-61D1F024FB34}). */
export type MapIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Maps/Rendering Parameters/Map Parameters template (ID: {05BDDF01-A0B8-4209-ACCA-6FE01C64F09D}). */
export type MapParameters = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'MapParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Animate Found POI (ID: {4AE0252D-31CE-4807-A4E7-159549819D0A}). */
  animateFoundPOI?: Maybe<CheckboxField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Center On Found POI (ID: {4A6CAC72-E0F0-4B2F-AA63-143CF43567A1}). */
  centerOnFoundPOI?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** Disable Map Scrolling (ID: {CF2A59FD-8DC8-4AB1-95DF-195D1B6F2BD9}). */
  disableMapScrolling?: Maybe<CheckboxField>;
  /** Disable Map Zoom On Scroll (ID: {D33CF492-CF65-4400-9246-81D4D77D7337}). */
  disableMapZoomOnScroll?: Maybe<CheckboxField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Search Results Signature (ID: {455F0146-D35F-476C-9165-7CE431F79A38}). */
  signature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Rendering Parameters/Map Parameters template (ID: {05BDDF01-A0B8-4209-ACCA-6FE01C64F09D}). */
export type MapParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Rendering Parameters/Map Parameters template (ID: {05BDDF01-A0B8-4209-ACCA-6FE01C64F09D}). */
export type MapParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Rendering Parameters/Map Parameters template (ID: {05BDDF01-A0B8-4209-ACCA-6FE01C64F09D}). */
export type MapParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Rendering Parameters/Map Parameters template (ID: {05BDDF01-A0B8-4209-ACCA-6FE01C64F09D}). */
export type MapParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Rendering Parameters/Map Parameters template (ID: {05BDDF01-A0B8-4209-ACCA-6FE01C64F09D}). */
export type MapParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Rendering Parameters/Map Parameters template (ID: {05BDDF01-A0B8-4209-ACCA-6FE01C64F09D}). */
export type MapParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Maps/Maps Folder template (ID: {8302B292-E67B-4396-BA95-B4F8289249FC}). */
export type MapsFolder = Item & {
  __typename?: 'MapsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Maps Folder template (ID: {8302B292-E67B-4396-BA95-B4F8289249FC}). */
export type MapsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Maps Folder template (ID: {8302B292-E67B-4396-BA95-B4F8289249FC}). */
export type MapsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Maps Folder template (ID: {8302B292-E67B-4396-BA95-B4F8289249FC}). */
export type MapsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Maps Folder template (ID: {8302B292-E67B-4396-BA95-B4F8289249FC}). */
export type MapsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Maps Folder template (ID: {8302B292-E67B-4396-BA95-B4F8289249FC}). */
export type MapsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Maps/Maps Folder template (ID: {8302B292-E67B-4396-BA95-B4F8289249FC}). */
export type MapsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/Maps Provider template (ID: {70461699-48E4-45FA-B74B-0CCE849FCA6A}). */
export type MapsProvider = Item & _SharedRoot & {
  __typename?: 'MapsProvider';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Key (ID: {D9EE34D4-1A82-4478-AC8B-B60D3CC5FA70}). */
  key?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/Maps Provider template (ID: {70461699-48E4-45FA-B74B-0CCE849FCA6A}). */
export type MapsProviderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/Maps Provider template (ID: {70461699-48E4-45FA-B74B-0CCE849FCA6A}). */
export type MapsProviderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/Maps Provider template (ID: {70461699-48E4-45FA-B74B-0CCE849FCA6A}). */
export type MapsProviderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/Maps Provider template (ID: {70461699-48E4-45FA-B74B-0CCE849FCA6A}). */
export type MapsProviderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/Maps Provider template (ID: {70461699-48E4-45FA-B74B-0CCE849FCA6A}). */
export type MapsProviderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/Maps Provider template (ID: {70461699-48E4-45FA-B74B-0CCE849FCA6A}). */
export type MapsProviderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block template (ID: {6A3B3957-E493-4BF5-8154-330B68130947}). */
export type MediaBlock = Item & {
  __typename?: 'MediaBlock';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {ED1FCF0B-C4DC-428D-8F8C-19DF50841C78}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {9D15B89E-097F-4EE7-9171-2AB235EC3A6C}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block template (ID: {6A3B3957-E493-4BF5-8154-330B68130947}). */
export type MediaBlockAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block template (ID: {6A3B3957-E493-4BF5-8154-330B68130947}). */
export type MediaBlockChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block template (ID: {6A3B3957-E493-4BF5-8154-330B68130947}). */
export type MediaBlockFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block template (ID: {6A3B3957-E493-4BF5-8154-330B68130947}). */
export type MediaBlockFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block template (ID: {6A3B3957-E493-4BF5-8154-330B68130947}). */
export type MediaBlockHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block template (ID: {6A3B3957-E493-4BF5-8154-330B68130947}). */
export type MediaBlockIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block Folder template (ID: {2F918C09-A539-4523-ABFF-C3FAA31BDE0D}). */
export type MediaBlockFolder = Item & {
  __typename?: 'MediaBlockFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block Folder template (ID: {2F918C09-A539-4523-ABFF-C3FAA31BDE0D}). */
export type MediaBlockFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block Folder template (ID: {2F918C09-A539-4523-ABFF-C3FAA31BDE0D}). */
export type MediaBlockFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block Folder template (ID: {2F918C09-A539-4523-ABFF-C3FAA31BDE0D}). */
export type MediaBlockFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block Folder template (ID: {2F918C09-A539-4523-ABFF-C3FAA31BDE0D}). */
export type MediaBlockFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block Folder template (ID: {2F918C09-A539-4523-ABFF-C3FAA31BDE0D}). */
export type MediaBlockFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Media Block/Media Block Folder template (ID: {2F918C09-A539-4523-ABFF-C3FAA31BDE0D}). */
export type MediaBlockFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Media Block Parameters Template template (ID: {428CAFC7-A70B-4319-A418-0EB487C8221D}). */
export type MediaBlockParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'MediaBlockParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** presentationType (ID: {20CD8BE2-DD2E-4369-B442-07FF5D089B17}). */
  presentationType?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Media Block Parameters Template template (ID: {428CAFC7-A70B-4319-A418-0EB487C8221D}). */
export type MediaBlockParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Media Block Parameters Template template (ID: {428CAFC7-A70B-4319-A418-0EB487C8221D}). */
export type MediaBlockParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Media Block Parameters Template template (ID: {428CAFC7-A70B-4319-A418-0EB487C8221D}). */
export type MediaBlockParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Media Block Parameters Template template (ID: {428CAFC7-A70B-4319-A418-0EB487C8221D}). */
export type MediaBlockParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Media Block Parameters Template template (ID: {428CAFC7-A70B-4319-A418-0EB487C8221D}). */
export type MediaBlockParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Media Block Parameters Template template (ID: {428CAFC7-A70B-4319-A418-0EB487C8221D}). */
export type MediaBlockParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Media Folder template (ID: {81150E58-37F5-443F-A3C0-75E14A9321E7}). */
export type MediaFolder_81150e5837f5443fa3c075e14a9321e7 = Item & {
  __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Media Folder template (ID: {81150E58-37F5-443F-A3C0-75E14A9321E7}). */
export type MediaFolder_81150e5837f5443fa3c075e14a9321e7AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Media Folder template (ID: {81150E58-37F5-443F-A3C0-75E14A9321E7}). */
export type MediaFolder_81150e5837f5443fa3c075e14a9321e7ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Media Folder template (ID: {81150E58-37F5-443F-A3C0-75E14A9321E7}). */
export type MediaFolder_81150e5837f5443fa3c075e14a9321e7FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Media Folder template (ID: {81150E58-37F5-443F-A3C0-75E14A9321E7}). */
export type MediaFolder_81150e5837f5443fa3c075e14a9321e7FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Media Folder template (ID: {81150E58-37F5-443F-A3C0-75E14A9321E7}). */
export type MediaFolder_81150e5837f5443fa3c075e14a9321e7HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Media Folder template (ID: {81150E58-37F5-443F-A3C0-75E14A9321E7}). */
export type MediaFolder_81150e5837f5443fa3c075e14a9321e7IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/MediaLinkParameters template (ID: {BBBB5070-016B-4F23-91BB-2517A38BFCD4}). */
export type MediaLinkParameters = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'MediaLinkParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/MediaLinkParameters template (ID: {BBBB5070-016B-4F23-91BB-2517A38BFCD4}). */
export type MediaLinkParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/MediaLinkParameters template (ID: {BBBB5070-016B-4F23-91BB-2517A38BFCD4}). */
export type MediaLinkParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/MediaLinkParameters template (ID: {BBBB5070-016B-4F23-91BB-2517A38BFCD4}). */
export type MediaLinkParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/MediaLinkParameters template (ID: {BBBB5070-016B-4F23-91BB-2517A38BFCD4}). */
export type MediaLinkParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/MediaLinkParameters template (ID: {BBBB5070-016B-4F23-91BB-2517A38BFCD4}). */
export type MediaLinkParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/MediaLinkParameters template (ID: {BBBB5070-016B-4F23-91BB-2517A38BFCD4}). */
export type MediaLinkParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/MediaVirtualFolder template (ID: {E8E8C94F-4248-43C3-A79F-99FBB49D78E6}). */
export type MediaVirtualFolder = Item & {
  __typename?: 'MediaVirtualFolder';
  /** AdditionalChildren (ID: {DE8257D9-43AA-4EFF-A2F4-2E9FBBD20E79}). */
  additionalChildren?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/MediaVirtualFolder template (ID: {E8E8C94F-4248-43C3-A79F-99FBB49D78E6}). */
export type MediaVirtualFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/MediaVirtualFolder template (ID: {E8E8C94F-4248-43C3-A79F-99FBB49D78E6}). */
export type MediaVirtualFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/MediaVirtualFolder template (ID: {E8E8C94F-4248-43C3-A79F-99FBB49D78E6}). */
export type MediaVirtualFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/MediaVirtualFolder template (ID: {E8E8C94F-4248-43C3-A79F-99FBB49D78E6}). */
export type MediaVirtualFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/MediaVirtualFolder template (ID: {E8E8C94F-4248-43C3-A79F-99FBB49D78E6}). */
export type MediaVirtualFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/MediaVirtualFolder template (ID: {E8E8C94F-4248-43C3-A79F-99FBB49D78E6}). */
export type MediaVirtualFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation template (ID: {91F28731-ADA4-464A-A4D8-EA3A4F7C0578}). */
export type MegaNavigation = Item & {
  __typename?: 'MegaNavigation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation template (ID: {91F28731-ADA4-464A-A4D8-EA3A4F7C0578}). */
export type MegaNavigationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation template (ID: {91F28731-ADA4-464A-A4D8-EA3A4F7C0578}). */
export type MegaNavigationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation template (ID: {91F28731-ADA4-464A-A4D8-EA3A4F7C0578}). */
export type MegaNavigationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation template (ID: {91F28731-ADA4-464A-A4D8-EA3A4F7C0578}). */
export type MegaNavigationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation template (ID: {91F28731-ADA4-464A-A4D8-EA3A4F7C0578}). */
export type MegaNavigationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation template (ID: {91F28731-ADA4-464A-A4D8-EA3A4F7C0578}). */
export type MegaNavigationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation Folder template (ID: {5700DE5C-A52A-4ED6-98D8-3485049D1A6B}). */
export type MegaNavigationFolder = Item & {
  __typename?: 'MegaNavigationFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation Folder template (ID: {5700DE5C-A52A-4ED6-98D8-3485049D1A6B}). */
export type MegaNavigationFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation Folder template (ID: {5700DE5C-A52A-4ED6-98D8-3485049D1A6B}). */
export type MegaNavigationFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation Folder template (ID: {5700DE5C-A52A-4ED6-98D8-3485049D1A6B}). */
export type MegaNavigationFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation Folder template (ID: {5700DE5C-A52A-4ED6-98D8-3485049D1A6B}). */
export type MegaNavigationFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation Folder template (ID: {5700DE5C-A52A-4ED6-98D8-3485049D1A6B}). */
export type MegaNavigationFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Mega Navigation Folder template (ID: {5700DE5C-A52A-4ED6-98D8-3485049D1A6B}). */
export type MegaNavigationFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Meta Branding/Meta Branding template (ID: {E72D7674-8D71-4FD7-BFCD-561012E05FFA}). */
export type MetaBranding = Item & {
  __typename?: 'MetaBranding';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Branding Label, separated by pipe ("|")  is added automatically to page meta title ending in case "Meta Title" page field is not defined and Display Name / Item Name is taking instead.  */
  brandingLabel?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Meta Branding/Meta Branding template (ID: {E72D7674-8D71-4FD7-BFCD-561012E05FFA}). */
export type MetaBrandingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Meta Branding/Meta Branding template (ID: {E72D7674-8D71-4FD7-BFCD-561012E05FFA}). */
export type MetaBrandingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Meta Branding/Meta Branding template (ID: {E72D7674-8D71-4FD7-BFCD-561012E05FFA}). */
export type MetaBrandingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Meta Branding/Meta Branding template (ID: {E72D7674-8D71-4FD7-BFCD-561012E05FFA}). */
export type MetaBrandingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Meta Branding/Meta Branding template (ID: {E72D7674-8D71-4FD7-BFCD-561012E05FFA}). */
export type MetaBrandingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Meta Branding/Meta Branding template (ID: {E72D7674-8D71-4FD7-BFCD-561012E05FFA}). */
export type MetaBrandingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Rendering Parameters/Meta rendering parameters template (ID: {5A5FDF21-4FB0-4316-9AC8-96200632E384}). */
export type MetaRenderingParameters = ICacheable & Item & StandardRenderingParameters & {
  __typename?: 'MetaRenderingParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Rendering Parameters/Meta rendering parameters template (ID: {5A5FDF21-4FB0-4316-9AC8-96200632E384}). */
export type MetaRenderingParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Rendering Parameters/Meta rendering parameters template (ID: {5A5FDF21-4FB0-4316-9AC8-96200632E384}). */
export type MetaRenderingParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Rendering Parameters/Meta rendering parameters template (ID: {5A5FDF21-4FB0-4316-9AC8-96200632E384}). */
export type MetaRenderingParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Rendering Parameters/Meta rendering parameters template (ID: {5A5FDF21-4FB0-4316-9AC8-96200632E384}). */
export type MetaRenderingParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Rendering Parameters/Meta rendering parameters template (ID: {5A5FDF21-4FB0-4316-9AC8-96200632E384}). */
export type MetaRenderingParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Rendering Parameters/Meta rendering parameters template (ID: {5A5FDF21-4FB0-4316-9AC8-96200632E384}). */
export type MetaRenderingParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Metadata Partial Design template (ID: {C2A8E276-1757-4957-9DD5-8669B79FD80D}). */
export type MetadataPartialDesign = Item & PartialDesign & _BasePartialDesign & {
  __typename?: 'MetadataPartialDesign';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Base Partial Design (ID: {76A92454-C8BE-479B-B260-26AEBCED5A1A}). */
  basePartialDesign?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Signature (ID: {55FAAE90-3BBA-4F7F-96FE-13C3F40055FF}). */
  signature?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Metadata Partial Design template (ID: {C2A8E276-1757-4957-9DD5-8669B79FD80D}). */
export type MetadataPartialDesignAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Metadata Partial Design template (ID: {C2A8E276-1757-4957-9DD5-8669B79FD80D}). */
export type MetadataPartialDesignChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Metadata Partial Design template (ID: {C2A8E276-1757-4957-9DD5-8669B79FD80D}). */
export type MetadataPartialDesignFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Metadata Partial Design template (ID: {C2A8E276-1757-4957-9DD5-8669B79FD80D}). */
export type MetadataPartialDesignFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Metadata Partial Design template (ID: {C2A8E276-1757-4957-9DD5-8669B79FD80D}). */
export type MetadataPartialDesignHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Metadata Partial Design template (ID: {C2A8E276-1757-4957-9DD5-8669B79FD80D}). */
export type MetadataPartialDesignIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model template (ID: {56B86FA3-4906-437F-9036-78F570B077F9}). */
export type Model = BaseVariantField & Item & _DataAttributes & {
  __typename?: 'Model';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /**
   * In the Property path field, you can enter the path to the property that you want to display. For example, 
   * Item.Paths.Path 
   * will access Item property from Model, then dig deeper and access the Paths property and then the Path string.
   */
  property?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model template (ID: {56B86FA3-4906-437F-9036-78F570B077F9}). */
export type ModelAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model template (ID: {56B86FA3-4906-437F-9036-78F570B077F9}). */
export type ModelChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model template (ID: {56B86FA3-4906-437F-9036-78F570B077F9}). */
export type ModelFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model template (ID: {56B86FA3-4906-437F-9036-78F570B077F9}). */
export type ModelFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model template (ID: {56B86FA3-4906-437F-9036-78F570B077F9}). */
export type ModelHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model template (ID: {56B86FA3-4906-437F-9036-78F570B077F9}). */
export type ModelIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model Iterator template (ID: {A4E60E05-2ABD-4582-A1C2-5E39B8572CB0}). */
export type ModelIterator = Item & _VariantPaging & {
  __typename?: 'ModelIterator';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NumberOfResultsToSkip (ID: {AE6DB294-8D8B-45BE-919C-1143867BC03D}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** Pass Through Model (ID: {1E89F254-8FED-49BF-B0AB-5B63F1F2B3FE}). */
  passThroughModel?: Maybe<TextField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model Iterator template (ID: {A4E60E05-2ABD-4582-A1C2-5E39B8572CB0}). */
export type ModelIteratorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model Iterator template (ID: {A4E60E05-2ABD-4582-A1C2-5E39B8572CB0}). */
export type ModelIteratorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model Iterator template (ID: {A4E60E05-2ABD-4582-A1C2-5E39B8572CB0}). */
export type ModelIteratorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model Iterator template (ID: {A4E60E05-2ABD-4582-A1C2-5E39B8572CB0}). */
export type ModelIteratorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model Iterator template (ID: {A4E60E05-2ABD-4582-A1C2-5E39B8572CB0}). */
export type ModelIteratorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Model Iterator template (ID: {A4E60E05-2ABD-4582-A1C2-5E39B8572CB0}). */
export type ModelIteratorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type MultilistField = ItemField & {
  __typename?: 'MultilistField';
  /** The number of items that this field references. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** The IDs of the referenced items. */
  targetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The item(s) that this field references. */
  targetItems?: Maybe<Array<Maybe<Item>>>;
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type MultilistFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/My Location POI template (ID: {7DD9ECE5-9461-498D-8721-7CBEA8111B5E}). */
export type MyLocationPoi = Item & {
  __typename?: 'MyLocationPOI';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {BC03D1BC-7743-464F-90C3-C9E1542FD8BC}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Image (ID: {971D6D7B-41C5-472A-91B3-876BA5CE89E3}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** POI Page (ID: {6A2B140E-FCB5-46E7-AE9A-FB4061B3DAB0}). */
  pOIPage?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {A9C02F55-E9D8-4D6B-9A7E-021794B3C6DE}). */
  title?: Maybe<TextField>;
  /** Type (ID: {07AAC6E6-06F7-4AB9-9F16-A7D060C8A8A3}). */
  type?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/My Location POI template (ID: {7DD9ECE5-9461-498D-8721-7CBEA8111B5E}). */
export type MyLocationPoiAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/My Location POI template (ID: {7DD9ECE5-9461-498D-8721-7CBEA8111B5E}). */
export type MyLocationPoiChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/My Location POI template (ID: {7DD9ECE5-9461-498D-8721-7CBEA8111B5E}). */
export type MyLocationPoiFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/My Location POI template (ID: {7DD9ECE5-9461-498D-8721-7CBEA8111B5E}). */
export type MyLocationPoiFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/My Location POI template (ID: {7DD9ECE5-9461-498D-8721-7CBEA8111B5E}). */
export type MyLocationPoiHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/My Location POI template (ID: {7DD9ECE5-9461-498D-8721-7CBEA8111B5E}). */
export type MyLocationPoiIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type NameValueListField = ItemField & {
  __typename?: 'NameValueListField';
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
  /** The key-value pairs in this field. */
  values?: Maybe<Array<Maybe<NameValueListValue>>>;
};


export type NameValueListFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type NameValueListValue = {
  __typename?: 'NameValueListValue';
  /** The name of the name-value pair. */
  name: Scalars['String']['output'];
  /** The value of the name-value pair. */
  value: Scalars['String']['output'];
};

/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {1E69E2ED-AC7C-4A97-9A51-49A0F3A2D1D9}). */
export type Navigation = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & Navigation_E6d98f24d01c419e871a4617125a49ed & StandardRenderingParameters & {
  __typename?: 'Navigation';
  /** AddRoot (ID: {9A0B3039-D8F2-47E5-8D96-9EF38B834682}). */
  addRoot?: Maybe<CheckboxField>;
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Filter (ID: {5509C7BE-2C58-4EA6-A1FB-1F7BDC72845A}). */
  filter?: Maybe<LookupField>;
  /** Flattened (ID: {E55B2D76-4774-4BAA-9E5F-F8108B77D45F}). */
  flattened?: Maybe<CheckboxField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LevelFrom (ID: {B20124B2-820E-4F89-A310-A260656F1A55}). */
  levelFrom?: Maybe<LookupField>;
  /** LevelTo (ID: {D3AE28E6-B489-4AB9-8C28-5B2BD0161228}). */
  levelTo?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationFieldNames (ID: {025E52D4-3213-4043-9414-21082F135533}). */
  navigationFieldNames?: Maybe<TextField>;
  /** NavigationRoot (ID: {A00D72AA-A24B-4E97-8D6D-49CC34849AE5}). */
  navigationRoot?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {1E69E2ED-AC7C-4A97-9A51-49A0F3A2D1D9}). */
export type NavigationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {1E69E2ED-AC7C-4A97-9A51-49A0F3A2D1D9}). */
export type NavigationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {1E69E2ED-AC7C-4A97-9A51-49A0F3A2D1D9}). */
export type NavigationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {1E69E2ED-AC7C-4A97-9A51-49A0F3A2D1D9}). */
export type NavigationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {1E69E2ED-AC7C-4A97-9A51-49A0F3A2D1D9}). */
export type NavigationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {1E69E2ED-AC7C-4A97-9A51-49A0F3A2D1D9}). */
export type NavigationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Category template (ID: {AE4F0E6E-274A-406E-BC66-58D3E7CFB11F}). */
export type NavigationCategory = Item & {
  __typename?: 'NavigationCategory';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** promotedContent (ID: {258CD6FB-C07F-4F40-AECD-7E5C32DC95B0}). */
  promotedContent?: Maybe<LookupField>;
  /** pulloutLink (ID: {EBE51844-A503-429C-9D34-DBE71AB5AC88}). */
  pulloutLink?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {729968CD-5706-4F7A-8BAE-307B98B6C4EC}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Category template (ID: {AE4F0E6E-274A-406E-BC66-58D3E7CFB11F}). */
export type NavigationCategoryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Category template (ID: {AE4F0E6E-274A-406E-BC66-58D3E7CFB11F}). */
export type NavigationCategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Category template (ID: {AE4F0E6E-274A-406E-BC66-58D3E7CFB11F}). */
export type NavigationCategoryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Category template (ID: {AE4F0E6E-274A-406E-BC66-58D3E7CFB11F}). */
export type NavigationCategoryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Category template (ID: {AE4F0E6E-274A-406E-BC66-58D3E7CFB11F}). */
export type NavigationCategoryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Category template (ID: {AE4F0E6E-274A-406E-BC66-58D3E7CFB11F}). */
export type NavigationCategoryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter template (ID: {966B041F-D956-4F71-A40A-68869A7BA6B9}). */
export type NavigationFilter = Item & {
  __typename?: 'NavigationFilter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Key (ID: {EE62CFBF-5B46-4F64-8334-207B9BD3FF96}). */
  key?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter template (ID: {966B041F-D956-4F71-A40A-68869A7BA6B9}). */
export type NavigationFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter template (ID: {966B041F-D956-4F71-A40A-68869A7BA6B9}). */
export type NavigationFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter template (ID: {966B041F-D956-4F71-A40A-68869A7BA6B9}). */
export type NavigationFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter template (ID: {966B041F-D956-4F71-A40A-68869A7BA6B9}). */
export type NavigationFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter template (ID: {966B041F-D956-4F71-A40A-68869A7BA6B9}). */
export type NavigationFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter template (ID: {966B041F-D956-4F71-A40A-68869A7BA6B9}). */
export type NavigationFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter Folder template (ID: {9C2D0FDF-4DAF-4494-BDE7-F857F1924825}). */
export type NavigationFilterFolder = Item & {
  __typename?: 'NavigationFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter Folder template (ID: {9C2D0FDF-4DAF-4494-BDE7-F857F1924825}). */
export type NavigationFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter Folder template (ID: {9C2D0FDF-4DAF-4494-BDE7-F857F1924825}). */
export type NavigationFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter Folder template (ID: {9C2D0FDF-4DAF-4494-BDE7-F857F1924825}). */
export type NavigationFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter Folder template (ID: {9C2D0FDF-4DAF-4494-BDE7-F857F1924825}). */
export type NavigationFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter Folder template (ID: {9C2D0FDF-4DAF-4494-BDE7-F857F1924825}). */
export type NavigationFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Navigation Filter Folder template (ID: {9C2D0FDF-4DAF-4494-BDE7-F857F1924825}). */
export type NavigationFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Link template (ID: {E53FCDEC-CC76-4FDF-9758-5C9068C7E1AA}). */
export type NavigationLink = Item & {
  __typename?: 'NavigationLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {31C3EE29-24EA-486D-81AE-E207CA082A99}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Link template (ID: {E53FCDEC-CC76-4FDF-9758-5C9068C7E1AA}). */
export type NavigationLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Link template (ID: {E53FCDEC-CC76-4FDF-9758-5C9068C7E1AA}). */
export type NavigationLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Link template (ID: {E53FCDEC-CC76-4FDF-9758-5C9068C7E1AA}). */
export type NavigationLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Link template (ID: {E53FCDEC-CC76-4FDF-9758-5C9068C7E1AA}). */
export type NavigationLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Link template (ID: {E53FCDEC-CC76-4FDF-9758-5C9068C7E1AA}). */
export type NavigationLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Link template (ID: {E53FCDEC-CC76-4FDF-9758-5C9068C7E1AA}). */
export type NavigationLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Subcategory template (ID: {3952B171-6886-45F2-8317-E7250ABB25B5}). */
export type NavigationSubcategory = Item & {
  __typename?: 'NavigationSubcategory';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {E721D2B5-2DE4-409F-AAEB-03C83FFD7042}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {8A69EB82-CC78-4856-9CA2-2D94613232CD}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Subcategory template (ID: {3952B171-6886-45F2-8317-E7250ABB25B5}). */
export type NavigationSubcategoryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Subcategory template (ID: {3952B171-6886-45F2-8317-E7250ABB25B5}). */
export type NavigationSubcategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Subcategory template (ID: {3952B171-6886-45F2-8317-E7250ABB25B5}). */
export type NavigationSubcategoryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Subcategory template (ID: {3952B171-6886-45F2-8317-E7250ABB25B5}). */
export type NavigationSubcategoryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Subcategory template (ID: {3952B171-6886-45F2-8317-E7250ABB25B5}). */
export type NavigationSubcategoryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Mega Navigation/Navigation Subcategory template (ID: {3952B171-6886-45F2-8317-E7250ABB25B5}). */
export type NavigationSubcategoryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {9CE34BF9-5C93-4DFF-841D-8F649C2BD6C8}). */
export type Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = BaseRenderingParameters & GridParameters & IComponentVariant & IRenderingId & IStyling & Item & Navigation_E6d98f24d01c419e871a4617125a49ed & StandardRenderingParameters & {
  __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8';
  /** AddRoot (ID: {9A0B3039-D8F2-47E5-8D96-9EF38B834682}). */
  addRoot?: Maybe<CheckboxField>;
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Filter (ID: {5509C7BE-2C58-4EA6-A1FB-1F7BDC72845A}). */
  filter?: Maybe<LookupField>;
  /** Flattened (ID: {E55B2D76-4774-4BAA-9E5F-F8108B77D45F}). */
  flattened?: Maybe<CheckboxField>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LevelFrom (ID: {B20124B2-820E-4F89-A310-A260656F1A55}). */
  levelFrom?: Maybe<LookupField>;
  /** LevelTo (ID: {D3AE28E6-B489-4AB9-8C28-5B2BD0161228}). */
  levelTo?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationRoot (ID: {A00D72AA-A24B-4E97-8D6D-49CC34849AE5}). */
  navigationRoot?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** SerializerFieldNames (ID: {0B2C3107-F59D-46F1-B464-1657886C1C87}). */
  serializerFieldNames?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {9CE34BF9-5C93-4DFF-841D-8F649C2BD6C8}). */
export type Navigation_9ce34bf95c934dff841d8f649c2bd6c8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {9CE34BF9-5C93-4DFF-841D-8F649C2BD6C8}). */
export type Navigation_9ce34bf95c934dff841d8f649c2bd6c8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {9CE34BF9-5C93-4DFF-841D-8F649C2BD6C8}). */
export type Navigation_9ce34bf95c934dff841d8f649c2bd6c8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {9CE34BF9-5C93-4DFF-841D-8F649C2BD6C8}). */
export type Navigation_9ce34bf95c934dff841d8f649c2bd6c8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {9CE34BF9-5C93-4DFF-841D-8F649C2BD6C8}). */
export type Navigation_9ce34bf95c934dff841d8f649c2bd6c8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {9CE34BF9-5C93-4DFF-841D-8F649C2BD6C8}). */
export type Navigation_9ce34bf95c934dff841d8f649c2bd6c8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/Rendering Parameters/Navigation template (ID: {E6D98F24-D01C-419E-871A-4617125A49ED}). Also implements _PerSiteStandardValues. */
export type Navigation_E6d98f24d01c419e871a4617125a49ed = {
  /** AddRoot (ID: {9A0B3039-D8F2-47E5-8D96-9EF38B834682}). */
  addRoot?: Maybe<CheckboxField>;
  /** Filter (ID: {5509C7BE-2C58-4EA6-A1FB-1F7BDC72845A}). */
  filter?: Maybe<LookupField>;
  /** Flattened (ID: {E55B2D76-4774-4BAA-9E5F-F8108B77D45F}). */
  flattened?: Maybe<CheckboxField>;
  /** LevelFrom (ID: {B20124B2-820E-4F89-A310-A260656F1A55}). */
  levelFrom?: Maybe<LookupField>;
  /** LevelTo (ID: {D3AE28E6-B489-4AB9-8C28-5B2BD0161228}). */
  levelTo?: Maybe<LookupField>;
  /** NavigationRoot (ID: {A00D72AA-A24B-4E97-8D6D-49CC34849AE5}). */
  navigationRoot?: Maybe<LookupField>;
};

export type NumberField = ItemField & {
  __typename?: 'NumberField';
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** The field's value as a floating-point number. */
  numberValue?: Maybe<Scalars['Float']['output']>;
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type NumberFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/OneTrust Settings/OneTrust Settings template (ID: {3FAE9D69-A8FB-4AD3-990C-CCD3353941C8}). */
export type OneTrustSettings = Item & {
  __typename?: 'OneTrustSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script ID (ID: {F29CCA7E-A9B6-4C55-8355-27CD66C2E278}). */
  scriptID?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/OneTrust Settings/OneTrust Settings template (ID: {3FAE9D69-A8FB-4AD3-990C-CCD3353941C8}). */
export type OneTrustSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/OneTrust Settings/OneTrust Settings template (ID: {3FAE9D69-A8FB-4AD3-990C-CCD3353941C8}). */
export type OneTrustSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/OneTrust Settings/OneTrust Settings template (ID: {3FAE9D69-A8FB-4AD3-990C-CCD3353941C8}). */
export type OneTrustSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/OneTrust Settings/OneTrust Settings template (ID: {3FAE9D69-A8FB-4AD3-990C-CCD3353941C8}). */
export type OneTrustSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/OneTrust Settings/OneTrust Settings template (ID: {3FAE9D69-A8FB-4AD3-990C-CCD3353941C8}). */
export type OneTrustSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/OneTrust Settings/OneTrust Settings template (ID: {3FAE9D69-A8FB-4AD3-990C-CCD3353941C8}). */
export type OneTrustSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration template (ID: {F16E48F5-C8D6-4EE4-8AF8-4C13BE6F5980}). */
export type OptimiserConfiguration = Item & {
  __typename?: 'OptimiserConfiguration';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration template (ID: {F16E48F5-C8D6-4EE4-8AF8-4C13BE6F5980}). */
export type OptimiserConfigurationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration template (ID: {F16E48F5-C8D6-4EE4-8AF8-4C13BE6F5980}). */
export type OptimiserConfigurationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration template (ID: {F16E48F5-C8D6-4EE4-8AF8-4C13BE6F5980}). */
export type OptimiserConfigurationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration template (ID: {F16E48F5-C8D6-4EE4-8AF8-4C13BE6F5980}). */
export type OptimiserConfigurationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration template (ID: {F16E48F5-C8D6-4EE4-8AF8-4C13BE6F5980}). */
export type OptimiserConfigurationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration template (ID: {F16E48F5-C8D6-4EE4-8AF8-4C13BE6F5980}). */
export type OptimiserConfigurationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration Section template (ID: {E3BA8CA1-0B54-4E56-9E24-0E2E1D229DC1}). */
export type OptimiserConfigurationSection = Item & {
  __typename?: 'OptimiserConfigurationSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Mode (ID: {C7497433-25DC-4B54-ACDC-18CB68F7969A}). */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration Section template (ID: {E3BA8CA1-0B54-4E56-9E24-0E2E1D229DC1}). */
export type OptimiserConfigurationSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration Section template (ID: {E3BA8CA1-0B54-4E56-9E24-0E2E1D229DC1}). */
export type OptimiserConfigurationSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration Section template (ID: {E3BA8CA1-0B54-4E56-9E24-0E2E1D229DC1}). */
export type OptimiserConfigurationSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration Section template (ID: {E3BA8CA1-0B54-4E56-9E24-0E2E1D229DC1}). */
export type OptimiserConfigurationSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration Section template (ID: {E3BA8CA1-0B54-4E56-9E24-0E2E1D229DC1}). */
export type OptimiserConfigurationSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimiser Configuration Section template (ID: {E3BA8CA1-0B54-4E56-9E24-0E2E1D229DC1}). */
export type OptimiserConfigurationSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimized File template (ID: {B43AB8D5-E123-42DD-8042-DE869CC98C4F}). */
export type OptimizedFile = File & Item & {
  __typename?: 'OptimizedFile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Blob (ID: {40E50ED9-BA07-4702-992E-A912738D32DC}). */
  blob?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CountryCode (ID: {FF01BC1A-EF22-407C-9115-7DBEE11451A5}). */
  countryCode?: Maybe<TextField>;
  /** Description (ID: {BA8341A1-FF30-47B8-AE6A-F4947E4113F0}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension (ID: {C06867FE-9A43-4C7D-B739-48780492D06F}). */
  extension?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** File Path (ID: {2134867A-AC67-4DAC-836C-A9264FD9D6D6}). */
  filePath?: Maybe<TextField>;
  /** Format (ID: {FBD90442-DB0C-48F1-A0F4-0427CD9AFCCE}). */
  format?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Keywords (ID: {2FAFE7CB-2691-4800-8848-255EFA1D31AA}). */
  keywords?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Latitude (ID: {5D589EC4-4842-4630-A860-540357A196F3}). */
  latitude?: Maybe<NumberField>;
  /** LocationDescription (ID: {E8FA62D2-13FC-4C5C-91E5-71D615591420}). */
  locationDescription?: Maybe<TextField>;
  /** Longitude (ID: {11CB6358-8F71-4F80-AB30-04D745D99D56}). */
  longitude?: Maybe<NumberField>;
  /** Mime Type (ID: {6F47A0A5-9C94-4B48-ABEB-42D38DEF6054}). */
  mimeType?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Size (ID: {6954B7C7-2487-423F-8600-436CB3B6DC0E}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {3F4B20E9-36E6-4D45-A423-C86567373F82}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** ZipCode (ID: {FB540BF1-B2EB-47C9-A55F-F01B2FCA5851}). */
  zipCode?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimized File template (ID: {B43AB8D5-E123-42DD-8042-DE869CC98C4F}). */
export type OptimizedFileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimized File template (ID: {B43AB8D5-E123-42DD-8042-DE869CC98C4F}). */
export type OptimizedFileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimized File template (ID: {B43AB8D5-E123-42DD-8042-DE869CC98C4F}). */
export type OptimizedFileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimized File template (ID: {B43AB8D5-E123-42DD-8042-DE869CC98C4F}). */
export type OptimizedFileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimized File template (ID: {B43AB8D5-E123-42DD-8042-DE869CC98C4F}). */
export type OptimizedFileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Optimized File template (ID: {B43AB8D5-E123-42DD-8042-DE869CC98C4F}). */
export type OptimizedFileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Oracle CDP Settings/Oracle CDP Settings template (ID: {018202CA-1B9B-4F6C-AB7B-0D1C5D893536}). */
export type OracleCdpSettings = Item & {
  __typename?: 'OracleCDPSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** cdpId (ID: {D0D40886-874C-4236-81B8-11A613922F8A}). */
  cdpId?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Oracle CDP Settings/Oracle CDP Settings template (ID: {018202CA-1B9B-4F6C-AB7B-0D1C5D893536}). */
export type OracleCdpSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Oracle CDP Settings/Oracle CDP Settings template (ID: {018202CA-1B9B-4F6C-AB7B-0D1C5D893536}). */
export type OracleCdpSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Oracle CDP Settings/Oracle CDP Settings template (ID: {018202CA-1B9B-4F6C-AB7B-0D1C5D893536}). */
export type OracleCdpSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Oracle CDP Settings/Oracle CDP Settings template (ID: {018202CA-1B9B-4F6C-AB7B-0D1C5D893536}). */
export type OracleCdpSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Oracle CDP Settings/Oracle CDP Settings template (ID: {018202CA-1B9B-4F6C-AB7B-0D1C5D893536}). */
export type OracleCdpSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Oracle CDP Settings/Oracle CDP Settings template (ID: {018202CA-1B9B-4F6C-AB7B-0D1C5D893536}). */
export type OracleCdpSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** /sitecore/templates/Feature/Experience Accelerator/Overlays/Overlay Content template (ID: {6BF19F1C-DA51-477F-B7D9-B49B41FD1578}). */
export type OverlayContent = Item & {
  __typename?: 'OverlayContent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Height (ID: {AB626903-E218-4AB6-8691-DA4982C3548C}). */
  height?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UsePercent (ID: {5CC3C9FC-B55C-4A4D-856B-8949F40E0CD4}). */
  usePercent?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Width (ID: {87F9B654-5410-4DC2-9C9D-E3B55F623C6C}). */
  width?: Maybe<TextField>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/Overlay Content template (ID: {6BF19F1C-DA51-477F-B7D9-B49B41FD1578}). */
export type OverlayContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/Overlay Content template (ID: {6BF19F1C-DA51-477F-B7D9-B49B41FD1578}). */
export type OverlayContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/Overlay Content template (ID: {6BF19F1C-DA51-477F-B7D9-B49B41FD1578}). */
export type OverlayContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/Overlay Content template (ID: {6BF19F1C-DA51-477F-B7D9-B49B41FD1578}). */
export type OverlayContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/Overlay Content template (ID: {6BF19F1C-DA51-477F-B7D9-B49B41FD1578}). */
export type OverlayContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/Overlay Content template (ID: {6BF19F1C-DA51-477F-B7D9-B49B41FD1578}). */
export type OverlayContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Overlays/OverlayFolderTemplate template (ID: {D7BFFBE5-DAD8-4137-85DE-28013313F72F}). */
export type OverlayFolderTemplate = Item & {
  __typename?: 'OverlayFolderTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/OverlayFolderTemplate template (ID: {D7BFFBE5-DAD8-4137-85DE-28013313F72F}). */
export type OverlayFolderTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/OverlayFolderTemplate template (ID: {D7BFFBE5-DAD8-4137-85DE-28013313F72F}). */
export type OverlayFolderTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/OverlayFolderTemplate template (ID: {D7BFFBE5-DAD8-4137-85DE-28013313F72F}). */
export type OverlayFolderTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/OverlayFolderTemplate template (ID: {D7BFFBE5-DAD8-4137-85DE-28013313F72F}). */
export type OverlayFolderTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/OverlayFolderTemplate template (ID: {D7BFFBE5-DAD8-4137-85DE-28013313F72F}). */
export type OverlayFolderTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Overlays/OverlayFolderTemplate template (ID: {D7BFFBE5-DAD8-4137-85DE-28013313F72F}). */
export type OverlayFolderTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership template (ID: {8E794110-651B-4269-B27E-051D7A3D02AB}). */
export type Ownership = Item & {
  __typename?: 'Ownership';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {CE14EFBE-6A69-404B-AF35-B06A0D455724}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership template (ID: {8E794110-651B-4269-B27E-051D7A3D02AB}). */
export type OwnershipAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership template (ID: {8E794110-651B-4269-B27E-051D7A3D02AB}). */
export type OwnershipChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership template (ID: {8E794110-651B-4269-B27E-051D7A3D02AB}). */
export type OwnershipFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership template (ID: {8E794110-651B-4269-B27E-051D7A3D02AB}). */
export type OwnershipFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership template (ID: {8E794110-651B-4269-B27E-051D7A3D02AB}). */
export type OwnershipHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership template (ID: {8E794110-651B-4269-B27E-051D7A3D02AB}). */
export type OwnershipIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership Folder template (ID: {D95F94A8-2AE8-4984-A5DA-06655678C0FE}). */
export type OwnershipFolder = Item & {
  __typename?: 'OwnershipFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership Folder template (ID: {D95F94A8-2AE8-4984-A5DA-06655678C0FE}). */
export type OwnershipFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership Folder template (ID: {D95F94A8-2AE8-4984-A5DA-06655678C0FE}). */
export type OwnershipFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership Folder template (ID: {D95F94A8-2AE8-4984-A5DA-06655678C0FE}). */
export type OwnershipFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership Folder template (ID: {D95F94A8-2AE8-4984-A5DA-06655678C0FE}). */
export type OwnershipFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership Folder template (ID: {D95F94A8-2AE8-4984-A5DA-06655678C0FE}). */
export type OwnershipFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Ownership/Ownership Folder template (ID: {D95F94A8-2AE8-4984-A5DA-06655678C0FE}). */
export type OwnershipFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI template (ID: {6EBB38CE-04FC-425C-895B-3C81FA4A7B5C}). */
export type Poi = Coordinate & IPoi & Item & {
  __typename?: 'POI';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Deprecated-Latitude (ID: {94969C59-C4B8-43ED-9C92-3FBF930C0ACF}). */
  deprecatedLatitude?: Maybe<NumberField>;
  /** Deprecated-Longitude (ID: {8C1AEA63-2E5E-4FEE-B413-D3B1E050DD26}). */
  deprecatedLongitude?: Maybe<NumberField>;
  /** Description (ID: {7DB4985A-73A1-44A3-9B2C-FFEA56093431}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Image (ID: {0D044F4B-5AB5-4BFC-811B-63F25C84F751}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Latitudes range from -90 to 90. For example 41.25 or -31.96 */
  latitude?: Maybe<NumberField>;
  /** Longitudes range from -180 to 180. For example, -120.9762 and 115.84 */
  longitude?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** POI Page (ID: {5AD51916-E40E-480E-A863-E1D09E2CC2FF}). */
  pOIPage?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {E428DD88-04A5-43C2-BE37-35E0E3CF9890}). */
  title?: Maybe<TextField>;
  /** Type (ID: {8E09C5D1-4EC5-48FD-B355-3D1C65DD5C0F}). */
  type?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI template (ID: {6EBB38CE-04FC-425C-895B-3C81FA4A7B5C}). */
export type PoiAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI template (ID: {6EBB38CE-04FC-425C-895B-3C81FA4A7B5C}). */
export type PoiChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI template (ID: {6EBB38CE-04FC-425C-895B-3C81FA4A7B5C}). */
export type PoiFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI template (ID: {6EBB38CE-04FC-425C-895B-3C81FA4A7B5C}). */
export type PoiFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI template (ID: {6EBB38CE-04FC-425C-895B-3C81FA4A7B5C}). */
export type PoiHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI template (ID: {6EBB38CE-04FC-425C-895B-3C81FA4A7B5C}). */
export type PoiIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Folder template (ID: {9716FAFC-C305-4C95-A92B-0C0DA8714634}). */
export type PoiFolder = Item & {
  __typename?: 'POIFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Folder template (ID: {9716FAFC-C305-4C95-A92B-0C0DA8714634}). */
export type PoiFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Folder template (ID: {9716FAFC-C305-4C95-A92B-0C0DA8714634}). */
export type PoiFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Folder template (ID: {9716FAFC-C305-4C95-A92B-0C0DA8714634}). */
export type PoiFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Folder template (ID: {9716FAFC-C305-4C95-A92B-0C0DA8714634}). */
export type PoiFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Folder template (ID: {9716FAFC-C305-4C95-A92B-0C0DA8714634}). */
export type PoiFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Folder template (ID: {9716FAFC-C305-4C95-A92B-0C0DA8714634}). */
export type PoiFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Type template (ID: {C58EE915-AA14-49BF-BEE4-C821CAC26913}). */
export type PoiType = Item & {
  __typename?: 'POIType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldNames (ID: {B348A1BF-27BE-4713-915A-4811BC987E37}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Icon (ID: {57E50235-CE3E-4F31-846E-2646CBBA69F8}). */
  icon_57e50235ce3e4f31846e2646cbba69f8?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Type template (ID: {C58EE915-AA14-49BF-BEE4-C821CAC26913}). */
export type PoiTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Type template (ID: {C58EE915-AA14-49BF-BEE4-C821CAC26913}). */
export type PoiTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Type template (ID: {C58EE915-AA14-49BF-BEE4-C821CAC26913}). */
export type PoiTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Type template (ID: {C58EE915-AA14-49BF-BEE4-C821CAC26913}). */
export type PoiTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Type template (ID: {C58EE915-AA14-49BF-BEE4-C821CAC26913}). */
export type PoiTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POI Type template (ID: {C58EE915-AA14-49BF-BEE4-C821CAC26913}). */
export type PoiTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POIs template (ID: {8CA8B80D-A1AD-4B45-9F08-8839357E71D4}). */
export type PoIs = Item & {
  __typename?: 'POIs';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POIs template (ID: {8CA8B80D-A1AD-4B45-9F08-8839357E71D4}). */
export type PoIsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POIs template (ID: {8CA8B80D-A1AD-4B45-9F08-8839357E71D4}). */
export type PoIsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POIs template (ID: {8CA8B80D-A1AD-4B45-9F08-8839357E71D4}). */
export type PoIsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POIs template (ID: {8CA8B80D-A1AD-4B45-9F08-8839357E71D4}). */
export type PoIsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POIs template (ID: {8CA8B80D-A1AD-4B45-9F08-8839357E71D4}). */
export type PoIsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/POIs template (ID: {8CA8B80D-A1AD-4B45-9F08-8839357E71D4}). */
export type PoIsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Page Branches/Page Branches Folder template (ID: {FBC802E5-4B9E-480F-93DA-3F2A80CAE5CB}). */
export type PageBranchesFolder = Item & {
  __typename?: 'PageBranchesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rule (ID: {BB3391DD-F8BE-4B2E-AE9F-47BB63C166CE}). */
  rule?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Page Branches/Page Branches Folder template (ID: {FBC802E5-4B9E-480F-93DA-3F2A80CAE5CB}). */
export type PageBranchesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Page Branches/Page Branches Folder template (ID: {FBC802E5-4B9E-480F-93DA-3F2A80CAE5CB}). */
export type PageBranchesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Page Branches/Page Branches Folder template (ID: {FBC802E5-4B9E-480F-93DA-3F2A80CAE5CB}). */
export type PageBranchesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Page Branches/Page Branches Folder template (ID: {FBC802E5-4B9E-480F-93DA-3F2A80CAE5CB}). */
export type PageBranchesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Page Branches/Page Branches Folder template (ID: {FBC802E5-4B9E-480F-93DA-3F2A80CAE5CB}). */
export type PageBranchesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Page Branches/Page Branches Folder template (ID: {FBC802E5-4B9E-480F-93DA-3F2A80CAE5CB}). */
export type PageBranchesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {936D40D8-E317-4A33-9F66-E65E9FF51845}). */
export type PageContent = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'PageContent';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {936D40D8-E317-4A33-9F66-E65E9FF51845}). */
export type PageContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {936D40D8-E317-4A33-9F66-E65E9FF51845}). */
export type PageContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {936D40D8-E317-4A33-9F66-E65E9FF51845}). */
export type PageContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {936D40D8-E317-4A33-9F66-E65E9FF51845}). */
export type PageContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {936D40D8-E317-4A33-9F66-E65E9FF51845}). */
export type PageContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {936D40D8-E317-4A33-9F66-E65E9FF51845}). */
export type PageContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Page Content Folder template (ID: {497AD3AE-D7C4-46B4-9FAD-0C9CECFB12C7}). */
export type PageContentFolder = Item & {
  __typename?: 'PageContentFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Page Content Folder template (ID: {497AD3AE-D7C4-46B4-9FAD-0C9CECFB12C7}). */
export type PageContentFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Page Content Folder template (ID: {497AD3AE-D7C4-46B4-9FAD-0C9CECFB12C7}). */
export type PageContentFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Page Content Folder template (ID: {497AD3AE-D7C4-46B4-9FAD-0C9CECFB12C7}). */
export type PageContentFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Page Content Folder template (ID: {497AD3AE-D7C4-46B4-9FAD-0C9CECFB12C7}). */
export type PageContentFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Page Content Folder template (ID: {497AD3AE-D7C4-46B4-9FAD-0C9CECFB12C7}). */
export type PageContentFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Page Content Folder template (ID: {497AD3AE-D7C4-46B4-9FAD-0C9CECFB12C7}). */
export type PageContentFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {EF87E73B-C7FF-49A2-AC59-9B0BE83755C3}). */
export type PageContent_Ef87e73bc7ff49a2ac599b0be83755c3 = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {EF87E73B-C7FF-49A2-AC59-9B0BE83755C3}). */
export type PageContent_Ef87e73bc7ff49a2ac599b0be83755c3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {EF87E73B-C7FF-49A2-AC59-9B0BE83755C3}). */
export type PageContent_Ef87e73bc7ff49a2ac599b0be83755c3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {EF87E73B-C7FF-49A2-AC59-9B0BE83755C3}). */
export type PageContent_Ef87e73bc7ff49a2ac599b0be83755c3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {EF87E73B-C7FF-49A2-AC59-9B0BE83755C3}). */
export type PageContent_Ef87e73bc7ff49a2ac599b0be83755c3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {EF87E73B-C7FF-49A2-AC59-9B0BE83755C3}). */
export type PageContent_Ef87e73bc7ff49a2ac599b0be83755c3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Page Content template (ID: {EF87E73B-C7FF-49A2-AC59-9B0BE83755C3}). */
export type PageContent_Ef87e73bc7ff49a2ac599b0be83755c3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Design template (ID: {EBCFFAE1-B6B4-4B50-B722-155E869FC430}). */
export type PageDesign = Item & _BasePageDesign & {
  __typename?: 'PageDesign';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** PartialDesigns (ID: {0966B999-0D0E-4278-ACC9-9DA69D461FE6}). */
  partialDesigns?: Maybe<MultilistField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Design template (ID: {EBCFFAE1-B6B4-4B50-B722-155E869FC430}). */
export type PageDesignAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Design template (ID: {EBCFFAE1-B6B4-4B50-B722-155E869FC430}). */
export type PageDesignChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Design template (ID: {EBCFFAE1-B6B4-4B50-B722-155E869FC430}). */
export type PageDesignFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Design template (ID: {EBCFFAE1-B6B4-4B50-B722-155E869FC430}). */
export type PageDesignFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Design template (ID: {EBCFFAE1-B6B4-4B50-B722-155E869FC430}). */
export type PageDesignHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Design template (ID: {EBCFFAE1-B6B4-4B50-B722-155E869FC430}). */
export type PageDesignIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Page Design Folder template (ID: {1AA9BC82-50A9-4E4E-B150-03B55B4DFED0}). */
export type PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = Item & {
  __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Page Design Folder template (ID: {1AA9BC82-50A9-4E4E-B150-03B55B4DFED0}). */
export type PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page Design Folder template (ID: {1AA9BC82-50A9-4E4E-B150-03B55B4DFED0}). */
export type PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page Design Folder template (ID: {1AA9BC82-50A9-4E4E-B150-03B55B4DFED0}). */
export type PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Page Design Folder template (ID: {1AA9BC82-50A9-4E4E-B150-03B55B4DFED0}). */
export type PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Page Design Folder template (ID: {1AA9BC82-50A9-4E4E-B150-03B55B4DFED0}). */
export type PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page Design Folder template (ID: {1AA9BC82-50A9-4E4E-B150-03B55B4DFED0}). */
export type PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Page Design Folder template (ID: {27D4F8BE-63B0-4576-9A4E-F3163C935B47}). */
export type PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = Item & {
  __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Page Design Folder template (ID: {27D4F8BE-63B0-4576-9A4E-F3163C935B47}). */
export type PageDesignFolder_27d4f8be63b045769a4ef3163c935b47AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page Design Folder template (ID: {27D4F8BE-63B0-4576-9A4E-F3163C935B47}). */
export type PageDesignFolder_27d4f8be63b045769a4ef3163c935b47ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page Design Folder template (ID: {27D4F8BE-63B0-4576-9A4E-F3163C935B47}). */
export type PageDesignFolder_27d4f8be63b045769a4ef3163c935b47FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Page Design Folder template (ID: {27D4F8BE-63B0-4576-9A4E-F3163C935B47}). */
export type PageDesignFolder_27d4f8be63b045769a4ef3163c935b47FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Page Design Folder template (ID: {27D4F8BE-63B0-4576-9A4E-F3163C935B47}). */
export type PageDesignFolder_27d4f8be63b045769a4ef3163c935b47HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page Design Folder template (ID: {27D4F8BE-63B0-4576-9A4E-F3163C935B47}). */
export type PageDesignFolder_27d4f8be63b045769a4ef3163c935b47IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Page Design Folder template (ID: {352CE40E-E6E1-457A-8BF2-25D8771894E8}). */
export type PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = Item & {
  __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Design Folder template (ID: {352CE40E-E6E1-457A-8BF2-25D8771894E8}). */
export type PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Design Folder template (ID: {352CE40E-E6E1-457A-8BF2-25D8771894E8}). */
export type PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Design Folder template (ID: {352CE40E-E6E1-457A-8BF2-25D8771894E8}). */
export type PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Design Folder template (ID: {352CE40E-E6E1-457A-8BF2-25D8771894E8}). */
export type PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Design Folder template (ID: {352CE40E-E6E1-457A-8BF2-25D8771894E8}). */
export type PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Design Folder template (ID: {352CE40E-E6E1-457A-8BF2-25D8771894E8}). */
export type PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Page Design Folder template (ID: {446A7EAD-EB89-4ED6-B48C-7F1862F29D7B}). */
export type PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = Item & {
  __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Page Design Folder template (ID: {446A7EAD-EB89-4ED6-B48C-7F1862F29D7B}). */
export type PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Design Folder template (ID: {446A7EAD-EB89-4ED6-B48C-7F1862F29D7B}). */
export type PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Design Folder template (ID: {446A7EAD-EB89-4ED6-B48C-7F1862F29D7B}). */
export type PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Page Design Folder template (ID: {446A7EAD-EB89-4ED6-B48C-7F1862F29D7B}). */
export type PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Design Folder template (ID: {446A7EAD-EB89-4ED6-B48C-7F1862F29D7B}). */
export type PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Design Folder template (ID: {446A7EAD-EB89-4ED6-B48C-7F1862F29D7B}). */
export type PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Page Design Folder template (ID: {720D01F1-1E50-46FA-9C4A-697F9321F662}). */
export type PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = Item & {
  __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Page Design Folder template (ID: {720D01F1-1E50-46FA-9C4A-697F9321F662}). */
export type PageDesignFolder_720d01f11e5046fa9c4a697f9321f662AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page Design Folder template (ID: {720D01F1-1E50-46FA-9C4A-697F9321F662}). */
export type PageDesignFolder_720d01f11e5046fa9c4a697f9321f662ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page Design Folder template (ID: {720D01F1-1E50-46FA-9C4A-697F9321F662}). */
export type PageDesignFolder_720d01f11e5046fa9c4a697f9321f662FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Page Design Folder template (ID: {720D01F1-1E50-46FA-9C4A-697F9321F662}). */
export type PageDesignFolder_720d01f11e5046fa9c4a697f9321f662FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Page Design Folder template (ID: {720D01F1-1E50-46FA-9C4A-697F9321F662}). */
export type PageDesignFolder_720d01f11e5046fa9c4a697f9321f662HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page Design Folder template (ID: {720D01F1-1E50-46FA-9C4A-697F9321F662}). */
export type PageDesignFolder_720d01f11e5046fa9c4a697f9321f662IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Invest Trusts/Page Design Folder template (ID: {771A0DE7-E83F-4433-8C5D-78727EAD93BC}). */
export type PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = Item & {
  __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/Page Design Folder template (ID: {771A0DE7-E83F-4433-8C5D-78727EAD93BC}). */
export type PageDesignFolder_771a0de7e83f44338c5d78727ead93bcAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Design Folder template (ID: {771A0DE7-E83F-4433-8C5D-78727EAD93BC}). */
export type PageDesignFolder_771a0de7e83f44338c5d78727ead93bcChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Design Folder template (ID: {771A0DE7-E83F-4433-8C5D-78727EAD93BC}). */
export type PageDesignFolder_771a0de7e83f44338c5d78727ead93bcFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/Page Design Folder template (ID: {771A0DE7-E83F-4433-8C5D-78727EAD93BC}). */
export type PageDesignFolder_771a0de7e83f44338c5d78727ead93bcFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Design Folder template (ID: {771A0DE7-E83F-4433-8C5D-78727EAD93BC}). */
export type PageDesignFolder_771a0de7e83f44338c5d78727ead93bcHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Design Folder template (ID: {771A0DE7-E83F-4433-8C5D-78727EAD93BC}). */
export type PageDesignFolder_771a0de7e83f44338c5d78727ead93bcIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/Page Design Folder template (ID: {14161EC2-0498-4AA7-A2A4-6DECADF669F5}). */
export type PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = Item & {
  __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Design Folder template (ID: {14161EC2-0498-4AA7-A2A4-6DECADF669F5}). */
export type PageDesignFolder_14161ec204984aa7a2a46decadf669f5AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Design Folder template (ID: {14161EC2-0498-4AA7-A2A4-6DECADF669F5}). */
export type PageDesignFolder_14161ec204984aa7a2a46decadf669f5ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Design Folder template (ID: {14161EC2-0498-4AA7-A2A4-6DECADF669F5}). */
export type PageDesignFolder_14161ec204984aa7a2a46decadf669f5FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Design Folder template (ID: {14161EC2-0498-4AA7-A2A4-6DECADF669F5}). */
export type PageDesignFolder_14161ec204984aa7a2a46decadf669f5FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Design Folder template (ID: {14161EC2-0498-4AA7-A2A4-6DECADF669F5}). */
export type PageDesignFolder_14161ec204984aa7a2a46decadf669f5HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Design Folder template (ID: {14161EC2-0498-4AA7-A2A4-6DECADF669F5}). */
export type PageDesignFolder_14161ec204984aa7a2a46decadf669f5IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Page Design Folder template (ID: {C691C2C4-E0DD-4FED-B84A-3C29DE7002CB}). */
export type PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb = Item & {
  __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Page Design Folder template (ID: {C691C2C4-E0DD-4FED-B84A-3C29DE7002CB}). */
export type PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cbAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page Design Folder template (ID: {C691C2C4-E0DD-4FED-B84A-3C29DE7002CB}). */
export type PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cbChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page Design Folder template (ID: {C691C2C4-E0DD-4FED-B84A-3C29DE7002CB}). */
export type PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cbFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Page Design Folder template (ID: {C691C2C4-E0DD-4FED-B84A-3C29DE7002CB}). */
export type PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cbFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Page Design Folder template (ID: {C691C2C4-E0DD-4FED-B84A-3C29DE7002CB}). */
export type PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cbHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page Design Folder template (ID: {C691C2C4-E0DD-4FED-B84A-3C29DE7002CB}). */
export type PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cbIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/Page Design Folder template (ID: {D84605F7-86EA-482D-A6FF-683F6572821C}). */
export type PageDesignFolder_D84605f786ea482da6ff683f6572821c = Item & {
  __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/Page Design Folder template (ID: {D84605F7-86EA-482D-A6FF-683F6572821C}). */
export type PageDesignFolder_D84605f786ea482da6ff683f6572821cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page Design Folder template (ID: {D84605F7-86EA-482D-A6FF-683F6572821C}). */
export type PageDesignFolder_D84605f786ea482da6ff683f6572821cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page Design Folder template (ID: {D84605F7-86EA-482D-A6FF-683F6572821C}). */
export type PageDesignFolder_D84605f786ea482da6ff683f6572821cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/Page Design Folder template (ID: {D84605F7-86EA-482D-A6FF-683F6572821C}). */
export type PageDesignFolder_D84605f786ea482da6ff683f6572821cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/Page Design Folder template (ID: {D84605F7-86EA-482D-A6FF-683F6572821C}). */
export type PageDesignFolder_D84605f786ea482da6ff683f6572821cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page Design Folder template (ID: {D84605F7-86EA-482D-A6FF-683F6572821C}). */
export type PageDesignFolder_D84605f786ea482da6ff683f6572821cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Design template (ID: {1105B8F8-1E00-426B-BF1F-C840742D827B}). */
export type PageDesign_1105b8f81e00426bbf1fc840742d827b = Item & _BasePageDesign & {
  __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** PartialDesigns (ID: {0966B999-0D0E-4278-ACC9-9DA69D461FE6}). */
  partialDesigns?: Maybe<MultilistField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Design template (ID: {1105B8F8-1E00-426B-BF1F-C840742D827B}). */
export type PageDesign_1105b8f81e00426bbf1fc840742d827bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Design template (ID: {1105B8F8-1E00-426B-BF1F-C840742D827B}). */
export type PageDesign_1105b8f81e00426bbf1fc840742d827bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Design template (ID: {1105B8F8-1E00-426B-BF1F-C840742D827B}). */
export type PageDesign_1105b8f81e00426bbf1fc840742d827bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Design template (ID: {1105B8F8-1E00-426B-BF1F-C840742D827B}). */
export type PageDesign_1105b8f81e00426bbf1fc840742d827bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Design template (ID: {1105B8F8-1E00-426B-BF1F-C840742D827B}). */
export type PageDesign_1105b8f81e00426bbf1fc840742d827bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Design template (ID: {1105B8F8-1E00-426B-BF1F-C840742D827B}). */
export type PageDesign_1105b8f81e00426bbf1fc840742d827bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Designs template (ID: {4A27A071-4D99-408F-B97E-2C9852C8D137}). */
export type PageDesigns = Item & _DesignTemplateMapping & {
  __typename?: 'PageDesigns';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Designs template (ID: {4A27A071-4D99-408F-B97E-2C9852C8D137}). */
export type PageDesignsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Designs template (ID: {4A27A071-4D99-408F-B97E-2C9852C8D137}). */
export type PageDesignsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Designs template (ID: {4A27A071-4D99-408F-B97E-2C9852C8D137}). */
export type PageDesignsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Designs template (ID: {4A27A071-4D99-408F-B97E-2C9852C8D137}). */
export type PageDesignsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Designs template (ID: {4A27A071-4D99-408F-B97E-2C9852C8D137}). */
export type PageDesignsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Page Designs template (ID: {4A27A071-4D99-408F-B97E-2C9852C8D137}). */
export type PageDesignsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Page Designs template (ID: {3AF52E70-E982-424B-9C85-E355542500C9}). */
export type PageDesigns_3af52e70e982424b9c85e355542500c9 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Designs template (ID: {3AF52E70-E982-424B-9C85-E355542500C9}). */
export type PageDesigns_3af52e70e982424b9c85e355542500c9AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Designs template (ID: {3AF52E70-E982-424B-9C85-E355542500C9}). */
export type PageDesigns_3af52e70e982424b9c85e355542500c9ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Designs template (ID: {3AF52E70-E982-424B-9C85-E355542500C9}). */
export type PageDesigns_3af52e70e982424b9c85e355542500c9FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Designs template (ID: {3AF52E70-E982-424B-9C85-E355542500C9}). */
export type PageDesigns_3af52e70e982424b9c85e355542500c9FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Designs template (ID: {3AF52E70-E982-424B-9C85-E355542500C9}). */
export type PageDesigns_3af52e70e982424b9c85e355542500c9HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Page Designs template (ID: {3AF52E70-E982-424B-9C85-E355542500C9}). */
export type PageDesigns_3af52e70e982424b9c85e355542500c9IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Page Designs template (ID: {9B34083E-890B-467D-8E76-B8C3DBBB712D}). */
export type PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Page Designs template (ID: {9B34083E-890B-467D-8E76-B8C3DBBB712D}). */
export type PageDesigns_9b34083e890b467d8e76b8c3dbbb712dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page Designs template (ID: {9B34083E-890B-467D-8E76-B8C3DBBB712D}). */
export type PageDesigns_9b34083e890b467d8e76b8c3dbbb712dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page Designs template (ID: {9B34083E-890B-467D-8E76-B8C3DBBB712D}). */
export type PageDesigns_9b34083e890b467d8e76b8c3dbbb712dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Page Designs template (ID: {9B34083E-890B-467D-8E76-B8C3DBBB712D}). */
export type PageDesigns_9b34083e890b467d8e76b8c3dbbb712dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Page Designs template (ID: {9B34083E-890B-467D-8E76-B8C3DBBB712D}). */
export type PageDesigns_9b34083e890b467d8e76b8c3dbbb712dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page Designs template (ID: {9B34083E-890B-467D-8E76-B8C3DBBB712D}). */
export type PageDesigns_9b34083e890b467d8e76b8c3dbbb712dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/Page Designs template (ID: {48D2D50A-150C-4F62-8360-3A4FED5646E0}). */
export type PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Designs template (ID: {48D2D50A-150C-4F62-8360-3A4FED5646E0}). */
export type PageDesigns_48d2d50a150c4f6283603a4fed5646e0AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Designs template (ID: {48D2D50A-150C-4F62-8360-3A4FED5646E0}). */
export type PageDesigns_48d2d50a150c4f6283603a4fed5646e0ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Designs template (ID: {48D2D50A-150C-4F62-8360-3A4FED5646E0}). */
export type PageDesigns_48d2d50a150c4f6283603a4fed5646e0FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Designs template (ID: {48D2D50A-150C-4F62-8360-3A4FED5646E0}). */
export type PageDesigns_48d2d50a150c4f6283603a4fed5646e0FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Designs template (ID: {48D2D50A-150C-4F62-8360-3A4FED5646E0}). */
export type PageDesigns_48d2d50a150c4f6283603a4fed5646e0HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page Designs template (ID: {48D2D50A-150C-4F62-8360-3A4FED5646E0}). */
export type PageDesigns_48d2d50a150c4f6283603a4fed5646e0IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Page Designs template (ID: {99A71BBA-5077-4672-9C3F-B29B04ABEE23}). */
export type PageDesigns_99a71bba507746729c3fb29b04abee23 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Page Designs template (ID: {99A71BBA-5077-4672-9C3F-B29B04ABEE23}). */
export type PageDesigns_99a71bba507746729c3fb29b04abee23AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page Designs template (ID: {99A71BBA-5077-4672-9C3F-B29B04ABEE23}). */
export type PageDesigns_99a71bba507746729c3fb29b04abee23ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page Designs template (ID: {99A71BBA-5077-4672-9C3F-B29B04ABEE23}). */
export type PageDesigns_99a71bba507746729c3fb29b04abee23FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Page Designs template (ID: {99A71BBA-5077-4672-9C3F-B29B04ABEE23}). */
export type PageDesigns_99a71bba507746729c3fb29b04abee23FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Page Designs template (ID: {99A71BBA-5077-4672-9C3F-B29B04ABEE23}). */
export type PageDesigns_99a71bba507746729c3fb29b04abee23HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page Designs template (ID: {99A71BBA-5077-4672-9C3F-B29B04ABEE23}). */
export type PageDesigns_99a71bba507746729c3fb29b04abee23IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Page Designs template (ID: {A0F265B4-2D62-4196-8B65-D3EDE7CB59C3}). */
export type PageDesigns_A0f265b42d6241968b65d3ede7cb59c3 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Page Designs template (ID: {A0F265B4-2D62-4196-8B65-D3EDE7CB59C3}). */
export type PageDesigns_A0f265b42d6241968b65d3ede7cb59c3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Designs template (ID: {A0F265B4-2D62-4196-8B65-D3EDE7CB59C3}). */
export type PageDesigns_A0f265b42d6241968b65d3ede7cb59c3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Designs template (ID: {A0F265B4-2D62-4196-8B65-D3EDE7CB59C3}). */
export type PageDesigns_A0f265b42d6241968b65d3ede7cb59c3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Page Designs template (ID: {A0F265B4-2D62-4196-8B65-D3EDE7CB59C3}). */
export type PageDesigns_A0f265b42d6241968b65d3ede7cb59c3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Designs template (ID: {A0F265B4-2D62-4196-8B65-D3EDE7CB59C3}). */
export type PageDesigns_A0f265b42d6241968b65d3ede7cb59c3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page Designs template (ID: {A0F265B4-2D62-4196-8B65-D3EDE7CB59C3}). */
export type PageDesigns_A0f265b42d6241968b65d3ede7cb59c3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/Page Designs template (ID: {ABE5CE6A-82FF-4433-B497-3BC50F192E11}). */
export type PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/Page Designs template (ID: {ABE5CE6A-82FF-4433-B497-3BC50F192E11}). */
export type PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page Designs template (ID: {ABE5CE6A-82FF-4433-B497-3BC50F192E11}). */
export type PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page Designs template (ID: {ABE5CE6A-82FF-4433-B497-3BC50F192E11}). */
export type PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/Page Designs template (ID: {ABE5CE6A-82FF-4433-B497-3BC50F192E11}). */
export type PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/Page Designs template (ID: {ABE5CE6A-82FF-4433-B497-3BC50F192E11}). */
export type PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page Designs template (ID: {ABE5CE6A-82FF-4433-B497-3BC50F192E11}). */
export type PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Page Designs template (ID: {B8D9B352-C169-4B31-BD50-6848B47CA884}). */
export type PageDesigns_B8d9b352c1694b31bd506848b47ca884 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Page Designs template (ID: {B8D9B352-C169-4B31-BD50-6848B47CA884}). */
export type PageDesigns_B8d9b352c1694b31bd506848b47ca884AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page Designs template (ID: {B8D9B352-C169-4B31-BD50-6848B47CA884}). */
export type PageDesigns_B8d9b352c1694b31bd506848b47ca884ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page Designs template (ID: {B8D9B352-C169-4B31-BD50-6848B47CA884}). */
export type PageDesigns_B8d9b352c1694b31bd506848b47ca884FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Page Designs template (ID: {B8D9B352-C169-4B31-BD50-6848B47CA884}). */
export type PageDesigns_B8d9b352c1694b31bd506848b47ca884FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Page Designs template (ID: {B8D9B352-C169-4B31-BD50-6848B47CA884}). */
export type PageDesigns_B8d9b352c1694b31bd506848b47ca884HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page Designs template (ID: {B8D9B352-C169-4B31-BD50-6848B47CA884}). */
export type PageDesigns_B8d9b352c1694b31bd506848b47ca884IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Page Designs template (ID: {D3B2E146-6F74-4DF0-900B-EC314F699EF3}). */
export type PageDesigns_D3b2e1466f744df0900bec314f699ef3 = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Page Designs template (ID: {D3B2E146-6F74-4DF0-900B-EC314F699EF3}). */
export type PageDesigns_D3b2e1466f744df0900bec314f699ef3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page Designs template (ID: {D3B2E146-6F74-4DF0-900B-EC314F699EF3}). */
export type PageDesigns_D3b2e1466f744df0900bec314f699ef3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page Designs template (ID: {D3B2E146-6F74-4DF0-900B-EC314F699EF3}). */
export type PageDesigns_D3b2e1466f744df0900bec314f699ef3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Page Designs template (ID: {D3B2E146-6F74-4DF0-900B-EC314F699EF3}). */
export type PageDesigns_D3b2e1466f744df0900bec314f699ef3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Page Designs template (ID: {D3B2E146-6F74-4DF0-900B-EC314F699EF3}). */
export type PageDesigns_D3b2e1466f744df0900bec314f699ef3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page Designs template (ID: {D3B2E146-6F74-4DF0-900B-EC314F699EF3}). */
export type PageDesigns_D3b2e1466f744df0900bec314f699ef3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Page Designs template (ID: {DAAF41FD-96DB-4892-BE99-F62F16D036C4}). Also implements PageDesignFolder, _DesignTemplateMapping, _BasePageDesignFolder, Folder. */
export type PageDesigns_Daaf41fd96db4892be99f62f16d036c4 = {
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
};

/** /sitecore/templates/Project/Invest Trusts/Page Designs template (ID: {FD4B9B54-F747-4F01-ABDE-BA569D4B5BBE}). */
export type PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe = Item & PageDesigns_Daaf41fd96db4892be99f62f16d036c4 & _DesignTemplateMapping & {
  __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/Page Designs template (ID: {FD4B9B54-F747-4F01-ABDE-BA569D4B5BBE}). */
export type PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Designs template (ID: {FD4B9B54-F747-4F01-ABDE-BA569D4B5BBE}). */
export type PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Designs template (ID: {FD4B9B54-F747-4F01-ABDE-BA569D4B5BBE}). */
export type PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/Page Designs template (ID: {FD4B9B54-F747-4F01-ABDE-BA569D4B5BBE}). */
export type PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Designs template (ID: {FD4B9B54-F747-4F01-ABDE-BA569D4B5BBE}). */
export type PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page Designs template (ID: {FD4B9B54-F747-4F01-ABDE-BA569D4B5BBE}). */
export type PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Scalars['String']['output'];
  /** Indicates whether more pages exist. */
  hasNext: Scalars['Boolean']['output'];
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs template (ID: {7A62EDFA-562E-4D75-88A9-D15352BF5CA1}). */
export type PageLevelTabs = Item & {
  __typename?: 'PageLevelTabs';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs template (ID: {7A62EDFA-562E-4D75-88A9-D15352BF5CA1}). */
export type PageLevelTabsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs template (ID: {7A62EDFA-562E-4D75-88A9-D15352BF5CA1}). */
export type PageLevelTabsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs template (ID: {7A62EDFA-562E-4D75-88A9-D15352BF5CA1}). */
export type PageLevelTabsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs template (ID: {7A62EDFA-562E-4D75-88A9-D15352BF5CA1}). */
export type PageLevelTabsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs template (ID: {7A62EDFA-562E-4D75-88A9-D15352BF5CA1}). */
export type PageLevelTabsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs template (ID: {7A62EDFA-562E-4D75-88A9-D15352BF5CA1}). */
export type PageLevelTabsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs Folder template (ID: {32362B98-CAB1-4C1D-A2FD-711AFC22E3C5}). */
export type PageLevelTabsFolder = Item & {
  __typename?: 'PageLevelTabsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs Folder template (ID: {32362B98-CAB1-4C1D-A2FD-711AFC22E3C5}). */
export type PageLevelTabsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs Folder template (ID: {32362B98-CAB1-4C1D-A2FD-711AFC22E3C5}). */
export type PageLevelTabsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs Folder template (ID: {32362B98-CAB1-4C1D-A2FD-711AFC22E3C5}). */
export type PageLevelTabsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs Folder template (ID: {32362B98-CAB1-4C1D-A2FD-711AFC22E3C5}). */
export type PageLevelTabsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs Folder template (ID: {32362B98-CAB1-4C1D-A2FD-711AFC22E3C5}). */
export type PageLevelTabsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Page Level Tabs Folder template (ID: {32362B98-CAB1-4C1D-A2FD-711AFC22E3C5}). */
export type PageLevelTabsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page List template (ID: {A7AEC509-595D-4217-9999-35EEE709F1FC}). */
export type PageList = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IPaginable & IPagination & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'PageList';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** ListSignature (ID: {3E44E786-672E-4DC0-86A0-FFF0D99A3471}). */
  listSignature?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Offset (ID: {778DF306-72BF-4ECA-8DED-0F0A18A5F9B4}). */
  offset?: Maybe<IntegerField>;
  /** PageSize (ID: {C5A5C905-855F-4DA9-941A-2C20845D0473}). */
  pageSize?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Source Type (ID: {C57B9A95-2420-4CCA-8112-6A9C41B9148B}). */
  sourceType?: Maybe<LookupField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page List template (ID: {A7AEC509-595D-4217-9999-35EEE709F1FC}). */
export type PageListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page List template (ID: {A7AEC509-595D-4217-9999-35EEE709F1FC}). */
export type PageListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page List template (ID: {A7AEC509-595D-4217-9999-35EEE709F1FC}). */
export type PageListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page List template (ID: {A7AEC509-595D-4217-9999-35EEE709F1FC}). */
export type PageListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page List template (ID: {A7AEC509-595D-4217-9999-35EEE709F1FC}). */
export type PageListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Page List template (ID: {A7AEC509-595D-4217-9999-35EEE709F1FC}). */
export type PageListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Selector template (ID: {C4354A50-7A46-4DF0-89AB-DD02DB6D15CB}). */
export type PageSelector = Item & {
  __typename?: 'PageSelector';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FirstLabel (ID: {CD2000F5-5AD5-44F0-8C83-5A87EA9812AC}). */
  firstLabel?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LastLabel (ID: {C431B494-CBB5-4BBD-8276-3D9BE420FC92}). */
  lastLabel?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NextLabel (ID: {85C8AB08-22CA-41BF-9673-F7D1F25174A7}). */
  nextLabel?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PreviousLabel (ID: {6E8AE3CB-EAFC-49A1-A1F2-EFE2E9B04ACD}). */
  previousLabel?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Selector template (ID: {C4354A50-7A46-4DF0-89AB-DD02DB6D15CB}). */
export type PageSelectorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Selector template (ID: {C4354A50-7A46-4DF0-89AB-DD02DB6D15CB}). */
export type PageSelectorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Selector template (ID: {C4354A50-7A46-4DF0-89AB-DD02DB6D15CB}). */
export type PageSelectorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Selector template (ID: {C4354A50-7A46-4DF0-89AB-DD02DB6D15CB}). */
export type PageSelectorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Selector template (ID: {C4354A50-7A46-4DF0-89AB-DD02DB6D15CB}). */
export type PageSelectorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Selector template (ID: {C4354A50-7A46-4DF0-89AB-DD02DB6D15CB}). */
export type PageSelectorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Page Selector Configuration template (ID: {458A37BA-8222-4182-86E5-E086CFCDAD5C}). */
export type PageSelectorConfiguration = Item & {
  __typename?: 'PageSelectorConfiguration';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FirstLabel (ID: {022BC2FE-8BBB-4B83-A3D5-A5E1273FE57B}). */
  firstLabel?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LastLabel (ID: {B5631789-5AE0-4DB2-BAA2-995296EF5D8A}). */
  lastLabel?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NextLabel (ID: {0D22BFA8-90DF-4417-A46A-D5059A1EDAC9}). */
  nextLabel?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PreviousLabel (ID: {F973FAD7-E7A4-471B-B888-5A88F95DC121}). */
  previousLabel?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Page Selector Configuration template (ID: {458A37BA-8222-4182-86E5-E086CFCDAD5C}). */
export type PageSelectorConfigurationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Page Selector Configuration template (ID: {458A37BA-8222-4182-86E5-E086CFCDAD5C}). */
export type PageSelectorConfigurationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Page Selector Configuration template (ID: {458A37BA-8222-4182-86E5-E086CFCDAD5C}). */
export type PageSelectorConfigurationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Page Selector Configuration template (ID: {458A37BA-8222-4182-86E5-E086CFCDAD5C}). */
export type PageSelectorConfigurationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Page Selector Configuration template (ID: {458A37BA-8222-4182-86E5-E086CFCDAD5C}). */
export type PageSelectorConfigurationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Page Selector Configuration template (ID: {458A37BA-8222-4182-86E5-E086CFCDAD5C}). */
export type PageSelectorConfigurationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Selector Folder template (ID: {3CB0D374-029B-4EEB-BA8B-ED75B0C25188}). */
export type PageSelectorFolder = Item & {
  __typename?: 'PageSelectorFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Selector Folder template (ID: {3CB0D374-029B-4EEB-BA8B-ED75B0C25188}). */
export type PageSelectorFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Selector Folder template (ID: {3CB0D374-029B-4EEB-BA8B-ED75B0C25188}). */
export type PageSelectorFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Selector Folder template (ID: {3CB0D374-029B-4EEB-BA8B-ED75B0C25188}). */
export type PageSelectorFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Selector Folder template (ID: {3CB0D374-029B-4EEB-BA8B-ED75B0C25188}). */
export type PageSelectorFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Selector Folder template (ID: {3CB0D374-029B-4EEB-BA8B-ED75B0C25188}). */
export type PageSelectorFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Selector Folder template (ID: {3CB0D374-029B-4EEB-BA8B-ED75B0C25188}). */
export type PageSelectorFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Selector template (ID: {59A7BB77-5F8C-435A-B810-291ABDE80E63}). */
export type PageSelector_59a7bb775f8c435ab810291abde80e63 = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Collapsed mode treshold (ID: {13BDF0F6-D371-432D-9C5E-A986A75D92CB}). */
  collapsedModeTreshold?: Maybe<IntegerField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Selector template (ID: {59A7BB77-5F8C-435A-B810-291ABDE80E63}). */
export type PageSelector_59a7bb775f8c435ab810291abde80e63AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Selector template (ID: {59A7BB77-5F8C-435A-B810-291ABDE80E63}). */
export type PageSelector_59a7bb775f8c435ab810291abde80e63ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Selector template (ID: {59A7BB77-5F8C-435A-B810-291ABDE80E63}). */
export type PageSelector_59a7bb775f8c435ab810291abde80e63FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Selector template (ID: {59A7BB77-5F8C-435A-B810-291ABDE80E63}). */
export type PageSelector_59a7bb775f8c435ab810291abde80e63FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Selector template (ID: {59A7BB77-5F8C-435A-B810-291ABDE80E63}). */
export type PageSelector_59a7bb775f8c435ab810291abde80e63HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Selector template (ID: {59A7BB77-5F8C-435A-B810-291ABDE80E63}). */
export type PageSelector_59a7bb775f8c435ab810291abde80e63IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Size template (ID: {FF866CD3-0503-4549-A9C4-AE6361E040D1}). */
export type PageSize = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'PageSize';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** PageSize (ID: {85E2D73B-F11A-4BD7-9826-86BB191925C5}). */
  pageSize?: Maybe<LookupField>;
  /** PagingSchema (ID: {6D46205B-A8BE-4891-8A2B-B573179365D3}). */
  pagingSchema?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Size template (ID: {FF866CD3-0503-4549-A9C4-AE6361E040D1}). */
export type PageSizeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Size template (ID: {FF866CD3-0503-4549-A9C4-AE6361E040D1}). */
export type PageSizeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Size template (ID: {FF866CD3-0503-4549-A9C4-AE6361E040D1}). */
export type PageSizeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Size template (ID: {FF866CD3-0503-4549-A9C4-AE6361E040D1}). */
export type PageSizeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Size template (ID: {FF866CD3-0503-4549-A9C4-AE6361E040D1}). */
export type PageSizeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Page Size template (ID: {FF866CD3-0503-4549-A9C4-AE6361E040D1}). */
export type PageSizeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Size Folder template (ID: {F823B393-FEA3-4487-A3C8-C084F114151A}). */
export type PageSizeFolder = Item & {
  __typename?: 'PageSizeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Size Folder template (ID: {F823B393-FEA3-4487-A3C8-C084F114151A}). */
export type PageSizeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Size Folder template (ID: {F823B393-FEA3-4487-A3C8-C084F114151A}). */
export type PageSizeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Size Folder template (ID: {F823B393-FEA3-4487-A3C8-C084F114151A}). */
export type PageSizeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Size Folder template (ID: {F823B393-FEA3-4487-A3C8-C084F114151A}). */
export type PageSizeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Size Folder template (ID: {F823B393-FEA3-4487-A3C8-C084F114151A}). */
export type PageSizeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Page Size Folder template (ID: {F823B393-FEA3-4487-A3C8-C084F114151A}). */
export type PageSizeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/PageSize template (ID: {B682562E-0AF6-4B3E-9E3B-45273BBE152D}). */
export type PageSize_B682562e0af64b3e9e3b45273bbe152d = Item & {
  __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Text (ID: {11E20569-CC3A-4C0F-B068-50605C3C3AA7}). */
  text?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Value (ID: {BEFC61BF-8CFD-4478-9F5C-8422E6E2F005}). */
  value?: Maybe<IntegerField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/PageSize template (ID: {B682562E-0AF6-4B3E-9E3B-45273BBE152D}). */
export type PageSize_B682562e0af64b3e9e3b45273bbe152dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/PageSize template (ID: {B682562E-0AF6-4B3E-9E3B-45273BBE152D}). */
export type PageSize_B682562e0af64b3e9e3b45273bbe152dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/PageSize template (ID: {B682562E-0AF6-4B3E-9E3B-45273BBE152D}). */
export type PageSize_B682562e0af64b3e9e3b45273bbe152dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/PageSize template (ID: {B682562E-0AF6-4B3E-9E3B-45273BBE152D}). */
export type PageSize_B682562e0af64b3e9e3b45273bbe152dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/PageSize template (ID: {B682562E-0AF6-4B3E-9E3B-45273BBE152D}). */
export type PageSize_B682562e0af64b3e9e3b45273bbe152dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/PageSize template (ID: {B682562E-0AF6-4B3E-9E3B-45273BBE152D}). */
export type PageSize_B682562e0af64b3e9e3b45273bbe152dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Theme template (ID: {844A7B4E-AC13-4945-8B2A-45A8D165BB3C}). */
export type PageTheme = Item & {
  __typename?: 'PageTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Theme template (ID: {844A7B4E-AC13-4945-8B2A-45A8D165BB3C}). */
export type PageThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Theme template (ID: {844A7B4E-AC13-4945-8B2A-45A8D165BB3C}). */
export type PageThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Theme template (ID: {844A7B4E-AC13-4945-8B2A-45A8D165BB3C}). */
export type PageThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Theme template (ID: {844A7B4E-AC13-4945-8B2A-45A8D165BB3C}). */
export type PageThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Theme template (ID: {844A7B4E-AC13-4945-8B2A-45A8D165BB3C}). */
export type PageThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Theme template (ID: {844A7B4E-AC13-4945-8B2A-45A8D165BB3C}). */
export type PageThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Themes Folder template (ID: {A2AEB252-9246-41E8-9252-A1735C245F72}). */
export type PageThemesFolder = Item & {
  __typename?: 'PageThemesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Themes Folder template (ID: {A2AEB252-9246-41E8-9252-A1735C245F72}). */
export type PageThemesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Themes Folder template (ID: {A2AEB252-9246-41E8-9252-A1735C245F72}). */
export type PageThemesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Themes Folder template (ID: {A2AEB252-9246-41E8-9252-A1735C245F72}). */
export type PageThemesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Themes Folder template (ID: {A2AEB252-9246-41E8-9252-A1735C245F72}). */
export type PageThemesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Themes Folder template (ID: {A2AEB252-9246-41E8-9252-A1735C245F72}). */
export type PageThemesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Page Theme/Page Themes Folder template (ID: {A2AEB252-9246-41E8-9252-A1735C245F72}). */
export type PageThemesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Page template (ID: {4F49A81D-B366-4F19-8B89-CAB92F377D7A}). */
export type Page_4f49a81db3664f198b89cab92f377d7a = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {186D2E1D-ADD6-43DC-959B-A8E75EEDE7E0}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {16F3CD00-82E8-4B26-A7B9-AF81AA850174}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Page template (ID: {4F49A81D-B366-4F19-8B89-CAB92F377D7A}). */
export type Page_4f49a81db3664f198b89cab92f377d7aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page template (ID: {4F49A81D-B366-4F19-8B89-CAB92F377D7A}). */
export type Page_4f49a81db3664f198b89cab92f377d7aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page template (ID: {4F49A81D-B366-4F19-8B89-CAB92F377D7A}). */
export type Page_4f49a81db3664f198b89cab92f377d7aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Page template (ID: {4F49A81D-B366-4F19-8B89-CAB92F377D7A}). */
export type Page_4f49a81db3664f198b89cab92f377d7aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Page template (ID: {4F49A81D-B366-4F19-8B89-CAB92F377D7A}). */
export type Page_4f49a81db3664f198b89cab92f377d7aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Page template (ID: {4F49A81D-B366-4F19-8B89-CAB92F377D7A}). */
export type Page_4f49a81db3664f198b89cab92f377d7aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/Page template (ID: {5E66D863-5354-4FE6-A27D-3B894984D50F}). */
export type Page_5e66d86353544fe6a27d3b894984d50f = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {78504001-1B6A-4370-A163-6D55D5180732}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {DB98B293-EC1D-4D6B-A688-23D2F33465AD}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/Page template (ID: {5E66D863-5354-4FE6-A27D-3B894984D50F}). */
export type Page_5e66d86353544fe6a27d3b894984d50fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page template (ID: {5E66D863-5354-4FE6-A27D-3B894984D50F}). */
export type Page_5e66d86353544fe6a27d3b894984d50fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page template (ID: {5E66D863-5354-4FE6-A27D-3B894984D50F}). */
export type Page_5e66d86353544fe6a27d3b894984d50fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/Page template (ID: {5E66D863-5354-4FE6-A27D-3B894984D50F}). */
export type Page_5e66d86353544fe6a27d3b894984d50fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/Page template (ID: {5E66D863-5354-4FE6-A27D-3B894984D50F}). */
export type Page_5e66d86353544fe6a27d3b894984d50fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Page template (ID: {5E66D863-5354-4FE6-A27D-3B894984D50F}). */
export type Page_5e66d86353544fe6a27d3b894984d50fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Page template (ID: {84F342AD-2D06-46B9-AA9A-818201145CA2}). */
export type Page_84f342ad2d0646b9aa9a818201145ca2 = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {6594E6F7-0499-40BF-B0B5-991987AF3068}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {29F3758D-89E2-4EA2-B6BF-29A1585635D6}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Page template (ID: {84F342AD-2D06-46B9-AA9A-818201145CA2}). */
export type Page_84f342ad2d0646b9aa9a818201145ca2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page template (ID: {84F342AD-2D06-46B9-AA9A-818201145CA2}). */
export type Page_84f342ad2d0646b9aa9a818201145ca2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page template (ID: {84F342AD-2D06-46B9-AA9A-818201145CA2}). */
export type Page_84f342ad2d0646b9aa9a818201145ca2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Page template (ID: {84F342AD-2D06-46B9-AA9A-818201145CA2}). */
export type Page_84f342ad2d0646b9aa9a818201145ca2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Page template (ID: {84F342AD-2D06-46B9-AA9A-818201145CA2}). */
export type Page_84f342ad2d0646b9aa9a818201145ca2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Page template (ID: {84F342AD-2D06-46B9-AA9A-818201145CA2}). */
export type Page_84f342ad2d0646b9aa9a818201145ca2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Page template (ID: {718DF200-BE51-463D-93ED-F4D77AB7A49E}). */
export type Page_718df200be51463d93edf4d77ab7a49e = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_718df200be51463d93edf4d77ab7a49e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {25B19A78-6419-4BE6-8758-2C527613CCF7}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {546FC037-72E8-46FC-AECE-93EC6CAEBB0B}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Page template (ID: {718DF200-BE51-463D-93ED-F4D77AB7A49E}). */
export type Page_718df200be51463d93edf4d77ab7a49eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page template (ID: {718DF200-BE51-463D-93ED-F4D77AB7A49E}). */
export type Page_718df200be51463d93edf4d77ab7a49eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page template (ID: {718DF200-BE51-463D-93ED-F4D77AB7A49E}). */
export type Page_718df200be51463d93edf4d77ab7a49eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Page template (ID: {718DF200-BE51-463D-93ED-F4D77AB7A49E}). */
export type Page_718df200be51463d93edf4d77ab7a49eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Page template (ID: {718DF200-BE51-463D-93ED-F4D77AB7A49E}). */
export type Page_718df200be51463d93edf4d77ab7a49eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Page template (ID: {718DF200-BE51-463D-93ED-F4D77AB7A49E}). */
export type Page_718df200be51463d93edf4d77ab7a49eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/Page template (ID: {B61D5BAB-E46F-4EF3-9F27-B57C4CCEFDF7}). */
export type Page_B61d5babe46f4ef39f27b57c4ccefdf7 = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {13720E39-A128-4890-B57E-F720D4B3EE49}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {C904D940-7D77-4424-AC6F-63FAB4715346}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page template (ID: {B61D5BAB-E46F-4EF3-9F27-B57C4CCEFDF7}). */
export type Page_B61d5babe46f4ef39f27b57c4ccefdf7AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page template (ID: {B61D5BAB-E46F-4EF3-9F27-B57C4CCEFDF7}). */
export type Page_B61d5babe46f4ef39f27b57c4ccefdf7ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page template (ID: {B61D5BAB-E46F-4EF3-9F27-B57C4CCEFDF7}). */
export type Page_B61d5babe46f4ef39f27b57c4ccefdf7FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page template (ID: {B61D5BAB-E46F-4EF3-9F27-B57C4CCEFDF7}). */
export type Page_B61d5babe46f4ef39f27b57c4ccefdf7FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page template (ID: {B61D5BAB-E46F-4EF3-9F27-B57C4CCEFDF7}). */
export type Page_B61d5babe46f4ef39f27b57c4ccefdf7HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Page template (ID: {B61D5BAB-E46F-4EF3-9F27-B57C4CCEFDF7}). */
export type Page_B61d5babe46f4ef39f27b57c4ccefdf7IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Page template (ID: {CFD6E046-97E2-4F3C-B9EB-41B79AFC35DC}). */
export type Page_Cfd6e04697e24f3cb9eb41b79afc35dc = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {CA257CC0-FF99-4BD9-A11C-F1DE06312D97}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {10682761-9EB6-40BE-8D55-D5D9309BD847}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Page template (ID: {CFD6E046-97E2-4F3C-B9EB-41B79AFC35DC}). */
export type Page_Cfd6e04697e24f3cb9eb41b79afc35dcAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page template (ID: {CFD6E046-97E2-4F3C-B9EB-41B79AFC35DC}). */
export type Page_Cfd6e04697e24f3cb9eb41b79afc35dcChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page template (ID: {CFD6E046-97E2-4F3C-B9EB-41B79AFC35DC}). */
export type Page_Cfd6e04697e24f3cb9eb41b79afc35dcFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Page template (ID: {CFD6E046-97E2-4F3C-B9EB-41B79AFC35DC}). */
export type Page_Cfd6e04697e24f3cb9eb41b79afc35dcFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Page template (ID: {CFD6E046-97E2-4F3C-B9EB-41B79AFC35DC}). */
export type Page_Cfd6e04697e24f3cb9eb41b79afc35dcHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Page template (ID: {CFD6E046-97E2-4F3C-B9EB-41B79AFC35DC}). */
export type Page_Cfd6e04697e24f3cb9eb41b79afc35dcIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Page template (ID: {DAE78211-53E1-4DBA-BB0D-DF0B53A90AAF}). */
export type Page_Dae7821153e14dbabb0ddf0b53a90aaf = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {068C75A4-A14F-4C1B-B5A1-3C91FC420BB0}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {A296AB05-A521-4590-BBD4-5D99C8151BD6}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Page template (ID: {DAE78211-53E1-4DBA-BB0D-DF0B53A90AAF}). */
export type Page_Dae7821153e14dbabb0ddf0b53a90aafAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page template (ID: {DAE78211-53E1-4DBA-BB0D-DF0B53A90AAF}). */
export type Page_Dae7821153e14dbabb0ddf0b53a90aafChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page template (ID: {DAE78211-53E1-4DBA-BB0D-DF0B53A90AAF}). */
export type Page_Dae7821153e14dbabb0ddf0b53a90aafFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Page template (ID: {DAE78211-53E1-4DBA-BB0D-DF0B53A90AAF}). */
export type Page_Dae7821153e14dbabb0ddf0b53a90aafFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Page template (ID: {DAE78211-53E1-4DBA-BB0D-DF0B53A90AAF}). */
export type Page_Dae7821153e14dbabb0ddf0b53a90aafHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Page template (ID: {DAE78211-53E1-4DBA-BB0D-DF0B53A90AAF}). */
export type Page_Dae7821153e14dbabb0ddf0b53a90aafIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Invest Trusts/Page template (ID: {FA608B3E-6AEB-4263-88A0-59D89CAABADA}). */
export type Page_Fa608b3e6aeb426388a059d89caabada = Item & _Designable & _Navigable & _Sitemap & _Taggable & {
  __typename?: 'Page_fa608b3e6aeb426388a059d89caabada';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {23804466-D33A-452B-AD14-480DEC81B077}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {B85B0446-8169-4922-B2CE-211264D9E867}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/Page template (ID: {FA608B3E-6AEB-4263-88A0-59D89CAABADA}). */
export type Page_Fa608b3e6aeb426388a059d89caabadaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page template (ID: {FA608B3E-6AEB-4263-88A0-59D89CAABADA}). */
export type Page_Fa608b3e6aeb426388a059d89caabadaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page template (ID: {FA608B3E-6AEB-4263-88A0-59D89CAABADA}). */
export type Page_Fa608b3e6aeb426388a059d89caabadaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/Page template (ID: {FA608B3E-6AEB-4263-88A0-59D89CAABADA}). */
export type Page_Fa608b3e6aeb426388a059d89caabadaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/Page template (ID: {FA608B3E-6AEB-4263-88A0-59D89CAABADA}). */
export type Page_Fa608b3e6aeb426388a059d89caabadaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Page template (ID: {FA608B3E-6AEB-4263-88A0-59D89CAABADA}). */
export type Page_Fa608b3e6aeb426388a059d89caabadaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/Pagging template (ID: {41CBDC01-C2DF-4768-8ADD-87FB6B5A434B}). */
export type Pagging = Item & {
  __typename?: 'Pagging';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {6D6E0783-1423-4834-AB27-74312E8B6754}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/Pagging template (ID: {41CBDC01-C2DF-4768-8ADD-87FB6B5A434B}). */
export type PaggingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/Pagging template (ID: {41CBDC01-C2DF-4768-8ADD-87FB6B5A434B}). */
export type PaggingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/Pagging template (ID: {41CBDC01-C2DF-4768-8ADD-87FB6B5A434B}). */
export type PaggingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/Pagging template (ID: {41CBDC01-C2DF-4768-8ADD-87FB6B5A434B}). */
export type PaggingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/Pagging template (ID: {41CBDC01-C2DF-4768-8ADD-87FB6B5A434B}). */
export type PaggingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Page Size/Pagging template (ID: {41CBDC01-C2DF-4768-8ADD-87FB6B5A434B}). */
export type PaggingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Pagination template (ID: {366F6F24-0F8D-4F8D-98CC-01622DF9A6AF}). */
export type Pagination = GridParameters & ICacheable & IPagination & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Pagination';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CollapseModeThreshold (ID: {84FC60EE-8AB6-47AA-B04E-FCC1E45DB087}). */
  collapseModeThreshold?: Maybe<IntegerField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** ListSignature (ID: {3E44E786-672E-4DC0-86A0-FFF0D99A3471}). */
  listSignature?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Pagination template (ID: {366F6F24-0F8D-4F8D-98CC-01622DF9A6AF}). */
export type PaginationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Pagination template (ID: {366F6F24-0F8D-4F8D-98CC-01622DF9A6AF}). */
export type PaginationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Pagination template (ID: {366F6F24-0F8D-4F8D-98CC-01622DF9A6AF}). */
export type PaginationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Pagination template (ID: {366F6F24-0F8D-4F8D-98CC-01622DF9A6AF}). */
export type PaginationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Pagination template (ID: {366F6F24-0F8D-4F8D-98CC-01622DF9A6AF}). */
export type PaginationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Pagination template (ID: {366F6F24-0F8D-4F8D-98CC-01622DF9A6AF}). */
export type PaginationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Pagination Folder template (ID: {89895ED9-F3BB-4296-A9B7-C87B7770CDD3}). */
export type PaginationFolder = Item & {
  __typename?: 'PaginationFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Pagination Folder template (ID: {89895ED9-F3BB-4296-A9B7-C87B7770CDD3}). */
export type PaginationFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Pagination Folder template (ID: {89895ED9-F3BB-4296-A9B7-C87B7770CDD3}). */
export type PaginationFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Pagination Folder template (ID: {89895ED9-F3BB-4296-A9B7-C87B7770CDD3}). */
export type PaginationFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Pagination Folder template (ID: {89895ED9-F3BB-4296-A9B7-C87B7770CDD3}). */
export type PaginationFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Pagination Folder template (ID: {89895ED9-F3BB-4296-A9B7-C87B7770CDD3}). */
export type PaginationFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Pagination Folder template (ID: {89895ED9-F3BB-4296-A9B7-C87B7770CDD3}). */
export type PaginationFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Paragraph template (ID: {14DBB572-8C74-48B6-9064-CE8945A929E6}). */
export type Paragraph = Item & {
  __typename?: 'Paragraph';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {9B6D4D9E-4EB4-420A-90C0-B33BEE6C577F}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Paragraph template (ID: {14DBB572-8C74-48B6-9064-CE8945A929E6}). */
export type ParagraphAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Paragraph template (ID: {14DBB572-8C74-48B6-9064-CE8945A929E6}). */
export type ParagraphChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Paragraph template (ID: {14DBB572-8C74-48B6-9064-CE8945A929E6}). */
export type ParagraphFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Paragraph template (ID: {14DBB572-8C74-48B6-9064-CE8945A929E6}). */
export type ParagraphFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Paragraph template (ID: {14DBB572-8C74-48B6-9064-CE8945A929E6}). */
export type ParagraphHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Paragraph template (ID: {14DBB572-8C74-48B6-9064-CE8945A929E6}). */
export type ParagraphIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Design template (ID: {BF680756-B2FA-4CAE-8B69-EE361080616F}). Also implements _BasePartialDesign. */
export type PartialDesign = {
  /** Base Partial Design (ID: {76A92454-C8BE-479B-B260-26AEBCED5A1A}). */
  basePartialDesign?: Maybe<LookupField>;
  /** Signature (ID: {55FAAE90-3BBA-4F7F-96FE-13C3F40055FF}). */
  signature?: Maybe<TextField>;
};

/** /sitecore/templates/Project/Personal/Partial Design Folder template (ID: {8CF20A44-12B7-46EE-8012-18122C955B2D}). */
export type PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = Item & {
  __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Partial Design Folder template (ID: {8CF20A44-12B7-46EE-8012-18122C955B2D}). */
export type PartialDesignFolder_8cf20a4412b746ee801218122c955b2dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Partial Design Folder template (ID: {8CF20A44-12B7-46EE-8012-18122C955B2D}). */
export type PartialDesignFolder_8cf20a4412b746ee801218122c955b2dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Partial Design Folder template (ID: {8CF20A44-12B7-46EE-8012-18122C955B2D}). */
export type PartialDesignFolder_8cf20a4412b746ee801218122c955b2dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Partial Design Folder template (ID: {8CF20A44-12B7-46EE-8012-18122C955B2D}). */
export type PartialDesignFolder_8cf20a4412b746ee801218122c955b2dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Partial Design Folder template (ID: {8CF20A44-12B7-46EE-8012-18122C955B2D}). */
export type PartialDesignFolder_8cf20a4412b746ee801218122c955b2dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Partial Design Folder template (ID: {8CF20A44-12B7-46EE-8012-18122C955B2D}). */
export type PartialDesignFolder_8cf20a4412b746ee801218122c955b2dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Partial Design Folder template (ID: {42EB57EC-AA47-4923-B3DD-BFB72818F00B}). */
export type PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = Item & {
  __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Partial Design Folder template (ID: {42EB57EC-AA47-4923-B3DD-BFB72818F00B}). */
export type PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Design Folder template (ID: {42EB57EC-AA47-4923-B3DD-BFB72818F00B}). */
export type PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Design Folder template (ID: {42EB57EC-AA47-4923-B3DD-BFB72818F00B}). */
export type PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Partial Design Folder template (ID: {42EB57EC-AA47-4923-B3DD-BFB72818F00B}). */
export type PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Design Folder template (ID: {42EB57EC-AA47-4923-B3DD-BFB72818F00B}). */
export type PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Design Folder template (ID: {42EB57EC-AA47-4923-B3DD-BFB72818F00B}). */
export type PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Partial Design Folder template (ID: {766D4DE8-59A0-4192-92DE-1898FE0AC4E8}). */
export type PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = Item & {
  __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Partial Design Folder template (ID: {766D4DE8-59A0-4192-92DE-1898FE0AC4E8}). */
export type PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Partial Design Folder template (ID: {766D4DE8-59A0-4192-92DE-1898FE0AC4E8}). */
export type PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Partial Design Folder template (ID: {766D4DE8-59A0-4192-92DE-1898FE0AC4E8}). */
export type PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Partial Design Folder template (ID: {766D4DE8-59A0-4192-92DE-1898FE0AC4E8}). */
export type PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Partial Design Folder template (ID: {766D4DE8-59A0-4192-92DE-1898FE0AC4E8}). */
export type PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Partial Design Folder template (ID: {766D4DE8-59A0-4192-92DE-1898FE0AC4E8}). */
export type PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Partial Design Folder template (ID: {827D4D2F-2A84-408E-8F0F-F1D6869A441B}). */
export type PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = Item & {
  __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Design Folder template (ID: {827D4D2F-2A84-408E-8F0F-F1D6869A441B}). */
export type PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Design Folder template (ID: {827D4D2F-2A84-408E-8F0F-F1D6869A441B}). */
export type PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Design Folder template (ID: {827D4D2F-2A84-408E-8F0F-F1D6869A441B}). */
export type PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Design Folder template (ID: {827D4D2F-2A84-408E-8F0F-F1D6869A441B}). */
export type PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Design Folder template (ID: {827D4D2F-2A84-408E-8F0F-F1D6869A441B}). */
export type PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Design Folder template (ID: {827D4D2F-2A84-408E-8F0F-F1D6869A441B}). */
export type PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/Partial Design Folder template (ID: {828B5FF1-44CD-4150-BCDF-E54084165112}). */
export type PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = Item & {
  __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/Partial Design Folder template (ID: {828B5FF1-44CD-4150-BCDF-E54084165112}). */
export type PartialDesignFolder_828b5ff144cd4150bcdfe54084165112AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Partial Design Folder template (ID: {828B5FF1-44CD-4150-BCDF-E54084165112}). */
export type PartialDesignFolder_828b5ff144cd4150bcdfe54084165112ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Partial Design Folder template (ID: {828B5FF1-44CD-4150-BCDF-E54084165112}). */
export type PartialDesignFolder_828b5ff144cd4150bcdfe54084165112FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/Partial Design Folder template (ID: {828B5FF1-44CD-4150-BCDF-E54084165112}). */
export type PartialDesignFolder_828b5ff144cd4150bcdfe54084165112FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/Partial Design Folder template (ID: {828B5FF1-44CD-4150-BCDF-E54084165112}). */
export type PartialDesignFolder_828b5ff144cd4150bcdfe54084165112HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Partial Design Folder template (ID: {828B5FF1-44CD-4150-BCDF-E54084165112}). */
export type PartialDesignFolder_828b5ff144cd4150bcdfe54084165112IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Design Folder template (ID: {89098E30-89AA-4062-A773-46D608CAAC90}). */
export type PartialDesignFolder_89098e3089aa4062a77346d608caac90 = Item & {
  __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Design Folder template (ID: {89098E30-89AA-4062-A773-46D608CAAC90}). */
export type PartialDesignFolder_89098e3089aa4062a77346d608caac90AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Design Folder template (ID: {89098E30-89AA-4062-A773-46D608CAAC90}). */
export type PartialDesignFolder_89098e3089aa4062a77346d608caac90ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Design Folder template (ID: {89098E30-89AA-4062-A773-46D608CAAC90}). */
export type PartialDesignFolder_89098e3089aa4062a77346d608caac90FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Design Folder template (ID: {89098E30-89AA-4062-A773-46D608CAAC90}). */
export type PartialDesignFolder_89098e3089aa4062a77346d608caac90FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Design Folder template (ID: {89098E30-89AA-4062-A773-46D608CAAC90}). */
export type PartialDesignFolder_89098e3089aa4062a77346d608caac90HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Design Folder template (ID: {89098E30-89AA-4062-A773-46D608CAAC90}). */
export type PartialDesignFolder_89098e3089aa4062a77346d608caac90IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Partial Design Folder template (ID: {1695576F-B936-47D7-842E-D17730278C32}). */
export type PartialDesignFolder_1695576fb93647d7842ed17730278c32 = Item & {
  __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Partial Design Folder template (ID: {1695576F-B936-47D7-842E-D17730278C32}). */
export type PartialDesignFolder_1695576fb93647d7842ed17730278c32AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Partial Design Folder template (ID: {1695576F-B936-47D7-842E-D17730278C32}). */
export type PartialDesignFolder_1695576fb93647d7842ed17730278c32ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Partial Design Folder template (ID: {1695576F-B936-47D7-842E-D17730278C32}). */
export type PartialDesignFolder_1695576fb93647d7842ed17730278c32FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Partial Design Folder template (ID: {1695576F-B936-47D7-842E-D17730278C32}). */
export type PartialDesignFolder_1695576fb93647d7842ed17730278c32FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Partial Design Folder template (ID: {1695576F-B936-47D7-842E-D17730278C32}). */
export type PartialDesignFolder_1695576fb93647d7842ed17730278c32HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Partial Design Folder template (ID: {1695576F-B936-47D7-842E-D17730278C32}). */
export type PartialDesignFolder_1695576fb93647d7842ed17730278c32IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Partial Design Folder template (ID: {F16AE56F-B788-4563-9407-C88EDAFFCBCC}). */
export type PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc = Item & {
  __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Partial Design Folder template (ID: {F16AE56F-B788-4563-9407-C88EDAFFCBCC}). */
export type PartialDesignFolder_F16ae56fb78845639407c88edaffcbccAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Partial Design Folder template (ID: {F16AE56F-B788-4563-9407-C88EDAFFCBCC}). */
export type PartialDesignFolder_F16ae56fb78845639407c88edaffcbccChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Partial Design Folder template (ID: {F16AE56F-B788-4563-9407-C88EDAFFCBCC}). */
export type PartialDesignFolder_F16ae56fb78845639407c88edaffcbccFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Partial Design Folder template (ID: {F16AE56F-B788-4563-9407-C88EDAFFCBCC}). */
export type PartialDesignFolder_F16ae56fb78845639407c88edaffcbccFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Partial Design Folder template (ID: {F16AE56F-B788-4563-9407-C88EDAFFCBCC}). */
export type PartialDesignFolder_F16ae56fb78845639407c88edaffcbccHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Partial Design Folder template (ID: {F16AE56F-B788-4563-9407-C88EDAFFCBCC}). */
export type PartialDesignFolder_F16ae56fb78845639407c88edaffcbccIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Invest Trusts/Partial Design Folder template (ID: {FB58558A-3EC9-46D1-8524-CD30805AB21A}). */
export type PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a = Item & {
  __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/Partial Design Folder template (ID: {FB58558A-3EC9-46D1-8524-CD30805AB21A}). */
export type PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Design Folder template (ID: {FB58558A-3EC9-46D1-8524-CD30805AB21A}). */
export type PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Design Folder template (ID: {FB58558A-3EC9-46D1-8524-CD30805AB21A}). */
export type PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/Partial Design Folder template (ID: {FB58558A-3EC9-46D1-8524-CD30805AB21A}). */
export type PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Design Folder template (ID: {FB58558A-3EC9-46D1-8524-CD30805AB21A}). */
export type PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Design Folder template (ID: {FB58558A-3EC9-46D1-8524-CD30805AB21A}). */
export type PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Design template (ID: {FD2059FD-6043-4DFE-8C04-E2437CE87634}). */
export type PartialDesign_Fd2059fd60434dfe8c04e2437ce87634 = Item & _BasePartialDesign & {
  __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Base Partial Design (ID: {76A92454-C8BE-479B-B260-26AEBCED5A1A}). */
  basePartialDesign?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Signature (ID: {55FAAE90-3BBA-4F7F-96FE-13C3F40055FF}). */
  signature?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Design template (ID: {FD2059FD-6043-4DFE-8C04-E2437CE87634}). */
export type PartialDesign_Fd2059fd60434dfe8c04e2437ce87634AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Design template (ID: {FD2059FD-6043-4DFE-8C04-E2437CE87634}). */
export type PartialDesign_Fd2059fd60434dfe8c04e2437ce87634ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Design template (ID: {FD2059FD-6043-4DFE-8C04-E2437CE87634}). */
export type PartialDesign_Fd2059fd60434dfe8c04e2437ce87634FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Design template (ID: {FD2059FD-6043-4DFE-8C04-E2437CE87634}). */
export type PartialDesign_Fd2059fd60434dfe8c04e2437ce87634FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Design template (ID: {FD2059FD-6043-4DFE-8C04-E2437CE87634}). */
export type PartialDesign_Fd2059fd60434dfe8c04e2437ce87634HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Partial Design template (ID: {FD2059FD-6043-4DFE-8C04-E2437CE87634}). */
export type PartialDesign_Fd2059fd60434dfe8c04e2437ce87634IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Designs template (ID: {3B4F7E7A-9B8B-4DFD-BCDD-6ADD1DF49613}). */
export type PartialDesigns = Item & {
  __typename?: 'PartialDesigns';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Designs template (ID: {3B4F7E7A-9B8B-4DFD-BCDD-6ADD1DF49613}). */
export type PartialDesignsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Designs template (ID: {3B4F7E7A-9B8B-4DFD-BCDD-6ADD1DF49613}). */
export type PartialDesignsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Designs template (ID: {3B4F7E7A-9B8B-4DFD-BCDD-6ADD1DF49613}). */
export type PartialDesignsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Designs template (ID: {3B4F7E7A-9B8B-4DFD-BCDD-6ADD1DF49613}). */
export type PartialDesignsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Designs template (ID: {3B4F7E7A-9B8B-4DFD-BCDD-6ADD1DF49613}). */
export type PartialDesignsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Partial Designs template (ID: {3B4F7E7A-9B8B-4DFD-BCDD-6ADD1DF49613}). */
export type PartialDesignsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Partial Designs template (ID: {043D3AD0-AC44-45DB-A03A-FC3550D088EC}). */
export type PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = Item & {
  __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Partial Designs template (ID: {043D3AD0-AC44-45DB-A03A-FC3550D088EC}). */
export type PartialDesigns_043d3ad0ac4445dba03afc3550d088ecAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Partial Designs template (ID: {043D3AD0-AC44-45DB-A03A-FC3550D088EC}). */
export type PartialDesigns_043d3ad0ac4445dba03afc3550d088ecChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Partial Designs template (ID: {043D3AD0-AC44-45DB-A03A-FC3550D088EC}). */
export type PartialDesigns_043d3ad0ac4445dba03afc3550d088ecFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Partial Designs template (ID: {043D3AD0-AC44-45DB-A03A-FC3550D088EC}). */
export type PartialDesigns_043d3ad0ac4445dba03afc3550d088ecFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Partial Designs template (ID: {043D3AD0-AC44-45DB-A03A-FC3550D088EC}). */
export type PartialDesigns_043d3ad0ac4445dba03afc3550d088ecHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Partial Designs template (ID: {043D3AD0-AC44-45DB-A03A-FC3550D088EC}). */
export type PartialDesigns_043d3ad0ac4445dba03afc3550d088ecIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Designs template (ID: {0310A4BF-20D1-441C-886A-0418C53E30F4}). */
export type PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = Item & {
  __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Designs template (ID: {0310A4BF-20D1-441C-886A-0418C53E30F4}). */
export type PartialDesigns_0310a4bf20d1441c886a0418c53e30f4AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Designs template (ID: {0310A4BF-20D1-441C-886A-0418C53E30F4}). */
export type PartialDesigns_0310a4bf20d1441c886a0418c53e30f4ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Designs template (ID: {0310A4BF-20D1-441C-886A-0418C53E30F4}). */
export type PartialDesigns_0310a4bf20d1441c886a0418c53e30f4FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Designs template (ID: {0310A4BF-20D1-441C-886A-0418C53E30F4}). */
export type PartialDesigns_0310a4bf20d1441c886a0418c53e30f4FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Designs template (ID: {0310A4BF-20D1-441C-886A-0418C53E30F4}). */
export type PartialDesigns_0310a4bf20d1441c886a0418c53e30f4HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/xmc-getting-started-collection/Partial Designs template (ID: {0310A4BF-20D1-441C-886A-0418C53E30F4}). */
export type PartialDesigns_0310a4bf20d1441c886a0418c53e30f4IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Partial Designs template (ID: {36C869DE-D220-4092-9CE8-29F6ED643C66}). */
export type PartialDesigns_36c869ded22040929ce829f6ed643c66 = Item & {
  __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Partial Designs template (ID: {36C869DE-D220-4092-9CE8-29F6ED643C66}). */
export type PartialDesigns_36c869ded22040929ce829f6ed643c66AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Partial Designs template (ID: {36C869DE-D220-4092-9CE8-29F6ED643C66}). */
export type PartialDesigns_36c869ded22040929ce829f6ed643c66ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Partial Designs template (ID: {36C869DE-D220-4092-9CE8-29F6ED643C66}). */
export type PartialDesigns_36c869ded22040929ce829f6ed643c66FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Partial Designs template (ID: {36C869DE-D220-4092-9CE8-29F6ED643C66}). */
export type PartialDesigns_36c869ded22040929ce829f6ed643c66FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Partial Designs template (ID: {36C869DE-D220-4092-9CE8-29F6ED643C66}). */
export type PartialDesigns_36c869ded22040929ce829f6ed643c66HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Partial Designs template (ID: {36C869DE-D220-4092-9CE8-29F6ED643C66}). */
export type PartialDesigns_36c869ded22040929ce829f6ed643c66IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Partial Designs template (ID: {1943DC73-710A-4308-9551-5A342C84B037}). */
export type PartialDesigns_1943dc73710a430895515a342c84b037 = Item & {
  __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Designs template (ID: {1943DC73-710A-4308-9551-5A342C84B037}). */
export type PartialDesigns_1943dc73710a430895515a342c84b037AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Designs template (ID: {1943DC73-710A-4308-9551-5A342C84B037}). */
export type PartialDesigns_1943dc73710a430895515a342c84b037ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Designs template (ID: {1943DC73-710A-4308-9551-5A342C84B037}). */
export type PartialDesigns_1943dc73710a430895515a342c84b037FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Designs template (ID: {1943DC73-710A-4308-9551-5A342C84B037}). */
export type PartialDesigns_1943dc73710a430895515a342c84b037FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Designs template (ID: {1943DC73-710A-4308-9551-5A342C84B037}). */
export type PartialDesigns_1943dc73710a430895515a342c84b037HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Partial Designs template (ID: {1943DC73-710A-4308-9551-5A342C84B037}). */
export type PartialDesigns_1943dc73710a430895515a342c84b037IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Partial Designs template (ID: {B1E2A679-0A14-42D8-BAFA-66317B8BE117}). */
export type PartialDesigns_B1e2a6790a1442d8bafa66317b8be117 = Item & {
  __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Partial Designs template (ID: {B1E2A679-0A14-42D8-BAFA-66317B8BE117}). */
export type PartialDesigns_B1e2a6790a1442d8bafa66317b8be117AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Partial Designs template (ID: {B1E2A679-0A14-42D8-BAFA-66317B8BE117}). */
export type PartialDesigns_B1e2a6790a1442d8bafa66317b8be117ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Partial Designs template (ID: {B1E2A679-0A14-42D8-BAFA-66317B8BE117}). */
export type PartialDesigns_B1e2a6790a1442d8bafa66317b8be117FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Partial Designs template (ID: {B1E2A679-0A14-42D8-BAFA-66317B8BE117}). */
export type PartialDesigns_B1e2a6790a1442d8bafa66317b8be117FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Partial Designs template (ID: {B1E2A679-0A14-42D8-BAFA-66317B8BE117}). */
export type PartialDesigns_B1e2a6790a1442d8bafa66317b8be117HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Partial Designs template (ID: {B1E2A679-0A14-42D8-BAFA-66317B8BE117}). */
export type PartialDesigns_B1e2a6790a1442d8bafa66317b8be117IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Partial Designs template (ID: {CC6D8635-F3E2-440A-B8EB-B93DC1030E9E}). */
export type PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e = Item & {
  __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Partial Designs template (ID: {CC6D8635-F3E2-440A-B8EB-B93DC1030E9E}). */
export type PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Designs template (ID: {CC6D8635-F3E2-440A-B8EB-B93DC1030E9E}). */
export type PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Designs template (ID: {CC6D8635-F3E2-440A-B8EB-B93DC1030E9E}). */
export type PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Partial Designs template (ID: {CC6D8635-F3E2-440A-B8EB-B93DC1030E9E}). */
export type PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Designs template (ID: {CC6D8635-F3E2-440A-B8EB-B93DC1030E9E}). */
export type PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Partial Designs template (ID: {CC6D8635-F3E2-440A-B8EB-B93DC1030E9E}). */
export type PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Test/automation/Partial Designs template (ID: {D52704ED-3B70-4A53-ABB4-292105F687AD}). */
export type PartialDesigns_D52704ed3b704a53abb4292105f687ad = Item & {
  __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Test/automation/Partial Designs template (ID: {D52704ED-3B70-4A53-ABB4-292105F687AD}). */
export type PartialDesigns_D52704ed3b704a53abb4292105f687adAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Partial Designs template (ID: {D52704ED-3B70-4A53-ABB4-292105F687AD}). */
export type PartialDesigns_D52704ed3b704a53abb4292105f687adChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Partial Designs template (ID: {D52704ED-3B70-4A53-ABB4-292105F687AD}). */
export type PartialDesigns_D52704ed3b704a53abb4292105f687adFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Test/automation/Partial Designs template (ID: {D52704ED-3B70-4A53-ABB4-292105F687AD}). */
export type PartialDesigns_D52704ed3b704a53abb4292105f687adFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Test/automation/Partial Designs template (ID: {D52704ED-3B70-4A53-ABB4-292105F687AD}). */
export type PartialDesigns_D52704ed3b704a53abb4292105f687adHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Test/automation/Partial Designs template (ID: {D52704ED-3B70-4A53-ABB4-292105F687AD}). */
export type PartialDesigns_D52704ed3b704a53abb4292105f687adIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Invest Trusts/Partial Designs template (ID: {D216303F-58D8-4256-88DA-8CD30D00AFAB}). */
export type PartialDesigns_D216303f58d8425688da8cd30d00afab = Item & {
  __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Invest Trusts/Partial Designs template (ID: {D216303F-58D8-4256-88DA-8CD30D00AFAB}). */
export type PartialDesigns_D216303f58d8425688da8cd30d00afabAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Designs template (ID: {D216303F-58D8-4256-88DA-8CD30D00AFAB}). */
export type PartialDesigns_D216303f58d8425688da8cd30d00afabChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Designs template (ID: {D216303F-58D8-4256-88DA-8CD30D00AFAB}). */
export type PartialDesigns_D216303f58d8425688da8cd30d00afabFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Invest Trusts/Partial Designs template (ID: {D216303F-58D8-4256-88DA-8CD30D00AFAB}). */
export type PartialDesigns_D216303f58d8425688da8cd30d00afabFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Designs template (ID: {D216303F-58D8-4256-88DA-8CD30D00AFAB}). */
export type PartialDesigns_D216303f58d8425688da8cd30d00afabHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Invest Trusts/Partial Designs template (ID: {D216303F-58D8-4256-88DA-8CD30D00AFAB}). */
export type PartialDesigns_D216303f58d8425688da8cd30d00afabIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Partial Designs template (ID: {FACDA267-9120-4FA9-A036-3344348F2C42}). */
export type PartialDesigns_Facda26791204fa9a0363344348f2c42 = Item & {
  __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Partial Designs template (ID: {FACDA267-9120-4FA9-A036-3344348F2C42}). */
export type PartialDesigns_Facda26791204fa9a0363344348f2c42AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Partial Designs template (ID: {FACDA267-9120-4FA9-A036-3344348F2C42}). */
export type PartialDesigns_Facda26791204fa9a0363344348f2c42ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Partial Designs template (ID: {FACDA267-9120-4FA9-A036-3344348F2C42}). */
export type PartialDesigns_Facda26791204fa9a0363344348f2c42FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Partial Designs template (ID: {FACDA267-9120-4FA9-A036-3344348F2C42}). */
export type PartialDesigns_Facda26791204fa9a0363344348f2c42FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Partial Designs template (ID: {FACDA267-9120-4FA9-A036-3344348F2C42}). */
export type PartialDesigns_Facda26791204fa9a0363344348f2c42HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Partial Designs template (ID: {FACDA267-9120-4FA9-A036-3344348F2C42}). */
export type PartialDesigns_Facda26791204fa9a0363344348f2c42IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Settings/Performance Chart Settings template (ID: {FD636790-C23B-411A-9D20-CD4A44B77234}). */
export type PerformanceChartSettings = Item & {
  __typename?: 'PerformanceChartSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** availableOptions (ID: {2D9F4C21-A9A7-4D30-B94C-1FB264BA2732}). */
  availableOptions?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** defaultOption (ID: {940149D2-916D-4738-9D57-BA356FC0A957}). */
  defaultOption?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Settings/Performance Chart Settings template (ID: {FD636790-C23B-411A-9D20-CD4A44B77234}). */
export type PerformanceChartSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Settings/Performance Chart Settings template (ID: {FD636790-C23B-411A-9D20-CD4A44B77234}). */
export type PerformanceChartSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Settings/Performance Chart Settings template (ID: {FD636790-C23B-411A-9D20-CD4A44B77234}). */
export type PerformanceChartSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Settings/Performance Chart Settings template (ID: {FD636790-C23B-411A-9D20-CD4A44B77234}). */
export type PerformanceChartSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Settings/Performance Chart Settings template (ID: {FD636790-C23B-411A-9D20-CD4A44B77234}). */
export type PerformanceChartSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Settings/Performance Chart Settings template (ID: {FD636790-C23B-411A-9D20-CD4A44B77234}). */
export type PerformanceChartSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period template (ID: {CD47F36F-8CB7-46EE-B83E-7BA8C06DDE27}). */
export type PerformanceChartTimePeriod = Item & {
  __typename?: 'PerformanceChartTimePeriod';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period template (ID: {CD47F36F-8CB7-46EE-B83E-7BA8C06DDE27}). */
export type PerformanceChartTimePeriodAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period template (ID: {CD47F36F-8CB7-46EE-B83E-7BA8C06DDE27}). */
export type PerformanceChartTimePeriodChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period template (ID: {CD47F36F-8CB7-46EE-B83E-7BA8C06DDE27}). */
export type PerformanceChartTimePeriodFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period template (ID: {CD47F36F-8CB7-46EE-B83E-7BA8C06DDE27}). */
export type PerformanceChartTimePeriodFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period template (ID: {CD47F36F-8CB7-46EE-B83E-7BA8C06DDE27}). */
export type PerformanceChartTimePeriodHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period template (ID: {CD47F36F-8CB7-46EE-B83E-7BA8C06DDE27}). */
export type PerformanceChartTimePeriodIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period Folder template (ID: {22262FEE-E029-4F96-9B6E-03DCB3F738F3}). */
export type PerformanceChartTimePeriodFolder = Item & {
  __typename?: 'PerformanceChartTimePeriodFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period Folder template (ID: {22262FEE-E029-4F96-9B6E-03DCB3F738F3}). */
export type PerformanceChartTimePeriodFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period Folder template (ID: {22262FEE-E029-4F96-9B6E-03DCB3F738F3}). */
export type PerformanceChartTimePeriodFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period Folder template (ID: {22262FEE-E029-4F96-9B6E-03DCB3F738F3}). */
export type PerformanceChartTimePeriodFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period Folder template (ID: {22262FEE-E029-4F96-9B6E-03DCB3F738F3}). */
export type PerformanceChartTimePeriodFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period Folder template (ID: {22262FEE-E029-4F96-9B6E-03DCB3F738F3}). */
export type PerformanceChartTimePeriodFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Performance Chart Time Period/Performance Chart Time Period Folder template (ID: {22262FEE-E029-4F96-9B6E-03DCB3F738F3}). */
export type PerformanceChartTimePeriodFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Layout/Placeholder template (ID: {5C547D4E-7111-4995-95B0-6B561751BF2E}). */
export type Placeholder = {
  /** Allowed Controls (ID: {E391B526-D0C5-439D-803E-17512EAE6222}). */
  allowedControls?: Maybe<MultilistField>;
  /** Description (ID: {87871FF5-1965-46D6-884F-01D6A0B9C4C1}). */
  description?: Maybe<RichTextField>;
  /** Editable (ID: {14D0728A-82F9-4B01-AB16-1FE1577CEDE2}). */
  editable?: Maybe<CheckboxField>;
  /** If left empty, the settings should be applied to individual placeholders. */
  placeholderKey?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {0339BAC0-78C1-43C1-B930-F8C26A5FDF80}). */
export type PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = Item & _BasePlaceholderSettingsFolder & {
  __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateForCreation (ID: {30D2A0D2-7A60-4F32-86A9-4AA50BFAB87B}). */
  templateForCreation?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {0339BAC0-78C1-43C1-B930-F8C26A5FDF80}). */
export type PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {0339BAC0-78C1-43C1-B930-F8C26A5FDF80}). */
export type PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {0339BAC0-78C1-43C1-B930-F8C26A5FDF80}). */
export type PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {0339BAC0-78C1-43C1-B930-F8C26A5FDF80}). */
export type PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {0339BAC0-78C1-43C1-B930-F8C26A5FDF80}). */
export type PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {0339BAC0-78C1-43C1-B930-F8C26A5FDF80}). */
export type PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Placeholder Settings Folder template (ID: {3D281BF8-5336-4686-9DD6-AB4AB5B3FD5D}). */
export type PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = Item & {
  __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Placeholder Settings Folder template (ID: {3D281BF8-5336-4686-9DD6-AB4AB5B3FD5D}). */
export type PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Placeholder Settings Folder template (ID: {3D281BF8-5336-4686-9DD6-AB4AB5B3FD5D}). */
export type PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Placeholder Settings Folder template (ID: {3D281BF8-5336-4686-9DD6-AB4AB5B3FD5D}). */
export type PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Placeholder Settings Folder template (ID: {3D281BF8-5336-4686-9DD6-AB4AB5B3FD5D}). */
export type PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Placeholder Settings Folder template (ID: {3D281BF8-5336-4686-9DD6-AB4AB5B3FD5D}). */
export type PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Placeholder Settings Folder template (ID: {3D281BF8-5336-4686-9DD6-AB4AB5B3FD5D}). */
export type PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {52288E39-7830-4694-B62D-32A54C6EF7BA}). */
export type PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = Item & _BasePlaceholderSettingsFolder & {
  __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateForCreation (ID: {30D2A0D2-7A60-4F32-86A9-4AA50BFAB87B}). */
  templateForCreation?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {52288E39-7830-4694-B62D-32A54C6EF7BA}). */
export type PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7baAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {52288E39-7830-4694-B62D-32A54C6EF7BA}). */
export type PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7baChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {52288E39-7830-4694-B62D-32A54C6EF7BA}). */
export type PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7baFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {52288E39-7830-4694-B62D-32A54C6EF7BA}). */
export type PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7baFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {52288E39-7830-4694-B62D-32A54C6EF7BA}). */
export type PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7baHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder Settings Folder template (ID: {52288E39-7830-4694-B62D-32A54C6EF7BA}). */
export type PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7baIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/__Placeholder Wrapper template (ID: {BD046B4C-641A-43C5-960A-5ACB941CCC37}). */
export type PlaceholderWrapper = {
  /** Wrapping Class (ID: {BC8986B2-5872-466F-AFEB-390C9A3EDAA4}). */
  wrappingClass?: Maybe<TextField>;
  /** Wrapping Tag (ID: {2341030D-19BA-46E1-91FE-9DF617284932}). */
  wrappingTag?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder template (ID: {1CA0304B-E5B6-4810-8211-54426F1752C2}). */
export type Placeholder_1ca0304be5b64810821154426f1752c2 = Caching & Item & Placeholder & {
  __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2';
  /** Allowed Controls (ID: {E391B526-D0C5-439D-803E-17512EAE6222}). */
  allowedControls?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CacheClearingBehavior (ID: {A6D4FC1D-0803-4E0A-9145-B8C6121D6F26}). */
  cacheClearingBehavior?: Maybe<TextField>;
  /** Cacheable (ID: {3D08DB46-2267-41B0-BC52-BE69FD618633}). */
  cacheable?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ClearOnIndexUpdate (ID: {F3E7E552-D7C8-469B-A150-69E4E14AB35C}). */
  clearOnIndexUpdate?: Maybe<CheckboxField>;
  /** Description (ID: {87871FF5-1965-46D6-884F-01D6A0B9C4C1}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Editable (ID: {14D0728A-82F9-4B01-AB16-1FE1577CEDE2}). */
  editable?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** If left empty, the settings should be applied to individual placeholders. */
  placeholderKey?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Reset Caching Options (ID: {FF1FA49E-6FAC-4FF2-8F79-57ABE7338715}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** VaryByData (ID: {8B6D532B-6128-4486-A044-CA06D90948BA}). */
  varyByData?: Maybe<CheckboxField>;
  /** VaryByDevice (ID: {C98CF969-BA71-42DA-833D-B3FC1368BA27}). */
  varyByDevice?: Maybe<CheckboxField>;
  /** VaryByLogin (ID: {8D9232B0-613F-440B-A2FA-DCDD80FBD33E}). */
  varyByLogin?: Maybe<CheckboxField>;
  /** VaryByParm (ID: {3AD2506A-DC39-4B1E-959F-9D524ADDBF50}). */
  varyByParm?: Maybe<CheckboxField>;
  /** VaryByQueryString (ID: {1084D3D2-0457-456A-ABBC-EB4CC0966072}). */
  varyByQueryString?: Maybe<CheckboxField>;
  /** VaryByUser (ID: {0E54A8DC-72AD-4372-A7C7-BB4773FAD44D}). */
  varyByUser?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder template (ID: {1CA0304B-E5B6-4810-8211-54426F1752C2}). */
export type Placeholder_1ca0304be5b64810821154426f1752c2AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder template (ID: {1CA0304B-E5B6-4810-8211-54426F1752C2}). */
export type Placeholder_1ca0304be5b64810821154426f1752c2ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder template (ID: {1CA0304B-E5B6-4810-8211-54426F1752C2}). */
export type Placeholder_1ca0304be5b64810821154426f1752c2FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder template (ID: {1CA0304B-E5B6-4810-8211-54426F1752C2}). */
export type Placeholder_1ca0304be5b64810821154426f1752c2FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder template (ID: {1CA0304B-E5B6-4810-8211-54426F1752C2}). */
export type Placeholder_1ca0304be5b64810821154426f1752c2HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Placeholder template (ID: {1CA0304B-E5B6-4810-8211-54426F1752C2}). */
export type Placeholder_1ca0304be5b64810821154426f1752c2IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder template (ID: {D2A6884C-04D5-4089-A64E-D27CA9D68D4C}). */
export type Placeholder_D2a6884c04d54089a64ed27ca9d68d4c = Item & Placeholder & {
  __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c';
  /** Allowed Controls (ID: {E391B526-D0C5-439D-803E-17512EAE6222}). */
  allowedControls?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {87871FF5-1965-46D6-884F-01D6A0B9C4C1}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Editable (ID: {14D0728A-82F9-4B01-AB16-1FE1577CEDE2}). */
  editable?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** If left empty, the settings should be applied to individual placeholders. */
  placeholderKey?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder template (ID: {D2A6884C-04D5-4089-A64E-D27CA9D68D4C}). */
export type Placeholder_D2a6884c04d54089a64ed27ca9d68d4cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder template (ID: {D2A6884C-04D5-4089-A64E-D27CA9D68D4C}). */
export type Placeholder_D2a6884c04d54089a64ed27ca9d68d4cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder template (ID: {D2A6884C-04D5-4089-A64E-D27CA9D68D4C}). */
export type Placeholder_D2a6884c04d54089a64ed27ca9d68d4cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder template (ID: {D2A6884C-04D5-4089-A64E-D27CA9D68D4C}). */
export type Placeholder_D2a6884c04d54089a64ed27ca9d68d4cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder template (ID: {D2A6884C-04D5-4089-A64E-D27CA9D68D4C}). */
export type Placeholder_D2a6884c04d54089a64ed27ca9d68d4cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Placeholder Settings/Placeholder template (ID: {D2A6884C-04D5-4089-A64E-D27CA9D68D4C}). */
export type Placeholder_D2a6884c04d54089a64ed27ca9d68d4cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/PlainHtmlParametersTemplate template (ID: {DE811464-F6D9-40C1-B456-A7970D08FA58}). */
export type PlainHtmlParametersTemplate = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'PlainHtmlParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/PlainHtmlParametersTemplate template (ID: {DE811464-F6D9-40C1-B456-A7970D08FA58}). */
export type PlainHtmlParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/PlainHtmlParametersTemplate template (ID: {DE811464-F6D9-40C1-B456-A7970D08FA58}). */
export type PlainHtmlParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/PlainHtmlParametersTemplate template (ID: {DE811464-F6D9-40C1-B456-A7970D08FA58}). */
export type PlainHtmlParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/PlainHtmlParametersTemplate template (ID: {DE811464-F6D9-40C1-B456-A7970D08FA58}). */
export type PlainHtmlParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/PlainHtmlParametersTemplate template (ID: {DE811464-F6D9-40C1-B456-A7970D08FA58}). */
export type PlainHtmlParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/PlainHtmlParametersTemplate template (ID: {DE811464-F6D9-40C1-B456-A7970D08FA58}). */
export type PlainHtmlParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist template (ID: {1BF71895-BC29-47DA-8B79-7FD5F88363D9}). */
export type Playlist = Item & {
  __typename?: 'Playlist';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {D3BF9175-3C00-4BD5-978B-D27DF8C41482}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist template (ID: {1BF71895-BC29-47DA-8B79-7FD5F88363D9}). */
export type PlaylistAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist template (ID: {1BF71895-BC29-47DA-8B79-7FD5F88363D9}). */
export type PlaylistChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist template (ID: {1BF71895-BC29-47DA-8B79-7FD5F88363D9}). */
export type PlaylistFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist template (ID: {1BF71895-BC29-47DA-8B79-7FD5F88363D9}). */
export type PlaylistFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist template (ID: {1BF71895-BC29-47DA-8B79-7FD5F88363D9}). */
export type PlaylistHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist template (ID: {1BF71895-BC29-47DA-8B79-7FD5F88363D9}). */
export type PlaylistIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist Folder template (ID: {948BF196-D6EB-4247-BE9C-F5EB5E1160D7}). */
export type PlaylistFolder = Item & {
  __typename?: 'PlaylistFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist Folder template (ID: {948BF196-D6EB-4247-BE9C-F5EB5E1160D7}). */
export type PlaylistFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist Folder template (ID: {948BF196-D6EB-4247-BE9C-F5EB5E1160D7}). */
export type PlaylistFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist Folder template (ID: {948BF196-D6EB-4247-BE9C-F5EB5E1160D7}). */
export type PlaylistFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist Folder template (ID: {948BF196-D6EB-4247-BE9C-F5EB5E1160D7}). */
export type PlaylistFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist Folder template (ID: {948BF196-D6EB-4247-BE9C-F5EB5E1160D7}). */
export type PlaylistFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Playlist Folder template (ID: {948BF196-D6EB-4247-BE9C-F5EB5E1160D7}). */
export type PlaylistFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/PlaylistParametersTemplate template (ID: {12D5BCE9-A553-4FD0-88E3-0AFAF1711B97}). */
export type PlaylistParametersTemplate = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'PlaylistParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Autoplay (ID: {1D1FB7C1-66F9-4893-874B-4C1011B491D4}). */
  autoplay?: Maybe<CheckboxField>;
  /** AutoplaySelected (ID: {1077622C-65CD-4A2F-B780-2C743EDFE199}). */
  autoplaySelected?: Maybe<CheckboxField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** PlayNext (ID: {BE3FBE02-963E-4FA9-92B9-CAC9BEB3B188}). */
  playNext?: Maybe<CheckboxField>;
  /** Player (ID: {FE8B4FE6-2895-422E-B146-82AB9A382627}). */
  player?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** RepeatAfterAll (ID: {42A7C3BC-191A-4D23-8C83-0C50645BE3BB}). */
  repeatAfterAll?: Maybe<CheckboxField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** ShowPrevNext (ID: {C3068F73-7EE2-410B-9957-0B78E7ED5B96}). */
  showPrevNext?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TitleHeadingLevel (ID: {2D6A83D4-00D3-40AD-B64A-51D1441BAE1E}). */
  titleHeadingLevel?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/PlaylistParametersTemplate template (ID: {12D5BCE9-A553-4FD0-88E3-0AFAF1711B97}). */
export type PlaylistParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/PlaylistParametersTemplate template (ID: {12D5BCE9-A553-4FD0-88E3-0AFAF1711B97}). */
export type PlaylistParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/PlaylistParametersTemplate template (ID: {12D5BCE9-A553-4FD0-88E3-0AFAF1711B97}). */
export type PlaylistParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/PlaylistParametersTemplate template (ID: {12D5BCE9-A553-4FD0-88E3-0AFAF1711B97}). */
export type PlaylistParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/PlaylistParametersTemplate template (ID: {12D5BCE9-A553-4FD0-88E3-0AFAF1711B97}). */
export type PlaylistParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/PlaylistParametersTemplate template (ID: {12D5BCE9-A553-4FD0-88E3-0AFAF1711B97}). */
export type PlaylistParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast template (ID: {3C650B08-6A1E-4548-A4AF-2022EFB2B997}). */
export type Podcast = Item & {
  __typename?: 'Podcast';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {38E06D2C-002B-4F93-AB8E-1CF59A5DB2F3}). */
  title?: Maybe<TextField>;
  /** transcript (ID: {39EEF947-C6E7-40C2-9CB8-7B50425A1BA3}). */
  transcript?: Maybe<RichTextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Podcast URL, only part after "https://www.buzzsprout.com/" should be entered here. Example: "0000000/00000000-podcast-title" */
  url_07feaa8a8d914b1ca826de4a86918560?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast template (ID: {3C650B08-6A1E-4548-A4AF-2022EFB2B997}). */
export type PodcastAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast template (ID: {3C650B08-6A1E-4548-A4AF-2022EFB2B997}). */
export type PodcastChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast template (ID: {3C650B08-6A1E-4548-A4AF-2022EFB2B997}). */
export type PodcastFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast template (ID: {3C650B08-6A1E-4548-A4AF-2022EFB2B997}). */
export type PodcastFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast template (ID: {3C650B08-6A1E-4548-A4AF-2022EFB2B997}). */
export type PodcastHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast template (ID: {3C650B08-6A1E-4548-A4AF-2022EFB2B997}). */
export type PodcastIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast Folder template (ID: {14C68E8E-44AC-4549-BD8B-CFC1308C9BC5}). */
export type PodcastFolder = Item & {
  __typename?: 'PodcastFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast Folder template (ID: {14C68E8E-44AC-4549-BD8B-CFC1308C9BC5}). */
export type PodcastFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast Folder template (ID: {14C68E8E-44AC-4549-BD8B-CFC1308C9BC5}). */
export type PodcastFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast Folder template (ID: {14C68E8E-44AC-4549-BD8B-CFC1308C9BC5}). */
export type PodcastFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast Folder template (ID: {14C68E8E-44AC-4549-BD8B-CFC1308C9BC5}). */
export type PodcastFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast Folder template (ID: {14C68E8E-44AC-4549-BD8B-CFC1308C9BC5}). */
export type PodcastFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Podcast/Podcast Folder template (ID: {14C68E8E-44AC-4549-BD8B-CFC1308C9BC5}). */
export type PodcastFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Page template (ID: {08A1ECC0-5B49-4F33-A316-1C0B3045D42A}). */
export type PodcastPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BaseArticle & _BasePage & _ContentType & _Designable & _FundMetadataPage & _InternalArticle & _LimitedDisplay & _MetadataPage & _Navigable & _NavigablePage & _Podcast & _PremiumContentPage & _SharedPage & _Sitemap & _Taggable & {
  __typename?: 'PodcastPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {EE25CB28-67AA-4564-8B8B-4A8B7076FFF4}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Page template (ID: {08A1ECC0-5B49-4F33-A316-1C0B3045D42A}). */
export type PodcastPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Page template (ID: {08A1ECC0-5B49-4F33-A316-1C0B3045D42A}). */
export type PodcastPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Page template (ID: {08A1ECC0-5B49-4F33-A316-1C0B3045D42A}). */
export type PodcastPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Page template (ID: {08A1ECC0-5B49-4F33-A316-1C0B3045D42A}). */
export type PodcastPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Page template (ID: {08A1ECC0-5B49-4F33-A316-1C0B3045D42A}). */
export type PodcastPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Page template (ID: {08A1ECC0-5B49-4F33-A316-1C0B3045D42A}). */
export type PodcastPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Press Release Page template (ID: {B72D4608-9737-4A3F-B7B0-868B77DD3A04}). */
export type PodcastPressReleasePage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _BasePressRelease & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _PodcastPressRelease & _PressReleaseContentType & _SharedPage & _Sitemap & _Taggable & {
  __typename?: 'PodcastPressReleasePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {123C45F4-DFB2-4D8D-B942-7FBC333B02BD}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Press Release Page template (ID: {B72D4608-9737-4A3F-B7B0-868B77DD3A04}). */
export type PodcastPressReleasePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Press Release Page template (ID: {B72D4608-9737-4A3F-B7B0-868B77DD3A04}). */
export type PodcastPressReleasePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Press Release Page template (ID: {B72D4608-9737-4A3F-B7B0-868B77DD3A04}). */
export type PodcastPressReleasePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Press Release Page template (ID: {B72D4608-9737-4A3F-B7B0-868B77DD3A04}). */
export type PodcastPressReleasePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Press Release Page template (ID: {B72D4608-9737-4A3F-B7B0-868B77DD3A04}). */
export type PodcastPressReleasePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Podcast Press Release Page template (ID: {B72D4608-9737-4A3F-B7B0-868B77DD3A04}). */
export type PodcastPressReleasePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/PoiTypes template (ID: {3A1DDE20-0A86-492A-81EE-5F56C827FA94}). */
export type PoiTypes = Item & {
  __typename?: 'PoiTypes';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/PoiTypes template (ID: {3A1DDE20-0A86-492A-81EE-5F56C827FA94}). */
export type PoiTypesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/PoiTypes template (ID: {3A1DDE20-0A86-492A-81EE-5F56C827FA94}). */
export type PoiTypesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/PoiTypes template (ID: {3A1DDE20-0A86-492A-81EE-5F56C827FA94}). */
export type PoiTypesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/PoiTypes template (ID: {3A1DDE20-0A86-492A-81EE-5F56C827FA94}). */
export type PoiTypesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/PoiTypes template (ID: {3A1DDE20-0A86-492A-81EE-5F56C827FA94}). */
export type PoiTypesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Geospatial/PoiTypes template (ID: {3A1DDE20-0A86-492A-81EE-5F56C827FA94}). */
export type PoiTypesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {22E0ECE5-590B-49AC-B2BC-B61253F91C31}). */
export type PostDeleteStep = Item & _Script & {
  __typename?: 'PostDeleteStep';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {22E0ECE5-590B-49AC-B2BC-B61253F91C31}). */
export type PostDeleteStepAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {22E0ECE5-590B-49AC-B2BC-B61253F91C31}). */
export type PostDeleteStepChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {22E0ECE5-590B-49AC-B2BC-B61253F91C31}). */
export type PostDeleteStepFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {22E0ECE5-590B-49AC-B2BC-B61253F91C31}). */
export type PostDeleteStepFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {22E0ECE5-590B-49AC-B2BC-B61253F91C31}). */
export type PostDeleteStepHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {22E0ECE5-590B-49AC-B2BC-B61253F91C31}). */
export type PostDeleteStepIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {7A7E57B9-9C6D-4A22-B5FD-F7B214DDE574}). */
export type PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = Item & _Script & {
  __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {7A7E57B9-9C6D-4A22-B5FD-F7B214DDE574}). */
export type PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {7A7E57B9-9C6D-4A22-B5FD-F7B214DDE574}). */
export type PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {7A7E57B9-9C6D-4A22-B5FD-F7B214DDE574}). */
export type PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {7A7E57B9-9C6D-4A22-B5FD-F7B214DDE574}). */
export type PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {7A7E57B9-9C6D-4A22-B5FD-F7B214DDE574}). */
export type PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {7A7E57B9-9C6D-4A22-B5FD-F7B214DDE574}). */
export type PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {78D6EC9B-66E3-4763-9870-03CF314EE37A}). */
export type PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = Item & _Script & {
  __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {78D6EC9B-66E3-4763-9870-03CF314EE37A}). */
export type PostDeleteStep_78d6ec9b66e34763987003cf314ee37aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {78D6EC9B-66E3-4763-9870-03CF314EE37A}). */
export type PostDeleteStep_78d6ec9b66e34763987003cf314ee37aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {78D6EC9B-66E3-4763-9870-03CF314EE37A}). */
export type PostDeleteStep_78d6ec9b66e34763987003cf314ee37aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {78D6EC9B-66E3-4763-9870-03CF314EE37A}). */
export type PostDeleteStep_78d6ec9b66e34763987003cf314ee37aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {78D6EC9B-66E3-4763-9870-03CF314EE37A}). */
export type PostDeleteStep_78d6ec9b66e34763987003cf314ee37aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostDeleteStep template (ID: {78D6EC9B-66E3-4763-9870-03CF314EE37A}). */
export type PostDeleteStep_78d6ec9b66e34763987003cf314ee37aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {B2085789-5385-4138-83F0-96F3767CB156}). */
export type PostDeleteStep_B20857895385413883f096f3767cb156 = Item & _Script & {
  __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {B2085789-5385-4138-83F0-96F3767CB156}). */
export type PostDeleteStep_B20857895385413883f096f3767cb156AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {B2085789-5385-4138-83F0-96F3767CB156}). */
export type PostDeleteStep_B20857895385413883f096f3767cb156ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {B2085789-5385-4138-83F0-96F3767CB156}). */
export type PostDeleteStep_B20857895385413883f096f3767cb156FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {B2085789-5385-4138-83F0-96F3767CB156}). */
export type PostDeleteStep_B20857895385413883f096f3767cb156FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {B2085789-5385-4138-83F0-96F3767CB156}). */
export type PostDeleteStep_B20857895385413883f096f3767cb156HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostDeleteStep template (ID: {B2085789-5385-4138-83F0-96F3767CB156}). */
export type PostDeleteStep_B20857895385413883f096f3767cb156IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {0C602893-2BE9-4020-912D-56AF21DEFF73}). */
export type PostSetupStep = Item & _Script & {
  __typename?: 'PostSetupStep';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {0C602893-2BE9-4020-912D-56AF21DEFF73}). */
export type PostSetupStepAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {0C602893-2BE9-4020-912D-56AF21DEFF73}). */
export type PostSetupStepChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {0C602893-2BE9-4020-912D-56AF21DEFF73}). */
export type PostSetupStepFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {0C602893-2BE9-4020-912D-56AF21DEFF73}). */
export type PostSetupStepFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {0C602893-2BE9-4020-912D-56AF21DEFF73}). */
export type PostSetupStepHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {0C602893-2BE9-4020-912D-56AF21DEFF73}). */
export type PostSetupStepIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {6FAC654E-2215-4A41-9A1D-59197BEBC0FE}). */
export type PostSetupStep_6fac654e22154a419a1d59197bebc0fe = Item & _Script & {
  __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {6FAC654E-2215-4A41-9A1D-59197BEBC0FE}). */
export type PostSetupStep_6fac654e22154a419a1d59197bebc0feAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {6FAC654E-2215-4A41-9A1D-59197BEBC0FE}). */
export type PostSetupStep_6fac654e22154a419a1d59197bebc0feChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {6FAC654E-2215-4A41-9A1D-59197BEBC0FE}). */
export type PostSetupStep_6fac654e22154a419a1d59197bebc0feFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {6FAC654E-2215-4A41-9A1D-59197BEBC0FE}). */
export type PostSetupStep_6fac654e22154a419a1d59197bebc0feFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {6FAC654E-2215-4A41-9A1D-59197BEBC0FE}). */
export type PostSetupStep_6fac654e22154a419a1d59197bebc0feHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PostSetupStep template (ID: {6FAC654E-2215-4A41-9A1D-59197BEBC0FE}). */
export type PostSetupStep_6fac654e22154a419a1d59197bebc0feIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {8FF2FEBF-F6D2-461D-9ED3-8B0CB5D9D86F}). */
export type PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = Item & _Script & {
  __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {8FF2FEBF-F6D2-461D-9ED3-8B0CB5D9D86F}). */
export type PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {8FF2FEBF-F6D2-461D-9ED3-8B0CB5D9D86F}). */
export type PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {8FF2FEBF-F6D2-461D-9ED3-8B0CB5D9D86F}). */
export type PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {8FF2FEBF-F6D2-461D-9ED3-8B0CB5D9D86F}). */
export type PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {8FF2FEBF-F6D2-461D-9ED3-8B0CB5D9D86F}). */
export type PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {8FF2FEBF-F6D2-461D-9ED3-8B0CB5D9D86F}). */
export type PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {341738AA-44FE-490E-90FF-7010A3C2463B}). */
export type PostSetupStep_341738aa44fe490e90ff7010a3c2463b = Item & _Script & {
  __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {341738AA-44FE-490E-90FF-7010A3C2463B}). */
export type PostSetupStep_341738aa44fe490e90ff7010a3c2463bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {341738AA-44FE-490E-90FF-7010A3C2463B}). */
export type PostSetupStep_341738aa44fe490e90ff7010a3c2463bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {341738AA-44FE-490E-90FF-7010A3C2463B}). */
export type PostSetupStep_341738aa44fe490e90ff7010a3c2463bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {341738AA-44FE-490E-90FF-7010A3C2463B}). */
export type PostSetupStep_341738aa44fe490e90ff7010a3c2463bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {341738AA-44FE-490E-90FF-7010A3C2463B}). */
export type PostSetupStep_341738aa44fe490e90ff7010a3c2463bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PostSetupStep template (ID: {341738AA-44FE-490E-90FF-7010A3C2463B}). */
export type PostSetupStep_341738aa44fe490e90ff7010a3c2463bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Modules/PowerShell Console/PowerShell Script template (ID: {DD22F1B3-BD87-4DB2-9E7D-F7A496888D43}). */
export type PowerShellScript = {
  /** Enabled status is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  enableRule?: Maybe<TextField>;
  /** Scripts with the specified ID will use a single shared session; after which those sessions will remain in memory. When left empty, sessions will close after each use. */
  persistentSessionId?: Maybe<TextField>;
  /** Script (ID: {B1A94FF0-6897-47C0-9C51-AA6ACB80B1F0}). */
  script?: Maybe<TextField>;
  /** Visibility is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  showRule?: Maybe<TextField>;
};

/** /sitecore/templates/Modules/PowerShell Console/PowerShell Script Library template (ID: {AB154D3D-1126-4AB4-AC21-8B86E6BD70EA}). */
export type PowerShellScriptLibrary = {
  /** Enabled status is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  enableRule?: Maybe<TextField>;
  /** Visibility is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  showRule?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {ADB13651-2EB9-494F-ADA0-0DFDA0B2EBBF}). */
export type PreDeleteStep = Item & _Script & {
  __typename?: 'PreDeleteStep';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {ADB13651-2EB9-494F-ADA0-0DFDA0B2EBBF}). */
export type PreDeleteStepAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {ADB13651-2EB9-494F-ADA0-0DFDA0B2EBBF}). */
export type PreDeleteStepChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {ADB13651-2EB9-494F-ADA0-0DFDA0B2EBBF}). */
export type PreDeleteStepFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {ADB13651-2EB9-494F-ADA0-0DFDA0B2EBBF}). */
export type PreDeleteStepFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {ADB13651-2EB9-494F-ADA0-0DFDA0B2EBBF}). */
export type PreDeleteStepHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {ADB13651-2EB9-494F-ADA0-0DFDA0B2EBBF}). */
export type PreDeleteStepIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {51437C06-212C-4C0F-B3B2-FA5B0486AB49}). */
export type PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = Item & _Script & {
  __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {51437C06-212C-4C0F-B3B2-FA5B0486AB49}). */
export type PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {51437C06-212C-4C0F-B3B2-FA5B0486AB49}). */
export type PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {51437C06-212C-4C0F-B3B2-FA5B0486AB49}). */
export type PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {51437C06-212C-4C0F-B3B2-FA5B0486AB49}). */
export type PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {51437C06-212C-4C0F-B3B2-FA5B0486AB49}). */
export type PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {51437C06-212C-4C0F-B3B2-FA5B0486AB49}). */
export type PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {52510F54-9EC5-464C-B075-EF44B5C2F96B}). */
export type PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = Item & _Script & {
  __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {52510F54-9EC5-464C-B075-EF44B5C2F96B}). */
export type PreDeleteStep_52510f549ec5464cb075ef44b5c2f96bAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {52510F54-9EC5-464C-B075-EF44B5C2F96B}). */
export type PreDeleteStep_52510f549ec5464cb075ef44b5c2f96bChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {52510F54-9EC5-464C-B075-EF44B5C2F96B}). */
export type PreDeleteStep_52510f549ec5464cb075ef44b5c2f96bFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {52510F54-9EC5-464C-B075-EF44B5C2F96B}). */
export type PreDeleteStep_52510f549ec5464cb075ef44b5c2f96bFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {52510F54-9EC5-464C-B075-EF44B5C2F96B}). */
export type PreDeleteStep_52510f549ec5464cb075ef44b5c2f96bHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteStep template (ID: {52510F54-9EC5-464C-B075-EF44B5C2F96B}). */
export type PreDeleteStep_52510f549ec5464cb075ef44b5c2f96bIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {F0DAF401-190F-4546-8BDA-8568D08E161D}). */
export type PreDeleteStep_F0daf401190f45468bda8568d08e161d = Item & _Script & {
  __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {F0DAF401-190F-4546-8BDA-8568D08E161D}). */
export type PreDeleteStep_F0daf401190f45468bda8568d08e161dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {F0DAF401-190F-4546-8BDA-8568D08E161D}). */
export type PreDeleteStep_F0daf401190f45468bda8568d08e161dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {F0DAF401-190F-4546-8BDA-8568D08E161D}). */
export type PreDeleteStep_F0daf401190f45468bda8568d08e161dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {F0DAF401-190F-4546-8BDA-8568D08E161D}). */
export type PreDeleteStep_F0daf401190f45468bda8568d08e161dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {F0DAF401-190F-4546-8BDA-8568D08E161D}). */
export type PreDeleteStep_F0daf401190f45468bda8568d08e161dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteStep template (ID: {F0DAF401-190F-4546-8BDA-8568D08E161D}). */
export type PreDeleteStep_F0daf401190f45468bda8568d08e161dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {A7981549-D3E3-4883-8A55-3554ACC9CC53}). */
export type PreDeleteValidationStep = Item & _Validation & {
  __typename?: 'PreDeleteValidationStep';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {A7981549-D3E3-4883-8A55-3554ACC9CC53}). */
export type PreDeleteValidationStepAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {A7981549-D3E3-4883-8A55-3554ACC9CC53}). */
export type PreDeleteValidationStepChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {A7981549-D3E3-4883-8A55-3554ACC9CC53}). */
export type PreDeleteValidationStepFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {A7981549-D3E3-4883-8A55-3554ACC9CC53}). */
export type PreDeleteValidationStepFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {A7981549-D3E3-4883-8A55-3554ACC9CC53}). */
export type PreDeleteValidationStepHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {A7981549-D3E3-4883-8A55-3554ACC9CC53}). */
export type PreDeleteValidationStepIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {408FD8AB-1667-440B-A605-1370DDF0A51F}). */
export type PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = Item & _Validation & {
  __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {408FD8AB-1667-440B-A605-1370DDF0A51F}). */
export type PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {408FD8AB-1667-440B-A605-1370DDF0A51F}). */
export type PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {408FD8AB-1667-440B-A605-1370DDF0A51F}). */
export type PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {408FD8AB-1667-440B-A605-1370DDF0A51F}). */
export type PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {408FD8AB-1667-440B-A605-1370DDF0A51F}). */
export type PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {408FD8AB-1667-440B-A605-1370DDF0A51F}). */
export type PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {EDF1FA42-06C4-4703-AB1A-F23495BC6D8F}). */
export type PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f = Item & _Validation & {
  __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {EDF1FA42-06C4-4703-AB1A-F23495BC6D8F}). */
export type PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {EDF1FA42-06C4-4703-AB1A-F23495BC6D8F}). */
export type PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {EDF1FA42-06C4-4703-AB1A-F23495BC6D8F}). */
export type PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {EDF1FA42-06C4-4703-AB1A-F23495BC6D8F}). */
export type PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {EDF1FA42-06C4-4703-AB1A-F23495BC6D8F}). */
export type PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Actions/Tenant/PreDeleteValidationStep template (ID: {EDF1FA42-06C4-4703-AB1A-F23495BC6D8F}). */
export type PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {F8C52120-D0EA-4D00-9DE3-B49FE12A3F1E}). */
export type PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e = Item & _Validation & {
  __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {F8C52120-D0EA-4D00-9DE3-B49FE12A3F1E}). */
export type PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {F8C52120-D0EA-4D00-9DE3-B49FE12A3F1E}). */
export type PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {F8C52120-D0EA-4D00-9DE3-B49FE12A3F1E}). */
export type PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {F8C52120-D0EA-4D00-9DE3-B49FE12A3F1E}). */
export type PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {F8C52120-D0EA-4D00-9DE3-B49FE12A3F1E}). */
export type PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Site/PreDeleteValidationStep template (ID: {F8C52120-D0EA-4D00-9DE3-B49FE12A3F1E}). */
export type PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Presentation template (ID: {26BF5BE6-815D-4078-98BF-AB66B82D2171}). */
export type Presentation = Item & {
  __typename?: 'Presentation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Presentation template (ID: {26BF5BE6-815D-4078-98BF-AB66B82D2171}). */
export type PresentationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Presentation template (ID: {26BF5BE6-815D-4078-98BF-AB66B82D2171}). */
export type PresentationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Presentation template (ID: {26BF5BE6-815D-4078-98BF-AB66B82D2171}). */
export type PresentationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Presentation template (ID: {26BF5BE6-815D-4078-98BF-AB66B82D2171}). */
export type PresentationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Presentation template (ID: {26BF5BE6-815D-4078-98BF-AB66B82D2171}). */
export type PresentationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Presentation template (ID: {26BF5BE6-815D-4078-98BF-AB66B82D2171}). */
export type PresentationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Presentation template (ID: {0A70FA73-8923-4A6E-ABF3-4134F25F3221}). */
export type Presentation_0a70fa7389234a6eabf34134f25f3221 = Item & {
  __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Presentation template (ID: {0A70FA73-8923-4A6E-ABF3-4134F25F3221}). */
export type Presentation_0a70fa7389234a6eabf34134f25f3221AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Presentation template (ID: {0A70FA73-8923-4A6E-ABF3-4134F25F3221}). */
export type Presentation_0a70fa7389234a6eabf34134f25f3221ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Presentation template (ID: {0A70FA73-8923-4A6E-ABF3-4134F25F3221}). */
export type Presentation_0a70fa7389234a6eabf34134f25f3221FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Presentation template (ID: {0A70FA73-8923-4A6E-ABF3-4134F25F3221}). */
export type Presentation_0a70fa7389234a6eabf34134f25f3221FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Presentation template (ID: {0A70FA73-8923-4A6E-ABF3-4134F25F3221}). */
export type Presentation_0a70fa7389234a6eabf34134f25f3221HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/Presentation template (ID: {0A70FA73-8923-4A6E-ABF3-4134F25F3221}). */
export type Presentation_0a70fa7389234a6eabf34134f25f3221IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Type template (ID: {1D763B43-F685-46CB-9FFC-E8C58051E6C8}). */
export type PressReleaseContentType = Item & {
  __typename?: 'PressReleaseContentType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {4B7A47E3-4D98-49EF-B2AA-96279704F2C2}). */
  name_4b7a47e34d9849efb2aa96279704f2c2?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Type template (ID: {1D763B43-F685-46CB-9FFC-E8C58051E6C8}). */
export type PressReleaseContentTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Type template (ID: {1D763B43-F685-46CB-9FFC-E8C58051E6C8}). */
export type PressReleaseContentTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Type template (ID: {1D763B43-F685-46CB-9FFC-E8C58051E6C8}). */
export type PressReleaseContentTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Type template (ID: {1D763B43-F685-46CB-9FFC-E8C58051E6C8}). */
export type PressReleaseContentTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Type template (ID: {1D763B43-F685-46CB-9FFC-E8C58051E6C8}). */
export type PressReleaseContentTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Type template (ID: {1D763B43-F685-46CB-9FFC-E8C58051E6C8}). */
export type PressReleaseContentTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Types Folder template (ID: {BF6E50AB-31A0-48C5-A28E-8FA46BD3BE2C}). */
export type PressReleaseContentTypesFolder = Item & {
  __typename?: 'PressReleaseContentTypesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Types Folder template (ID: {BF6E50AB-31A0-48C5-A28E-8FA46BD3BE2C}). */
export type PressReleaseContentTypesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Types Folder template (ID: {BF6E50AB-31A0-48C5-A28E-8FA46BD3BE2C}). */
export type PressReleaseContentTypesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Types Folder template (ID: {BF6E50AB-31A0-48C5-A28E-8FA46BD3BE2C}). */
export type PressReleaseContentTypesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Types Folder template (ID: {BF6E50AB-31A0-48C5-A28E-8FA46BD3BE2C}). */
export type PressReleaseContentTypesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Types Folder template (ID: {BF6E50AB-31A0-48C5-A28E-8FA46BD3BE2C}). */
export type PressReleaseContentTypesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Content Type/Press Release Content Types Folder template (ID: {BF6E50AB-31A0-48C5-A28E-8FA46BD3BE2C}). */
export type PressReleaseContentTypesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Press Release Filter/Press Release Filter template (ID: {225A44F4-3DA9-4F8E-A740-6F46E6833E53}). */
export type PressReleaseFilter = Item & {
  __typename?: 'PressReleaseFilter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentType (ID: {8531D7D5-35A4-4516-8CB7-43360D9C8198}). */
  contentType?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** filterSubHeading (ID: {14C3CA6F-1A79-4808-89D6-C2CBB745AB2E}). */
  filterSubHeading?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Press Release Filter/Press Release Filter template (ID: {225A44F4-3DA9-4F8E-A740-6F46E6833E53}). */
export type PressReleaseFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Press Release Filter/Press Release Filter template (ID: {225A44F4-3DA9-4F8E-A740-6F46E6833E53}). */
export type PressReleaseFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Press Release Filter/Press Release Filter template (ID: {225A44F4-3DA9-4F8E-A740-6F46E6833E53}). */
export type PressReleaseFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Press Release Filter/Press Release Filter template (ID: {225A44F4-3DA9-4F8E-A740-6F46E6833E53}). */
export type PressReleaseFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Press Release Filter/Press Release Filter template (ID: {225A44F4-3DA9-4F8E-A740-6F46E6833E53}). */
export type PressReleaseFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Press Release Filter/Press Release Filter template (ID: {225A44F4-3DA9-4F8E-A740-6F46E6833E53}). */
export type PressReleaseFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Page template (ID: {1894730B-8450-4B97-8B97-DB29E88E1B9E}). */
export type PressReleasePage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _BasePressRelease & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _PressRelease & _PressReleaseContentType & _SharedPage & _Sitemap & _Taggable & {
  __typename?: 'PressReleasePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Populated automatically during publish */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Page template (ID: {1894730B-8450-4B97-8B97-DB29E88E1B9E}). */
export type PressReleasePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Page template (ID: {1894730B-8450-4B97-8B97-DB29E88E1B9E}). */
export type PressReleasePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Page template (ID: {1894730B-8450-4B97-8B97-DB29E88E1B9E}). */
export type PressReleasePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Page template (ID: {1894730B-8450-4B97-8B97-DB29E88E1B9E}). */
export type PressReleasePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Page template (ID: {1894730B-8450-4B97-8B97-DB29E88E1B9E}). */
export type PressReleasePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Press Release Page template (ID: {1894730B-8450-4B97-8B97-DB29E88E1B9E}). */
export type PressReleasePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platform template (ID: {F18DD01D-7B0E-4D0E-ABFA-70A699A4C968}). */
export type PressReleasePlatform = Item & {
  __typename?: 'PressReleasePlatform';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {CC07DF81-36B0-4EB8-BBC9-763E31C85261}). */
  name_cc07df8136b04eb8bbc9763e31c85261?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platform template (ID: {F18DD01D-7B0E-4D0E-ABFA-70A699A4C968}). */
export type PressReleasePlatformAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platform template (ID: {F18DD01D-7B0E-4D0E-ABFA-70A699A4C968}). */
export type PressReleasePlatformChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platform template (ID: {F18DD01D-7B0E-4D0E-ABFA-70A699A4C968}). */
export type PressReleasePlatformFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platform template (ID: {F18DD01D-7B0E-4D0E-ABFA-70A699A4C968}). */
export type PressReleasePlatformFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platform template (ID: {F18DD01D-7B0E-4D0E-ABFA-70A699A4C968}). */
export type PressReleasePlatformHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platform template (ID: {F18DD01D-7B0E-4D0E-ABFA-70A699A4C968}). */
export type PressReleasePlatformIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platforms Folder template (ID: {D9163498-6626-489D-86FC-F5D1642AC2BE}). */
export type PressReleasePlatformsFolder = Item & {
  __typename?: 'PressReleasePlatformsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platforms Folder template (ID: {D9163498-6626-489D-86FC-F5D1642AC2BE}). */
export type PressReleasePlatformsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platforms Folder template (ID: {D9163498-6626-489D-86FC-F5D1642AC2BE}). */
export type PressReleasePlatformsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platforms Folder template (ID: {D9163498-6626-489D-86FC-F5D1642AC2BE}). */
export type PressReleasePlatformsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platforms Folder template (ID: {D9163498-6626-489D-86FC-F5D1642AC2BE}). */
export type PressReleasePlatformsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platforms Folder template (ID: {D9163498-6626-489D-86FC-F5D1642AC2BE}). */
export type PressReleasePlatformsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Press Release Platform/Press Release Platforms Folder template (ID: {D9163498-6626-489D-86FC-F5D1642AC2BE}). */
export type PressReleasePlatformsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Search Page template (ID: {12469FDC-ECA6-4AEB-9CDF-34632CA53E62}). */
export type PressReleaseSearchPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseSearchPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Search Page template (ID: {12469FDC-ECA6-4AEB-9CDF-34632CA53E62}). */
export type PressReleaseSearchPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Search Page template (ID: {12469FDC-ECA6-4AEB-9CDF-34632CA53E62}). */
export type PressReleaseSearchPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Search Page template (ID: {12469FDC-ECA6-4AEB-9CDF-34632CA53E62}). */
export type PressReleaseSearchPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Search Page template (ID: {12469FDC-ECA6-4AEB-9CDF-34632CA53E62}). */
export type PressReleaseSearchPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Search Page template (ID: {12469FDC-ECA6-4AEB-9CDF-34632CA53E62}). */
export type PressReleaseSearchPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Search Page template (ID: {12469FDC-ECA6-4AEB-9CDF-34632CA53E62}). */
export type PressReleaseSearchPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Press Release Search Page template (ID: {1B2F7A53-709A-4C62-B381-DAE5F1280B7F}). */
export type PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Search Page template (ID: {1B2F7A53-709A-4C62-B381-DAE5F1280B7F}). */
export type PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Search Page template (ID: {1B2F7A53-709A-4C62-B381-DAE5F1280B7F}). */
export type PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Search Page template (ID: {1B2F7A53-709A-4C62-B381-DAE5F1280B7F}). */
export type PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Search Page template (ID: {1B2F7A53-709A-4C62-B381-DAE5F1280B7F}). */
export type PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Search Page template (ID: {1B2F7A53-709A-4C62-B381-DAE5F1280B7F}). */
export type PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Search Page template (ID: {1B2F7A53-709A-4C62-B381-DAE5F1280B7F}). */
export type PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Press Release Search Page template (ID: {A6C344CA-7C69-4600-9DE2-CA92E27D7B72}). */
export type PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Search Page template (ID: {A6C344CA-7C69-4600-9DE2-CA92E27D7B72}). */
export type PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Search Page template (ID: {A6C344CA-7C69-4600-9DE2-CA92E27D7B72}). */
export type PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Search Page template (ID: {A6C344CA-7C69-4600-9DE2-CA92E27D7B72}). */
export type PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Search Page template (ID: {A6C344CA-7C69-4600-9DE2-CA92E27D7B72}). */
export type PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Search Page template (ID: {A6C344CA-7C69-4600-9DE2-CA92E27D7B72}). */
export type PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Search Page template (ID: {A6C344CA-7C69-4600-9DE2-CA92E27D7B72}). */
export type PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Search Page template (ID: {B9CD16F5-85EA-4405-A1CE-DA10CB20F64D}). */
export type PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Search Page template (ID: {B9CD16F5-85EA-4405-A1CE-DA10CB20F64D}). */
export type PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Search Page template (ID: {B9CD16F5-85EA-4405-A1CE-DA10CB20F64D}). */
export type PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Search Page template (ID: {B9CD16F5-85EA-4405-A1CE-DA10CB20F64D}). */
export type PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Search Page template (ID: {B9CD16F5-85EA-4405-A1CE-DA10CB20F64D}). */
export type PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Search Page template (ID: {B9CD16F5-85EA-4405-A1CE-DA10CB20F64D}). */
export type PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Search Page template (ID: {B9CD16F5-85EA-4405-A1CE-DA10CB20F64D}). */
export type PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Press Release Search Page template (ID: {C9702744-2DF6-47CF-9C36-EEDFC6787F58}). */
export type PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Search Page template (ID: {C9702744-2DF6-47CF-9C36-EEDFC6787F58}). */
export type PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Search Page template (ID: {C9702744-2DF6-47CF-9C36-EEDFC6787F58}). */
export type PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Search Page template (ID: {C9702744-2DF6-47CF-9C36-EEDFC6787F58}). */
export type PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Search Page template (ID: {C9702744-2DF6-47CF-9C36-EEDFC6787F58}). */
export type PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Search Page template (ID: {C9702744-2DF6-47CF-9C36-EEDFC6787F58}). */
export type PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Search Page template (ID: {C9702744-2DF6-47CF-9C36-EEDFC6787F58}). */
export type PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Press Release Wildcard Page template (ID: {15962601-30FD-4953-8B56-869810F31A4B}). */
export type PressReleaseWildcardPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseWildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Wildcard Page template (ID: {15962601-30FD-4953-8B56-869810F31A4B}). */
export type PressReleaseWildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Wildcard Page template (ID: {15962601-30FD-4953-8B56-869810F31A4B}). */
export type PressReleaseWildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Wildcard Page template (ID: {15962601-30FD-4953-8B56-869810F31A4B}). */
export type PressReleaseWildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Wildcard Page template (ID: {15962601-30FD-4953-8B56-869810F31A4B}). */
export type PressReleaseWildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Wildcard Page template (ID: {15962601-30FD-4953-8B56-869810F31A4B}). */
export type PressReleaseWildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Press Release Wildcard Page template (ID: {15962601-30FD-4953-8B56-869810F31A4B}). */
export type PressReleaseWildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Press Release Wildcard Page template (ID: {2C028BDB-0287-4051-B629-A7B7D422CC1E}). */
export type PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Wildcard Page template (ID: {2C028BDB-0287-4051-B629-A7B7D422CC1E}). */
export type PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Wildcard Page template (ID: {2C028BDB-0287-4051-B629-A7B7D422CC1E}). */
export type PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Wildcard Page template (ID: {2C028BDB-0287-4051-B629-A7B7D422CC1E}). */
export type PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Wildcard Page template (ID: {2C028BDB-0287-4051-B629-A7B7D422CC1E}). */
export type PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Wildcard Page template (ID: {2C028BDB-0287-4051-B629-A7B7D422CC1E}). */
export type PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Press Release Wildcard Page template (ID: {2C028BDB-0287-4051-B629-A7B7D422CC1E}). */
export type PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Press Release Wildcard Page template (ID: {5A72BE83-4C65-4D70-A591-CEF7E9CE9D79}). */
export type PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Wildcard Page template (ID: {5A72BE83-4C65-4D70-A591-CEF7E9CE9D79}). */
export type PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Wildcard Page template (ID: {5A72BE83-4C65-4D70-A591-CEF7E9CE9D79}). */
export type PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Wildcard Page template (ID: {5A72BE83-4C65-4D70-A591-CEF7E9CE9D79}). */
export type PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Wildcard Page template (ID: {5A72BE83-4C65-4D70-A591-CEF7E9CE9D79}). */
export type PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Wildcard Page template (ID: {5A72BE83-4C65-4D70-A591-CEF7E9CE9D79}). */
export type PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Press Release Wildcard Page template (ID: {5A72BE83-4C65-4D70-A591-CEF7E9CE9D79}). */
export type PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Wildcard Page template (ID: {B337D304-03C6-42D2-B975-7E23D08223A1}). */
export type PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Wildcard Page template (ID: {B337D304-03C6-42D2-B975-7E23D08223A1}). */
export type PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Wildcard Page template (ID: {B337D304-03C6-42D2-B975-7E23D08223A1}). */
export type PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Wildcard Page template (ID: {B337D304-03C6-42D2-B975-7E23D08223A1}). */
export type PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Wildcard Page template (ID: {B337D304-03C6-42D2-B975-7E23D08223A1}). */
export type PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Wildcard Page template (ID: {B337D304-03C6-42D2-B975-7E23D08223A1}). */
export type PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Press Release Wildcard Page template (ID: {B337D304-03C6-42D2-B975-7E23D08223A1}). */
export type PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Wildcard Page template (ID: {E55E9D5B-F961-4E30-B0A2-A90327428258}). */
export type PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Wildcard Page template (ID: {E55E9D5B-F961-4E30-B0A2-A90327428258}). */
export type PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Wildcard Page template (ID: {E55E9D5B-F961-4E30-B0A2-A90327428258}). */
export type PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Wildcard Page template (ID: {E55E9D5B-F961-4E30-B0A2-A90327428258}). */
export type PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Wildcard Page template (ID: {E55E9D5B-F961-4E30-B0A2-A90327428258}). */
export type PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Wildcard Page template (ID: {E55E9D5B-F961-4E30-B0A2-A90327428258}). */
export type PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Press Release Wildcard Page template (ID: {E55E9D5B-F961-4E30-B0A2-A90327428258}). */
export type PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Press Releases Group Folder template (ID: {DBC0B458-7A49-4CAC-BE24-ED868893BEF9}). */
export type PressReleasesGroupFolder = Item & _PressReleaseContentType & _SharedPage & {
  __typename?: 'PressReleasesGroupFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Press Releases Group Folder template (ID: {DBC0B458-7A49-4CAC-BE24-ED868893BEF9}). */
export type PressReleasesGroupFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Press Releases Group Folder template (ID: {DBC0B458-7A49-4CAC-BE24-ED868893BEF9}). */
export type PressReleasesGroupFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Press Releases Group Folder template (ID: {DBC0B458-7A49-4CAC-BE24-ED868893BEF9}). */
export type PressReleasesGroupFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Press Releases Group Folder template (ID: {DBC0B458-7A49-4CAC-BE24-ED868893BEF9}). */
export type PressReleasesGroupFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Press Releases Group Folder template (ID: {DBC0B458-7A49-4CAC-BE24-ED868893BEF9}). */
export type PressReleasesGroupFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Press Releases Group Folder template (ID: {DBC0B458-7A49-4CAC-BE24-ED868893BEF9}). */
export type PressReleasesGroupFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Compliancy/Privacy Warning template (ID: {DC66D5DA-3216-48E6-AE78-BAC8445B6A46}). */
export type PrivacyWarning = ICacheable & Item & {
  __typename?: 'PrivacyWarning';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LearnMoreTarget (ID: {A4270003-480F-467A-BBEA-0D1B05B28656}). */
  learnMoreTarget?: Maybe<LinkField>;
  /** LearnMoreText (ID: {1466C213-7752-427F-A6B8-E4E2CF6E1264}). */
  learnMoreText?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PrivacyWarningButtonText (ID: {6AF8DFD6-F541-400A-83C0-2A90A1FE8E6F}). */
  privacyWarningButtonText?: Maybe<TextField>;
  /** PrivacyWarningContent (ID: {F2AD4C49-ECC4-4D42-A967-2756182705AC}). */
  privacyWarningContent?: Maybe<RichTextField>;
  /** PrivacyWarningType (ID: {73501930-26ED-493F-ADC9-3AC77FC5ED66}). */
  privacyWarningType?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Whitelist (ID: {0F232DAF-9D2C-453A-9262-8BBB266842D7}). */
  whitelist?: Maybe<MultilistField>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Compliancy/Privacy Warning template (ID: {DC66D5DA-3216-48E6-AE78-BAC8445B6A46}). */
export type PrivacyWarningAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Compliancy/Privacy Warning template (ID: {DC66D5DA-3216-48E6-AE78-BAC8445B6A46}). */
export type PrivacyWarningChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Compliancy/Privacy Warning template (ID: {DC66D5DA-3216-48E6-AE78-BAC8445B6A46}). */
export type PrivacyWarningFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Compliancy/Privacy Warning template (ID: {DC66D5DA-3216-48E6-AE78-BAC8445B6A46}). */
export type PrivacyWarningFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Compliancy/Privacy Warning template (ID: {DC66D5DA-3216-48E6-AE78-BAC8445B6A46}). */
export type PrivacyWarningHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Compliancy/Privacy Warning template (ID: {DC66D5DA-3216-48E6-AE78-BAC8445B6A46}). */
export type PrivacyWarningIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Project Folder template (ID: {77157D54-90C8-4014-9B9E-540D24E71D03}). */
export type ProjectFolder = Item & {
  __typename?: 'ProjectFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Project Folder template (ID: {77157D54-90C8-4014-9B9E-540D24E71D03}). */
export type ProjectFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Project Folder template (ID: {77157D54-90C8-4014-9B9E-540D24E71D03}). */
export type ProjectFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Project Folder template (ID: {77157D54-90C8-4014-9B9E-540D24E71D03}). */
export type ProjectFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Project Folder template (ID: {77157D54-90C8-4014-9B9E-540D24E71D03}). */
export type ProjectFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Project Folder template (ID: {77157D54-90C8-4014-9B9E-540D24E71D03}). */
export type ProjectFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Project Folder template (ID: {77157D54-90C8-4014-9B9E-540D24E71D03}). */
export type ProjectFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo template (ID: {324733CF-AFEC-4281-9A18-03B6CFC4E535}). */
export type Promo = Item & {
  __typename?: 'Promo';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PromoIcon (ID: {18F9BEB8-0116-40FD-B47E-FD0A2327D7E0}). */
  promoIcon?: Maybe<ImageField>;
  /** PromoIcon2 (ID: {82A6CE45-59B5-4BC8-83B9-79CCB8174A2A}). */
  promoIcon2?: Maybe<ImageField>;
  /** PromoLink (ID: {B8C1A9D2-DE76-4519-AFF4-1442525F32B0}). */
  promoLink?: Maybe<LinkField>;
  /** PromoText (ID: {14023DD5-30E7-4E3C-BF31-D835F3A87410}). */
  promoText?: Maybe<RichTextField>;
  /** PromoText2 (ID: {B59ADC09-32A3-46F2-AEDE-B0C633979263}). */
  promoText2?: Maybe<RichTextField>;
  /** PromoText3 (ID: {832D3C97-5C05-49BF-89EF-9C29D30345E7}). */
  promoText3?: Maybe<RichTextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo template (ID: {324733CF-AFEC-4281-9A18-03B6CFC4E535}). */
export type PromoAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo template (ID: {324733CF-AFEC-4281-9A18-03B6CFC4E535}). */
export type PromoChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo template (ID: {324733CF-AFEC-4281-9A18-03B6CFC4E535}). */
export type PromoFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo template (ID: {324733CF-AFEC-4281-9A18-03B6CFC4E535}). */
export type PromoFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo template (ID: {324733CF-AFEC-4281-9A18-03B6CFC4E535}). */
export type PromoHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo template (ID: {324733CF-AFEC-4281-9A18-03B6CFC4E535}). */
export type PromoIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo Folder template (ID: {8FE7F8DC-CB5D-42C2-99F8-76608C243F10}). */
export type PromoFolder = Item & {
  __typename?: 'PromoFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo Folder template (ID: {8FE7F8DC-CB5D-42C2-99F8-76608C243F10}). */
export type PromoFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo Folder template (ID: {8FE7F8DC-CB5D-42C2-99F8-76608C243F10}). */
export type PromoFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo Folder template (ID: {8FE7F8DC-CB5D-42C2-99F8-76608C243F10}). */
export type PromoFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo Folder template (ID: {8FE7F8DC-CB5D-42C2-99F8-76608C243F10}). */
export type PromoFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo Folder template (ID: {8FE7F8DC-CB5D-42C2-99F8-76608C243F10}). */
export type PromoFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo Folder template (ID: {8FE7F8DC-CB5D-42C2-99F8-76608C243F10}). */
export type PromoFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo Folder template (ID: {F07CBE89-73AE-4DE6-9217-2570260CAC6E}). */
export type PromoFolder_F07cbe8973ae4de692172570260cac6e = Item & {
  __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo Folder template (ID: {F07CBE89-73AE-4DE6-9217-2570260CAC6E}). */
export type PromoFolder_F07cbe8973ae4de692172570260cac6eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo Folder template (ID: {F07CBE89-73AE-4DE6-9217-2570260CAC6E}). */
export type PromoFolder_F07cbe8973ae4de692172570260cac6eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo Folder template (ID: {F07CBE89-73AE-4DE6-9217-2570260CAC6E}). */
export type PromoFolder_F07cbe8973ae4de692172570260cac6eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo Folder template (ID: {F07CBE89-73AE-4DE6-9217-2570260CAC6E}). */
export type PromoFolder_F07cbe8973ae4de692172570260cac6eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo Folder template (ID: {F07CBE89-73AE-4DE6-9217-2570260CAC6E}). */
export type PromoFolder_F07cbe8973ae4de692172570260cac6eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Promo Folder template (ID: {F07CBE89-73AE-4DE6-9217-2570260CAC6E}). */
export type PromoFolder_F07cbe8973ae4de692172570260cac6eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {7F21F14D-096B-4F27-BBCC-F115C6E6F6F1}). */
export type Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {7F21F14D-096B-4F27-BBCC-F115C6E6F6F1}). */
export type Promo_7f21f14d096b4f27bbccf115c6e6f6f1AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {7F21F14D-096B-4F27-BBCC-F115C6E6F6F1}). */
export type Promo_7f21f14d096b4f27bbccf115c6e6f6f1ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {7F21F14D-096B-4F27-BBCC-F115C6E6F6F1}). */
export type Promo_7f21f14d096b4f27bbccf115c6e6f6f1FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {7F21F14D-096B-4F27-BBCC-F115C6E6F6F1}). */
export type Promo_7f21f14d096b4f27bbccf115c6e6f6f1FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {7F21F14D-096B-4F27-BBCC-F115C6E6F6F1}). */
export type Promo_7f21f14d096b4f27bbccf115c6e6f6f1HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {7F21F14D-096B-4F27-BBCC-F115C6E6F6F1}). */
export type Promo_7f21f14d096b4f27bbccf115c6e6f6f1IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {881869CA-7F58-45EA-8B34-AD1BFD3551A8}). */
export type Promo_881869ca7f5845ea8b34ad1bfd3551a8 = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {881869CA-7F58-45EA-8B34-AD1BFD3551A8}). */
export type Promo_881869ca7f5845ea8b34ad1bfd3551a8AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {881869CA-7F58-45EA-8B34-AD1BFD3551A8}). */
export type Promo_881869ca7f5845ea8b34ad1bfd3551a8ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {881869CA-7F58-45EA-8B34-AD1BFD3551A8}). */
export type Promo_881869ca7f5845ea8b34ad1bfd3551a8FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {881869CA-7F58-45EA-8B34-AD1BFD3551A8}). */
export type Promo_881869ca7f5845ea8b34ad1bfd3551a8FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {881869CA-7F58-45EA-8B34-AD1BFD3551A8}). */
export type Promo_881869ca7f5845ea8b34ad1bfd3551a8HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Promo template (ID: {881869CA-7F58-45EA-8B34-AD1BFD3551A8}). */
export type Promo_881869ca7f5845ea8b34ad1bfd3551a8IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo template (ID: {DFED4457-D760-457A-BEC1-C0DCCDC44381}). */
export type Promo_Dfed4457d760457abec1c0dccdc44381 = Item & {
  __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PromoIcon (ID: {F94B9858-C439-4291-863B-757B536C8B65}). */
  promoIcon?: Maybe<ImageField>;
  /** PromoIcon2 (ID: {739C6CC2-0031-463D-9599-13478FD50EE3}). */
  promoIcon2?: Maybe<ImageField>;
  /** PromoLink (ID: {EF24BED2-46AB-4D53-AD1A-1019935A4E89}). */
  promoLink?: Maybe<LinkField>;
  /** PromoText (ID: {28079F3A-896B-4273-BE5F-59D0EBB7CD7D}). */
  promoText?: Maybe<RichTextField>;
  /** PromoText2 (ID: {1F66862D-A5E3-405F-8E3E-B787B4C39B12}). */
  promoText2?: Maybe<RichTextField>;
  /** PromoText3 (ID: {C6E604C3-5371-4E67-83DF-A09A5EA66249}). */
  promoText3?: Maybe<RichTextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo template (ID: {DFED4457-D760-457A-BEC1-C0DCCDC44381}). */
export type Promo_Dfed4457d760457abec1c0dccdc44381AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo template (ID: {DFED4457-D760-457A-BEC1-C0DCCDC44381}). */
export type Promo_Dfed4457d760457abec1c0dccdc44381ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo template (ID: {DFED4457-D760-457A-BEC1-C0DCCDC44381}). */
export type Promo_Dfed4457d760457abec1c0dccdc44381FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo template (ID: {DFED4457-D760-457A-BEC1-C0DCCDC44381}). */
export type Promo_Dfed4457d760457abec1c0dccdc44381FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo template (ID: {DFED4457-D760-457A-BEC1-C0DCCDC44381}). */
export type Promo_Dfed4457d760457abec1c0dccdc44381HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Promo template (ID: {DFED4457-D760-457A-BEC1-C0DCCDC44381}). */
export type Promo_Dfed4457d760457abec1c0dccdc44381IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content template (ID: {A24B8FE7-233A-44DD-A86C-A781EE125788}). */
export type PromotedContent = Item & {
  __typename?: 'PromotedContent';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ctaLink (ID: {30C6D4F1-7819-48A5-9371-9A3A56900C0B}). */
  ctaLink?: Maybe<TextField>;
  /** description (ID: {E52AD5CB-3E66-40C8-AB89-AEDAA357506F}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {E1224ED3-8095-48E2-884E-52E2892270F3}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {E148C984-6CC8-4A9D-BF57-18D7EF4F05D6}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content template (ID: {A24B8FE7-233A-44DD-A86C-A781EE125788}). */
export type PromotedContentAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content template (ID: {A24B8FE7-233A-44DD-A86C-A781EE125788}). */
export type PromotedContentChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content template (ID: {A24B8FE7-233A-44DD-A86C-A781EE125788}). */
export type PromotedContentFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content template (ID: {A24B8FE7-233A-44DD-A86C-A781EE125788}). */
export type PromotedContentFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content template (ID: {A24B8FE7-233A-44DD-A86C-A781EE125788}). */
export type PromotedContentHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content template (ID: {A24B8FE7-233A-44DD-A86C-A781EE125788}). */
export type PromotedContentIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content Folder template (ID: {96168921-91BA-4D44-8E9E-78796B47E67A}). */
export type PromotedContentFolder = Item & {
  __typename?: 'PromotedContentFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content Folder template (ID: {96168921-91BA-4D44-8E9E-78796B47E67A}). */
export type PromotedContentFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content Folder template (ID: {96168921-91BA-4D44-8E9E-78796B47E67A}). */
export type PromotedContentFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content Folder template (ID: {96168921-91BA-4D44-8E9E-78796B47E67A}). */
export type PromotedContentFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content Folder template (ID: {96168921-91BA-4D44-8E9E-78796B47E67A}). */
export type PromotedContentFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content Folder template (ID: {96168921-91BA-4D44-8E9E-78796B47E67A}). */
export type PromotedContentFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Promoted Content/Promoted Content Folder template (ID: {96168921-91BA-4D44-8E9E-78796B47E67A}). */
export type PromotedContentFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Card template (ID: {1E19401D-E756-47F1-A90B-9F0C905B913D}). */
export type PropertyListingCard = Item & {
  __typename?: 'PropertyListingCard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** details (ID: {C1C5DB41-9E84-4576-8834-07FA5C8E61D4}). */
  details?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {420795D7-BEB0-4FA6-9A77-1974EABC1739}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** occupationalTenancies (ID: {A0FBC3D5-1E38-4BF2-9110-1CE7F495813C}). */
  occupationalTenancies?: Maybe<TextField>;
  /** ownership (ID: {8478864C-A42C-4AA6-B854-8C666F4BFFA2}). */
  ownership?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {38F16D9C-213D-4786-8A40-45BFBDB331E3}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Card template (ID: {1E19401D-E756-47F1-A90B-9F0C905B913D}). */
export type PropertyListingCardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Card template (ID: {1E19401D-E756-47F1-A90B-9F0C905B913D}). */
export type PropertyListingCardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Card template (ID: {1E19401D-E756-47F1-A90B-9F0C905B913D}). */
export type PropertyListingCardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Card template (ID: {1E19401D-E756-47F1-A90B-9F0C905B913D}). */
export type PropertyListingCardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Card template (ID: {1E19401D-E756-47F1-A90B-9F0C905B913D}). */
export type PropertyListingCardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Card template (ID: {1E19401D-E756-47F1-A90B-9F0C905B913D}). */
export type PropertyListingCardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Cards template (ID: {0F9B559A-7488-4C91-B7CD-22B9C8E2AC94}). */
export type PropertyListingCards = Item & {
  __typename?: 'PropertyListingCards';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** mapUrl (ID: {E22570CC-6990-46DF-9A96-F20675598458}). */
  mapUrl?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Cards template (ID: {0F9B559A-7488-4C91-B7CD-22B9C8E2AC94}). */
export type PropertyListingCardsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Cards template (ID: {0F9B559A-7488-4C91-B7CD-22B9C8E2AC94}). */
export type PropertyListingCardsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Cards template (ID: {0F9B559A-7488-4C91-B7CD-22B9C8E2AC94}). */
export type PropertyListingCardsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Cards template (ID: {0F9B559A-7488-4C91-B7CD-22B9C8E2AC94}). */
export type PropertyListingCardsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Cards template (ID: {0F9B559A-7488-4C91-B7CD-22B9C8E2AC94}). */
export type PropertyListingCardsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Cards template (ID: {0F9B559A-7488-4C91-B7CD-22B9C8E2AC94}). */
export type PropertyListingCardsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Category template (ID: {255262C1-F39B-4391-B514-BBEB95F0581E}). */
export type PropertyListingCategory = Item & {
  __typename?: 'PropertyListingCategory';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {FC54C142-C870-491D-91FC-212BADC1CD19}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Category template (ID: {255262C1-F39B-4391-B514-BBEB95F0581E}). */
export type PropertyListingCategoryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Category template (ID: {255262C1-F39B-4391-B514-BBEB95F0581E}). */
export type PropertyListingCategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Category template (ID: {255262C1-F39B-4391-B514-BBEB95F0581E}). */
export type PropertyListingCategoryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Category template (ID: {255262C1-F39B-4391-B514-BBEB95F0581E}). */
export type PropertyListingCategoryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Category template (ID: {255262C1-F39B-4391-B514-BBEB95F0581E}). */
export type PropertyListingCategoryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Category template (ID: {255262C1-F39B-4391-B514-BBEB95F0581E}). */
export type PropertyListingCategoryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Folder template (ID: {CD3511F2-F456-4072-8051-75D05E8829A5}). */
export type PropertyListingFolder = Item & {
  __typename?: 'PropertyListingFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Folder template (ID: {CD3511F2-F456-4072-8051-75D05E8829A5}). */
export type PropertyListingFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Folder template (ID: {CD3511F2-F456-4072-8051-75D05E8829A5}). */
export type PropertyListingFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Folder template (ID: {CD3511F2-F456-4072-8051-75D05E8829A5}). */
export type PropertyListingFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Folder template (ID: {CD3511F2-F456-4072-8051-75D05E8829A5}). */
export type PropertyListingFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Folder template (ID: {CD3511F2-F456-4072-8051-75D05E8829A5}). */
export type PropertyListingFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Property Listing Cards/Property Listing Folder template (ID: {CD3511F2-F456-4072-8051-75D05E8829A5}). */
export type PropertyListingFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Allows querying for information about an item in the content tree. */
  item?: Maybe<Item>;
  /** Allows querying presentation details/layout data for the item. */
  layout?: Maybe<LayoutData>;
  /** Allows querying for items based on provided criteria. */
  search?: Maybe<ItemSearchResults>;
  /** Allows querying for information about content sites. */
  site?: Maybe<SiteData>;
};


export type QueryItemArgs = {
  language: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLayoutArgs = {
  language: Scalars['String']['input'];
  routePath: Scalars['String']['input'];
  site: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ItemSearchOrderByInput>;
  where: ItemSearchPredicateInput;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Query template (ID: {98B41352-5A4B-4067-B924-18A4B50F0A53}). */
export type Query_98b413525a4b4067b92418a4b50f0a53 = IBoosting & Item & _VariantPaging & {
  __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NumberOfResultsToSkip (ID: {AE6DB294-8D8B-45BE-919C-1143867BC03D}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /**
   * Determines the query that will be run on the current context item. For example:
   * To get all child items:
   * query:./* 
   * To get all items of Page template from under the current item:
   * query:..//*[@@templatename='Page'] 
   * To get all items of Page template from under Home item of the current site:
   * query:/*[@@name='Home']//*[@@templatename='Page']
   */
  query?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rule (ID: {0F628FD3-A28C-4DA7-968B-DCE9F3B71B5A}). */
  rule?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Query template (ID: {98B41352-5A4B-4067-B924-18A4B50F0A53}). */
export type Query_98b413525a4b4067b92418a4b50f0a53AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Query template (ID: {98B41352-5A4B-4067-B924-18A4B50F0A53}). */
export type Query_98b413525a4b4067b92418a4b50f0a53ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Query template (ID: {98B41352-5A4B-4067-B924-18A4B50F0A53}). */
export type Query_98b413525a4b4067b92418a4b50f0a53FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Query template (ID: {98B41352-5A4B-4067-B924-18A4B50F0A53}). */
export type Query_98b413525a4b4067b92418a4b50f0a53FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Query template (ID: {98B41352-5A4B-4067-B924-18A4B50F0A53}). */
export type Query_98b413525a4b4067b92418a4b50f0a53HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Query template (ID: {98B41352-5A4B-4067-B924-18A4B50F0A53}). */
export type Query_98b413525a4b4067b92418a4b50f0a53IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links template (ID: {083FAF7B-13E2-48C7-AA6D-AACD3E88DF35}). */
export type QuickLinks = Item & {
  __typename?: 'QuickLinks';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {82D8D28A-7B33-4464-AFF6-5AA6A5B9A869}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links template (ID: {083FAF7B-13E2-48C7-AA6D-AACD3E88DF35}). */
export type QuickLinksAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links template (ID: {083FAF7B-13E2-48C7-AA6D-AACD3E88DF35}). */
export type QuickLinksChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links template (ID: {083FAF7B-13E2-48C7-AA6D-AACD3E88DF35}). */
export type QuickLinksFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links template (ID: {083FAF7B-13E2-48C7-AA6D-AACD3E88DF35}). */
export type QuickLinksFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links template (ID: {083FAF7B-13E2-48C7-AA6D-AACD3E88DF35}). */
export type QuickLinksHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links template (ID: {083FAF7B-13E2-48C7-AA6D-AACD3E88DF35}). */
export type QuickLinksIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links Folder template (ID: {A8C37CE7-5968-4BC3-8D1C-AD01E08D7882}). */
export type QuickLinksFolder = Item & {
  __typename?: 'QuickLinksFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links Folder template (ID: {A8C37CE7-5968-4BC3-8D1C-AD01E08D7882}). */
export type QuickLinksFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links Folder template (ID: {A8C37CE7-5968-4BC3-8D1C-AD01E08D7882}). */
export type QuickLinksFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links Folder template (ID: {A8C37CE7-5968-4BC3-8D1C-AD01E08D7882}). */
export type QuickLinksFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links Folder template (ID: {A8C37CE7-5968-4BC3-8D1C-AD01E08D7882}). */
export type QuickLinksFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links Folder template (ID: {A8C37CE7-5968-4BC3-8D1C-AD01E08D7882}). */
export type QuickLinksFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quick Links/Quick Links Folder template (ID: {A8C37CE7-5968-4BC3-8D1C-AD01E08D7882}). */
export type QuickLinksFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quick Links Parameters Template template (ID: {C6A336B7-CBEF-46B3-A131-47A52BC7A661}). */
export type QuickLinksParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'QuickLinksParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {01966C13-B59F-4CFE-BD0C-7508BAAA58FB}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** col (ID: {D1F2AEE2-996D-41AE-AF5C-A88E73225DE7}). */
  col?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quick Links Parameters Template template (ID: {C6A336B7-CBEF-46B3-A131-47A52BC7A661}). */
export type QuickLinksParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quick Links Parameters Template template (ID: {C6A336B7-CBEF-46B3-A131-47A52BC7A661}). */
export type QuickLinksParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quick Links Parameters Template template (ID: {C6A336B7-CBEF-46B3-A131-47A52BC7A661}). */
export type QuickLinksParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quick Links Parameters Template template (ID: {C6A336B7-CBEF-46B3-A131-47A52BC7A661}). */
export type QuickLinksParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quick Links Parameters Template template (ID: {C6A336B7-CBEF-46B3-A131-47A52BC7A661}). */
export type QuickLinksParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quick Links Parameters Template template (ID: {C6A336B7-CBEF-46B3-A131-47A52BC7A661}). */
export type QuickLinksParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Block Item template (ID: {50FB8D02-7BC3-407D-B1F0-A57FEE23B57A}). */
export type QuotationBlockItem = Item & {
  __typename?: 'QuotationBlockItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** authorName (ID: {E73F94E7-22F3-4095-A429-BC5673DA9074}). */
  authorName?: Maybe<TextField>;
  /** authorTitle (ID: {5C80589C-80C2-4A3D-A761-6CDE3FA4D61B}). */
  authorTitle?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {0F263585-8D7D-4DEE-8727-D818318AA26F}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** quotation (ID: {7FDD916E-3A21-496F-BF37-CEAEDC8A9B04}). */
  quotation?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Block Item template (ID: {50FB8D02-7BC3-407D-B1F0-A57FEE23B57A}). */
export type QuotationBlockItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Block Item template (ID: {50FB8D02-7BC3-407D-B1F0-A57FEE23B57A}). */
export type QuotationBlockItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Block Item template (ID: {50FB8D02-7BC3-407D-B1F0-A57FEE23B57A}). */
export type QuotationBlockItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Block Item template (ID: {50FB8D02-7BC3-407D-B1F0-A57FEE23B57A}). */
export type QuotationBlockItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Block Item template (ID: {50FB8D02-7BC3-407D-B1F0-A57FEE23B57A}). */
export type QuotationBlockItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Block Item template (ID: {50FB8D02-7BC3-407D-B1F0-A57FEE23B57A}). */
export type QuotationBlockItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks template (ID: {3C24B39A-64EB-4517-B874-0F819C14CEBC}). */
export type QuotationBlocks = Item & {
  __typename?: 'QuotationBlocks';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {010628E9-F458-4576-B0D1-D781AF23AB0E}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks template (ID: {3C24B39A-64EB-4517-B874-0F819C14CEBC}). */
export type QuotationBlocksAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks template (ID: {3C24B39A-64EB-4517-B874-0F819C14CEBC}). */
export type QuotationBlocksChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks template (ID: {3C24B39A-64EB-4517-B874-0F819C14CEBC}). */
export type QuotationBlocksFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks template (ID: {3C24B39A-64EB-4517-B874-0F819C14CEBC}). */
export type QuotationBlocksFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks template (ID: {3C24B39A-64EB-4517-B874-0F819C14CEBC}). */
export type QuotationBlocksHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks template (ID: {3C24B39A-64EB-4517-B874-0F819C14CEBC}). */
export type QuotationBlocksIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks Folder template (ID: {50C4BA13-E994-44B5-AB6F-893C91DFD89D}). */
export type QuotationBlocksFolder = Item & {
  __typename?: 'QuotationBlocksFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks Folder template (ID: {50C4BA13-E994-44B5-AB6F-893C91DFD89D}). */
export type QuotationBlocksFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks Folder template (ID: {50C4BA13-E994-44B5-AB6F-893C91DFD89D}). */
export type QuotationBlocksFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks Folder template (ID: {50C4BA13-E994-44B5-AB6F-893C91DFD89D}). */
export type QuotationBlocksFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks Folder template (ID: {50C4BA13-E994-44B5-AB6F-893C91DFD89D}). */
export type QuotationBlocksFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks Folder template (ID: {50C4BA13-E994-44B5-AB6F-893C91DFD89D}). */
export type QuotationBlocksFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Quotation Blocks/Quotation Blocks Folder template (ID: {50C4BA13-E994-44B5-AB6F-893C91DFD89D}). */
export type QuotationBlocksFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quotation Blocks Parameters Template template (ID: {DD0A9588-18B8-49D7-AA1A-D1AD70CC41B9}). */
export type QuotationBlocksParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'QuotationBlocksParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {0DB18FE6-8014-4C6F-9B28-3AF3181A6383}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quotation Blocks Parameters Template template (ID: {DD0A9588-18B8-49D7-AA1A-D1AD70CC41B9}). */
export type QuotationBlocksParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quotation Blocks Parameters Template template (ID: {DD0A9588-18B8-49D7-AA1A-D1AD70CC41B9}). */
export type QuotationBlocksParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quotation Blocks Parameters Template template (ID: {DD0A9588-18B8-49D7-AA1A-D1AD70CC41B9}). */
export type QuotationBlocksParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quotation Blocks Parameters Template template (ID: {DD0A9588-18B8-49D7-AA1A-D1AD70CC41B9}). */
export type QuotationBlocksParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quotation Blocks Parameters Template template (ID: {DD0A9588-18B8-49D7-AA1A-D1AD70CC41B9}). */
export type QuotationBlocksParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Quotation Blocks Parameters Template template (ID: {DD0A9588-18B8-49D7-AA1A-D1AD70CC41B9}). */
export type QuotationBlocksParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote template (ID: {98CD4F89-A76C-4373-9ED4-6B6F6622BC13}). */
export type Quote = Item & {
  __typename?: 'Quote';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** quoteAuthor (ID: {94F5B370-A633-4419-8489-F2CF04B4F7C3}). */
  quoteAuthor?: Maybe<TextField>;
  /** quoteTitle (ID: {294A6A8F-2EDD-4204-B396-BCCA21C1F3BD}). */
  quoteTitle?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote template (ID: {98CD4F89-A76C-4373-9ED4-6B6F6622BC13}). */
export type QuoteAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote template (ID: {98CD4F89-A76C-4373-9ED4-6B6F6622BC13}). */
export type QuoteChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote template (ID: {98CD4F89-A76C-4373-9ED4-6B6F6622BC13}). */
export type QuoteFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote template (ID: {98CD4F89-A76C-4373-9ED4-6B6F6622BC13}). */
export type QuoteFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote template (ID: {98CD4F89-A76C-4373-9ED4-6B6F6622BC13}). */
export type QuoteHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote template (ID: {98CD4F89-A76C-4373-9ED4-6B6F6622BC13}). */
export type QuoteIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote Folder template (ID: {4C913237-84F6-491E-B9BB-94C0728D3B07}). */
export type QuoteFolder = Item & {
  __typename?: 'QuoteFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote Folder template (ID: {4C913237-84F6-491E-B9BB-94C0728D3B07}). */
export type QuoteFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote Folder template (ID: {4C913237-84F6-491E-B9BB-94C0728D3B07}). */
export type QuoteFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote Folder template (ID: {4C913237-84F6-491E-B9BB-94C0728D3B07}). */
export type QuoteFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote Folder template (ID: {4C913237-84F6-491E-B9BB-94C0728D3B07}). */
export type QuoteFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote Folder template (ID: {4C913237-84F6-491E-B9BB-94C0728D3B07}). */
export type QuoteFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Quote/Quote Folder template (ID: {4C913237-84F6-491E-B9BB-94C0728D3B07}). */
export type QuoteFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Quote Parameters Template template (ID: {197978CE-CEB5-4500-A413-5EFB93D0501F}). */
export type QuoteParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'QuoteParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {930DB1B6-0B29-4FF1-B2C2-19698B1D6556}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Quote Parameters Template template (ID: {197978CE-CEB5-4500-A413-5EFB93D0501F}). */
export type QuoteParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Quote Parameters Template template (ID: {197978CE-CEB5-4500-A413-5EFB93D0501F}). */
export type QuoteParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Quote Parameters Template template (ID: {197978CE-CEB5-4500-A413-5EFB93D0501F}). */
export type QuoteParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Quote Parameters Template template (ID: {197978CE-CEB5-4500-A413-5EFB93D0501F}). */
export type QuoteParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Quote Parameters Template template (ID: {197978CE-CEB5-4500-A413-5EFB93D0501F}). */
export type QuoteParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Quote Parameters Template template (ID: {197978CE-CEB5-4500-A413-5EFB93D0501F}). */
export type QuoteParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Radius Filter template (ID: {FEE0A5DC-5022-41F7-88F3-C4CA896726D3}). */
export type RadiusFilter = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'RadiusFilter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Radius Scheme (ID: {BE18541B-8B36-4021-AC89-C215515E7B7C}). */
  radiusScheme?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Radius Filter template (ID: {FEE0A5DC-5022-41F7-88F3-C4CA896726D3}). */
export type RadiusFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Radius Filter template (ID: {FEE0A5DC-5022-41F7-88F3-C4CA896726D3}). */
export type RadiusFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Radius Filter template (ID: {FEE0A5DC-5022-41F7-88F3-C4CA896726D3}). */
export type RadiusFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Radius Filter template (ID: {FEE0A5DC-5022-41F7-88F3-C4CA896726D3}). */
export type RadiusFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Radius Filter template (ID: {FEE0A5DC-5022-41F7-88F3-C4CA896726D3}). */
export type RadiusFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Radius Filter template (ID: {FEE0A5DC-5022-41F7-88F3-C4CA896726D3}). */
export type RadiusFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Radius Filter Folder template (ID: {ED133836-964C-4CAE-ACDC-87EADC8849EF}). */
export type RadiusFilterFolder = Item & {
  __typename?: 'RadiusFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Radius Filter Folder template (ID: {ED133836-964C-4CAE-ACDC-87EADC8849EF}). */
export type RadiusFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Radius Filter Folder template (ID: {ED133836-964C-4CAE-ACDC-87EADC8849EF}). */
export type RadiusFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Radius Filter Folder template (ID: {ED133836-964C-4CAE-ACDC-87EADC8849EF}). */
export type RadiusFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Radius Filter Folder template (ID: {ED133836-964C-4CAE-ACDC-87EADC8849EF}). */
export type RadiusFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Radius Filter Folder template (ID: {ED133836-964C-4CAE-ACDC-87EADC8849EF}). */
export type RadiusFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Radius Filter Folder template (ID: {ED133836-964C-4CAE-ACDC-87EADC8849EF}). */
export type RadiusFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Filter template (ID: {DE3FA58E-EF9D-4544-9F77-DCD1DBB05B64}). */
export type RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64 = FacetSelectorConfigBase & Item & {
  __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Facet (ID: {AE5D211A-4FF1-4E9E-BA0F-9442B0ABCA91}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Filter template (ID: {DE3FA58E-EF9D-4544-9F77-DCD1DBB05B64}). */
export type RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Filter template (ID: {DE3FA58E-EF9D-4544-9F77-DCD1DBB05B64}). */
export type RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Filter template (ID: {DE3FA58E-EF9D-4544-9F77-DCD1DBB05B64}). */
export type RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Filter template (ID: {DE3FA58E-EF9D-4544-9F77-DCD1DBB05B64}). */
export type RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Filter template (ID: {DE3FA58E-EF9D-4544-9F77-DCD1DBB05B64}). */
export type RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Filter template (ID: {DE3FA58E-EF9D-4544-9F77-DCD1DBB05B64}). */
export type RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/RadiusScheme template (ID: {5DA3844C-1111-422D-A5AD-FAEF2B22EF2E}). */
export type RadiusScheme = Item & {
  __typename?: 'RadiusScheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/RadiusScheme template (ID: {5DA3844C-1111-422D-A5AD-FAEF2B22EF2E}). */
export type RadiusSchemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/RadiusScheme template (ID: {5DA3844C-1111-422D-A5AD-FAEF2B22EF2E}). */
export type RadiusSchemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/RadiusScheme template (ID: {5DA3844C-1111-422D-A5AD-FAEF2B22EF2E}). */
export type RadiusSchemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/RadiusScheme template (ID: {5DA3844C-1111-422D-A5AD-FAEF2B22EF2E}). */
export type RadiusSchemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/RadiusScheme template (ID: {5DA3844C-1111-422D-A5AD-FAEF2B22EF2E}). */
export type RadiusSchemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/RadiusScheme template (ID: {5DA3844C-1111-422D-A5AD-FAEF2B22EF2E}). */
export type RadiusSchemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Scheme Value template (ID: {EA45C3AD-8E63-4E2A-BCC0-9E4C06F2AA12}). */
export type RadiusSchemeValue = Item & {
  __typename?: 'RadiusSchemeValue';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {6F0451F9-BF0E-4420-AD61-82BB14A257F9}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Value (ID: {4F892959-FDE6-4020-8569-2CF934BA412C}). */
  value?: Maybe<IntegerField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Scheme Value template (ID: {EA45C3AD-8E63-4E2A-BCC0-9E4C06F2AA12}). */
export type RadiusSchemeValueAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Scheme Value template (ID: {EA45C3AD-8E63-4E2A-BCC0-9E4C06F2AA12}). */
export type RadiusSchemeValueChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Scheme Value template (ID: {EA45C3AD-8E63-4E2A-BCC0-9E4C06F2AA12}). */
export type RadiusSchemeValueFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Scheme Value template (ID: {EA45C3AD-8E63-4E2A-BCC0-9E4C06F2AA12}). */
export type RadiusSchemeValueFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Scheme Value template (ID: {EA45C3AD-8E63-4E2A-BCC0-9E4C06F2AA12}). */
export type RadiusSchemeValueHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Radius Scheme Value template (ID: {EA45C3AD-8E63-4E2A-BCC0-9E4C06F2AA12}). */
export type RadiusSchemeValueIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Range Slider Filter template (ID: {4AC2EC48-5300-4F17-8319-12C350BC1771}). */
export type RangeSliderFilter = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & _SlidersRangeSettings & {
  __typename?: 'RangeSliderFilter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** ShowRangeIndicators (ID: {10D0D449-2D0B-440D-92D8-DD9237C7E36B}). */
  showRangeIndicators?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Range Slider Filter template (ID: {4AC2EC48-5300-4F17-8319-12C350BC1771}). */
export type RangeSliderFilterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Range Slider Filter template (ID: {4AC2EC48-5300-4F17-8319-12C350BC1771}). */
export type RangeSliderFilterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Range Slider Filter template (ID: {4AC2EC48-5300-4F17-8319-12C350BC1771}). */
export type RangeSliderFilterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Range Slider Filter template (ID: {4AC2EC48-5300-4F17-8319-12C350BC1771}). */
export type RangeSliderFilterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Range Slider Filter template (ID: {4AC2EC48-5300-4F17-8319-12C350BC1771}). */
export type RangeSliderFilterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Range Slider Filter template (ID: {4AC2EC48-5300-4F17-8319-12C350BC1771}). */
export type RangeSliderFilterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Range Slider Filter Folder template (ID: {7D431148-B2A1-452D-900F-7E36D864DF02}). */
export type RangeSliderFilterFolder = Item & {
  __typename?: 'RangeSliderFilterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Range Slider Filter Folder template (ID: {7D431148-B2A1-452D-900F-7E36D864DF02}). */
export type RangeSliderFilterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Range Slider Filter Folder template (ID: {7D431148-B2A1-452D-900F-7E36D864DF02}). */
export type RangeSliderFilterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Range Slider Filter Folder template (ID: {7D431148-B2A1-452D-900F-7E36D864DF02}). */
export type RangeSliderFilterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Range Slider Filter Folder template (ID: {7D431148-B2A1-452D-900F-7E36D864DF02}). */
export type RangeSliderFilterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Range Slider Filter Folder template (ID: {7D431148-B2A1-452D-900F-7E36D864DF02}). */
export type RangeSliderFilterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Range Slider Filter Folder template (ID: {7D431148-B2A1-452D-900F-7E36D864DF02}). */
export type RangeSliderFilterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Range Slider Filter template (ID: {0A1787C2-96B5-4D40-8285-22564A5D8E03}). */
export type RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = FacetSelectorConfigBase & Item & {
  __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** ChangeStep (ID: {928FA1B1-13BF-41E8-837E-D3D4EE505C0D}). */
  changeStep?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Facet (ID: {F1B4CEC1-36B7-4A29-8A14-E7034E70F036}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Format String (ID: {C9D34357-C9BF-471B-A742-957BD73168DB}). */
  formatString?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MaxRangeValue (ID: {525E680A-29AB-415F-AE0C-724941C506FA}). */
  maxRangeValue?: Maybe<TextField>;
  /** MinRangeValue (ID: {609D6909-8059-4E1B-98B6-AB7CC0FF77DF}). */
  minRangeValue?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Remove Filter Text (ID: {57008EBA-ACB7-4F86-A239-57C8027C2AFE}). */
  removeFilterText?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SelectedMaxValue (ID: {AFB416D9-8261-4614-837A-EE61E78F9E84}). */
  selectedMaxValue?: Maybe<TextField>;
  /** SelectedMinValue (ID: {E7055FF1-F28B-4516-9E67-4ADC1DE1AB28}). */
  selectedMinValue?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE2FB54E-10CB-4DEC-BF62-DFEB17D3CC7E}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Range Slider Filter template (ID: {0A1787C2-96B5-4D40-8285-22564A5D8E03}). */
export type RangeSliderFilter_0a1787c296b54d40828522564a5d8e03AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Range Slider Filter template (ID: {0A1787C2-96B5-4D40-8285-22564A5D8E03}). */
export type RangeSliderFilter_0a1787c296b54d40828522564a5d8e03ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Range Slider Filter template (ID: {0A1787C2-96B5-4D40-8285-22564A5D8E03}). */
export type RangeSliderFilter_0a1787c296b54d40828522564a5d8e03FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Range Slider Filter template (ID: {0A1787C2-96B5-4D40-8285-22564A5D8E03}). */
export type RangeSliderFilter_0a1787c296b54d40828522564a5d8e03FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Range Slider Filter template (ID: {0A1787C2-96B5-4D40-8285-22564A5D8E03}). */
export type RangeSliderFilter_0a1787c296b54d40828522564a5d8e03HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Range Slider Filter template (ID: {0A1787C2-96B5-4D40-8285-22564A5D8E03}). */
export type RangeSliderFilter_0a1787c296b54d40828522564a5d8e03IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Recent Articles/Recent Articles template (ID: {297FA908-7E34-4611-8BD1-0F5C32F32AC3}). */
export type RecentArticles = Item & _ContentType & {
  __typename?: 'RecentArticles';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** viewAll (ID: {0F2F071F-4A53-4A00-A4B4-C59C97D20626}). */
  viewAll?: Maybe<LinkField>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Recent Articles/Recent Articles template (ID: {297FA908-7E34-4611-8BD1-0F5C32F32AC3}). */
export type RecentArticlesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Recent Articles/Recent Articles template (ID: {297FA908-7E34-4611-8BD1-0F5C32F32AC3}). */
export type RecentArticlesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Recent Articles/Recent Articles template (ID: {297FA908-7E34-4611-8BD1-0F5C32F32AC3}). */
export type RecentArticlesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Recent Articles/Recent Articles template (ID: {297FA908-7E34-4611-8BD1-0F5C32F32AC3}). */
export type RecentArticlesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Recent Articles/Recent Articles template (ID: {297FA908-7E34-4611-8BD1-0F5C32F32AC3}). */
export type RecentArticlesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Recent Articles/Recent Articles template (ID: {297FA908-7E34-4611-8BD1-0F5C32F32AC3}). */
export type RecentArticlesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect template (ID: {C14B6289-8AC2-439C-9E5B-40DE9F820C3F}). */
export type Redirect = Item & {
  __typename?: 'Redirect';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** RedirectUrl (ID: {22753447-BE25-4035-A3C9-7F875AFE8E57}). */
  redirectUrl?: Maybe<LinkField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect template (ID: {C14B6289-8AC2-439C-9E5B-40DE9F820C3F}). */
export type RedirectAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect template (ID: {C14B6289-8AC2-439C-9E5B-40DE9F820C3F}). */
export type RedirectChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect template (ID: {C14B6289-8AC2-439C-9E5B-40DE9F820C3F}). */
export type RedirectFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect template (ID: {C14B6289-8AC2-439C-9E5B-40DE9F820C3F}). */
export type RedirectFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect template (ID: {C14B6289-8AC2-439C-9E5B-40DE9F820C3F}). */
export type RedirectHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect template (ID: {C14B6289-8AC2-439C-9E5B-40DE9F820C3F}). */
export type RedirectIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectInfo = {
  __typename?: 'RedirectInfo';
  /** Information about whether the language is preserved upon redirect. */
  isLanguagePreserved: Scalars['Boolean']['output'];
  /** Information about whether the query string is preserved upon redirect. */
  isQueryStringPreserved: Scalars['Boolean']['output'];
  /** Language name that should match request locale (used only for redirect items). */
  locale: Scalars['String']['output'];
  /** The pattern to get paths by and apply redirection to. */
  pattern: Scalars['String']['output'];
  /** Type of redirect ('REDIRECT_301', 'REDIRECT_302' or 'SERVER_TRANSFER'). */
  redirectType: RedirectType;
  /** The path to redirect to. */
  target: Scalars['String']['output'];
};

/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map template (ID: {F4FB6125-F113-4373-8AA2-4648C2C1960E}). */
export type RedirectMap = Item & {
  __typename?: 'RedirectMap';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IncludeVirtualFolder (ID: {BF5B4F11-4995-4EDF-B8DB-F436A503E02E}). */
  includeVirtualFolder?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PreserveLanguage (ID: {D3319168-3CFF-431E-B3FB-D6A9C0D574A3}). */
  preserveLanguage?: Maybe<CheckboxField>;
  /** PreserveQueryString (ID: {F24D347E-98C2-4995-A14C-B15697BA86E5}). */
  preserveQueryString?: Maybe<CheckboxField>;
  /** RedirectType (ID: {980DFA07-41D4-4C4E-AB28-DE657AFDB6BC}). */
  redirectType?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UrlMapping (ID: {5ECFFFC9-D530-4512-B757-9E9830F07D5A}). */
  urlMapping?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map template (ID: {F4FB6125-F113-4373-8AA2-4648C2C1960E}). */
export type RedirectMapAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map template (ID: {F4FB6125-F113-4373-8AA2-4648C2C1960E}). */
export type RedirectMapChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map template (ID: {F4FB6125-F113-4373-8AA2-4648C2C1960E}). */
export type RedirectMapFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map template (ID: {F4FB6125-F113-4373-8AA2-4648C2C1960E}). */
export type RedirectMapFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map template (ID: {F4FB6125-F113-4373-8AA2-4648C2C1960E}). */
export type RedirectMapHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Map template (ID: {F4FB6125-F113-4373-8AA2-4648C2C1960E}). */
export type RedirectMapIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Maps template (ID: {C2DC4690-AF44-48C7-BB21-90D1AD246732}). */
export type RedirectMaps = Item & _SharedRoot & {
  __typename?: 'RedirectMaps';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Maps template (ID: {C2DC4690-AF44-48C7-BB21-90D1AD246732}). */
export type RedirectMapsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Maps template (ID: {C2DC4690-AF44-48C7-BB21-90D1AD246732}). */
export type RedirectMapsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Maps template (ID: {C2DC4690-AF44-48C7-BB21-90D1AD246732}). */
export type RedirectMapsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Maps template (ID: {C2DC4690-AF44-48C7-BB21-90D1AD246732}). */
export type RedirectMapsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Maps template (ID: {C2DC4690-AF44-48C7-BB21-90D1AD246732}). */
export type RedirectMapsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Redirects/Redirect Maps template (ID: {C2DC4690-AF44-48C7-BB21-90D1AD246732}). */
export type RedirectMapsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum RedirectType {
  Redirect_301 = 'REDIRECT_301',
  Redirect_302 = 'REDIRECT_302',
  ServerTransfer = 'SERVER_TRANSFER'
}

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Region template (ID: {2B7277E9-0B7F-456A-9CF4-C4F3641FE9B4}). */
export type Region = Item & {
  __typename?: 'Region';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {B7BFEAB3-3EDC-439D-B80A-C1DF24E4E504}). */
  name_b7bfeab33edc439db80ac1df24e4e504?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Region template (ID: {2B7277E9-0B7F-456A-9CF4-C4F3641FE9B4}). */
export type RegionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Region template (ID: {2B7277E9-0B7F-456A-9CF4-C4F3641FE9B4}). */
export type RegionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Region template (ID: {2B7277E9-0B7F-456A-9CF4-C4F3641FE9B4}). */
export type RegionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Region template (ID: {2B7277E9-0B7F-456A-9CF4-C4F3641FE9B4}). */
export type RegionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Region template (ID: {2B7277E9-0B7F-456A-9CF4-C4F3641FE9B4}). */
export type RegionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Global Language Selector/Region template (ID: {2B7277E9-0B7F-456A-9CF4-C4F3641FE9B4}). */
export type RegionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages template (ID: {FF71F40B-2F34-4EC5-BA2C-5095AE711BEB}). */
export type RegionLanguages = Item & {
  __typename?: 'RegionLanguages';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** regionLanguages (ID: {D71ECC27-B5E8-4D84-AEE2-785CF097C910}). */
  regionLanguages?: Maybe<MultilistField>;
  /** Set code for current region (ex. CA - Canada) */
  regionName?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages template (ID: {FF71F40B-2F34-4EC5-BA2C-5095AE711BEB}). */
export type RegionLanguagesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages template (ID: {FF71F40B-2F34-4EC5-BA2C-5095AE711BEB}). */
export type RegionLanguagesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages template (ID: {FF71F40B-2F34-4EC5-BA2C-5095AE711BEB}). */
export type RegionLanguagesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages template (ID: {FF71F40B-2F34-4EC5-BA2C-5095AE711BEB}). */
export type RegionLanguagesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages template (ID: {FF71F40B-2F34-4EC5-BA2C-5095AE711BEB}). */
export type RegionLanguagesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages template (ID: {FF71F40B-2F34-4EC5-BA2C-5095AE711BEB}). */
export type RegionLanguagesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages Folder template (ID: {249E810E-91BD-4722-BD4A-80A8EAF6DF73}). */
export type RegionLanguagesFolder = Item & {
  __typename?: 'RegionLanguagesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages Folder template (ID: {249E810E-91BD-4722-BD4A-80A8EAF6DF73}). */
export type RegionLanguagesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages Folder template (ID: {249E810E-91BD-4722-BD4A-80A8EAF6DF73}). */
export type RegionLanguagesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages Folder template (ID: {249E810E-91BD-4722-BD4A-80A8EAF6DF73}). */
export type RegionLanguagesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages Folder template (ID: {249E810E-91BD-4722-BD4A-80A8EAF6DF73}). */
export type RegionLanguagesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages Folder template (ID: {249E810E-91BD-4722-BD4A-80A8EAF6DF73}). */
export type RegionLanguagesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Language Selector/Region Languages Folder template (ID: {249E810E-91BD-4722-BD4A-80A8EAF6DF73}). */
export type RegionLanguagesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Related Articles/Related Articles template (ID: {0CDCFF6D-B46A-49B7-A1E9-570CB9A34C86}). */
export type RelatedArticles = Item & {
  __typename?: 'RelatedArticles';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleCapabilities (ID: {F2F4C135-C8B2-40D7-9CF0-B0C3C9465359}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategories (ID: {457479E3-4599-42A6-9BB2-BEE91E56C1DE}). */
  articleCategories?: Maybe<MultilistField>;
  /** articleTags (ID: {23E74A1B-65F1-4A41-8893-0296F177F1C4}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {67110BBC-3362-4F31-B498-19137D4E8FEB}). */
  articleThemes?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If selected, filter will include articles where Limited Display property matches selected value. */
  limitedDisplay?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Related Articles/Related Articles template (ID: {0CDCFF6D-B46A-49B7-A1E9-570CB9A34C86}). */
export type RelatedArticlesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Related Articles/Related Articles template (ID: {0CDCFF6D-B46A-49B7-A1E9-570CB9A34C86}). */
export type RelatedArticlesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Related Articles/Related Articles template (ID: {0CDCFF6D-B46A-49B7-A1E9-570CB9A34C86}). */
export type RelatedArticlesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Related Articles/Related Articles template (ID: {0CDCFF6D-B46A-49B7-A1E9-570CB9A34C86}). */
export type RelatedArticlesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Related Articles/Related Articles template (ID: {0CDCFF6D-B46A-49B7-A1E9-570CB9A34C86}). */
export type RelatedArticlesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Related Articles/Related Articles template (ID: {0CDCFF6D-B46A-49B7-A1E9-570CB9A34C86}). */
export type RelatedArticlesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Related Articles Parameters Template template (ID: {D5A23E69-0C22-4BD2-B0FC-2F5F7B18993D}). */
export type RelatedArticlesParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'RelatedArticlesParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {9A660C55-2191-4B3B-80F6-450153B9956E}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Related Articles Parameters Template template (ID: {D5A23E69-0C22-4BD2-B0FC-2F5F7B18993D}). */
export type RelatedArticlesParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Related Articles Parameters Template template (ID: {D5A23E69-0C22-4BD2-B0FC-2F5F7B18993D}). */
export type RelatedArticlesParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Related Articles Parameters Template template (ID: {D5A23E69-0C22-4BD2-B0FC-2F5F7B18993D}). */
export type RelatedArticlesParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Related Articles Parameters Template template (ID: {D5A23E69-0C22-4BD2-B0FC-2F5F7B18993D}). */
export type RelatedArticlesParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Related Articles Parameters Template template (ID: {D5A23E69-0C22-4BD2-B0FC-2F5F7B18993D}). */
export type RelatedArticlesParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Related Articles Parameters Template template (ID: {D5A23E69-0C22-4BD2-B0FC-2F5F7B18993D}). */
export type RelatedArticlesParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JavaScript Services/Render Engine Type template (ID: {7FEC3963-0AC6-4743-B02C-35E6971300ED}). */
export type RenderEngineType = Item & {
  __typename?: 'RenderEngineType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Engine Type Name (ID: {90C6AAF1-9962-4DC9-A730-5E5952B3AE51}). */
  engineTypeName?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Render Engine Type template (ID: {7FEC3963-0AC6-4743-B02C-35E6971300ED}). */
export type RenderEngineTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Render Engine Type template (ID: {7FEC3963-0AC6-4743-B02C-35E6971300ED}). */
export type RenderEngineTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Render Engine Type template (ID: {7FEC3963-0AC6-4743-B02C-35E6971300ED}). */
export type RenderEngineTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JavaScript Services/Render Engine Type template (ID: {7FEC3963-0AC6-4743-B02C-35E6971300ED}). */
export type RenderEngineTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Render Engine Type template (ID: {7FEC3963-0AC6-4743-B02C-35E6971300ED}). */
export type RenderEngineTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JavaScript Services/Render Engine Type template (ID: {7FEC3963-0AC6-4743-B02C-35E6971300ED}). */
export type RenderEngineTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Rendering Folder template (ID: {840D4A46-5503-49EC-BF9D-BD090946C63D}). */
export type RenderingFolder_840d4a46550349ecbf9dbd090946c63d = Item & {
  __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Rendering Folder template (ID: {840D4A46-5503-49EC-BF9D-BD090946C63D}). */
export type RenderingFolder_840d4a46550349ecbf9dbd090946c63dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Rendering Folder template (ID: {840D4A46-5503-49EC-BF9D-BD090946C63D}). */
export type RenderingFolder_840d4a46550349ecbf9dbd090946c63dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Rendering Folder template (ID: {840D4A46-5503-49EC-BF9D-BD090946C63D}). */
export type RenderingFolder_840d4a46550349ecbf9dbd090946c63dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Rendering Folder template (ID: {840D4A46-5503-49EC-BF9D-BD090946C63D}). */
export type RenderingFolder_840d4a46550349ecbf9dbd090946c63dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Rendering Folder template (ID: {840D4A46-5503-49EC-BF9D-BD090946C63D}). */
export type RenderingFolder_840d4a46550349ecbf9dbd090946c63dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Rendering Folder template (ID: {840D4A46-5503-49EC-BF9D-BD090946C63D}). */
export type RenderingFolder_840d4a46550349ecbf9dbd090946c63dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/RenderingHost template (ID: {BC71D442-3E4F-46BA-887C-746E54F9BB83}). */
export type RenderingHost = Item & {
  __typename?: 'RenderingHost';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Application name (ID: {3121C257-53CF-464A-B736-98B418876057}). */
  appName?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Server side rendering engine application URL (ID: {E32C1801-79B3-4FC1-A9C4-3C6E6C2968AE}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** Server side rendering engine configuration URL (ID: {94470B31-E282-4D8D-BC54-85689EFB294C}). */
  serverSideRenderingEngineConfigUrl?: Maybe<TextField>;
  /** Server side rendering engine endpoint URL (ID: {FC76919B-0D7C-4732-865D-2AF795FB38A4}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/RenderingHost template (ID: {BC71D442-3E4F-46BA-887C-746E54F9BB83}). */
export type RenderingHostAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/RenderingHost template (ID: {BC71D442-3E4F-46BA-887C-746E54F9BB83}). */
export type RenderingHostChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/RenderingHost template (ID: {BC71D442-3E4F-46BA-887C-746E54F9BB83}). */
export type RenderingHostFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/RenderingHost template (ID: {BC71D442-3E4F-46BA-887C-746E54F9BB83}). */
export type RenderingHostFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/RenderingHost template (ID: {BC71D442-3E4F-46BA-887C-746E54F9BB83}). */
export type RenderingHostHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/RenderingHost template (ID: {BC71D442-3E4F-46BA-887C-746E54F9BB83}). */
export type RenderingHostIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Layout/Sections/Rendering Options template (ID: {D1592226-3898-4CE2-B190-090FD5F84A4C}). Also implements ExtendedOptions, ExtendedOptions_f1850030f97848b4bdb5884b7e863160, ExtendedOptions_2964fb4257a6440fb192218443904c90. */
export type RenderingOptions = {
  /** Additional compatible templates (ID: {F6677A49-0A1D-4BAD-B8BA-4F0F22BDEE64}). */
  additionalCompatibleTemplates?: Maybe<MultilistField>;
  /** AllowedOnTemplates (ID: {1B58D065-FE74-43E3-BA20-54C9588B3011}). */
  allowedOnTemplates?: Maybe<MultilistField>;
  /** Can select Page as a data source (ID: {A3411FF6-C978-40AA-B059-A49B9CA2209B}). */
  canSelectPageAsADataSource?: Maybe<CheckboxField>;
  /** Compatible Renderings (ID: {E441ABE7-2CA3-4640-AE26-3789967925D7}). */
  compatibleRenderings?: Maybe<MultilistField>;
  /** Datasource Location (ID: {B5B27AF1-25EF-405C-87CE-369B3A004016}). */
  datasourceLocation?: Maybe<TextField>;
  /** Datasource Template (ID: {1A7C85E5-DC0B-490D-9187-BB1DBCB4C72F}). */
  datasourceTemplate?: Maybe<TextField>;
  /** Editable (ID: {308E88F5-CD6E-4F8F-BAFE-95A47DEDEFDC}). */
  editable?: Maybe<CheckboxField>;
  /** Enable Datasource Query (ID: {F172B787-7B88-4BD5-AE4D-6308E102EF11}). */
  enableDatasourceQuery?: Maybe<CheckboxField>;
  /** OtherProperties (ID: {E829C217-5E94-4306-9C48-2634B094FDC2}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Page Editor Buttons (ID: {A2F5D9DF-8CBA-4A1D-99EB-51ACB94CB057}). */
  pageEditorButtons?: Maybe<MultilistField>;
  /** Placeholders (ID: {069A8361-B1CD-437C-8C32-A3BE78941446}). */
  placeholders?: Maybe<MultilistField>;
  /** Render as HTML (ID: {BBB8A1E0-F966-4710-B4F4-42F267598127}). */
  renderAsHTML?: Maybe<CheckboxField>;
  /** Rendering Contents Resolver (ID: {B0B15510-B138-470E-8F33-8DA2E228AAFE}). */
  renderingContentsResolver?: Maybe<LookupField>;
  /** RenderingCssClass (ID: {34E81E40-1D4D-45B0-BCF1-A0FFE5521685}). */
  renderingCssClass?: Maybe<TextField>;
  /** RenderingViewPath (ID: {49B9D6C5-9551-4BA4-840E-74D5582256C0}). */
  renderingViewPath?: Maybe<TextField>;
};

/** /sitecore/templates/Project/Personal/Pages/Resizable IFrame Page template (ID: {3ED432EA-A0B3-42DB-90C3-75795431FBF7}). */
export type ResizableIFramePage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ResizableIFramePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Resizable IFrame Page template (ID: {3ED432EA-A0B3-42DB-90C3-75795431FBF7}). */
export type ResizableIFramePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Resizable IFrame Page template (ID: {3ED432EA-A0B3-42DB-90C3-75795431FBF7}). */
export type ResizableIFramePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Resizable IFrame Page template (ID: {3ED432EA-A0B3-42DB-90C3-75795431FBF7}). */
export type ResizableIFramePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Resizable IFrame Page template (ID: {3ED432EA-A0B3-42DB-90C3-75795431FBF7}). */
export type ResizableIFramePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Resizable IFrame Page template (ID: {3ED432EA-A0B3-42DB-90C3-75795431FBF7}). */
export type ResizableIFramePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Resizable IFrame Page template (ID: {3ED432EA-A0B3-42DB-90C3-75795431FBF7}). */
export type ResizableIFramePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Resizable IFrame Page template (ID: {8AB2AE10-6350-452C-A0E7-B06D6D859067}). */
export type ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Resizable IFrame Page template (ID: {8AB2AE10-6350-452C-A0E7-B06D6D859067}). */
export type ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Resizable IFrame Page template (ID: {8AB2AE10-6350-452C-A0E7-B06D6D859067}). */
export type ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Resizable IFrame Page template (ID: {8AB2AE10-6350-452C-A0E7-B06D6D859067}). */
export type ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Resizable IFrame Page template (ID: {8AB2AE10-6350-452C-A0E7-B06D6D859067}). */
export type ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Resizable IFrame Page template (ID: {8AB2AE10-6350-452C-A0E7-B06D6D859067}). */
export type ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Resizable IFrame Page template (ID: {8AB2AE10-6350-452C-A0E7-B06D6D859067}). */
export type ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Resizable IFrame Page template (ID: {92674815-F3F7-4A87-9C08-74BCB72C9B68}). */
export type ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Resizable IFrame Page template (ID: {92674815-F3F7-4A87-9C08-74BCB72C9B68}). */
export type ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Resizable IFrame Page template (ID: {92674815-F3F7-4A87-9C08-74BCB72C9B68}). */
export type ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Resizable IFrame Page template (ID: {92674815-F3F7-4A87-9C08-74BCB72C9B68}). */
export type ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Resizable IFrame Page template (ID: {92674815-F3F7-4A87-9C08-74BCB72C9B68}). */
export type ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Resizable IFrame Page template (ID: {92674815-F3F7-4A87-9C08-74BCB72C9B68}). */
export type ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Resizable IFrame Page template (ID: {92674815-F3F7-4A87-9C08-74BCB72C9B68}). */
export type ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Resizable IFrame Page template (ID: {B58EACFB-27F5-417B-B536-141F94B92521}). */
export type ResizableIFramePage_B58eacfb27f5417bb536141f94b92521 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Resizable IFrame Page template (ID: {B58EACFB-27F5-417B-B536-141F94B92521}). */
export type ResizableIFramePage_B58eacfb27f5417bb536141f94b92521AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Resizable IFrame Page template (ID: {B58EACFB-27F5-417B-B536-141F94B92521}). */
export type ResizableIFramePage_B58eacfb27f5417bb536141f94b92521ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Resizable IFrame Page template (ID: {B58EACFB-27F5-417B-B536-141F94B92521}). */
export type ResizableIFramePage_B58eacfb27f5417bb536141f94b92521FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Resizable IFrame Page template (ID: {B58EACFB-27F5-417B-B536-141F94B92521}). */
export type ResizableIFramePage_B58eacfb27f5417bb536141f94b92521FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Resizable IFrame Page template (ID: {B58EACFB-27F5-417B-B536-141F94B92521}). */
export type ResizableIFramePage_B58eacfb27f5417bb536141f94b92521HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Resizable IFrame Page template (ID: {B58EACFB-27F5-417B-B536-141F94B92521}). */
export type ResizableIFramePage_B58eacfb27f5417bb536141f94b92521IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Resizable IFrame Page template (ID: {D8D76A24-0708-4147-BF39-00CD5E12E401}). */
export type ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Resizable IFrame Page template (ID: {D8D76A24-0708-4147-BF39-00CD5E12E401}). */
export type ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Resizable IFrame Page template (ID: {D8D76A24-0708-4147-BF39-00CD5E12E401}). */
export type ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Resizable IFrame Page template (ID: {D8D76A24-0708-4147-BF39-00CD5E12E401}). */
export type ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Resizable IFrame Page template (ID: {D8D76A24-0708-4147-BF39-00CD5E12E401}). */
export type ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Resizable IFrame Page template (ID: {D8D76A24-0708-4147-BF39-00CD5E12E401}). */
export type ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Resizable IFrame Page template (ID: {D8D76A24-0708-4147-BF39-00CD5E12E401}). */
export type ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Resizable IFrame Page template (ID: {F460AB05-5585-4418-9202-3750E7CEF6B7}). */
export type ResizableIFramePage_F460ab055585441892023750e7cef6b7 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Resizable IFrame Page template (ID: {F460AB05-5585-4418-9202-3750E7CEF6B7}). */
export type ResizableIFramePage_F460ab055585441892023750e7cef6b7AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Resizable IFrame Page template (ID: {F460AB05-5585-4418-9202-3750E7CEF6B7}). */
export type ResizableIFramePage_F460ab055585441892023750e7cef6b7ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Resizable IFrame Page template (ID: {F460AB05-5585-4418-9202-3750E7CEF6B7}). */
export type ResizableIFramePage_F460ab055585441892023750e7cef6b7FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Resizable IFrame Page template (ID: {F460AB05-5585-4418-9202-3750E7CEF6B7}). */
export type ResizableIFramePage_F460ab055585441892023750e7cef6b7FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Resizable IFrame Page template (ID: {F460AB05-5585-4418-9202-3750E7CEF6B7}). */
export type ResizableIFramePage_F460ab055585441892023750e7cef6b7HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Resizable IFrame Page template (ID: {F460AB05-5585-4418-9202-3750E7CEF6B7}). */
export type ResizableIFramePage_F460ab055585441892023750e7cef6b7IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Responsive Image template (ID: {070A64FA-5F1B-40CC-83CB-3CE05D1895FC}). */
export type ResponsiveImage = BaseVariantField & Item & _DataAttributes & {
  __typename?: 'ResponsiveImage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CssClass (ID: {67735953-1DDD-4B23-92DF-7D68263961C9}). */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /**
   * Determines the default size of a responsive image.
   * Used to generate responsive image syntax
   */
  defaultSize?: Maybe<IntegerField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MWidths (ID: {23A32CA5-1169-4FB5-8624-C1090341A25D}). */
  mWidths?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /**
   * Defines media conditions for a responsive image and indicates what image size would be best to choose.
   * Used to generate responsive image syntax
   */
  sizes?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /**
   * Determines available widths for a responsive image.
   * Used to generate responsive image syntax.
   */
  widths?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Responsive Image template (ID: {070A64FA-5F1B-40CC-83CB-3CE05D1895FC}). */
export type ResponsiveImageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Responsive Image template (ID: {070A64FA-5F1B-40CC-83CB-3CE05D1895FC}). */
export type ResponsiveImageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Responsive Image template (ID: {070A64FA-5F1B-40CC-83CB-3CE05D1895FC}). */
export type ResponsiveImageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Responsive Image template (ID: {070A64FA-5F1B-40CC-83CB-3CE05D1895FC}). */
export type ResponsiveImageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Responsive Image template (ID: {070A64FA-5F1B-40CC-83CB-3CE05D1895FC}). */
export type ResponsiveImageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Responsive Image template (ID: {070A64FA-5F1B-40CC-83CB-3CE05D1895FC}). */
export type ResponsiveImageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Count template (ID: {FD4E7B99-D862-489E-AEEA-01FA7D4C5E30}). */
export type ResultsCount = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'ResultsCount';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Count template (ID: {FD4E7B99-D862-489E-AEEA-01FA7D4C5E30}). */
export type ResultsCountAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Count template (ID: {FD4E7B99-D862-489E-AEEA-01FA7D4C5E30}). */
export type ResultsCountChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Count template (ID: {FD4E7B99-D862-489E-AEEA-01FA7D4C5E30}). */
export type ResultsCountFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Count template (ID: {FD4E7B99-D862-489E-AEEA-01FA7D4C5E30}). */
export type ResultsCountFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Count template (ID: {FD4E7B99-D862-489E-AEEA-01FA7D4C5E30}). */
export type ResultsCountHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Count template (ID: {FD4E7B99-D862-489E-AEEA-01FA7D4C5E30}). */
export type ResultsCountIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Results Count Folder template (ID: {D873C6E4-52B6-408B-B44B-A27B67E5DAF9}). */
export type ResultsCountFolder = Item & {
  __typename?: 'ResultsCountFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Results Count Folder template (ID: {D873C6E4-52B6-408B-B44B-A27B67E5DAF9}). */
export type ResultsCountFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Results Count Folder template (ID: {D873C6E4-52B6-408B-B44B-A27B67E5DAF9}). */
export type ResultsCountFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Results Count Folder template (ID: {D873C6E4-52B6-408B-B44B-A27B67E5DAF9}). */
export type ResultsCountFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Results Count Folder template (ID: {D873C6E4-52B6-408B-B44B-A27B67E5DAF9}). */
export type ResultsCountFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Results Count Folder template (ID: {D873C6E4-52B6-408B-B44B-A27B67E5DAF9}). */
export type ResultsCountFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Results Count Folder template (ID: {D873C6E4-52B6-408B-B44B-A27B67E5DAF9}). */
export type ResultsCountFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Results Count template (ID: {F3C0661E-F9A9-444C-A26D-44BF2A68A186}). */
export type ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186 = Item & {
  __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Results Count Text (ID: {04DBBAAF-675A-4324-AEBD-9B32D2D8D7D3}). */
  resultsCountText?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Results Count template (ID: {F3C0661E-F9A9-444C-A26D-44BF2A68A186}). */
export type ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Results Count template (ID: {F3C0661E-F9A9-444C-A26D-44BF2A68A186}). */
export type ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Results Count template (ID: {F3C0661E-F9A9-444C-A26D-44BF2A68A186}). */
export type ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Results Count template (ID: {F3C0661E-F9A9-444C-A26D-44BF2A68A186}). */
export type ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Results Count template (ID: {F3C0661E-F9A9-444C-A26D-44BF2A68A186}). */
export type ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Results Count template (ID: {F3C0661E-F9A9-444C-A26D-44BF2A68A186}). */
export type ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Variant Selector template (ID: {45CA023A-9441-4DF0-B1B5-583CA4BC09C1}). */
export type ResultsVariantSelector = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'ResultsVariantSelector';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AvailableVariants (ID: {AAFC5448-B00F-4942-8002-6F53F21A304D}). */
  availableVariants?: Maybe<MultilistField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Variant Selector template (ID: {45CA023A-9441-4DF0-B1B5-583CA4BC09C1}). */
export type ResultsVariantSelectorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Variant Selector template (ID: {45CA023A-9441-4DF0-B1B5-583CA4BC09C1}). */
export type ResultsVariantSelectorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Variant Selector template (ID: {45CA023A-9441-4DF0-B1B5-583CA4BC09C1}). */
export type ResultsVariantSelectorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Variant Selector template (ID: {45CA023A-9441-4DF0-B1B5-583CA4BC09C1}). */
export type ResultsVariantSelectorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Variant Selector template (ID: {45CA023A-9441-4DF0-B1B5-583CA4BC09C1}). */
export type ResultsVariantSelectorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Results Variant Selector template (ID: {45CA023A-9441-4DF0-B1B5-583CA4BC09C1}). */
export type ResultsVariantSelectorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {E8091CB4-7D93-4AE8-BA34-B4B61D8B9A7D}). */
export type RichText = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'RichText';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {E8091CB4-7D93-4AE8-BA34-B4B61D8B9A7D}). */
export type RichTextAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {E8091CB4-7D93-4AE8-BA34-B4B61D8B9A7D}). */
export type RichTextChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {E8091CB4-7D93-4AE8-BA34-B4B61D8B9A7D}). */
export type RichTextFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {E8091CB4-7D93-4AE8-BA34-B4B61D8B9A7D}). */
export type RichTextFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {E8091CB4-7D93-4AE8-BA34-B4B61D8B9A7D}). */
export type RichTextHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {E8091CB4-7D93-4AE8-BA34-B4B61D8B9A7D}). */
export type RichTextIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type RichTextField = ItemField & {
  __typename?: 'RichTextField';
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type RichTextFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text Folder template (ID: {A6CE487D-DE59-41C7-8319-50674E909204}). */
export type RichTextFolder = Item & {
  __typename?: 'RichTextFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text Folder template (ID: {A6CE487D-DE59-41C7-8319-50674E909204}). */
export type RichTextFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text Folder template (ID: {A6CE487D-DE59-41C7-8319-50674E909204}). */
export type RichTextFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text Folder template (ID: {A6CE487D-DE59-41C7-8319-50674E909204}). */
export type RichTextFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text Folder template (ID: {A6CE487D-DE59-41C7-8319-50674E909204}). */
export type RichTextFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text Folder template (ID: {A6CE487D-DE59-41C7-8319-50674E909204}). */
export type RichTextFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text Folder template (ID: {A6CE487D-DE59-41C7-8319-50674E909204}). */
export type RichTextFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {0F3B7336-6112-418C-8BBA-B0526F3887CE}). */
export type RichText_0f3b73366112418c8bbab0526f3887ce = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {0F3B7336-6112-418C-8BBA-B0526F3887CE}). */
export type RichText_0f3b73366112418c8bbab0526f3887ceAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {0F3B7336-6112-418C-8BBA-B0526F3887CE}). */
export type RichText_0f3b73366112418c8bbab0526f3887ceChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {0F3B7336-6112-418C-8BBA-B0526F3887CE}). */
export type RichText_0f3b73366112418c8bbab0526f3887ceFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {0F3B7336-6112-418C-8BBA-B0526F3887CE}). */
export type RichText_0f3b73366112418c8bbab0526f3887ceFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {0F3B7336-6112-418C-8BBA-B0526F3887CE}). */
export type RichText_0f3b73366112418c8bbab0526f3887ceHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Rich Text template (ID: {0F3B7336-6112-418C-8BBA-B0526F3887CE}). */
export type RichText_0f3b73366112418c8bbab0526f3887ceIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text template (ID: {EFCFD8F6-5967-45F4-8F85-B5421928205D}). */
export type RichText_Efcfd8f6596745f48f85b5421928205d = Item & {
  __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {58E5A007-E51C-482F-AAD3-02553C882F77}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text template (ID: {EFCFD8F6-5967-45F4-8F85-B5421928205D}). */
export type RichText_Efcfd8f6596745f48f85b5421928205dAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text template (ID: {EFCFD8F6-5967-45F4-8F85-B5421928205D}). */
export type RichText_Efcfd8f6596745f48f85b5421928205dChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text template (ID: {EFCFD8F6-5967-45F4-8F85-B5421928205D}). */
export type RichText_Efcfd8f6596745f48f85b5421928205dFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text template (ID: {EFCFD8F6-5967-45F4-8F85-B5421928205D}). */
export type RichText_Efcfd8f6596745f48f85b5421928205dFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text template (ID: {EFCFD8F6-5967-45F4-8F85-B5421928205D}). */
export type RichText_Efcfd8f6596745f48f85b5421928205dHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Datasource/Rich Text/Rich Text template (ID: {EFCFD8F6-5967-45F4-8F85-B5421928205D}). */
export type RichText_Efcfd8f6596745f48f85b5421928205dIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mapping template (ID: {30F63F88-0745-4E9B-8202-8DFB67E8F84D}). */
export type RiskImageMapping = Item & {
  __typename?: 'RiskImageMapping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {FD2A38AC-C1E8-4BF6-BCBA-9FF31CA08360}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** riskLevel (ID: {32B36582-DAB3-46A2-AAC4-9D65197854E7}). */
  riskLevel?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mapping template (ID: {30F63F88-0745-4E9B-8202-8DFB67E8F84D}). */
export type RiskImageMappingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mapping template (ID: {30F63F88-0745-4E9B-8202-8DFB67E8F84D}). */
export type RiskImageMappingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mapping template (ID: {30F63F88-0745-4E9B-8202-8DFB67E8F84D}). */
export type RiskImageMappingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mapping template (ID: {30F63F88-0745-4E9B-8202-8DFB67E8F84D}). */
export type RiskImageMappingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mapping template (ID: {30F63F88-0745-4E9B-8202-8DFB67E8F84D}). */
export type RiskImageMappingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mapping template (ID: {30F63F88-0745-4E9B-8202-8DFB67E8F84D}). */
export type RiskImageMappingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mappings template (ID: {B4B22AB1-13D0-49C9-855B-5823FBF12151}). */
export type RiskImageMappings = Item & {
  __typename?: 'RiskImageMappings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mappings template (ID: {B4B22AB1-13D0-49C9-855B-5823FBF12151}). */
export type RiskImageMappingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mappings template (ID: {B4B22AB1-13D0-49C9-855B-5823FBF12151}). */
export type RiskImageMappingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mappings template (ID: {B4B22AB1-13D0-49C9-855B-5823FBF12151}). */
export type RiskImageMappingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mappings template (ID: {B4B22AB1-13D0-49C9-855B-5823FBF12151}). */
export type RiskImageMappingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mappings template (ID: {B4B22AB1-13D0-49C9-855B-5823FBF12151}). */
export type RiskImageMappingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Image Mappings/Risk Image Mappings template (ID: {B4B22AB1-13D0-49C9-855B-5823FBF12151}). */
export type RiskImageMappingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option template (ID: {627C0438-1E04-4CF7-8E84-79E98CE5D4BC}). */
export type RiskLevelOption = Item & {
  __typename?: 'RiskLevelOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option template (ID: {627C0438-1E04-4CF7-8E84-79E98CE5D4BC}). */
export type RiskLevelOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option template (ID: {627C0438-1E04-4CF7-8E84-79E98CE5D4BC}). */
export type RiskLevelOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option template (ID: {627C0438-1E04-4CF7-8E84-79E98CE5D4BC}). */
export type RiskLevelOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option template (ID: {627C0438-1E04-4CF7-8E84-79E98CE5D4BC}). */
export type RiskLevelOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option template (ID: {627C0438-1E04-4CF7-8E84-79E98CE5D4BC}). */
export type RiskLevelOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option template (ID: {627C0438-1E04-4CF7-8E84-79E98CE5D4BC}). */
export type RiskLevelOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option Folder template (ID: {8DCA6C5D-341B-429A-9CCD-5A573DCE34CE}). */
export type RiskLevelOptionFolder = Item & {
  __typename?: 'RiskLevelOptionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option Folder template (ID: {8DCA6C5D-341B-429A-9CCD-5A573DCE34CE}). */
export type RiskLevelOptionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option Folder template (ID: {8DCA6C5D-341B-429A-9CCD-5A573DCE34CE}). */
export type RiskLevelOptionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option Folder template (ID: {8DCA6C5D-341B-429A-9CCD-5A573DCE34CE}). */
export type RiskLevelOptionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option Folder template (ID: {8DCA6C5D-341B-429A-9CCD-5A573DCE34CE}). */
export type RiskLevelOptionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option Folder template (ID: {8DCA6C5D-341B-429A-9CCD-5A573DCE34CE}). */
export type RiskLevelOptionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Risk Level/Risk Level Option Folder template (ID: {8DCA6C5D-341B-429A-9CCD-5A573DCE34CE}). */
export type RiskLevelOptionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning template (ID: {819936AB-5DDE-4F53-B447-313A3D9917AF}). */
export type RiskWarning = Item & {
  __typename?: 'RiskWarning';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {F3DEE3C4-446B-4333-9EB3-9BD5D7219ABD}). */
  description?: Maybe<TextField>;
  /** descriptionExtra (ID: {8B76BA11-F536-48B1-821F-5D5E9808D7B6}). */
  descriptionExtra?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {97EEDE9B-007B-4093-A357-0E07D7E0593F}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {5240A3D7-452E-41DD-A0E9-88E2ABDA9F30}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning template (ID: {819936AB-5DDE-4F53-B447-313A3D9917AF}). */
export type RiskWarningAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning template (ID: {819936AB-5DDE-4F53-B447-313A3D9917AF}). */
export type RiskWarningChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning template (ID: {819936AB-5DDE-4F53-B447-313A3D9917AF}). */
export type RiskWarningFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning template (ID: {819936AB-5DDE-4F53-B447-313A3D9917AF}). */
export type RiskWarningFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning template (ID: {819936AB-5DDE-4F53-B447-313A3D9917AF}). */
export type RiskWarningHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning template (ID: {819936AB-5DDE-4F53-B447-313A3D9917AF}). */
export type RiskWarningIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning Folder template (ID: {C78D1745-56F0-40E7-9004-CAA5A1DC4065}). */
export type RiskWarningFolder = Item & {
  __typename?: 'RiskWarningFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning Folder template (ID: {C78D1745-56F0-40E7-9004-CAA5A1DC4065}). */
export type RiskWarningFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning Folder template (ID: {C78D1745-56F0-40E7-9004-CAA5A1DC4065}). */
export type RiskWarningFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning Folder template (ID: {C78D1745-56F0-40E7-9004-CAA5A1DC4065}). */
export type RiskWarningFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning Folder template (ID: {C78D1745-56F0-40E7-9004-CAA5A1DC4065}). */
export type RiskWarningFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning Folder template (ID: {C78D1745-56F0-40E7-9004-CAA5A1DC4065}). */
export type RiskWarningFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Risk Warning/Risk Warning Folder template (ID: {C78D1745-56F0-40E7-9004-CAA5A1DC4065}). */
export type RiskWarningFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Risk Warning Parameters Template template (ID: {1D3BB1E3-DA58-4367-A45B-A0B2DDBA4CF1}). */
export type RiskWarningParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'RiskWarningParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {347F08F0-D24B-4D98-AC9E-B7C51DAF3B8D}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Risk Warning Parameters Template template (ID: {1D3BB1E3-DA58-4367-A45B-A0B2DDBA4CF1}). */
export type RiskWarningParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Risk Warning Parameters Template template (ID: {1D3BB1E3-DA58-4367-A45B-A0B2DDBA4CF1}). */
export type RiskWarningParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Risk Warning Parameters Template template (ID: {1D3BB1E3-DA58-4367-A45B-A0B2DDBA4CF1}). */
export type RiskWarningParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Risk Warning Parameters Template template (ID: {1D3BB1E3-DA58-4367-A45B-A0B2DDBA4CF1}). */
export type RiskWarningParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Risk Warning Parameters Template template (ID: {1D3BB1E3-DA58-4367-A45B-A0B2DDBA4CF1}). */
export type RiskWarningParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Risk Warning Parameters Template template (ID: {1D3BB1E3-DA58-4367-A45B-A0B2DDBA4CF1}). */
export type RiskWarningParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/RolePlaceholder template (ID: {B7450F41-8E34-497B-971A-2FD329ADE505}). */
export type RolePlaceholder = Item & _MemberOf & _RoleDomain & _RoleName & _RoleType & {
  __typename?: 'RolePlaceholder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MemberOf (ID: {359B28A0-9FAC-4F93-B0F6-DB957CBE5CE9}). */
  memberOf?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** RoleName (ID: {5382BFDE-8E39-4571-A1C5-EB3C43D5BCE3}). */
  roleName?: Maybe<TextField>;
  /** RoleType (ID: {6471939F-9E50-4512-9EB7-556594C5C728}). */
  roleType?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/RolePlaceholder template (ID: {B7450F41-8E34-497B-971A-2FD329ADE505}). */
export type RolePlaceholderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/RolePlaceholder template (ID: {B7450F41-8E34-497B-971A-2FD329ADE505}). */
export type RolePlaceholderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/RolePlaceholder template (ID: {B7450F41-8E34-497B-971A-2FD329ADE505}). */
export type RolePlaceholderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/RolePlaceholder template (ID: {B7450F41-8E34-497B-971A-2FD329ADE505}). */
export type RolePlaceholderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/RolePlaceholder template (ID: {B7450F41-8E34-497B-971A-2FD329ADE505}). */
export type RolePlaceholderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/RolePlaceholder template (ID: {B7450F41-8E34-497B-971A-2FD329ADE505}). */
export type RolePlaceholderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Route = {
  __typename?: 'Route';
  /** Item representing the route path. */
  route: Item;
  /** The route path for a specific language. */
  routePath: Scalars['String']['output'];
};

export type RoutesResult = {
  __typename?: 'RoutesResult';
  /** Pagination info. */
  pageInfo: PageInfo;
  /** All site routes for a specific language. */
  results: Array<Maybe<Route>>;
  /** Total number of routes for the site in a specific language. */
  total: Scalars['Int']['output'];
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {DB88EFA8-E015-4B96-BA0E-348D8B510563}). */
export type RowSplitter = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & ISplitter & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'RowSplitter';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Styles1 (ID: {22E04FBA-7AF3-4EFE-91D0-91C96C50E8F6}). */
  styles1?: Maybe<TextField>;
  /** Styles2 (ID: {2D4DFF46-7563-4671-A6E7-CFDB6BC2A175}). */
  styles2?: Maybe<TextField>;
  /** Styles3 (ID: {6B44B72D-2C7D-4089-B7B9-AFA4E1DDD5F5}). */
  styles3?: Maybe<TextField>;
  /** Styles4 (ID: {DD4A8F2A-3A6C-4F00-A164-620EDA04459F}). */
  styles4?: Maybe<TextField>;
  /** Styles5 (ID: {DEB68026-9F4C-4C43-9C4F-E37299AB7D26}). */
  styles5?: Maybe<TextField>;
  /** Styles6 (ID: {B0D40EE8-FA8E-4FD8-BD08-206294897C7C}). */
  styles6?: Maybe<TextField>;
  /** Styles7 (ID: {41D71E94-EF5B-4883-A1E1-FC28AC995B73}). */
  styles7?: Maybe<TextField>;
  /** Styles8 (ID: {9BA62B79-B72E-4D63-A123-5FED10F694D1}). */
  styles8?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {DB88EFA8-E015-4B96-BA0E-348D8B510563}). */
export type RowSplitterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {DB88EFA8-E015-4B96-BA0E-348D8B510563}). */
export type RowSplitterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {DB88EFA8-E015-4B96-BA0E-348D8B510563}). */
export type RowSplitterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {DB88EFA8-E015-4B96-BA0E-348D8B510563}). */
export type RowSplitterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {DB88EFA8-E015-4B96-BA0E-348D8B510563}). */
export type RowSplitterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {DB88EFA8-E015-4B96-BA0E-348D8B510563}). */
export type RowSplitterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {340C887D-A1D1-415B-9678-C763AF74EA97}). */
export type RowSplitter_340c887da1d1415b9678c763af74ea97 = ICacheable & IDynamicPlaceholder & ISplitter & Item & StandardRenderingParameters & {
  __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Styles1 (ID: {CB8D0DC2-7D8F-4F11-A795-0FEA5F362609}). */
  styles1?: Maybe<TextField>;
  /** Styles2 (ID: {B60503AB-99F8-47AA-B000-C909BF99BF1B}). */
  styles2?: Maybe<TextField>;
  /** Styles3 (ID: {A4D4C24A-7857-420C-94CC-15F16CDBA190}). */
  styles3?: Maybe<TextField>;
  /** Styles4 (ID: {7C698EA1-F674-45A4-8220-166C356B2660}). */
  styles4?: Maybe<TextField>;
  /** Styles5 (ID: {ACFBDC15-1939-489E-821F-74BCD6013179}). */
  styles5?: Maybe<TextField>;
  /** Styles6 (ID: {B290632E-747B-4354-A269-067AE2A18289}). */
  styles6?: Maybe<TextField>;
  /** Styles7 (ID: {E1A406CC-1006-4B57-BC85-1D233B4C6752}). */
  styles7?: Maybe<TextField>;
  /** Styles8 (ID: {D8BE02BC-B145-446F-AE06-D813E5C74533}). */
  styles8?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {340C887D-A1D1-415B-9678-C763AF74EA97}). */
export type RowSplitter_340c887da1d1415b9678c763af74ea97AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {340C887D-A1D1-415B-9678-C763AF74EA97}). */
export type RowSplitter_340c887da1d1415b9678c763af74ea97ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {340C887D-A1D1-415B-9678-C763AF74EA97}). */
export type RowSplitter_340c887da1d1415b9678c763af74ea97FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {340C887D-A1D1-415B-9678-C763AF74EA97}). */
export type RowSplitter_340c887da1d1415b9678c763af74ea97FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {340C887D-A1D1-415B-9678-C763AF74EA97}). */
export type RowSplitter_340c887da1d1415b9678c763af74ea97HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/RowSplitter template (ID: {340C887D-A1D1-415B-9678-C763AF74EA97}). */
export type RowSplitter_340c887da1d1415b9678c763af74ea97IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Rule template (ID: {962D1760-F973-44B8-B553-8A74BCDC23FA}). */
export type Rule = BaseVariantField & Item & {
  __typename?: 'Rule';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Rule template (ID: {962D1760-F973-44B8-B553-8A74BCDC23FA}). */
export type RuleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Rule template (ID: {962D1760-F973-44B8-B553-8A74BCDC23FA}). */
export type RuleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Rule template (ID: {962D1760-F973-44B8-B553-8A74BCDC23FA}). */
export type RuleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Rule template (ID: {962D1760-F973-44B8-B553-8A74BCDC23FA}). */
export type RuleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Rule template (ID: {962D1760-F973-44B8-B553-8A74BCDC23FA}). */
export type RuleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Rule template (ID: {962D1760-F973-44B8-B553-8A74BCDC23FA}). */
export type RuleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mapping template (ID: {0FFF2F0F-BADB-442C-BF8C-56CEBDC2CF60}). */
export type SdrLogoMapping = Item & {
  __typename?: 'SDRLogoMapping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {FF443204-14E2-4F60-AA3D-EE03C626BEAC}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** type (ID: {C3E2CF1D-1564-4159-9878-4B66D7747067}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mapping template (ID: {0FFF2F0F-BADB-442C-BF8C-56CEBDC2CF60}). */
export type SdrLogoMappingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mapping template (ID: {0FFF2F0F-BADB-442C-BF8C-56CEBDC2CF60}). */
export type SdrLogoMappingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mapping template (ID: {0FFF2F0F-BADB-442C-BF8C-56CEBDC2CF60}). */
export type SdrLogoMappingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mapping template (ID: {0FFF2F0F-BADB-442C-BF8C-56CEBDC2CF60}). */
export type SdrLogoMappingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mapping template (ID: {0FFF2F0F-BADB-442C-BF8C-56CEBDC2CF60}). */
export type SdrLogoMappingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mapping template (ID: {0FFF2F0F-BADB-442C-BF8C-56CEBDC2CF60}). */
export type SdrLogoMappingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mappings template (ID: {BF5D962B-A6DB-4FDB-AD38-310CB86F8D55}). */
export type SdrLogoMappings = Item & {
  __typename?: 'SDRLogoMappings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mappings template (ID: {BF5D962B-A6DB-4FDB-AD38-310CB86F8D55}). */
export type SdrLogoMappingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mappings template (ID: {BF5D962B-A6DB-4FDB-AD38-310CB86F8D55}). */
export type SdrLogoMappingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mappings template (ID: {BF5D962B-A6DB-4FDB-AD38-310CB86F8D55}). */
export type SdrLogoMappingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mappings template (ID: {BF5D962B-A6DB-4FDB-AD38-310CB86F8D55}). */
export type SdrLogoMappingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mappings template (ID: {BF5D962B-A6DB-4FDB-AD38-310CB86F8D55}). */
export type SdrLogoMappingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Logo Mappings/SDR Logo Mappings template (ID: {BF5D962B-A6DB-4FDB-AD38-310CB86F8D55}). */
export type SdrLogoMappingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option template (ID: {9CF4C94A-F49B-4ACC-AD61-881F09EB79BC}). */
export type SdrTypeOption = Item & {
  __typename?: 'SDRTypeOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option template (ID: {9CF4C94A-F49B-4ACC-AD61-881F09EB79BC}). */
export type SdrTypeOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option template (ID: {9CF4C94A-F49B-4ACC-AD61-881F09EB79BC}). */
export type SdrTypeOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option template (ID: {9CF4C94A-F49B-4ACC-AD61-881F09EB79BC}). */
export type SdrTypeOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option template (ID: {9CF4C94A-F49B-4ACC-AD61-881F09EB79BC}). */
export type SdrTypeOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option template (ID: {9CF4C94A-F49B-4ACC-AD61-881F09EB79BC}). */
export type SdrTypeOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option template (ID: {9CF4C94A-F49B-4ACC-AD61-881F09EB79BC}). */
export type SdrTypeOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option Folder template (ID: {7651D736-5D43-46D9-8B86-076B4CC64A3B}). */
export type SdrTypeOptionFolder = Item & {
  __typename?: 'SDRTypeOptionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option Folder template (ID: {7651D736-5D43-46D9-8B86-076B4CC64A3B}). */
export type SdrTypeOptionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option Folder template (ID: {7651D736-5D43-46D9-8B86-076B4CC64A3B}). */
export type SdrTypeOptionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option Folder template (ID: {7651D736-5D43-46D9-8B86-076B4CC64A3B}). */
export type SdrTypeOptionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option Folder template (ID: {7651D736-5D43-46D9-8B86-076B4CC64A3B}). */
export type SdrTypeOptionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option Folder template (ID: {7651D736-5D43-46D9-8B86-076B4CC64A3B}). */
export type SdrTypeOptionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/SDR Type/SDR Type Option Folder template (ID: {7651D736-5D43-46D9-8B86-076B4CC64A3B}). */
export type SdrTypeOptionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/SXA JSS Layout template (ID: {E4E11508-04A4-4B0B-A263-5201F811C9CD}). */
export type SxajssLayout = Item & Layout & {
  __typename?: 'SXAJSSLayout';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Area (ID: {70DC08D9-CDA2-4F04-AA35-C11FD7138066}). */
  area?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Model (ID: {E9CC5A73-3C8A-4D7D-92AC-3B88C18A996A}). */
  model?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  /** Path (ID: {A036B2BC-BA04-44F6-A75F-BAE6CD242ABF}). */
  path_a036b2bcba0444f6a75fbae6cd242abf?: Maybe<TextField>;
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholders (ID: {80334869-86DC-4472-AA89-44CF1B2F6C9B}). */
  placeholders?: Maybe<MultilistField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/SXA JSS Layout template (ID: {E4E11508-04A4-4B0B-A263-5201F811C9CD}). */
export type SxajssLayoutAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/SXA JSS Layout template (ID: {E4E11508-04A4-4B0B-A263-5201F811C9CD}). */
export type SxajssLayoutChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/SXA JSS Layout template (ID: {E4E11508-04A4-4B0B-A263-5201F811C9CD}). */
export type SxajssLayoutFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/SXA JSS Layout template (ID: {E4E11508-04A4-4B0B-A263-5201F811C9CD}). */
export type SxajssLayoutFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/SXA JSS Layout template (ID: {E4E11508-04A4-4B0B-A263-5201F811C9CD}). */
export type SxajssLayoutHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Presentation/SXA JSS Layout template (ID: {E4E11508-04A4-4B0B-A263-5201F811C9CD}). */
export type SxajssLayoutIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/SXA Role template (ID: {C38AA55A-EC75-4498-9EB6-13269C07FDB5}). */
export type SxaRole = Item & _MemberOf & _RoleDomain & _RoleName & {
  __typename?: 'SXARole';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MemberOf (ID: {359B28A0-9FAC-4F93-B0F6-DB957CBE5CE9}). */
  memberOf?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** RoleName (ID: {5382BFDE-8E39-4571-A1C5-EB3C43D5BCE3}). */
  roleName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/SXA Role template (ID: {C38AA55A-EC75-4498-9EB6-13269C07FDB5}). */
export type SxaRoleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/SXA Role template (ID: {C38AA55A-EC75-4498-9EB6-13269C07FDB5}). */
export type SxaRoleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/SXA Role template (ID: {C38AA55A-EC75-4498-9EB6-13269C07FDB5}). */
export type SxaRoleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/SXA Role template (ID: {C38AA55A-EC75-4498-9EB6-13269C07FDB5}). */
export type SxaRoleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/SXA Role template (ID: {C38AA55A-EC75-4498-9EB6-13269C07FDB5}). */
export type SxaRoleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/SXA Role template (ID: {C38AA55A-EC75-4498-9EB6-13269C07FDB5}). */
export type SxaRoleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/SXA Standard Values Folder template (ID: {AB987746-78B0-4773-A8DE-B295C493B7A4}). */
export type SxaStandardValuesFolder = Item & {
  __typename?: 'SXAStandardValuesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/SXA Standard Values Folder template (ID: {AB987746-78B0-4773-A8DE-B295C493B7A4}). */
export type SxaStandardValuesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/SXA Standard Values Folder template (ID: {AB987746-78B0-4773-A8DE-B295C493B7A4}). */
export type SxaStandardValuesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/SXA Standard Values Folder template (ID: {AB987746-78B0-4773-A8DE-B295C493B7A4}). */
export type SxaStandardValuesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/SXA Standard Values Folder template (ID: {AB987746-78B0-4773-A8DE-B295C493B7A4}). */
export type SxaStandardValuesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/SXA Standard Values Folder template (ID: {AB987746-78B0-4773-A8DE-B295C493B7A4}). */
export type SxaStandardValuesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/StandardValues/SXA Standard Values Folder template (ID: {AB987746-78B0-4773-A8DE-B295C493B7A4}). */
export type SxaStandardValuesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Alert Message template (ID: {797EC377-DB3E-4D9D-AE98-0E7D0EB4C8AD}). */
export type SalesforceAlertMessage = Item & {
  __typename?: 'SalesforceAlertMessage';
  /** alertExpandableText (ID: {B9FFD30B-BC80-486B-9C91-5BB9E93DF231}). */
  alertExpandableText?: Maybe<RichTextField>;
  /** alertText (ID: {5E5BF403-5D3F-409B-94D8-7DD719656AA3}). */
  alertText?: Maybe<RichTextField>;
  /** alertTitle (ID: {4C18CD55-4D70-45D7-B2F3-57FA5A72B4AE}). */
  alertTitle?: Maybe<TextField>;
  /** alertType (ID: {1142FCC9-1B40-47DD-B71B-4F13A62EE82F}). */
  alertType?: Maybe<TextField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** expandedView (ID: {51BC6202-EDC2-4F55-B583-780DFE378855}). */
  expandedView?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Alert Message template (ID: {797EC377-DB3E-4D9D-AE98-0E7D0EB4C8AD}). */
export type SalesforceAlertMessageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Alert Message template (ID: {797EC377-DB3E-4D9D-AE98-0E7D0EB4C8AD}). */
export type SalesforceAlertMessageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Alert Message template (ID: {797EC377-DB3E-4D9D-AE98-0E7D0EB4C8AD}). */
export type SalesforceAlertMessageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Alert Message template (ID: {797EC377-DB3E-4D9D-AE98-0E7D0EB4C8AD}). */
export type SalesforceAlertMessageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Alert Message template (ID: {797EC377-DB3E-4D9D-AE98-0E7D0EB4C8AD}). */
export type SalesforceAlertMessageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Alert Message template (ID: {797EC377-DB3E-4D9D-AE98-0E7D0EB4C8AD}). */
export type SalesforceAlertMessageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Check Box template (ID: {F4DD3BF3-EE7F-4251-B494-3ED38DF386AD}). */
export type SalesforceCheckBox = Item & _SalesforceCommonValidations & _SalesforceFieldId & _SalesforceFieldTitle & _SalesforceFieldValue & {
  __typename?: 'SalesforceCheckBox';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** salesforceValue (ID: {1627FF3E-97E6-4133-99A3-1E2B62CBAD8A}). */
  salesforceValue?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** type (ID: {71AC78F8-4819-4222-A410-8CFF1D8B6B9A}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Check Box template (ID: {F4DD3BF3-EE7F-4251-B494-3ED38DF386AD}). */
export type SalesforceCheckBoxAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Check Box template (ID: {F4DD3BF3-EE7F-4251-B494-3ED38DF386AD}). */
export type SalesforceCheckBoxChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Check Box template (ID: {F4DD3BF3-EE7F-4251-B494-3ED38DF386AD}). */
export type SalesforceCheckBoxFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Check Box template (ID: {F4DD3BF3-EE7F-4251-B494-3ED38DF386AD}). */
export type SalesforceCheckBoxFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Check Box template (ID: {F4DD3BF3-EE7F-4251-B494-3ED38DF386AD}). */
export type SalesforceCheckBoxHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Check Box template (ID: {F4DD3BF3-EE7F-4251-B494-3ED38DF386AD}). */
export type SalesforceCheckBoxIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Check Box Type template (ID: {3421DA8A-E845-4C07-9832-ACF9756179D3}). */
export type SalesforceCheckBoxType = Item & {
  __typename?: 'SalesforceCheckBoxType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Check Box Type template (ID: {3421DA8A-E845-4C07-9832-ACF9756179D3}). */
export type SalesforceCheckBoxTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Check Box Type template (ID: {3421DA8A-E845-4C07-9832-ACF9756179D3}). */
export type SalesforceCheckBoxTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Check Box Type template (ID: {3421DA8A-E845-4C07-9832-ACF9756179D3}). */
export type SalesforceCheckBoxTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Check Box Type template (ID: {3421DA8A-E845-4C07-9832-ACF9756179D3}). */
export type SalesforceCheckBoxTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Check Box Type template (ID: {3421DA8A-E845-4C07-9832-ACF9756179D3}). */
export type SalesforceCheckBoxTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Check Box Type template (ID: {3421DA8A-E845-4C07-9832-ACF9756179D3}). */
export type SalesforceCheckBoxTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Button template (ID: {6D3CA1F0-E139-4C90-B537-E3B03F03ABE7}). */
export type SalesforceConditionalRadioButton = Item & _SalesforceFieldTitle & _SalesforceFieldValue & {
  __typename?: 'SalesforceConditionalRadioButton';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isPreselected (ID: {DA351580-9D83-4E16-AAA4-E85ABFA38070}). */
  isPreselected?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceValue (ID: {1627FF3E-97E6-4133-99A3-1E2B62CBAD8A}). */
  salesforceValue?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Button template (ID: {6D3CA1F0-E139-4C90-B537-E3B03F03ABE7}). */
export type SalesforceConditionalRadioButtonAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Button template (ID: {6D3CA1F0-E139-4C90-B537-E3B03F03ABE7}). */
export type SalesforceConditionalRadioButtonChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Button template (ID: {6D3CA1F0-E139-4C90-B537-E3B03F03ABE7}). */
export type SalesforceConditionalRadioButtonFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Button template (ID: {6D3CA1F0-E139-4C90-B537-E3B03F03ABE7}). */
export type SalesforceConditionalRadioButtonFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Button template (ID: {6D3CA1F0-E139-4C90-B537-E3B03F03ABE7}). */
export type SalesforceConditionalRadioButtonHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Button template (ID: {6D3CA1F0-E139-4C90-B537-E3B03F03ABE7}). */
export type SalesforceConditionalRadioButtonIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Buttons template (ID: {B79C5784-9991-4F25-BC79-82F8F34FDC77}). */
export type SalesforceConditionalRadioButtons = Item & _SalesforceCommonValidations & _SalesforceFieldId & _SalesforceFieldTitle & {
  __typename?: 'SalesforceConditionalRadioButtons';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Buttons template (ID: {B79C5784-9991-4F25-BC79-82F8F34FDC77}). */
export type SalesforceConditionalRadioButtonsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Buttons template (ID: {B79C5784-9991-4F25-BC79-82F8F34FDC77}). */
export type SalesforceConditionalRadioButtonsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Buttons template (ID: {B79C5784-9991-4F25-BC79-82F8F34FDC77}). */
export type SalesforceConditionalRadioButtonsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Buttons template (ID: {B79C5784-9991-4F25-BC79-82F8F34FDC77}). */
export type SalesforceConditionalRadioButtonsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Buttons template (ID: {B79C5784-9991-4F25-BC79-82F8F34FDC77}). */
export type SalesforceConditionalRadioButtonsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Conditional Radio Buttons template (ID: {B79C5784-9991-4F25-BC79-82F8F34FDC77}). */
export type SalesforceConditionalRadioButtonsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Date Input template (ID: {B23D8801-171C-4473-B8DA-442DF137DAF2}). */
export type SalesforceDateInput = Item & _SalesforceCommonValidations & _SalesforceFieldId & _SalesforceFieldTitle & {
  __typename?: 'SalesforceDateInput';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Date Input template (ID: {B23D8801-171C-4473-B8DA-442DF137DAF2}). */
export type SalesforceDateInputAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Date Input template (ID: {B23D8801-171C-4473-B8DA-442DF137DAF2}). */
export type SalesforceDateInputChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Date Input template (ID: {B23D8801-171C-4473-B8DA-442DF137DAF2}). */
export type SalesforceDateInputFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Date Input template (ID: {B23D8801-171C-4473-B8DA-442DF137DAF2}). */
export type SalesforceDateInputFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Date Input template (ID: {B23D8801-171C-4473-B8DA-442DF137DAF2}). */
export type SalesforceDateInputHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Date Input template (ID: {B23D8801-171C-4473-B8DA-442DF137DAF2}). */
export type SalesforceDateInputIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown template (ID: {35C78191-87D7-4711-90FE-3F5BB4953CAB}). */
export type SalesforceDropdown = Item & _SalesforceCommonValidations & _SalesforceFieldId & _SalesforceFieldTitle & {
  __typename?: 'SalesforceDropdown';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown template (ID: {35C78191-87D7-4711-90FE-3F5BB4953CAB}). */
export type SalesforceDropdownAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown template (ID: {35C78191-87D7-4711-90FE-3F5BB4953CAB}). */
export type SalesforceDropdownChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown template (ID: {35C78191-87D7-4711-90FE-3F5BB4953CAB}). */
export type SalesforceDropdownFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown template (ID: {35C78191-87D7-4711-90FE-3F5BB4953CAB}). */
export type SalesforceDropdownFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown template (ID: {35C78191-87D7-4711-90FE-3F5BB4953CAB}). */
export type SalesforceDropdownHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown template (ID: {35C78191-87D7-4711-90FE-3F5BB4953CAB}). */
export type SalesforceDropdownIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown Option template (ID: {2A32D499-86D0-497B-A9A3-30025DBD3474}). */
export type SalesforceDropdownOption = Item & _SalesforceFieldTitle & _SalesforceFieldValue & {
  __typename?: 'SalesforceDropdownOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** hasRepeatableSection (ID: {A2526D01-76B3-4312-8EF7-1D9C4ACD15A4}). */
  hasRepeatableSection?: Maybe<CheckboxField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceValue (ID: {1627FF3E-97E6-4133-99A3-1E2B62CBAD8A}). */
  salesforceValue?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown Option template (ID: {2A32D499-86D0-497B-A9A3-30025DBD3474}). */
export type SalesforceDropdownOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown Option template (ID: {2A32D499-86D0-497B-A9A3-30025DBD3474}). */
export type SalesforceDropdownOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown Option template (ID: {2A32D499-86D0-497B-A9A3-30025DBD3474}). */
export type SalesforceDropdownOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown Option template (ID: {2A32D499-86D0-497B-A9A3-30025DBD3474}). */
export type SalesforceDropdownOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown Option template (ID: {2A32D499-86D0-497B-A9A3-30025DBD3474}). */
export type SalesforceDropdownOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Dropdown Option template (ID: {2A32D499-86D0-497B-A9A3-30025DBD3474}). */
export type SalesforceDropdownOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Hidden Field template (ID: {6475FB5E-E9E3-40A3-90F2-9DF3F8CB07A8}). */
export type SalesforceHiddenField = Item & _SalesforceFieldId & _SalesforceFieldValue & {
  __typename?: 'SalesforceHiddenField';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** If checked, field will be invisible, but be included in page markup */
  includeInMarkup?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** salesforceValue (ID: {1627FF3E-97E6-4133-99A3-1E2B62CBAD8A}). */
  salesforceValue?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Hidden Field template (ID: {6475FB5E-E9E3-40A3-90F2-9DF3F8CB07A8}). */
export type SalesforceHiddenFieldAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Hidden Field template (ID: {6475FB5E-E9E3-40A3-90F2-9DF3F8CB07A8}). */
export type SalesforceHiddenFieldChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Hidden Field template (ID: {6475FB5E-E9E3-40A3-90F2-9DF3F8CB07A8}). */
export type SalesforceHiddenFieldFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Hidden Field template (ID: {6475FB5E-E9E3-40A3-90F2-9DF3F8CB07A8}). */
export type SalesforceHiddenFieldFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Hidden Field template (ID: {6475FB5E-E9E3-40A3-90F2-9DF3F8CB07A8}). */
export type SalesforceHiddenFieldHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Hidden Field template (ID: {6475FB5E-E9E3-40A3-90F2-9DF3F8CB07A8}). */
export type SalesforceHiddenFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Input template (ID: {26E7802D-9C96-4A29-87A7-A44CB385A1C0}). */
export type SalesforceInput = Item & _SalesforceCommonValidations & _SalesforceFieldId & _SalesforceFieldTitle & {
  __typename?: 'SalesforceInput';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** type (ID: {4C956F97-83B3-405B-A791-FD4BD7DEE943}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Input template (ID: {26E7802D-9C96-4A29-87A7-A44CB385A1C0}). */
export type SalesforceInputAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Input template (ID: {26E7802D-9C96-4A29-87A7-A44CB385A1C0}). */
export type SalesforceInputChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Input template (ID: {26E7802D-9C96-4A29-87A7-A44CB385A1C0}). */
export type SalesforceInputFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Input template (ID: {26E7802D-9C96-4A29-87A7-A44CB385A1C0}). */
export type SalesforceInputFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Input template (ID: {26E7802D-9C96-4A29-87A7-A44CB385A1C0}). */
export type SalesforceInputHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Input template (ID: {26E7802D-9C96-4A29-87A7-A44CB385A1C0}). */
export type SalesforceInputIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Input Type template (ID: {4A5ADCEF-6966-462A-A1FD-FD346EA470EB}). */
export type SalesforceInputType = Item & {
  __typename?: 'SalesforceInputType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Input Type template (ID: {4A5ADCEF-6966-462A-A1FD-FD346EA470EB}). */
export type SalesforceInputTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Input Type template (ID: {4A5ADCEF-6966-462A-A1FD-FD346EA470EB}). */
export type SalesforceInputTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Input Type template (ID: {4A5ADCEF-6966-462A-A1FD-FD346EA470EB}). */
export type SalesforceInputTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Input Type template (ID: {4A5ADCEF-6966-462A-A1FD-FD346EA470EB}). */
export type SalesforceInputTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Input Type template (ID: {4A5ADCEF-6966-462A-A1FD-FD346EA470EB}). */
export type SalesforceInputTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Input Type template (ID: {4A5ADCEF-6966-462A-A1FD-FD346EA470EB}). */
export type SalesforceInputTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Integrated Form template (ID: {E6533250-188B-498C-BA81-8942ADF02113}). */
export type SalesforceIntegratedForm = Item & {
  __typename?: 'SalesforceIntegratedForm';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** endPage (ID: {7F272884-E849-4CFC-AE48-4C0C480D5E6D}). */
  endPage?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** helpSection (ID: {85CA7387-3116-4FBB-B046-76F325C741D3}). */
  helpSection?: Maybe<RichTextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** recordTypeId (ID: {853FEE67-BB26-415D-AFCF-1578C247FC17}). */
  recordTypeId?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** submissionEndpoint (ID: {5C0AC4E3-F495-447B-9239-496F3ED5CF34}). */
  submissionEndpoint?: Maybe<TextField>;
  /** submissionType (ID: {FE6D0262-19D1-4FF1-95AB-C622FF8F0FBB}). */
  submissionType?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Integrated Form template (ID: {E6533250-188B-498C-BA81-8942ADF02113}). */
export type SalesforceIntegratedFormAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Integrated Form template (ID: {E6533250-188B-498C-BA81-8942ADF02113}). */
export type SalesforceIntegratedFormChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Integrated Form template (ID: {E6533250-188B-498C-BA81-8942ADF02113}). */
export type SalesforceIntegratedFormFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Integrated Form template (ID: {E6533250-188B-498C-BA81-8942ADF02113}). */
export type SalesforceIntegratedFormFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Integrated Form template (ID: {E6533250-188B-498C-BA81-8942ADF02113}). */
export type SalesforceIntegratedFormHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Integrated Form template (ID: {E6533250-188B-498C-BA81-8942ADF02113}). */
export type SalesforceIntegratedFormIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Integrated Form Types Folder template (ID: {945E8EF2-DCFA-492C-8961-D2A9DDF2ACEE}). */
export type SalesforceIntegratedFormTypesFolder = Item & {
  __typename?: 'SalesforceIntegratedFormTypesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Integrated Form Types Folder template (ID: {945E8EF2-DCFA-492C-8961-D2A9DDF2ACEE}). */
export type SalesforceIntegratedFormTypesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Integrated Form Types Folder template (ID: {945E8EF2-DCFA-492C-8961-D2A9DDF2ACEE}). */
export type SalesforceIntegratedFormTypesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Integrated Form Types Folder template (ID: {945E8EF2-DCFA-492C-8961-D2A9DDF2ACEE}). */
export type SalesforceIntegratedFormTypesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Integrated Form Types Folder template (ID: {945E8EF2-DCFA-492C-8961-D2A9DDF2ACEE}). */
export type SalesforceIntegratedFormTypesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Integrated Form Types Folder template (ID: {945E8EF2-DCFA-492C-8961-D2A9DDF2ACEE}). */
export type SalesforceIntegratedFormTypesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Integrated Form Types Folder template (ID: {945E8EF2-DCFA-492C-8961-D2A9DDF2ACEE}). */
export type SalesforceIntegratedFormTypesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Repeatable Sub Section template (ID: {8E0F1D09-2298-4EF6-81CE-697771CB72BE}). */
export type SalesforceRepeatableSubSection = Item & {
  __typename?: 'SalesforceRepeatableSubSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** dropdownText (ID: {B085A2A6-9653-4BC3-9045-0B34FDD681E0}). */
  dropdownText?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** maxRepeats (ID: {26447021-B933-43F4-A9E2-C9898D800A78}). */
  maxRepeats?: Maybe<NumberField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Repeatable Sub Section template (ID: {8E0F1D09-2298-4EF6-81CE-697771CB72BE}). */
export type SalesforceRepeatableSubSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Repeatable Sub Section template (ID: {8E0F1D09-2298-4EF6-81CE-697771CB72BE}). */
export type SalesforceRepeatableSubSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Repeatable Sub Section template (ID: {8E0F1D09-2298-4EF6-81CE-697771CB72BE}). */
export type SalesforceRepeatableSubSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Repeatable Sub Section template (ID: {8E0F1D09-2298-4EF6-81CE-697771CB72BE}). */
export type SalesforceRepeatableSubSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Repeatable Sub Section template (ID: {8E0F1D09-2298-4EF6-81CE-697771CB72BE}). */
export type SalesforceRepeatableSubSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Repeatable Sub Section template (ID: {8E0F1D09-2298-4EF6-81CE-697771CB72BE}). */
export type SalesforceRepeatableSubSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Rich Text Area template (ID: {362AAFA3-CD50-4C35-81A8-9A4C96A71837}). */
export type SalesforceRichTextArea = Item & {
  __typename?: 'SalesforceRichTextArea';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** richTextArea (ID: {07F440C7-B00F-47FE-B3F7-6E9E0765A830}). */
  richTextArea?: Maybe<RichTextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Rich Text Area template (ID: {362AAFA3-CD50-4C35-81A8-9A4C96A71837}). */
export type SalesforceRichTextAreaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Rich Text Area template (ID: {362AAFA3-CD50-4C35-81A8-9A4C96A71837}). */
export type SalesforceRichTextAreaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Rich Text Area template (ID: {362AAFA3-CD50-4C35-81A8-9A4C96A71837}). */
export type SalesforceRichTextAreaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Rich Text Area template (ID: {362AAFA3-CD50-4C35-81A8-9A4C96A71837}). */
export type SalesforceRichTextAreaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Rich Text Area template (ID: {362AAFA3-CD50-4C35-81A8-9A4C96A71837}). */
export type SalesforceRichTextAreaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Rich Text Area template (ID: {362AAFA3-CD50-4C35-81A8-9A4C96A71837}). */
export type SalesforceRichTextAreaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Section template (ID: {C695BAA0-853B-4E66-8C3D-E3EBC4A8C423}). */
export type SalesforceSection = Item & _SalesforceFieldTitle & {
  __typename?: 'SalesforceSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** conditionalAvailability (ID: {23FB64E8-EB84-4B98-9D8A-40CBE0E1CB20}). */
  conditionalAvailability?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** step (ID: {A9AA546E-D065-47C5-93CB-D48B20AAFF10}). */
  step?: Maybe<IntegerField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Section template (ID: {C695BAA0-853B-4E66-8C3D-E3EBC4A8C423}). */
export type SalesforceSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Section template (ID: {C695BAA0-853B-4E66-8C3D-E3EBC4A8C423}). */
export type SalesforceSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Section template (ID: {C695BAA0-853B-4E66-8C3D-E3EBC4A8C423}). */
export type SalesforceSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Section template (ID: {C695BAA0-853B-4E66-8C3D-E3EBC4A8C423}). */
export type SalesforceSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Section template (ID: {C695BAA0-853B-4E66-8C3D-E3EBC4A8C423}). */
export type SalesforceSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Section template (ID: {C695BAA0-853B-4E66-8C3D-E3EBC4A8C423}). */
export type SalesforceSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Sort Code Input template (ID: {AD53A5C8-AC95-4538-AC86-087CD5B253E7}). */
export type SalesforceSortCodeInput = Item & _SalesforceCommonValidations & _SalesforceFieldId & _SalesforceFieldTitle & {
  __typename?: 'SalesforceSortCodeInput';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Sort Code Input template (ID: {AD53A5C8-AC95-4538-AC86-087CD5B253E7}). */
export type SalesforceSortCodeInputAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Sort Code Input template (ID: {AD53A5C8-AC95-4538-AC86-087CD5B253E7}). */
export type SalesforceSortCodeInputChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Sort Code Input template (ID: {AD53A5C8-AC95-4538-AC86-087CD5B253E7}). */
export type SalesforceSortCodeInputFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Sort Code Input template (ID: {AD53A5C8-AC95-4538-AC86-087CD5B253E7}). */
export type SalesforceSortCodeInputFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Sort Code Input template (ID: {AD53A5C8-AC95-4538-AC86-087CD5B253E7}). */
export type SalesforceSortCodeInputHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Salesforce Sort Code Input template (ID: {AD53A5C8-AC95-4538-AC86-087CD5B253E7}). */
export type SalesforceSortCodeInputIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Submission Type template (ID: {2376D224-B8C9-4D0D-AB35-6A52F09C68BC}). */
export type SalesforceSubmissionType = Item & {
  __typename?: 'SalesforceSubmissionType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Submission Type template (ID: {2376D224-B8C9-4D0D-AB35-6A52F09C68BC}). */
export type SalesforceSubmissionTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Submission Type template (ID: {2376D224-B8C9-4D0D-AB35-6A52F09C68BC}). */
export type SalesforceSubmissionTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Submission Type template (ID: {2376D224-B8C9-4D0D-AB35-6A52F09C68BC}). */
export type SalesforceSubmissionTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Submission Type template (ID: {2376D224-B8C9-4D0D-AB35-6A52F09C68BC}). */
export type SalesforceSubmissionTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Submission Type template (ID: {2376D224-B8C9-4D0D-AB35-6A52F09C68BC}). */
export type SalesforceSubmissionTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form Types/Salesforce Submission Type template (ID: {2376D224-B8C9-4D0D-AB35-6A52F09C68BC}). */
export type SalesforceSubmissionTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scope template (ID: {8B649372-CC12-4F31-802A-8C3B3D09BB3F}). */
export type Scope = IBoosting & Item & {
  __typename?: 'Scope';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rule (ID: {0F628FD3-A28C-4DA7-968B-DCE9F3B71B5A}). */
  rule?: Maybe<TextField>;
  /** ScopeQuery (ID: {B04FE662-2B23-44DD-B971-2B864A1EC55F}). */
  scopeQuery?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scope template (ID: {8B649372-CC12-4F31-802A-8C3B3D09BB3F}). */
export type ScopeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scope template (ID: {8B649372-CC12-4F31-802A-8C3B3D09BB3F}). */
export type ScopeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scope template (ID: {8B649372-CC12-4F31-802A-8C3B3D09BB3F}). */
export type ScopeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scope template (ID: {8B649372-CC12-4F31-802A-8C3B3D09BB3F}). */
export type ScopeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scope template (ID: {8B649372-CC12-4F31-802A-8C3B3D09BB3F}). */
export type ScopeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scope template (ID: {8B649372-CC12-4F31-802A-8C3B3D09BB3F}). */
export type ScopeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scopes Folder template (ID: {44936C95-BCA9-4FB3-9D98-2066A5FBBB4D}). */
export type ScopesFolder = Item & {
  __typename?: 'ScopesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scopes Folder template (ID: {44936C95-BCA9-4FB3-9D98-2066A5FBBB4D}). */
export type ScopesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scopes Folder template (ID: {44936C95-BCA9-4FB3-9D98-2066A5FBBB4D}). */
export type ScopesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scopes Folder template (ID: {44936C95-BCA9-4FB3-9D98-2066A5FBBB4D}). */
export type ScopesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scopes Folder template (ID: {44936C95-BCA9-4FB3-9D98-2066A5FBBB4D}). */
export type ScopesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scopes Folder template (ID: {44936C95-BCA9-4FB3-9D98-2066A5FBBB4D}). */
export type ScopesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Settings/Scopes Folder template (ID: {44936C95-BCA9-4FB3-9D98-2066A5FBBB4D}). */
export type ScopesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Scriban template (ID: {8FCD3CFE-8B3B-423E-8176-6A7C72CB43FC}). */
export type Scriban = BaseVariantField & Item & _DataAttributes & {
  __typename?: 'Scriban';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CssClass (ID: {7B5B7E8D-E579-44AA-8174-D4594DB0C2F9}). */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tag (ID: {8A85A595-3298-4EB1-96DD-C882EE5802AE}). */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Template (ID: {936E68B4-5346-4ADB-9B77-79771D0B40DC}). */
  template_936e68b453464adb9b7779771d0b40dc?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Scriban template (ID: {8FCD3CFE-8B3B-423E-8176-6A7C72CB43FC}). */
export type ScribanAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Scriban template (ID: {8FCD3CFE-8B3B-423E-8176-6A7C72CB43FC}). */
export type ScribanChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Scriban template (ID: {8FCD3CFE-8B3B-423E-8176-6A7C72CB43FC}). */
export type ScribanFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Scriban template (ID: {8FCD3CFE-8B3B-423E-8176-6A7C72CB43FC}). */
export type ScribanFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Scriban template (ID: {8FCD3CFE-8B3B-423E-8176-6A7C72CB43FC}). */
export type ScribanHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scriban/Scriban template (ID: {8FCD3CFE-8B3B-423E-8176-6A7C72CB43FC}). */
export type ScribanIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Scripts template (ID: {536EF8AE-E6DF-4AED-BD84-1F18DE8CEBF7}). */
export type Scripts = Item & {
  __typename?: 'Scripts';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Scripts template (ID: {536EF8AE-E6DF-4AED-BD84-1F18DE8CEBF7}). */
export type ScriptsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Scripts template (ID: {536EF8AE-E6DF-4AED-BD84-1F18DE8CEBF7}). */
export type ScriptsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Scripts template (ID: {536EF8AE-E6DF-4AED-BD84-1F18DE8CEBF7}). */
export type ScriptsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Scripts template (ID: {536EF8AE-E6DF-4AED-BD84-1F18DE8CEBF7}). */
export type ScriptsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Scripts template (ID: {536EF8AE-E6DF-4AED-BD84-1F18DE8CEBF7}). */
export type ScriptsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Scripts template (ID: {536EF8AE-E6DF-4AED-BD84-1F18DE8CEBF7}). */
export type ScriptsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Box template (ID: {85BC7A7F-DD82-4A5E-9DE1-99F38D38A698}). */
export type SearchBox = GridParameters & ICacheable & IComponentVariant & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'SearchBox';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** Default Language Filter (ID: {80B843F9-C114-4D25-B31D-BCF5719A7BEB}). */
  defaultLanguageFilter?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MaxPredictiveResultsCount (ID: {E619A1A3-684C-4A67-AE35-B9FF24385CE2}). */
  maxPredictiveResultsCount?: Maybe<IntegerField>;
  /** MinSuggestionsTriggerCharacterCount (ID: {C82418E9-09F7-4999-834B-2E92A3FB08E9}). */
  minSuggestionsTriggerCharacterCount?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Scope (ID: {A50B1622-0C89-4B44-BD32-24C098C63026}). */
  scope?: Maybe<LookupField>;
  /** Search Result Page (ID: {E88506B3-CA9F-40E7-B3B2-CE24E0FC4FFE}). */
  searchResultPage?: Maybe<LookupField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Search Text Box Visible (ID: {02FA2F4A-42A3-4610-98B6-26D273DF7136}). */
  searchTextBoxVisible?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Suggestions Mode (ID: {C8B4F409-BEE6-4A0D-BAA4-6A5D398507F3}). */
  suggestionsMode?: Maybe<TextField>;
  /** TargetSignature (ID: {948A385E-1154-4063-B9D2-0E3C261F0323}). */
  targetSignature?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Box template (ID: {85BC7A7F-DD82-4A5E-9DE1-99F38D38A698}). */
export type SearchBoxAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Box template (ID: {85BC7A7F-DD82-4A5E-9DE1-99F38D38A698}). */
export type SearchBoxChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Box template (ID: {85BC7A7F-DD82-4A5E-9DE1-99F38D38A698}). */
export type SearchBoxFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Box template (ID: {85BC7A7F-DD82-4A5E-9DE1-99F38D38A698}). */
export type SearchBoxFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Box template (ID: {85BC7A7F-DD82-4A5E-9DE1-99F38D38A698}). */
export type SearchBoxHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Box template (ID: {85BC7A7F-DD82-4A5E-9DE1-99F38D38A698}). */
export type SearchBoxIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Box Folder template (ID: {DA1CFA5B-8FAB-4E8A-BAA3-3B1F8D198EFD}). */
export type SearchBoxFolder = Item & {
  __typename?: 'SearchBoxFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Box Folder template (ID: {DA1CFA5B-8FAB-4E8A-BAA3-3B1F8D198EFD}). */
export type SearchBoxFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Box Folder template (ID: {DA1CFA5B-8FAB-4E8A-BAA3-3B1F8D198EFD}). */
export type SearchBoxFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Box Folder template (ID: {DA1CFA5B-8FAB-4E8A-BAA3-3B1F8D198EFD}). */
export type SearchBoxFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Box Folder template (ID: {DA1CFA5B-8FAB-4E8A-BAA3-3B1F8D198EFD}). */
export type SearchBoxFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Box Folder template (ID: {DA1CFA5B-8FAB-4E8A-BAA3-3B1F8D198EFD}). */
export type SearchBoxFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Box Folder template (ID: {DA1CFA5B-8FAB-4E8A-BAA3-3B1F8D198EFD}). */
export type SearchBoxFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Box template (ID: {1C04FD61-1D87-4590-ACFE-9CC186865AB3}). */
export type SearchBox_1c04fd611d874590acfe9cc186865ab3 = Item & {
  __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Search Button Text (ID: {A799C388-0D5E-4196-AC39-ADDC9F76756C}). */
  searchButtonText?: Maybe<TextField>;
  /** Search TextBox Label (ID: {143BC719-8C3F-42EB-9B1A-2DB64C7CFEB7}). */
  searchTextBoxLabel?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TextBox Text (ID: {7B0DCD82-5A3B-413C-AC54-E3F26ED2C37E}). */
  textBoxText?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Box template (ID: {1C04FD61-1D87-4590-ACFE-9CC186865AB3}). */
export type SearchBox_1c04fd611d874590acfe9cc186865ab3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Box template (ID: {1C04FD61-1D87-4590-ACFE-9CC186865AB3}). */
export type SearchBox_1c04fd611d874590acfe9cc186865ab3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Box template (ID: {1C04FD61-1D87-4590-ACFE-9CC186865AB3}). */
export type SearchBox_1c04fd611d874590acfe9cc186865ab3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Box template (ID: {1C04FD61-1D87-4590-ACFE-9CC186865AB3}). */
export type SearchBox_1c04fd611d874590acfe9cc186865ab3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Box template (ID: {1C04FD61-1D87-4590-ACFE-9CC186865AB3}). */
export type SearchBox_1c04fd611d874590acfe9cc186865ab3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Box template (ID: {1C04FD61-1D87-4590-ACFE-9CC186865AB3}). */
export type SearchBox_1c04fd611d874590acfe9cc186865ab3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Search Folder template (ID: {E32F0141-5506-44F6-A211-FB224756ECC0}). */
export type SearchFolder = Item & {
  __typename?: 'SearchFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Search Folder template (ID: {E32F0141-5506-44F6-A211-FB224756ECC0}). */
export type SearchFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Search Folder template (ID: {E32F0141-5506-44F6-A211-FB224756ECC0}). */
export type SearchFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Search Folder template (ID: {E32F0141-5506-44F6-A211-FB224756ECC0}). */
export type SearchFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Search Folder template (ID: {E32F0141-5506-44F6-A211-FB224756ECC0}). */
export type SearchFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Search Folder template (ID: {E32F0141-5506-44F6-A211-FB224756ECC0}). */
export type SearchFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Search Folder template (ID: {E32F0141-5506-44F6-A211-FB224756ECC0}). */
export type SearchFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Results template (ID: {8BBDA239-8756-4087-972B-9422333F5146}). */
export type SearchResults = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'SearchResults';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Auto Fire Search When No Criteria Set (ID: {C17B9A2E-306F-4E7E-B782-E8FBA57A29D4}). */
  autoFireSearchWhenNoCriteriaSet?: Maybe<CheckboxField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** Default Language Filter (ID: {50335A82-DB02-4B18-A280-A027346EDBD4}). */
  defaultLanguageFilter?: Maybe<LookupField>;
  /** Default Sort Order (ID: {5401947E-6EAA-4C21-87C8-5774EA8B09B6}). */
  defaultSortOrder?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Page Size (ID: {7AF6BC3F-5CF9-4207-BD99-319185B2197A}). */
  pageSize?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Scope (ID: {FA38C1AD-BC33-4991-9817-E2A1A6100605}). */
  scope?: Maybe<LookupField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Results template (ID: {8BBDA239-8756-4087-972B-9422333F5146}). */
export type SearchResultsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Results template (ID: {8BBDA239-8756-4087-972B-9422333F5146}). */
export type SearchResultsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Results template (ID: {8BBDA239-8756-4087-972B-9422333F5146}). */
export type SearchResultsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Results template (ID: {8BBDA239-8756-4087-972B-9422333F5146}). */
export type SearchResultsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Results template (ID: {8BBDA239-8756-4087-972B-9422333F5146}). */
export type SearchResultsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Search Results template (ID: {8BBDA239-8756-4087-972B-9422333F5146}). */
export type SearchResultsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Results Folder template (ID: {F1C4144C-1B74-4916-A918-41CD68F3980F}). */
export type SearchResultsFolder = Item & {
  __typename?: 'SearchResultsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Results Folder template (ID: {F1C4144C-1B74-4916-A918-41CD68F3980F}). */
export type SearchResultsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Results Folder template (ID: {F1C4144C-1B74-4916-A918-41CD68F3980F}). */
export type SearchResultsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Results Folder template (ID: {F1C4144C-1B74-4916-A918-41CD68F3980F}). */
export type SearchResultsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Results Folder template (ID: {F1C4144C-1B74-4916-A918-41CD68F3980F}). */
export type SearchResultsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Results Folder template (ID: {F1C4144C-1B74-4916-A918-41CD68F3980F}). */
export type SearchResultsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Search Results Folder template (ID: {F1C4144C-1B74-4916-A918-41CD68F3980F}). */
export type SearchResultsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Results template (ID: {A06F7130-041D-46BB-8C29-95A2DC00C26A}). */
export type SearchResults_A06f7130041d46bb8c2995a2dc00c26a = Item & {
  __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Results Not Found Text (ID: {904CB4CA-42D1-4690-8A99-9ECF22855E88}). */
  resultsNotFoundText?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Results template (ID: {A06F7130-041D-46BB-8C29-95A2DC00C26A}). */
export type SearchResults_A06f7130041d46bb8c2995a2dc00c26aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Results template (ID: {A06F7130-041D-46BB-8C29-95A2DC00C26A}). */
export type SearchResults_A06f7130041d46bb8c2995a2dc00c26aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Results template (ID: {A06F7130-041D-46BB-8C29-95A2DC00C26A}). */
export type SearchResults_A06f7130041d46bb8c2995a2dc00c26aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Results template (ID: {A06F7130-041D-46BB-8C29-95A2DC00C26A}). */
export type SearchResults_A06f7130041d46bb8c2995a2dc00c26aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Results template (ID: {A06F7130-041D-46BB-8C29-95A2DC00C26A}). */
export type SearchResults_A06f7130041d46bb8c2995a2dc00c26aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Search Results template (ID: {A06F7130-041D-46BB-8C29-95A2DC00C26A}). */
export type SearchResults_A06f7130041d46bb8c2995a2dc00c26aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Secondary Hero Banner Parameters Template template (ID: {B344133C-515B-4EF7-A9E4-24E4A401815B}). */
export type SecondaryHeroBannerParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'SecondaryHeroBannerParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** linkType (ID: {C2F3AA2E-CE41-45F6-9622-E99B3EE311E8}). */
  linkType?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Secondary Hero Banner Parameters Template template (ID: {B344133C-515B-4EF7-A9E4-24E4A401815B}). */
export type SecondaryHeroBannerParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Secondary Hero Banner Parameters Template template (ID: {B344133C-515B-4EF7-A9E4-24E4A401815B}). */
export type SecondaryHeroBannerParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Secondary Hero Banner Parameters Template template (ID: {B344133C-515B-4EF7-A9E4-24E4A401815B}). */
export type SecondaryHeroBannerParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Secondary Hero Banner Parameters Template template (ID: {B344133C-515B-4EF7-A9E4-24E4A401815B}). */
export type SecondaryHeroBannerParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Secondary Hero Banner Parameters Template template (ID: {B344133C-515B-4EF7-A9E4-24E4A401815B}). */
export type SecondaryHeroBannerParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Secondary Hero Banner Parameters Template template (ID: {B344133C-515B-4EF7-A9E4-24E4A401815B}). */
export type SecondaryHeroBannerParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading template (ID: {C056E17A-6FB0-495F-9403-CD51B81148FA}). */
export type SectionHeading = Item & {
  __typename?: 'SectionHeading';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {CE5ADF97-9572-409B-932B-9DD9B7237AC6}). */
  cta?: Maybe<TextField>;
  /** description (ID: {FB3DB9E0-3FF8-4C75-9027-A52F1CEDF0E7}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** icon (ID: {745E5A1C-C2BA-4D31-80DF-3FBDA08FB351}). */
  icon_745e5a1cc2ba4d3180df3fbda08fb351?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {023A9F4D-D15C-4D83-89FA-08D2F1B9A6BD}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading template (ID: {C056E17A-6FB0-495F-9403-CD51B81148FA}). */
export type SectionHeadingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading template (ID: {C056E17A-6FB0-495F-9403-CD51B81148FA}). */
export type SectionHeadingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading template (ID: {C056E17A-6FB0-495F-9403-CD51B81148FA}). */
export type SectionHeadingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading template (ID: {C056E17A-6FB0-495F-9403-CD51B81148FA}). */
export type SectionHeadingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading template (ID: {C056E17A-6FB0-495F-9403-CD51B81148FA}). */
export type SectionHeadingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading template (ID: {C056E17A-6FB0-495F-9403-CD51B81148FA}). */
export type SectionHeadingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading Folder template (ID: {867B4189-362A-49FC-B0CF-EB4CF4437C5F}). */
export type SectionHeadingFolder = Item & {
  __typename?: 'SectionHeadingFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading Folder template (ID: {867B4189-362A-49FC-B0CF-EB4CF4437C5F}). */
export type SectionHeadingFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading Folder template (ID: {867B4189-362A-49FC-B0CF-EB4CF4437C5F}). */
export type SectionHeadingFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading Folder template (ID: {867B4189-362A-49FC-B0CF-EB4CF4437C5F}). */
export type SectionHeadingFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading Folder template (ID: {867B4189-362A-49FC-B0CF-EB4CF4437C5F}). */
export type SectionHeadingFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading Folder template (ID: {867B4189-362A-49FC-B0CF-EB4CF4437C5F}). */
export type SectionHeadingFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Heading/Section Heading Folder template (ID: {867B4189-362A-49FC-B0CF-EB4CF4437C5F}). */
export type SectionHeadingFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Section Heading Parameters Template template (ID: {C0138AB2-C091-439C-807C-EA52F554C687}). */
export type SectionHeadingParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'SectionHeadingParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {69178794-DA80-409B-AAAC-F7C131BEDB44}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** type (ID: {D146F6C4-334F-4F2C-B9C6-B7350863B76F}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Section Heading Parameters Template template (ID: {C0138AB2-C091-439C-807C-EA52F554C687}). */
export type SectionHeadingParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Section Heading Parameters Template template (ID: {C0138AB2-C091-439C-807C-EA52F554C687}). */
export type SectionHeadingParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Section Heading Parameters Template template (ID: {C0138AB2-C091-439C-807C-EA52F554C687}). */
export type SectionHeadingParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Section Heading Parameters Template template (ID: {C0138AB2-C091-439C-807C-EA52F554C687}). */
export type SectionHeadingParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Section Heading Parameters Template template (ID: {C0138AB2-C091-439C-807C-EA52F554C687}). */
export type SectionHeadingParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Section Heading Parameters Template template (ID: {C0138AB2-C091-439C-807C-EA52F554C687}). */
export type SectionHeadingParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type template (ID: {939D1BC6-D9E0-46AE-A47E-EB61805E02A7}). */
export type SectionHeadingType = Item & {
  __typename?: 'SectionHeadingType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type template (ID: {939D1BC6-D9E0-46AE-A47E-EB61805E02A7}). */
export type SectionHeadingTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type template (ID: {939D1BC6-D9E0-46AE-A47E-EB61805E02A7}). */
export type SectionHeadingTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type template (ID: {939D1BC6-D9E0-46AE-A47E-EB61805E02A7}). */
export type SectionHeadingTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type template (ID: {939D1BC6-D9E0-46AE-A47E-EB61805E02A7}). */
export type SectionHeadingTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type template (ID: {939D1BC6-D9E0-46AE-A47E-EB61805E02A7}). */
export type SectionHeadingTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type template (ID: {939D1BC6-D9E0-46AE-A47E-EB61805E02A7}). */
export type SectionHeadingTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type Folder template (ID: {88A5697D-539D-4A61-A504-AF8A9C825D83}). */
export type SectionHeadingTypeFolder = Item & {
  __typename?: 'SectionHeadingTypeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type Folder template (ID: {88A5697D-539D-4A61-A504-AF8A9C825D83}). */
export type SectionHeadingTypeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type Folder template (ID: {88A5697D-539D-4A61-A504-AF8A9C825D83}). */
export type SectionHeadingTypeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type Folder template (ID: {88A5697D-539D-4A61-A504-AF8A9C825D83}). */
export type SectionHeadingTypeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type Folder template (ID: {88A5697D-539D-4A61-A504-AF8A9C825D83}). */
export type SectionHeadingTypeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type Folder template (ID: {88A5697D-539D-4A61-A504-AF8A9C825D83}). */
export type SectionHeadingTypeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Section Heading/Section Heading Type Folder template (ID: {88A5697D-539D-4A61-A504-AF8A9C825D83}). */
export type SectionHeadingTypeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector template (ID: {3D06C4E9-F144-4647-9D80-83549C38481C}). */
export type SectionSelector = Item & {
  __typename?: 'SectionSelector';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {058D2A90-BE86-4ED7-8756-828D02D706DD}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** subtitle (ID: {0C68C94A-9C67-40A6-844C-C6E886312324}). */
  subtitle?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {FC65774A-A162-4C58-87EE-D23BC3C21D56}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector template (ID: {3D06C4E9-F144-4647-9D80-83549C38481C}). */
export type SectionSelectorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector template (ID: {3D06C4E9-F144-4647-9D80-83549C38481C}). */
export type SectionSelectorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector template (ID: {3D06C4E9-F144-4647-9D80-83549C38481C}). */
export type SectionSelectorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector template (ID: {3D06C4E9-F144-4647-9D80-83549C38481C}). */
export type SectionSelectorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector template (ID: {3D06C4E9-F144-4647-9D80-83549C38481C}). */
export type SectionSelectorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector template (ID: {3D06C4E9-F144-4647-9D80-83549C38481C}). */
export type SectionSelectorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Folder template (ID: {31BE921F-4BC1-403F-9F69-6831C663FDCE}). */
export type SectionSelectorFolder = Item & {
  __typename?: 'SectionSelectorFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Folder template (ID: {31BE921F-4BC1-403F-9F69-6831C663FDCE}). */
export type SectionSelectorFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Folder template (ID: {31BE921F-4BC1-403F-9F69-6831C663FDCE}). */
export type SectionSelectorFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Folder template (ID: {31BE921F-4BC1-403F-9F69-6831C663FDCE}). */
export type SectionSelectorFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Folder template (ID: {31BE921F-4BC1-403F-9F69-6831C663FDCE}). */
export type SectionSelectorFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Folder template (ID: {31BE921F-4BC1-403F-9F69-6831C663FDCE}). */
export type SectionSelectorFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Folder template (ID: {31BE921F-4BC1-403F-9F69-6831C663FDCE}). */
export type SectionSelectorFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Tab template (ID: {643F9224-37B9-4D00-B35F-7E9D72CAC674}). */
export type SectionSelectorTab = Item & {
  __typename?: 'SectionSelectorTab';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pictogram (ID: {ABD00ABB-6118-46E1-A502-CF3742AC121A}). */
  pictogram?: Maybe<ImageField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {E9C7BCAC-DD10-447A-8D09-947873847F78}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Tab template (ID: {643F9224-37B9-4D00-B35F-7E9D72CAC674}). */
export type SectionSelectorTabAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Tab template (ID: {643F9224-37B9-4D00-B35F-7E9D72CAC674}). */
export type SectionSelectorTabChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Tab template (ID: {643F9224-37B9-4D00-B35F-7E9D72CAC674}). */
export type SectionSelectorTabFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Tab template (ID: {643F9224-37B9-4D00-B35F-7E9D72CAC674}). */
export type SectionSelectorTabFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Tab template (ID: {643F9224-37B9-4D00-B35F-7E9D72CAC674}). */
export type SectionSelectorTabHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Section Selector/Section Selector Tab template (ID: {643F9224-37B9-4D00-B35F-7E9D72CAC674}). */
export type SectionSelectorTabIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Security template (ID: {33077D51-EBAD-4D1C-B4A8-3B79F51DBA13}). */
export type Security_33077d51ebad4d1cb4a83b79f51dba13 = Item & {
  __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Security template (ID: {33077D51-EBAD-4D1C-B4A8-3B79F51DBA13}). */
export type Security_33077d51ebad4d1cb4a83b79f51dba13AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Security template (ID: {33077D51-EBAD-4D1C-B4A8-3B79F51DBA13}). */
export type Security_33077d51ebad4d1cb4a83b79f51dba13ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Security template (ID: {33077D51-EBAD-4D1C-B4A8-3B79F51DBA13}). */
export type Security_33077d51ebad4d1cb4a83b79f51dba13FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Security template (ID: {33077D51-EBAD-4D1C-B4A8-3B79F51DBA13}). */
export type Security_33077d51ebad4d1cb4a83b79f51dba13FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Security template (ID: {33077D51-EBAD-4D1C-B4A8-3B79F51DBA13}). */
export type Security_33077d51ebad4d1cb4a83b79f51dba13HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Datasource/Security template (ID: {33077D51-EBAD-4D1C-B4A8-3B79F51DBA13}). */
export type Security_33077d51ebad4d1cb4a83b79f51dba13IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series template (ID: {4E9F2E28-D6FF-47DB-BF72-CE28A860AB4E}). */
export type Series = Item & {
  __typename?: 'Series';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {A9A3F692-2CB5-4797-9FBA-8FF8685942D1}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {88ECDC82-2DB0-4A84-B3AB-248F51212D42}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {6C4025E5-3F29-4E7B-BCCE-6E8D9BF34675}). */
  name_6c4025e53f294e7bbcce6e8d9bf34675?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series template (ID: {4E9F2E28-D6FF-47DB-BF72-CE28A860AB4E}). */
export type SeriesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series template (ID: {4E9F2E28-D6FF-47DB-BF72-CE28A860AB4E}). */
export type SeriesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series template (ID: {4E9F2E28-D6FF-47DB-BF72-CE28A860AB4E}). */
export type SeriesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series template (ID: {4E9F2E28-D6FF-47DB-BF72-CE28A860AB4E}). */
export type SeriesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series template (ID: {4E9F2E28-D6FF-47DB-BF72-CE28A860AB4E}). */
export type SeriesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series template (ID: {4E9F2E28-D6FF-47DB-BF72-CE28A860AB4E}). */
export type SeriesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series Folder template (ID: {FC88BE56-3809-4547-9D3C-0494EDC1A2CE}). */
export type SeriesFolder = Item & {
  __typename?: 'SeriesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series Folder template (ID: {FC88BE56-3809-4547-9D3C-0494EDC1A2CE}). */
export type SeriesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series Folder template (ID: {FC88BE56-3809-4547-9D3C-0494EDC1A2CE}). */
export type SeriesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series Folder template (ID: {FC88BE56-3809-4547-9D3C-0494EDC1A2CE}). */
export type SeriesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series Folder template (ID: {FC88BE56-3809-4547-9D3C-0494EDC1A2CE}). */
export type SeriesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series Folder template (ID: {FC88BE56-3809-4547-9D3C-0494EDC1A2CE}). */
export type SeriesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Series/Series Folder template (ID: {FC88BE56-3809-4547-9D3C-0494EDC1A2CE}). */
export type SeriesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Settings template (ID: {8517DBE7-68BC-4700-AD41-379C4EBB76A0}). */
export type Settings = Item & ItemBucketsSettings & _BaseSettings & _LinkSettings & {
  __typename?: 'Settings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibrary (ID: {E81E1F9E-8B87-495B-9CB7-84A2A23133BE}). */
  mediaLibrary?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Settings template (ID: {8517DBE7-68BC-4700-AD41-379C4EBB76A0}). */
export type SettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Settings template (ID: {8517DBE7-68BC-4700-AD41-379C4EBB76A0}). */
export type SettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Settings template (ID: {8517DBE7-68BC-4700-AD41-379C4EBB76A0}). */
export type SettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Settings template (ID: {8517DBE7-68BC-4700-AD41-379C4EBB76A0}). */
export type SettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Settings template (ID: {8517DBE7-68BC-4700-AD41-379C4EBB76A0}). */
export type SettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Settings template (ID: {8517DBE7-68BC-4700-AD41-379C4EBB76A0}). */
export type SettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Settings Folder template (ID: {B4D86F9B-E917-4D68-978E-741361332174}). */
export type SettingsFolder = Item & {
  __typename?: 'SettingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Settings Folder template (ID: {B4D86F9B-E917-4D68-978E-741361332174}). */
export type SettingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Settings Folder template (ID: {B4D86F9B-E917-4D68-978E-741361332174}). */
export type SettingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Settings Folder template (ID: {B4D86F9B-E917-4D68-978E-741361332174}). */
export type SettingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Settings Folder template (ID: {B4D86F9B-E917-4D68-978E-741361332174}). */
export type SettingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Settings Folder template (ID: {B4D86F9B-E917-4D68-978E-741361332174}). */
export type SettingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Folders/Settings Folder template (ID: {B4D86F9B-E917-4D68-978E-741361332174}). */
export type SettingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Shared Folders/Settings template (ID: {6C82CACA-67DC-4641-9569-8FAAD083230E}). */
export type Settings_6c82caca67dc464195698faad083230e = IfEaaSComponentsDataSourceTemplates & IfEaaSComponentsEditorScriptUrl & Item & ItemBucketsSettings & JssSettings & _BaseSettings & _EditingTheme & _ErrorHandling & _GridMapping & _LinkSettings & _RobotsContent & _SupportedLanguages & {
  __typename?: 'Settings_6c82caca67dc464195698faad083230e';
  /** AnalyzeAllowedControls (ID: {812DEDEB-C5BD-471C-9F48-B1CE75D0D4A9}). */
  analyzeAllowedControls?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AppDatasourcesPath (ID: {5764D2D4-724D-4313-A81B-9246C911FAFF}). */
  appDatasourcesPath?: Maybe<LookupField>;
  /** AppTemplate (ID: {32CE6BBE-4217-46E5-9335-42793884CBE3}). */
  appTemplate?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Component data source templates (ID: {9CE73B35-34D3-49DC-BD5A-CE1E8267FDA9}). */
  componentDataSourceTemplates?: Maybe<MultilistField>;
  /** ComponentEditorScript (ID: {9CBC4D47-1608-4A43-AC9C-6EB461FE58F5}). */
  componentEditorScript?: Maybe<TextField>;
  /** DatasourceStrategy (ID: {F7C6ACFB-63F0-4ACA-9E44-3133B2B94A5B}). */
  datasourceStrategy?: Maybe<TextField>;
  /** DebugSecurity (ID: {A5C4B74E-993A-40D6-AEAB-23BB12ABCF0A}). */
  debugSecurity?: Maybe<CheckboxField>;
  /** DefaultWorkflow (ID: {3AF0E329-6D5E-4D8F-9F82-F48265658A3E}). */
  defaultWorkflow?: Maybe<LookupField>;
  /** DeploymentSecret (ID: {797D2F63-D5C4-4C4C-B21F-D3E250E2AB12}). */
  deploymentSecret?: Maybe<TextField>;
  /** DictionaryDomain (ID: {0129DA3F-8C86-4591-AE32-6EC923413923}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** DictionaryPath (ID: {A7BBAD73-B933-49FF-95C8-1C269CB35E7C}). */
  dictionaryPath?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilesystemPath (ID: {72E83C8D-3578-4E50-B4C0-93A78A1729F2}). */
  filesystemPath?: Maybe<TextField>;
  /** FolderTemplate (ID: {BDE120A5-4CC2-4340-9B63-562A139BF197}). */
  folderTemplate?: Maybe<LookupField>;
  /** GraphQLEndpoint (ID: {30E0A829-637E-478C-A136-66ADB568398D}). */
  graphQLEndpoint?: Maybe<TextField>;
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ImportDatabase (ID: {DF376030-46E9-4C77-BC05-DEBEFC86E3D5}). */
  importDatabase?: Maybe<TextField>;
  /** ImportDevice (ID: {1F14AA04-2868-481F-9247-30DC5C65672C}). */
  importDevice?: Maybe<LookupField>;
  /** ImportLanguage (ID: {04E6B1F3-AE47-4D95-A154-2271075869A9}). */
  importLanguage?: Maybe<TextField>;
  /** ImportUser (ID: {F87F0D81-C32C-4C1D-8CAF-67856C3AB06E}). */
  importUser?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LayoutFolderTemplate (ID: {466902A9-6B16-41B1-9D33-7C55094A2713}). */
  layoutFolderTemplate?: Maybe<LookupField>;
  /** LayoutPath (ID: {C8D002F9-9518-4C5E-9BAA-6617E13F0797}). */
  layoutPath?: Maybe<LookupField>;
  /** LayoutServiceConfiguration (ID: {E3259313-387A-41F0-B113-962F14B1AA2B}). */
  layoutServiceConfiguration?: Maybe<TextField>;
  /** LayoutTemplate (ID: {E13C1A83-9D60-4530-B318-3A5EFFCC6338}). */
  layoutTemplate?: Maybe<LookupField>;
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
  /** MediaLibraryFolderTemplate (ID: {1CC82067-2B48-442A-A352-453D56A49D93}). */
  mediaLibraryFolderTemplate?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** App Name (ID: {3E4F559F-8E59-4405-B50D-619811371F6C}). */
  name_3e4f559f8e594405b50d619811371f6c?: Maybe<TextField>;
  /** Opening Search Results (ID: {5A81D794-7364-4CC5-8AA9-A921D5DDA4AF}). */
  openingSearchResults?: Maybe<TextField>;
  /** OptimizeImportIndexing (ID: {4088F63E-09E5-43FA-AE99-829BD9BDC114}). */
  optimizeImportIndexing?: Maybe<CheckboxField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolderTemplate (ID: {F5594251-F757-429E-A9BD-07F65F6875B9}). */
  placeholderSettingsFolderTemplate?: Maybe<LookupField>;
  /** PlaceholdersPath (ID: {5CA117EB-8782-4A4F-9F2F-30DE31FC2E34}). */
  placeholdersPath?: Maybe<LookupField>;
  /** ProtectDeveloperItems (ID: {B0711DF7-724A-4C6C-8D4D-BE846DE6124C}). */
  protectDeveloperItems?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolderTemplate (ID: {F5821C4C-226E-4953-8213-C0243826F85F}). */
  renderingsFolderTemplate?: Maybe<LookupField>;
  /** RenderingsPath (ID: {F29428D5-1285-48B8-A884-44057965829A}). */
  renderingsPath?: Maybe<LookupField>;
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
  /** RouteBaseTemplate (ID: {396AF2F6-FE48-4FD4-A7E2-3DA13EF977EB}). */
  routeBaseTemplate?: Maybe<LookupField>;
  /** RouteDatasourcesPath (ID: {414F61DD-02C2-47D1-BA83-DCFBC3071E52}). */
  routeDatasourcesPath?: Maybe<TextField>;
  /** RouteTemplateName (ID: {300FB7A0-B27F-44DD-9AF0-B37A19723E0E}). */
  routeTemplateName?: Maybe<TextField>;
  /** Rule (ID: {4B5D1CB7-E617-4CD0-A7E8-CC8A9FD80688}). */
  rule?: Maybe<TextField>;
  /** ServerBundle (ID: {4A3EEBA3-A250-44F4-BD97-6E863CC6F0D5}). */
  serverBundle?: Maybe<TextField>;
  /** ServerSideRenderingEngine (ID: {9016141C-FF51-40F2-9135-40F5161B9784}). */
  serverSideRenderingEngine?: Maybe<TextField>;
  /** ServerSideRenderingEngineApplicationUrl (ID: {5E8ED724-126A-4BB7-8106-85C2D1042C9E}). */
  serverSideRenderingEngineApplicationUrl?: Maybe<TextField>;
  /** ServerSideRenderingEngineEditOnly (ID: {557D5F36-6F2D-4EB6-A8CE-25F30F7B9397}). */
  serverSideRenderingEngineEditOnly?: Maybe<CheckboxField>;
  /** ServerSideRenderingEngineEndpointUrl (ID: {89849738-34EE-46BC-B525-825F1153189E}). */
  serverSideRenderingEngineEndpointUrl?: Maybe<TextField>;
  /** ServerSideRenderingFunctionName (ID: {7975673A-AAFD-4C5B-96A5-CBCAAC500A44}). */
  serverSideRenderingFunctionName?: Maybe<TextField>;
  /** ServerSideRenderingWorkerProcesses (ID: {6224A1CE-D964-4EE8-8E09-AD2F81E0A2B6}). */
  serverSideRenderingWorkerProcesses?: Maybe<IntegerField>;
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
  /** Tag Parent (ID: {37AC831A-7CB4-4962-AEBD-A269649E5D35}). */
  tagParent?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TemplateFolderTemplate (ID: {218760C0-8001-4C2D-A8B0-61C128276F96}). */
  templateFolderTemplate?: Maybe<LookupField>;
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** UseLanguageSpecificLayout (ID: {1864E99D-C29A-40BF-96E0-B3E7896A013B}). */
  useLanguageSpecificLayout?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Shared Folders/Settings template (ID: {6C82CACA-67DC-4641-9569-8FAAD083230E}). */
export type Settings_6c82caca67dc464195698faad083230eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Shared Folders/Settings template (ID: {6C82CACA-67DC-4641-9569-8FAAD083230E}). */
export type Settings_6c82caca67dc464195698faad083230eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Shared Folders/Settings template (ID: {6C82CACA-67DC-4641-9569-8FAAD083230E}). */
export type Settings_6c82caca67dc464195698faad083230eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Shared Folders/Settings template (ID: {6C82CACA-67DC-4641-9569-8FAAD083230E}). */
export type Settings_6c82caca67dc464195698faad083230eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Shared Folders/Settings template (ID: {6C82CACA-67DC-4641-9569-8FAAD083230E}). */
export type Settings_6c82caca67dc464195698faad083230eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Shared Folders/Settings template (ID: {6C82CACA-67DC-4641-9569-8FAAD083230E}). */
export type Settings_6c82caca67dc464195698faad083230eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Share Price Settings/Share Price Settings template (ID: {07A1C8C1-7A48-4B06-8B25-7FDB2F4D2DA4}). */
export type SharePriceSettings = Item & {
  __typename?: 'SharePriceSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** sharePriceCta (ID: {A1BF80DA-E633-4A01-BB64-5860DD97DF1E}). */
  sharePriceCta?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Share Price Settings/Share Price Settings template (ID: {07A1C8C1-7A48-4B06-8B25-7FDB2F4D2DA4}). */
export type SharePriceSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Share Price Settings/Share Price Settings template (ID: {07A1C8C1-7A48-4B06-8B25-7FDB2F4D2DA4}). */
export type SharePriceSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Share Price Settings/Share Price Settings template (ID: {07A1C8C1-7A48-4B06-8B25-7FDB2F4D2DA4}). */
export type SharePriceSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Share Price Settings/Share Price Settings template (ID: {07A1C8C1-7A48-4B06-8B25-7FDB2F4D2DA4}). */
export type SharePriceSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Share Price Settings/Share Price Settings template (ID: {07A1C8C1-7A48-4B06-8B25-7FDB2F4D2DA4}). */
export type SharePriceSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Settings/Share Price Settings/Share Price Settings template (ID: {07A1C8C1-7A48-4B06-8B25-7FDB2F4D2DA4}). */
export type SharePriceSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Articles Folder template (ID: {D59ADE0E-E301-4C2D-8FEC-34F80AC921F0}). */
export type SharedArticlesFolder = HeadlessSite & Item & _Description & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _SiteMediaLibrary & _SiteTemplate & {
  __typename?: 'SharedArticlesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Articles Folder template (ID: {D59ADE0E-E301-4C2D-8FEC-34F80AC921F0}). */
export type SharedArticlesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Articles Folder template (ID: {D59ADE0E-E301-4C2D-8FEC-34F80AC921F0}). */
export type SharedArticlesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Articles Folder template (ID: {D59ADE0E-E301-4C2D-8FEC-34F80AC921F0}). */
export type SharedArticlesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Articles Folder template (ID: {D59ADE0E-E301-4C2D-8FEC-34F80AC921F0}). */
export type SharedArticlesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Articles Folder template (ID: {D59ADE0E-E301-4C2D-8FEC-34F80AC921F0}). */
export type SharedArticlesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Articles Folder template (ID: {D59ADE0E-E301-4C2D-8FEC-34F80AC921F0}). */
export type SharedArticlesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Content Folder template (ID: {433B7BEF-AD78-415D-BAD1-A7115E14B60D}). */
export type SharedContentFolder = Item & {
  __typename?: 'SharedContentFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Content Folder template (ID: {433B7BEF-AD78-415D-BAD1-A7115E14B60D}). */
export type SharedContentFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Content Folder template (ID: {433B7BEF-AD78-415D-BAD1-A7115E14B60D}). */
export type SharedContentFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Content Folder template (ID: {433B7BEF-AD78-415D-BAD1-A7115E14B60D}). */
export type SharedContentFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Content Folder template (ID: {433B7BEF-AD78-415D-BAD1-A7115E14B60D}). */
export type SharedContentFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Content Folder template (ID: {433B7BEF-AD78-415D-BAD1-A7115E14B60D}). */
export type SharedContentFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Content Folder template (ID: {433B7BEF-AD78-415D-BAD1-A7115E14B60D}). */
export type SharedContentFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Folder template (ID: {494B4005-3B2B-4E78-A376-71E1596575EC}). */
export type SharedFolder = HeadlessTenant & Item & _BaseJssTenant & _BaseTenant & _Description & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & {
  __typename?: 'SharedFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Folder template (ID: {494B4005-3B2B-4E78-A376-71E1596575EC}). */
export type SharedFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Folder template (ID: {494B4005-3B2B-4E78-A376-71E1596575EC}). */
export type SharedFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Folder template (ID: {494B4005-3B2B-4E78-A376-71E1596575EC}). */
export type SharedFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Folder template (ID: {494B4005-3B2B-4E78-A376-71E1596575EC}). */
export type SharedFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Folder template (ID: {494B4005-3B2B-4E78-A376-71E1596575EC}). */
export type SharedFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Folder template (ID: {494B4005-3B2B-4E78-A376-71E1596575EC}). */
export type SharedFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Help Articles Folder template (ID: {D40621F7-A462-46FD-81AD-8A86FD405885}). */
export type SharedHelpArticlesFolder = HeadlessSite & Item & _Description & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _SiteMediaLibrary & _SiteTemplate & {
  __typename?: 'SharedHelpArticlesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Help Articles Folder template (ID: {D40621F7-A462-46FD-81AD-8A86FD405885}). */
export type SharedHelpArticlesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Help Articles Folder template (ID: {D40621F7-A462-46FD-81AD-8A86FD405885}). */
export type SharedHelpArticlesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Help Articles Folder template (ID: {D40621F7-A462-46FD-81AD-8A86FD405885}). */
export type SharedHelpArticlesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Help Articles Folder template (ID: {D40621F7-A462-46FD-81AD-8A86FD405885}). */
export type SharedHelpArticlesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Help Articles Folder template (ID: {D40621F7-A462-46FD-81AD-8A86FD405885}). */
export type SharedHelpArticlesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Help Articles Folder template (ID: {D40621F7-A462-46FD-81AD-8A86FD405885}). */
export type SharedHelpArticlesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Press Releases Folder template (ID: {6EDA1F02-A24B-4549-BCD7-DFDFD2F9D816}). */
export type SharedPressReleasesFolder = HeadlessSite & Item & _Description & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _SiteMediaLibrary & _SiteTemplate & {
  __typename?: 'SharedPressReleasesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Press Releases Folder template (ID: {6EDA1F02-A24B-4549-BCD7-DFDFD2F9D816}). */
export type SharedPressReleasesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Press Releases Folder template (ID: {6EDA1F02-A24B-4549-BCD7-DFDFD2F9D816}). */
export type SharedPressReleasesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Press Releases Folder template (ID: {6EDA1F02-A24B-4549-BCD7-DFDFD2F9D816}). */
export type SharedPressReleasesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Press Releases Folder template (ID: {6EDA1F02-A24B-4549-BCD7-DFDFD2F9D816}). */
export type SharedPressReleasesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Press Releases Folder template (ID: {6EDA1F02-A24B-4549-BCD7-DFDFD2F9D816}). */
export type SharedPressReleasesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Folders/Shared Press Releases Folder template (ID: {6EDA1F02-A24B-4549-BCD7-DFDFD2F9D816}). */
export type SharedPressReleasesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Settings Folder template (ID: {41588A5F-408D-4AAB-8BC1-ED2230503E03}). */
export type SharedSettingsFolder = Item & {
  __typename?: 'SharedSettingsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Settings Folder template (ID: {41588A5F-408D-4AAB-8BC1-ED2230503E03}). */
export type SharedSettingsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Settings Folder template (ID: {41588A5F-408D-4AAB-8BC1-ED2230503E03}). */
export type SharedSettingsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Settings Folder template (ID: {41588A5F-408D-4AAB-8BC1-ED2230503E03}). */
export type SharedSettingsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Settings Folder template (ID: {41588A5F-408D-4AAB-8BC1-ED2230503E03}). */
export type SharedSettingsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Settings Folder template (ID: {41588A5F-408D-4AAB-8BC1-ED2230503E03}). */
export type SharedSettingsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Shared Settings Folder template (ID: {41588A5F-408D-4AAB-8BC1-ED2230503E03}). */
export type SharedSettingsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Shared Sites Settings template (ID: {18D0BD79-7DA4-4C2A-A924-B93A2B99D669}). */
export type SharedSitesSettings = Item & _BaseSharedSitesSettings & {
  __typename?: 'SharedSitesSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Delegated Areas (ID: {D5E1CC0E-0D69-4A31-8321-13994D5ACCF6}). */
  delegatedAreas?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Shared Sites Settings template (ID: {18D0BD79-7DA4-4C2A-A924-B93A2B99D669}). */
export type SharedSitesSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Shared Sites Settings template (ID: {18D0BD79-7DA4-4C2A-A924-B93A2B99D669}). */
export type SharedSitesSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Shared Sites Settings template (ID: {18D0BD79-7DA4-4C2A-A924-B93A2B99D669}). */
export type SharedSitesSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Shared Sites Settings template (ID: {18D0BD79-7DA4-4C2A-A924-B93A2B99D669}). */
export type SharedSitesSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Shared Sites Settings template (ID: {18D0BD79-7DA4-4C2A-A924-B93A2B99D669}). */
export type SharedSitesSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Shared Sites Settings template (ID: {18D0BD79-7DA4-4C2A-A924-B93A2B99D669}). */
export type SharedSitesSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Shared Sites Settings template (ID: {C14BF746-030F-4E59-8594-395F6D299E61}). */
export type SharedSitesSettings_C14bf746030f4e598594395f6d299e61 = Item & _BaseSharedSitesSettings & {
  __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Delegated Areas (ID: {D5E1CC0E-0D69-4A31-8321-13994D5ACCF6}). */
  delegatedAreas?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Shared Sites Settings template (ID: {C14BF746-030F-4E59-8594-395F6D299E61}). */
export type SharedSitesSettings_C14bf746030f4e598594395f6d299e61AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Shared Sites Settings template (ID: {C14BF746-030F-4E59-8594-395F6D299E61}). */
export type SharedSitesSettings_C14bf746030f4e598594395f6d299e61ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Shared Sites Settings template (ID: {C14BF746-030F-4E59-8594-395F6D299E61}). */
export type SharedSitesSettings_C14bf746030f4e598594395f6d299e61FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Shared Sites Settings template (ID: {C14BF746-030F-4E59-8594-395F6D299E61}). */
export type SharedSitesSettings_C14bf746030f4e598594395f6d299e61FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Shared Sites Settings template (ID: {C14BF746-030F-4E59-8594-395F6D299E61}). */
export type SharedSitesSettings_C14bf746030f4e598594395f6d299e61HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Shared Sites Settings template (ID: {C14BF746-030F-4E59-8594-395F6D299E61}). */
export type SharedSitesSettings_C14bf746030f4e598594395f6d299e61IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase template (ID: {5974FFC3-52F3-4655-AAB4-87D4BFD59D8D}). */
export type Showcase = Item & {
  __typename?: 'Showcase';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {83DFBCD5-5E53-456F-8717-834C2AFDEFCA}). */
  cta?: Maybe<TextField>;
  /** description (ID: {8B8822F2-6632-4A5C-B8EC-510C3A65A104}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {BB61FD66-9FA4-4A72-B19E-43C89A9ABAD8}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase template (ID: {5974FFC3-52F3-4655-AAB4-87D4BFD59D8D}). */
export type ShowcaseAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase template (ID: {5974FFC3-52F3-4655-AAB4-87D4BFD59D8D}). */
export type ShowcaseChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase template (ID: {5974FFC3-52F3-4655-AAB4-87D4BFD59D8D}). */
export type ShowcaseFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase template (ID: {5974FFC3-52F3-4655-AAB4-87D4BFD59D8D}). */
export type ShowcaseFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase template (ID: {5974FFC3-52F3-4655-AAB4-87D4BFD59D8D}). */
export type ShowcaseHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase template (ID: {5974FFC3-52F3-4655-AAB4-87D4BFD59D8D}). */
export type ShowcaseIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Folder template (ID: {C2C33DE3-7A99-4C46-9190-9F26601D2641}). */
export type ShowcaseFolder = Item & {
  __typename?: 'ShowcaseFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Folder template (ID: {C2C33DE3-7A99-4C46-9190-9F26601D2641}). */
export type ShowcaseFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Folder template (ID: {C2C33DE3-7A99-4C46-9190-9F26601D2641}). */
export type ShowcaseFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Folder template (ID: {C2C33DE3-7A99-4C46-9190-9F26601D2641}). */
export type ShowcaseFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Folder template (ID: {C2C33DE3-7A99-4C46-9190-9F26601D2641}). */
export type ShowcaseFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Folder template (ID: {C2C33DE3-7A99-4C46-9190-9F26601D2641}). */
export type ShowcaseFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Folder template (ID: {C2C33DE3-7A99-4C46-9190-9F26601D2641}). */
export type ShowcaseFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Item template (ID: {5147EB72-7BCA-4BFF-A112-70EE6F8BBE65}). */
export type ShowcaseItem = Item & {
  __typename?: 'ShowcaseItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {12BB663B-CA35-40D3-AB8A-4FE71C004FB3}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {50D47065-C8E0-4FBA-9B8A-76426706DE60}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {F9CE8A24-E569-4723-8CCE-F576CE6D67E4}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Item template (ID: {5147EB72-7BCA-4BFF-A112-70EE6F8BBE65}). */
export type ShowcaseItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Item template (ID: {5147EB72-7BCA-4BFF-A112-70EE6F8BBE65}). */
export type ShowcaseItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Item template (ID: {5147EB72-7BCA-4BFF-A112-70EE6F8BBE65}). */
export type ShowcaseItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Item template (ID: {5147EB72-7BCA-4BFF-A112-70EE6F8BBE65}). */
export type ShowcaseItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Item template (ID: {5147EB72-7BCA-4BFF-A112-70EE6F8BBE65}). */
export type ShowcaseItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Showcase/Showcase Item template (ID: {5147EB72-7BCA-4BFF-A112-70EE6F8BBE65}). */
export type ShowcaseItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Showcase Parameters Template template (ID: {A25AD80B-4FAC-4C50-B3E4-D91EC514F1EF}). */
export type ShowcaseParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'ShowcaseParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {3401227C-AEE1-4CB4-913B-E7767D9B8DD1}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Showcase Parameters Template template (ID: {A25AD80B-4FAC-4C50-B3E4-D91EC514F1EF}). */
export type ShowcaseParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Showcase Parameters Template template (ID: {A25AD80B-4FAC-4C50-B3E4-D91EC514F1EF}). */
export type ShowcaseParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Showcase Parameters Template template (ID: {A25AD80B-4FAC-4C50-B3E4-D91EC514F1EF}). */
export type ShowcaseParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Showcase Parameters Template template (ID: {A25AD80B-4FAC-4C50-B3E4-D91EC514F1EF}). */
export type ShowcaseParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Showcase Parameters Template template (ID: {A25AD80B-4FAC-4C50-B3E4-D91EC514F1EF}). */
export type ShowcaseParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Showcase Parameters Template template (ID: {A25AD80B-4FAC-4C50-B3E4-D91EC514F1EF}). */
export type ShowcaseParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Simple Video template (ID: {75746D59-692E-47DB-A87C-B5D4B756A1EE}). Also implements _PerSiteStandardValues. */
export type SimpleVideo = {
  /** MP4Movie (ID: {10DC336D-04A0-4AD7-ACD9-7E820CFCB9CB}). */
  mP4Movie?: Maybe<LinkField>;
  /** MovieCaption (ID: {C4A0614E-5A4A-4ECF-B49B-B0D82E5EEE7E}). */
  movieCaption?: Maybe<TextField>;
  /** MovieDescription (ID: {75562C38-22F6-4B63-AF7A-DAF44F0730F1}). */
  movieDescription?: Maybe<RichTextField>;
  /** MovieThumbnail (ID: {4E3A41DD-AFB7-4763-BA20-FF27E0BEEDDF}). */
  movieThumbnail?: Maybe<ImageField>;
  /** OggMovie (ID: {BFCADF11-A141-4200-9FC2-8484E446320D}). */
  oggMovie?: Maybe<LinkField>;
  /** PosterImage (ID: {22379A66-606E-4205-ABEE-F9AC597084DD}). */
  posterImage?: Maybe<ImageField>;
  /** WebMMovie (ID: {2295492E-299B-40FD-BE80-ECCB3EEC7790}). */
  webMMovie?: Maybe<LinkField>;
  /** YoutubeMovie (ID: {C7ABDB60-3F28-4D17-B457-2056710E384F}). */
  youtubeMovie?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site template (ID: {6669DC16-F106-44B5-96BE-7A31AE82B5B5}). */
export type Site = Item & _SiteMediaLibrary & {
  __typename?: 'Site';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** ThemesFolder (ID: {D7264A2B-E343-4613-A71A-1727F50DBC15}). */
  themesFolder?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site template (ID: {6669DC16-F106-44B5-96BE-7A31AE82B5B5}). */
export type SiteAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site template (ID: {6669DC16-F106-44B5-96BE-7A31AE82B5B5}). */
export type SiteChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site template (ID: {6669DC16-F106-44B5-96BE-7A31AE82B5B5}). */
export type SiteFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site template (ID: {6669DC16-F106-44B5-96BE-7A31AE82B5B5}). */
export type SiteFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site template (ID: {6669DC16-F106-44B5-96BE-7A31AE82B5B5}). */
export type SiteHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site template (ID: {6669DC16-F106-44B5-96BE-7A31AE82B5B5}). */
export type SiteIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Content Folder template (ID: {AD500A64-7FAF-4490-A8A3-9B231881989C}). */
export type SiteContentFolder = Item & {
  __typename?: 'SiteContentFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Content Folder template (ID: {AD500A64-7FAF-4490-A8A3-9B231881989C}). */
export type SiteContentFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Content Folder template (ID: {AD500A64-7FAF-4490-A8A3-9B231881989C}). */
export type SiteContentFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Content Folder template (ID: {AD500A64-7FAF-4490-A8A3-9B231881989C}). */
export type SiteContentFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Content Folder template (ID: {AD500A64-7FAF-4490-A8A3-9B231881989C}). */
export type SiteContentFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Content Folder template (ID: {AD500A64-7FAF-4490-A8A3-9B231881989C}). */
export type SiteContentFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Site Content Folder template (ID: {AD500A64-7FAF-4490-A8A3-9B231881989C}). */
export type SiteContentFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type SiteData = {
  __typename?: 'SiteData';
  /** Basic information about available content sites. Offset paging supports up to 10,000 sites. */
  allSiteInfo?: Maybe<SiteInfoResult>;
  /** Basic information about the site. */
  siteInfo?: Maybe<SiteInfo>;
  /**
   * Basic information about available content sites.
   * @deprecated Please use 'allSiteInfo' instead, this field will be removed in future releases.
   */
  siteInfoCollection: Array<Maybe<SiteInfo>>;
};


export type SiteDataAllSiteInfoArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteDataSiteInfoArgs = {
  site: Scalars['String']['input'];
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Definition template (ID: {EDA823FC-BC7E-4EF6-B498-CD09EC6FDAEF}). */
export type SiteDefinition = Item & _BaseSiteDefinition & {
  __typename?: 'SiteDefinition';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Database (ID: {A7803A5D-CD03-4EDA-ABED-1D9AF4BF6660}). */
  database_a7803a5dcd034edaabed1d9af4bf6660?: Maybe<TextField>;
  /** DictionaryDomain (ID: {6A92178C-31B7-4D72-ACA1-7A4B5DC7CCD9}). */
  dictionaryDomain?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Environment (ID: {DA06D09E-02B6-464A-80FC-9D8D7FC875E3}). */
  environment?: Maybe<TextField>;
  /** ErrorPageUrl (ID: {76DE376A-A332-46F8-8CAF-A59E557DFEFD}). */
  errorPageUrl?: Maybe<TextField>;
  /** ExternalPort (ID: {FA273891-D5D0-41DF-A713-ADEA620D7732}). */
  externalPort?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldLanguageFallback (ID: {6E6DA5B0-8D01-4514-B7DD-1940AFF3E8CD}). */
  fieldLanguageFallback?: Maybe<CheckboxField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilteredItemsCacheSize (ID: {42DDBE59-96DF-4C83-BB22-0F739A603B3D}). */
  filteredItemsCacheSize?: Maybe<IntegerField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** HostName (ID: {8E0DD914-9AFB-4D45-BF8B-7FF5D6E5337E}). */
  hostName?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Indexes (ID: {85F47095-7E58-449C-9773-B0AEB925AD1F}). */
  indexes?: Maybe<NameValueListField>;
  /** ItemLanguageFallback (ID: {8C436235-B85D-4097-89CF-D5A4FA70CC0A}). */
  itemLanguageFallback?: Maybe<CheckboxField>;
  /** ItemNotFoundUrl (ID: {7B32B669-0B70-4FFA-A264-247B97DE8571}). */
  itemNotFoundUrl?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Language Embedding (ID: {4E9E2AE5-36DB-4955-9AF1-5A1934A27C7D}). */
  languageEmbedding?: Maybe<CheckboxField>;
  /** Language (ID: {F19277FE-1B85-4B0A-8C26-5E74D766B3A3}). */
  language_f19277fe1b854b0a8c265e74d766b3a3?: Maybe<TextField>;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LinkProvider (ID: {822CC751-5C96-4A43-B687-FF4786A6EBA2}). */
  linkProvider?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OtherProperties (ID: {301E719A-6F65-4874-B565-A953A7B5AC83}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Port (ID: {1BF930DC-11E1-4103-9001-59562B698C96}). */
  port?: Maybe<IntegerField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Scheme (ID: {B59E43AB-84DA-49F3-87A1-D2FCF648365B}). */
  scheme?: Maybe<TextField>;
  /** SiteName (ID: {CB4E9E2E-2B66-43DC-AD3F-9CAF363D28D3}). */
  siteName?: Maybe<TextField>;
  /** StartItem (ID: {1EE576AF-BA8E-4312-9FBD-2CCF8395BAA1}). */
  startItem?: Maybe<LookupField>;
  /** SxaLinkable (ID: {4EEFF055-EDCD-4387-9E86-C3F40A15DBAC}). */
  sxaLinkable?: Maybe<CheckboxField>;
  /** TargetHostName (ID: {E5B5CCB5-17A1-429D-BD3E-6122B3216E52}). */
  targetHostName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** VirtualFolder (ID: {475031D8-724D-463C-80B2-90839DD1AD98}). */
  virtualFolder?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Definition template (ID: {EDA823FC-BC7E-4EF6-B498-CD09EC6FDAEF}). */
export type SiteDefinitionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Definition template (ID: {EDA823FC-BC7E-4EF6-B498-CD09EC6FDAEF}). */
export type SiteDefinitionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Definition template (ID: {EDA823FC-BC7E-4EF6-B498-CD09EC6FDAEF}). */
export type SiteDefinitionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Definition template (ID: {EDA823FC-BC7E-4EF6-B498-CD09EC6FDAEF}). */
export type SiteDefinitionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Definition template (ID: {EDA823FC-BC7E-4EF6-B498-CD09EC6FDAEF}). */
export type SiteDefinitionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Definition template (ID: {EDA823FC-BC7E-4EF6-B498-CD09EC6FDAEF}). */
export type SiteDefinitionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Entry Disclaimer/Site Entry Disclaimer template (ID: {860B8A4E-828A-44FA-B0C1-B652C4340E79}). */
export type SiteEntryDisclaimer = Item & {
  __typename?: 'SiteEntryDisclaimer';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** declineLink (ID: {508A04A8-B0F9-4A5A-8B16-9BDD232361ED}). */
  declineLink?: Maybe<TextField>;
  /** description (ID: {D7D44B74-A428-4C56-80DD-949DCFFE6EF7}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** session (ID: {363641DA-B706-4E24-A5B6-86B60CE85514}). */
  session?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {C093B98E-A287-44B1-9812-CD87768BF265}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Entry Disclaimer/Site Entry Disclaimer template (ID: {860B8A4E-828A-44FA-B0C1-B652C4340E79}). */
export type SiteEntryDisclaimerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Entry Disclaimer/Site Entry Disclaimer template (ID: {860B8A4E-828A-44FA-B0C1-B652C4340E79}). */
export type SiteEntryDisclaimerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Entry Disclaimer/Site Entry Disclaimer template (ID: {860B8A4E-828A-44FA-B0C1-B652C4340E79}). */
export type SiteEntryDisclaimerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Entry Disclaimer/Site Entry Disclaimer template (ID: {860B8A4E-828A-44FA-B0C1-B652C4340E79}). */
export type SiteEntryDisclaimerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Entry Disclaimer/Site Entry Disclaimer template (ID: {860B8A4E-828A-44FA-B0C1-B652C4340E79}). */
export type SiteEntryDisclaimerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Entry Disclaimer/Site Entry Disclaimer template (ID: {860B8A4E-828A-44FA-B0C1-B652C4340E79}). */
export type SiteEntryDisclaimerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Folder template (ID: {C0CBBC66-4EF0-4660-A0D3-91E862FCCB65}). */
export type SiteFolder = Item & {
  __typename?: 'SiteFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Folder template (ID: {C0CBBC66-4EF0-4660-A0D3-91E862FCCB65}). */
export type SiteFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Folder template (ID: {C0CBBC66-4EF0-4660-A0D3-91E862FCCB65}). */
export type SiteFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Folder template (ID: {C0CBBC66-4EF0-4660-A0D3-91E862FCCB65}). */
export type SiteFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Folder template (ID: {C0CBBC66-4EF0-4660-A0D3-91E862FCCB65}). */
export type SiteFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Folder template (ID: {C0CBBC66-4EF0-4660-A0D3-91E862FCCB65}). */
export type SiteFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Folder template (ID: {C0CBBC66-4EF0-4660-A0D3-91E862FCCB65}). */
export type SiteFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/SiteGrouping template (ID: {11F57D7B-CBB2-4647-B98C-71457564BA4F}). */
export type SiteGrouping = Item & {
  __typename?: 'SiteGrouping';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/SiteGrouping template (ID: {11F57D7B-CBB2-4647-B98C-71457564BA4F}). */
export type SiteGroupingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/SiteGrouping template (ID: {11F57D7B-CBB2-4647-B98C-71457564BA4F}). */
export type SiteGroupingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/SiteGrouping template (ID: {11F57D7B-CBB2-4647-B98C-71457564BA4F}). */
export type SiteGroupingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/SiteGrouping template (ID: {11F57D7B-CBB2-4647-B98C-71457564BA4F}). */
export type SiteGroupingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/SiteGrouping template (ID: {11F57D7B-CBB2-4647-B98C-71457564BA4F}). */
export type SiteGroupingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/SiteGrouping template (ID: {11F57D7B-CBB2-4647-B98C-71457564BA4F}). */
export type SiteGroupingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type SiteInfo = {
  __typename?: 'SiteInfo';
  /** Additional site attributes. */
  attributes?: Maybe<Array<Maybe<KeyValuePair>>>;
  /** Dictionary for the site in a specific language. */
  dictionary?: Maybe<DictionaryResult>;
  /** Error handling information for the site. */
  errorHandling?: Maybe<ErrorHandlingInfo>;
  /** The configured host name attribute of the site. */
  hostname?: Maybe<Scalars['String']['output']>;
  /** The configured default language. */
  language?: Maybe<Scalars['String']['output']>;
  /** The name of the site. */
  name: Scalars['String']['output'];
  /** Information about redirect rules for the site. */
  redirects: Array<Maybe<RedirectInfo>>;
  /** Information about the URLs search engine crawlers can/are allowed to access on the site. */
  robots?: Maybe<Scalars['String']['output']>;
  /** The content path of the root item of the site. */
  rootPath: Scalars['String']['output'];
  /** Routes for the site in a specific language. */
  routes?: Maybe<RoutesResult>;
  /** List of urls to sitemap.xml media items. */
  sitemap?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteInfoDictionaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
};


export type SiteInfoErrorHandlingArgs = {
  language: Scalars['String']['input'];
};


export type SiteInfoRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  excludedPaths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includedPaths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language: Scalars['String']['input'];
};

export type SiteInfoResult = {
  __typename?: 'SiteInfoResult';
  /** The collection of sites in a page. */
  results: Array<Maybe<SiteInfo>>;
  /** The total number of available sites. */
  total: Scalars['Int']['output'];
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Management template (ID: {85486BE1-A56F-4B9B-AA55-19706E534388}). */
export type SiteManagement = Item & {
  __typename?: 'SiteManagement';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Order (ID: {235B36B3-4088-4B72-808E-5CD724C58DDB}). */
  order?: Maybe<MultilistField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Management template (ID: {85486BE1-A56F-4B9B-AA55-19706E534388}). */
export type SiteManagementAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Management template (ID: {85486BE1-A56F-4B9B-AA55-19706E534388}). */
export type SiteManagementChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Management template (ID: {85486BE1-A56F-4B9B-AA55-19706E534388}). */
export type SiteManagementFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Management template (ID: {85486BE1-A56F-4B9B-AA55-19706E534388}). */
export type SiteManagementFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Management template (ID: {85486BE1-A56F-4B9B-AA55-19706E534388}). */
export type SiteManagementHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Site Management template (ID: {85486BE1-A56F-4B9B-AA55-19706E534388}). */
export type SiteManagementIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Site Security Item Pointer template (ID: {7791AF96-E93F-4DA0-8565-2EE8D5EE90BA}). */
export type SiteSecurityItemPointer = Item & _SecurityItemPointer & {
  __typename?: 'SiteSecurityItemPointer';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {BBC2E73A-DE40-493B-9320-86D66D024AAF}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Site Security Item Pointer template (ID: {7791AF96-E93F-4DA0-8565-2EE8D5EE90BA}). */
export type SiteSecurityItemPointerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Site Security Item Pointer template (ID: {7791AF96-E93F-4DA0-8565-2EE8D5EE90BA}). */
export type SiteSecurityItemPointerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Site Security Item Pointer template (ID: {7791AF96-E93F-4DA0-8565-2EE8D5EE90BA}). */
export type SiteSecurityItemPointerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Site Security Item Pointer template (ID: {7791AF96-E93F-4DA0-8565-2EE8D5EE90BA}). */
export type SiteSecurityItemPointerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Site Security Item Pointer template (ID: {7791AF96-E93F-4DA0-8565-2EE8D5EE90BA}). */
export type SiteSecurityItemPointerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Site Security Item Pointer template (ID: {7791AF96-E93F-4DA0-8565-2EE8D5EE90BA}). */
export type SiteSecurityItemPointerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Site Selector template (ID: {165F2CBE-2D8B-4844-85D3-12A2C6FD2CD7}). */
export type SiteSelector = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'SiteSelector';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Site Selector template (ID: {165F2CBE-2D8B-4844-85D3-12A2C6FD2CD7}). */
export type SiteSelectorAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Site Selector template (ID: {165F2CBE-2D8B-4844-85D3-12A2C6FD2CD7}). */
export type SiteSelectorChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Site Selector template (ID: {165F2CBE-2D8B-4844-85D3-12A2C6FD2CD7}). */
export type SiteSelectorFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Site Selector template (ID: {165F2CBE-2D8B-4844-85D3-12A2C6FD2CD7}). */
export type SiteSelectorFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Site Selector template (ID: {165F2CBE-2D8B-4844-85D3-12A2C6FD2CD7}). */
export type SiteSelectorHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Context/Rendering Parameters/Site Selector template (ID: {165F2CBE-2D8B-4844-85D3-12A2C6FD2CD7}). */
export type SiteSelectorIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/Site Selector template (ID: {A44632F5-6DCD-4D10-B489-2F4E35E193C3}). */
export type SiteSelector_A44632f56dcd4d10b4892f4e35e193c3 = Item & {
  __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** changeCountryCta (ID: {1B1D6A9E-4E45-44FF-9D4D-5C5ECECDE1F7}). */
  changeCountryCta?: Maybe<TextField>;
  /** changeCountryIcon (ID: {0D4C6F04-34C9-4F36-918B-E190AFC7E448}). */
  changeCountryIcon?: Maybe<ImageField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/Site Selector template (ID: {A44632F5-6DCD-4D10-B489-2F4E35E193C3}). */
export type SiteSelector_A44632f56dcd4d10b4892f4e35e193c3AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/Site Selector template (ID: {A44632F5-6DCD-4D10-B489-2F4E35E193C3}). */
export type SiteSelector_A44632f56dcd4d10b4892f4e35e193c3ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/Site Selector template (ID: {A44632F5-6DCD-4D10-B489-2F4E35E193C3}). */
export type SiteSelector_A44632f56dcd4d10b4892f4e35e193c3FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/Site Selector template (ID: {A44632F5-6DCD-4D10-B489-2F4E35E193C3}). */
export type SiteSelector_A44632f56dcd4d10b4892f4e35e193c3FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/Site Selector template (ID: {A44632F5-6DCD-4D10-B489-2F4E35E193C3}). */
export type SiteSelector_A44632f56dcd4d10b4892f4e35e193c3HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Site Selector/Site Selector template (ID: {A44632F5-6DCD-4D10-B489-2F4E35E193C3}). */
export type SiteSelector_A44632f56dcd4d10b4892f4e35e193c3IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/SiteSetupRoot template (ID: {292CCFCD-7790-4692-856B-76014B8038E7}). */
export type SiteSetupRoot = Item & _Dependencies & _Enabled & _IncludeByDefault & _IncludeIfInstalled & _IsSystemModule & _Name_B88cf88159a54a19991e71038751cb60 & {
  __typename?: 'SiteSetupRoot';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Dependencies (ID: {40DEEE2F-7595-40BD-B2C9-51F9E2346100}). */
  dependencies?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled (ID: {4B475746-CF34-4C06-97C8-7A8B0B40064F}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IncludeByDefault (ID: {11488836-D40F-40D4-BEB4-1D31DA7B1470}). */
  includeByDefault?: Maybe<CheckboxField>;
  /** IncludeIfInstalled (ID: {52A4245C-A3D5-4B23-9F3A-5B33C9811906}). */
  includeIfInstalled?: Maybe<MultilistField>;
  /** IsSystemModule (ID: {06D2C562-9229-4779-8807-E2A5FD2990D4}). */
  isSystemModule?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {C202067E-7FAB-4606-AFB4-E76DF2185DDC}). */
  name_c202067e7fab4606afb4e76df2185ddc?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/SiteSetupRoot template (ID: {292CCFCD-7790-4692-856B-76014B8038E7}). */
export type SiteSetupRootAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/SiteSetupRoot template (ID: {292CCFCD-7790-4692-856B-76014B8038E7}). */
export type SiteSetupRootChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/SiteSetupRoot template (ID: {292CCFCD-7790-4692-856B-76014B8038E7}). */
export type SiteSetupRootFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/SiteSetupRoot template (ID: {292CCFCD-7790-4692-856B-76014B8038E7}). */
export type SiteSetupRootFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/SiteSetupRoot template (ID: {292CCFCD-7790-4692-856B-76014B8038E7}). */
export type SiteSetupRootHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/SiteSetupRoot template (ID: {292CCFCD-7790-4692-856B-76014B8038E7}). */
export type SiteSetupRootIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Theme/Site Theme template (ID: {9FA666F7-9AFB-40EB-AB87-9D80F6A5AC73}). */
export type SiteTheme = Item & {
  __typename?: 'SiteTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** theme (ID: {9940E0A0-DE4F-4246-88AE-160E4309C8CC}). */
  theme?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Theme/Site Theme template (ID: {9FA666F7-9AFB-40EB-AB87-9D80F6A5AC73}). */
export type SiteThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Theme/Site Theme template (ID: {9FA666F7-9AFB-40EB-AB87-9D80F6A5AC73}). */
export type SiteThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Theme/Site Theme template (ID: {9FA666F7-9AFB-40EB-AB87-9D80F6A5AC73}). */
export type SiteThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Theme/Site Theme template (ID: {9FA666F7-9AFB-40EB-AB87-9D80F6A5AC73}). */
export type SiteThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Theme/Site Theme template (ID: {9FA666F7-9AFB-40EB-AB87-9D80F6A5AC73}). */
export type SiteThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Site Theme/Site Theme template (ID: {9FA666F7-9AFB-40EB-AB87-9D80F6A5AC73}). */
export type SiteThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Site template (ID: {E46F3AF2-39FA-4866-A157-7017C4B2A40C}). */
export type Site_E46f3af239fa4866a1577017c4b2a40c = Item & _BaseSiteDefinition & _Description & _Name_0345fd2f95094dc7b0f56c73a9b6cd8d & _SolutionTemplateDescription & _SolutionTemplateName & {
  __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Database (ID: {A7803A5D-CD03-4EDA-ABED-1D9AF4BF6660}). */
  database_a7803a5dcd034edaabed1d9af4bf6660?: Maybe<TextField>;
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
  /** Description (ID: {9F437E68-A84D-48AE-8CE1-A3E26C0B5E64}). */
  description_9f437e68a84d48ae8ce1a3e26c0b5e64?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Environment (ID: {DA06D09E-02B6-464A-80FC-9D8D7FC875E3}). */
  environment?: Maybe<TextField>;
  /** ErrorPageUrl (ID: {76DE376A-A332-46F8-8CAF-A59E557DFEFD}). */
  errorPageUrl?: Maybe<TextField>;
  /** ExternalPort (ID: {FA273891-D5D0-41DF-A713-ADEA620D7732}). */
  externalPort?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** FieldLanguageFallback (ID: {6E6DA5B0-8D01-4514-B7DD-1940AFF3E8CD}). */
  fieldLanguageFallback?: Maybe<CheckboxField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FilteredItemsCacheSize (ID: {42DDBE59-96DF-4C83-BB22-0F739A603B3D}). */
  filteredItemsCacheSize?: Maybe<IntegerField>;
  /** GenerateThumbnails (ID: {8700CD8F-83CC-42BA-AA78-65BCCAB44FC7}). */
  generateThumbnails?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** HostName (ID: {8E0DD914-9AFB-4D45-BF8B-7FF5D6E5337E}). */
  hostName?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** ItemLanguageFallback (ID: {8C436235-B85D-4097-89CF-D5A4FA70CC0A}). */
  itemLanguageFallback?: Maybe<CheckboxField>;
  /** ItemNotFoundUrl (ID: {7B32B669-0B70-4FFA-A264-247B97DE8571}). */
  itemNotFoundUrl?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Language Embedding (ID: {4E9E2AE5-36DB-4955-9AF1-5A1934A27C7D}). */
  languageEmbedding?: Maybe<CheckboxField>;
  /** Language (ID: {F19277FE-1B85-4B0A-8C26-5E74D766B3A3}). */
  language_f19277fe1b854b0a8c265e74d766b3a3?: Maybe<TextField>;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LinkProvider (ID: {822CC751-5C96-4A43-B687-FF4786A6EBA2}). */
  linkProvider?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {82E64B52-0B8A-4A38-8C78-530C5493814E}). */
  name_82e64b520b8a4a388c78530c5493814e?: Maybe<TextField>;
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
  /** OtherProperties (ID: {301E719A-6F65-4874-B565-A953A7B5AC83}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Point of sale (ID: {9EAF6DC9-B811-4CDA-9EDD-9697FABA628A}). */
  pOS?: Maybe<NameValueListField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Port (ID: {1BF930DC-11E1-4103-9001-59562B698C96}). */
  port?: Maybe<IntegerField>;
  /** Project (ID: {36CDA943-5589-4405-90BD-B0CF1C0B8450}). */
  project?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Predefined application editing host (ID: {F57099A3-526A-49F2-AEBD-635453E48875}). */
  renderingHost?: Maybe<TextField>;
  /** Scheme (ID: {B59E43AB-84DA-49F3-87A1-D2FCF648365B}). */
  scheme?: Maybe<TextField>;
  /** SiteName (ID: {CB4E9E2E-2B66-43DC-AD3F-9CAF363D28D3}). */
  siteName?: Maybe<TextField>;
  /** StartItem (ID: {1EE576AF-BA8E-4312-9FBD-2CCF8395BAA1}). */
  startItem?: Maybe<LookupField>;
  /** SxaLinkable (ID: {4EEFF055-EDCD-4387-9E86-C3F40A15DBAC}). */
  sxaLinkable?: Maybe<CheckboxField>;
  /** TargetHostName (ID: {E5B5CCB5-17A1-429D-BD3E-6122B3216E52}). */
  targetHostName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** ThumbnailsRootPath (ID: {6DD8A774-2CE5-4C9E-BE7F-1EAF65789956}). */
  thumbnailsRootPath?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** VirtualFolder (ID: {475031D8-724D-463C-80B2-90839DD1AD98}). */
  virtualFolder?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Site template (ID: {E46F3AF2-39FA-4866-A157-7017C4B2A40C}). */
export type Site_E46f3af239fa4866a1577017c4b2a40cAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Site template (ID: {E46F3AF2-39FA-4866-A157-7017C4B2A40C}). */
export type Site_E46f3af239fa4866a1577017c4b2a40cChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Site template (ID: {E46F3AF2-39FA-4866-A157-7017C4B2A40C}). */
export type Site_E46f3af239fa4866a1577017c4b2a40cFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Site template (ID: {E46F3AF2-39FA-4866-A157-7017C4B2A40C}). */
export type Site_E46f3af239fa4866a1577017c4b2a40cFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Site template (ID: {E46F3AF2-39FA-4866-A157-7017C4B2A40C}). */
export type Site_E46f3af239fa4866a1577017c4b2a40cHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Site template (ID: {E46F3AF2-39FA-4866-A157-7017C4B2A40C}). */
export type Site_E46f3af239fa4866a1577017c4b2a40cIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Rendering Parameters/SitecoreFormWrapperParametersTemplate template (ID: {94934361-27EC-495F-BB92-CE0D83FA181E}). */
export type SitecoreFormWrapperParametersTemplate = GridParameters & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'SitecoreFormWrapperParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Rendering Parameters/SitecoreFormWrapperParametersTemplate template (ID: {94934361-27EC-495F-BB92-CE0D83FA181E}). */
export type SitecoreFormWrapperParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Rendering Parameters/SitecoreFormWrapperParametersTemplate template (ID: {94934361-27EC-495F-BB92-CE0D83FA181E}). */
export type SitecoreFormWrapperParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Rendering Parameters/SitecoreFormWrapperParametersTemplate template (ID: {94934361-27EC-495F-BB92-CE0D83FA181E}). */
export type SitecoreFormWrapperParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Rendering Parameters/SitecoreFormWrapperParametersTemplate template (ID: {94934361-27EC-495F-BB92-CE0D83FA181E}). */
export type SitecoreFormWrapperParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Rendering Parameters/SitecoreFormWrapperParametersTemplate template (ID: {94934361-27EC-495F-BB92-CE0D83FA181E}). */
export type SitecoreFormWrapperParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Rendering Parameters/SitecoreFormWrapperParametersTemplate template (ID: {94934361-27EC-495F-BB92-CE0D83FA181E}). */
export type SitecoreFormWrapperParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Sitecore Role template (ID: {35528C6B-4039-4EE5-89AE-831340190764}). */
export type SitecoreRole = Item & _RoleDomain & _RoleName & {
  __typename?: 'SitecoreRole';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
  /** RoleName (ID: {5382BFDE-8E39-4571-A1C5-EB3C43D5BCE3}). */
  roleName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Sitecore Role template (ID: {35528C6B-4039-4EE5-89AE-831340190764}). */
export type SitecoreRoleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Sitecore Role template (ID: {35528C6B-4039-4EE5-89AE-831340190764}). */
export type SitecoreRoleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Sitecore Role template (ID: {35528C6B-4039-4EE5-89AE-831340190764}). */
export type SitecoreRoleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Sitecore Role template (ID: {35528C6B-4039-4EE5-89AE-831340190764}). */
export type SitecoreRoleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Sitecore Role template (ID: {35528C6B-4039-4EE5-89AE-831340190764}). */
export type SitecoreRoleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Sitecore Role template (ID: {35528C6B-4039-4EE5-89AE-831340190764}). */
export type SitecoreRoleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/Sitemap Settings template (ID: {651BCAD2-F32D-4CB3-9BD4-DB9B895382BF}). */
export type SitemapSettings = {
  /** Cache Expiration (ID: {139EB09E-73C4-4F96-A06B-A8BC050954E4}). */
  cacheExpiration?: Maybe<NumberField>;
  /** Cache Type (ID: {FCEFA910-FD09-439B-AE81-EF00487090AD}). */
  cacheType?: Maybe<LookupField>;
  /** changefreq (ID: {E35A52F4-12F4-4153-A49E-2B894355A22E}). */
  changefreq?: Maybe<CheckboxField>;
  /** Crawler (ID: {A4DA1F5E-CBFE-458D-BAC5-7ABFB80B3E84}). */
  crawler?: Maybe<TextField>;
  /** Generate Alternate Links (ID: {EB78B584-B22E-47CD-88DA-E80D6DBB9238}). */
  generateAlternateLinks?: Maybe<CheckboxField>;
  /** HrefLang (ID: {4369DE8A-D99C-441D-8A4D-106B6366A522}). */
  hrefLang?: Maybe<LookupField>;
  /** Include xdefault (ID: {674A7926-436F-4882-ADD1-0F92EA860C19}). */
  includeXdefault?: Maybe<CheckboxField>;
  /** lastmod (ID: {0708C430-1AD8-4B9B-B48D-E3B7D4495088}). */
  lastmod?: Maybe<CheckboxField>;
  /** LinkProvider (ID: {80823FFA-5BCF-4EA8-8CEA-CEF3B024A5F6}). */
  linkProvider?: Maybe<TextField>;
  /** priority (ID: {95C52046-38E4-4D96-BB32-B699891BA215}). */
  priority?: Maybe<CheckboxField>;
  /** Refresh Threshold (ID: {E12195E6-3BCD-4C51-9CD4-3AE3C0779B9F}). */
  refreshThreshold?: Maybe<NumberField>;
  /** Sitemap Index Threshold (ID: {7634339B-C588-4E3C-952F-7E18F0935378}). */
  sitemapIndexThreshold?: Maybe<NumberField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/SiteMetadata/Sitemap Settings template (ID: {C71D8566-35C8-49B7-A84D-9D176E9CBD05}). */
export type SitemapSettings_C71d856635c849b7a84d9d176e9cbd05 = Item & SitemapSettings & {
  __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Cache Expiration (ID: {139EB09E-73C4-4F96-A06B-A8BC050954E4}). */
  cacheExpiration?: Maybe<NumberField>;
  /** Cache Type (ID: {FCEFA910-FD09-439B-AE81-EF00487090AD}). */
  cacheType?: Maybe<LookupField>;
  /** changefreq (ID: {E35A52F4-12F4-4153-A49E-2B894355A22E}). */
  changefreq?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Crawler (ID: {A4DA1F5E-CBFE-458D-BAC5-7ABFB80B3E84}). */
  crawler?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Generate Alternate Links (ID: {EB78B584-B22E-47CD-88DA-E80D6DBB9238}). */
  generateAlternateLinks?: Maybe<CheckboxField>;
  /** Generate sitemap media items (ID: {7F070BC5-5CD4-474F-AA2F-AB2A0A128F00}). */
  generateSitemapMediaItems?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** HrefLang (ID: {4369DE8A-D99C-441D-8A4D-106B6366A522}). */
  hrefLang?: Maybe<LookupField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Include xdefault (ID: {674A7926-436F-4882-ADD1-0F92EA860C19}). */
  includeXdefault?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** lastmod (ID: {0708C430-1AD8-4B9B-B48D-E3B7D4495088}). */
  lastmod?: Maybe<CheckboxField>;
  /** LinkProvider (ID: {80823FFA-5BCF-4EA8-8CEA-CEF3B024A5F6}). */
  linkProvider?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** priority (ID: {95C52046-38E4-4D96-BB32-B699891BA215}). */
  priority?: Maybe<CheckboxField>;
  /** Refresh Threshold (ID: {E12195E6-3BCD-4C51-9CD4-3AE3C0779B9F}). */
  refreshThreshold?: Maybe<NumberField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Sitemap Index Threshold (ID: {7634339B-C588-4E3C-952F-7E18F0935378}). */
  sitemapIndexThreshold?: Maybe<NumberField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/SiteMetadata/Sitemap Settings template (ID: {C71D8566-35C8-49B7-A84D-9D176E9CBD05}). */
export type SitemapSettings_C71d856635c849b7a84d9d176e9cbd05AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/SiteMetadata/Sitemap Settings template (ID: {C71D8566-35C8-49B7-A84D-9D176E9CBD05}). */
export type SitemapSettings_C71d856635c849b7a84d9d176e9cbd05ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/SiteMetadata/Sitemap Settings template (ID: {C71D8566-35C8-49B7-A84D-9D176E9CBD05}). */
export type SitemapSettings_C71d856635c849b7a84d9d176e9cbd05FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/SiteMetadata/Sitemap Settings template (ID: {C71D8566-35C8-49B7-A84D-9D176E9CBD05}). */
export type SitemapSettings_C71d856635c849b7a84d9d176e9cbd05FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/SiteMetadata/Sitemap Settings template (ID: {C71D8566-35C8-49B7-A84D-9D176E9CBD05}). */
export type SitemapSettings_C71d856635c849b7a84d9d176e9cbd05HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/SiteMetadata/Sitemap Settings template (ID: {C71D8566-35C8-49B7-A84D-9D176E9CBD05}). */
export type SitemapSettings_C71d856635c849b7a84d9d176e9cbd05IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Link template (ID: {B7F6949A-6DDE-44FC-9E28-D8E2C2C8529E}). */
export type SkipLink = Item & {
  __typename?: 'SkipLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content ID (ID: {668126E9-5A1E-4553-974B-A26400B5BAD7}). */
  contentID?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {2147200A-CD2E-4196-91D5-E23C0724502D}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Link template (ID: {B7F6949A-6DDE-44FC-9E28-D8E2C2C8529E}). */
export type SkipLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Link template (ID: {B7F6949A-6DDE-44FC-9E28-D8E2C2C8529E}). */
export type SkipLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Link template (ID: {B7F6949A-6DDE-44FC-9E28-D8E2C2C8529E}). */
export type SkipLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Link template (ID: {B7F6949A-6DDE-44FC-9E28-D8E2C2C8529E}). */
export type SkipLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Link template (ID: {B7F6949A-6DDE-44FC-9E28-D8E2C2C8529E}). */
export type SkipLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Link template (ID: {B7F6949A-6DDE-44FC-9E28-D8E2C2C8529E}). */
export type SkipLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Rendering Parameters/Skip Link Parameters template (ID: {3920B223-9351-4357-8D0C-DD64EB4B5117}). */
export type SkipLinkParameters = ICacheable & IRenderingId & Item & StandardRenderingParameters & {
  __typename?: 'SkipLinkParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Skip Link Class (ID: {4416AAB3-2149-4423-82D0-1B5886D7DAE8}). */
  skipLinkClass?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Rendering Parameters/Skip Link Parameters template (ID: {3920B223-9351-4357-8D0C-DD64EB4B5117}). */
export type SkipLinkParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Rendering Parameters/Skip Link Parameters template (ID: {3920B223-9351-4357-8D0C-DD64EB4B5117}). */
export type SkipLinkParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Rendering Parameters/Skip Link Parameters template (ID: {3920B223-9351-4357-8D0C-DD64EB4B5117}). */
export type SkipLinkParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Rendering Parameters/Skip Link Parameters template (ID: {3920B223-9351-4357-8D0C-DD64EB4B5117}). */
export type SkipLinkParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Rendering Parameters/Skip Link Parameters template (ID: {3920B223-9351-4357-8D0C-DD64EB4B5117}). */
export type SkipLinkParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Rendering Parameters/Skip Link Parameters template (ID: {3920B223-9351-4357-8D0C-DD64EB4B5117}). */
export type SkipLinkParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Links Folder template (ID: {1DC97094-8357-4335-8DF5-3349193B1E02}). */
export type SkipLinksFolder = Item & {
  __typename?: 'SkipLinksFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Links Folder template (ID: {1DC97094-8357-4335-8DF5-3349193B1E02}). */
export type SkipLinksFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Links Folder template (ID: {1DC97094-8357-4335-8DF5-3349193B1E02}). */
export type SkipLinksFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Links Folder template (ID: {1DC97094-8357-4335-8DF5-3349193B1E02}). */
export type SkipLinksFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Links Folder template (ID: {1DC97094-8357-4335-8DF5-3349193B1E02}). */
export type SkipLinksFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Links Folder template (ID: {1DC97094-8357-4335-8DF5-3349193B1E02}). */
export type SkipLinksFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Accessibility/Skip Links Folder template (ID: {1DC97094-8357-4335-8DF5-3349193B1E02}). */
export type SkipLinksFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Snippet template (ID: {3DF44DFB-1292-4D31-837C-15042EDB6609}). */
export type Snippet = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Snippet';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Snippet template (ID: {3DF44DFB-1292-4D31-837C-15042EDB6609}). */
export type SnippetAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Snippet template (ID: {3DF44DFB-1292-4D31-837C-15042EDB6609}). */
export type SnippetChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Snippet template (ID: {3DF44DFB-1292-4D31-837C-15042EDB6609}). */
export type SnippetFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Snippet template (ID: {3DF44DFB-1292-4D31-837C-15042EDB6609}). */
export type SnippetFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Snippet template (ID: {3DF44DFB-1292-4D31-837C-15042EDB6609}). */
export type SnippetHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Snippet template (ID: {3DF44DFB-1292-4D31-837C-15042EDB6609}). */
export type SnippetIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippet Item template (ID: {2B35E65C-137A-4641-B683-D223CA7CFAC0}). */
export type SnippetItem = GlobalDatasourceBehavior & Item & {
  __typename?: 'SnippetItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source Selection Behavior (ID: {C80E6F3C-5BCD-426B-B1EB-6D10672E985D}). */
  dataSourceSelectionBehavior?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippet Item template (ID: {2B35E65C-137A-4641-B683-D223CA7CFAC0}). */
export type SnippetItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippet Item template (ID: {2B35E65C-137A-4641-B683-D223CA7CFAC0}). */
export type SnippetItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippet Item template (ID: {2B35E65C-137A-4641-B683-D223CA7CFAC0}). */
export type SnippetItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippet Item template (ID: {2B35E65C-137A-4641-B683-D223CA7CFAC0}). */
export type SnippetItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippet Item template (ID: {2B35E65C-137A-4641-B683-D223CA7CFAC0}). */
export type SnippetItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippet Item template (ID: {2B35E65C-137A-4641-B683-D223CA7CFAC0}). */
export type SnippetItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippets Folder template (ID: {E854B5B7-510C-4B65-97F7-D483A9B54398}). */
export type SnippetsFolder = Item & {
  __typename?: 'SnippetsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippets Folder template (ID: {E854B5B7-510C-4B65-97F7-D483A9B54398}). */
export type SnippetsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippets Folder template (ID: {E854B5B7-510C-4B65-97F7-D483A9B54398}). */
export type SnippetsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippets Folder template (ID: {E854B5B7-510C-4B65-97F7-D483A9B54398}). */
export type SnippetsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippets Folder template (ID: {E854B5B7-510C-4B65-97F7-D483A9B54398}). */
export type SnippetsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippets Folder template (ID: {E854B5B7-510C-4B65-97F7-D483A9B54398}). */
export type SnippetsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Snippet/Snippets Folder template (ID: {E854B5B7-510C-4B65-97F7-D483A9B54398}). */
export type SnippetsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Social Login Wrapper template (ID: {A2C4B25D-6FAB-459C-8CEE-3A3320F1BEE6}). */
export type SocialLoginWrapper = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'SocialLoginWrapper';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Social Login Wrapper template (ID: {A2C4B25D-6FAB-459C-8CEE-3A3320F1BEE6}). */
export type SocialLoginWrapperAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Social Login Wrapper template (ID: {A2C4B25D-6FAB-459C-8CEE-3A3320F1BEE6}). */
export type SocialLoginWrapperChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Social Login Wrapper template (ID: {A2C4B25D-6FAB-459C-8CEE-3A3320F1BEE6}). */
export type SocialLoginWrapperFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Social Login Wrapper template (ID: {A2C4B25D-6FAB-459C-8CEE-3A3320F1BEE6}). */
export type SocialLoginWrapperFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Social Login Wrapper template (ID: {A2C4B25D-6FAB-459C-8CEE-3A3320F1BEE6}). */
export type SocialLoginWrapperHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Security/Rendering Parameters/Social Login Wrapper template (ID: {A2C4B25D-6FAB-459C-8CEE-3A3320F1BEE6}). */
export type SocialLoginWrapperIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Buttons template (ID: {EFAFBBF5-01A0-46D3-9F7B-E71763E7F221}). */
export type SocialMediaButtons = Item & {
  __typename?: 'SocialMediaButtons';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Buttons template (ID: {EFAFBBF5-01A0-46D3-9F7B-E71763E7F221}). */
export type SocialMediaButtonsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Buttons template (ID: {EFAFBBF5-01A0-46D3-9F7B-E71763E7F221}). */
export type SocialMediaButtonsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Buttons template (ID: {EFAFBBF5-01A0-46D3-9F7B-E71763E7F221}). */
export type SocialMediaButtonsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Buttons template (ID: {EFAFBBF5-01A0-46D3-9F7B-E71763E7F221}). */
export type SocialMediaButtonsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Buttons template (ID: {EFAFBBF5-01A0-46D3-9F7B-E71763E7F221}). */
export type SocialMediaButtonsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Buttons template (ID: {EFAFBBF5-01A0-46D3-9F7B-E71763E7F221}). */
export type SocialMediaButtonsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Folder template (ID: {B14BAB5B-8965-466B-886B-1F93175BCAB3}). */
export type SocialMediaFolder = Item & {
  __typename?: 'SocialMediaFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Folder template (ID: {B14BAB5B-8965-466B-886B-1F93175BCAB3}). */
export type SocialMediaFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Folder template (ID: {B14BAB5B-8965-466B-886B-1F93175BCAB3}). */
export type SocialMediaFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Folder template (ID: {B14BAB5B-8965-466B-886B-1F93175BCAB3}). */
export type SocialMediaFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Folder template (ID: {B14BAB5B-8965-466B-886B-1F93175BCAB3}). */
export type SocialMediaFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Folder template (ID: {B14BAB5B-8965-466B-886B-1F93175BCAB3}). */
export type SocialMediaFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Social Media Folder template (ID: {B14BAB5B-8965-466B-886B-1F93175BCAB3}). */
export type SocialMediaFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Social Media Share template (ID: {56DF23C8-35EA-4C41-ABA4-2AB7EC2FC80C}). */
export type SocialMediaShare = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'SocialMediaShare';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Social Media Share template (ID: {56DF23C8-35EA-4C41-ABA4-2AB7EC2FC80C}). */
export type SocialMediaShareAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Social Media Share template (ID: {56DF23C8-35EA-4C41-ABA4-2AB7EC2FC80C}). */
export type SocialMediaShareChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Social Media Share template (ID: {56DF23C8-35EA-4C41-ABA4-2AB7EC2FC80C}). */
export type SocialMediaShareFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Social Media Share template (ID: {56DF23C8-35EA-4C41-ABA4-2AB7EC2FC80C}). */
export type SocialMediaShareFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Social Media Share template (ID: {56DF23C8-35EA-4C41-ABA4-2AB7EC2FC80C}). */
export type SocialMediaShareHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/Social Media Share template (ID: {56DF23C8-35EA-4C41-ABA4-2AB7EC2FC80C}). */
export type SocialMediaShareIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/SocialMediaTemplate template (ID: {3DE7AA7E-961A-4B90-98F2-01AC2BE92EC5}). */
export type SocialMediaTemplate = Item & {
  __typename?: 'SocialMediaTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** ButtonCode (ID: {31B5C056-CFD5-4331-950D-25453A808D7C}). */
  buttonCode?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled (ID: {FFDB9651-779B-4219-B983-D42FEF761E1B}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OnlyOnceCode (ID: {3A453560-042A-4DF9-945F-5750EA7C4A46}). */
  onlyOnceCode?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** ShareTextProperty (ID: {66509977-761C-499C-AC9B-65830516EE11}). */
  shareTextProperty?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/SocialMediaTemplate template (ID: {3DE7AA7E-961A-4B90-98F2-01AC2BE92EC5}). */
export type SocialMediaTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/SocialMediaTemplate template (ID: {3DE7AA7E-961A-4B90-98F2-01AC2BE92EC5}). */
export type SocialMediaTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/SocialMediaTemplate template (ID: {3DE7AA7E-961A-4B90-98F2-01AC2BE92EC5}). */
export type SocialMediaTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/SocialMediaTemplate template (ID: {3DE7AA7E-961A-4B90-98F2-01AC2BE92EC5}). */
export type SocialMediaTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/SocialMediaTemplate template (ID: {3DE7AA7E-961A-4B90-98F2-01AC2BE92EC5}). */
export type SocialMediaTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/SocialMediaTemplate template (ID: {3DE7AA7E-961A-4B90-98F2-01AC2BE92EC5}). */
export type SocialMediaTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network template (ID: {93847328-4C5F-46B7-80F0-C296109B7FA5}). */
export type SocialNetwork = Item & {
  __typename?: 'SocialNetwork';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network template (ID: {93847328-4C5F-46B7-80F0-C296109B7FA5}). */
export type SocialNetworkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network template (ID: {93847328-4C5F-46B7-80F0-C296109B7FA5}). */
export type SocialNetworkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network template (ID: {93847328-4C5F-46B7-80F0-C296109B7FA5}). */
export type SocialNetworkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network template (ID: {93847328-4C5F-46B7-80F0-C296109B7FA5}). */
export type SocialNetworkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network template (ID: {93847328-4C5F-46B7-80F0-C296109B7FA5}). */
export type SocialNetworkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network template (ID: {93847328-4C5F-46B7-80F0-C296109B7FA5}). */
export type SocialNetworkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Folder template (ID: {6BF2D646-8F0B-42A3-817E-1259398656D7}). */
export type SocialNetworkFolder = Item & {
  __typename?: 'SocialNetworkFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Folder template (ID: {6BF2D646-8F0B-42A3-817E-1259398656D7}). */
export type SocialNetworkFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Folder template (ID: {6BF2D646-8F0B-42A3-817E-1259398656D7}). */
export type SocialNetworkFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Folder template (ID: {6BF2D646-8F0B-42A3-817E-1259398656D7}). */
export type SocialNetworkFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Folder template (ID: {6BF2D646-8F0B-42A3-817E-1259398656D7}). */
export type SocialNetworkFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Folder template (ID: {6BF2D646-8F0B-42A3-817E-1259398656D7}). */
export type SocialNetworkFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Folder template (ID: {6BF2D646-8F0B-42A3-817E-1259398656D7}). */
export type SocialNetworkFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Link template (ID: {8150861E-9612-4B13-A245-F7E0F289CA9B}). */
export type SocialNetworkLink = Item & {
  __typename?: 'SocialNetworkLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** icon (ID: {46535B0B-75D6-4F1C-9196-B928E3FFCAEA}). */
  icon_46535b0b75d64f1c9196b928e3ffcaea?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {930B21EA-62D3-49E4-8BF2-4661E2E25EAA}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Link template (ID: {8150861E-9612-4B13-A245-F7E0F289CA9B}). */
export type SocialNetworkLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Link template (ID: {8150861E-9612-4B13-A245-F7E0F289CA9B}). */
export type SocialNetworkLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Link template (ID: {8150861E-9612-4B13-A245-F7E0F289CA9B}). */
export type SocialNetworkLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Link template (ID: {8150861E-9612-4B13-A245-F7E0F289CA9B}). */
export type SocialNetworkLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Link template (ID: {8150861E-9612-4B13-A245-F7E0F289CA9B}). */
export type SocialNetworkLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Navigation/Datasource/Social Network/Social Network Link template (ID: {8150861E-9612-4B13-A245-F7E0F289CA9B}). */
export type SocialNetworkLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Solution template template (ID: {1B2DFD3B-F2F2-4F40-A75C-F6C2490919C4}). */
export type SolutionTemplate = Item & _SolutionTemplateContent & _SolutionTemplateDescription & _SolutionTemplateName & {
  __typename?: 'SolutionTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Built-in template (ID: {A13AAE24-A295-4CC3-B188-DFA59E2172A9}). */
  builtinTemplate?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {DA855368-E5F2-4932-AE55-7F8B08A5A205}). */
  content?: Maybe<TextField>;
  /** Description (ID: {9F437E68-A84D-48AE-8CE1-A3E26C0B5E64}). */
  description_9f437e68a84d48ae8ce1a3e26c0b5e64?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled (ID: {0D21F818-1938-4CD8-B0A8-A44F73D69367}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {82E64B52-0B8A-4A38-8C78-530C5493814E}). */
  name_82e64b520b8a4a388c78530c5493814e?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Site Modules (ID: {C262443B-653D-461D-96C8-7CFAA0EF2B2D}). */
  siteModules?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Tenant Modules (ID: {41AC536A-923A-43F9-AC87-F3993F638125}). */
  tenantModules?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Solution template template (ID: {1B2DFD3B-F2F2-4F40-A75C-F6C2490919C4}). */
export type SolutionTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Solution template template (ID: {1B2DFD3B-F2F2-4F40-A75C-F6C2490919C4}). */
export type SolutionTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Solution template template (ID: {1B2DFD3B-F2F2-4F40-A75C-F6C2490919C4}). */
export type SolutionTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Solution template template (ID: {1B2DFD3B-F2F2-4F40-A75C-F6C2490919C4}). */
export type SolutionTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Solution template template (ID: {1B2DFD3B-F2F2-4F40-A75C-F6C2490919C4}). */
export type SolutionTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Solution template template (ID: {1B2DFD3B-F2F2-4F40-A75C-F6C2490919C4}). */
export type SolutionTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Sort Results template (ID: {A9135A64-C3A3-4746-B740-FD6EB2579AA5}). */
export type SortResults = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & _SearchSignature & {
  __typename?: 'SortResults';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Sort Results template (ID: {A9135A64-C3A3-4746-B740-FD6EB2579AA5}). */
export type SortResultsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Sort Results template (ID: {A9135A64-C3A3-4746-B740-FD6EB2579AA5}). */
export type SortResultsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Sort Results template (ID: {A9135A64-C3A3-4746-B740-FD6EB2579AA5}). */
export type SortResultsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Sort Results template (ID: {A9135A64-C3A3-4746-B740-FD6EB2579AA5}). */
export type SortResultsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Sort Results template (ID: {A9135A64-C3A3-4746-B740-FD6EB2579AA5}). */
export type SortResultsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Sort Results template (ID: {A9135A64-C3A3-4746-B740-FD6EB2579AA5}). */
export type SortResultsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Sort Results Folder template (ID: {C24428AB-3AF5-44CD-AB5F-5F7E33F9D1AC}). */
export type SortResultsFolder = Item & {
  __typename?: 'SortResultsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Sort Results Folder template (ID: {C24428AB-3AF5-44CD-AB5F-5F7E33F9D1AC}). */
export type SortResultsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Sort Results Folder template (ID: {C24428AB-3AF5-44CD-AB5F-5F7E33F9D1AC}). */
export type SortResultsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Sort Results Folder template (ID: {C24428AB-3AF5-44CD-AB5F-5F7E33F9D1AC}). */
export type SortResultsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Sort Results Folder template (ID: {C24428AB-3AF5-44CD-AB5F-5F7E33F9D1AC}). */
export type SortResultsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Sort Results Folder template (ID: {C24428AB-3AF5-44CD-AB5F-5F7E33F9D1AC}). */
export type SortResultsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Roots/Renderings/Sort Results Folder template (ID: {C24428AB-3AF5-44CD-AB5F-5F7E33F9D1AC}). */
export type SortResultsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Sorting template (ID: {3E53AC1B-65E8-4AE2-8C5B-8BAF9C3D655E}). */
export type Sorting = Item & {
  __typename?: 'Sorting';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Direction (ID: {73A7C430-816E-4481-B4C1-3AB8C2C1052B}). */
  direction?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Facet (ID: {C95B7BAD-FA93-41F0-82DE-C2C2BF0A0E89}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {F3B01C7D-BD46-4972-AB13-4C9C95C4F23D}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Sorting template (ID: {3E53AC1B-65E8-4AE2-8C5B-8BAF9C3D655E}). */
export type SortingAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Sorting template (ID: {3E53AC1B-65E8-4AE2-8C5B-8BAF9C3D655E}). */
export type SortingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Sorting template (ID: {3E53AC1B-65E8-4AE2-8C5B-8BAF9C3D655E}). */
export type SortingFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Sorting template (ID: {3E53AC1B-65E8-4AE2-8C5B-8BAF9C3D655E}). */
export type SortingFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Sorting template (ID: {3E53AC1B-65E8-4AE2-8C5B-8BAF9C3D655E}). */
export type SortingHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/Sorting template (ID: {3E53AC1B-65E8-4AE2-8C5B-8BAF9C3D655E}). */
export type SortingIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/SortingGroups template (ID: {CD618631-E4E3-4943-A3A4-D3B4B39DF327}). */
export type SortingGroups = Item & {
  __typename?: 'SortingGroups';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Grouped (ID: {BF7F1D61-2F56-45AC-90DE-3BFFBB897E5B}). */
  grouped?: Maybe<CheckboxField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {29AC186D-0A90-470F-93D0-F548179B1FC3}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/SortingGroups template (ID: {CD618631-E4E3-4943-A3A4-D3B4B39DF327}). */
export type SortingGroupsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/SortingGroups template (ID: {CD618631-E4E3-4943-A3A4-D3B4B39DF327}). */
export type SortingGroupsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/SortingGroups template (ID: {CD618631-E4E3-4943-A3A4-D3B4B39DF327}). */
export type SortingGroupsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/SortingGroups template (ID: {CD618631-E4E3-4943-A3A4-D3B4B39DF327}). */
export type SortingGroupsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/SortingGroups template (ID: {CD618631-E4E3-4943-A3A4-D3B4B39DF327}). */
export type SortingGroupsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Search/Datasource/SortingGroups template (ID: {CD618631-E4E3-4943-A3A4-D3B4B39DF327}). */
export type SortingGroupsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast template (ID: {4D9F7C66-C84D-44EC-8E0F-932CEC15F107}). */
export type SpotifyPodcast = Item & {
  __typename?: 'SpotifyPodcast';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {7A502188-2C51-41FA-AD11-284F0FCB45D8}). */
  title?: Maybe<TextField>;
  /** transcript (ID: {199FBCDD-B217-4B04-BD9D-2502F685C55E}). */
  transcript?: Maybe<RichTextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** url (ID: {BF98B682-D918-40F6-A16D-D4A7B2FEFF8E}). */
  url_bf98b682d91840f6a16dd4a7b2feff8e?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast template (ID: {4D9F7C66-C84D-44EC-8E0F-932CEC15F107}). */
export type SpotifyPodcastAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast template (ID: {4D9F7C66-C84D-44EC-8E0F-932CEC15F107}). */
export type SpotifyPodcastChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast template (ID: {4D9F7C66-C84D-44EC-8E0F-932CEC15F107}). */
export type SpotifyPodcastFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast template (ID: {4D9F7C66-C84D-44EC-8E0F-932CEC15F107}). */
export type SpotifyPodcastFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast template (ID: {4D9F7C66-C84D-44EC-8E0F-932CEC15F107}). */
export type SpotifyPodcastHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast template (ID: {4D9F7C66-C84D-44EC-8E0F-932CEC15F107}). */
export type SpotifyPodcastIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast Folder template (ID: {858CB9D6-97B0-4A74-8FB5-C3697013C101}). */
export type SpotifyPodcastFolder = Item & {
  __typename?: 'SpotifyPodcastFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast Folder template (ID: {858CB9D6-97B0-4A74-8FB5-C3697013C101}). */
export type SpotifyPodcastFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast Folder template (ID: {858CB9D6-97B0-4A74-8FB5-C3697013C101}). */
export type SpotifyPodcastFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast Folder template (ID: {858CB9D6-97B0-4A74-8FB5-C3697013C101}). */
export type SpotifyPodcastFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast Folder template (ID: {858CB9D6-97B0-4A74-8FB5-C3697013C101}). */
export type SpotifyPodcastFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast Folder template (ID: {858CB9D6-97B0-4A74-8FB5-C3697013C101}). */
export type SpotifyPodcastFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Spotify Podcast/Spotify Podcast Folder template (ID: {858CB9D6-97B0-4A74-8FB5-C3697013C101}). */
export type SpotifyPodcastFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/System/Layout/Rendering Parameters/Standard Rendering Parameters template (ID: {8CA06D6A-B353-44E8-BC31-B528C7306971}). */
export type StandardRenderingParameters = {
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA template (ID: {EB8F15E4-20F7-4888-B5D7-CB67D75752C1}). */
export type StickyCta = Item & {
  __typename?: 'StickyCTA';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ctaLink (ID: {A556AA68-3146-4271-A7F1-C4912065966A}). */
  ctaLink?: Maybe<TextField>;
  /** ctaLogo (ID: {A98C2211-376A-4662-8794-0112FA635099}). */
  ctaLogo?: Maybe<TextField>;
  /** desktopAnimation (ID: {69CED18B-B777-47C6-94DA-5267F2A7EC10}). */
  desktopAnimation?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** mobileAnimation (ID: {7D353C98-06FD-4E4F-A768-A82D4DC1A8CA}). */
  mobileAnimation?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {99FB5224-AF91-46BC-90E7-4322E56C0597}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA template (ID: {EB8F15E4-20F7-4888-B5D7-CB67D75752C1}). */
export type StickyCtaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA template (ID: {EB8F15E4-20F7-4888-B5D7-CB67D75752C1}). */
export type StickyCtaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA template (ID: {EB8F15E4-20F7-4888-B5D7-CB67D75752C1}). */
export type StickyCtaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA template (ID: {EB8F15E4-20F7-4888-B5D7-CB67D75752C1}). */
export type StickyCtaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA template (ID: {EB8F15E4-20F7-4888-B5D7-CB67D75752C1}). */
export type StickyCtaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA template (ID: {EB8F15E4-20F7-4888-B5D7-CB67D75752C1}). */
export type StickyCtaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA Folder template (ID: {5F262F1E-DF38-4CA0-A928-4B96644953D0}). */
export type StickyCtaFolder = Item & {
  __typename?: 'StickyCTAFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA Folder template (ID: {5F262F1E-DF38-4CA0-A928-4B96644953D0}). */
export type StickyCtaFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA Folder template (ID: {5F262F1E-DF38-4CA0-A928-4B96644953D0}). */
export type StickyCtaFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA Folder template (ID: {5F262F1E-DF38-4CA0-A928-4B96644953D0}). */
export type StickyCtaFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA Folder template (ID: {5F262F1E-DF38-4CA0-A928-4B96644953D0}). */
export type StickyCtaFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA Folder template (ID: {5F262F1E-DF38-4CA0-A928-4B96644953D0}). */
export type StickyCtaFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Sticky CTA/Sticky CTA Folder template (ID: {5F262F1E-DF38-4CA0-A928-4B96644953D0}). */
export type StickyCtaFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Sticky CTA Parameters Template template (ID: {89D31DAC-1862-4310-B19F-730DDFEC7C5A}). */
export type StickyCtaParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'StickyCTAParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {A8466CAB-524F-4B5F-AED5-0DBE64534EFE}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Sticky CTA Parameters Template template (ID: {89D31DAC-1862-4310-B19F-730DDFEC7C5A}). */
export type StickyCtaParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Sticky CTA Parameters Template template (ID: {89D31DAC-1862-4310-B19F-730DDFEC7C5A}). */
export type StickyCtaParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Sticky CTA Parameters Template template (ID: {89D31DAC-1862-4310-B19F-730DDFEC7C5A}). */
export type StickyCtaParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Sticky CTA Parameters Template template (ID: {89D31DAC-1862-4310-B19F-730DDFEC7C5A}). */
export type StickyCtaParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Sticky CTA Parameters Template template (ID: {89D31DAC-1862-4310-B19F-730DDFEC7C5A}). */
export type StickyCtaParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Sticky CTA Parameters Template template (ID: {89D31DAC-1862-4310-B19F-730DDFEC7C5A}). */
export type StickyCtaParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategies In Focus Folder template (ID: {85AB1452-1B9B-4842-9B31-F05A032C0406}). */
export type StrategiesInFocusFolder = Item & {
  __typename?: 'StrategiesInFocusFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategies In Focus Folder template (ID: {85AB1452-1B9B-4842-9B31-F05A032C0406}). */
export type StrategiesInFocusFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategies In Focus Folder template (ID: {85AB1452-1B9B-4842-9B31-F05A032C0406}). */
export type StrategiesInFocusFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategies In Focus Folder template (ID: {85AB1452-1B9B-4842-9B31-F05A032C0406}). */
export type StrategiesInFocusFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategies In Focus Folder template (ID: {85AB1452-1B9B-4842-9B31-F05A032C0406}). */
export type StrategiesInFocusFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategies In Focus Folder template (ID: {85AB1452-1B9B-4842-9B31-F05A032C0406}). */
export type StrategiesInFocusFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategies In Focus Folder template (ID: {85AB1452-1B9B-4842-9B31-F05A032C0406}). */
export type StrategiesInFocusFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategy In Focus template (ID: {CA36FD00-1C06-478D-BCEE-2613D7F0B8AB}). */
export type StrategyInFocus = Item & {
  __typename?: 'StrategyInFocus';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** funds (ID: {CBE104F4-586E-4ADC-9631-1DDBE2DA4903}). */
  funds?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategy In Focus template (ID: {CA36FD00-1C06-478D-BCEE-2613D7F0B8AB}). */
export type StrategyInFocusAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategy In Focus template (ID: {CA36FD00-1C06-478D-BCEE-2613D7F0B8AB}). */
export type StrategyInFocusChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategy In Focus template (ID: {CA36FD00-1C06-478D-BCEE-2613D7F0B8AB}). */
export type StrategyInFocusFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategy In Focus template (ID: {CA36FD00-1C06-478D-BCEE-2613D7F0B8AB}). */
export type StrategyInFocusFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategy In Focus template (ID: {CA36FD00-1C06-478D-BCEE-2613D7F0B8AB}). */
export type StrategyInFocusHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Strategy In Focus/Strategy In Focus template (ID: {CA36FD00-1C06-478D-BCEE-2613D7F0B8AB}). */
export type StrategyInFocusIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Style template (ID: {6B8AABEF-D650-46E0-97D0-C0B04F7F016B}). */
export type Style = IIcon & Item & {
  __typename?: 'Style';
  /** Allowed Renderings (ID: {69BB49F3-DA64-4B0E-ABD6-184B832FF6AB}). */
  allowedRenderings?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Icon (ID: {39816442-74D9-4CE2-BEB3-128B204EFD40}). */
  icon_3981644274d94ce2beb3128b204efd40?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IsVerifiedStyle (ID: {95579875-484E-41F0-B9C2-804EAFAF3CCC}). */
  isVerifiedStyle?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Value (ID: {09147FB2-EBFB-4949-8C8E-26A424409D5E}). */
  value?: Maybe<TextField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Style template (ID: {6B8AABEF-D650-46E0-97D0-C0B04F7F016B}). */
export type StyleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Style template (ID: {6B8AABEF-D650-46E0-97D0-C0B04F7F016B}). */
export type StyleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Style template (ID: {6B8AABEF-D650-46E0-97D0-C0B04F7F016B}). */
export type StyleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Style template (ID: {6B8AABEF-D650-46E0-97D0-C0B04F7F016B}). */
export type StyleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Style template (ID: {6B8AABEF-D650-46E0-97D0-C0B04F7F016B}). */
export type StyleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Style template (ID: {6B8AABEF-D650-46E0-97D0-C0B04F7F016B}). */
export type StyleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Styles template (ID: {C6DC7393-15BB-4CD7-B798-AB63E77EBAC4}). */
export type Styles = IAllowEmpty & IControlType & Item & {
  __typename?: 'Styles';
  /** AllowEmpty (ID: {C91E098F-A65C-4625-B166-0ED004ADAA75}). */
  allowEmpty?: Maybe<CheckboxField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Type (ID: {62CA1C9E-71A4-465F-835E-55BDA7BB270B}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Styles template (ID: {C6DC7393-15BB-4CD7-B798-AB63E77EBAC4}). */
export type StylesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Styles template (ID: {C6DC7393-15BB-4CD7-B798-AB63E77EBAC4}). */
export type StylesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Styles template (ID: {C6DC7393-15BB-4CD7-B798-AB63E77EBAC4}). */
export type StylesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Styles template (ID: {C6DC7393-15BB-4CD7-B798-AB63E77EBAC4}). */
export type StylesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Styles template (ID: {C6DC7393-15BB-4CD7-B798-AB63E77EBAC4}). */
export type StylesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Styles template (ID: {C6DC7393-15BB-4CD7-B798-AB63E77EBAC4}). */
export type StylesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Styles template (ID: {9C0DAC28-08AA-4B44-BC21-53363206F6A5}). */
export type Styles_9c0dac2808aa4b44bc2153363206f6a5 = Item & {
  __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Styles template (ID: {9C0DAC28-08AA-4B44-BC21-53363206F6A5}). */
export type Styles_9c0dac2808aa4b44bc2153363206f6a5AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Styles template (ID: {9C0DAC28-08AA-4B44-BC21-53363206F6A5}). */
export type Styles_9c0dac2808aa4b44bc2153363206f6a5ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Styles template (ID: {9C0DAC28-08AA-4B44-BC21-53363206F6A5}). */
export type Styles_9c0dac2808aa4b44bc2153363206f6a5FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Styles template (ID: {9C0DAC28-08AA-4B44-BC21-53363206F6A5}). */
export type Styles_9c0dac2808aa4b44bc2153363206f6a5FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Styles template (ID: {9C0DAC28-08AA-4B44-BC21-53363206F6A5}). */
export type Styles_9c0dac2808aa4b44bc2153363206f6a5HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Folders/Styles template (ID: {9C0DAC28-08AA-4B44-BC21-53363206F6A5}). */
export type Styles_9c0dac2808aa4b44bc2153363206f6a5IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Subscription Banner Parameters Template template (ID: {10FFB0B1-8265-4F2F-95F7-0BAC23EC926B}). */
export type SubscriptionBannerParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'SubscriptionBannerParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {35FC7CFB-E380-47D3-9930-3E9FFF86A8EC}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Subscription Banner Parameters Template template (ID: {10FFB0B1-8265-4F2F-95F7-0BAC23EC926B}). */
export type SubscriptionBannerParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Subscription Banner Parameters Template template (ID: {10FFB0B1-8265-4F2F-95F7-0BAC23EC926B}). */
export type SubscriptionBannerParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Subscription Banner Parameters Template template (ID: {10FFB0B1-8265-4F2F-95F7-0BAC23EC926B}). */
export type SubscriptionBannerParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Subscription Banner Parameters Template template (ID: {10FFB0B1-8265-4F2F-95F7-0BAC23EC926B}). */
export type SubscriptionBannerParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Subscription Banner Parameters Template template (ID: {10FFB0B1-8265-4F2F-95F7-0BAC23EC926B}). */
export type SubscriptionBannerParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Subscription Banner Parameters Template template (ID: {10FFB0B1-8265-4F2F-95F7-0BAC23EC926B}). */
export type SubscriptionBannerParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Tab template (ID: {2243E188-3079-4007-B43A-02C563E88212}). */
export type Tab = Item & {
  __typename?: 'Tab';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {CFCE6191-B1BE-4388-9C94-6CE4D5CE5F85}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Tab template (ID: {2243E188-3079-4007-B43A-02C563E88212}). */
export type TabAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Tab template (ID: {2243E188-3079-4007-B43A-02C563E88212}). */
export type TabChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Tab template (ID: {2243E188-3079-4007-B43A-02C563E88212}). */
export type TabFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Tab template (ID: {2243E188-3079-4007-B43A-02C563E88212}). */
export type TabFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Tab template (ID: {2243E188-3079-4007-B43A-02C563E88212}). */
export type TabHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Page Level Tabs/Tab template (ID: {2243E188-3079-4007-B43A-02C563E88212}). */
export type TabIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tab Item template (ID: {B27059E6-1190-4273-92A0-D22AF3C440B4}). */
export type TabItem = Item & {
  __typename?: 'TabItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Content (ID: {99F62656-1F3E-4F98-9EAC-A596FB174BA0}). */
  content?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Heading (ID: {70181515-2AAB-4710-91F4-52A08151693E}). */
  heading?: Maybe<RichTextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tab Item template (ID: {B27059E6-1190-4273-92A0-D22AF3C440B4}). */
export type TabItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tab Item template (ID: {B27059E6-1190-4273-92A0-D22AF3C440B4}). */
export type TabItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tab Item template (ID: {B27059E6-1190-4273-92A0-D22AF3C440B4}). */
export type TabItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tab Item template (ID: {B27059E6-1190-4273-92A0-D22AF3C440B4}). */
export type TabItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tab Item template (ID: {B27059E6-1190-4273-92A0-D22AF3C440B4}). */
export type TabItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tab Item template (ID: {B27059E6-1190-4273-92A0-D22AF3C440B4}). */
export type TabItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents template (ID: {76E35450-A213-4672-B0C3-660F13A75733}). */
export type TableOfContents = Item & {
  __typename?: 'TableOfContents';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {8DF912FC-8D98-476D-AB8E-28B8A3880B84}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents template (ID: {76E35450-A213-4672-B0C3-660F13A75733}). */
export type TableOfContentsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents template (ID: {76E35450-A213-4672-B0C3-660F13A75733}). */
export type TableOfContentsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents template (ID: {76E35450-A213-4672-B0C3-660F13A75733}). */
export type TableOfContentsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents template (ID: {76E35450-A213-4672-B0C3-660F13A75733}). */
export type TableOfContentsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents template (ID: {76E35450-A213-4672-B0C3-660F13A75733}). */
export type TableOfContentsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents template (ID: {76E35450-A213-4672-B0C3-660F13A75733}). */
export type TableOfContentsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Folder template (ID: {64383F39-9C9C-48EC-84DD-0D445AD9CD6C}). */
export type TableOfContentsFolder = Item & {
  __typename?: 'TableOfContentsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Folder template (ID: {64383F39-9C9C-48EC-84DD-0D445AD9CD6C}). */
export type TableOfContentsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Folder template (ID: {64383F39-9C9C-48EC-84DD-0D445AD9CD6C}). */
export type TableOfContentsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Folder template (ID: {64383F39-9C9C-48EC-84DD-0D445AD9CD6C}). */
export type TableOfContentsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Folder template (ID: {64383F39-9C9C-48EC-84DD-0D445AD9CD6C}). */
export type TableOfContentsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Folder template (ID: {64383F39-9C9C-48EC-84DD-0D445AD9CD6C}). */
export type TableOfContentsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Folder template (ID: {64383F39-9C9C-48EC-84DD-0D445AD9CD6C}). */
export type TableOfContentsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Section template (ID: {6C0749D0-447F-4DC3-B3B1-481F08BE3984}). */
export type TableOfContentsSection = Item & {
  __typename?: 'TableOfContentsSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {A3D41FA3-4ADC-49C3-90EA-D0FD1436B632}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Section template (ID: {6C0749D0-447F-4DC3-B3B1-481F08BE3984}). */
export type TableOfContentsSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Section template (ID: {6C0749D0-447F-4DC3-B3B1-481F08BE3984}). */
export type TableOfContentsSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Section template (ID: {6C0749D0-447F-4DC3-B3B1-481F08BE3984}). */
export type TableOfContentsSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Section template (ID: {6C0749D0-447F-4DC3-B3B1-481F08BE3984}). */
export type TableOfContentsSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Section template (ID: {6C0749D0-447F-4DC3-B3B1-481F08BE3984}). */
export type TableOfContentsSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Section template (ID: {6C0749D0-447F-4DC3-B3B1-481F08BE3984}). */
export type TableOfContentsSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Subsection template (ID: {EC27A46D-7252-440B-95AC-409E04E48D10}). */
export type TableOfContentsSubsection = Item & {
  __typename?: 'TableOfContentsSubsection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {7658DD01-8F5D-44E9-A74F-77DE38807C55}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** subsectionTitle (ID: {BBD1B61F-FC97-4DC7-8757-CBE875ABD5BB}). */
  subsectionTitle?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Subsection template (ID: {EC27A46D-7252-440B-95AC-409E04E48D10}). */
export type TableOfContentsSubsectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Subsection template (ID: {EC27A46D-7252-440B-95AC-409E04E48D10}). */
export type TableOfContentsSubsectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Subsection template (ID: {EC27A46D-7252-440B-95AC-409E04E48D10}). */
export type TableOfContentsSubsectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Subsection template (ID: {EC27A46D-7252-440B-95AC-409E04E48D10}). */
export type TableOfContentsSubsectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Subsection template (ID: {EC27A46D-7252-440B-95AC-409E04E48D10}). */
export type TableOfContentsSubsectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Table of Contents/Table of Contents Subsection template (ID: {EC27A46D-7252-440B-95AC-409E04E48D10}). */
export type TableOfContentsSubsectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Tabs template (ID: {98BA1330-4412-4FCB-8CD5-9818A781D3CC}). */
export type Tabs = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Tabs';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** TabControlBelowContent (ID: {09535391-2445-43B8-8E81-F1FF8AFA648D}). */
  tabControlBelowContent?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Tabs template (ID: {98BA1330-4412-4FCB-8CD5-9818A781D3CC}). */
export type TabsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Tabs template (ID: {98BA1330-4412-4FCB-8CD5-9818A781D3CC}). */
export type TabsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Tabs template (ID: {98BA1330-4412-4FCB-8CD5-9818A781D3CC}). */
export type TabsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Tabs template (ID: {98BA1330-4412-4FCB-8CD5-9818A781D3CC}). */
export type TabsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Tabs template (ID: {98BA1330-4412-4FCB-8CD5-9818A781D3CC}). */
export type TabsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Rendering Parameters/Tabs template (ID: {98BA1330-4412-4FCB-8CD5-9818A781D3CC}). */
export type TabsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs Folder template (ID: {1EF29B63-5B98-463C-B3C8-66DFE99BD641}). */
export type TabsFolder = Item & {
  __typename?: 'TabsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs Folder template (ID: {1EF29B63-5B98-463C-B3C8-66DFE99BD641}). */
export type TabsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs Folder template (ID: {1EF29B63-5B98-463C-B3C8-66DFE99BD641}). */
export type TabsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs Folder template (ID: {1EF29B63-5B98-463C-B3C8-66DFE99BD641}). */
export type TabsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs Folder template (ID: {1EF29B63-5B98-463C-B3C8-66DFE99BD641}). */
export type TabsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs Folder template (ID: {1EF29B63-5B98-463C-B3C8-66DFE99BD641}). */
export type TabsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs Folder template (ID: {1EF29B63-5B98-463C-B3C8-66DFE99BD641}). */
export type TabsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs template (ID: {F26A9560-CCF1-48C5-9542-800E837CAF7A}). */
export type Tabs_F26a9560ccf148c59542800e837caf7a = Item & {
  __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs template (ID: {F26A9560-CCF1-48C5-9542-800E837CAF7A}). */
export type Tabs_F26a9560ccf148c59542800e837caf7aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs template (ID: {F26A9560-CCF1-48C5-9542-800E837CAF7A}). */
export type Tabs_F26a9560ccf148c59542800e837caf7aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs template (ID: {F26A9560-CCF1-48C5-9542-800E837CAF7A}). */
export type Tabs_F26a9560ccf148c59542800e837caf7aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs template (ID: {F26A9560-CCF1-48C5-9542-800E837CAF7A}). */
export type Tabs_F26a9560ccf148c59542800e837caf7aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs template (ID: {F26A9560-CCF1-48C5-9542-800E837CAF7A}). */
export type Tabs_F26a9560ccf148c59542800e837caf7aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/Datasource/Tabs/Tabs template (ID: {F26A9560-CCF1-48C5-9542-800E837CAF7A}). */
export type Tabs_F26a9560ccf148c59542800e837caf7aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag template (ID: {6B40E84C-8785-49FC-8A10-6BCA862FF7EA}). */
export type Tag = Item & {
  __typename?: 'Tag';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {B8A8B6C9-4757-496B-9AAE-5F46FF381563}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag template (ID: {6B40E84C-8785-49FC-8A10-6BCA862FF7EA}). */
export type TagAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag template (ID: {6B40E84C-8785-49FC-8A10-6BCA862FF7EA}). */
export type TagChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag template (ID: {6B40E84C-8785-49FC-8A10-6BCA862FF7EA}). */
export type TagFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag template (ID: {6B40E84C-8785-49FC-8A10-6BCA862FF7EA}). */
export type TagFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag template (ID: {6B40E84C-8785-49FC-8A10-6BCA862FF7EA}). */
export type TagHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag template (ID: {6B40E84C-8785-49FC-8A10-6BCA862FF7EA}). */
export type TagIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag Cloud template (ID: {92B790B2-4A6C-4FA6-8E81-4CC546D23489}). */
export type TagCloud = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'TagCloud';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** Default Language Filter (ID: {39B613F3-36A5-426F-9359-37238160749D}). */
  defaultLanguageFilter?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Facet (ID: {A358F222-FA00-4916-BF31-9630D0487066}). */
  facet?: Maybe<LookupField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Search Result Page (ID: {B8BAA359-BF96-4E71-B867-B7A1AA0C983F}). */
  searchResultPage?: Maybe<LookupField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag Cloud template (ID: {92B790B2-4A6C-4FA6-8E81-4CC546D23489}). */
export type TagCloudAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag Cloud template (ID: {92B790B2-4A6C-4FA6-8E81-4CC546D23489}). */
export type TagCloudChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag Cloud template (ID: {92B790B2-4A6C-4FA6-8E81-4CC546D23489}). */
export type TagCloudFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag Cloud template (ID: {92B790B2-4A6C-4FA6-8E81-4CC546D23489}). */
export type TagCloudFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag Cloud template (ID: {92B790B2-4A6C-4FA6-8E81-4CC546D23489}). */
export type TagCloudHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag Cloud template (ID: {92B790B2-4A6C-4FA6-8E81-4CC546D23489}). */
export type TagCloudIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag Folder template (ID: {25A6B824-672F-4C15-9B98-0B231C80F81C}). */
export type TagFolder = Item & {
  __typename?: 'TagFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag Folder template (ID: {25A6B824-672F-4C15-9B98-0B231C80F81C}). */
export type TagFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag Folder template (ID: {25A6B824-672F-4C15-9B98-0B231C80F81C}). */
export type TagFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag Folder template (ID: {25A6B824-672F-4C15-9B98-0B231C80F81C}). */
export type TagFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag Folder template (ID: {25A6B824-672F-4C15-9B98-0B231C80F81C}). */
export type TagFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag Folder template (ID: {25A6B824-672F-4C15-9B98-0B231C80F81C}). */
export type TagFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/Datasource/Tag Folder template (ID: {25A6B824-672F-4C15-9B98-0B231C80F81C}). */
export type TagFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag List template (ID: {F6AB882E-0AB2-46AD-B0D9-E3BC425C4B66}). */
export type TagList = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'TagList';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Search Result Page (ID: {ACBB7730-16C7-477A-A8ED-BD4F4AD856A7}). */
  searchResultPage?: Maybe<LookupField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag List template (ID: {F6AB882E-0AB2-46AD-B0D9-E3BC425C4B66}). */
export type TagListAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag List template (ID: {F6AB882E-0AB2-46AD-B0D9-E3BC425C4B66}). */
export type TagListChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag List template (ID: {F6AB882E-0AB2-46AD-B0D9-E3BC425C4B66}). */
export type TagListFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag List template (ID: {F6AB882E-0AB2-46AD-B0D9-E3BC425C4B66}). */
export type TagListFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag List template (ID: {F6AB882E-0AB2-46AD-B0D9-E3BC425C4B66}). */
export type TagListHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Taxonomy/Rendering Parameters/Tag List template (ID: {F6AB882E-0AB2-46AD-B0D9-E3BC425C4B66}). */
export type TagListIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Biography Settings/Team Biography Settings template (ID: {54EE7A88-CB4B-4B9D-8DAC-9FAE8971A33A}). */
export type TeamBiographySettings = Item & {
  __typename?: 'TeamBiographySettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** teamBiographyWildcardPage (ID: {CE5DB9CD-8212-4247-AEAF-3C5CD1E4D5C0}). */
  teamBiographyWildcardPage?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Biography Settings/Team Biography Settings template (ID: {54EE7A88-CB4B-4B9D-8DAC-9FAE8971A33A}). */
export type TeamBiographySettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Biography Settings/Team Biography Settings template (ID: {54EE7A88-CB4B-4B9D-8DAC-9FAE8971A33A}). */
export type TeamBiographySettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Biography Settings/Team Biography Settings template (ID: {54EE7A88-CB4B-4B9D-8DAC-9FAE8971A33A}). */
export type TeamBiographySettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Biography Settings/Team Biography Settings template (ID: {54EE7A88-CB4B-4B9D-8DAC-9FAE8971A33A}). */
export type TeamBiographySettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Biography Settings/Team Biography Settings template (ID: {54EE7A88-CB4B-4B9D-8DAC-9FAE8971A33A}). */
export type TeamBiographySettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Biography Settings/Team Biography Settings template (ID: {54EE7A88-CB4B-4B9D-8DAC-9FAE8971A33A}). */
export type TeamBiographySettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards template (ID: {4A39EB0E-D4D7-41CA-A8E0-BEB8E31C2406}). */
export type TeamListingCards = Item & {
  __typename?: 'TeamListingCards';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards template (ID: {4A39EB0E-D4D7-41CA-A8E0-BEB8E31C2406}). */
export type TeamListingCardsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards template (ID: {4A39EB0E-D4D7-41CA-A8E0-BEB8E31C2406}). */
export type TeamListingCardsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards template (ID: {4A39EB0E-D4D7-41CA-A8E0-BEB8E31C2406}). */
export type TeamListingCardsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards template (ID: {4A39EB0E-D4D7-41CA-A8E0-BEB8E31C2406}). */
export type TeamListingCardsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards template (ID: {4A39EB0E-D4D7-41CA-A8E0-BEB8E31C2406}). */
export type TeamListingCardsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards template (ID: {4A39EB0E-D4D7-41CA-A8E0-BEB8E31C2406}). */
export type TeamListingCardsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards Folder template (ID: {0B489FE5-9CE2-4A37-9A36-B0379CCEA2E5}). */
export type TeamListingCardsFolder = Item & {
  __typename?: 'TeamListingCardsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards Folder template (ID: {0B489FE5-9CE2-4A37-9A36-B0379CCEA2E5}). */
export type TeamListingCardsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards Folder template (ID: {0B489FE5-9CE2-4A37-9A36-B0379CCEA2E5}). */
export type TeamListingCardsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards Folder template (ID: {0B489FE5-9CE2-4A37-9A36-B0379CCEA2E5}). */
export type TeamListingCardsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards Folder template (ID: {0B489FE5-9CE2-4A37-9A36-B0379CCEA2E5}). */
export type TeamListingCardsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards Folder template (ID: {0B489FE5-9CE2-4A37-9A36-B0379CCEA2E5}). */
export type TeamListingCardsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Listing Cards Folder template (ID: {0B489FE5-9CE2-4A37-9A36-B0379CCEA2E5}). */
export type TeamListingCardsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Member template (ID: {3B1FCAF5-AEF4-4A7C-901B-77AE4F7B02F4}). */
export type TeamMember = Item & _MetadataPage & {
  __typename?: 'TeamMember';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** downloadImageLink (ID: {86A674B3-3E0E-4678-A2D2-0D7213EE7C65}). */
  downloadImageLink?: Maybe<LinkField>;
  /** email (ID: {EE58A008-5AE0-4E7A-8EC5-383ECCB39672}). */
  email?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** firstName (ID: {2A9FCB3C-401D-4262-98F8-9442F1645454}). */
  firstName?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {36BDFEE8-7C51-4C10-BD6E-DF1918BF8A25}). */
  image?: Maybe<ImageField>;
  /** jobTitle (ID: {91644A28-4D92-44B2-B9B7-648C282B446B}). */
  jobTitle?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** lastName (ID: {6B6B6FE7-3BF6-4205-8959-D548076401BF}). */
  lastName?: Maybe<TextField>;
  /** linkedin (ID: {6EC7ACD1-CFFC-4F00-9D5F-5FC1978F96AC}). */
  linkedin?: Maybe<LinkField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** phoneNumber (ID: {A0A8A8E3-8364-46DF-A684-F91729B4AE53}). */
  phoneNumber?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** twitter (ID: {2EC4DC34-3C36-46EC-87D4-CF815326C183}). */
  twitter?: Maybe<LinkField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Member template (ID: {3B1FCAF5-AEF4-4A7C-901B-77AE4F7B02F4}). */
export type TeamMemberAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Member template (ID: {3B1FCAF5-AEF4-4A7C-901B-77AE4F7B02F4}). */
export type TeamMemberChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Member template (ID: {3B1FCAF5-AEF4-4A7C-901B-77AE4F7B02F4}). */
export type TeamMemberFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Member template (ID: {3B1FCAF5-AEF4-4A7C-901B-77AE4F7B02F4}). */
export type TeamMemberFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Member template (ID: {3B1FCAF5-AEF4-4A7C-901B-77AE4F7B02F4}). */
export type TeamMemberHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Member template (ID: {3B1FCAF5-AEF4-4A7C-901B-77AE4F7B02F4}). */
export type TeamMemberIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Member Card template (ID: {DFE694E4-DABC-4A09-B277-5D6258447272}). */
export type TeamMemberCard = Item & {
  __typename?: 'TeamMemberCard';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {27F05C92-9EE7-4D56-B0EA-09F73EAF330D}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {D85EB222-65A9-4032-8182-5E5FE8664D57}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** position (ID: {B17A516A-013E-4403-877A-508C37C5DC91}). */
  position?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {A2A4BF15-BB4E-4EB4-8F8B-F143CE8240CC}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Member Card template (ID: {DFE694E4-DABC-4A09-B277-5D6258447272}). */
export type TeamMemberCardAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Member Card template (ID: {DFE694E4-DABC-4A09-B277-5D6258447272}). */
export type TeamMemberCardChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Member Card template (ID: {DFE694E4-DABC-4A09-B277-5D6258447272}). */
export type TeamMemberCardFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Member Card template (ID: {DFE694E4-DABC-4A09-B277-5D6258447272}). */
export type TeamMemberCardFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Member Card template (ID: {DFE694E4-DABC-4A09-B277-5D6258447272}). */
export type TeamMemberCardHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Listing Cards/Team Member Card template (ID: {DFE694E4-DABC-4A09-B277-5D6258447272}). */
export type TeamMemberCardIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Members template (ID: {0701AF3F-7550-42D3-9AAA-DB10721A9173}). */
export type TeamMembers = Item & {
  __typename?: 'TeamMembers';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Members template (ID: {0701AF3F-7550-42D3-9AAA-DB10721A9173}). */
export type TeamMembersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Members template (ID: {0701AF3F-7550-42D3-9AAA-DB10721A9173}). */
export type TeamMembersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Members template (ID: {0701AF3F-7550-42D3-9AAA-DB10721A9173}). */
export type TeamMembersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Members template (ID: {0701AF3F-7550-42D3-9AAA-DB10721A9173}). */
export type TeamMembersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Members template (ID: {0701AF3F-7550-42D3-9AAA-DB10721A9173}). */
export type TeamMembersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Team Members/Team Members template (ID: {0701AF3F-7550-42D3-9AAA-DB10721A9173}). */
export type TeamMembersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Team Members Parent Page template (ID: {019D0105-A48C-419A-B0E2-EB21C6C32707}). */
export type TeamMembersParentPage = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersParentPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Parent Page template (ID: {019D0105-A48C-419A-B0E2-EB21C6C32707}). */
export type TeamMembersParentPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Parent Page template (ID: {019D0105-A48C-419A-B0E2-EB21C6C32707}). */
export type TeamMembersParentPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Parent Page template (ID: {019D0105-A48C-419A-B0E2-EB21C6C32707}). */
export type TeamMembersParentPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Parent Page template (ID: {019D0105-A48C-419A-B0E2-EB21C6C32707}). */
export type TeamMembersParentPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Parent Page template (ID: {019D0105-A48C-419A-B0E2-EB21C6C32707}). */
export type TeamMembersParentPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Parent Page template (ID: {019D0105-A48C-419A-B0E2-EB21C6C32707}). */
export type TeamMembersParentPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Parent Page template (ID: {0DFB4014-0BA4-4ABE-8A48-0904FF1EFF1E}). */
export type TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Parent Page template (ID: {0DFB4014-0BA4-4ABE-8A48-0904FF1EFF1E}). */
export type TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Parent Page template (ID: {0DFB4014-0BA4-4ABE-8A48-0904FF1EFF1E}). */
export type TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Parent Page template (ID: {0DFB4014-0BA4-4ABE-8A48-0904FF1EFF1E}). */
export type TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Parent Page template (ID: {0DFB4014-0BA4-4ABE-8A48-0904FF1EFF1E}). */
export type TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Parent Page template (ID: {0DFB4014-0BA4-4ABE-8A48-0904FF1EFF1E}). */
export type TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Parent Page template (ID: {0DFB4014-0BA4-4ABE-8A48-0904FF1EFF1E}). */
export type TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Team Members Parent Page template (ID: {2E9DF92F-E936-4619-87FD-0EA8AD08BD9E}). */
export type TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Parent Page template (ID: {2E9DF92F-E936-4619-87FD-0EA8AD08BD9E}). */
export type TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Parent Page template (ID: {2E9DF92F-E936-4619-87FD-0EA8AD08BD9E}). */
export type TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Parent Page template (ID: {2E9DF92F-E936-4619-87FD-0EA8AD08BD9E}). */
export type TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Parent Page template (ID: {2E9DF92F-E936-4619-87FD-0EA8AD08BD9E}). */
export type TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Parent Page template (ID: {2E9DF92F-E936-4619-87FD-0EA8AD08BD9E}). */
export type TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Parent Page template (ID: {2E9DF92F-E936-4619-87FD-0EA8AD08BD9E}). */
export type TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Team Members Parent Page template (ID: {47F304D6-29A8-4648-A0E2-B942513133FF}). */
export type TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Parent Page template (ID: {47F304D6-29A8-4648-A0E2-B942513133FF}). */
export type TeamMembersParentPage_47f304d629a84648a0e2b942513133ffAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Parent Page template (ID: {47F304D6-29A8-4648-A0E2-B942513133FF}). */
export type TeamMembersParentPage_47f304d629a84648a0e2b942513133ffChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Parent Page template (ID: {47F304D6-29A8-4648-A0E2-B942513133FF}). */
export type TeamMembersParentPage_47f304d629a84648a0e2b942513133ffFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Parent Page template (ID: {47F304D6-29A8-4648-A0E2-B942513133FF}). */
export type TeamMembersParentPage_47f304d629a84648a0e2b942513133ffFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Parent Page template (ID: {47F304D6-29A8-4648-A0E2-B942513133FF}). */
export type TeamMembersParentPage_47f304d629a84648a0e2b942513133ffHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Parent Page template (ID: {47F304D6-29A8-4648-A0E2-B942513133FF}). */
export type TeamMembersParentPage_47f304d629a84648a0e2b942513133ffIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Team Members Parent Page template (ID: {75C911BD-1870-4434-AD7A-DCCA64DFB089}). */
export type TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Parent Page template (ID: {75C911BD-1870-4434-AD7A-DCCA64DFB089}). */
export type TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Parent Page template (ID: {75C911BD-1870-4434-AD7A-DCCA64DFB089}). */
export type TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Parent Page template (ID: {75C911BD-1870-4434-AD7A-DCCA64DFB089}). */
export type TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Parent Page template (ID: {75C911BD-1870-4434-AD7A-DCCA64DFB089}). */
export type TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Parent Page template (ID: {75C911BD-1870-4434-AD7A-DCCA64DFB089}). */
export type TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Parent Page template (ID: {75C911BD-1870-4434-AD7A-DCCA64DFB089}). */
export type TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Parent Page template (ID: {B4311697-C06C-4D58-B88D-CA047C0A72B0}). */
export type TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Parent Page template (ID: {B4311697-C06C-4D58-B88D-CA047C0A72B0}). */
export type TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Parent Page template (ID: {B4311697-C06C-4D58-B88D-CA047C0A72B0}). */
export type TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Parent Page template (ID: {B4311697-C06C-4D58-B88D-CA047C0A72B0}). */
export type TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Parent Page template (ID: {B4311697-C06C-4D58-B88D-CA047C0A72B0}). */
export type TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Parent Page template (ID: {B4311697-C06C-4D58-B88D-CA047C0A72B0}). */
export type TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Parent Page template (ID: {B4311697-C06C-4D58-B88D-CA047C0A72B0}). */
export type TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Corporate/Pages/Team Members Wildcard Page template (ID: {13ADEF95-60DD-4CF7-B19D-E6246DA13E95}). */
export type TeamMembersWildcardPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_6105875085f346729dfc8d133b481f26 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersWildcardPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Wildcard Page template (ID: {13ADEF95-60DD-4CF7-B19D-E6246DA13E95}). */
export type TeamMembersWildcardPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Wildcard Page template (ID: {13ADEF95-60DD-4CF7-B19D-E6246DA13E95}). */
export type TeamMembersWildcardPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Wildcard Page template (ID: {13ADEF95-60DD-4CF7-B19D-E6246DA13E95}). */
export type TeamMembersWildcardPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Wildcard Page template (ID: {13ADEF95-60DD-4CF7-B19D-E6246DA13E95}). */
export type TeamMembersWildcardPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Wildcard Page template (ID: {13ADEF95-60DD-4CF7-B19D-E6246DA13E95}). */
export type TeamMembersWildcardPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Corporate/Pages/Team Members Wildcard Page template (ID: {13ADEF95-60DD-4CF7-B19D-E6246DA13E95}). */
export type TeamMembersWildcardPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Wildcard Page template (ID: {6C0A7B26-2AC6-4E1B-A92A-B20013A5A00E}). */
export type TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_315fd21bebf04c9d9f00bae191442f1d & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Wildcard Page template (ID: {6C0A7B26-2AC6-4E1B-A92A-B20013A5A00E}). */
export type TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00eAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Wildcard Page template (ID: {6C0A7B26-2AC6-4E1B-A92A-B20013A5A00E}). */
export type TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00eChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Wildcard Page template (ID: {6C0A7B26-2AC6-4E1B-A92A-B20013A5A00E}). */
export type TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00eFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Wildcard Page template (ID: {6C0A7B26-2AC6-4E1B-A92A-B20013A5A00E}). */
export type TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00eFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Wildcard Page template (ID: {6C0A7B26-2AC6-4E1B-A92A-B20013A5A00E}). */
export type TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00eHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Financial Fairness/Pages/Team Members Wildcard Page template (ID: {6C0A7B26-2AC6-4E1B-A92A-B20013A5A00E}). */
export type TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00eIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Investments/Pages/Team Members Wildcard Page template (ID: {9C436BBF-177D-481D-A8BD-FDC12A53D450}). */
export type TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = AbrdnPage & BasePage_037da552a5524fe4aeee331f57ac1378 & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Wildcard Page template (ID: {9C436BBF-177D-481D-A8BD-FDC12A53D450}). */
export type TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Wildcard Page template (ID: {9C436BBF-177D-481D-A8BD-FDC12A53D450}). */
export type TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Wildcard Page template (ID: {9C436BBF-177D-481D-A8BD-FDC12A53D450}). */
export type TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Wildcard Page template (ID: {9C436BBF-177D-481D-A8BD-FDC12A53D450}). */
export type TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Wildcard Page template (ID: {9C436BBF-177D-481D-A8BD-FDC12A53D450}). */
export type TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Investments/Pages/Team Members Wildcard Page template (ID: {9C436BBF-177D-481D-A8BD-FDC12A53D450}). */
export type TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Personal/Pages/Team Members Wildcard Page template (ID: {52BA0118-982F-400F-B80E-1FEE787F1D3A}). */
export type TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_728c97b5c56146d9807e21018a972bb5 & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Wildcard Page template (ID: {52BA0118-982F-400F-B80E-1FEE787F1D3A}). */
export type TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3aAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Wildcard Page template (ID: {52BA0118-982F-400F-B80E-1FEE787F1D3A}). */
export type TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3aChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Wildcard Page template (ID: {52BA0118-982F-400F-B80E-1FEE787F1D3A}). */
export type TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3aFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Wildcard Page template (ID: {52BA0118-982F-400F-B80E-1FEE787F1D3A}). */
export type TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3aFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Wildcard Page template (ID: {52BA0118-982F-400F-B80E-1FEE787F1D3A}). */
export type TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3aHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Personal/Pages/Team Members Wildcard Page template (ID: {52BA0118-982F-400F-B80E-1FEE787F1D3A}). */
export type TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3aIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Adviser/Pages/Team Members Wildcard Page template (ID: {54E41187-7095-4F8A-BDFB-908C88CE2F29}). */
export type TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_B08130ebd3314a3b9c0f2b5e9b66387b & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Wildcard Page template (ID: {54E41187-7095-4F8A-BDFB-908C88CE2F29}). */
export type TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Wildcard Page template (ID: {54E41187-7095-4F8A-BDFB-908C88CE2F29}). */
export type TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Wildcard Page template (ID: {54E41187-7095-4F8A-BDFB-908C88CE2F29}). */
export type TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Wildcard Page template (ID: {54E41187-7095-4F8A-BDFB-908C88CE2F29}). */
export type TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Wildcard Page template (ID: {54E41187-7095-4F8A-BDFB-908C88CE2F29}). */
export type TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Adviser/Pages/Team Members Wildcard Page template (ID: {54E41187-7095-4F8A-BDFB-908C88CE2F29}). */
export type TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Wildcard Page template (ID: {EA27A3D8-35FD-49A3-A4C7-97D2A6D52745}). */
export type TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745 = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & BasePage_458c6cc442da4327b4d4d7d4ecd48cbd & Item & _BasePage & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _Sitemap & _Taggable & {
  __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Wildcard Page template (ID: {EA27A3D8-35FD-49A3-A4C7-97D2A6D52745}). */
export type TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Wildcard Page template (ID: {EA27A3D8-35FD-49A3-A4C7-97D2A6D52745}). */
export type TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Wildcard Page template (ID: {EA27A3D8-35FD-49A3-A4C7-97D2A6D52745}). */
export type TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Wildcard Page template (ID: {EA27A3D8-35FD-49A3-A4C7-97D2A6D52745}). */
export type TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Wildcard Page template (ID: {EA27A3D8-35FD-49A3-A4C7-97D2A6D52745}). */
export type TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen Automation/Pages/Team Members Wildcard Page template (ID: {EA27A3D8-35FD-49A3-A4C7-97D2A6D52745}). */
export type TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards template (ID: {69AA952E-BE8C-4AE0-89F3-60A4EB32E18E}). */
export type TeamProfileCards = Item & {
  __typename?: 'TeamProfileCards';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** teamMembers (ID: {225BC50E-C920-4A1D-B12C-536767667369}). */
  teamMembers?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards template (ID: {69AA952E-BE8C-4AE0-89F3-60A4EB32E18E}). */
export type TeamProfileCardsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards template (ID: {69AA952E-BE8C-4AE0-89F3-60A4EB32E18E}). */
export type TeamProfileCardsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards template (ID: {69AA952E-BE8C-4AE0-89F3-60A4EB32E18E}). */
export type TeamProfileCardsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards template (ID: {69AA952E-BE8C-4AE0-89F3-60A4EB32E18E}). */
export type TeamProfileCardsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards template (ID: {69AA952E-BE8C-4AE0-89F3-60A4EB32E18E}). */
export type TeamProfileCardsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards template (ID: {69AA952E-BE8C-4AE0-89F3-60A4EB32E18E}). */
export type TeamProfileCardsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards Folder template (ID: {A1FDFACB-4D68-4A70-AEC2-8504FF8CC36B}). */
export type TeamProfileCardsFolder = Item & {
  __typename?: 'TeamProfileCardsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards Folder template (ID: {A1FDFACB-4D68-4A70-AEC2-8504FF8CC36B}). */
export type TeamProfileCardsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards Folder template (ID: {A1FDFACB-4D68-4A70-AEC2-8504FF8CC36B}). */
export type TeamProfileCardsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards Folder template (ID: {A1FDFACB-4D68-4A70-AEC2-8504FF8CC36B}). */
export type TeamProfileCardsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards Folder template (ID: {A1FDFACB-4D68-4A70-AEC2-8504FF8CC36B}). */
export type TeamProfileCardsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards Folder template (ID: {A1FDFACB-4D68-4A70-AEC2-8504FF8CC36B}). */
export type TeamProfileCardsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Team Profile Cards/Team Profile Cards Folder template (ID: {A1FDFACB-4D68-4A70-AEC2-8504FF8CC36B}). */
export type TeamProfileCardsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Techzone Article Page template (ID: {3166089F-0014-48BF-A2D8-3DD4C1CCBD0E}). */
export type TechzoneArticlePage = Item & _BaseArticle & _ContentType & _ExternalArticle & _LimitedDisplay & _SharedPage & _TechzoneArticle & {
  __typename?: 'TechzoneArticlePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** articleUrl (ID: {03D20238-CFFC-4238-AB29-21DB4996DABF}). */
  articleUrl?: Maybe<LinkField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Techzone Article Page template (ID: {3166089F-0014-48BF-A2D8-3DD4C1CCBD0E}). */
export type TechzoneArticlePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Techzone Article Page template (ID: {3166089F-0014-48BF-A2D8-3DD4C1CCBD0E}). */
export type TechzoneArticlePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Techzone Article Page template (ID: {3166089F-0014-48BF-A2D8-3DD4C1CCBD0E}). */
export type TechzoneArticlePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Techzone Article Page template (ID: {3166089F-0014-48BF-A2D8-3DD4C1CCBD0E}). */
export type TechzoneArticlePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Techzone Article Page template (ID: {3166089F-0014-48BF-A2D8-3DD4C1CCBD0E}). */
export type TechzoneArticlePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Techzone Article Page template (ID: {3166089F-0014-48BF-A2D8-3DD4C1CCBD0E}). */
export type TechzoneArticlePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant template (ID: {215F8C54-68B3-4481-A20B-A5716F06081F}). */
export type Tenant = Item & _BaseTenant & {
  __typename?: 'Tenant';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
  /** Themes (ID: {ABFB8C52-73A8-4F60-A32A-F27DD8E1B83A}). */
  themes?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant template (ID: {215F8C54-68B3-4481-A20B-A5716F06081F}). */
export type TenantAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant template (ID: {215F8C54-68B3-4481-A20B-A5716F06081F}). */
export type TenantChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant template (ID: {215F8C54-68B3-4481-A20B-A5716F06081F}). */
export type TenantFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant template (ID: {215F8C54-68B3-4481-A20B-A5716F06081F}). */
export type TenantFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant template (ID: {215F8C54-68B3-4481-A20B-A5716F06081F}). */
export type TenantHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant template (ID: {215F8C54-68B3-4481-A20B-A5716F06081F}). */
export type TenantIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant Folder template (ID: {4F539F2E-9CF9-4453-8E82-3D13DED12AB3}). */
export type TenantFolder = Item & {
  __typename?: 'TenantFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant Folder template (ID: {4F539F2E-9CF9-4453-8E82-3D13DED12AB3}). */
export type TenantFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant Folder template (ID: {4F539F2E-9CF9-4453-8E82-3D13DED12AB3}). */
export type TenantFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant Folder template (ID: {4F539F2E-9CF9-4453-8E82-3D13DED12AB3}). */
export type TenantFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant Folder template (ID: {4F539F2E-9CF9-4453-8E82-3D13DED12AB3}). */
export type TenantFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant Folder template (ID: {4F539F2E-9CF9-4453-8E82-3D13DED12AB3}). */
export type TenantFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Tenant Folder template (ID: {4F539F2E-9CF9-4453-8E82-3D13DED12AB3}). */
export type TenantFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Tenant Security Item Pointer template (ID: {F8F9A85E-95D5-4E81-AEC4-249B697A8626}). */
export type TenantSecurityItemPointer = Item & _SecurityItemPointer & {
  __typename?: 'TenantSecurityItemPointer';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {BBC2E73A-DE40-493B-9320-86D66D024AAF}). */
  script?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Tenant Security Item Pointer template (ID: {F8F9A85E-95D5-4E81-AEC4-249B697A8626}). */
export type TenantSecurityItemPointerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Tenant Security Item Pointer template (ID: {F8F9A85E-95D5-4E81-AEC4-249B697A8626}). */
export type TenantSecurityItemPointerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Tenant Security Item Pointer template (ID: {F8F9A85E-95D5-4E81-AEC4-249B697A8626}). */
export type TenantSecurityItemPointerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Tenant Security Item Pointer template (ID: {F8F9A85E-95D5-4E81-AEC4-249B697A8626}). */
export type TenantSecurityItemPointerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Tenant Security Item Pointer template (ID: {F8F9A85E-95D5-4E81-AEC4-249B697A8626}). */
export type TenantSecurityItemPointerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Security/Tenant Security Item Pointer template (ID: {F8F9A85E-95D5-4E81-AEC4-249B697A8626}). */
export type TenantSecurityItemPointerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/TenantSetupRoot template (ID: {141DF88E-7156-4D2E-A004-C8C1A7C51E9D}). */
export type TenantSetupRoot = Item & _Enabled & _IncludeByDefault & _IsSystemModule & _Name_B88cf88159a54a19991e71038751cb60 & {
  __typename?: 'TenantSetupRoot';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled (ID: {4B475746-CF34-4C06-97C8-7A8B0B40064F}). */
  enabled?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** IncludeByDefault (ID: {11488836-D40F-40D4-BEB4-1D31DA7B1470}). */
  includeByDefault?: Maybe<CheckboxField>;
  /** IsSystemModule (ID: {06D2C562-9229-4779-8807-E2A5FD2990D4}). */
  isSystemModule?: Maybe<CheckboxField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Name (ID: {C202067E-7FAB-4606-AFB4-E76DF2185DDC}). */
  name_c202067e7fab4606afb4e76df2185ddc?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/TenantSetupRoot template (ID: {141DF88E-7156-4D2E-A004-C8C1A7C51E9D}). */
export type TenantSetupRootAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/TenantSetupRoot template (ID: {141DF88E-7156-4D2E-A004-C8C1A7C51E9D}). */
export type TenantSetupRootChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/TenantSetupRoot template (ID: {141DF88E-7156-4D2E-A004-C8C1A7C51E9D}). */
export type TenantSetupRootFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/TenantSetupRoot template (ID: {141DF88E-7156-4D2E-A004-C8C1A7C51E9D}). */
export type TenantSetupRootFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/TenantSetupRoot template (ID: {141DF88E-7156-4D2E-A004-C8C1A7C51E9D}). */
export type TenantSetupRootHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/TenantSetupRoot template (ID: {141DF88E-7156-4D2E-A004-C8C1A7C51E9D}). */
export type TenantSetupRootIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Tertiery Hero Banner template (ID: {4F568731-B5EB-4229-8E64-F2DC00E73EB9}). */
export type TertieryHeroBanner = Item & {
  __typename?: 'TertieryHeroBanner';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {93DFAF1D-0368-40D8-B102-1448BBF2CD92}). */
  cta?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** icon (ID: {31E2A047-F75F-4AF4-9ADA-887B29163331}). */
  icon_31e2a047f75f4af49ada887b29163331?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** subtitle (ID: {A6ECB974-2528-4A01-8711-CC71122F7D81}). */
  subtitle?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {18A559E7-FB4E-4B91-A0BA-C9653BFFDAD8}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Tertiery Hero Banner template (ID: {4F568731-B5EB-4229-8E64-F2DC00E73EB9}). */
export type TertieryHeroBannerAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Tertiery Hero Banner template (ID: {4F568731-B5EB-4229-8E64-F2DC00E73EB9}). */
export type TertieryHeroBannerChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Tertiery Hero Banner template (ID: {4F568731-B5EB-4229-8E64-F2DC00E73EB9}). */
export type TertieryHeroBannerFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Tertiery Hero Banner template (ID: {4F568731-B5EB-4229-8E64-F2DC00E73EB9}). */
export type TertieryHeroBannerFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Tertiery Hero Banner template (ID: {4F568731-B5EB-4229-8E64-F2DC00E73EB9}). */
export type TertieryHeroBannerHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Banner/Tertiery Hero Banner template (ID: {4F568731-B5EB-4229-8E64-F2DC00E73EB9}). */
export type TertieryHeroBannerIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tertiery Hero Banner Parameters Template template (ID: {2E123F75-08F1-4F7E-8396-BC4064E32598}). */
export type TertieryHeroBannerParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'TertieryHeroBannerParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {A7575C1F-FE25-49D5-854B-6761CC8E8719}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tertiery Hero Banner Parameters Template template (ID: {2E123F75-08F1-4F7E-8396-BC4064E32598}). */
export type TertieryHeroBannerParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tertiery Hero Banner Parameters Template template (ID: {2E123F75-08F1-4F7E-8396-BC4064E32598}). */
export type TertieryHeroBannerParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tertiery Hero Banner Parameters Template template (ID: {2E123F75-08F1-4F7E-8396-BC4064E32598}). */
export type TertieryHeroBannerParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tertiery Hero Banner Parameters Template template (ID: {2E123F75-08F1-4F7E-8396-BC4064E32598}). */
export type TertieryHeroBannerParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tertiery Hero Banner Parameters Template template (ID: {2E123F75-08F1-4F7E-8396-BC4064E32598}). */
export type TertieryHeroBannerParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tertiery Hero Banner Parameters Template template (ID: {2E123F75-08F1-4F7E-8396-BC4064E32598}). */
export type TertieryHeroBannerParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text template (ID: {0A7AA373-5ED1-4E9B-9678-22D3C5FAF6DF}). */
export type Text = Item & {
  __typename?: 'Text';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Text (ID: {729034FC-24F3-40B7-8FA4-FB49D7DE20DD}). */
  text?: Maybe<RichTextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text template (ID: {0A7AA373-5ED1-4E9B-9678-22D3C5FAF6DF}). */
export type TextAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text template (ID: {0A7AA373-5ED1-4E9B-9678-22D3C5FAF6DF}). */
export type TextChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text template (ID: {0A7AA373-5ED1-4E9B-9678-22D3C5FAF6DF}). */
export type TextFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text template (ID: {0A7AA373-5ED1-4E9B-9678-22D3C5FAF6DF}). */
export type TextFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text template (ID: {0A7AA373-5ED1-4E9B-9678-22D3C5FAF6DF}). */
export type TextHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text template (ID: {0A7AA373-5ED1-4E9B-9678-22D3C5FAF6DF}). */
export type TextIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Block template (ID: {035C0153-0D1B-4434-90C2-0A5D85C262E6}). */
export type TextBlock = Item & {
  __typename?: 'TextBlock';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {8A3A7DB0-5F40-477F-8082-81692F6F3164}). */
  cta?: Maybe<TextField>;
  /** description (ID: {8583CFFC-AEE3-470B-8EC9-604AAA12CB9A}). */
  description?: Maybe<RichTextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** icon (ID: {E64E65B6-2AF4-407A-A06A-7EDCAF7525BC}). */
  icon_e64e65b62af4407aa06a7edcaf7525bc?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {163E7380-7662-4BE5-BA9B-B5E616A2A4A9}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Block template (ID: {035C0153-0D1B-4434-90C2-0A5D85C262E6}). */
export type TextBlockAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Block template (ID: {035C0153-0D1B-4434-90C2-0A5D85C262E6}). */
export type TextBlockChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Block template (ID: {035C0153-0D1B-4434-90C2-0A5D85C262E6}). */
export type TextBlockFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Block template (ID: {035C0153-0D1B-4434-90C2-0A5D85C262E6}). */
export type TextBlockFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Block template (ID: {035C0153-0D1B-4434-90C2-0A5D85C262E6}). */
export type TextBlockHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Block template (ID: {035C0153-0D1B-4434-90C2-0A5D85C262E6}). */
export type TextBlockIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Block Heading Parameters Template template (ID: {502D3EA6-905A-40B3-95A1-279E7AE5D2F9}). */
export type TextBlockHeadingParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'TextBlockHeadingParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** type (ID: {316096E3-DAF1-4E83-8B6F-EA6E9E67F5ED}). */
  type?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Block Heading Parameters Template template (ID: {502D3EA6-905A-40B3-95A1-279E7AE5D2F9}). */
export type TextBlockHeadingParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Block Heading Parameters Template template (ID: {502D3EA6-905A-40B3-95A1-279E7AE5D2F9}). */
export type TextBlockHeadingParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Block Heading Parameters Template template (ID: {502D3EA6-905A-40B3-95A1-279E7AE5D2F9}). */
export type TextBlockHeadingParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Block Heading Parameters Template template (ID: {502D3EA6-905A-40B3-95A1-279E7AE5D2F9}). */
export type TextBlockHeadingParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Block Heading Parameters Template template (ID: {502D3EA6-905A-40B3-95A1-279E7AE5D2F9}). */
export type TextBlockHeadingParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Block Heading Parameters Template template (ID: {502D3EA6-905A-40B3-95A1-279E7AE5D2F9}). */
export type TextBlockHeadingParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type template (ID: {A08E05B6-0AF1-498E-963A-5825483795E5}). */
export type TextBlockHeadingType = Item & {
  __typename?: 'TextBlockHeadingType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type template (ID: {A08E05B6-0AF1-498E-963A-5825483795E5}). */
export type TextBlockHeadingTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type template (ID: {A08E05B6-0AF1-498E-963A-5825483795E5}). */
export type TextBlockHeadingTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type template (ID: {A08E05B6-0AF1-498E-963A-5825483795E5}). */
export type TextBlockHeadingTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type template (ID: {A08E05B6-0AF1-498E-963A-5825483795E5}). */
export type TextBlockHeadingTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type template (ID: {A08E05B6-0AF1-498E-963A-5825483795E5}). */
export type TextBlockHeadingTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type template (ID: {A08E05B6-0AF1-498E-963A-5825483795E5}). */
export type TextBlockHeadingTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type Folder template (ID: {1B019CED-4303-4792-AB3D-4D3517D1115B}). */
export type TextBlockHeadingTypeFolder = Item & {
  __typename?: 'TextBlockHeadingTypeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type Folder template (ID: {1B019CED-4303-4792-AB3D-4D3517D1115B}). */
export type TextBlockHeadingTypeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type Folder template (ID: {1B019CED-4303-4792-AB3D-4D3517D1115B}). */
export type TextBlockHeadingTypeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type Folder template (ID: {1B019CED-4303-4792-AB3D-4D3517D1115B}). */
export type TextBlockHeadingTypeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type Folder template (ID: {1B019CED-4303-4792-AB3D-4D3517D1115B}). */
export type TextBlockHeadingTypeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type Folder template (ID: {1B019CED-4303-4792-AB3D-4D3517D1115B}). */
export type TextBlockHeadingTypeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Heading Type Folder template (ID: {1B019CED-4303-4792-AB3D-4D3517D1115B}). */
export type TextBlockHeadingTypeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type template (ID: {B2D8EF6A-F706-41F8-935F-092B36698F22}). */
export type TextBlockLinkType = Item & {
  __typename?: 'TextBlockLinkType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type template (ID: {B2D8EF6A-F706-41F8-935F-092B36698F22}). */
export type TextBlockLinkTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type template (ID: {B2D8EF6A-F706-41F8-935F-092B36698F22}). */
export type TextBlockLinkTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type template (ID: {B2D8EF6A-F706-41F8-935F-092B36698F22}). */
export type TextBlockLinkTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type template (ID: {B2D8EF6A-F706-41F8-935F-092B36698F22}). */
export type TextBlockLinkTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type template (ID: {B2D8EF6A-F706-41F8-935F-092B36698F22}). */
export type TextBlockLinkTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type template (ID: {B2D8EF6A-F706-41F8-935F-092B36698F22}). */
export type TextBlockLinkTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type Folder template (ID: {D3F27E8B-F390-457B-A01C-72BC4006D345}). */
export type TextBlockLinkTypeFolder = Item & {
  __typename?: 'TextBlockLinkTypeFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type Folder template (ID: {D3F27E8B-F390-457B-A01C-72BC4006D345}). */
export type TextBlockLinkTypeFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type Folder template (ID: {D3F27E8B-F390-457B-A01C-72BC4006D345}). */
export type TextBlockLinkTypeFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type Folder template (ID: {D3F27E8B-F390-457B-A01C-72BC4006D345}). */
export type TextBlockLinkTypeFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type Folder template (ID: {D3F27E8B-F390-457B-A01C-72BC4006D345}). */
export type TextBlockLinkTypeFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type Folder template (ID: {D3F27E8B-F390-457B-A01C-72BC4006D345}). */
export type TextBlockLinkTypeFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Text Block/Text Block Link Type Folder template (ID: {D3F27E8B-F390-457B-A01C-72BC4006D345}). */
export type TextBlockLinkTypeFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks template (ID: {993C3877-0F05-47E8-BAFA-9644D37EE127}). */
export type TextBlocks = Item & {
  __typename?: 'TextBlocks';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {9A16B0BE-6719-4A2C-A838-367CB99691ED}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks template (ID: {993C3877-0F05-47E8-BAFA-9644D37EE127}). */
export type TextBlocksAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks template (ID: {993C3877-0F05-47E8-BAFA-9644D37EE127}). */
export type TextBlocksChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks template (ID: {993C3877-0F05-47E8-BAFA-9644D37EE127}). */
export type TextBlocksFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks template (ID: {993C3877-0F05-47E8-BAFA-9644D37EE127}). */
export type TextBlocksFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks template (ID: {993C3877-0F05-47E8-BAFA-9644D37EE127}). */
export type TextBlocksHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks template (ID: {993C3877-0F05-47E8-BAFA-9644D37EE127}). */
export type TextBlocksIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks Folder template (ID: {BB33B0DD-4034-43AD-87A4-B11E5F70E8EE}). */
export type TextBlocksFolder = Item & {
  __typename?: 'TextBlocksFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks Folder template (ID: {BB33B0DD-4034-43AD-87A4-B11E5F70E8EE}). */
export type TextBlocksFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks Folder template (ID: {BB33B0DD-4034-43AD-87A4-B11E5F70E8EE}). */
export type TextBlocksFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks Folder template (ID: {BB33B0DD-4034-43AD-87A4-B11E5F70E8EE}). */
export type TextBlocksFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks Folder template (ID: {BB33B0DD-4034-43AD-87A4-B11E5F70E8EE}). */
export type TextBlocksFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks Folder template (ID: {BB33B0DD-4034-43AD-87A4-B11E5F70E8EE}). */
export type TextBlocksFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Text Block/Text Blocks Folder template (ID: {BB33B0DD-4034-43AD-87A4-B11E5F70E8EE}). */
export type TextBlocksFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Blocks Parameters Template template (ID: {8BE0E077-8941-4595-A54B-0B48F6361AE2}). */
export type TextBlocksParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'TextBlocksParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {A7C7DC9F-523A-4903-9B6F-6A36B751BAF3}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** headingType (ID: {0480C252-FBCB-47C1-ACD3-8347568B682E}). */
  headingType?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** linkType (ID: {9EA1FC50-A289-471B-B989-E9CE40B221EC}). */
  linkType?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Blocks Parameters Template template (ID: {8BE0E077-8941-4595-A54B-0B48F6361AE2}). */
export type TextBlocksParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Blocks Parameters Template template (ID: {8BE0E077-8941-4595-A54B-0B48F6361AE2}). */
export type TextBlocksParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Blocks Parameters Template template (ID: {8BE0E077-8941-4595-A54B-0B48F6361AE2}). */
export type TextBlocksParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Blocks Parameters Template template (ID: {8BE0E077-8941-4595-A54B-0B48F6361AE2}). */
export type TextBlocksParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Blocks Parameters Template template (ID: {8BE0E077-8941-4595-A54B-0B48F6361AE2}). */
export type TextBlocksParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Text Blocks Parameters Template template (ID: {8BE0E077-8941-4595-A54B-0B48F6361AE2}). */
export type TextBlocksParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type TextField = ItemField & {
  __typename?: 'TextField';
  /** Properties describing the field. */
  definition?: Maybe<ItemTemplateField>;
  /** The ID of the field. */
  id: Scalars['ID']['output'];
  /** Raw value serialized into JSON format. For example, for an image field, it contains image specific properties such as 'src' and 'alt'. */
  jsonValue: Scalars['JSON']['output'];
  /** The name of the field. */
  name: Scalars['String']['output'];
  /** Raw value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};


export type TextFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text Folder template (ID: {A6298267-7240-472E-94D0-09FAD3D32C7B}). */
export type TextFolder = Item & {
  __typename?: 'TextFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text Folder template (ID: {A6298267-7240-472E-94D0-09FAD3D32C7B}). */
export type TextFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text Folder template (ID: {A6298267-7240-472E-94D0-09FAD3D32C7B}). */
export type TextFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text Folder template (ID: {A6298267-7240-472E-94D0-09FAD3D32C7B}). */
export type TextFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text Folder template (ID: {A6298267-7240-472E-94D0-09FAD3D32C7B}). */
export type TextFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text Folder template (ID: {A6298267-7240-472E-94D0-09FAD3D32C7B}). */
export type TextFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text Folder template (ID: {A6298267-7240-472E-94D0-09FAD3D32C7B}). */
export type TextFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text Folder template (ID: {B762D567-87F5-493C-BB48-0C455D834457}). */
export type TextFolder_B762d56787f5493cbb480c455d834457 = Item & {
  __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text Folder template (ID: {B762D567-87F5-493C-BB48-0C455D834457}). */
export type TextFolder_B762d56787f5493cbb480c455d834457AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text Folder template (ID: {B762D567-87F5-493C-BB48-0C455D834457}). */
export type TextFolder_B762d56787f5493cbb480c455d834457ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text Folder template (ID: {B762D567-87F5-493C-BB48-0C455D834457}). */
export type TextFolder_B762d56787f5493cbb480c455d834457FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text Folder template (ID: {B762D567-87F5-493C-BB48-0C455D834457}). */
export type TextFolder_B762d56787f5493cbb480c455d834457FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text Folder template (ID: {B762D567-87F5-493C-BB48-0C455D834457}). */
export type TextFolder_B762d56787f5493cbb480c455d834457HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Text Folder template (ID: {B762D567-87F5-493C-BB48-0C455D834457}). */
export type TextFolder_B762d56787f5493cbb480c455d834457IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text template (ID: {B8F5894C-B493-4016-BF78-4090B0A2FD16}). */
export type Text_B8f5894cb4934016bf784090b0a2fd16 = Item & {
  __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Text (ID: {B3635965-6786-457C-9DEE-28DE73C0A331}). */
  text?: Maybe<RichTextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text template (ID: {B8F5894C-B493-4016-BF78-4090B0A2FD16}). */
export type Text_B8f5894cb4934016bf784090b0a2fd16AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text template (ID: {B8F5894C-B493-4016-BF78-4090B0A2FD16}). */
export type Text_B8f5894cb4934016bf784090b0a2fd16ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text template (ID: {B8F5894C-B493-4016-BF78-4090B0A2FD16}). */
export type Text_B8f5894cb4934016bf784090b0a2fd16FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text template (ID: {B8F5894C-B493-4016-BF78-4090B0A2FD16}). */
export type Text_B8f5894cb4934016bf784090b0a2fd16FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text template (ID: {B8F5894C-B493-4016-BF78-4090B0A2FD16}). */
export type Text_B8f5894cb4934016bf784090b0a2fd16HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Text template (ID: {B8F5894C-B493-4016-BF78-4090B0A2FD16}). */
export type Text_B8f5894cb4934016bf784090b0a2fd16IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theme template (ID: {F7653F31-6F17-4DAA-9217-8E116BABC927}). */
export type Theme = Item & _AssetServiceThemeMode & _InternetExplorerCompatibilityMode & _ProtectedTheme & {
  __typename?: 'Theme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Background Color (ID: {2325724A-C12D-44AA-B880-D889FCFB03BF}). */
  backgroundColor?: Maybe<TextField>;
  /** BaseLayout (ID: {384C2D3C-3E34-4493-9CB2-ADE68CAF0DA2}). */
  baseLayout?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CompatibilityModeEdit (ID: {74F8C14D-559B-40D0-BF52-4C53FA62E7AA}). */
  compatibilityModeEdit?: Maybe<LookupField>;
  /** CompatibilityModePreviewPublic (ID: {A4BAAEBC-8AB7-4038-B6C9-BB7B7D170452}). */
  compatibilityModePreviewPublic?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Mock Image (ID: {17BF6A75-8215-449F-86DA-DEFD0CDAB50C}). */
  mockImage?: Maybe<ImageField>;
  /** Mode (ID: {4D0E825C-D503-42FF-A96F-1949F6259FD0}). */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Body classes (ID: {4648C540-D945-41BF-A6D0-59A2C2653647}). */
  otherClasses?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder settings (ID: {4A41457A-841A-4772-B26F-D4B10CD96DB4}). */
  placeholderSettings?: Maybe<TextField>;
  /** Protected Theme (ID: {0B9CCE83-5355-4D1A-BBFE-E9BA3C3FE744}). */
  protectedTheme?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Stretch Image (ID: {D97B6EA4-57A4-4EF9-971C-419F66409614}). */
  stretchImage?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Viewport (ID: {3DD034F9-D8D7-49C8-8FE7-FF09E18A2BE3}). */
  viewport?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theme template (ID: {F7653F31-6F17-4DAA-9217-8E116BABC927}). */
export type ThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theme template (ID: {F7653F31-6F17-4DAA-9217-8E116BABC927}). */
export type ThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theme template (ID: {F7653F31-6F17-4DAA-9217-8E116BABC927}). */
export type ThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theme template (ID: {F7653F31-6F17-4DAA-9217-8E116BABC927}). */
export type ThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theme template (ID: {F7653F31-6F17-4DAA-9217-8E116BABC927}). */
export type ThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theme template (ID: {F7653F31-6F17-4DAA-9217-8E116BABC927}). */
export type ThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tag template (ID: {83407BBF-9FE9-41F7-B57F-022BF2A76BDE}). */
export type ThemeTag = Item & {
  __typename?: 'ThemeTag';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** name (ID: {A58A32C8-988A-4C68-AD3B-1B7CAC1DCDFC}). */
  name_a58a32c8988a4c68ad3b1b7cac1dcdfc?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {B726C515-E677-43E5-8B2E-F44DA61E97F4}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tag template (ID: {83407BBF-9FE9-41F7-B57F-022BF2A76BDE}). */
export type ThemeTagAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tag template (ID: {83407BBF-9FE9-41F7-B57F-022BF2A76BDE}). */
export type ThemeTagChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tag template (ID: {83407BBF-9FE9-41F7-B57F-022BF2A76BDE}). */
export type ThemeTagFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tag template (ID: {83407BBF-9FE9-41F7-B57F-022BF2A76BDE}). */
export type ThemeTagFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tag template (ID: {83407BBF-9FE9-41F7-B57F-022BF2A76BDE}). */
export type ThemeTagHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tag template (ID: {83407BBF-9FE9-41F7-B57F-022BF2A76BDE}). */
export type ThemeTagIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tags Folder template (ID: {1AE24CC3-1798-4B1F-A4F7-61DD00971670}). */
export type ThemeTagsFolder = Item & {
  __typename?: 'ThemeTagsFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tags Folder template (ID: {1AE24CC3-1798-4B1F-A4F7-61DD00971670}). */
export type ThemeTagsFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tags Folder template (ID: {1AE24CC3-1798-4B1F-A4F7-61DD00971670}). */
export type ThemeTagsFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tags Folder template (ID: {1AE24CC3-1798-4B1F-A4F7-61DD00971670}). */
export type ThemeTagsFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tags Folder template (ID: {1AE24CC3-1798-4B1F-A4F7-61DD00971670}). */
export type ThemeTagsFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tags Folder template (ID: {1AE24CC3-1798-4B1F-A4F7-61DD00971670}). */
export type ThemeTagsFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Theme Tag/Theme Tags Folder template (ID: {1AE24CC3-1798-4B1F-A4F7-61DD00971670}). */
export type ThemeTagsFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Mode template (ID: {8440EBBF-31D9-49C2-9982-43DB477EF8E6}). */
export type ThemingMode = Item & {
  __typename?: 'ThemingMode';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Body class (ID: {CCE3E495-D917-4500-9405-2C2A77DDAE30}). */
  bodyClass?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Current site theme (ID: {5C510B91-B003-4B2A-AB83-54BA03DCC394}). */
  currentSiteTheme?: Maybe<CheckboxField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Theme (ID: {CFA8DBBE-4E47-412C-BFC5-B085917D4864}). */
  theme?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Mode template (ID: {8440EBBF-31D9-49C2-9982-43DB477EF8E6}). */
export type ThemingModeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Mode template (ID: {8440EBBF-31D9-49C2-9982-43DB477EF8E6}). */
export type ThemingModeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Mode template (ID: {8440EBBF-31D9-49C2-9982-43DB477EF8E6}). */
export type ThemingModeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Mode template (ID: {8440EBBF-31D9-49C2-9982-43DB477EF8E6}). */
export type ThemingModeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Mode template (ID: {8440EBBF-31D9-49C2-9982-43DB477EF8E6}). */
export type ThemingModeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Mode template (ID: {8440EBBF-31D9-49C2-9982-43DB477EF8E6}). */
export type ThemingModeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Modes template (ID: {68BEAB02-D5C4-4AB8-99C3-4BA87B4D5E03}). */
export type ThemingModes = Item & {
  __typename?: 'ThemingModes';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Modes template (ID: {68BEAB02-D5C4-4AB8-99C3-4BA87B4D5E03}). */
export type ThemingModesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Modes template (ID: {68BEAB02-D5C4-4AB8-99C3-4BA87B4D5E03}). */
export type ThemingModesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Modes template (ID: {68BEAB02-D5C4-4AB8-99C3-4BA87B4D5E03}). */
export type ThemingModesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Modes template (ID: {68BEAB02-D5C4-4AB8-99C3-4BA87B4D5E03}). */
export type ThemingModesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Modes template (ID: {68BEAB02-D5C4-4AB8-99C3-4BA87B4D5E03}). */
export type ThemingModesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Theming Modes template (ID: {68BEAB02-D5C4-4AB8-99C3-4BA87B4D5E03}). */
export type ThemingModesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile template (ID: {6574AEDC-C826-47EB-832E-6ECCACEAFB85}). */
export type Tile = Item & {
  __typename?: 'Tile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {94EF960E-129A-4E20-91AF-AEE0467B76EA}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** image (ID: {656B011F-83FF-4399-9FCC-FFBE25734A22}). */
  image?: Maybe<ImageField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {DF8E5EEE-CC83-4952-9A2E-F72AA3B1C73F}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile template (ID: {6574AEDC-C826-47EB-832E-6ECCACEAFB85}). */
export type TileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile template (ID: {6574AEDC-C826-47EB-832E-6ECCACEAFB85}). */
export type TileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile template (ID: {6574AEDC-C826-47EB-832E-6ECCACEAFB85}). */
export type TileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile template (ID: {6574AEDC-C826-47EB-832E-6ECCACEAFB85}). */
export type TileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile template (ID: {6574AEDC-C826-47EB-832E-6ECCACEAFB85}). */
export type TileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile template (ID: {6574AEDC-C826-47EB-832E-6ECCACEAFB85}). */
export type TileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile Link template (ID: {1AD1E84F-5FA2-448F-94F7-585F9065C373}). */
export type TileLink = Item & {
  __typename?: 'TileLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** cta (ID: {61FB0AE1-D3E0-492F-8FFE-D904E719DCDA}). */
  cta?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile Link template (ID: {1AD1E84F-5FA2-448F-94F7-585F9065C373}). */
export type TileLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile Link template (ID: {1AD1E84F-5FA2-448F-94F7-585F9065C373}). */
export type TileLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile Link template (ID: {1AD1E84F-5FA2-448F-94F7-585F9065C373}). */
export type TileLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile Link template (ID: {1AD1E84F-5FA2-448F-94F7-585F9065C373}). */
export type TileLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile Link template (ID: {1AD1E84F-5FA2-448F-94F7-585F9065C373}). */
export type TileLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tile Link template (ID: {1AD1E84F-5FA2-448F-94F7-585F9065C373}). */
export type TileLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tile Parameters Template template (ID: {182174F7-D2C1-4E5C-9375-B04FA785F47F}). */
export type TileParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'TileParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {57A333DC-99E6-4236-9E26-66C9C96741EC}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** size (ID: {63850AFB-2FA2-4A95-BC8E-AF377F24C0EC}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tile Parameters Template template (ID: {182174F7-D2C1-4E5C-9375-B04FA785F47F}). */
export type TileParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tile Parameters Template template (ID: {182174F7-D2C1-4E5C-9375-B04FA785F47F}). */
export type TileParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tile Parameters Template template (ID: {182174F7-D2C1-4E5C-9375-B04FA785F47F}). */
export type TileParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tile Parameters Template template (ID: {182174F7-D2C1-4E5C-9375-B04FA785F47F}). */
export type TileParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tile Parameters Template template (ID: {182174F7-D2C1-4E5C-9375-B04FA785F47F}). */
export type TileParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tile Parameters Template template (ID: {182174F7-D2C1-4E5C-9375-B04FA785F47F}). */
export type TileParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option template (ID: {8FD42930-7A36-4197-84FC-1D420C07F93F}). */
export type TileSizeOption = Item & {
  __typename?: 'TileSizeOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option template (ID: {8FD42930-7A36-4197-84FC-1D420C07F93F}). */
export type TileSizeOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option template (ID: {8FD42930-7A36-4197-84FC-1D420C07F93F}). */
export type TileSizeOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option template (ID: {8FD42930-7A36-4197-84FC-1D420C07F93F}). */
export type TileSizeOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option template (ID: {8FD42930-7A36-4197-84FC-1D420C07F93F}). */
export type TileSizeOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option template (ID: {8FD42930-7A36-4197-84FC-1D420C07F93F}). */
export type TileSizeOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option template (ID: {8FD42930-7A36-4197-84FC-1D420C07F93F}). */
export type TileSizeOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option Folder template (ID: {4CB85F16-28B2-49FC-8DCB-59190DCC4A20}). */
export type TileSizeOptionFolder = Item & {
  __typename?: 'TileSizeOptionFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option Folder template (ID: {4CB85F16-28B2-49FC-8DCB-59190DCC4A20}). */
export type TileSizeOptionFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option Folder template (ID: {4CB85F16-28B2-49FC-8DCB-59190DCC4A20}). */
export type TileSizeOptionFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option Folder template (ID: {4CB85F16-28B2-49FC-8DCB-59190DCC4A20}). */
export type TileSizeOptionFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option Folder template (ID: {4CB85F16-28B2-49FC-8DCB-59190DCC4A20}). */
export type TileSizeOptionFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option Folder template (ID: {4CB85F16-28B2-49FC-8DCB-59190DCC4A20}). */
export type TileSizeOptionFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Tile/Tile Size Option Folder template (ID: {4CB85F16-28B2-49FC-8DCB-59190DCC4A20}). */
export type TileSizeOptionFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tiles Folder template (ID: {C765CAF6-7FC2-4DBA-A10A-2B360DA71753}). */
export type TilesFolder = Item & {
  __typename?: 'TilesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tiles Folder template (ID: {C765CAF6-7FC2-4DBA-A10A-2B360DA71753}). */
export type TilesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tiles Folder template (ID: {C765CAF6-7FC2-4DBA-A10A-2B360DA71753}). */
export type TilesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tiles Folder template (ID: {C765CAF6-7FC2-4DBA-A10A-2B360DA71753}). */
export type TilesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tiles Folder template (ID: {C765CAF6-7FC2-4DBA-A10A-2B360DA71753}). */
export type TilesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tiles Folder template (ID: {C765CAF6-7FC2-4DBA-A10A-2B360DA71753}). */
export type TilesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Tile/Tiles Folder template (ID: {C765CAF6-7FC2-4DBA-A10A-2B360DA71753}). */
export type TilesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tiles Parameters Template template (ID: {C5CC409E-B047-4632-906F-8C865FC3C999}). */
export type TilesParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'TilesParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** background (ID: {46550C52-9B6D-4435-AB23-BCEE5A7B6525}). */
  background?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** size (ID: {90384210-DA83-4C59-B5DD-594FEDEEB251}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tiles Parameters Template template (ID: {C5CC409E-B047-4632-906F-8C865FC3C999}). */
export type TilesParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tiles Parameters Template template (ID: {C5CC409E-B047-4632-906F-8C865FC3C999}). */
export type TilesParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tiles Parameters Template template (ID: {C5CC409E-B047-4632-906F-8C865FC3C999}). */
export type TilesParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tiles Parameters Template template (ID: {C5CC409E-B047-4632-906F-8C865FC3C999}). */
export type TilesParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tiles Parameters Template template (ID: {C5CC409E-B047-4632-906F-8C865FC3C999}). */
export type TilesParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Tiles Parameters Template template (ID: {C5CC409E-B047-4632-906F-8C865FC3C999}). */
export type TilesParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {D5846F4F-F6D9-4ADD-8E8D-01A53F2B5DDF}). */
export type Title = GridParameters & ICacheable & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Title';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {D5846F4F-F6D9-4ADD-8E8D-01A53F2B5DDF}). */
export type TitleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {D5846F4F-F6D9-4ADD-8E8D-01A53F2B5DDF}). */
export type TitleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {D5846F4F-F6D9-4ADD-8E8D-01A53F2B5DDF}). */
export type TitleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {D5846F4F-F6D9-4ADD-8E8D-01A53F2B5DDF}). */
export type TitleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {D5846F4F-F6D9-4ADD-8E8D-01A53F2B5DDF}). */
export type TitleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {D5846F4F-F6D9-4ADD-8E8D-01A53F2B5DDF}). */
export type TitleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {A82E8931-0575-4175-917D-E904EF7E6DBE}). */
export type Title_A82e893105754175917de904ef7e6dbe = BaseRenderingParameters & GridParameters & IComponentVariant & IDynamicPlaceholder & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Title_a82e893105754175917de904ef7e6dbe';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Variant (ID: {75BBDF72-635F-4D72-A3D3-A9BABA09D161}). */
  fieldNames?: Maybe<LookupField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {A82E8931-0575-4175-917D-E904EF7E6DBE}). */
export type Title_A82e893105754175917de904ef7e6dbeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {A82E8931-0575-4175-917D-E904EF7E6DBE}). */
export type Title_A82e893105754175917de904ef7e6dbeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {A82E8931-0575-4175-917D-E904EF7E6DBE}). */
export type Title_A82e893105754175917de904ef7e6dbeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {A82E8931-0575-4175-917D-E904EF7E6DBE}). */
export type Title_A82e893105754175917de904ef7e6dbeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {A82E8931-0575-4175-917D-E904EF7E6DBE}). */
export type Title_A82e893105754175917de904ef7e6dbeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/JSS Experience Accelerator/Page Content/Rendering Parameters/Title template (ID: {A82E8931-0575-4175-917D-E904EF7E6DBE}). */
export type Title_A82e893105754175917de904ef7e6dbeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Toggle template (ID: {A2CB73C7-0054-4461-AAB8-0969FDD2E094}). */
export type Toggle = Item & {
  __typename?: 'Toggle';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Text (ID: {2D36CF85-84BE-42D2-B710-8D13B8844CDD}). */
  text?: Maybe<RichTextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Toggle template (ID: {A2CB73C7-0054-4461-AAB8-0969FDD2E094}). */
export type ToggleAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Toggle template (ID: {A2CB73C7-0054-4461-AAB8-0969FDD2E094}). */
export type ToggleChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Toggle template (ID: {A2CB73C7-0054-4461-AAB8-0969FDD2E094}). */
export type ToggleFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Toggle template (ID: {A2CB73C7-0054-4461-AAB8-0969FDD2E094}). */
export type ToggleFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Toggle template (ID: {A2CB73C7-0054-4461-AAB8-0969FDD2E094}). */
export type ToggleHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Toggle template (ID: {A2CB73C7-0054-4461-AAB8-0969FDD2E094}). */
export type ToggleIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/Toggle Folder template (ID: {8178B44E-B2BB-4635-85BA-B807CE420858}). */
export type ToggleFolder = Item & {
  __typename?: 'ToggleFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/Toggle Folder template (ID: {8178B44E-B2BB-4635-85BA-B807CE420858}). */
export type ToggleFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/Toggle Folder template (ID: {8178B44E-B2BB-4635-85BA-B807CE420858}). */
export type ToggleFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/Toggle Folder template (ID: {8178B44E-B2BB-4635-85BA-B807CE420858}). */
export type ToggleFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/Toggle Folder template (ID: {8178B44E-B2BB-4635-85BA-B807CE420858}). */
export type ToggleFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/Toggle Folder template (ID: {8178B44E-B2BB-4635-85BA-B807CE420858}). */
export type ToggleFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Datasource/Roots/Toggle Folder template (ID: {8178B44E-B2BB-4635-85BA-B807CE420858}). */
export type ToggleFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Toggle template (ID: {8E4C968E-9FA5-43A8-9AC4-C0BAF273CCDE}). */
export type Toggle_8e4c968e9fa543a89ac4c0baf273ccde = GridParameters & ICacheable & IDynamicPlaceholder & IRenderingId & ISplitter & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DynamicPlaceholderId (ID: {341C75BF-07F6-40F9-8CEE-8C5DD80A51AF}). */
  dynamicPlaceholderId?: Maybe<TextField>;
  /** EasingFunction (ID: {024FACFD-F2C9-484E-822C-151A71751456}). */
  easingFunction?: Maybe<LookupField>;
  /** EnabledPlaceholders (ID: {8C4F99AC-5C29-40EF-9A33-1A4C73DBFEA9}). */
  enabledPlaceholders?: Maybe<TextField>;
  /** ExpandOnHover (ID: {7C9FF093-4774-4B22-998C-0C25D5FF9550}). */
  expandOnHover?: Maybe<CheckboxField>;
  /** ExpandedByDefault (ID: {F29656D0-C8A7-4DFA-BEAB-6CCC5514FC8A}). */
  expandedByDefault?: Maybe<CheckboxField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Speed (ID: {A1D8F373-E390-4054-9289-F3A5CC4A51E4}). */
  speed?: Maybe<IntegerField>;
  /** SplitterSize (ID: {6055E1C7-B6F3-4514-B6BE-406D957CB031}). */
  splitterSize?: Maybe<NumberField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Toggle template (ID: {8E4C968E-9FA5-43A8-9AC4-C0BAF273CCDE}). */
export type Toggle_8e4c968e9fa543a89ac4c0baf273ccdeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Toggle template (ID: {8E4C968E-9FA5-43A8-9AC4-C0BAF273CCDE}). */
export type Toggle_8e4c968e9fa543a89ac4c0baf273ccdeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Toggle template (ID: {8E4C968E-9FA5-43A8-9AC4-C0BAF273CCDE}). */
export type Toggle_8e4c968e9fa543a89ac4c0baf273ccdeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Toggle template (ID: {8E4C968E-9FA5-43A8-9AC4-C0BAF273CCDE}). */
export type Toggle_8e4c968e9fa543a89ac4c0baf273ccdeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Toggle template (ID: {8E4C968E-9FA5-43A8-9AC4-C0BAF273CCDE}). */
export type Toggle_8e4c968e9fa543a89ac4c0baf273ccdeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Page Structure/Rendering Parameters/Toggle template (ID: {8E4C968E-9FA5-43A8-9AC4-C0BAF273CCDE}). */
export type Toggle_8e4c968e9fa543a89ac4c0baf273ccdeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Stylelabs/Transformation template (ID: {4546A0A8-59EC-44BD-9C3F-1EF4A36ED62D}). */
export type Transformation = Item & {
  __typename?: 'Transformation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TransformationHeight (ID: {1748EF89-4B1D-4EB6-9D00-C944FF468E34}). */
  transformationHeight?: Maybe<NumberField>;
  /** TransformationName (ID: {C83858FB-FC44-4782-BE34-8867CAED4C1F}). */
  transformationName?: Maybe<TextField>;
  /** TransformationQuality (ID: {DBA313DE-58E9-45B6-859E-8BAC1E91DE9C}). */
  transformationQuality?: Maybe<NumberField>;
  /** TransformationWidth (ID: {A7A1914C-97AA-4803-8B3A-B49F82696BBE}). */
  transformationWidth?: Maybe<NumberField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Stylelabs/Transformation template (ID: {4546A0A8-59EC-44BD-9C3F-1EF4A36ED62D}). */
export type TransformationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Stylelabs/Transformation template (ID: {4546A0A8-59EC-44BD-9C3F-1EF4A36ED62D}). */
export type TransformationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Stylelabs/Transformation template (ID: {4546A0A8-59EC-44BD-9C3F-1EF4A36ED62D}). */
export type TransformationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Stylelabs/Transformation template (ID: {4546A0A8-59EC-44BD-9C3F-1EF4A36ED62D}). */
export type TransformationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Stylelabs/Transformation template (ID: {4546A0A8-59EC-44BD-9C3F-1EF4A36ED62D}). */
export type TransformationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Stylelabs/Transformation template (ID: {4546A0A8-59EC-44BD-9C3F-1EF4A36ED62D}). */
export type TransformationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Trust Article Hero Parameters Template template (ID: {A11A2E8F-B27A-457C-A18C-444F833AC472}). */
export type TrustArticleHeroParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'TrustArticleHeroParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** imagePosition (ID: {B1FB3CF3-C446-46CA-8E55-E4F3C2C1B9AA}). */
  imagePosition?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Trust Article Hero Parameters Template template (ID: {A11A2E8F-B27A-457C-A18C-444F833AC472}). */
export type TrustArticleHeroParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Trust Article Hero Parameters Template template (ID: {A11A2E8F-B27A-457C-A18C-444F833AC472}). */
export type TrustArticleHeroParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Trust Article Hero Parameters Template template (ID: {A11A2E8F-B27A-457C-A18C-444F833AC472}). */
export type TrustArticleHeroParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Trust Article Hero Parameters Template template (ID: {A11A2E8F-B27A-457C-A18C-444F833AC472}). */
export type TrustArticleHeroParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Trust Article Hero Parameters Template template (ID: {A11A2E8F-B27A-457C-A18C-444F833AC472}). */
export type TrustArticleHeroParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Rendering Parameters/Trust Article Hero Parameters Template template (ID: {A11A2E8F-B27A-457C-A18C-444F833AC472}). */
export type TrustArticleHeroParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder template (ID: {07DB2DB8-2A5C-4147-88B2-E0C2764D6132}). */
export type TrustFinder = Item & {
  __typename?: 'TrustFinder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** filterSubHeading (ID: {BB85A0C4-C43F-4B94-BBF1-D72D88BE91C5}). */
  filterSubHeading?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder template (ID: {07DB2DB8-2A5C-4147-88B2-E0C2764D6132}). */
export type TrustFinderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder template (ID: {07DB2DB8-2A5C-4147-88B2-E0C2764D6132}). */
export type TrustFinderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder template (ID: {07DB2DB8-2A5C-4147-88B2-E0C2764D6132}). */
export type TrustFinderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder template (ID: {07DB2DB8-2A5C-4147-88B2-E0C2764D6132}). */
export type TrustFinderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder template (ID: {07DB2DB8-2A5C-4147-88B2-E0C2764D6132}). */
export type TrustFinderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder template (ID: {07DB2DB8-2A5C-4147-88B2-E0C2764D6132}). */
export type TrustFinderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder Filter Option template (ID: {DCBA212A-1F83-4959-B831-4056184476D5}). */
export type TrustFinderFilterOption = Item & {
  __typename?: 'TrustFinderFilterOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** displayName (ID: {4BB1BD03-B7A0-4CA4-B588-DF968F332E3E}). */
  displayName_4bb1bd03b7a04ca4b588df968f332e3e?: Maybe<TextField>;
  /** facetName (ID: {7C73B6FA-FA66-4AF3-9FA6-F1F2BE132C27}). */
  facetName?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder Filter Option template (ID: {DCBA212A-1F83-4959-B831-4056184476D5}). */
export type TrustFinderFilterOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder Filter Option template (ID: {DCBA212A-1F83-4959-B831-4056184476D5}). */
export type TrustFinderFilterOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder Filter Option template (ID: {DCBA212A-1F83-4959-B831-4056184476D5}). */
export type TrustFinderFilterOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder Filter Option template (ID: {DCBA212A-1F83-4959-B831-4056184476D5}). */
export type TrustFinderFilterOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder Filter Option template (ID: {DCBA212A-1F83-4959-B831-4056184476D5}). */
export type TrustFinderFilterOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Datasource/Trust Finder/Trust Finder Filter Option template (ID: {DCBA212A-1F83-4959-B831-4056184476D5}). */
export type TrustFinderFilterOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Region template (ID: {0D4E1CD3-DA6E-4739-A30A-0E2D088A3DE1}). */
export type TrustRegion = Item & {
  __typename?: 'TrustRegion';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Region template (ID: {0D4E1CD3-DA6E-4739-A30A-0E2D088A3DE1}). */
export type TrustRegionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Region template (ID: {0D4E1CD3-DA6E-4739-A30A-0E2D088A3DE1}). */
export type TrustRegionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Region template (ID: {0D4E1CD3-DA6E-4739-A30A-0E2D088A3DE1}). */
export type TrustRegionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Region template (ID: {0D4E1CD3-DA6E-4739-A30A-0E2D088A3DE1}). */
export type TrustRegionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Region template (ID: {0D4E1CD3-DA6E-4739-A30A-0E2D088A3DE1}). */
export type TrustRegionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Trust Region template (ID: {0D4E1CD3-DA6E-4739-A30A-0E2D088A3DE1}). */
export type TrustRegionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Type template (ID: {C4FF1317-A9E6-4B88-BD63-3CE7EFC1D1BC}). */
export type TrustType = Item & {
  __typename?: 'TrustType';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Type template (ID: {C4FF1317-A9E6-4B88-BD63-3CE7EFC1D1BC}). */
export type TrustTypeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Type template (ID: {C4FF1317-A9E6-4B88-BD63-3CE7EFC1D1BC}). */
export type TrustTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Type template (ID: {C4FF1317-A9E6-4B88-BD63-3CE7EFC1D1BC}). */
export type TrustTypeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Type template (ID: {C4FF1317-A9E6-4B88-BD63-3CE7EFC1D1BC}). */
export type TrustTypeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Type template (ID: {C4FF1317-A9E6-4B88-BD63-3CE7EFC1D1BC}). */
export type TrustTypeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Type template (ID: {C4FF1317-A9E6-4B88-BD63-3CE7EFC1D1BC}). */
export type TrustTypeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Types Folder template (ID: {B2BB893A-74ED-46AA-B5AD-3A75D2AFC786}). */
export type TrustTypesFolder = Item & {
  __typename?: 'TrustTypesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Types Folder template (ID: {B2BB893A-74ED-46AA-B5AD-3A75D2AFC786}). */
export type TrustTypesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Types Folder template (ID: {B2BB893A-74ED-46AA-B5AD-3A75D2AFC786}). */
export type TrustTypesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Types Folder template (ID: {B2BB893A-74ED-46AA-B5AD-3A75D2AFC786}). */
export type TrustTypesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Types Folder template (ID: {B2BB893A-74ED-46AA-B5AD-3A75D2AFC786}). */
export type TrustTypesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Types Folder template (ID: {B2BB893A-74ED-46AA-B5AD-3A75D2AFC786}). */
export type TrustTypesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Fund/Settings/Trust Type/Trust Types Folder template (ID: {B2BB893A-74ED-46AA-B5AD-3A75D2AFC786}). */
export type TrustTypesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter template (ID: {C27AAA1E-2764-46E4-908C-BB3A4C75C68F}). */
export type Twitter = Item & {
  __typename?: 'Twitter';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CacheInterval (ID: {CAC61C98-28FB-4B4B-9FD3-081D74FEA9C1}). */
  cacheInterval?: Maybe<IntegerField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Hashtag (ID: {614B5DA5-76B7-4EFA-BB0C-1C56B27CFADF}). */
  hashtag?: Maybe<TextField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** ScreenName (ID: {0B339A1F-4A43-4375-9F6A-39BE90F5A107}). */
  screenName?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {AE1EB2D8-3A7C-4337-83DF-1B0B0C857BEE}). */
  title?: Maybe<TextField>;
  /** TweetsNumber (ID: {07D2D2AC-A816-4D9E-8E46-A9413464A369}). */
  tweetsNumber?: Maybe<IntegerField>;
  /** TwitterApp (ID: {50B49831-4E52-4A67-8393-D7393F22CF37}). */
  twitterApp?: Maybe<LookupField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter template (ID: {C27AAA1E-2764-46E4-908C-BB3A4C75C68F}). */
export type TwitterAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter template (ID: {C27AAA1E-2764-46E4-908C-BB3A4C75C68F}). */
export type TwitterChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter template (ID: {C27AAA1E-2764-46E4-908C-BB3A4C75C68F}). */
export type TwitterFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter template (ID: {C27AAA1E-2764-46E4-908C-BB3A4C75C68F}). */
export type TwitterFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter template (ID: {C27AAA1E-2764-46E4-908C-BB3A4C75C68F}). */
export type TwitterHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter template (ID: {C27AAA1E-2764-46E4-908C-BB3A4C75C68F}). */
export type TwitterIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter App template (ID: {1D840426-5DEF-4A76-811C-E73DA21F64AC}). */
export type TwitterApp = Item & {
  __typename?: 'TwitterApp';
  /** AccessToken (ID: {B07D518C-4E73-45EF-B478-DEAE9EC7426F}). */
  accessToken?: Maybe<TextField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** ConsumerKey (ID: {B63DFC4A-758D-4990-83CD-C0F82C9F1364}). */
  consumerKey?: Maybe<TextField>;
  /** ConsumerSecret (ID: {39AC23AF-05D1-4CF6-AF8D-0A5433BD86CE}). */
  consumerSecret?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OAuthToken (ID: {3C9E33F5-955F-4E70-935F-4B8A07869419}). */
  oAuthToken?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter App template (ID: {1D840426-5DEF-4A76-811C-E73DA21F64AC}). */
export type TwitterAppAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter App template (ID: {1D840426-5DEF-4A76-811C-E73DA21F64AC}). */
export type TwitterAppChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter App template (ID: {1D840426-5DEF-4A76-811C-E73DA21F64AC}). */
export type TwitterAppFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter App template (ID: {1D840426-5DEF-4A76-811C-E73DA21F64AC}). */
export type TwitterAppFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter App template (ID: {1D840426-5DEF-4A76-811C-E73DA21F64AC}). */
export type TwitterAppHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter App template (ID: {1D840426-5DEF-4A76-811C-E73DA21F64AC}). */
export type TwitterAppIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter Apps template (ID: {456067DF-FC7D-4639-9177-41F69E81C927}). */
export type TwitterApps = Item & {
  __typename?: 'TwitterApps';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter Apps template (ID: {456067DF-FC7D-4639-9177-41F69E81C927}). */
export type TwitterAppsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter Apps template (ID: {456067DF-FC7D-4639-9177-41F69E81C927}). */
export type TwitterAppsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter Apps template (ID: {456067DF-FC7D-4639-9177-41F69E81C927}). */
export type TwitterAppsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter Apps template (ID: {456067DF-FC7D-4639-9177-41F69E81C927}). */
export type TwitterAppsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter Apps template (ID: {456067DF-FC7D-4639-9177-41F69E81C927}). */
export type TwitterAppsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Settings/Twitter Apps template (ID: {456067DF-FC7D-4639-9177-41F69E81C927}). */
export type TwitterAppsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter Folder template (ID: {041C1F9F-99A4-4EE6-8308-985499F91032}). */
export type TwitterFolder = Item & {
  __typename?: 'TwitterFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter Folder template (ID: {041C1F9F-99A4-4EE6-8308-985499F91032}). */
export type TwitterFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter Folder template (ID: {041C1F9F-99A4-4EE6-8308-985499F91032}). */
export type TwitterFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter Folder template (ID: {041C1F9F-99A4-4EE6-8308-985499F91032}). */
export type TwitterFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter Folder template (ID: {041C1F9F-99A4-4EE6-8308-985499F91032}). */
export type TwitterFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter Folder template (ID: {041C1F9F-99A4-4EE6-8308-985499F91032}). */
export type TwitterFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Datasource/Twitter Folder template (ID: {041C1F9F-99A4-4EE6-8308-985499F91032}). */
export type TwitterFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/TwitterParametersTemplate template (ID: {47038F5C-5BFA-44BC-A05B-6749CCF4D3F4}). */
export type TwitterParametersTemplate = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'TwitterParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** TitleHeadingLevel (ID: {D894B810-9D4D-4E78-BC56-08C42EA2E99F}). */
  titleHeadingLevel?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/TwitterParametersTemplate template (ID: {47038F5C-5BFA-44BC-A05B-6749CCF4D3F4}). */
export type TwitterParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/TwitterParametersTemplate template (ID: {47038F5C-5BFA-44BC-A05B-6749CCF4D3F4}). */
export type TwitterParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/TwitterParametersTemplate template (ID: {47038F5C-5BFA-44BC-A05B-6749CCF4D3F4}). */
export type TwitterParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/TwitterParametersTemplate template (ID: {47038F5C-5BFA-44BC-A05B-6749CCF4D3F4}). */
export type TwitterParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/TwitterParametersTemplate template (ID: {47038F5C-5BFA-44BC-A05B-6749CCF4D3F4}). */
export type TwitterParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Social/Rendering Parameters/TwitterParametersTemplate template (ID: {47038F5C-5BFA-44BC-A05B-6749CCF4D3F4}). */
export type TwitterParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Twitter Settings/Twitter Settings template (ID: {7337C8F9-9E4F-4EF8-89B6-67821C2067D5}). */
export type TwitterSettings = Item & {
  __typename?: 'TwitterSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Twitter Account (ID: {A33039DF-6637-4CE3-902B-434CEAA47F16}). */
  twitterAccount?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Twitter Settings/Twitter Settings template (ID: {7337C8F9-9E4F-4EF8-89B6-67821C2067D5}). */
export type TwitterSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Twitter Settings/Twitter Settings template (ID: {7337C8F9-9E4F-4EF8-89B6-67821C2067D5}). */
export type TwitterSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Twitter Settings/Twitter Settings template (ID: {7337C8F9-9E4F-4EF8-89B6-67821C2067D5}). */
export type TwitterSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Twitter Settings/Twitter Settings template (ID: {7337C8F9-9E4F-4EF8-89B6-67821C2067D5}). */
export type TwitterSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Twitter Settings/Twitter Settings template (ID: {7337C8F9-9E4F-4EF8-89B6-67821C2067D5}). */
export type TwitterSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Twitter Settings/Twitter Settings template (ID: {7337C8F9-9E4F-4EF8-89B6-67821C2067D5}). */
export type TwitterSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a Sitecore item whose template is not included in the schema. If you receive results of this type, consider expanding your included templates. */
export type UnknownItem = Item & {
  __typename?: 'UnknownItem';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** Represents a Sitecore item whose template is not included in the schema. If you receive results of this type, consider expanding your included templates. */
export type UnknownItemAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a Sitecore item whose template is not included in the schema. If you receive results of this type, consider expanding your included templates. */
export type UnknownItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a Sitecore item whose template is not included in the schema. If you receive results of this type, consider expanding your included templates. */
export type UnknownItemFieldArgs = {
  name: Scalars['String']['input'];
};


/** Represents a Sitecore item whose template is not included in the schema. If you receive results of this type, consider expanding your included templates. */
export type UnknownItemFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a Sitecore item whose template is not included in the schema. If you receive results of this type, consider expanding your included templates. */
export type UnknownItemHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a Sitecore item whose template is not included in the schema. If you receive results of this type, consider expanding your included templates. */
export type UnknownItemIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/UnminifiedFile template (ID: {07F65D09-2920-4F05-9AF5-A77C590BEFDF}). */
export type UnminifiedFile = File & Item & {
  __typename?: 'UnminifiedFile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Blob (ID: {40E50ED9-BA07-4702-992E-A912738D32DC}). */
  blob?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CountryCode (ID: {FF01BC1A-EF22-407C-9115-7DBEE11451A5}). */
  countryCode?: Maybe<TextField>;
  /** Description (ID: {BA8341A1-FF30-47B8-AE6A-F4947E4113F0}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension (ID: {C06867FE-9A43-4C7D-B739-48780492D06F}). */
  extension?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** File Path (ID: {2134867A-AC67-4DAC-836C-A9264FD9D6D6}). */
  filePath?: Maybe<TextField>;
  /** Format (ID: {FBD90442-DB0C-48F1-A0F4-0427CD9AFCCE}). */
  format?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Keywords (ID: {2FAFE7CB-2691-4800-8848-255EFA1D31AA}). */
  keywords?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Latitude (ID: {5D589EC4-4842-4630-A860-540357A196F3}). */
  latitude?: Maybe<NumberField>;
  /** LocationDescription (ID: {E8FA62D2-13FC-4C5C-91E5-71D615591420}). */
  locationDescription?: Maybe<TextField>;
  /** Longitude (ID: {11CB6358-8F71-4F80-AB30-04D745D99D56}). */
  longitude?: Maybe<NumberField>;
  /** Mime Type (ID: {6F47A0A5-9C94-4B48-ABEB-42D38DEF6054}). */
  mimeType?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Size (ID: {6954B7C7-2487-423F-8600-436CB3B6DC0E}). */
  size?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {3F4B20E9-36E6-4D45-A423-C86567373F82}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** ZipCode (ID: {FB540BF1-B2EB-47C9-A55F-F01B2FCA5851}). */
  zipCode?: Maybe<TextField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/UnminifiedFile template (ID: {07F65D09-2920-4F05-9AF5-A77C590BEFDF}). */
export type UnminifiedFileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/UnminifiedFile template (ID: {07F65D09-2920-4F05-9AF5-A77C590BEFDF}). */
export type UnminifiedFileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/UnminifiedFile template (ID: {07F65D09-2920-4F05-9AF5-A77C590BEFDF}). */
export type UnminifiedFileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/UnminifiedFile template (ID: {07F65D09-2920-4F05-9AF5-A77C590BEFDF}). */
export type UnminifiedFileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/UnminifiedFile template (ID: {07F65D09-2920-4F05-9AF5-A77C590BEFDF}). */
export type UnminifiedFileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/UnminifiedFile template (ID: {07F65D09-2920-4F05-9AF5-A77C590BEFDF}). */
export type UnminifiedFileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script template (ID: {5205CD92-0242-45AA-BEAD-B5C6288F2138}). */
export type UpgradeScript = Item & PowerShellScript & {
  __typename?: 'UpgradeScript';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Description (ID: {82563BD5-DE9B-4741-B79A-9BC9163E2086}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** DryRunSupported (ID: {AD057AE5-557E-42B9-A7FF-FC697BF9DBEA}). */
  dryRunSupported?: Maybe<CheckboxField>;
  /** Enabled status is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Mode (ID: {16CF2FE9-1576-456B-8FF3-0002D03EFB0D}). */
  mode?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  /** Scripts with the specified ID will use a single shared session; after which those sessions will remain in memory. When left empty, sessions will close after each use. */
  persistentSessionId?: Maybe<TextField>;
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Script (ID: {B1A94FF0-6897-47C0-9C51-AA6ACB80B1F0}). */
  script?: Maybe<TextField>;
  /** Visibility is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  showRule?: Maybe<TextField>;
  /** TargetVersion (ID: {67223412-5752-426F-940F-F2F40DF561F2}). */
  targetVersion?: Maybe<NumberField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Title (ID: {6ED03045-4ADB-40E9-9B88-19282B6E5C90}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script template (ID: {5205CD92-0242-45AA-BEAD-B5C6288F2138}). */
export type UpgradeScriptAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script template (ID: {5205CD92-0242-45AA-BEAD-B5C6288F2138}). */
export type UpgradeScriptChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script template (ID: {5205CD92-0242-45AA-BEAD-B5C6288F2138}). */
export type UpgradeScriptFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script template (ID: {5205CD92-0242-45AA-BEAD-B5C6288F2138}). */
export type UpgradeScriptFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script template (ID: {5205CD92-0242-45AA-BEAD-B5C6288F2138}). */
export type UpgradeScriptHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script template (ID: {5205CD92-0242-45AA-BEAD-B5C6288F2138}). */
export type UpgradeScriptIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script Library template (ID: {9BB0F2CE-01E2-4ADE-BF15-E4C60F1B61CB}). */
export type UpgradeScriptLibrary = Item & PowerShellScriptLibrary & {
  __typename?: 'UpgradeScriptLibrary';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled status is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Visibility is evaluated for integration points such as those seen in the Context Menu and Ribbon. */
  showRule?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script Library template (ID: {9BB0F2CE-01E2-4ADE-BF15-E4C60F1B61CB}). */
export type UpgradeScriptLibraryAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script Library template (ID: {9BB0F2CE-01E2-4ADE-BF15-E4C60F1B61CB}). */
export type UpgradeScriptLibraryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script Library template (ID: {9BB0F2CE-01E2-4ADE-BF15-E4C60F1B61CB}). */
export type UpgradeScriptLibraryFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script Library template (ID: {9BB0F2CE-01E2-4ADE-BF15-E4C60F1B61CB}). */
export type UpgradeScriptLibraryFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script Library template (ID: {9BB0F2CE-01E2-4ADE-BF15-E4C60F1B61CB}). */
export type UpgradeScriptLibraryHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Upgrade Script Library template (ID: {9BB0F2CE-01E2-4ADE-BF15-E4C60F1B61CB}). */
export type UpgradeScriptLibraryIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantComponentField template (ID: {1151B2A9-08AF-4F4D-A892-C2CC9A92EA6A}). */
export type VariantComponentField = BaseVariantField & Item & {
  __typename?: 'VariantComponentField';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Selects rendering used by rendering variant renderer. */
  renderingItem?: Maybe<LookupField>;
  /** Specifies rendering parameters for rendering variant renderer. */
  renderingParameters?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantComponentField template (ID: {1151B2A9-08AF-4F4D-A892-C2CC9A92EA6A}). */
export type VariantComponentFieldAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantComponentField template (ID: {1151B2A9-08AF-4F4D-A892-C2CC9A92EA6A}). */
export type VariantComponentFieldChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantComponentField template (ID: {1151B2A9-08AF-4F4D-A892-C2CC9A92EA6A}). */
export type VariantComponentFieldFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantComponentField template (ID: {1151B2A9-08AF-4F4D-A892-C2CC9A92EA6A}). */
export type VariantComponentFieldFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantComponentField template (ID: {1151B2A9-08AF-4F4D-A892-C2CC9A92EA6A}). */
export type VariantComponentFieldHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantComponentField template (ID: {1151B2A9-08AF-4F4D-A892-C2CC9A92EA6A}). */
export type VariantComponentFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantDateField template (ID: {DC4EBC23-A470-4B5D-8DF8-4A55FA823BB4}). */
export type VariantDateField = BaseVariantField & Item & VariantField & _DataAttributes & _LinkAttributes & {
  __typename?: 'VariantDateField';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** Determines the date format. */
  dateFormat?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Select to have a hyperlink with a download attribute. */
  isDownloadLink?: Maybe<CheckboxField>;
  /** Select to have hyperlinks that wrap the field content. */
  isLink?: Maybe<TextField>;
  /** Select to wrap prefix in the same link which you use for the field content. */
  isPrefixLink?: Maybe<TextField>;
  /** Select to wrap the suffix with a hyperlink. */
  isSuffixLink?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Adds string value as a prefix. */
  prefix?: Maybe<TextField>;
  /** Select to render empty element when the field is empty. */
  renderIfEmpty?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Adds string value as a suffix. */
  suffix?: Maybe<TextField>;
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** Select to edit rendered field. */
  useFieldRenderer?: Maybe<CheckboxField>;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantDateField template (ID: {DC4EBC23-A470-4B5D-8DF8-4A55FA823BB4}). */
export type VariantDateFieldAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantDateField template (ID: {DC4EBC23-A470-4B5D-8DF8-4A55FA823BB4}). */
export type VariantDateFieldChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantDateField template (ID: {DC4EBC23-A470-4B5D-8DF8-4A55FA823BB4}). */
export type VariantDateFieldFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantDateField template (ID: {DC4EBC23-A470-4B5D-8DF8-4A55FA823BB4}). */
export type VariantDateFieldFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantDateField template (ID: {DC4EBC23-A470-4B5D-8DF8-4A55FA823BB4}). */
export type VariantDateFieldHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantDateField template (ID: {DC4EBC23-A470-4B5D-8DF8-4A55FA823BB4}). */
export type VariantDateFieldIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variant Definition template (ID: {FB3E3034-33F8-4CE8-BE98-DD05010F4C22}). Also implements IVariantDefinition, IBaseVariantDefinition, ICompatibleRenderings. */
export type VariantDefinition = {
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** Specifies class to render into rendering content element.  */
  cssClass?: Maybe<TextField>;
  /**
   * Specifies field name of the rendered item from which the CSS class will be taken and rendered into class attribute.
   * Supported for Navigation rendering only.
   */
  itemCssClassField?: Maybe<TextField>;
  /** Provide the field name of the target item. This class is added to the list and navigation items markup (li HTML element). This link is used to override all links when the Is link, Is prefix link, or Is suffix link check boxes are selected. */
  linkField?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/Variant Definition template (ID: {4D50CDAE-C2D9-4DE8-B080-8F992BFB1B55}). */
export type VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = IBaseVariantDefinition & ICompatibleRenderings & IVariantDefinition & Item & {
  __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55';
  /** Specify the pages that the variant is available for. Click the relevant page template, click the right arrow to move it to the list of selected items, and then click Save. If no templates are selected, the variant is available for all pages. */
  allowedInTemplates?: Maybe<MultilistField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Provide the field name of the target item. This class is added to the list and navigation items markup (li HTML element). This link is used to override all links when the Is link, Is prefix link, or Is suffix link check boxes are selected. */
  linkField?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/Variant Definition template (ID: {4D50CDAE-C2D9-4DE8-B080-8F992BFB1B55}). */
export type VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/Variant Definition template (ID: {4D50CDAE-C2D9-4DE8-B080-8F992BFB1B55}). */
export type VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/Variant Definition template (ID: {4D50CDAE-C2D9-4DE8-B080-8F992BFB1B55}). */
export type VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/Variant Definition template (ID: {4D50CDAE-C2D9-4DE8-B080-8F992BFB1B55}). */
export type VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/Variant Definition template (ID: {4D50CDAE-C2D9-4DE8-B080-8F992BFB1B55}). */
export type VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/JSS Experience Accelerator/Headless Variants/Variant Definition template (ID: {4D50CDAE-C2D9-4DE8-B080-8F992BFB1B55}). */
export type VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantField template (ID: {FCD285DA-9AB2-4C8D-B185-5A7487A9BA1B}). Also implements BaseVariantField, _LinkAttributes, _DataAttributes, _RenderingVariantsBase. */
export type VariantField = {
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Name of the field from the item used for rendering content. */
  fieldName?: Maybe<TextField>;
  /** Select to have a hyperlink with a download attribute. */
  isDownloadLink?: Maybe<CheckboxField>;
  /** Select to have hyperlinks that wrap the field content. */
  isLink?: Maybe<TextField>;
  /** Select to wrap prefix in the same link which you use for the field content. */
  isPrefixLink?: Maybe<TextField>;
  /** Select to wrap the suffix with a hyperlink. */
  isSuffixLink?: Maybe<TextField>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** Adds string value as a prefix. */
  prefix?: Maybe<TextField>;
  /** Select to render empty element when the field is empty. */
  renderIfEmpty?: Maybe<CheckboxField>;
  /** Adds string value as a suffix. */
  suffix?: Maybe<TextField>;
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Select to edit rendered field. */
  useFieldRenderer?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantPlaceholder template (ID: {F4218805-86DD-4A01-A94D-7342FC392BCC}). */
export type VariantPlaceholder = BaseVariantField & Item & {
  __typename?: 'VariantPlaceholder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Defines placeholder key used for rendering placeholder. */
  placeholderKey?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Switch component context to currently rendered item */
  switchContext?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantPlaceholder template (ID: {F4218805-86DD-4A01-A94D-7342FC392BCC}). */
export type VariantPlaceholderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantPlaceholder template (ID: {F4218805-86DD-4A01-A94D-7342FC392BCC}). */
export type VariantPlaceholderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantPlaceholder template (ID: {F4218805-86DD-4A01-A94D-7342FC392BCC}). */
export type VariantPlaceholderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantPlaceholder template (ID: {F4218805-86DD-4A01-A94D-7342FC392BCC}). */
export type VariantPlaceholderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantPlaceholder template (ID: {F4218805-86DD-4A01-A94D-7342FC392BCC}). */
export type VariantPlaceholderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantPlaceholder template (ID: {F4218805-86DD-4A01-A94D-7342FC392BCC}). */
export type VariantPlaceholderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantReference template (ID: {6354D18E-54E9-45AD-9EC7-510769DB4809}). */
export type VariantReference = Item & _VariantPaging & {
  __typename?: 'VariantReference';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NumberOfResultsToSkip (ID: {AE6DB294-8D8B-45BE-919C-1143867BC03D}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** Defines the name of the field that stores the link to a different item. For example, a simple reference, such as a link, or a mult1-reference field, such as a Tree list. */
  passThroughField?: Maybe<TextField>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantReference template (ID: {6354D18E-54E9-45AD-9EC7-510769DB4809}). */
export type VariantReferenceAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantReference template (ID: {6354D18E-54E9-45AD-9EC7-510769DB4809}). */
export type VariantReferenceChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantReference template (ID: {6354D18E-54E9-45AD-9EC7-510769DB4809}). */
export type VariantReferenceFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantReference template (ID: {6354D18E-54E9-45AD-9EC7-510769DB4809}). */
export type VariantReferenceFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantReference template (ID: {6354D18E-54E9-45AD-9EC7-510769DB4809}). */
export type VariantReferenceHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantReference template (ID: {6354D18E-54E9-45AD-9EC7-510769DB4809}). */
export type VariantReferenceIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantSection template (ID: {ACA5C9A3-CDA0-49B6-893F-1D4A7CB595B0}). */
export type VariantSection = BaseVariantField & Item & _DataAttributes & _LinkAttributes & {
  __typename?: 'VariantSection';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Select to have hyperlinks that wrap the field content. */
  isLink?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantSection template (ID: {ACA5C9A3-CDA0-49B6-893F-1D4A7CB595B0}). */
export type VariantSectionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantSection template (ID: {ACA5C9A3-CDA0-49B6-893F-1D4A7CB595B0}). */
export type VariantSectionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantSection template (ID: {ACA5C9A3-CDA0-49B6-893F-1D4A7CB595B0}). */
export type VariantSectionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantSection template (ID: {ACA5C9A3-CDA0-49B6-893F-1D4A7CB595B0}). */
export type VariantSectionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantSection template (ID: {ACA5C9A3-CDA0-49B6-893F-1D4A7CB595B0}). */
export type VariantSectionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantSection template (ID: {ACA5C9A3-CDA0-49B6-893F-1D4A7CB595B0}). */
export type VariantSectionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantTemplate template (ID: {C645DD63-2462-470C-A48D-8B55757A2DB3}). */
export type VariantTemplate = BaseVariantField & Item & _DataAttributes & {
  __typename?: 'VariantTemplate';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /**
   * Define the NVelocity template that renders part of the component variant HTML
   *  – access to the current item (the .Name object displays the current item name).
   * .Format(date, format) – formats date and time values.
   * .Format(number, format) – formats numbers.
   * .Distance – displays distance to points of interest in geospatial searches.
   */
  template_d90f5d1a19e148ccb67347d6b5d9b3ed?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantTemplate template (ID: {C645DD63-2462-470C-A48D-8B55757A2DB3}). */
export type VariantTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantTemplate template (ID: {C645DD63-2462-470C-A48D-8B55757A2DB3}). */
export type VariantTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantTemplate template (ID: {C645DD63-2462-470C-A48D-8B55757A2DB3}). */
export type VariantTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantTemplate template (ID: {C645DD63-2462-470C-A48D-8B55757A2DB3}). */
export type VariantTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantTemplate template (ID: {C645DD63-2462-470C-A48D-8B55757A2DB3}). */
export type VariantTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantTemplate template (ID: {C645DD63-2462-470C-A48D-8B55757A2DB3}). */
export type VariantTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantText template (ID: {7C02E9F5-54B5-4EF4-BD10-F4C5D448A48C}). */
export type VariantText = BaseVariantField & Item & _DataAttributes & _LinkAttributes & {
  __typename?: 'VariantText';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Select to have hyperlinks that wrap the field content. */
  isLink?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** The text to render. */
  text?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantText template (ID: {7C02E9F5-54B5-4EF4-BD10-F4C5D448A48C}). */
export type VariantTextAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantText template (ID: {7C02E9F5-54B5-4EF4-BD10-F4C5D448A48C}). */
export type VariantTextChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantText template (ID: {7C02E9F5-54B5-4EF4-BD10-F4C5D448A48C}). */
export type VariantTextFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantText template (ID: {7C02E9F5-54B5-4EF4-BD10-F4C5D448A48C}). */
export type VariantTextFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantText template (ID: {7C02E9F5-54B5-4EF4-BD10-F4C5D448A48C}). */
export type VariantTextHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantText template (ID: {7C02E9F5-54B5-4EF4-BD10-F4C5D448A48C}). */
export type VariantTextIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantToken template (ID: {6ECA12E9-F4D5-4F6E-9C3C-6DF716BC593B}). */
export type VariantToken = BaseVariantField & Item & _DataAttributes & _LinkAttributes & {
  __typename?: 'VariantToken';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Adds CSS class to the tag. If Tag field is not specified, CSS class will not be rendered. */
  cssClass?: Maybe<TextField>;
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** EnableRule (ID: {9649A336-0DC1-4133-89ED-6D76BEB4C32E}). */
  enableRule?: Maybe<TextField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Select to have a hyperlink with a download attribute. */
  isDownloadLink?: Maybe<CheckboxField>;
  /** Select to have hyperlinks that wrap the field content. */
  isLink?: Maybe<TextField>;
  /** Select to wrap prefix in the same link which you use for the field content. */
  isPrefixLink?: Maybe<TextField>;
  /** Select to wrap the suffix with a hyperlink. */
  isSuffixLink?: Maybe<TextField>;
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Adds string value as a prefix. */
  prefix?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Adds string value as a suffix. */
  suffix?: Maybe<TextField>;
  /**
   * HTML tag used to wrap rendered field content. For example: div
   * If left empty field content will remain unwrapped.
   */
  tag?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /**
   * Use special tokens to format certain field values. Supported tokens are:
   * 	· $Size: displays size of a file depending on size unit.
   * 	· $FileTypeIcon: displays icon depending on file extension.
   * 	· $id: displays id of an item
   * 	· $name: displays name of an item
   */
  token?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantToken template (ID: {6ECA12E9-F4D5-4F6E-9C3C-6DF716BC593B}). */
export type VariantTokenAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantToken template (ID: {6ECA12E9-F4D5-4F6E-9C3C-6DF716BC593B}). */
export type VariantTokenChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantToken template (ID: {6ECA12E9-F4D5-4F6E-9C3C-6DF716BC593B}). */
export type VariantTokenFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantToken template (ID: {6ECA12E9-F4D5-4F6E-9C3C-6DF716BC593B}). */
export type VariantTokenFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantToken template (ID: {6ECA12E9-F4D5-4F6E-9C3C-6DF716BC593B}). */
export type VariantTokenHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/VariantToken template (ID: {6ECA12E9-F4D5-4F6E-9C3C-6DF716BC593B}). */
export type VariantTokenIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variants template (ID: {E1A3B30C-77BC-4F6C-A008-D01B3371235D}). */
export type Variants = ICompatibleRenderings & Item & {
  __typename?: 'Variants';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /**
   * Compatible Renderings	Makes rendering variant available for other renderings. 
   * For example, if for a Page Content rendering variant, in the Compatible Renderings field, you specify Title, you can use the rendering variant for the Title rendering as well.
   */
  compatibleRenderings?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variants template (ID: {E1A3B30C-77BC-4F6C-A008-D01B3371235D}). */
export type VariantsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variants template (ID: {E1A3B30C-77BC-4F6C-A008-D01B3371235D}). */
export type VariantsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variants template (ID: {E1A3B30C-77BC-4F6C-A008-D01B3371235D}). */
export type VariantsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variants template (ID: {E1A3B30C-77BC-4F6C-A008-D01B3371235D}). */
export type VariantsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variants template (ID: {E1A3B30C-77BC-4F6C-A008-D01B3371235D}). */
export type VariantsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Variants template (ID: {E1A3B30C-77BC-4F6C-A008-D01B3371235D}). */
export type VariantsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Folders/Vector Folder template (ID: {2DB2B2B3-0288-4F15-9BE8-BA1A64962B7E}). */
export type VectorFolder = Item & {
  __typename?: 'VectorFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Vector Folder template (ID: {2DB2B2B3-0288-4F15-9BE8-BA1A64962B7E}). */
export type VectorFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Vector Folder template (ID: {2DB2B2B3-0288-4F15-9BE8-BA1A64962B7E}). */
export type VectorFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Vector Folder template (ID: {2DB2B2B3-0288-4F15-9BE8-BA1A64962B7E}). */
export type VectorFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Vector Folder template (ID: {2DB2B2B3-0288-4F15-9BE8-BA1A64962B7E}). */
export type VectorFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Vector Folder template (ID: {2DB2B2B3-0288-4F15-9BE8-BA1A64962B7E}). */
export type VectorFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Folders/Vector Folder template (ID: {2DB2B2B3-0288-4F15-9BE8-BA1A64962B7E}). */
export type VectorFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile template (ID: {00F9CC96-2518-4B73-962C-088217B78DB5}). */
export type VectorTile = Item & {
  __typename?: 'VectorTile';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {3A8A6539-34D5-41E5-8A99-E898C240279A}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** heading (ID: {91F868A3-7D69-48CC-8FF4-19E60D742A0F}). */
  heading?: Maybe<TextField>;
  /** Displayed in Site Selector */
  icon_e7140ae076bb4e1281646d0da3665d5c?: Maybe<ImageField>;
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile template (ID: {00F9CC96-2518-4B73-962C-088217B78DB5}). */
export type VectorTileAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile template (ID: {00F9CC96-2518-4B73-962C-088217B78DB5}). */
export type VectorTileChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile template (ID: {00F9CC96-2518-4B73-962C-088217B78DB5}). */
export type VectorTileFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile template (ID: {00F9CC96-2518-4B73-962C-088217B78DB5}). */
export type VectorTileFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile template (ID: {00F9CC96-2518-4B73-962C-088217B78DB5}). */
export type VectorTileHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile template (ID: {00F9CC96-2518-4B73-962C-088217B78DB5}). */
export type VectorTileIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile Link template (ID: {8CEA9EB0-5615-4C31-97AC-DB523784E33F}). */
export type VectorTileLink = Item & {
  __typename?: 'VectorTileLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** link (ID: {84E73B82-D03B-43BE-8539-811B69C445D2}). */
  link?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile Link template (ID: {8CEA9EB0-5615-4C31-97AC-DB523784E33F}). */
export type VectorTileLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile Link template (ID: {8CEA9EB0-5615-4C31-97AC-DB523784E33F}). */
export type VectorTileLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile Link template (ID: {8CEA9EB0-5615-4C31-97AC-DB523784E33F}). */
export type VectorTileLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile Link template (ID: {8CEA9EB0-5615-4C31-97AC-DB523784E33F}). */
export type VectorTileLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile Link template (ID: {8CEA9EB0-5615-4C31-97AC-DB523784E33F}). */
export type VectorTileLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tile Link template (ID: {8CEA9EB0-5615-4C31-97AC-DB523784E33F}). */
export type VectorTileLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tiles Folder template (ID: {AB727054-ABAE-49B7-831D-A82E24648AA1}). */
export type VectorTilesFolder = Item & {
  __typename?: 'VectorTilesFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tiles Folder template (ID: {AB727054-ABAE-49B7-831D-A82E24648AA1}). */
export type VectorTilesFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tiles Folder template (ID: {AB727054-ABAE-49B7-831D-A82E24648AA1}). */
export type VectorTilesFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tiles Folder template (ID: {AB727054-ABAE-49B7-831D-A82E24648AA1}). */
export type VectorTilesFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tiles Folder template (ID: {AB727054-ABAE-49B7-831D-A82E24648AA1}). */
export type VectorTilesFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tiles Folder template (ID: {AB727054-ABAE-49B7-831D-A82E24648AA1}). */
export type VectorTilesFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Vector Tile/Vector Tiles Folder template (ID: {AB727054-ABAE-49B7-831D-A82E24648AA1}). */
export type VectorTilesFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Vector Tiles Parameters Template template (ID: {525CFD5C-D85C-4E3F-AD0C-135ABC4401F0}). */
export type VectorTilesParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'VectorTilesParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** col (ID: {A17EBF62-1784-4E63-99C4-5F51234EFA1C}). */
  col?: Maybe<TextField>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Vector Tiles Parameters Template template (ID: {525CFD5C-D85C-4E3F-AD0C-135ABC4401F0}). */
export type VectorTilesParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Vector Tiles Parameters Template template (ID: {525CFD5C-D85C-4E3F-AD0C-135ABC4401F0}). */
export type VectorTilesParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Vector Tiles Parameters Template template (ID: {525CFD5C-D85C-4E3F-AD0C-135ABC4401F0}). */
export type VectorTilesParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Vector Tiles Parameters Template template (ID: {525CFD5C-D85C-4E3F-AD0C-135ABC4401F0}). */
export type VectorTilesParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Vector Tiles Parameters Template template (ID: {525CFD5C-D85C-4E3F-AD0C-135ABC4401F0}). */
export type VectorTilesParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Vector Tiles Parameters Template template (ID: {525CFD5C-D85C-4E3F-AD0C-135ABC4401F0}). */
export type VectorTilesParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Version template (ID: {95EBC232-0477-4DC3-8AD3-465D5FE8DA2F}). */
export type Version_95ebc23204774dc38ad3465d5fe8da2f = Item & {
  __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** Version (ID: {0F173E1A-7151-4353-8539-5BB014D804D2}). */
  version_0f173e1a7151435385395bb014d804d2?: Maybe<IntegerField>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Version template (ID: {95EBC232-0477-4DC3-8AD3-465D5FE8DA2F}). */
export type Version_95ebc23204774dc38ad3465d5fe8da2fAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Version template (ID: {95EBC232-0477-4DC3-8AD3-465D5FE8DA2F}). */
export type Version_95ebc23204774dc38ad3465d5fe8da2fChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Version template (ID: {95EBC232-0477-4DC3-8AD3-465D5FE8DA2F}). */
export type Version_95ebc23204774dc38ad3465d5fe8da2fFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Version template (ID: {95EBC232-0477-4DC3-8AD3-465D5FE8DA2F}). */
export type Version_95ebc23204774dc38ad3465d5fe8da2fFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Version template (ID: {95EBC232-0477-4DC3-8AD3-465D5FE8DA2F}). */
export type Version_95ebc23204774dc38ad3465d5fe8da2fHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Upgrade/Version template (ID: {95EBC232-0477-4DC3-8AD3-465D5FE8DA2F}). */
export type Version_95ebc23204774dc38ad3465d5fe8da2fIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video template (ID: {ADE9EFF4-DA78-4E26-9248-B01BD93EAE95}). */
export type Video = Item & SimpleVideo & {
  __typename?: 'Video';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Autoplay (ID: {725A80DD-0CF3-451B-B2DB-220DA5247771}). */
  autoplay?: Maybe<CheckboxField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MP4Movie (ID: {10DC336D-04A0-4AD7-ACD9-7E820CFCB9CB}). */
  mP4Movie?: Maybe<LinkField>;
  /** MovieCaption (ID: {C4A0614E-5A4A-4ECF-B49B-B0D82E5EEE7E}). */
  movieCaption?: Maybe<TextField>;
  /** MovieDescription (ID: {75562C38-22F6-4B63-AF7A-DAF44F0730F1}). */
  movieDescription?: Maybe<RichTextField>;
  /** MovieLabel (ID: {45849EE3-903C-4B05-8E83-56D51066AFC5}). */
  movieLabel?: Maybe<TextField>;
  /** MovieLength (ID: {D2D5EF2A-C938-477E-9F7D-267439808068}). */
  movieLength?: Maybe<IntegerField>;
  /** MovieThumbnail (ID: {4E3A41DD-AFB7-4763-BA20-FF27E0BEEDDF}). */
  movieThumbnail?: Maybe<ImageField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OggMovie (ID: {BFCADF11-A141-4200-9FC2-8484E446320D}). */
  oggMovie?: Maybe<LinkField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** PosterImage (ID: {22379A66-606E-4205-ABEE-F9AC597084DD}). */
  posterImage?: Maybe<ImageField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** VideoNotAvailableImage (ID: {A86112E2-1FAC-46E3-BD8D-F618CE5F4BBC}). */
  videoNotAvailableImage?: Maybe<ImageField>;
  /** VideoNotAvailableText (ID: {051FEDB7-63DD-4600-A2A8-428BDB5B5D86}). */
  videoNotAvailableText?: Maybe<TextField>;
  /** WebMMovie (ID: {2295492E-299B-40FD-BE80-ECCB3EEC7790}). */
  webMMovie?: Maybe<LinkField>;
  /** YoutubeMovie (ID: {C7ABDB60-3F28-4D17-B457-2056710E384F}). */
  youtubeMovie?: Maybe<TextField>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video template (ID: {ADE9EFF4-DA78-4E26-9248-B01BD93EAE95}). */
export type VideoAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video template (ID: {ADE9EFF4-DA78-4E26-9248-B01BD93EAE95}). */
export type VideoChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video template (ID: {ADE9EFF4-DA78-4E26-9248-B01BD93EAE95}). */
export type VideoFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video template (ID: {ADE9EFF4-DA78-4E26-9248-B01BD93EAE95}). */
export type VideoFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video template (ID: {ADE9EFF4-DA78-4E26-9248-B01BD93EAE95}). */
export type VideoHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video template (ID: {ADE9EFF4-DA78-4E26-9248-B01BD93EAE95}). */
export type VideoIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Option template (ID: {8709B7FF-63B1-4FE2-8091-54F205A883F8}). */
export type VideoCountOption = Item & {
  __typename?: 'VideoCountOption';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Option template (ID: {8709B7FF-63B1-4FE2-8091-54F205A883F8}). */
export type VideoCountOptionAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Option template (ID: {8709B7FF-63B1-4FE2-8091-54F205A883F8}). */
export type VideoCountOptionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Option template (ID: {8709B7FF-63B1-4FE2-8091-54F205A883F8}). */
export type VideoCountOptionFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Option template (ID: {8709B7FF-63B1-4FE2-8091-54F205A883F8}). */
export type VideoCountOptionFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Option template (ID: {8709B7FF-63B1-4FE2-8091-54F205A883F8}). */
export type VideoCountOptionHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Option template (ID: {8709B7FF-63B1-4FE2-8091-54F205A883F8}). */
export type VideoCountOptionIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Options template (ID: {96B3E608-6200-492F-838B-F167334131AF}). */
export type VideoCountOptions = Item & {
  __typename?: 'VideoCountOptions';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Options template (ID: {96B3E608-6200-492F-838B-F167334131AF}). */
export type VideoCountOptionsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Options template (ID: {96B3E608-6200-492F-838B-F167334131AF}). */
export type VideoCountOptionsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Options template (ID: {96B3E608-6200-492F-838B-F167334131AF}). */
export type VideoCountOptionsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Options template (ID: {96B3E608-6200-492F-838B-F167334131AF}). */
export type VideoCountOptionsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Options template (ID: {96B3E608-6200-492F-838B-F167334131AF}). */
export type VideoCountOptionsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Settings/Video/Video Count Options template (ID: {96B3E608-6200-492F-838B-F167334131AF}). */
export type VideoCountOptionsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video Folder template (ID: {4C650AB1-7DAB-447C-9836-BB984DF71842}). */
export type VideoFolder = Item & {
  __typename?: 'VideoFolder';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video Folder template (ID: {4C650AB1-7DAB-447C-9836-BB984DF71842}). */
export type VideoFolderAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video Folder template (ID: {4C650AB1-7DAB-447C-9836-BB984DF71842}). */
export type VideoFolderChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video Folder template (ID: {4C650AB1-7DAB-447C-9836-BB984DF71842}). */
export type VideoFolderFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video Folder template (ID: {4C650AB1-7DAB-447C-9836-BB984DF71842}). */
export type VideoFolderFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video Folder template (ID: {4C650AB1-7DAB-447C-9836-BB984DF71842}). */
export type VideoFolderHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Datasource/Video Folder template (ID: {4C650AB1-7DAB-447C-9836-BB984DF71842}). */
export type VideoFolderIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video Folder template (ID: {BBA49474-673E-4681-86BA-8B1A20E067A9}). */
export type VideoFolder_Bba49474673e468186ba8b1a20e067a9 = Item & {
  __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video Folder template (ID: {BBA49474-673E-4681-86BA-8B1A20E067A9}). */
export type VideoFolder_Bba49474673e468186ba8b1a20e067a9AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video Folder template (ID: {BBA49474-673E-4681-86BA-8B1A20E067A9}). */
export type VideoFolder_Bba49474673e468186ba8b1a20e067a9ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video Folder template (ID: {BBA49474-673E-4681-86BA-8B1A20E067A9}). */
export type VideoFolder_Bba49474673e468186ba8b1a20e067a9FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video Folder template (ID: {BBA49474-673E-4681-86BA-8B1A20E067A9}). */
export type VideoFolder_Bba49474673e468186ba8b1a20e067a9FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video Folder template (ID: {BBA49474-673E-4681-86BA-8B1A20E067A9}). */
export type VideoFolder_Bba49474673e468186ba8b1a20e067a9HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video Folder template (ID: {BBA49474-673E-4681-86BA-8B1A20E067A9}). */
export type VideoFolder_Bba49474673e468186ba8b1a20e067a9IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Page template (ID: {D8B293AF-EF88-47AA-945B-7A058BDAF096}). */
export type VideoPage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BaseArticle & _BasePage & _ContentType & _Designable & _FundMetadataPage & _InternalArticle & _LimitedDisplay & _MetadataPage & _Navigable & _NavigablePage & _PremiumContentPage & _SharedPage & _Sitemap & _Taggable & _Video & {
  __typename?: 'VideoPage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {3FA832A3-1006-48DB-85DD-58A9926C49E0}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Page template (ID: {D8B293AF-EF88-47AA-945B-7A058BDAF096}). */
export type VideoPageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Page template (ID: {D8B293AF-EF88-47AA-945B-7A058BDAF096}). */
export type VideoPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Page template (ID: {D8B293AF-EF88-47AA-945B-7A058BDAF096}). */
export type VideoPageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Page template (ID: {D8B293AF-EF88-47AA-945B-7A058BDAF096}). */
export type VideoPageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Page template (ID: {D8B293AF-EF88-47AA-945B-7A058BDAF096}). */
export type VideoPageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Page template (ID: {D8B293AF-EF88-47AA-945B-7A058BDAF096}). */
export type VideoPageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/Video Parameters template (ID: {A0A85463-C88D-454D-8CCD-FDA3CA5B409B}). */
export type VideoParameters = GridParameters & ICacheable & IRenderingId & IStyling & Item & StandardRenderingParameters & {
  __typename?: 'VideoParameters';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** GridParameters (ID: {4321C097-ACE1-4F65-AEAB-B8AC8F3E5356}). */
  gridParameters?: Maybe<TextField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Identifier (ID: {23066E86-8B9E-4AAA-984A-3337135354CC}). */
  renderingIdentifier?: Maybe<TextField>;
  /** Reset Caching Options (ID: {4052C61F-E8C7-4B08-B7DD-211BB1AED14B}). */
  resetCachingOptions?: Maybe<CheckboxField>;
  /** Styles (ID: {04CF61B4-08ED-463D-A54F-1E370785423B}). */
  styles?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/Video Parameters template (ID: {A0A85463-C88D-454D-8CCD-FDA3CA5B409B}). */
export type VideoParametersAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/Video Parameters template (ID: {A0A85463-C88D-454D-8CCD-FDA3CA5B409B}). */
export type VideoParametersChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/Video Parameters template (ID: {A0A85463-C88D-454D-8CCD-FDA3CA5B409B}). */
export type VideoParametersFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/Video Parameters template (ID: {A0A85463-C88D-454D-8CCD-FDA3CA5B409B}). */
export type VideoParametersFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/Video Parameters template (ID: {A0A85463-C88D-454D-8CCD-FDA3CA5B409B}). */
export type VideoParametersHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Media/Rendering Parameters/Video Parameters template (ID: {A0A85463-C88D-454D-8CCD-FDA3CA5B409B}). */
export type VideoParametersIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Video Parameters Template template (ID: {B6A9E0FC-6184-400E-8BD8-9FA235CF6A94}). */
export type VideoParametersTemplate = Item & StandardRenderingParameters & _BaseRenderingParameters & {
  __typename?: 'VideoParametersTemplate';
  /** Additional Parameters (ID: {485E33D4-79F1-428F-8258-2CB29BB7CC6B}). */
  additionalParameters?: Maybe<NameValueListField>;
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
  /** CSSStyles (ID: {41577EC4-3840-45BF-91EB-98CF0438A34F}). */
  cSSStyles?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** Data Source (ID: {0793DCFF-0EE7-48AD-B9D4-EF1DD24EB59B}). */
  dataSource?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** maxVideoCount (ID: {A352F874-4062-4102-ACE1-33680D3C1160}). */
  maxVideoCount?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Placeholder (ID: {E42027F4-766D-45A7-8CF4-29E5C94326F7}). */
  placeholder?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Video Parameters Template template (ID: {B6A9E0FC-6184-400E-8BD8-9FA235CF6A94}). */
export type VideoParametersTemplateAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Video Parameters Template template (ID: {B6A9E0FC-6184-400E-8BD8-9FA235CF6A94}). */
export type VideoParametersTemplateChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Video Parameters Template template (ID: {B6A9E0FC-6184-400E-8BD8-9FA235CF6A94}). */
export type VideoParametersTemplateFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Video Parameters Template template (ID: {B6A9E0FC-6184-400E-8BD8-9FA235CF6A94}). */
export type VideoParametersTemplateFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Video Parameters Template template (ID: {B6A9E0FC-6184-400E-8BD8-9FA235CF6A94}). */
export type VideoParametersTemplateHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Rendering Parameters/Video Parameters Template template (ID: {B6A9E0FC-6184-400E-8BD8-9FA235CF6A94}). */
export type VideoParametersTemplateIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Press Release Page template (ID: {29171DC1-F659-434A-9793-8EDD14499B36}). */
export type VideoPressReleasePage = AbrdnPage & BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f & Item & _BasePage & _BasePressRelease & _Designable & _FundMetadataPage & _MetadataPage & _Navigable & _NavigablePage & _PressReleaseContentType & _SharedPage & _Sitemap & _Taggable & _VideoPressRelease & {
  __typename?: 'VideoPressReleasePage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** duration (ID: {809C7EAF-5258-4877-A44C-4FE3A4629C7E}). */
  duration?: Maybe<IntegerField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Press Release Page template (ID: {29171DC1-F659-434A-9793-8EDD14499B36}). */
export type VideoPressReleasePageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Press Release Page template (ID: {29171DC1-F659-434A-9793-8EDD14499B36}). */
export type VideoPressReleasePageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Press Release Page template (ID: {29171DC1-F659-434A-9793-8EDD14499B36}). */
export type VideoPressReleasePageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Press Release Page template (ID: {29171DC1-F659-434A-9793-8EDD14499B36}). */
export type VideoPressReleasePageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Press Release Page template (ID: {29171DC1-F659-434A-9793-8EDD14499B36}). */
export type VideoPressReleasePageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Project/Aberdeen/Web/Pages/Video Press Release Page template (ID: {29171DC1-F659-434A-9793-8EDD14499B36}). */
export type VideoPressReleasePageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video template (ID: {4BC64961-0A89-4242-BE2D-C5026090CF49}). */
export type Video_4bc649610a894242be2dc5026090cf49 = Item & {
  __typename?: 'Video_4bc649610a894242be2dc5026090cf49';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** description (ID: {EFF8EC63-6CD6-45A6-A0BB-933EB4488A37}). */
  description?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** playlistID (ID: {C5CB8B3D-0D02-4E5E-A6E9-7CCCC06519DE}). */
  playlistID?: Maybe<TextField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** title (ID: {33CD6A1A-2F82-48D0-A7D4-83DD4943456B}). */
  title?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
  /** videoID (ID: {D5942CD4-9010-4689-AE67-B1FD583E0037}). */
  videoID?: Maybe<TextField>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video template (ID: {4BC64961-0A89-4242-BE2D-C5026090CF49}). */
export type Video_4bc649610a894242be2dc5026090cf49AncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video template (ID: {4BC64961-0A89-4242-BE2D-C5026090CF49}). */
export type Video_4bc649610a894242be2dc5026090cf49ChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video template (ID: {4BC64961-0A89-4242-BE2D-C5026090CF49}). */
export type Video_4bc649610a894242be2dc5026090cf49FieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video template (ID: {4BC64961-0A89-4242-BE2D-C5026090CF49}). */
export type Video_4bc649610a894242be2dc5026090cf49FieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video template (ID: {4BC64961-0A89-4242-BE2D-C5026090CF49}). */
export type Video_4bc649610a894242be2dc5026090cf49HasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/PageContent/Datasource/Video/Video template (ID: {4BC64961-0A89-4242-BE2D-C5026090CF49}). */
export type Video_4bc649610a894242be2dc5026090cf49IdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_Arguments template (ID: {703641F5-1F48-4DD9-9DCB-F7BBEA265937}). */
export type _Arguments = {
  /** Arguments (ID: {E830AF53-210B-4981-B6A8-F8939F587EB1}). */
  arguments?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_Arguments template (ID: {33FAB87C-D52F-4431-9A1F-589BA7C1E287}). */
export type _Arguments_33fab87cd52f44319a1f589ba7c1e287 = {
  /** Arguments (ID: {58ACA5CA-742A-41BB-866F-CFA3764200C8}). */
  arguments?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Article template (ID: {5AA69853-066D-416A-9FFF-E7B0A0B1E245}). Also implements _InternalArticle, _BaseArticle, _PremiumContentPage, _SharedPage, _ContentType, _LimitedDisplay. */
export type _Article = {
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** Populated automatically during publish */
  duration?: Maybe<IntegerField>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_AssetServiceThemeMode template (ID: {3763E103-174C-4D1C-A3D7-8BBD02582BE1}). */
export type _AssetServiceThemeMode = {
  /** Mode (ID: {4D0E825C-D503-42FF-A96F-1949F6259FD0}). */
  mode?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Assets Optimization template (ID: {CA64FCD7-7CA9-415A-824B-28B0FEAC1EF7}). */
export type _AssetsOptimization = Item & {
  __typename?: '_AssetsOptimization';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Scripts Optimizing Enabled (ID: {4094E091-CF77-4BB1-A004-ADA2E2FCB267}). */
  scriptsOptimizingEnabled?: Maybe<TextField>;
  /** Styles Optimizing Enabled (ID: {E75A4228-26CD-4823-90A6-8D6C58A80CF3}). */
  stylesOptimizingEnabled?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Assets Optimization template (ID: {CA64FCD7-7CA9-415A-824B-28B0FEAC1EF7}). */
export type _AssetsOptimizationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Assets Optimization template (ID: {CA64FCD7-7CA9-415A-824B-28B0FEAC1EF7}). */
export type _AssetsOptimizationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Assets Optimization template (ID: {CA64FCD7-7CA9-415A-824B-28B0FEAC1EF7}). */
export type _AssetsOptimizationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Assets Optimization template (ID: {CA64FCD7-7CA9-415A-824B-28B0FEAC1EF7}). */
export type _AssetsOptimizationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Assets Optimization template (ID: {CA64FCD7-7CA9-415A-824B-28B0FEAC1EF7}). */
export type _AssetsOptimizationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Assets Optimization template (ID: {CA64FCD7-7CA9-415A-824B-28B0FEAC1EF7}). */
export type _AssetsOptimizationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Background Image template (ID: {F09CFB6D-7E3D-4C65-8AA8-85281A59940E}). */
export type _BackgroundImage = Item & {
  __typename?: '_BackgroundImage';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Background Image (ID: {3D872A4A-83F3-428F-83C1-9B6110389A75}). */
  backgroundImage?: Maybe<ImageField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Stretch mode (ID: {A9592843-F684-4A92-B2CE-BA3FEA432A05}). */
  stretchMode?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Background Image template (ID: {F09CFB6D-7E3D-4C65-8AA8-85281A59940E}). */
export type _BackgroundImageAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Background Image template (ID: {F09CFB6D-7E3D-4C65-8AA8-85281A59940E}). */
export type _BackgroundImageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Background Image template (ID: {F09CFB6D-7E3D-4C65-8AA8-85281A59940E}). */
export type _BackgroundImageFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Background Image template (ID: {F09CFB6D-7E3D-4C65-8AA8-85281A59940E}). */
export type _BackgroundImageFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Background Image template (ID: {F09CFB6D-7E3D-4C65-8AA8-85281A59940E}). */
export type _BackgroundImageHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Background Image template (ID: {F09CFB6D-7E3D-4C65-8AA8-85281A59940E}). */
export type _BackgroundImageIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle template (ID: {70945527-D09E-4CC5-A30A-364324CBFCCF}). Also implements _SharedPage, _ContentType, _LimitedDisplay. */
export type _BaseArticle = {
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseHelpArticle template (ID: {D3BECD5C-437B-44C8-BF7F-FB15BB5CA09B}). Also implements _SharedPage. */
export type _BaseHelpArticle = {
  /** helpPlatform (ID: {6D132CC4-961D-4DE6-94F4-C99A8DD8EE64}). */
  helpPlatform?: Maybe<MultilistField>;
  /** helpStrapline (ID: {20C18889-078D-4483-B837-E8CC2CEAD74E}). */
  helpStrapline?: Maybe<TextField>;
  /** helpTag (ID: {212899C9-5810-4BF4-8EEF-D957FBE30EB7}). */
  helpTag?: Maybe<LookupField>;
  /** helpTitle (ID: {8602E54D-E233-4F77-8083-C5023808D8DB}). */
  helpTitle?: Maybe<TextField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Fund/Pages/_BaseInvestmentTrust template (ID: {27F30130-B0DA-40CD-A8CB-654469C5377D}). */
export type _BaseInvestmentTrust = {
  /** trustAssetClass (ID: {34893A4D-3273-4069-8012-71D96C4D46A7}). */
  trustAssetClass?: Maybe<LookupField>;
  /** trustDescription (ID: {23A43E10-8A30-4C8A-A3A8-691D2B2D0D03}). */
  trustDescription?: Maybe<TextField>;
  /** trustId (ID: {EDBD21FE-E562-481E-B05D-8A0765158488}). */
  trustId?: Maybe<TextField>;
  /** trustImage (ID: {1D4C60A3-C121-4758-A634-7466B8C4CFFA}). */
  trustImage?: Maybe<ImageField>;
  /** If checked, trust will not appear on Trust Finder page. */
  trustIsHidden?: Maybe<CheckboxField>;
  /** trustLink (ID: {7A8A011D-72D1-4431-83D8-4220FB5B3AC8}). */
  trustLink?: Maybe<LinkField>;
  /** trustName (ID: {FD13EAF9-DC56-412A-9F46-4A223FE05029}). */
  trustName?: Maybe<TextField>;
  /** trustRegion (ID: {A53FE6EB-699C-49B0-8FA8-59172AAC6E1B}). */
  trustRegion?: Maybe<LookupField>;
  /** trustStyle (ID: {B117229B-0780-4447-858D-94B815A50560}). */
  trustStyle?: Maybe<LookupField>;
  /** trustType (ID: {752F80B1-AA76-43CD-B6C3-D57B0AD59093}). */
  trustType?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/_Base JSS Tenant template (ID: {053E9155-3993-42F3-9182-5854DC5355B3}). */
export type _BaseJssTenant = {
  /** BranchesFolder (ID: {C5DBB136-3299-4835-A8CE-BCA8B49BA3FA}). */
  branchesFolder?: Maybe<LookupField>;
  /** PlaceholderSettingsFolder (ID: {102B58DA-2A86-4953-B3CD-C9F91256B657}). */
  placeholderSettingsFolder?: Maybe<LookupField>;
  /** RenderingsFolder (ID: {853B245F-53E4-4EBE-BAB5-299F9DE314B6}). */
  renderingsFolder?: Maybe<LookupField>;
  /** SettingsFolder (ID: {B6953F8B-56D3-4C90-A6DB-885786711E4A}). */
  settingsFolder?: Maybe<LookupField>;
};

/** /sitecore/templates/Project/Aberdeen/Web/BasePage/_BasePage template (ID: {1BB7E7CE-5D73-4F7D-8D73-A0702002CBDB}). Also implements Route, _NavigablePage, _MetadataPage. */
export type _BasePage = {
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Page Design template (ID: {0407560F-387B-4A90-ADBE-398B077890E9}). */
export type _BasePageDesign = {
  /** PartialDesigns (ID: {0966B999-0D0E-4278-ACC9-9DA69D461FE6}). */
  partialDesigns?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Base/_Base Partial Design template (ID: {642BDD94-EED5-4B51-B27C-C9543FAB663F}). */
export type _BasePartialDesign = {
  /** Base Partial Design (ID: {76A92454-C8BE-479B-B260-26AEBCED5A1A}). */
  basePartialDesign?: Maybe<LookupField>;
  /** Signature (ID: {55FAAE90-3BBA-4F7F-96FE-13C3F40055FF}). */
  signature?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Placeholder Settings/Base/_Base Placeholder Settings Folder template (ID: {1E73F539-0A2D-4BDC-A7AE-65B223C0DB0A}). */
export type _BasePlaceholderSettingsFolder = {
  /** TemplateForCreation (ID: {30D2A0D2-7A60-4F32-86A9-4AA50BFAB87B}). */
  templateForCreation?: Maybe<LookupField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_BasePressRelease template (ID: {94E1D501-8642-4DCF-9CEA-A0EE86451733}). Also implements _SharedPage, _PressReleaseContentType. */
export type _BasePressRelease = {
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/Rendering Parameters/_BaseRenderingParameters template (ID: {72EBD589-471F-444D-9345-539B2166A196}). */
export type _BaseRenderingParameters = {
  /** anchorId (ID: {7B3F90D6-E929-4718-9A73-B33397E86EC0}). */
  anchorId?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Settings template (ID: {6D8FF35B-49FA-4896-B370-EB35D6B99F3F}). */
export type _BaseSettings = {
  /** Templates (ID: {E8881464-38AF-4655-BE4A-EE10586578A2}). */
  templates?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Shared Sites Settings template (ID: {A91551CF-CEAB-4299-A2C6-E75DBA0F28AD}). */
export type _BaseSharedSitesSettings = {
  /** Delegated Areas (ID: {D5E1CC0E-0D69-4A31-8321-13994D5ACCF6}). */
  delegatedAreas?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Site Definition template (ID: {2BB25752-B3BC-4F13-B9CB-38B906D21A33}). */
export type _BaseSiteDefinition = {
  /** Database (ID: {A7803A5D-CD03-4EDA-ABED-1D9AF4BF6660}). */
  database_a7803a5dcd034edaabed1d9af4bf6660?: Maybe<TextField>;
  /** Environment (ID: {DA06D09E-02B6-464A-80FC-9D8D7FC875E3}). */
  environment?: Maybe<TextField>;
  /** ErrorPageUrl (ID: {76DE376A-A332-46F8-8CAF-A59E557DFEFD}). */
  errorPageUrl?: Maybe<TextField>;
  /** ExternalPort (ID: {FA273891-D5D0-41DF-A713-ADEA620D7732}). */
  externalPort?: Maybe<IntegerField>;
  /** FieldLanguageFallback (ID: {6E6DA5B0-8D01-4514-B7DD-1940AFF3E8CD}). */
  fieldLanguageFallback?: Maybe<CheckboxField>;
  /** FilteredItemsCacheSize (ID: {42DDBE59-96DF-4C83-BB22-0F739A603B3D}). */
  filteredItemsCacheSize?: Maybe<IntegerField>;
  /** HostName (ID: {8E0DD914-9AFB-4D45-BF8B-7FF5D6E5337E}). */
  hostName?: Maybe<TextField>;
  /** ItemLanguageFallback (ID: {8C436235-B85D-4097-89CF-D5A4FA70CC0A}). */
  itemLanguageFallback?: Maybe<CheckboxField>;
  /** ItemNotFoundUrl (ID: {7B32B669-0B70-4FFA-A264-247B97DE8571}). */
  itemNotFoundUrl?: Maybe<TextField>;
  /** Language Embedding (ID: {4E9E2AE5-36DB-4955-9AF1-5A1934A27C7D}). */
  languageEmbedding?: Maybe<CheckboxField>;
  /** Language (ID: {F19277FE-1B85-4B0A-8C26-5E74D766B3A3}). */
  language_f19277fe1b854b0a8c265e74d766b3a3?: Maybe<TextField>;
  /** LinkProvider (ID: {822CC751-5C96-4A43-B687-FF4786A6EBA2}). */
  linkProvider?: Maybe<TextField>;
  /** OtherProperties (ID: {301E719A-6F65-4874-B565-A953A7B5AC83}). */
  otherProperties?: Maybe<NameValueListField>;
  /** Port (ID: {1BF930DC-11E1-4103-9001-59562B698C96}). */
  port?: Maybe<IntegerField>;
  /** Scheme (ID: {B59E43AB-84DA-49F3-87A1-D2FCF648365B}). */
  scheme?: Maybe<TextField>;
  /** SiteName (ID: {CB4E9E2E-2B66-43DC-AD3F-9CAF363D28D3}). */
  siteName?: Maybe<TextField>;
  /** StartItem (ID: {1EE576AF-BA8E-4312-9FBD-2CCF8395BAA1}). */
  startItem?: Maybe<LookupField>;
  /** SxaLinkable (ID: {4EEFF055-EDCD-4387-9E86-C3F40A15DBAC}). */
  sxaLinkable?: Maybe<CheckboxField>;
  /** TargetHostName (ID: {E5B5CCB5-17A1-429D-BD3E-6122B3216E52}). */
  targetHostName?: Maybe<TextField>;
  /** VirtualFolder (ID: {475031D8-724D-463C-80B2-90839DD1AD98}). */
  virtualFolder?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Base Tenant template (ID: {78180355-F0A2-4161-A34C-3069A9E17539}). Also implements _SitecoreClientSiteManaging. */
export type _BaseTenant = {
  /** MediaLibrary (ID: {E90A4413-C111-4951-9B6A-00C4CE7FB289}). */
  mediaLibrary?: Maybe<LookupField>;
  /** SharedMediaLibrary (ID: {800DC4ED-0846-45BA-B112-19902AF240F6}). */
  sharedMediaLibrary?: Maybe<LookupField>;
  /** SharedSites (ID: {7D29B525-8118-45C6-A89B-773A6A576EC7}). */
  sharedSites?: Maybe<MultilistField>;
  /** Templates (ID: {9C596379-F8D4-45D1-A064-CDF1EDE2E7C7}). */
  templates?: Maybe<LookupField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/JSON/CORS/_CORS template (ID: {BCA87769-ED10-4622-B84D-1C879C8253EE}). */
export type _Cors = {
  /** The Access-Control-Allow-Credentials header indicates whether or not the response to the request can be exposed when the credentials flag is set to true.  When used as part of a response to a preflight request, this indicates whether or not the actual request can be made using credentials. Simple GET requests are not preflighted, and so if a request is made for a resource with credentials, if this header is not returned with the resource, the response is ignored by the browser and not returned to web content. */
  allowCredentials?: Maybe<CheckboxField>;
  /** The Access-Control-Allow-Headers header is used in response to a preflight request to indicate which HTTP headers can be used when making the actual request. */
  allowHeaders?: Maybe<TextField>;
  /** The Access-Control-Allow-Methods header specifies the method or methods allowed when accessing the resource. This is used in response to a preflight request. */
  allowMethods?: Maybe<TextField>;
  /** The origin parameter specifies a URI that may access the resource. The browser must enforce this. For requests without credentials, the server may specify "*" as a wildcard, thereby allowing any origin to access the resource. */
  allowOrigin?: Maybe<TextField>;
  /** The Access-Control-Expose-Headers header lets a server whitelist headers that browsers are allowed to access. */
  exposeHeaders?: Maybe<TextField>;
  /** The  Access-Control-Max-Age header indicates how long the results of a preflight request can be cached. */
  maxAge?: Maybe<IntegerField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Compatible themes template (ID: {C6E5A68F-8493-42F3-A8B4-C7FA8A5FB31D}). */
export type _CompatibleThemes = Item & {
  __typename?: '_CompatibleThemes';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Themes (ID: {BEEEDE03-AB13-4558-96F9-C3E8957B46F8}). */
  themes?: Maybe<MultilistField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Compatible themes template (ID: {C6E5A68F-8493-42F3-A8B4-C7FA8A5FB31D}). */
export type _CompatibleThemesAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Compatible themes template (ID: {C6E5A68F-8493-42F3-A8B4-C7FA8A5FB31D}). */
export type _CompatibleThemesChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Compatible themes template (ID: {C6E5A68F-8493-42F3-A8B4-C7FA8A5FB31D}). */
export type _CompatibleThemesFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Compatible themes template (ID: {C6E5A68F-8493-42F3-A8B4-C7FA8A5FB31D}). */
export type _CompatibleThemesFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Compatible themes template (ID: {C6E5A68F-8493-42F3-A8B4-C7FA8A5FB31D}). */
export type _CompatibleThemesHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Compatible themes template (ID: {C6E5A68F-8493-42F3-A8B4-C7FA8A5FB31D}). */
export type _CompatibleThemesIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Composites/_Composite Theme template (ID: {E34966E9-E83A-4C9C-A191-6B54B8DE0254}). */
export type _CompositeTheme = Item & {
  __typename?: '_CompositeTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CompositeTheme (ID: {05E03A40-4B4A-4AD8-8F86-E29DA6FEADB3}). */
  compositeTheme?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/_Composite Theme template (ID: {E34966E9-E83A-4C9C-A191-6B54B8DE0254}). */
export type _CompositeThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/_Composite Theme template (ID: {E34966E9-E83A-4C9C-A191-6B54B8DE0254}). */
export type _CompositeThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/_Composite Theme template (ID: {E34966E9-E83A-4C9C-A191-6B54B8DE0254}). */
export type _CompositeThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/_Composite Theme template (ID: {E34966E9-E83A-4C9C-A191-6B54B8DE0254}). */
export type _CompositeThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/_Composite Theme template (ID: {E34966E9-E83A-4C9C-A191-6B54B8DE0254}). */
export type _CompositeThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Composites/_Composite Theme template (ID: {E34966E9-E83A-4C9C-A191-6B54B8DE0254}). */
export type _CompositeThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Content template (ID: {5A864363-5902-4CDB-8421-9B8AE7C1A013}). */
export type _Content = {
  /** Content (ID: {7152697D-E946-4EC4-AAD5-223FCC204CE7}). */
  content?: Maybe<RichTextField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_Content Type template (ID: {F6E9AFEA-6400-4659-A307-70253B8ED128}). */
export type _ContentType = {
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Custom Metadata template (ID: {A5F4B9CC-25D9-4EDA-A63D-E4CD0C6C6E24}). */
export type _CustomMetadata = Item & {
  __typename?: '_CustomMetadata';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Attributes (ID: {82F4BD76-0837-4E55-A1F6-15231096B2B9}). */
  attributes?: Maybe<NameValueListField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Custom Metadata template (ID: {A5F4B9CC-25D9-4EDA-A63D-E4CD0C6C6E24}). */
export type _CustomMetadataAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Custom Metadata template (ID: {A5F4B9CC-25D9-4EDA-A63D-E4CD0C6C6E24}). */
export type _CustomMetadataChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Custom Metadata template (ID: {A5F4B9CC-25D9-4EDA-A63D-E4CD0C6C6E24}). */
export type _CustomMetadataFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Custom Metadata template (ID: {A5F4B9CC-25D9-4EDA-A63D-E4CD0C6C6E24}). */
export type _CustomMetadataFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Custom Metadata template (ID: {A5F4B9CC-25D9-4EDA-A63D-E4CD0C6C6E24}). */
export type _CustomMetadataHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Custom Metadata template (ID: {A5F4B9CC-25D9-4EDA-A63D-E4CD0C6C6E24}). */
export type _CustomMetadataIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/MVC/_CustomRenderingViewPath template (ID: {46B0CB86-9B0F-4650-A06A-2E1CAC0F2ADC}). */
export type _CustomRenderingViewPath = Item & {
  __typename?: '_CustomRenderingViewPath';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** CustomRenderingViewPath (ID: {F463BA14-28B5-4972-BE33-9954025BD0BA}). */
  customRenderingViewPath?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/_CustomRenderingViewPath template (ID: {46B0CB86-9B0F-4650-A06A-2E1CAC0F2ADC}). */
export type _CustomRenderingViewPathAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/_CustomRenderingViewPath template (ID: {46B0CB86-9B0F-4650-A06A-2E1CAC0F2ADC}). */
export type _CustomRenderingViewPathChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/_CustomRenderingViewPath template (ID: {46B0CB86-9B0F-4650-A06A-2E1CAC0F2ADC}). */
export type _CustomRenderingViewPathFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/_CustomRenderingViewPath template (ID: {46B0CB86-9B0F-4650-A06A-2E1CAC0F2ADC}). */
export type _CustomRenderingViewPathFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/_CustomRenderingViewPath template (ID: {46B0CB86-9B0F-4650-A06A-2E1CAC0F2ADC}). */
export type _CustomRenderingViewPathHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/MVC/_CustomRenderingViewPath template (ID: {46B0CB86-9B0F-4650-A06A-2E1CAC0F2ADC}). */
export type _CustomRenderingViewPathIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Data Attributes template (ID: {74E42A46-5955-4990-BDA5-695F42A8A94D}). */
export type _DataAttributes = {
  /** Adds a data attribute to the HTML element generated by the rendering variant item. */
  dataAttributes?: Maybe<NameValueListField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Datasource Behaviour template (ID: {35EBD280-C9BE-4E49-BFAE-F90A32C019DD}). */
export type _DatasourceBehaviour = Item & {
  __typename?: '_DatasourceBehaviour';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DatasourceBehaviour (ID: {332A4C4E-222D-4A94-ABCC-79F92F3B7B4B}). */
  datasourceBehaviour?: Maybe<TextField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Datasource Behaviour template (ID: {35EBD280-C9BE-4E49-BFAE-F90A32C019DD}). */
export type _DatasourceBehaviourAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Datasource Behaviour template (ID: {35EBD280-C9BE-4E49-BFAE-F90A32C019DD}). */
export type _DatasourceBehaviourChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Datasource Behaviour template (ID: {35EBD280-C9BE-4E49-BFAE-F90A32C019DD}). */
export type _DatasourceBehaviourFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Datasource Behaviour template (ID: {35EBD280-C9BE-4E49-BFAE-F90A32C019DD}). */
export type _DatasourceBehaviourFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Datasource Behaviour template (ID: {35EBD280-C9BE-4E49-BFAE-F90A32C019DD}). */
export type _DatasourceBehaviourHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Datasource Behaviour template (ID: {35EBD280-C9BE-4E49-BFAE-F90A32C019DD}). */
export type _DatasourceBehaviourIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Dependencies template (ID: {39549BEF-2C0D-48F8-AF7C-F406241D4FE6}). */
export type _Dependencies = {
  /** Dependencies (ID: {40DEEE2F-7595-40BD-B2C9-51F9E2346100}). */
  dependencies?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Description template (ID: {79CBA7D0-EE47-4FC6-911C-9BCCAFCAAC2E}). */
export type _Description = {
  /** Description (ID: {89CECF4F-E545-44F2-813D-272C08661D14}). */
  description?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Design Template Mapping template (ID: {71B1F3CD-4460-430F-82EC-9CE310ABCB7C}). */
export type _DesignTemplateMapping = {
  /** DesignRules (ID: {23C23F7B-2C76-4D3C-9B88-16B7A6D52D89}). */
  designRules?: Maybe<TextField>;
  /** TemplatesMapping (ID: {BA1F60D6-3DEB-40CC-BB61-EEC772279EE1}). */
  templatesMapping?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/_Designable template (ID: {6650FB34-7EA1-4245-A919-5CC0F002A6D7}). */
export type _Designable = {
  /** Page Design (ID: {24171BF1-C0E1-480E-BE76-4C0A1876F916}). */
  pageDesign?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditTenantTemplate/_EditType template (ID: {ED18E119-680E-489B-9FEF-6D8C9CDFA37C}). */
export type _EditType = {
  /** EditType (ID: {614F52CF-D54B-47D1-A242-D9A7D42860F4}). */
  editType?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/EditSiteItem/_EditType template (ID: {8A9F84BA-AA12-4C5D-9096-935714809DA4}). */
export type _EditType_8a9f84baaa124c5d9096935714809da4 = {
  /** EditType (ID: {76691B61-8692-4D98-A4FF-115BA4208AB6}). */
  editType?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Editing/_Editing Theme template (ID: {6175F4C7-F87F-4F7F-928E-4C5CA5DFFAF4}). */
export type _EditingTheme = {
  /** EditingTheme (ID: {AF332C24-FE17-41E7-8CAF-8E64C588FE72}). */
  editingTheme?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Enabled template (ID: {767CCF52-E761-430A-8036-7631B93B3CAC}). */
export type _Enabled = {
  /** Enabled (ID: {4B475746-CF34-4C06-97C8-7A8B0B40064F}). */
  enabled?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Error Handling/_Error Handling template (ID: {CBC14160-BED0-4AA2-9387-4C13179205B9}). */
export type _ErrorHandling = {
  /** Error404Page (ID: {96E5E297-6FD1-46D6-8E92-B03E33A9376C}). */
  error404Page?: Maybe<TextField>;
  /** Error500Page (ID: {D91BF82C-0E2B-4B79-AE85-E54B9AFD5026}). */
  error500Page?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_ExternalArticle template (ID: {9BF4E2D8-EFB1-413A-957A-2E427D9A5F81}). Also implements _BaseArticle, _SharedPage, _ContentType, _LimitedDisplay. */
export type _ExternalArticle = {
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** articleUrl (ID: {03D20238-CFFC-4238-AB29-21DB4996DABF}). */
  articleUrl?: Maybe<LinkField>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Favicon template (ID: {03CA361C-8524-4505-8EED-2DF7E3C37159}). */
export type _Favicon = Item & {
  __typename?: '_Favicon';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Favicon (ID: {B31A3B74-D75C-477A-BE16-F44C4593DFE9}). */
  favicon?: Maybe<ImageField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Favicon template (ID: {03CA361C-8524-4505-8EED-2DF7E3C37159}). */
export type _FaviconAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Favicon template (ID: {03CA361C-8524-4505-8EED-2DF7E3C37159}). */
export type _FaviconChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Favicon template (ID: {03CA361C-8524-4505-8EED-2DF7E3C37159}). */
export type _FaviconFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Favicon template (ID: {03CA361C-8524-4505-8EED-2DF7E3C37159}). */
export type _FaviconFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Favicon template (ID: {03CA361C-8524-4505-8EED-2DF7E3C37159}). */
export type _FaviconHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Favicon template (ID: {03CA361C-8524-4505-8EED-2DF7E3C37159}). */
export type _FaviconIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Fields template (ID: {CD702887-E232-41F8-9FFC-8F70CD8B4B28}). */
export type _Fields = {
  /** Fields (ID: {AD0E8DE7-F6C1-49FA-B2C4-87E10FBDAA52}). */
  fields_ad0e8de7f6c149fab2c487e10fbdaa52?: Maybe<NameValueListField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_FilteredArticlesWildcard template (ID: {6BCDFCC8-15AC-4B32-8797-7988CA6644B2}). Also implements _WildcardPage, _PageWorkflow, _Statistics. */
export type _FilteredArticlesWildcard = {
  /** criteria (ID: {9BD44868-9AD3-40C0-8DDA-CDFFF6356D72}). */
  criteria?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_Footnotes template (ID: {39099ADC-E4E8-4CD2-98F3-06441525E89E}). */
export type _Footnotes = {
  /** databridgeHoldingsFootnote (ID: {D9BD8C0C-7C9B-4CEF-B6CA-6F9DF0939FC2}). */
  databridgeHoldingsFootnote?: Maybe<RichTextField>;
  /** databridgeKeyInformationFootnote (ID: {8ADED624-9A31-4227-909D-B59EB556FA64}). */
  databridgeKeyInformationFootnote?: Maybe<RichTextField>;
  /** databridgePerformanceFootnote (ID: {1FF1C62A-BBB8-47A1-B29A-71D93EF78E23}). */
  databridgePerformanceFootnote?: Maybe<RichTextField>;
  /** databridgeRiskAnalysisFootnote (ID: {82C18EF2-D617-4B30-8614-9AC2ABEC6789}). */
  databridgeRiskAnalysisFootnote?: Maybe<RichTextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Base/_Forms Folder Location template (ID: {75A9D420-5F3A-4ED8-9AEA-F58DEBB74786}). */
export type _FormsFolderLocation = Item & {
  __typename?: '_FormsFolderLocation';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** FormsFolderLocation (ID: {BD094ADF-1E7F-4F1B-8300-8D8248ED4600}). */
  formsFolderLocation?: Maybe<LookupField>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Base/_Forms Folder Location template (ID: {75A9D420-5F3A-4ED8-9AEA-F58DEBB74786}). */
export type _FormsFolderLocationAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Base/_Forms Folder Location template (ID: {75A9D420-5F3A-4ED8-9AEA-F58DEBB74786}). */
export type _FormsFolderLocationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Base/_Forms Folder Location template (ID: {75A9D420-5F3A-4ED8-9AEA-F58DEBB74786}). */
export type _FormsFolderLocationFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Base/_Forms Folder Location template (ID: {75A9D420-5F3A-4ED8-9AEA-F58DEBB74786}). */
export type _FormsFolderLocationFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Base/_Forms Folder Location template (ID: {75A9D420-5F3A-4ED8-9AEA-F58DEBB74786}). */
export type _FormsFolderLocationHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/Sitecore Forms/Base/_Forms Folder Location template (ID: {75A9D420-5F3A-4ED8-9AEA-F58DEBB74786}). */
export type _FormsFolderLocationIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_FundFormAvailability template (ID: {F4697982-8E26-4010-B364-73162C0120D6}). */
export type _FundFormAvailability = {
  /** applicableFunds (ID: {D5891DA4-76A3-4C2A-9B6B-E002FD5BC978}). */
  applicableFunds?: Maybe<TextField>;
  /** formAuthorizations (ID: {261F0149-9EA4-4257-B36F-E5D912D66AAD}). */
  formAuthorizations?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_FundMetadataPage template (ID: {2C3777F3-CC37-447D-8F20-0AD1DDB8B389}). */
export type _FundMetadataPage = {
  /** pageFundAssetClasses (ID: {E2EECA0A-8F6C-4329-9AAE-80F1350075BC}). */
  pageFundAssetClasses?: Maybe<MultilistField>;
  /** pageFundCapabilities (ID: {13F88561-2457-4770-95CA-75D4986B767E}). */
  pageFundCapabilities?: Maybe<MultilistField>;
  /** pageFundSubAssetClasses (ID: {B7D81C75-AFCC-4138-B18E-BF8D260F9D43}). */
  pageFundSubAssetClasses?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_FundSettings template (ID: {7BD0DF0F-A8A4-41AE-BEC4-9383A7B46B08}). */
export type _FundSettings = Item & {
  __typename?: '_FundSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_FundSettings template (ID: {7BD0DF0F-A8A4-41AE-BEC4-9383A7B46B08}). */
export type _FundSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_FundSettings template (ID: {7BD0DF0F-A8A4-41AE-BEC4-9383A7B46B08}). */
export type _FundSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_FundSettings template (ID: {7BD0DF0F-A8A4-41AE-BEC4-9383A7B46B08}). */
export type _FundSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_FundSettings template (ID: {7BD0DF0F-A8A4-41AE-BEC4-9383A7B46B08}). */
export type _FundSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_FundSettings template (ID: {7BD0DF0F-A8A4-41AE-BEC4-9383A7B46B08}). */
export type _FundSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_FundSettings template (ID: {7BD0DF0F-A8A4-41AE-BEC4-9383A7B46B08}). */
export type _FundSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Grid/_Grid Mapping template (ID: {9D81C61A-0341-4312-816D-E5204385EA3C}). */
export type _GridMapping = {
  /** Grid Mapping (ID: {AD84CC6B-32EF-49D8-9326-916976CB2520}). */
  gridMapping?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Content Validation/_HasValidUrlName template (ID: {0A7DA0A0-FCD9-4B7B-A725-E159FA3E7E6C}). */
export type _HasValidUrlName = Item & {
  __typename?: '_HasValidUrlName';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Content Validation/_HasValidUrlName template (ID: {0A7DA0A0-FCD9-4B7B-A725-E159FA3E7E6C}). */
export type _HasValidUrlNameAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Content Validation/_HasValidUrlName template (ID: {0A7DA0A0-FCD9-4B7B-A725-E159FA3E7E6C}). */
export type _HasValidUrlNameChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Content Validation/_HasValidUrlName template (ID: {0A7DA0A0-FCD9-4B7B-A725-E159FA3E7E6C}). */
export type _HasValidUrlNameFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Content Validation/_HasValidUrlName template (ID: {0A7DA0A0-FCD9-4B7B-A725-E159FA3E7E6C}). */
export type _HasValidUrlNameFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Content Validation/_HasValidUrlName template (ID: {0A7DA0A0-FCD9-4B7B-A725-E159FA3E7E6C}). */
export type _HasValidUrlNameHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Content Validation/_HasValidUrlName template (ID: {0A7DA0A0-FCD9-4B7B-A725-E159FA3E7E6C}). */
export type _HasValidUrlNameIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_HelpArticle template (ID: {FB8C307A-8717-4729-BB56-4A437E20DCFA}). Also implements _BaseHelpArticle, _SharedPage. */
export type _HelpArticle = {
  /** helpPlatform (ID: {6D132CC4-961D-4DE6-94F4-C99A8DD8EE64}). */
  helpPlatform?: Maybe<MultilistField>;
  /** helpStrapline (ID: {20C18889-078D-4483-B837-E8CC2CEAD74E}). */
  helpStrapline?: Maybe<TextField>;
  /** helpTag (ID: {212899C9-5810-4BF4-8EEF-D957FBE30EB7}). */
  helpTag?: Maybe<LookupField>;
  /** helpTitle (ID: {8602E54D-E233-4F77-8083-C5023808D8DB}). */
  helpTitle?: Maybe<TextField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Icon template (ID: {E35821CA-6A09-4D40-AA00-C86FC7E2E66E}). */
export type _Icon = {
  /** Icon (ID: {BF2F5042-9481-488D-A389-1B70A0B78ED8}). */
  icon_bf2f50429481488da3891b70a0b78ed8?: Maybe<ImageField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeByDefault template (ID: {DAD67B24-0BAF-461F-9BFC-73DCE99812CC}). */
export type _IncludeByDefault = {
  /** IncludeByDefault (ID: {11488836-D40F-40D4-BEB4-1D31DA7B1470}). */
  includeByDefault?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IncludeIfInstalled template (ID: {54AE044D-062B-4236-856B-F2CF3EE4E3C0}). */
export type _IncludeIfInstalled = {
  /** IncludeIfInstalled (ID: {52A4245C-A3D5-4B23-9F3A-5B33C9811906}). */
  includeIfInstalled?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_InternalArticle template (ID: {C51FCB34-181F-4B4D-A365-2A0995FC9821}). Also implements _BaseArticle, _PremiumContentPage, _SharedPage, _ContentType, _LimitedDisplay. */
export type _InternalArticle = {
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Internet Explorer Compatibility Mode template (ID: {643E3759-5A31-4AB4-BCD7-DC9DA028F1A6}). */
export type _InternetExplorerCompatibilityMode = {
  /** CompatibilityModeEdit (ID: {74F8C14D-559B-40D0-BF52-4C53FA62E7AA}). */
  compatibilityModeEdit?: Maybe<LookupField>;
  /** CompatibilityModePreviewPublic (ID: {A4BAAEBC-8AB7-4038-B6C9-BB7B7D170452}). */
  compatibilityModePreviewPublic?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_IsSystemModule template (ID: {BF489796-633D-46D4-92AA-CC0BD886C841}). */
export type _IsSystemModule = {
  /** IsSystemModule (ID: {06D2C562-9229-4779-8807-E2A5FD2990D4}). */
  isSystemModule?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Json Variants/Base/_JSON Variant Paging template (ID: {F2E87B7C-1567-453C-BE29-8E3C24119070}). */
export type _JsonVariantPaging = {
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** NumberOfResultsToSkip (ID: {79499A55-648D-4B30-A526-13C9F47C3121}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Limited Display/_LimitedDisplay template (ID: {E3EAB662-557C-4B88-8724-4181046BCE80}). */
export type _LimitedDisplay = {
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Link Attributes template (ID: {6CACB1F5-9F58-4C9B-A1C2-F50E82691869}). */
export type _LinkAttributes = {
  /** Adds a link attribute to the link element generated by the rendering variant. */
  linkAttributes?: Maybe<NameValueListField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Link Settings template (ID: {15B2DFA2-6F63-4D58-ACCE-F3CD69C3B310}). */
export type _LinkSettings = {
  /** Link Settings (ID: {E41D2D4B-4C5D-4467-A8D6-0CFA23577501}). */
  linkSettings?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Base/_LocalDataLink template (ID: {9B6DFD34-7101-4BD5-BBFD-3E23CA8A2CAC}). */
export type _LocalDataLink = Item & {
  __typename?: '_LocalDataLink';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** Local data (ID: {DB51D4E9-C24D-4670-AF0E-62C8AA08E2B6}). */
  localData?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Base/_LocalDataLink template (ID: {9B6DFD34-7101-4BD5-BBFD-3E23CA8A2CAC}). */
export type _LocalDataLinkAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Base/_LocalDataLink template (ID: {9B6DFD34-7101-4BD5-BBFD-3E23CA8A2CAC}). */
export type _LocalDataLinkChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Base/_LocalDataLink template (ID: {9B6DFD34-7101-4BD5-BBFD-3E23CA8A2CAC}). */
export type _LocalDataLinkFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Base/_LocalDataLink template (ID: {9B6DFD34-7101-4BD5-BBFD-3E23CA8A2CAC}). */
export type _LocalDataLinkFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Base/_LocalDataLink template (ID: {9B6DFD34-7101-4BD5-BBFD-3E23CA8A2CAC}). */
export type _LocalDataLinkHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Local Datasources/Base/_LocalDataLink template (ID: {9B6DFD34-7101-4BD5-BBFD-3E23CA8A2CAC}). */
export type _LocalDataLinkIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Login template (ID: {8CEDA096-B9B0-4CE7-BC69-A6591C72FCF2}). */
export type _Login = Item & {
  __typename?: '_Login';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** LoginPage (ID: {602AB79D-FC25-4C5B-89D3-27AAEF3BB37C}). */
  loginPage?: Maybe<LookupField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** RequireLogin (ID: {995A8168-A8A9-4563-BDC9-94E3148F8EE8}). */
  requireLogin?: Maybe<CheckboxField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Login template (ID: {8CEDA096-B9B0-4CE7-BC69-A6591C72FCF2}). */
export type _LoginAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Login template (ID: {8CEDA096-B9B0-4CE7-BC69-A6591C72FCF2}). */
export type _LoginChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Login template (ID: {8CEDA096-B9B0-4CE7-BC69-A6591C72FCF2}). */
export type _LoginFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Login template (ID: {8CEDA096-B9B0-4CE7-BC69-A6591C72FCF2}). */
export type _LoginFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Login template (ID: {8CEDA096-B9B0-4CE7-BC69-A6591C72FCF2}). */
export type _LoginHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Login template (ID: {8CEDA096-B9B0-4CE7-BC69-A6591C72FCF2}). */
export type _LoginIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/DataProviders/Settings/DataBridge/_ManualKeyInformation template (ID: {9B597635-0C68-4407-A1D2-D5C15BE428DA}). */
export type _ManualKeyInformation = {
  /** cefFiscalYearEnd (ID: {36090CDB-E822-43AA-A941-8DAD83E90944}). */
  cefFiscalYearEnd?: Maybe<TextField>;
  /** cefGrossExpenseRatio (ID: {A82CC7EA-1832-4169-B963-F4B6A99A04C9}). */
  cefGrossExpenseRatio?: Maybe<TextField>;
  /** cefManagedAssets (ID: {46F2EAC2-858F-4F01-AABF-8899EC39C967}). */
  cefManagedAssets?: Maybe<TextField>;
  /** cefMarketDistributionRate (ID: {49217872-A9FB-411B-9D18-E03AD788C21B}). */
  cefMarketDistributionRate?: Maybe<TextField>;
  /** cefNavDistributionRate (ID: {F9ADB002-5758-410F-90A7-6E7002B4F83E}). */
  cefNavDistributionRate?: Maybe<TextField>;
  /** cefNetAssets (ID: {B5DD3507-1038-40A7-9A09-F2F782DA3EBE}). */
  cefNetAssets?: Maybe<TextField>;
  /** cefNetExpenseRatio (ID: {35D637EF-F66B-452E-B95B-207681B9ED6D}). */
  cefNetExpenseRatio?: Maybe<TextField>;
  /** cefSharesOutstanding (ID: {DC32AA50-4061-41D1-B68E-9D1D7058BC6A}). */
  cefSharesOutstanding?: Maybe<TextField>;
  /** cefTickerSymbol (ID: {FA32E335-E08D-4ED2-A5BF-89E25E7D46C6}). */
  cefTickerSymbol?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_MemberOf template (ID: {F9EB573D-804C-42C2-9C34-22DB80D9FA81}). */
export type _MemberOf = {
  /** MemberOf (ID: {359B28A0-9FAC-4F93-B0F6-DB957CBE5CE9}). */
  memberOf?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/PageContent/Pages/_MetadataPage template (ID: {E67C4DB8-D8FA-4932-A5A4-0E7F6E311A59}). */
export type _MetadataPage = {
  /** The length of meta description field should be less than 161 characters */
  metaDescription?: Maybe<TextField>;
  /** The length of meta title field should be less than 71 character */
  metaTitle?: Maybe<TextField>;
  /** pageTheme (ID: {70336A8C-A941-44A2-BEF6-F37A067BB0D4}). */
  pageTheme?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/_Modules template (ID: {3BC304DB-FE8F-4AA8-B95C-8C331E823F4C}). */
export type _Modules = {
  /** Modules (ID: {1230D2CB-4948-4D43-8A3B-B39978F6F1B3}). */
  modules?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Name template (ID: {600CBACF-7AD5-423E-B5C7-943B8924BA9C}). */
export type _Name = {
  /** Name (ID: {4F886DD0-63DC-4A32-8765-E7FE78B9B0D2}). */
  name_4f886dd063dc4a328765e7fe78b9b0d2?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Name template (ID: {0345FD2F-9509-4DC7-B0F5-6C73A9B6CD8D}). */
export type _Name_0345fd2f95094dc7b0f56c73a9b6cd8d = {
  /** Name (ID: {85A7501A-86D9-4243-9075-0B727C3A6DB4}). */
  name_85a7501a86d9424390750b727c3a6db4?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Name template (ID: {299CDB15-4745-448A-8078-68D401248EAA}). */
export type _Name_299cdb154745448a807868d401248eaa = {
  /** Name (ID: {7868E6BC-525C-4FCE-AB8A-77DA3E09B171}). */
  name_7868e6bc525c4fceab8a77da3e09b171?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Name template (ID: {B88CF881-59A5-4A19-991E-71038751CB60}). */
export type _Name_B88cf88159a54a19991e71038751cb60 = {
  /** Name (ID: {C202067E-7FAB-4606-AFB4-E76DF2185DDC}). */
  name_c202067e7fab4606afb4e76df2185ddc?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Navigation/_Navigable template (ID: {371D5FBB-5498-4D94-AB2B-E3B70EEBE78C}). */
export type _Navigable = {
  /** NavigationClass (ID: {0D83E59A-C3F1-41BE-81B2-762D35E0799F}). */
  navigationClass?: Maybe<LookupField>;
  /** NavigationFilter (ID: {1FBC6A49-6281-48EE-87E9-A3970B145ADB}). */
  navigationFilter?: Maybe<MultilistField>;
  /** NavigationTitle (ID: {4E0720E9-9D50-4DDC-87CF-ECD65E8E94C8}). */
  navigationTitle?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/_NavigablePage template (ID: {3F342971-6FF1-4723-89BD-AEB0EEE0B1CA}). */
export type _NavigablePage = {
  /** navigationTitle (ID: {7527EAEA-4F57-48BC-9AED-66405B30F2A5}). */
  navigationTitle_7527eaea4f5748bc9aed66405b30f2a5?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_OpenGraph Metadata template (ID: {49B99587-1114-4BEB-894B-1455EBDC0C41}). */
export type _OpenGraphMetadata = Item & {
  __typename?: '_OpenGraphMetadata';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** OpenGraphAdmins (ID: {37A25DA2-795F-449E-B004-7205DA942756}). */
  openGraphAdmins?: Maybe<TextField>;
  /** OpenGraphAppId (ID: {5655A025-8A0C-41D2-91D5-12E980F1885D}). */
  openGraphAppId?: Maybe<TextField>;
  /** OpenGraphDescription (ID: {7BDDC8B8-1F77-46D8-9D7F-46E20E041F74}). */
  openGraphDescription?: Maybe<TextField>;
  /** OpenGraphImageUrl (ID: {D8B38DD7-E9A0-4410-9F17-D436B0C8635A}). */
  openGraphImageUrl?: Maybe<ImageField>;
  /** OpenGraphSiteName (ID: {B0F2F11D-F706-41DA-81FE-88EBFACB3B53}). */
  openGraphSiteName?: Maybe<TextField>;
  /** OpenGraphTitle (ID: {7D988161-3991-465A-A88C-280BC65542A0}). */
  openGraphTitle?: Maybe<TextField>;
  /** OpenGraphType (ID: {961CADD8-8F7D-4B12-B0DA-7AF04B54B22D}). */
  openGraphType?: Maybe<TextField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_OpenGraph Metadata template (ID: {49B99587-1114-4BEB-894B-1455EBDC0C41}). */
export type _OpenGraphMetadataAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_OpenGraph Metadata template (ID: {49B99587-1114-4BEB-894B-1455EBDC0C41}). */
export type _OpenGraphMetadataChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_OpenGraph Metadata template (ID: {49B99587-1114-4BEB-894B-1455EBDC0C41}). */
export type _OpenGraphMetadataFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_OpenGraph Metadata template (ID: {49B99587-1114-4BEB-894B-1455EBDC0C41}). */
export type _OpenGraphMetadataFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_OpenGraph Metadata template (ID: {49B99587-1114-4BEB-894B-1455EBDC0C41}). */
export type _OpenGraphMetadataHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_OpenGraph Metadata template (ID: {49B99587-1114-4BEB-894B-1455EBDC0C41}). */
export type _OpenGraphMetadataIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Page Design Theme template (ID: {E105BB00-8920-4B3E-A22C-CEECF36DB614}). */
export type _PageDesignTheme = Item & {
  __typename?: '_PageDesignTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Page Design Theme (ID: {7B487159-E180-4846-BE49-E196E4C3A2B3}). */
  pageDesignTheme?: Maybe<LookupField>;
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Page Design Theme template (ID: {E105BB00-8920-4B3E-A22C-CEECF36DB614}). */
export type _PageDesignThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Page Design Theme template (ID: {E105BB00-8920-4B3E-A22C-CEECF36DB614}). */
export type _PageDesignThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Page Design Theme template (ID: {E105BB00-8920-4B3E-A22C-CEECF36DB614}). */
export type _PageDesignThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Page Design Theme template (ID: {E105BB00-8920-4B3E-A22C-CEECF36DB614}). */
export type _PageDesignThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Page Design Theme template (ID: {E105BB00-8920-4B3E-A22C-CEECF36DB614}). */
export type _PageDesignThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Page Design Theme template (ID: {E105BB00-8920-4B3E-A22C-CEECF36DB614}). */
export type _PageDesignThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Page Search Scope template (ID: {8114D1CE-CB6C-4DC7-930E-173345CB4746}). */
export type _PageSearchScope = Item & {
  __typename?: '_PageSearchScope';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Scope (ID: {ADEFA09C-5378-43E7-9555-332F566E7880}). */
  scope?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Page Search Scope template (ID: {8114D1CE-CB6C-4DC7-930E-173345CB4746}). */
export type _PageSearchScopeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Page Search Scope template (ID: {8114D1CE-CB6C-4DC7-930E-173345CB4746}). */
export type _PageSearchScopeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Page Search Scope template (ID: {8114D1CE-CB6C-4DC7-930E-173345CB4746}). */
export type _PageSearchScopeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Page Search Scope template (ID: {8114D1CE-CB6C-4DC7-930E-173345CB4746}). */
export type _PageSearchScopeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Page Search Scope template (ID: {8114D1CE-CB6C-4DC7-930E-173345CB4746}). */
export type _PageSearchScopeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Page Search Scope template (ID: {8114D1CE-CB6C-4DC7-930E-173345CB4746}). */
export type _PageSearchScopeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Podcast template (ID: {02312FC9-EDE4-40FF-8606-5DA068784F2C}). Also implements _InternalArticle, _BaseArticle, _PremiumContentPage, _SharedPage, _ContentType, _LimitedDisplay. */
export type _Podcast = {
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** duration (ID: {EE25CB28-67AA-4564-8B8B-4A8B7076FFF4}). */
  duration?: Maybe<IntegerField>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PodcastPressRelease template (ID: {B0566D63-A87B-4E89-9155-AA1BAB91FFA8}). Also implements _BasePressRelease, _SharedPage, _PressReleaseContentType. */
export type _PodcastPressRelease = {
  /** duration (ID: {123C45F4-DFB2-4D8D-B942-7FBC333B02BD}). */
  duration?: Maybe<IntegerField>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Premium Content/_PremiumContentPage template (ID: {10D69B80-5773-4E0C-8ABC-7724152A09D0}). */
export type _PremiumContentPage = {
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_PressRelease template (ID: {6B6346A5-78D1-4EBE-828C-85ACBA073AC2}). Also implements _BasePressRelease, _SharedPage, _PressReleaseContentType. */
export type _PressRelease = {
  /** Populated automatically during publish */
  duration?: Maybe<IntegerField>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Settings/Content Type/_PressReleaseContentType template (ID: {30684F31-AC21-49C7-B270-2D1476D8AB1B}). */
export type _PressReleaseContentType = {
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/Fields/_Protected Theme template (ID: {395E359F-2803-41AE-977E-79BDC95FC64E}). */
export type _ProtectedTheme = {
  /** Protected Theme (ID: {0B9CCE83-5355-4D1A-BBFE-E9BA3C3FE744}). */
  protectedTheme?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Aberdeen/JSS/Renderings/_Rendering Related Parameters template (ID: {6FAC30D1-698A-4063-A41D-B26A991977C2}). */
export type _RenderingRelatedParameters = {
  /** AllowedRenderings (ID: {7DA92DDB-CD84-4284-826E-44A163E9A53F}). */
  allowedRenderings?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Presentation/Available Renderings/_Renderings List template (ID: {BD94E83A-E66E-414D-B99C-6EBC8FF44F92}). */
export type _RenderingsList = {
  /** Renderings (ID: {715AE6C0-71C8-4744-AB4F-65362D20AD65}). */
  renderings?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/_Robots Content template (ID: {A7228B46-610D-4A17-9F61-649F3A30AAAE}). */
export type _RobotsContent = {
  /** RobotsContent (ID: {64971FA7-F8AC-4C88-9BB2-2949F2A28670}). */
  robotsContent?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Domain template (ID: {DCB42A80-68C9-46F9-B036-BC44A27D96FE}). */
export type _RoleDomain = {
  /** RoleDomain (ID: {2F325664-BBA1-4EAC-8D8F-C365D2F40245}). */
  roleDomain?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Name template (ID: {3D223462-3F77-4439-A60B-B7AB665D8DD3}). */
export type _RoleName = {
  /** RoleName (ID: {5382BFDE-8E39-4571-A1C5-EB3C43D5BCE3}). */
  roleName?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Role Type template (ID: {21CFEAFA-BFE0-4BD9-84B4-FA2C507B6842}). */
export type _RoleType = {
  /** RoleType (ID: {6471939F-9E50-4512-9EB7-556594C5C728}). */
  roleType?: Maybe<LookupField>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceCommonValidations template (ID: {887C659C-6566-4782-B5D4-FB610E91FF8F}). */
export type _SalesforceCommonValidations = {
  /** isRequired (ID: {49D666E3-4099-40A4-B9DD-A985DAEC9CC8}). */
  isRequired?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldId template (ID: {A9DA1356-11B6-43E5-9926-4000EE667E27}). */
export type _SalesforceFieldId = {
  /** salesforceFieldId (ID: {F8AE8A34-D302-49D2-9EE6-3FFF675A5BD1}). */
  salesforceFieldId?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldTitle template (ID: {ED4B701E-6158-4E36-A032-1B6DB660AB98}). */
export type _SalesforceFieldTitle = {
  /** title (ID: {060CF8E5-33D8-4FBC-B17E-5466D36A9073}). */
  title?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Aberdeen/Form/Salesforce Integrated Form/Base Templates/_SalesforceFieldValue template (ID: {4B57FE1F-1830-4667-A522-FFF90FAE2B5A}). */
export type _SalesforceFieldValue = {
  /** salesforceValue (ID: {1627FF3E-97E6-4133-99A3-1E2B62CBAD8A}). */
  salesforceValue?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Script template (ID: {5BA56C14-020E-4FB4-81AE-2531C311DBA8}). */
export type _Script = {
  /** Script (ID: {C0A5BD91-E658-46CE-B631-77CE337D8E6E}). */
  script?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Search Criteria template (ID: {D81B405A-B997-4ACE-9068-A15E179A5419}). */
export type _SearchCriteria = Item & {
  __typename?: '_SearchCriteria';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** AssociatedContent (ID: {25482C19-9DD6-4B95-8D3E-7CA50750CEF3}). */
  associatedContent?: Maybe<MultilistField>;
  /** AssociatedMedia (ID: {5846EEFB-C568-4999-B82C-F00A74809D5D}). */
  associatedMedia?: Maybe<MultilistField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** DatasourceSearchScope (ID: {6A0971B2-7BD4-44B8-B3C4-8F76EB4B1ECE}). */
  datasourceSearchScope?: Maybe<MultilistField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Scope (ID: {1D8D2039-8412-4EFA-87FF-1D540330A373}). */
  scope?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Search Criteria template (ID: {D81B405A-B997-4ACE-9068-A15E179A5419}). */
export type _SearchCriteriaAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Search Criteria template (ID: {D81B405A-B997-4ACE-9068-A15E179A5419}). */
export type _SearchCriteriaChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Search Criteria template (ID: {D81B405A-B997-4ACE-9068-A15E179A5419}). */
export type _SearchCriteriaFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Search Criteria template (ID: {D81B405A-B997-4ACE-9068-A15E179A5419}). */
export type _SearchCriteriaFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Search Criteria template (ID: {D81B405A-B997-4ACE-9068-A15E179A5419}). */
export type _SearchCriteriaHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_Search Criteria template (ID: {D81B405A-B997-4ACE-9068-A15E179A5419}). */
export type _SearchCriteriaIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SearchSignature template (ID: {F684AF43-896D-4922-949E-5CC5BF10BB16}). */
export type _SearchSignature = {
  /** SearchSignature (ID: {F3F50A03-336C-4610-845D-2E89227EC2FF}). */
  searchSignature?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_SearchableWithoutRelatedItems template (ID: {2B249AA3-A7BE-4A0D-A34A-8947B0DDE6F8}). */
export type _SearchableWithoutRelatedItems = Item & {
  __typename?: '_SearchableWithoutRelatedItems';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_SearchableWithoutRelatedItems template (ID: {2B249AA3-A7BE-4A0D-A34A-8947B0DDE6F8}). */
export type _SearchableWithoutRelatedItemsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_SearchableWithoutRelatedItems template (ID: {2B249AA3-A7BE-4A0D-A34A-8947B0DDE6F8}). */
export type _SearchableWithoutRelatedItemsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_SearchableWithoutRelatedItems template (ID: {2B249AA3-A7BE-4A0D-A34A-8947B0DDE6F8}). */
export type _SearchableWithoutRelatedItemsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_SearchableWithoutRelatedItems template (ID: {2B249AA3-A7BE-4A0D-A34A-8947B0DDE6F8}). */
export type _SearchableWithoutRelatedItemsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_SearchableWithoutRelatedItems template (ID: {2B249AA3-A7BE-4A0D-A34A-8947B0DDE6F8}). */
export type _SearchableWithoutRelatedItemsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Search/Computed Fields/_SearchableWithoutRelatedItems template (ID: {2B249AA3-A7BE-4A0D-A34A-8947B0DDE6F8}). */
export type _SearchableWithoutRelatedItemsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Security/Base/_Security Item Pointer template (ID: {B1AF1A3E-7A5B-4910-B7C5-56E9449F28EA}). */
export type _SecurityItemPointer = {
  /** Script (ID: {BBC2E73A-DE40-493B-9320-86D66D024AAF}). */
  script?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Seo Metadata template (ID: {9B5B9E0E-1CEF-4D54-8C47-27F241CE075B}). */
export type _SeoMetadata = Item & {
  __typename?: '_SeoMetadata';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** MetaDescription (ID: {528986CC-6FF9-4383-8BEE-514F0E8172CF}). */
  metaDescription?: Maybe<TextField>;
  /** MetaKeywords (ID: {5E650555-C7F0-456A-8185-F69388169CBC}). */
  metaKeywords?: Maybe<TextField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Seo Metadata template (ID: {9B5B9E0E-1CEF-4D54-8C47-27F241CE075B}). */
export type _SeoMetadataAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Seo Metadata template (ID: {9B5B9E0E-1CEF-4D54-8C47-27F241CE075B}). */
export type _SeoMetadataChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Seo Metadata template (ID: {9B5B9E0E-1CEF-4D54-8C47-27F241CE075B}). */
export type _SeoMetadataFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Seo Metadata template (ID: {9B5B9E0E-1CEF-4D54-8C47-27F241CE075B}). */
export type _SeoMetadataFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Seo Metadata template (ID: {9B5B9E0E-1CEF-4D54-8C47-27F241CE075B}). */
export type _SeoMetadataHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Seo Metadata template (ID: {9B5B9E0E-1CEF-4D54-8C47-27F241CE075B}). */
export type _SeoMetadataIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_Shared Page template (ID: {E47DA5E9-3647-41E5-8D30-AED2EC4CB37C}). */
export type _SharedPage = {
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_Shared Root template (ID: {F3F0CB13-B505-42DE-9649-4A9866A0B1A7}). */
export type _SharedRoot = {
  /** IsShared (ID: {7147CA94-CD06-4ABA-8AF3-E179A24F4DE5}). */
  isShared?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Base/_SiteMediaLibrary template (ID: {74A69144-4B78-447F-AF96-D835D1C6B97D}). */
export type _SiteMediaLibrary = {
  /** SiteMediaLibrary (ID: {33D9005E-1F71-415F-B107-53B965C3B037}). */
  siteMediaLibrary?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_Site Template template (ID: {B99C3F50-6478-4CFE-98FD-82398044DC84}). */
export type _SiteTemplate = {
  /** SiteTemplate (ID: {E2BF3C8D-A12E-45F4-98D6-A37F13BCF375}). */
  siteTemplate?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Site Theme template (ID: {1479D1EC-DE94-4546-B02F-84636B2061C2}). */
export type _SiteTheme = Item & {
  __typename?: '_SiteTheme';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Theme (ID: {C0C88E34-D7E6-46A0-B84F-B0A432D11642}). */
  theme?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Site Theme template (ID: {1479D1EC-DE94-4546-B02F-84636B2061C2}). */
export type _SiteThemeAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Site Theme template (ID: {1479D1EC-DE94-4546-B02F-84636B2061C2}). */
export type _SiteThemeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Site Theme template (ID: {1479D1EC-DE94-4546-B02F-84636B2061C2}). */
export type _SiteThemeFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Site Theme template (ID: {1479D1EC-DE94-4546-B02F-84636B2061C2}). */
export type _SiteThemeFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Site Theme template (ID: {1479D1EC-DE94-4546-B02F-84636B2061C2}). */
export type _SiteThemeHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Site Theme template (ID: {1479D1EC-DE94-4546-B02F-84636B2061C2}). */
export type _SiteThemeIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_Sitemap template (ID: {4414A1F9-826A-4647-8DF4-ED6A95E64C43}). */
export type _Sitemap = {
  /** Change frequency (ID: {508C54C0-CD02-4266-8B68-D71F88DE1AA9}). */
  changeFrequency?: Maybe<LookupField>;
  /** Priority (ID: {76FB6FFD-4487-4028-A1CF-705FBE360CBA}). */
  priority?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Base/_SitemapMediaItems template (ID: {448108A3-CEA9-42E3-A86C-2D2BD325870E}). */
export type _SitemapMediaItems = {
  /** Sitemap media items (ID: {2B2FE9FD-78A6-40EB-B9F9-28409D8D3700}). */
  sitemapMediaItems?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_SitemapSettings template (ID: {59F55DFC-4DB7-422F-9D40-F2ECF66C8499}). */
export type _SitemapSettings = Item & {
  __typename?: '_SitemapSettings';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** External Sitemaps (ID: {868CE25D-CA14-4720-9D62-997C2E11B3D8}). */
  externalSitemaps?: Maybe<NameValueListField>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Sitemap Index (ID: {8E52D1F4-28EE-4E9D-9E7E-8347375ECAAF}). */
  sitemapIndex?: Maybe<CheckboxField>;
  /** Sitemap Mode (ID: {7517C0BF-69E3-4975-B141-5A2EB90EBADC}). */
  sitemapMode?: Maybe<LookupField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_SitemapSettings template (ID: {59F55DFC-4DB7-422F-9D40-F2ECF66C8499}). */
export type _SitemapSettingsAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_SitemapSettings template (ID: {59F55DFC-4DB7-422F-9D40-F2ECF66C8499}). */
export type _SitemapSettingsChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_SitemapSettings template (ID: {59F55DFC-4DB7-422F-9D40-F2ECF66C8499}). */
export type _SitemapSettingsFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_SitemapSettings template (ID: {59F55DFC-4DB7-422F-9D40-F2ECF66C8499}). */
export type _SitemapSettingsFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_SitemapSettings template (ID: {59F55DFC-4DB7-422F-9D40-F2ECF66C8499}). */
export type _SitemapSettingsHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/SiteMetadata/Sitemap/_SitemapSettings template (ID: {59F55DFC-4DB7-422F-9D40-F2ECF66C8499}). */
export type _SitemapSettingsIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SlidersRangeSettings template (ID: {A88DBE5E-E75E-429E-BC60-C8AA99F3B58A}). */
export type _SlidersRangeSettings = {
  /** ShowRangeIndicators (ID: {10D0D449-2D0B-440D-92D8-DD9237C7E36B}). */
  showRangeIndicators?: Maybe<CheckboxField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateContent template (ID: {75947485-7624-4588-BDAC-812B865141DD}). */
export type _SolutionTemplateContent = {
  /** Content (ID: {DA855368-E5F2-4932-AE55-7F8B08A5A205}). */
  content?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateDescription template (ID: {77B1399F-5F30-4643-A054-59BBB1C7C62C}). */
export type _SolutionTemplateDescription = {
  /** Description (ID: {9F437E68-A84D-48AE-8CE1-A3E26C0B5E64}). */
  description_9f437e68a84d48ae8ce1a3e26c0b5e64?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Scaffolding/Base/Solution template/_SolutionTemplateName template (ID: {EE5BEC5A-609F-4C64-8960-18D6CAE7F890}). */
export type _SolutionTemplateName = {
  /** Name (ID: {82E64B52-0B8A-4A38-8C78-530C5493814E}). */
  name_82e64b520b8a4a388c78530c5493814e?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/Search/Rendering Parameters/Base/_SortOrder template (ID: {09A97A02-1FC8-4192-A9E9-56555485D8EC}). */
export type _SortOrder = {
  /** SortOrder (ID: {91ED9872-2007-47E9-BF01-1292C1B261B2}). */
  sortOrder?: Maybe<TextField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_StackBreakpoint template (ID: {DEEAA769-6D96-4B6B-8E5F-39B5B073FBC1}). */
export type _StackBreakpoint = {
  /** StackAtBreakpoint (ID: {8CBC1CDD-5F1F-4187-B3B0-D81DB7CA675C}). */
  stackAtBreakpoint?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/StickyNotes/_Sticky Note template (ID: {11AB06B6-1F36-42D1-8065-77D7CE0FE085}). */
export type _StickyNote = Item & {
  __typename?: '_StickyNote';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** StickyNotes (ID: {4C2F221F-9426-45ED-9EEB-C79BB3169565}). */
  stickyNotes?: Maybe<TextField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/StickyNotes/_Sticky Note template (ID: {11AB06B6-1F36-42D1-8065-77D7CE0FE085}). */
export type _StickyNoteAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/StickyNotes/_Sticky Note template (ID: {11AB06B6-1F36-42D1-8065-77D7CE0FE085}). */
export type _StickyNoteChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/StickyNotes/_Sticky Note template (ID: {11AB06B6-1F36-42D1-8065-77D7CE0FE085}). */
export type _StickyNoteFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/StickyNotes/_Sticky Note template (ID: {11AB06B6-1F36-42D1-8065-77D7CE0FE085}). */
export type _StickyNoteFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/StickyNotes/_Sticky Note template (ID: {11AB06B6-1F36-42D1-8065-77D7CE0FE085}). */
export type _StickyNoteHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/StickyNotes/_Sticky Note template (ID: {11AB06B6-1F36-42D1-8065-77D7CE0FE085}). */
export type _StickyNoteIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Styleable template (ID: {DFD71B66-796C-4BDE-A2BB-B60958D7BAF8}). */
export type _Styleable = Item & {
  __typename?: '_Styleable';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Body Css Class (ID: {D4952280-2D7D-4BF4-A99A-EA36DAD0F0A7}). */
  bodyCssClass?: Maybe<TextField>;
  /** Body Id (ID: {A4960085-5C00-4B39-BA38-CDB43F1D776F}). */
  bodyId?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Styleable template (ID: {DFD71B66-796C-4BDE-A2BB-B60958D7BAF8}). */
export type _StyleableAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Styleable template (ID: {DFD71B66-796C-4BDE-A2BB-B60958D7BAF8}). */
export type _StyleableChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Styleable template (ID: {DFD71B66-796C-4BDE-A2BB-B60958D7BAF8}). */
export type _StyleableFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Styleable template (ID: {DFD71B66-796C-4BDE-A2BB-B60958D7BAF8}). */
export type _StyleableFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Styleable template (ID: {DFD71B66-796C-4BDE-A2BB-B60958D7BAF8}). */
export type _StyleableHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Experience Accelerator/Theming/_Styleable template (ID: {DFD71B66-796C-4BDE-A2BB-B60958D7BAF8}). */
export type _StyleableIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/JSS Experience Accelerator/Multisite/Base/Sites/_SupportedLanguages template (ID: {615A59CC-A275-4E57-8B48-A57F0A703F84}). */
export type _SupportedLanguages = {
  /** Supported languages (ID: {D0CE707C-342F-4C02-AC0A-EDB21346DDE4}). */
  supportedLanguages?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Taxonomy/_Taggable template (ID: {F39A594A-7BC9-4DB0-BAA1-88543409C1F9}). */
export type _Taggable = {
  /** Tags (ID: {97FB669D-5B8E-4829-9A24-06418C315D73}). */
  sxaTags?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_TechzoneArticle template (ID: {710FD048-A509-4775-BFDB-4FED7E836E54}). Also implements _ExternalArticle, _BaseArticle, _SharedPage, _ContentType, _LimitedDisplay. */
export type _TechzoneArticle = {
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** articleUrl (ID: {03D20238-CFFC-4238-AB29-21DB4996DABF}). */
  articleUrl?: Maybe<LinkField>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Actions/Base/AddItem/_Template template (ID: {86A88D69-9A4D-4C0E-8068-ECF04470A8A4}). */
export type _Template = {
  /** Template (ID: {E62C28F0-9D3B-46E2-8BEC-A5E120542499}). */
  template_e62c28f09d3b46e28beca5e120542499?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Multisite/Content/_Title template (ID: {7879CEA4-44EB-498B-9917-0DA4646E1021}). */
export type _Title = {
  /** Title (ID: {1AB993C6-6E09-4367-AAF2-9372B017910B}). */
  title?: Maybe<TextField>;
};

/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Twitter Metadata template (ID: {0EC7A941-BB98-4A56-BD1A-9CDFE12896E9}). */
export type _TwitterMetadata = Item & {
  __typename?: '_TwitterMetadata';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** TwitterCardType (ID: {CE53062E-4385-4244-8382-C2B4530A51BA}). */
  twitterCardType?: Maybe<LookupField>;
  /** TwitterDescription (ID: {4D263B95-322F-4003-ADBD-70920FACF823}). */
  twitterDescription?: Maybe<TextField>;
  /** TwitterImage (ID: {DE457091-0989-414E-ADDF-59DB0DDB6690}). */
  twitterImage?: Maybe<ImageField>;
  /** TwitterSite (ID: {45CE257A-6060-4C4A-9A0F-AE77BF705B25}). */
  twitterSite?: Maybe<TextField>;
  /** TwitterTitle (ID: {48A66E40-D164-4C8E-BC06-172ECC6769EC}). */
  twitterTitle?: Maybe<TextField>;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Twitter Metadata template (ID: {0EC7A941-BB98-4A56-BD1A-9CDFE12896E9}). */
export type _TwitterMetadataAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Twitter Metadata template (ID: {0EC7A941-BB98-4A56-BD1A-9CDFE12896E9}). */
export type _TwitterMetadataChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Twitter Metadata template (ID: {0EC7A941-BB98-4A56-BD1A-9CDFE12896E9}). */
export type _TwitterMetadataFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Twitter Metadata template (ID: {0EC7A941-BB98-4A56-BD1A-9CDFE12896E9}). */
export type _TwitterMetadataFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Twitter Metadata template (ID: {0EC7A941-BB98-4A56-BD1A-9CDFE12896E9}). */
export type _TwitterMetadataHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Experience Accelerator/SiteMetadata/_Twitter Metadata template (ID: {0EC7A941-BB98-4A56-BD1A-9CDFE12896E9}). */
export type _TwitterMetadataIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Type template (ID: {836B39F5-7467-4C00-84AF-2E3ED26D558F}). */
export type _Type = {
  /** Type (ID: {654618D7-A288-44A2-BFA8-A9E1CCB4EFB8}). */
  type?: Maybe<LookupField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Scaffolding/Roots/_Validation template (ID: {662A18B8-C080-49A9-BEA9-73D9E635382F}). */
export type _Validation = {
  /** ValidationScript (ID: {51BAE6C9-5808-423C-8C0F-BEBD884B256D}). */
  validationScript?: Maybe<MultilistField>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Rendering Variants/Base/_Variant Paging template (ID: {308A13CD-1BA2-4377-80E4-CE4BA4663AD5}). */
export type _VariantPaging = {
  /** Enter a number to limit the number of items returned. */
  maxNumberOfResults?: Maybe<IntegerField>;
  /** NumberOfResultsToSkip (ID: {AE6DB294-8D8B-45BE-919C-1143867BC03D}). */
  numberOfResultsToSkip?: Maybe<IntegerField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Video template (ID: {16E7A72E-9B67-49A1-BF78-731012D45AC6}). Also implements _InternalArticle, _BaseArticle, _PremiumContentPage, _SharedPage, _ContentType, _LimitedDisplay. */
export type _Video = {
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** duration (ID: {3FA832A3-1006-48DB-85DD-58A9926C49E0}). */
  duration?: Maybe<IntegerField>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_VideoPressRelease template (ID: {331FC25B-BB32-4279-8E47-F8333441866D}). Also implements _BasePressRelease, _SharedPage, _PressReleaseContentType. */
export type _VideoPressRelease = {
  /** duration (ID: {809C7EAF-5258-4877-A44C-4FE3A4629C7E}). */
  duration?: Maybe<IntegerField>;
  /** pressReleaseContentType (ID: {D0D12D5E-778A-4EB9-9B41-8CB83987AD5C}). */
  pressReleaseContentType?: Maybe<LookupField>;
  /** pressReleaseDescription (ID: {5260F744-BBEC-43D3-99A7-C8B150A61642}). */
  pressReleaseDescription?: Maybe<TextField>;
  /** pressReleasePlatform (ID: {709A2B09-D76B-4456-938B-EBF37A76CC6A}). */
  pressReleasePlatform?: Maybe<LookupField>;
  /** pressReleasePublicationDate (ID: {668A954D-917E-4310-9ACE-A69091DF3FE9}). */
  pressReleasePublicationDate?: Maybe<DateField>;
  /** pressReleaseTitle (ID: {0169259D-1DC4-43D2-88A9-765E0A5A6D1A}). */
  pressReleaseTitle?: Maybe<TextField>;
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
};

/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Webinar template (ID: {37BE8567-9E56-4253-BE88-884C9E07E6FC}). */
export type _Webinar = Item & _BaseArticle & _ContentType & _InternalArticle & _LimitedDisplay & _PremiumContentPage & _SharedPage & {
  __typename?: '_Webinar';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** articleAuthor (ID: {FA689CE6-D1D9-4A69-949F-5421994DFB83}). */
  articleAuthor?: Maybe<MultilistField>;
  /** articleCapabilities (ID: {A5BB08E0-4400-40CA-A448-78BC5797F7E2}). */
  articleCapabilities?: Maybe<MultilistField>;
  /** articleCategory (ID: {9C41864D-6C37-4AFB-8785-207EF73193F0}). */
  articleCategory?: Maybe<LookupField>;
  /** articleContributor (ID: {006D09FA-CF47-4802-945D-5B993AEA8578}). */
  articleContributor?: Maybe<MultilistField>;
  /** articleCorporateThemes (ID: {AEBE598C-4166-470A-85BD-ECB89929F813}). */
  articleCorporateThemes?: Maybe<MultilistField>;
  /** articleImage (ID: {C1B59459-4229-4BB9-9937-ACB9A8AB8C7D}). */
  articleImage?: Maybe<ImageField>;
  /** articlePublicationDate (ID: {CB048134-DB9F-4934-AB7A-AB3DD1485749}). */
  articlePublicationDate?: Maybe<DateField>;
  /** articleRegion (ID: {3299FD66-CAE7-4EB8-BC92-A644F4EE9F17}). */
  articleRegion?: Maybe<LookupField>;
  /** articleSeries (ID: {D5247A84-AAF0-4524-88C7-507B4FAF16BE}). */
  articleSeries?: Maybe<LookupField>;
  /** articleSeriesPart (ID: {A5EDE0DD-1F75-4093-8BF5-B3ED7A188BD9}). */
  articleSeriesPart?: Maybe<NumberField>;
  /** articleStrapline (ID: {28CAF9C2-777C-4960-8CE8-9126683822C0}). */
  articleStrapline?: Maybe<TextField>;
  /** articleTags (ID: {8AD0C0DF-7DC7-4000-8064-132F34559486}). */
  articleTags?: Maybe<MultilistField>;
  /** articleThemes (ID: {B2360FE6-87DF-4F70-A1F1-67B5F7615BE4}). */
  articleThemes?: Maybe<MultilistField>;
  /** articleTitle (ID: {279A6269-7578-4E75-A4F0-9C449EA0EE3B}). */
  articleTitle?: Maybe<TextField>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** contentGroup (ID: {D6F3AC3A-4EF5-48BF-9B40-D90B998AB418}). */
  contentGroup?: Maybe<LookupField>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** If populated, article will only be visible on Related Articles components on pages where this value matches. */
  limitedDisplay?: Maybe<LookupField>;
  /** If populated, Limited Display setting will not apply for selected sites */
  limitedDisplayExceptions?: Maybe<MultilistField>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** premiumContent (ID: {2B742A59-1DD1-4C8A-974D-479DD481CB88}). */
  premiumContent?: Maybe<CheckboxField>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** shareTo (ID: {243B96B7-ACAF-4BC9-A7DE-E60B6FE17C84}). */
  shareTo?: Maybe<MultilistField>;
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Webinar template (ID: {37BE8567-9E56-4253-BE88-884C9E07E6FC}). */
export type _WebinarAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Webinar template (ID: {37BE8567-9E56-4253-BE88-884C9E07E6FC}). */
export type _WebinarChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Webinar template (ID: {37BE8567-9E56-4253-BE88-884C9E07E6FC}). */
export type _WebinarFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Webinar template (ID: {37BE8567-9E56-4253-BE88-884C9E07E6FC}). */
export type _WebinarFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Webinar template (ID: {37BE8567-9E56-4253-BE88-884C9E07E6FC}). */
export type _WebinarHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Feature/Aberdeen/Article/Pages/_Webinar template (ID: {37BE8567-9E56-4253-BE88-884C9E07E6FC}). */
export type _WebinarIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** /sitecore/templates/Foundation/Experience Accelerator/Horizon/Devices/Base/_Width template (ID: {166A2F25-9AAF-4A50-A9F8-A06095674CEC}). */
export type _Width = {
  /** Width (ID: {01C5C169-867F-4A45-A8A3-891A3B13B39A}). */
  width?: Maybe<NumberField>;
};

/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardSource template (ID: {D13BEBA4-A9E6-4522-8F45-AA1B9126EE92}). */
export type _WildcardSource = Item & {
  __typename?: '_WildcardSource';
  /** Ancestors in the content hierarchy. */
  ancestors: Array<Maybe<Item>>;
  /** Children in the content hierarchy. */
  children?: Maybe<ItemSearchResults>;
  /** The display name of the item. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Single field by name or ID. */
  field?: Maybe<ItemField>;
  /** All item fields. */
  fields: Array<Maybe<ItemField>>;
  /** Indicates whether the item has children. */
  hasChildren: Scalars['Boolean']['output'];
  /** Unique ID of the item. */
  id: Scalars['ID']['output'];
  /** Information about the language. */
  language: ItemLanguage;
  /** Item information for every language defined for the item. */
  languages: Array<Maybe<Item>>;
  /** The name of the item. */
  name: Scalars['String']['output'];
  /** Parent in the content hierarchy. */
  parent?: Maybe<Item>;
  /** The full path of the item in the content tree. */
  path: Scalars['String']['output'];
  personalization?: Maybe<ItemPersonalization>;
  /** Item presentation details. */
  rendered: Scalars['JSON']['output'];
  /** Information about the template. */
  template: ItemTemplate;
  /** Location object properties. For example, 'hostName', 'path'. */
  url: ItemUrl;
  /** The newest version of the item. */
  version: Scalars['Int']['output'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardSource template (ID: {D13BEBA4-A9E6-4522-8F45-AA1B9126EE92}). */
export type _WildcardSourceAncestorsArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardSource template (ID: {D13BEBA4-A9E6-4522-8F45-AA1B9126EE92}). */
export type _WildcardSourceChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardSource template (ID: {D13BEBA4-A9E6-4522-8F45-AA1B9126EE92}). */
export type _WildcardSourceFieldArgs = {
  name: Scalars['String']['input'];
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardSource template (ID: {D13BEBA4-A9E6-4522-8F45-AA1B9126EE92}). */
export type _WildcardSourceFieldsArgs = {
  ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardSource template (ID: {D13BEBA4-A9E6-4522-8F45-AA1B9126EE92}). */
export type _WildcardSourceHasChildrenArgs = {
  hasLayout?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** /sitecore/templates/Foundation/Aberdeen/Configuration/_WildcardSource template (ID: {D13BEBA4-A9E6-4522-8F45-AA1B9126EE92}). */
export type _WildcardSourceIdArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};
